(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5906"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5906"] = parcelRequire;
}
parcelRequire.register("aSMts", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7ec48c7d8ea17758$export$fdf2a89c76341bbf; });

var $jG3FW = parcelRequire("jG3FW");

var $hpdLM = parcelRequire("hpdLM");

var $8V4Ru = parcelRequire("8V4Ru");

var $fXGmO = parcelRequire("fXGmO");
function $7ec48c7d8ea17758$export$fdf2a89c76341bbf(arr, i) {
    return (0, $jG3FW._array_with_holes)(arr) || (0, $hpdLM._iterable_to_array_limit)(arr, i) || (0, $fXGmO._unsupported_iterable_to_array)(arr, i) || (0, $8V4Ru._non_iterable_rest)();
}

});
parcelRequire.register("jG3FW", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $e534ca721748b0c3$export$e6256bf45c68d561; });
function $e534ca721748b0c3$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("hpdLM", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $cabf73d5763ce5a2$export$2fd15edff6687200; });
function $cabf73d5763ce5a2$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRequire.register("8V4Ru", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $67e76b0988166e1e$export$60dbc22abd7da546; });
function $67e76b0988166e1e$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRequire.register("fXGmO", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $b9ed3ae1694dd153$export$a5be06335b3a083c; });

var $5B3Hz = parcelRequire("5B3Hz");
function $b9ed3ae1694dd153$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5B3Hz._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5B3Hz._array_like_to_array)(o, minLen);
}

});
parcelRequire.register("5B3Hz", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $4133478a60806ab4$export$79e617b1955a2616; });
function $4133478a60806ab4$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRequire.register("esXub", function(module, exports) {
"use strict";

module.exports = (parcelRequire("iPFGn"));

});
parcelRequire.register("iPFGn", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $db5d52b52065cc9b$export$ffb0004e005737fa; }, function (v) { return $db5d52b52065cc9b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $db5d52b52065cc9b$export$34b9dba7ce09269b; }, function (v) { return $db5d52b52065cc9b$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $db5d52b52065cc9b$export$25062201e9e25d76; }, function (v) { return $db5d52b52065cc9b$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $db5d52b52065cc9b$export$ffb0004e005737fa;
var $db5d52b52065cc9b$export$34b9dba7ce09269b;
var $db5d52b52065cc9b$export$25062201e9e25d76;
"use strict";

var $3aC2T = parcelRequire("3aC2T");
var $db5d52b52065cc9b$var$k = Symbol["for"]("react.element"), $db5d52b52065cc9b$var$l = Symbol["for"]("react.fragment"), $db5d52b52065cc9b$var$m = Object.prototype.hasOwnProperty, $db5d52b52065cc9b$var$n = $3aC2T.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $db5d52b52065cc9b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $db5d52b52065cc9b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$db5d52b52065cc9b$var$m.call(a, b) && !$db5d52b52065cc9b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $db5d52b52065cc9b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $db5d52b52065cc9b$var$n.current
    };
}
$db5d52b52065cc9b$export$ffb0004e005737fa = $db5d52b52065cc9b$var$l;
$db5d52b52065cc9b$export$34b9dba7ce09269b = $db5d52b52065cc9b$var$q;
$db5d52b52065cc9b$export$25062201e9e25d76 = $db5d52b52065cc9b$var$q;

});
parcelRequire.register("3aC2T", function(module, exports) {
"use strict";

module.exports = (parcelRequire("d91kw"));

});
parcelRequire.register("d91kw", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $991d25b6c67751d2$export$dca3b0875bd9a954; }, function (v) { return $991d25b6c67751d2$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $991d25b6c67751d2$export$16fa2f45be04daa8; }, function (v) { return $991d25b6c67751d2$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $991d25b6c67751d2$export$ffb0004e005737fa; }, function (v) { return $991d25b6c67751d2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $991d25b6c67751d2$export$e2c29f18771995cb; }, function (v) { return $991d25b6c67751d2$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $991d25b6c67751d2$export$221d75b3f55bb0bd; }, function (v) { return $991d25b6c67751d2$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $991d25b6c67751d2$export$5f8d39834fd61797; }, function (v) { return $991d25b6c67751d2$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $991d25b6c67751d2$export$74bf444e3cd11ea5; }, function (v) { return $991d25b6c67751d2$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $991d25b6c67751d2$export$ae55be85d98224ed; }, function (v) { return $991d25b6c67751d2$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $991d25b6c67751d2$export$e530037191fcd5d7; }, function (v) { return $991d25b6c67751d2$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $991d25b6c67751d2$export$fd42f52fd3ae1109; }, function (v) { return $991d25b6c67751d2$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $991d25b6c67751d2$export$c8a8987d4410bf2d; }, function (v) { return $991d25b6c67751d2$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $991d25b6c67751d2$export$d38cd72104c1f0e9; }, function (v) { return $991d25b6c67751d2$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $991d25b6c67751d2$export$7d1e3a5e95ceca43; }, function (v) { return $991d25b6c67751d2$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $991d25b6c67751d2$export$257a8862b851cb5b; }, function (v) { return $991d25b6c67751d2$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $991d25b6c67751d2$export$a8257692ac88316c; }, function (v) { return $991d25b6c67751d2$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $991d25b6c67751d2$export$488013bae63b21da; }, function (v) { return $991d25b6c67751d2$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $991d25b6c67751d2$export$7c73462e0d25e514; }, function (v) { return $991d25b6c67751d2$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $991d25b6c67751d2$export$7568632d0d33d16d; }, function (v) { return $991d25b6c67751d2$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $991d25b6c67751d2$export$88948ce120ea2619; }, function (v) { return $991d25b6c67751d2$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $991d25b6c67751d2$export$35808ee640e87ca7; }, function (v) { return $991d25b6c67751d2$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $991d25b6c67751d2$export$fae74005e78b1a27; }, function (v) { return $991d25b6c67751d2$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $991d25b6c67751d2$export$dc8fbce3eb94dc1e; }, function (v) { return $991d25b6c67751d2$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $991d25b6c67751d2$export$6a7bc4e911dc01cf; }, function (v) { return $991d25b6c67751d2$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $991d25b6c67751d2$export$6d9c69b0de29b591; }, function (v) { return $991d25b6c67751d2$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $991d25b6c67751d2$export$f680877a34711e37; }, function (v) { return $991d25b6c67751d2$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $991d25b6c67751d2$export$d5a552a76deda3c2; }, function (v) { return $991d25b6c67751d2$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $991d25b6c67751d2$export$aaabe4eda9ed9969; }, function (v) { return $991d25b6c67751d2$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $991d25b6c67751d2$export$e5c5a5f917a5871c; }, function (v) { return $991d25b6c67751d2$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $991d25b6c67751d2$export$1538c33de8887b59; }, function (v) { return $991d25b6c67751d2$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $991d25b6c67751d2$export$13e3392192263954; }, function (v) { return $991d25b6c67751d2$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $991d25b6c67751d2$export$b8f5890fc79d6aca; }, function (v) { return $991d25b6c67751d2$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $991d25b6c67751d2$export$60241385465d0a34; }, function (v) { return $991d25b6c67751d2$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $991d25b6c67751d2$export$306c0aa65ff9ec16; }, function (v) { return $991d25b6c67751d2$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $991d25b6c67751d2$export$7b286972b8d8ccbf; }, function (v) { return $991d25b6c67751d2$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $991d25b6c67751d2$export$83d89fbfd8236492; }, function (v) { return $991d25b6c67751d2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $qb7pP = parcelRequire("qb7pP");
var $991d25b6c67751d2$export$dca3b0875bd9a954;
var $991d25b6c67751d2$export$16fa2f45be04daa8;
var $991d25b6c67751d2$export$ffb0004e005737fa;
var $991d25b6c67751d2$export$e2c29f18771995cb;
var $991d25b6c67751d2$export$221d75b3f55bb0bd;
var $991d25b6c67751d2$export$5f8d39834fd61797;
var $991d25b6c67751d2$export$74bf444e3cd11ea5;
var $991d25b6c67751d2$export$ae55be85d98224ed;
var $991d25b6c67751d2$export$e530037191fcd5d7;
var $991d25b6c67751d2$export$fd42f52fd3ae1109;
var $991d25b6c67751d2$export$c8a8987d4410bf2d;
var $991d25b6c67751d2$export$d38cd72104c1f0e9;
var $991d25b6c67751d2$export$7d1e3a5e95ceca43;
var $991d25b6c67751d2$export$257a8862b851cb5b;
var $991d25b6c67751d2$export$a8257692ac88316c;
var $991d25b6c67751d2$export$488013bae63b21da;
var $991d25b6c67751d2$export$7c73462e0d25e514;
var $991d25b6c67751d2$export$7568632d0d33d16d;
var $991d25b6c67751d2$export$88948ce120ea2619;
var $991d25b6c67751d2$export$35808ee640e87ca7;
var $991d25b6c67751d2$export$fae74005e78b1a27;
var $991d25b6c67751d2$export$dc8fbce3eb94dc1e;
var $991d25b6c67751d2$export$6a7bc4e911dc01cf;
var $991d25b6c67751d2$export$6d9c69b0de29b591;
var $991d25b6c67751d2$export$f680877a34711e37;
var $991d25b6c67751d2$export$d5a552a76deda3c2;
var $991d25b6c67751d2$export$aaabe4eda9ed9969;
var $991d25b6c67751d2$export$e5c5a5f917a5871c;
var $991d25b6c67751d2$export$1538c33de8887b59;
var $991d25b6c67751d2$export$13e3392192263954;
var $991d25b6c67751d2$export$b8f5890fc79d6aca;
var $991d25b6c67751d2$export$60241385465d0a34;
var $991d25b6c67751d2$export$306c0aa65ff9ec16;
var $991d25b6c67751d2$export$7b286972b8d8ccbf;
var $991d25b6c67751d2$export$83d89fbfd8236492;
"use strict";
var $991d25b6c67751d2$var$l = Symbol["for"]("react.element"), $991d25b6c67751d2$var$n = Symbol["for"]("react.portal"), $991d25b6c67751d2$var$p = Symbol["for"]("react.fragment"), $991d25b6c67751d2$var$q = Symbol["for"]("react.strict_mode"), $991d25b6c67751d2$var$r = Symbol["for"]("react.profiler"), $991d25b6c67751d2$var$t = Symbol["for"]("react.provider"), $991d25b6c67751d2$var$u = Symbol["for"]("react.context"), $991d25b6c67751d2$var$v = Symbol["for"]("react.forward_ref"), $991d25b6c67751d2$var$w = Symbol["for"]("react.suspense"), $991d25b6c67751d2$var$x = Symbol["for"]("react.memo"), $991d25b6c67751d2$var$y = Symbol["for"]("react.lazy"), $991d25b6c67751d2$var$z = Symbol.iterator;
function $991d25b6c67751d2$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $991d25b6c67751d2$var$z && a[$991d25b6c67751d2$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $991d25b6c67751d2$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $991d25b6c67751d2$var$C = Object.assign, $991d25b6c67751d2$var$D = {};
function $991d25b6c67751d2$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $991d25b6c67751d2$var$D;
    this.updater = e || $991d25b6c67751d2$var$B;
}
$991d25b6c67751d2$var$E.prototype.isReactComponent = {};
$991d25b6c67751d2$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$991d25b6c67751d2$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $991d25b6c67751d2$var$F() {}
$991d25b6c67751d2$var$F.prototype = $991d25b6c67751d2$var$E.prototype;
function $991d25b6c67751d2$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $991d25b6c67751d2$var$D;
    this.updater = e || $991d25b6c67751d2$var$B;
}
var $991d25b6c67751d2$var$H = $991d25b6c67751d2$var$G.prototype = new $991d25b6c67751d2$var$F;
$991d25b6c67751d2$var$H.constructor = $991d25b6c67751d2$var$G;
$991d25b6c67751d2$var$C($991d25b6c67751d2$var$H, $991d25b6c67751d2$var$E.prototype);
$991d25b6c67751d2$var$H.isPureReactComponent = !0;
var $991d25b6c67751d2$var$I = Array.isArray, $991d25b6c67751d2$var$J = Object.prototype.hasOwnProperty, $991d25b6c67751d2$var$K = {
    current: null
}, $991d25b6c67751d2$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $991d25b6c67751d2$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$991d25b6c67751d2$var$J.call(b, d) && !$991d25b6c67751d2$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $991d25b6c67751d2$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $991d25b6c67751d2$var$K.current
    };
}
function $991d25b6c67751d2$var$N(a, b) {
    return {
        $$typeof: $991d25b6c67751d2$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $991d25b6c67751d2$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $991d25b6c67751d2$var$l;
}
function $991d25b6c67751d2$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $991d25b6c67751d2$var$P = /\/+/g;
function $991d25b6c67751d2$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $991d25b6c67751d2$var$escape("" + a.key) : b.toString(36);
}
function $991d25b6c67751d2$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $qb7pP._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $991d25b6c67751d2$var$l:
                case $991d25b6c67751d2$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $991d25b6c67751d2$var$Q(h, 0) : d, $991d25b6c67751d2$var$I(c) ? (e = "", null != a && (e = a.replace($991d25b6c67751d2$var$P, "$&/") + "/"), $991d25b6c67751d2$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($991d25b6c67751d2$var$O(c) && (c = $991d25b6c67751d2$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($991d25b6c67751d2$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($991d25b6c67751d2$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $991d25b6c67751d2$var$Q(k, g);
        h += $991d25b6c67751d2$var$R(k, b, e, f, c);
    }
    else if (f = $991d25b6c67751d2$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $991d25b6c67751d2$var$Q(k, g++), h += $991d25b6c67751d2$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $991d25b6c67751d2$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $991d25b6c67751d2$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $991d25b6c67751d2$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result["default"];
    throw a._result;
}
var $991d25b6c67751d2$var$U = {
    current: null
}, $991d25b6c67751d2$var$V = {
    transition: null
}, $991d25b6c67751d2$var$W = {
    ReactCurrentDispatcher: $991d25b6c67751d2$var$U,
    ReactCurrentBatchConfig: $991d25b6c67751d2$var$V,
    ReactCurrentOwner: $991d25b6c67751d2$var$K
};
$991d25b6c67751d2$export$dca3b0875bd9a954 = {
    map: $991d25b6c67751d2$var$S,
    forEach: function forEach(a, b, e) {
        $991d25b6c67751d2$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $991d25b6c67751d2$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $991d25b6c67751d2$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$991d25b6c67751d2$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$991d25b6c67751d2$export$16fa2f45be04daa8 = $991d25b6c67751d2$var$E;
$991d25b6c67751d2$export$ffb0004e005737fa = $991d25b6c67751d2$var$p;
$991d25b6c67751d2$export$e2c29f18771995cb = $991d25b6c67751d2$var$r;
$991d25b6c67751d2$export$221d75b3f55bb0bd = $991d25b6c67751d2$var$G;
$991d25b6c67751d2$export$5f8d39834fd61797 = $991d25b6c67751d2$var$q;
$991d25b6c67751d2$export$74bf444e3cd11ea5 = $991d25b6c67751d2$var$w;
$991d25b6c67751d2$export$ae55be85d98224ed = $991d25b6c67751d2$var$W;
$991d25b6c67751d2$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $991d25b6c67751d2$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $991d25b6c67751d2$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$991d25b6c67751d2$var$J.call(b, f) && !$991d25b6c67751d2$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $991d25b6c67751d2$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$991d25b6c67751d2$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $991d25b6c67751d2$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $991d25b6c67751d2$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$991d25b6c67751d2$export$c8a8987d4410bf2d = $991d25b6c67751d2$var$M;
$991d25b6c67751d2$export$d38cd72104c1f0e9 = function(a) {
    var b = $991d25b6c67751d2$var$M.bind(null, a);
    b.type = a;
    return b;
};
$991d25b6c67751d2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$991d25b6c67751d2$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $991d25b6c67751d2$var$v,
        render: a
    };
};
$991d25b6c67751d2$export$a8257692ac88316c = $991d25b6c67751d2$var$O;
$991d25b6c67751d2$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $991d25b6c67751d2$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $991d25b6c67751d2$var$T
    };
};
$991d25b6c67751d2$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $991d25b6c67751d2$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$991d25b6c67751d2$export$7568632d0d33d16d = function(a) {
    var b = $991d25b6c67751d2$var$V.transition;
    $991d25b6c67751d2$var$V.transition = {};
    try {
        a();
    } finally{
        $991d25b6c67751d2$var$V.transition = b;
    }
};
$991d25b6c67751d2$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$991d25b6c67751d2$export$35808ee640e87ca7 = function(a, b) {
    return $991d25b6c67751d2$var$U.current.useCallback(a, b);
};
$991d25b6c67751d2$export$fae74005e78b1a27 = function(a) {
    return $991d25b6c67751d2$var$U.current.useContext(a);
};
$991d25b6c67751d2$export$dc8fbce3eb94dc1e = function() {};
$991d25b6c67751d2$export$6a7bc4e911dc01cf = function(a) {
    return $991d25b6c67751d2$var$U.current.useDeferredValue(a);
};
$991d25b6c67751d2$export$6d9c69b0de29b591 = function(a, b) {
    return $991d25b6c67751d2$var$U.current.useEffect(a, b);
};
$991d25b6c67751d2$export$f680877a34711e37 = function() {
    return $991d25b6c67751d2$var$U.current.useId();
};
$991d25b6c67751d2$export$d5a552a76deda3c2 = function(a, b, e) {
    return $991d25b6c67751d2$var$U.current.useImperativeHandle(a, b, e);
};
$991d25b6c67751d2$export$aaabe4eda9ed9969 = function(a, b) {
    return $991d25b6c67751d2$var$U.current.useInsertionEffect(a, b);
};
$991d25b6c67751d2$export$e5c5a5f917a5871c = function(a, b) {
    return $991d25b6c67751d2$var$U.current.useLayoutEffect(a, b);
};
$991d25b6c67751d2$export$1538c33de8887b59 = function(a, b) {
    return $991d25b6c67751d2$var$U.current.useMemo(a, b);
};
$991d25b6c67751d2$export$13e3392192263954 = function(a, b, e) {
    return $991d25b6c67751d2$var$U.current.useReducer(a, b, e);
};
$991d25b6c67751d2$export$b8f5890fc79d6aca = function(a) {
    return $991d25b6c67751d2$var$U.current.useRef(a);
};
$991d25b6c67751d2$export$60241385465d0a34 = function(a) {
    return $991d25b6c67751d2$var$U.current.useState(a);
};
$991d25b6c67751d2$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $991d25b6c67751d2$var$U.current.useSyncExternalStore(a, b, e);
};
$991d25b6c67751d2$export$7b286972b8d8ccbf = function() {
    return $991d25b6c67751d2$var$U.current.useTransition();
};
$991d25b6c67751d2$export$83d89fbfd8236492 = "18.2.0";

});
parcelRequire.register("qb7pP", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $04eb0dbf26262756$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $04eb0dbf26262756$export$5f0017c582d45a2d; });
function $04eb0dbf26262756$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRequire.register("diKvV", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $9af1097fda9f2b31$export$ae55be85d98224ed; }, function (v) { return $9af1097fda9f2b31$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $9af1097fda9f2b31$export$d39a5bbd09211389; }, function (v) { return $9af1097fda9f2b31$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $9af1097fda9f2b31$export$882461b6382ed46c; }, function (v) { return $9af1097fda9f2b31$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $9af1097fda9f2b31$export$466bfc07425424d5; }, function (v) { return $9af1097fda9f2b31$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $9af1097fda9f2b31$export$cd75ccfd720a3cd4; }, function (v) { return $9af1097fda9f2b31$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $9af1097fda9f2b31$export$fa8d919ba61d84db; }, function (v) { return $9af1097fda9f2b31$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $9af1097fda9f2b31$export$757ceba2d55c277e; }, function (v) { return $9af1097fda9f2b31$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $9af1097fda9f2b31$export$b3890eb0ae9dca99; }, function (v) { return $9af1097fda9f2b31$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $9af1097fda9f2b31$export$502457920280e6be; }, function (v) { return $9af1097fda9f2b31$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $9af1097fda9f2b31$export$c78a37762a8d58e1; }, function (v) { return $9af1097fda9f2b31$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $9af1097fda9f2b31$export$dc54d992c10e8a18; }, function (v) { return $9af1097fda9f2b31$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $9af1097fda9f2b31$export$83d89fbfd8236492; }, function (v) { return $9af1097fda9f2b31$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $qb7pP = parcelRequire("qb7pP");
var $9af1097fda9f2b31$export$ae55be85d98224ed;
var $9af1097fda9f2b31$export$d39a5bbd09211389;
var $9af1097fda9f2b31$export$882461b6382ed46c;
var $9af1097fda9f2b31$export$466bfc07425424d5;
var $9af1097fda9f2b31$export$cd75ccfd720a3cd4;
var $9af1097fda9f2b31$export$fa8d919ba61d84db;
var $9af1097fda9f2b31$export$757ceba2d55c277e;
var $9af1097fda9f2b31$export$b3890eb0ae9dca99;
var $9af1097fda9f2b31$export$502457920280e6be;
var $9af1097fda9f2b31$export$c78a37762a8d58e1;
var $9af1097fda9f2b31$export$dc54d992c10e8a18;
var $9af1097fda9f2b31$export$83d89fbfd8236492;
"use strict";

var $3aC2T = parcelRequire("3aC2T");

var $uOv5F = parcelRequire("uOv5F");
function $9af1097fda9f2b31$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9af1097fda9f2b31$var$da = new Set, $9af1097fda9f2b31$var$ea = {};
function $9af1097fda9f2b31$var$fa(a, b) {
    $9af1097fda9f2b31$var$ha(a, b);
    $9af1097fda9f2b31$var$ha(a + "Capture", b);
}
function $9af1097fda9f2b31$var$ha(a, b) {
    $9af1097fda9f2b31$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9af1097fda9f2b31$var$da.add(b[a]);
}
var $9af1097fda9f2b31$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9af1097fda9f2b31$var$ja = Object.prototype.hasOwnProperty, $9af1097fda9f2b31$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9af1097fda9f2b31$var$la = {}, $9af1097fda9f2b31$var$ma = {};
function $9af1097fda9f2b31$var$oa(a) {
    if ($9af1097fda9f2b31$var$ja.call($9af1097fda9f2b31$var$ma, a)) return !0;
    if ($9af1097fda9f2b31$var$ja.call($9af1097fda9f2b31$var$la, a)) return !1;
    if ($9af1097fda9f2b31$var$ka.test(a)) return $9af1097fda9f2b31$var$ma[a] = !0;
    $9af1097fda9f2b31$var$la[a] = !0;
    return !1;
}
function $9af1097fda9f2b31$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $qb7pP._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9af1097fda9f2b31$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9af1097fda9f2b31$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9af1097fda9f2b31$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9af1097fda9f2b31$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9af1097fda9f2b31$var$z[b] = new $9af1097fda9f2b31$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9af1097fda9f2b31$var$ra = /[\-:]([a-z])/g;
function $9af1097fda9f2b31$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9af1097fda9f2b31$var$ra, $9af1097fda9f2b31$var$sa);
    $9af1097fda9f2b31$var$z[b] = new $9af1097fda9f2b31$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9af1097fda9f2b31$var$ra, $9af1097fda9f2b31$var$sa);
    $9af1097fda9f2b31$var$z[b] = new $9af1097fda9f2b31$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9af1097fda9f2b31$var$ra, $9af1097fda9f2b31$var$sa);
    $9af1097fda9f2b31$var$z[b] = new $9af1097fda9f2b31$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9af1097fda9f2b31$var$z.xlinkHref = new $9af1097fda9f2b31$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9af1097fda9f2b31$var$ta(a, b, c, d) {
    var e = $9af1097fda9f2b31$var$z.hasOwnProperty(b) ? $9af1097fda9f2b31$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9af1097fda9f2b31$var$qa(b, c, e, d) && (c = null), d || null === e ? $9af1097fda9f2b31$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9af1097fda9f2b31$var$ua = $3aC2T.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9af1097fda9f2b31$var$va = Symbol["for"]("react.element"), $9af1097fda9f2b31$var$wa = Symbol["for"]("react.portal"), $9af1097fda9f2b31$var$ya = Symbol["for"]("react.fragment"), $9af1097fda9f2b31$var$za = Symbol["for"]("react.strict_mode"), $9af1097fda9f2b31$var$Aa = Symbol["for"]("react.profiler"), $9af1097fda9f2b31$var$Ba = Symbol["for"]("react.provider"), $9af1097fda9f2b31$var$Ca = Symbol["for"]("react.context"), $9af1097fda9f2b31$var$Da = Symbol["for"]("react.forward_ref"), $9af1097fda9f2b31$var$Ea = Symbol["for"]("react.suspense"), $9af1097fda9f2b31$var$Fa = Symbol["for"]("react.suspense_list"), $9af1097fda9f2b31$var$Ga = Symbol["for"]("react.memo"), $9af1097fda9f2b31$var$Ha = Symbol["for"]("react.lazy");
Symbol["for"]("react.scope");
Symbol["for"]("react.debug_trace_mode");
var $9af1097fda9f2b31$var$Ia = Symbol["for"]("react.offscreen");
Symbol["for"]("react.legacy_hidden");
Symbol["for"]("react.cache");
Symbol["for"]("react.tracing_marker");
var $9af1097fda9f2b31$var$Ja = Symbol.iterator;
function $9af1097fda9f2b31$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9af1097fda9f2b31$var$Ja && a[$9af1097fda9f2b31$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9af1097fda9f2b31$var$A = Object.assign, $9af1097fda9f2b31$var$La;
function $9af1097fda9f2b31$var$Ma(a) {
    if (void 0 === $9af1097fda9f2b31$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9af1097fda9f2b31$var$La = b && b[1] || "";
    }
    return "\n" + $9af1097fda9f2b31$var$La + a;
}
var $9af1097fda9f2b31$var$Na = !1;
function $9af1097fda9f2b31$var$Oa(a, b) {
    if (!a || $9af1097fda9f2b31$var$Na) return "";
    $9af1097fda9f2b31$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9af1097fda9f2b31$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9af1097fda9f2b31$var$Ma(a) : "";
}
function $9af1097fda9f2b31$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9af1097fda9f2b31$var$Ma(a.type);
        case 16:
            return $9af1097fda9f2b31$var$Ma("Lazy");
        case 13:
            return $9af1097fda9f2b31$var$Ma("Suspense");
        case 19:
            return $9af1097fda9f2b31$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9af1097fda9f2b31$var$Oa(a.type, !1), a;
        case 11:
            return a = $9af1097fda9f2b31$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9af1097fda9f2b31$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9af1097fda9f2b31$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9af1097fda9f2b31$var$ya:
            return "Fragment";
        case $9af1097fda9f2b31$var$wa:
            return "Portal";
        case $9af1097fda9f2b31$var$Aa:
            return "Profiler";
        case $9af1097fda9f2b31$var$za:
            return "StrictMode";
        case $9af1097fda9f2b31$var$Ea:
            return "Suspense";
        case $9af1097fda9f2b31$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9af1097fda9f2b31$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9af1097fda9f2b31$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9af1097fda9f2b31$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9af1097fda9f2b31$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9af1097fda9f2b31$var$Qa(a.type) || "Memo";
        case $9af1097fda9f2b31$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9af1097fda9f2b31$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9af1097fda9f2b31$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9af1097fda9f2b31$var$Qa(b);
        case 8:
            return b === $9af1097fda9f2b31$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9af1097fda9f2b31$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $qb7pP._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9af1097fda9f2b31$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9af1097fda9f2b31$var$Ua(a) {
    var b = $9af1097fda9f2b31$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9af1097fda9f2b31$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9af1097fda9f2b31$var$Ua(a));
}
function $9af1097fda9f2b31$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9af1097fda9f2b31$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9af1097fda9f2b31$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9af1097fda9f2b31$var$Ya(a, b) {
    var c = b.checked;
    return $9af1097fda9f2b31$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9af1097fda9f2b31$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9af1097fda9f2b31$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9af1097fda9f2b31$var$ab(a, b) {
    b = b.checked;
    null != b && $9af1097fda9f2b31$var$ta(a, "checked", b, !1);
}
function $9af1097fda9f2b31$var$bb(a, b) {
    $9af1097fda9f2b31$var$ab(a, b);
    var c = $9af1097fda9f2b31$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9af1097fda9f2b31$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9af1097fda9f2b31$var$cb(a, b.type, $9af1097fda9f2b31$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9af1097fda9f2b31$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9af1097fda9f2b31$var$cb(a, b, c) {
    if ("number" !== b || $9af1097fda9f2b31$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9af1097fda9f2b31$var$eb = Array.isArray;
function $9af1097fda9f2b31$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9af1097fda9f2b31$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9af1097fda9f2b31$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9af1097fda9f2b31$var$p(91));
    return $9af1097fda9f2b31$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9af1097fda9f2b31$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9af1097fda9f2b31$var$p(92));
            if ($9af1097fda9f2b31$var$eb(c)) {
                if (1 < c.length) throw Error($9af1097fda9f2b31$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9af1097fda9f2b31$var$Sa(c)
    };
}
function $9af1097fda9f2b31$var$ib(a, b) {
    var c = $9af1097fda9f2b31$var$Sa(b.value), d = $9af1097fda9f2b31$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9af1097fda9f2b31$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9af1097fda9f2b31$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9af1097fda9f2b31$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9af1097fda9f2b31$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9af1097fda9f2b31$var$mb, $9af1097fda9f2b31$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9af1097fda9f2b31$var$mb = $9af1097fda9f2b31$var$mb || document.createElement("div");
        $9af1097fda9f2b31$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9af1097fda9f2b31$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9af1097fda9f2b31$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9af1097fda9f2b31$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9af1097fda9f2b31$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9af1097fda9f2b31$var$pb).forEach(function(a) {
    $9af1097fda9f2b31$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9af1097fda9f2b31$var$pb[b] = $9af1097fda9f2b31$var$pb[a];
    });
});
function $9af1097fda9f2b31$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9af1097fda9f2b31$var$pb.hasOwnProperty(a) && $9af1097fda9f2b31$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9af1097fda9f2b31$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9af1097fda9f2b31$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9af1097fda9f2b31$var$tb = $9af1097fda9f2b31$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9af1097fda9f2b31$var$ub(a, b) {
    if (b) {
        if ($9af1097fda9f2b31$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9af1097fda9f2b31$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9af1097fda9f2b31$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9af1097fda9f2b31$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9af1097fda9f2b31$var$p(62));
    }
}
function $9af1097fda9f2b31$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9af1097fda9f2b31$var$wb = null;
function $9af1097fda9f2b31$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9af1097fda9f2b31$var$yb = null, $9af1097fda9f2b31$var$zb = null, $9af1097fda9f2b31$var$Ab = null;
function $9af1097fda9f2b31$var$Bb(a) {
    if (a = $9af1097fda9f2b31$var$Cb(a)) {
        if ("function" !== typeof $9af1097fda9f2b31$var$yb) throw Error($9af1097fda9f2b31$var$p(280));
        var b = a.stateNode;
        b && (b = $9af1097fda9f2b31$var$Db(b), $9af1097fda9f2b31$var$yb(a.stateNode, a.type, b));
    }
}
function $9af1097fda9f2b31$var$Eb(a) {
    $9af1097fda9f2b31$var$zb ? $9af1097fda9f2b31$var$Ab ? $9af1097fda9f2b31$var$Ab.push(a) : $9af1097fda9f2b31$var$Ab = [
        a
    ] : $9af1097fda9f2b31$var$zb = a;
}
function $9af1097fda9f2b31$var$Fb() {
    if ($9af1097fda9f2b31$var$zb) {
        var a = $9af1097fda9f2b31$var$zb, b = $9af1097fda9f2b31$var$Ab;
        $9af1097fda9f2b31$var$Ab = $9af1097fda9f2b31$var$zb = null;
        $9af1097fda9f2b31$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9af1097fda9f2b31$var$Bb(b[a]);
    }
}
function $9af1097fda9f2b31$var$Gb(a, b) {
    return a(b);
}
function $9af1097fda9f2b31$var$Hb() {}
var $9af1097fda9f2b31$var$Ib = !1;
function $9af1097fda9f2b31$var$Jb(a, b, c) {
    if ($9af1097fda9f2b31$var$Ib) return a(b, c);
    $9af1097fda9f2b31$var$Ib = !0;
    try {
        return $9af1097fda9f2b31$var$Gb(a, b, c);
    } finally{
        if ($9af1097fda9f2b31$var$Ib = !1, null !== $9af1097fda9f2b31$var$zb || null !== $9af1097fda9f2b31$var$Ab) $9af1097fda9f2b31$var$Hb(), $9af1097fda9f2b31$var$Fb();
    }
}
function $9af1097fda9f2b31$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9af1097fda9f2b31$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9af1097fda9f2b31$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $qb7pP._)(c)));
    return c;
}
var $9af1097fda9f2b31$var$Lb = !1;
if ($9af1097fda9f2b31$var$ia) try {
    var $9af1097fda9f2b31$var$Mb = {};
    Object.defineProperty($9af1097fda9f2b31$var$Mb, "passive", {
        get: function get() {
            $9af1097fda9f2b31$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9af1097fda9f2b31$var$Mb, $9af1097fda9f2b31$var$Mb);
    window.removeEventListener("test", $9af1097fda9f2b31$var$Mb, $9af1097fda9f2b31$var$Mb);
} catch (a) {
    $9af1097fda9f2b31$var$Lb = !1;
}
function $9af1097fda9f2b31$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9af1097fda9f2b31$var$Ob = !1, $9af1097fda9f2b31$var$Pb = null, $9af1097fda9f2b31$var$Qb = !1, $9af1097fda9f2b31$var$Rb = null, $9af1097fda9f2b31$var$Sb = {
    onError: function onError(a) {
        $9af1097fda9f2b31$var$Ob = !0;
        $9af1097fda9f2b31$var$Pb = a;
    }
};
function $9af1097fda9f2b31$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9af1097fda9f2b31$var$Ob = !1;
    $9af1097fda9f2b31$var$Pb = null;
    $9af1097fda9f2b31$var$Nb.apply($9af1097fda9f2b31$var$Sb, arguments);
}
function $9af1097fda9f2b31$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9af1097fda9f2b31$var$Tb.apply(this, arguments);
    if ($9af1097fda9f2b31$var$Ob) {
        if ($9af1097fda9f2b31$var$Ob) {
            var l = $9af1097fda9f2b31$var$Pb;
            $9af1097fda9f2b31$var$Ob = !1;
            $9af1097fda9f2b31$var$Pb = null;
        } else throw Error($9af1097fda9f2b31$var$p(198));
        $9af1097fda9f2b31$var$Qb || ($9af1097fda9f2b31$var$Qb = !0, $9af1097fda9f2b31$var$Rb = l);
    }
}
function $9af1097fda9f2b31$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b["return"];)b = b["return"];
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b["return"]), a = b["return"];
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9af1097fda9f2b31$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9af1097fda9f2b31$var$Xb(a) {
    if ($9af1097fda9f2b31$var$Vb(a) !== a) throw Error($9af1097fda9f2b31$var$p(188));
}
function $9af1097fda9f2b31$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9af1097fda9f2b31$var$Vb(a);
        if (null === b) throw Error($9af1097fda9f2b31$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c["return"];
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e["return"];
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9af1097fda9f2b31$var$Xb(e), a;
                if (f === d) return $9af1097fda9f2b31$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9af1097fda9f2b31$var$p(188));
        }
        if (c["return"] !== d["return"]) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9af1097fda9f2b31$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9af1097fda9f2b31$var$p(190));
    }
    if (3 !== c.tag) throw Error($9af1097fda9f2b31$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9af1097fda9f2b31$var$Zb(a) {
    a = $9af1097fda9f2b31$var$Yb(a);
    return null !== a ? $9af1097fda9f2b31$var$$b(a) : null;
}
function $9af1097fda9f2b31$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9af1097fda9f2b31$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9af1097fda9f2b31$var$ac = $uOv5F.unstable_scheduleCallback, $9af1097fda9f2b31$var$bc = $uOv5F.unstable_cancelCallback, $9af1097fda9f2b31$var$cc = $uOv5F.unstable_shouldYield, $9af1097fda9f2b31$var$dc = $uOv5F.unstable_requestPaint, $9af1097fda9f2b31$var$B = $uOv5F.unstable_now, $9af1097fda9f2b31$var$ec = $uOv5F.unstable_getCurrentPriorityLevel, $9af1097fda9f2b31$var$fc = $uOv5F.unstable_ImmediatePriority, $9af1097fda9f2b31$var$gc = $uOv5F.unstable_UserBlockingPriority, $9af1097fda9f2b31$var$hc = $uOv5F.unstable_NormalPriority, $9af1097fda9f2b31$var$ic = $uOv5F.unstable_LowPriority, $9af1097fda9f2b31$var$jc = $uOv5F.unstable_IdlePriority, $9af1097fda9f2b31$var$kc = null, $9af1097fda9f2b31$var$lc = null;
function $9af1097fda9f2b31$var$mc(a) {
    if ($9af1097fda9f2b31$var$lc && "function" === typeof $9af1097fda9f2b31$var$lc.onCommitFiberRoot) try {
        $9af1097fda9f2b31$var$lc.onCommitFiberRoot($9af1097fda9f2b31$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9af1097fda9f2b31$var$oc = Math.clz32 ? Math.clz32 : $9af1097fda9f2b31$var$nc, $9af1097fda9f2b31$var$pc = Math.log, $9af1097fda9f2b31$var$qc = Math.LN2;
function $9af1097fda9f2b31$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9af1097fda9f2b31$var$pc(a) / $9af1097fda9f2b31$var$qc | 0) | 0;
}
var $9af1097fda9f2b31$var$rc = 64, $9af1097fda9f2b31$var$sc = 4194304;
function $9af1097fda9f2b31$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9af1097fda9f2b31$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9af1097fda9f2b31$var$tc(h) : (f &= g, 0 !== f && (d = $9af1097fda9f2b31$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9af1097fda9f2b31$var$tc(g) : 0 !== f && (d = $9af1097fda9f2b31$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9af1097fda9f2b31$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9af1097fda9f2b31$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9af1097fda9f2b31$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9af1097fda9f2b31$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9af1097fda9f2b31$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9af1097fda9f2b31$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9af1097fda9f2b31$var$yc() {
    var a = $9af1097fda9f2b31$var$rc;
    $9af1097fda9f2b31$var$rc <<= 1;
    0 === ($9af1097fda9f2b31$var$rc & 4194240) && ($9af1097fda9f2b31$var$rc = 64);
    return a;
}
function $9af1097fda9f2b31$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9af1097fda9f2b31$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9af1097fda9f2b31$var$oc(b);
    a[b] = c;
}
function $9af1097fda9f2b31$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9af1097fda9f2b31$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9af1097fda9f2b31$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9af1097fda9f2b31$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9af1097fda9f2b31$var$C = 0;
function $9af1097fda9f2b31$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9af1097fda9f2b31$var$Ec, $9af1097fda9f2b31$var$Fc, $9af1097fda9f2b31$var$Gc, $9af1097fda9f2b31$var$Hc, $9af1097fda9f2b31$var$Ic, $9af1097fda9f2b31$var$Jc = !1, $9af1097fda9f2b31$var$Kc = [], $9af1097fda9f2b31$var$Lc = null, $9af1097fda9f2b31$var$Mc = null, $9af1097fda9f2b31$var$Nc = null, $9af1097fda9f2b31$var$Oc = new Map, $9af1097fda9f2b31$var$Pc = new Map, $9af1097fda9f2b31$var$Qc = [], $9af1097fda9f2b31$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9af1097fda9f2b31$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9af1097fda9f2b31$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9af1097fda9f2b31$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9af1097fda9f2b31$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9af1097fda9f2b31$var$Oc["delete"](b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9af1097fda9f2b31$var$Pc["delete"](b.pointerId);
    }
}
function $9af1097fda9f2b31$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9af1097fda9f2b31$var$Cb(b), null !== b && $9af1097fda9f2b31$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9af1097fda9f2b31$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9af1097fda9f2b31$var$Lc = $9af1097fda9f2b31$var$Tc($9af1097fda9f2b31$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9af1097fda9f2b31$var$Mc = $9af1097fda9f2b31$var$Tc($9af1097fda9f2b31$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9af1097fda9f2b31$var$Nc = $9af1097fda9f2b31$var$Tc($9af1097fda9f2b31$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9af1097fda9f2b31$var$Oc.set(f, $9af1097fda9f2b31$var$Tc($9af1097fda9f2b31$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9af1097fda9f2b31$var$Pc.set(f, $9af1097fda9f2b31$var$Tc($9af1097fda9f2b31$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9af1097fda9f2b31$var$Vc(a) {
    var b = $9af1097fda9f2b31$var$Wc(a.target);
    if (null !== b) {
        var c = $9af1097fda9f2b31$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9af1097fda9f2b31$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9af1097fda9f2b31$var$Ic(a.priority, function() {
                        $9af1097fda9f2b31$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9af1097fda9f2b31$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9af1097fda9f2b31$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9af1097fda9f2b31$var$wb = d;
            c.target.dispatchEvent(d);
            $9af1097fda9f2b31$var$wb = null;
        } else return b = $9af1097fda9f2b31$var$Cb(c), null !== b && $9af1097fda9f2b31$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9af1097fda9f2b31$var$Zc(a, b, c) {
    $9af1097fda9f2b31$var$Xc(a) && c["delete"](b);
}
function $9af1097fda9f2b31$var$$c() {
    $9af1097fda9f2b31$var$Jc = !1;
    null !== $9af1097fda9f2b31$var$Lc && $9af1097fda9f2b31$var$Xc($9af1097fda9f2b31$var$Lc) && ($9af1097fda9f2b31$var$Lc = null);
    null !== $9af1097fda9f2b31$var$Mc && $9af1097fda9f2b31$var$Xc($9af1097fda9f2b31$var$Mc) && ($9af1097fda9f2b31$var$Mc = null);
    null !== $9af1097fda9f2b31$var$Nc && $9af1097fda9f2b31$var$Xc($9af1097fda9f2b31$var$Nc) && ($9af1097fda9f2b31$var$Nc = null);
    $9af1097fda9f2b31$var$Oc.forEach($9af1097fda9f2b31$var$Zc);
    $9af1097fda9f2b31$var$Pc.forEach($9af1097fda9f2b31$var$Zc);
}
function $9af1097fda9f2b31$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9af1097fda9f2b31$var$Jc || ($9af1097fda9f2b31$var$Jc = !0, $uOv5F.unstable_scheduleCallback($uOv5F.unstable_NormalPriority, $9af1097fda9f2b31$var$$c)));
}
function $9af1097fda9f2b31$var$bd(a) {
    var b = function b(_b) {
        return $9af1097fda9f2b31$var$ad(_b, a);
    };
    if (0 < $9af1097fda9f2b31$var$Kc.length) {
        $9af1097fda9f2b31$var$ad($9af1097fda9f2b31$var$Kc[0], a);
        for(var c = 1; c < $9af1097fda9f2b31$var$Kc.length; c++){
            var d = $9af1097fda9f2b31$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9af1097fda9f2b31$var$Lc && $9af1097fda9f2b31$var$ad($9af1097fda9f2b31$var$Lc, a);
    null !== $9af1097fda9f2b31$var$Mc && $9af1097fda9f2b31$var$ad($9af1097fda9f2b31$var$Mc, a);
    null !== $9af1097fda9f2b31$var$Nc && $9af1097fda9f2b31$var$ad($9af1097fda9f2b31$var$Nc, a);
    $9af1097fda9f2b31$var$Oc.forEach(b);
    $9af1097fda9f2b31$var$Pc.forEach(b);
    for(c = 0; c < $9af1097fda9f2b31$var$Qc.length; c++)d = $9af1097fda9f2b31$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9af1097fda9f2b31$var$Qc.length && (c = $9af1097fda9f2b31$var$Qc[0], null === c.blockedOn);)$9af1097fda9f2b31$var$Vc(c), null === c.blockedOn && $9af1097fda9f2b31$var$Qc.shift();
}
var $9af1097fda9f2b31$var$cd = $9af1097fda9f2b31$var$ua.ReactCurrentBatchConfig, $9af1097fda9f2b31$var$dd = !0;
function $9af1097fda9f2b31$var$ed(a, b, c, d) {
    var e = $9af1097fda9f2b31$var$C, f = $9af1097fda9f2b31$var$cd.transition;
    $9af1097fda9f2b31$var$cd.transition = null;
    try {
        $9af1097fda9f2b31$var$C = 1, $9af1097fda9f2b31$var$fd(a, b, c, d);
    } finally{
        $9af1097fda9f2b31$var$C = e, $9af1097fda9f2b31$var$cd.transition = f;
    }
}
function $9af1097fda9f2b31$var$gd(a, b, c, d) {
    var e = $9af1097fda9f2b31$var$C, f = $9af1097fda9f2b31$var$cd.transition;
    $9af1097fda9f2b31$var$cd.transition = null;
    try {
        $9af1097fda9f2b31$var$C = 4, $9af1097fda9f2b31$var$fd(a, b, c, d);
    } finally{
        $9af1097fda9f2b31$var$C = e, $9af1097fda9f2b31$var$cd.transition = f;
    }
}
function $9af1097fda9f2b31$var$fd(a, b, c, d) {
    if ($9af1097fda9f2b31$var$dd) {
        var e = $9af1097fda9f2b31$var$Yc(a, b, c, d);
        if (null === e) $9af1097fda9f2b31$var$hd(a, b, d, $9af1097fda9f2b31$var$id, c), $9af1097fda9f2b31$var$Sc(a, d);
        else if ($9af1097fda9f2b31$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9af1097fda9f2b31$var$Sc(a, d), b & 4 && -1 < $9af1097fda9f2b31$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9af1097fda9f2b31$var$Cb(e);
                null !== f && $9af1097fda9f2b31$var$Ec(f);
                f = $9af1097fda9f2b31$var$Yc(a, b, c, d);
                null === f && $9af1097fda9f2b31$var$hd(a, b, d, $9af1097fda9f2b31$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9af1097fda9f2b31$var$hd(a, b, d, null, c);
    }
}
var $9af1097fda9f2b31$var$id = null;
function $9af1097fda9f2b31$var$Yc(a, b, c, d) {
    $9af1097fda9f2b31$var$id = null;
    a = $9af1097fda9f2b31$var$xb(d);
    a = $9af1097fda9f2b31$var$Wc(a);
    if (null !== a) {
        if (b = $9af1097fda9f2b31$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9af1097fda9f2b31$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9af1097fda9f2b31$var$id = a;
    return null;
}
function $9af1097fda9f2b31$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9af1097fda9f2b31$var$ec()){
                case $9af1097fda9f2b31$var$fc:
                    return 1;
                case $9af1097fda9f2b31$var$gc:
                    return 4;
                case $9af1097fda9f2b31$var$hc:
                case $9af1097fda9f2b31$var$ic:
                    return 16;
                case $9af1097fda9f2b31$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9af1097fda9f2b31$var$kd = null, $9af1097fda9f2b31$var$ld = null, $9af1097fda9f2b31$var$md = null;
function $9af1097fda9f2b31$var$nd() {
    if ($9af1097fda9f2b31$var$md) return $9af1097fda9f2b31$var$md;
    var a, b = $9af1097fda9f2b31$var$ld, c = b.length, d, e = "value" in $9af1097fda9f2b31$var$kd ? $9af1097fda9f2b31$var$kd.value : $9af1097fda9f2b31$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9af1097fda9f2b31$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9af1097fda9f2b31$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9af1097fda9f2b31$var$pd() {
    return !0;
}
function $9af1097fda9f2b31$var$qd() {
    return !1;
}
function $9af1097fda9f2b31$var$rd(a) {
    var b = function b(_b, d, e, f, g) {
        this._reactName = _b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (_b = a[c], this[c] = _b ? _b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9af1097fda9f2b31$var$pd : $9af1097fda9f2b31$var$qd;
        this.isPropagationStopped = $9af1097fda9f2b31$var$qd;
        return this;
    };
    $9af1097fda9f2b31$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $qb7pP._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $9af1097fda9f2b31$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $qb7pP._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $9af1097fda9f2b31$var$pd);
        },
        persist: function persist() {},
        isPersistent: $9af1097fda9f2b31$var$pd
    });
    return b;
}
var $9af1097fda9f2b31$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9af1097fda9f2b31$var$td = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$sd), $9af1097fda9f2b31$var$ud = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$sd, {
    view: 0,
    detail: 0
}), $9af1097fda9f2b31$var$vd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$ud), $9af1097fda9f2b31$var$wd, $9af1097fda9f2b31$var$xd, $9af1097fda9f2b31$var$yd, $9af1097fda9f2b31$var$Ad = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9af1097fda9f2b31$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9af1097fda9f2b31$var$yd && ($9af1097fda9f2b31$var$yd && "mousemove" === a.type ? ($9af1097fda9f2b31$var$wd = a.screenX - $9af1097fda9f2b31$var$yd.screenX, $9af1097fda9f2b31$var$xd = a.screenY - $9af1097fda9f2b31$var$yd.screenY) : $9af1097fda9f2b31$var$xd = $9af1097fda9f2b31$var$wd = 0, $9af1097fda9f2b31$var$yd = a);
        return $9af1097fda9f2b31$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $9af1097fda9f2b31$var$xd;
    }
}), $9af1097fda9f2b31$var$Bd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Ad), $9af1097fda9f2b31$var$Cd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$Ad, {
    dataTransfer: 0
}), $9af1097fda9f2b31$var$Dd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Cd), $9af1097fda9f2b31$var$Ed = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$ud, {
    relatedTarget: 0
}), $9af1097fda9f2b31$var$Fd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Ed), $9af1097fda9f2b31$var$Gd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9af1097fda9f2b31$var$Hd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Gd), $9af1097fda9f2b31$var$Id = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9af1097fda9f2b31$var$Jd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Id), $9af1097fda9f2b31$var$Kd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$sd, {
    data: 0
}), $9af1097fda9f2b31$var$Ld = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Kd), $9af1097fda9f2b31$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9af1097fda9f2b31$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9af1097fda9f2b31$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9af1097fda9f2b31$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9af1097fda9f2b31$var$Od[a]) ? !!b[a] : !1;
}
function $9af1097fda9f2b31$var$zd() {
    return $9af1097fda9f2b31$var$Pd;
}
var $9af1097fda9f2b31$var$Qd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $9af1097fda9f2b31$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9af1097fda9f2b31$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9af1097fda9f2b31$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9af1097fda9f2b31$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $9af1097fda9f2b31$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $9af1097fda9f2b31$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9af1097fda9f2b31$var$Rd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Qd), $9af1097fda9f2b31$var$Sd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9af1097fda9f2b31$var$Td = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Sd), $9af1097fda9f2b31$var$Ud = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9af1097fda9f2b31$var$zd
}), $9af1097fda9f2b31$var$Vd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Ud), $9af1097fda9f2b31$var$Wd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9af1097fda9f2b31$var$Xd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Wd), $9af1097fda9f2b31$var$Yd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9af1097fda9f2b31$var$Zd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Yd), $9af1097fda9f2b31$var$$d = [
    9,
    13,
    27,
    32
], $9af1097fda9f2b31$var$ae = $9af1097fda9f2b31$var$ia && "CompositionEvent" in window, $9af1097fda9f2b31$var$be = null;
$9af1097fda9f2b31$var$ia && "documentMode" in document && ($9af1097fda9f2b31$var$be = document.documentMode);
var $9af1097fda9f2b31$var$ce = $9af1097fda9f2b31$var$ia && "TextEvent" in window && !$9af1097fda9f2b31$var$be, $9af1097fda9f2b31$var$de = $9af1097fda9f2b31$var$ia && (!$9af1097fda9f2b31$var$ae || $9af1097fda9f2b31$var$be && 8 < $9af1097fda9f2b31$var$be && 11 >= $9af1097fda9f2b31$var$be), $9af1097fda9f2b31$var$ee = String.fromCharCode(32), $9af1097fda9f2b31$var$fe = !1;
function $9af1097fda9f2b31$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9af1097fda9f2b31$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9af1097fda9f2b31$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9af1097fda9f2b31$var$ie = !1;
function $9af1097fda9f2b31$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9af1097fda9f2b31$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9af1097fda9f2b31$var$fe = !0;
            return $9af1097fda9f2b31$var$ee;
        case "textInput":
            return a = b.data, a === $9af1097fda9f2b31$var$ee && $9af1097fda9f2b31$var$fe ? null : a;
        default:
            return null;
    }
}
function $9af1097fda9f2b31$var$ke(a, b) {
    if ($9af1097fda9f2b31$var$ie) return "compositionend" === a || !$9af1097fda9f2b31$var$ae && $9af1097fda9f2b31$var$ge(a, b) ? (a = $9af1097fda9f2b31$var$nd(), $9af1097fda9f2b31$var$md = $9af1097fda9f2b31$var$ld = $9af1097fda9f2b31$var$kd = null, $9af1097fda9f2b31$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b["char"] && 1 < b["char"].length) return b["char"];
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9af1097fda9f2b31$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9af1097fda9f2b31$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9af1097fda9f2b31$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9af1097fda9f2b31$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9af1097fda9f2b31$var$ne(a, b, c, d) {
    $9af1097fda9f2b31$var$Eb(d);
    b = $9af1097fda9f2b31$var$oe(b, "onChange");
    0 < b.length && (c = new $9af1097fda9f2b31$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9af1097fda9f2b31$var$pe = null, $9af1097fda9f2b31$var$qe = null;
function $9af1097fda9f2b31$var$re(a) {
    $9af1097fda9f2b31$var$se(a, 0);
}
function $9af1097fda9f2b31$var$te(a) {
    var b = $9af1097fda9f2b31$var$ue(a);
    if ($9af1097fda9f2b31$var$Wa(b)) return a;
}
function $9af1097fda9f2b31$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9af1097fda9f2b31$var$we = !1;
if ($9af1097fda9f2b31$var$ia) {
    var $9af1097fda9f2b31$var$xe;
    if ($9af1097fda9f2b31$var$ia) {
        var $9af1097fda9f2b31$var$ye = "oninput" in document;
        if (!$9af1097fda9f2b31$var$ye) {
            var $9af1097fda9f2b31$var$ze = document.createElement("div");
            $9af1097fda9f2b31$var$ze.setAttribute("oninput", "return;");
            $9af1097fda9f2b31$var$ye = "function" === typeof $9af1097fda9f2b31$var$ze.oninput;
        }
        $9af1097fda9f2b31$var$xe = $9af1097fda9f2b31$var$ye;
    } else $9af1097fda9f2b31$var$xe = !1;
    $9af1097fda9f2b31$var$we = $9af1097fda9f2b31$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9af1097fda9f2b31$var$Ae() {
    $9af1097fda9f2b31$var$pe && ($9af1097fda9f2b31$var$pe.detachEvent("onpropertychange", $9af1097fda9f2b31$var$Be), $9af1097fda9f2b31$var$qe = $9af1097fda9f2b31$var$pe = null);
}
function $9af1097fda9f2b31$var$Be(a) {
    if ("value" === a.propertyName && $9af1097fda9f2b31$var$te($9af1097fda9f2b31$var$qe)) {
        var b = [];
        $9af1097fda9f2b31$var$ne(b, $9af1097fda9f2b31$var$qe, a, $9af1097fda9f2b31$var$xb(a));
        $9af1097fda9f2b31$var$Jb($9af1097fda9f2b31$var$re, b);
    }
}
function $9af1097fda9f2b31$var$Ce(a, b, c) {
    "focusin" === a ? ($9af1097fda9f2b31$var$Ae(), $9af1097fda9f2b31$var$pe = b, $9af1097fda9f2b31$var$qe = c, $9af1097fda9f2b31$var$pe.attachEvent("onpropertychange", $9af1097fda9f2b31$var$Be)) : "focusout" === a && $9af1097fda9f2b31$var$Ae();
}
function $9af1097fda9f2b31$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9af1097fda9f2b31$var$te($9af1097fda9f2b31$var$qe);
}
function $9af1097fda9f2b31$var$Ee(a, b) {
    if ("click" === a) return $9af1097fda9f2b31$var$te(b);
}
function $9af1097fda9f2b31$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9af1097fda9f2b31$var$te(b);
}
function $9af1097fda9f2b31$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9af1097fda9f2b31$var$He = "function" === typeof Object.is ? Object.is : $9af1097fda9f2b31$var$Ge;
function $9af1097fda9f2b31$var$Ie(a, b) {
    if ($9af1097fda9f2b31$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9af1097fda9f2b31$var$ja.call(b, e) || !$9af1097fda9f2b31$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9af1097fda9f2b31$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9af1097fda9f2b31$var$Ke(a, b) {
    var c = $9af1097fda9f2b31$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9af1097fda9f2b31$var$Je(c);
    }
}
function $9af1097fda9f2b31$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9af1097fda9f2b31$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9af1097fda9f2b31$var$Me() {
    for(var a = window, b = $9af1097fda9f2b31$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9af1097fda9f2b31$var$Xa(a.document);
    }
    return b;
}
function $9af1097fda9f2b31$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9af1097fda9f2b31$var$Oe(a) {
    var b = $9af1097fda9f2b31$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9af1097fda9f2b31$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9af1097fda9f2b31$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9af1097fda9f2b31$var$Ke(c, f);
                var g = $9af1097fda9f2b31$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9af1097fda9f2b31$var$Pe = $9af1097fda9f2b31$var$ia && "documentMode" in document && 11 >= document.documentMode, $9af1097fda9f2b31$var$Qe = null, $9af1097fda9f2b31$var$Re = null, $9af1097fda9f2b31$var$Se = null, $9af1097fda9f2b31$var$Te = !1;
function $9af1097fda9f2b31$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9af1097fda9f2b31$var$Te || null == $9af1097fda9f2b31$var$Qe || $9af1097fda9f2b31$var$Qe !== $9af1097fda9f2b31$var$Xa(d) || (d = $9af1097fda9f2b31$var$Qe, "selectionStart" in d && $9af1097fda9f2b31$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9af1097fda9f2b31$var$Se && $9af1097fda9f2b31$var$Ie($9af1097fda9f2b31$var$Se, d) || ($9af1097fda9f2b31$var$Se = d, d = $9af1097fda9f2b31$var$oe($9af1097fda9f2b31$var$Re, "onSelect"), 0 < d.length && (b = new $9af1097fda9f2b31$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9af1097fda9f2b31$var$Qe)));
}
function $9af1097fda9f2b31$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9af1097fda9f2b31$var$We = {
    animationend: $9af1097fda9f2b31$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9af1097fda9f2b31$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9af1097fda9f2b31$var$Ve("Animation", "AnimationStart"),
    transitionend: $9af1097fda9f2b31$var$Ve("Transition", "TransitionEnd")
}, $9af1097fda9f2b31$var$Xe = {}, $9af1097fda9f2b31$var$Ye = {};
$9af1097fda9f2b31$var$ia && ($9af1097fda9f2b31$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9af1097fda9f2b31$var$We.animationend.animation, delete $9af1097fda9f2b31$var$We.animationiteration.animation, delete $9af1097fda9f2b31$var$We.animationstart.animation), "TransitionEvent" in window || delete $9af1097fda9f2b31$var$We.transitionend.transition);
function $9af1097fda9f2b31$var$Ze(a) {
    if ($9af1097fda9f2b31$var$Xe[a]) return $9af1097fda9f2b31$var$Xe[a];
    if (!$9af1097fda9f2b31$var$We[a]) return a;
    var b = $9af1097fda9f2b31$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9af1097fda9f2b31$var$Ye) return $9af1097fda9f2b31$var$Xe[a] = b[c];
    return a;
}
var $9af1097fda9f2b31$var$$e = $9af1097fda9f2b31$var$Ze("animationend"), $9af1097fda9f2b31$var$af = $9af1097fda9f2b31$var$Ze("animationiteration"), $9af1097fda9f2b31$var$bf = $9af1097fda9f2b31$var$Ze("animationstart"), $9af1097fda9f2b31$var$cf = $9af1097fda9f2b31$var$Ze("transitionend"), $9af1097fda9f2b31$var$df = new Map, $9af1097fda9f2b31$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9af1097fda9f2b31$var$ff(a, b) {
    $9af1097fda9f2b31$var$df.set(a, b);
    $9af1097fda9f2b31$var$fa(b, [
        a
    ]);
}
for(var $9af1097fda9f2b31$var$gf = 0; $9af1097fda9f2b31$var$gf < $9af1097fda9f2b31$var$ef.length; $9af1097fda9f2b31$var$gf++){
    var $9af1097fda9f2b31$var$hf = $9af1097fda9f2b31$var$ef[$9af1097fda9f2b31$var$gf], $9af1097fda9f2b31$var$jf = $9af1097fda9f2b31$var$hf.toLowerCase(), $9af1097fda9f2b31$var$kf = $9af1097fda9f2b31$var$hf[0].toUpperCase() + $9af1097fda9f2b31$var$hf.slice(1);
    $9af1097fda9f2b31$var$ff($9af1097fda9f2b31$var$jf, "on" + $9af1097fda9f2b31$var$kf);
}
$9af1097fda9f2b31$var$ff($9af1097fda9f2b31$var$$e, "onAnimationEnd");
$9af1097fda9f2b31$var$ff($9af1097fda9f2b31$var$af, "onAnimationIteration");
$9af1097fda9f2b31$var$ff($9af1097fda9f2b31$var$bf, "onAnimationStart");
$9af1097fda9f2b31$var$ff("dblclick", "onDoubleClick");
$9af1097fda9f2b31$var$ff("focusin", "onFocus");
$9af1097fda9f2b31$var$ff("focusout", "onBlur");
$9af1097fda9f2b31$var$ff($9af1097fda9f2b31$var$cf, "onTransitionEnd");
$9af1097fda9f2b31$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9af1097fda9f2b31$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9af1097fda9f2b31$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9af1097fda9f2b31$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9af1097fda9f2b31$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9af1097fda9f2b31$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9af1097fda9f2b31$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9af1097fda9f2b31$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9af1097fda9f2b31$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9af1097fda9f2b31$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9af1097fda9f2b31$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9af1097fda9f2b31$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9af1097fda9f2b31$var$lf));
function $9af1097fda9f2b31$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9af1097fda9f2b31$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9af1097fda9f2b31$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9af1097fda9f2b31$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9af1097fda9f2b31$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9af1097fda9f2b31$var$Qb) throw a = $9af1097fda9f2b31$var$Rb, $9af1097fda9f2b31$var$Qb = !1, $9af1097fda9f2b31$var$Rb = null, a;
}
function $9af1097fda9f2b31$var$D(a, b) {
    var c = b[$9af1097fda9f2b31$var$of];
    void 0 === c && (c = b[$9af1097fda9f2b31$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9af1097fda9f2b31$var$pf(b, a, 2, !1), c.add(d));
}
function $9af1097fda9f2b31$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9af1097fda9f2b31$var$pf(c, a, d, b);
}
var $9af1097fda9f2b31$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9af1097fda9f2b31$var$sf(a) {
    if (!a[$9af1097fda9f2b31$var$rf]) {
        a[$9af1097fda9f2b31$var$rf] = !0;
        $9af1097fda9f2b31$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9af1097fda9f2b31$var$mf.has(b) || $9af1097fda9f2b31$var$qf(b, !1, a), $9af1097fda9f2b31$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9af1097fda9f2b31$var$rf] || (b[$9af1097fda9f2b31$var$rf] = !0, $9af1097fda9f2b31$var$qf("selectionchange", !1, b));
    }
}
function $9af1097fda9f2b31$var$pf(a, b, c, d) {
    switch($9af1097fda9f2b31$var$jd(b)){
        case 1:
            var e = $9af1097fda9f2b31$var$ed;
            break;
        case 4:
            e = $9af1097fda9f2b31$var$gd;
            break;
        default:
            e = $9af1097fda9f2b31$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9af1097fda9f2b31$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9af1097fda9f2b31$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d["return"]; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g["return"];
            }
            for(; null !== h;){
                g = $9af1097fda9f2b31$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d["return"];
    }
    $9af1097fda9f2b31$var$Jb(function() {
        var _$d = f, _$e = $9af1097fda9f2b31$var$xb(c), g = [];
        a: {
            var h = $9af1097fda9f2b31$var$df.get(a);
            if (void 0 !== h) {
                var k = $9af1097fda9f2b31$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9af1097fda9f2b31$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9af1097fda9f2b31$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9af1097fda9f2b31$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9af1097fda9f2b31$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9af1097fda9f2b31$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9af1097fda9f2b31$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9af1097fda9f2b31$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9af1097fda9f2b31$var$Vd;
                        break;
                    case $9af1097fda9f2b31$var$$e:
                    case $9af1097fda9f2b31$var$af:
                    case $9af1097fda9f2b31$var$bf:
                        k = $9af1097fda9f2b31$var$Hd;
                        break;
                    case $9af1097fda9f2b31$var$cf:
                        k = $9af1097fda9f2b31$var$Xd;
                        break;
                    case "scroll":
                        k = $9af1097fda9f2b31$var$vd;
                        break;
                    case "wheel":
                        k = $9af1097fda9f2b31$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9af1097fda9f2b31$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9af1097fda9f2b31$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9af1097fda9f2b31$var$Kb(w, x), null != F && t.push($9af1097fda9f2b31$var$tf(w, F, u))));
                    if (J) break;
                    w = w["return"];
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9af1097fda9f2b31$var$wb && (n = c.relatedTarget || c.fromElement) && ($9af1097fda9f2b31$var$Wc(n) || n[$9af1097fda9f2b31$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $9af1097fda9f2b31$var$Wc(n) : null, null !== n && (J = $9af1097fda9f2b31$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $9af1097fda9f2b31$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9af1097fda9f2b31$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9af1097fda9f2b31$var$ue(k);
                        u = null == n ? h : $9af1097fda9f2b31$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9af1097fda9f2b31$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9af1097fda9f2b31$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9af1097fda9f2b31$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9af1097fda9f2b31$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9af1097fda9f2b31$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9af1097fda9f2b31$var$vf(t);
                                x = $9af1097fda9f2b31$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9af1097fda9f2b31$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9af1097fda9f2b31$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $9af1097fda9f2b31$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9af1097fda9f2b31$var$ve;
                else if ($9af1097fda9f2b31$var$me(h)) {
                    if ($9af1097fda9f2b31$var$we) na = $9af1097fda9f2b31$var$Fe;
                    else {
                        na = $9af1097fda9f2b31$var$De;
                        var xa = $9af1097fda9f2b31$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9af1097fda9f2b31$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $9af1097fda9f2b31$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9af1097fda9f2b31$var$cb(h, "number", h.value);
            }
            xa = _$d ? $9af1097fda9f2b31$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($9af1097fda9f2b31$var$me(xa) || "true" === xa.contentEditable) $9af1097fda9f2b31$var$Qe = xa, $9af1097fda9f2b31$var$Re = _$d, $9af1097fda9f2b31$var$Se = null;
                    break;
                case "focusout":
                    $9af1097fda9f2b31$var$Se = $9af1097fda9f2b31$var$Re = $9af1097fda9f2b31$var$Qe = null;
                    break;
                case "mousedown":
                    $9af1097fda9f2b31$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9af1097fda9f2b31$var$Te = !1;
                    $9af1097fda9f2b31$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($9af1097fda9f2b31$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9af1097fda9f2b31$var$Ue(g, c, _$e);
            }
            var $a;
            if ($9af1097fda9f2b31$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9af1097fda9f2b31$var$ie ? $9af1097fda9f2b31$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9af1097fda9f2b31$var$de && "ko" !== c.locale && ($9af1097fda9f2b31$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9af1097fda9f2b31$var$ie && ($a = $9af1097fda9f2b31$var$nd()) : ($9af1097fda9f2b31$var$kd = _$e, $9af1097fda9f2b31$var$ld = "value" in $9af1097fda9f2b31$var$kd ? $9af1097fda9f2b31$var$kd.value : $9af1097fda9f2b31$var$kd.textContent, $9af1097fda9f2b31$var$ie = !0)), xa = $9af1097fda9f2b31$var$oe(_$d, ba), 0 < xa.length && (ba = new $9af1097fda9f2b31$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9af1097fda9f2b31$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9af1097fda9f2b31$var$ce ? $9af1097fda9f2b31$var$je(a, c) : $9af1097fda9f2b31$var$ke(a, c)) _$d = $9af1097fda9f2b31$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $9af1097fda9f2b31$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $9af1097fda9f2b31$var$se(g, b);
    });
}
function $9af1097fda9f2b31$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9af1097fda9f2b31$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9af1097fda9f2b31$var$Kb(a, c), null != f && d.unshift($9af1097fda9f2b31$var$tf(a, f, e)), f = $9af1097fda9f2b31$var$Kb(a, b), null != f && d.push($9af1097fda9f2b31$var$tf(a, f, e)));
        a = a["return"];
    }
    return d;
}
function $9af1097fda9f2b31$var$vf(a) {
    if (null === a) return null;
    do a = a["return"];
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9af1097fda9f2b31$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9af1097fda9f2b31$var$Kb(c, f), null != k && g.unshift($9af1097fda9f2b31$var$tf(c, k, h))) : e || (k = $9af1097fda9f2b31$var$Kb(c, f), null != k && g.push($9af1097fda9f2b31$var$tf(c, k, h))));
        c = c["return"];
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9af1097fda9f2b31$var$xf = /\r\n?/g, $9af1097fda9f2b31$var$yf = /\u0000|\uFFFD/g;
function $9af1097fda9f2b31$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9af1097fda9f2b31$var$xf, "\n").replace($9af1097fda9f2b31$var$yf, "");
}
function $9af1097fda9f2b31$var$Af(a, b, c) {
    b = $9af1097fda9f2b31$var$zf(b);
    if ($9af1097fda9f2b31$var$zf(a) !== b && c) throw Error($9af1097fda9f2b31$var$p(425));
}
function $9af1097fda9f2b31$var$Bf() {}
var $9af1097fda9f2b31$var$Cf = null, $9af1097fda9f2b31$var$Df = null;
function $9af1097fda9f2b31$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9af1097fda9f2b31$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9af1097fda9f2b31$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9af1097fda9f2b31$var$Hf = "function" === typeof Promise ? Promise : void 0, $9af1097fda9f2b31$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9af1097fda9f2b31$var$Hf ? function Jf(a) {
    return $9af1097fda9f2b31$var$Hf.resolve(null).then(a)["catch"]($9af1097fda9f2b31$var$If);
} : $9af1097fda9f2b31$var$Ff;
function $9af1097fda9f2b31$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9af1097fda9f2b31$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9af1097fda9f2b31$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9af1097fda9f2b31$var$bd(b);
}
function $9af1097fda9f2b31$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9af1097fda9f2b31$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9af1097fda9f2b31$var$Nf = Math.random().toString(36).slice(2), $9af1097fda9f2b31$var$Of = "__reactFiber$" + $9af1097fda9f2b31$var$Nf, $9af1097fda9f2b31$var$Pf = "__reactProps$" + $9af1097fda9f2b31$var$Nf, $9af1097fda9f2b31$var$uf = "__reactContainer$" + $9af1097fda9f2b31$var$Nf, $9af1097fda9f2b31$var$of = "__reactEvents$" + $9af1097fda9f2b31$var$Nf, $9af1097fda9f2b31$var$Qf = "__reactListeners$" + $9af1097fda9f2b31$var$Nf, $9af1097fda9f2b31$var$Rf = "__reactHandles$" + $9af1097fda9f2b31$var$Nf;
function $9af1097fda9f2b31$var$Wc(a) {
    var b = a[$9af1097fda9f2b31$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9af1097fda9f2b31$var$uf] || c[$9af1097fda9f2b31$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9af1097fda9f2b31$var$Mf(a); null !== a;){
                if (c = a[$9af1097fda9f2b31$var$Of]) return c;
                a = $9af1097fda9f2b31$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9af1097fda9f2b31$var$Cb(a) {
    a = a[$9af1097fda9f2b31$var$Of] || a[$9af1097fda9f2b31$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9af1097fda9f2b31$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9af1097fda9f2b31$var$p(33));
}
function $9af1097fda9f2b31$var$Db(a) {
    return a[$9af1097fda9f2b31$var$Pf] || null;
}
var $9af1097fda9f2b31$var$Sf = [], $9af1097fda9f2b31$var$Tf = -1;
function $9af1097fda9f2b31$var$Uf(a) {
    return {
        current: a
    };
}
function $9af1097fda9f2b31$var$E(a) {
    0 > $9af1097fda9f2b31$var$Tf || (a.current = $9af1097fda9f2b31$var$Sf[$9af1097fda9f2b31$var$Tf], $9af1097fda9f2b31$var$Sf[$9af1097fda9f2b31$var$Tf] = null, $9af1097fda9f2b31$var$Tf--);
}
function $9af1097fda9f2b31$var$G(a, b) {
    $9af1097fda9f2b31$var$Tf++;
    $9af1097fda9f2b31$var$Sf[$9af1097fda9f2b31$var$Tf] = a.current;
    a.current = b;
}
var $9af1097fda9f2b31$var$Vf = {}, $9af1097fda9f2b31$var$H = $9af1097fda9f2b31$var$Uf($9af1097fda9f2b31$var$Vf), $9af1097fda9f2b31$var$Wf = $9af1097fda9f2b31$var$Uf(!1), $9af1097fda9f2b31$var$Xf = $9af1097fda9f2b31$var$Vf;
function $9af1097fda9f2b31$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9af1097fda9f2b31$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9af1097fda9f2b31$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9af1097fda9f2b31$var$$f() {
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf);
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$H);
}
function $9af1097fda9f2b31$var$ag(a, b, c) {
    if ($9af1097fda9f2b31$var$H.current !== $9af1097fda9f2b31$var$Vf) throw Error($9af1097fda9f2b31$var$p(168));
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$H, b);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Wf, c);
}
function $9af1097fda9f2b31$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9af1097fda9f2b31$var$p(108, $9af1097fda9f2b31$var$Ra(a) || "Unknown", e));
    return $9af1097fda9f2b31$var$A({}, c, d);
}
function $9af1097fda9f2b31$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9af1097fda9f2b31$var$Vf;
    $9af1097fda9f2b31$var$Xf = $9af1097fda9f2b31$var$H.current;
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$H, a);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Wf, $9af1097fda9f2b31$var$Wf.current);
    return !0;
}
function $9af1097fda9f2b31$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9af1097fda9f2b31$var$p(169));
    c ? (a = $9af1097fda9f2b31$var$bg(a, b, $9af1097fda9f2b31$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf), $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$H), $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$H, a)) : $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Wf, c);
}
var $9af1097fda9f2b31$var$eg = null, $9af1097fda9f2b31$var$fg = !1, $9af1097fda9f2b31$var$gg = !1;
function $9af1097fda9f2b31$var$hg(a) {
    null === $9af1097fda9f2b31$var$eg ? $9af1097fda9f2b31$var$eg = [
        a
    ] : $9af1097fda9f2b31$var$eg.push(a);
}
function $9af1097fda9f2b31$var$ig(a) {
    $9af1097fda9f2b31$var$fg = !0;
    $9af1097fda9f2b31$var$hg(a);
}
function $9af1097fda9f2b31$var$jg() {
    if (!$9af1097fda9f2b31$var$gg && null !== $9af1097fda9f2b31$var$eg) {
        $9af1097fda9f2b31$var$gg = !0;
        var a = 0, b = $9af1097fda9f2b31$var$C;
        try {
            var c = $9af1097fda9f2b31$var$eg;
            for($9af1097fda9f2b31$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9af1097fda9f2b31$var$eg = null;
            $9af1097fda9f2b31$var$fg = !1;
        } catch (e) {
            throw null !== $9af1097fda9f2b31$var$eg && ($9af1097fda9f2b31$var$eg = $9af1097fda9f2b31$var$eg.slice(a + 1)), $9af1097fda9f2b31$var$ac($9af1097fda9f2b31$var$fc, $9af1097fda9f2b31$var$jg), e;
        } finally{
            $9af1097fda9f2b31$var$C = b, $9af1097fda9f2b31$var$gg = !1;
        }
    }
    return null;
}
var $9af1097fda9f2b31$var$kg = [], $9af1097fda9f2b31$var$lg = 0, $9af1097fda9f2b31$var$mg = null, $9af1097fda9f2b31$var$ng = 0, $9af1097fda9f2b31$var$og = [], $9af1097fda9f2b31$var$pg = 0, $9af1097fda9f2b31$var$qg = null, $9af1097fda9f2b31$var$rg = 1, $9af1097fda9f2b31$var$sg = "";
function $9af1097fda9f2b31$var$tg(a, b) {
    $9af1097fda9f2b31$var$kg[$9af1097fda9f2b31$var$lg++] = $9af1097fda9f2b31$var$ng;
    $9af1097fda9f2b31$var$kg[$9af1097fda9f2b31$var$lg++] = $9af1097fda9f2b31$var$mg;
    $9af1097fda9f2b31$var$mg = a;
    $9af1097fda9f2b31$var$ng = b;
}
function $9af1097fda9f2b31$var$ug(a, b, c) {
    $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$rg;
    $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$sg;
    $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$qg;
    $9af1097fda9f2b31$var$qg = a;
    var d = $9af1097fda9f2b31$var$rg;
    a = $9af1097fda9f2b31$var$sg;
    var e = 32 - $9af1097fda9f2b31$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9af1097fda9f2b31$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9af1097fda9f2b31$var$rg = 1 << 32 - $9af1097fda9f2b31$var$oc(b) + e | c << e | d;
        $9af1097fda9f2b31$var$sg = f + a;
    } else $9af1097fda9f2b31$var$rg = 1 << f | c << e | d, $9af1097fda9f2b31$var$sg = a;
}
function $9af1097fda9f2b31$var$vg(a) {
    null !== a["return"] && ($9af1097fda9f2b31$var$tg(a, 1), $9af1097fda9f2b31$var$ug(a, 1, 0));
}
function $9af1097fda9f2b31$var$wg(a) {
    for(; a === $9af1097fda9f2b31$var$mg;)$9af1097fda9f2b31$var$mg = $9af1097fda9f2b31$var$kg[--$9af1097fda9f2b31$var$lg], $9af1097fda9f2b31$var$kg[$9af1097fda9f2b31$var$lg] = null, $9af1097fda9f2b31$var$ng = $9af1097fda9f2b31$var$kg[--$9af1097fda9f2b31$var$lg], $9af1097fda9f2b31$var$kg[$9af1097fda9f2b31$var$lg] = null;
    for(; a === $9af1097fda9f2b31$var$qg;)$9af1097fda9f2b31$var$qg = $9af1097fda9f2b31$var$og[--$9af1097fda9f2b31$var$pg], $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg] = null, $9af1097fda9f2b31$var$sg = $9af1097fda9f2b31$var$og[--$9af1097fda9f2b31$var$pg], $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg] = null, $9af1097fda9f2b31$var$rg = $9af1097fda9f2b31$var$og[--$9af1097fda9f2b31$var$pg], $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg] = null;
}
var $9af1097fda9f2b31$var$xg = null, $9af1097fda9f2b31$var$yg = null, $9af1097fda9f2b31$var$I = !1, $9af1097fda9f2b31$var$zg = null;
function $9af1097fda9f2b31$var$Ag(a, b) {
    var c = $9af1097fda9f2b31$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c["return"] = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9af1097fda9f2b31$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9af1097fda9f2b31$var$xg = a, $9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9af1097fda9f2b31$var$xg = a, $9af1097fda9f2b31$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9af1097fda9f2b31$var$qg ? {
                id: $9af1097fda9f2b31$var$rg,
                overflow: $9af1097fda9f2b31$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9af1097fda9f2b31$var$Bg(18, null, null, 0), c.stateNode = b, c["return"] = a, a.child = c, $9af1097fda9f2b31$var$xg = a, $9af1097fda9f2b31$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9af1097fda9f2b31$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9af1097fda9f2b31$var$Eg(a) {
    if ($9af1097fda9f2b31$var$I) {
        var b = $9af1097fda9f2b31$var$yg;
        if (b) {
            var c = b;
            if (!$9af1097fda9f2b31$var$Cg(a, b)) {
                if ($9af1097fda9f2b31$var$Dg(a)) throw Error($9af1097fda9f2b31$var$p(418));
                b = $9af1097fda9f2b31$var$Lf(c.nextSibling);
                var d = $9af1097fda9f2b31$var$xg;
                b && $9af1097fda9f2b31$var$Cg(a, b) ? $9af1097fda9f2b31$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9af1097fda9f2b31$var$I = !1, $9af1097fda9f2b31$var$xg = a);
            }
        } else {
            if ($9af1097fda9f2b31$var$Dg(a)) throw Error($9af1097fda9f2b31$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9af1097fda9f2b31$var$I = !1;
            $9af1097fda9f2b31$var$xg = a;
        }
    }
}
function $9af1097fda9f2b31$var$Fg(a) {
    for(a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a["return"];
    $9af1097fda9f2b31$var$xg = a;
}
function $9af1097fda9f2b31$var$Gg(a) {
    if (a !== $9af1097fda9f2b31$var$xg) return !1;
    if (!$9af1097fda9f2b31$var$I) return $9af1097fda9f2b31$var$Fg(a), $9af1097fda9f2b31$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9af1097fda9f2b31$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9af1097fda9f2b31$var$yg)) {
        if ($9af1097fda9f2b31$var$Dg(a)) throw $9af1097fda9f2b31$var$Hg(), Error($9af1097fda9f2b31$var$p(418));
        for(; b;)$9af1097fda9f2b31$var$Ag(a, b), b = $9af1097fda9f2b31$var$Lf(b.nextSibling);
    }
    $9af1097fda9f2b31$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9af1097fda9f2b31$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9af1097fda9f2b31$var$yg = null;
        }
    } else $9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$xg ? $9af1097fda9f2b31$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9af1097fda9f2b31$var$Hg() {
    for(var a = $9af1097fda9f2b31$var$yg; a;)a = $9af1097fda9f2b31$var$Lf(a.nextSibling);
}
function $9af1097fda9f2b31$var$Ig() {
    $9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$xg = null;
    $9af1097fda9f2b31$var$I = !1;
}
function $9af1097fda9f2b31$var$Jg(a) {
    null === $9af1097fda9f2b31$var$zg ? $9af1097fda9f2b31$var$zg = [
        a
    ] : $9af1097fda9f2b31$var$zg.push(a);
}
var $9af1097fda9f2b31$var$Kg = $9af1097fda9f2b31$var$ua.ReactCurrentBatchConfig;
function $9af1097fda9f2b31$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $9af1097fda9f2b31$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $9af1097fda9f2b31$var$Mg = $9af1097fda9f2b31$var$Uf(null), $9af1097fda9f2b31$var$Ng = null, $9af1097fda9f2b31$var$Og = null, $9af1097fda9f2b31$var$Pg = null;
function $9af1097fda9f2b31$var$Qg() {
    $9af1097fda9f2b31$var$Pg = $9af1097fda9f2b31$var$Og = $9af1097fda9f2b31$var$Ng = null;
}
function $9af1097fda9f2b31$var$Rg(a) {
    var b = $9af1097fda9f2b31$var$Mg.current;
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Mg);
    a._currentValue = b;
}
function $9af1097fda9f2b31$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a["return"];
    }
}
function $9af1097fda9f2b31$var$Tg(a, b) {
    $9af1097fda9f2b31$var$Ng = a;
    $9af1097fda9f2b31$var$Pg = $9af1097fda9f2b31$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9af1097fda9f2b31$var$Ug = !0), a.firstContext = null);
}
function $9af1097fda9f2b31$var$Vg(a) {
    var b = a._currentValue;
    if ($9af1097fda9f2b31$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9af1097fda9f2b31$var$Og) {
            if (null === $9af1097fda9f2b31$var$Ng) throw Error($9af1097fda9f2b31$var$p(308));
            $9af1097fda9f2b31$var$Og = a;
            $9af1097fda9f2b31$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9af1097fda9f2b31$var$Og = $9af1097fda9f2b31$var$Og.next = a;
    }
    return b;
}
var $9af1097fda9f2b31$var$Wg = null;
function $9af1097fda9f2b31$var$Xg(a) {
    null === $9af1097fda9f2b31$var$Wg ? $9af1097fda9f2b31$var$Wg = [
        a
    ] : $9af1097fda9f2b31$var$Wg.push(a);
}
function $9af1097fda9f2b31$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9af1097fda9f2b31$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9af1097fda9f2b31$var$Zg(a, d);
}
function $9af1097fda9f2b31$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a["return"]; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a["return"];
    return 3 === c.tag ? c.stateNode : null;
}
var $9af1097fda9f2b31$var$$g = !1;
function $9af1097fda9f2b31$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9af1097fda9f2b31$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9af1097fda9f2b31$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9af1097fda9f2b31$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9af1097fda9f2b31$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9af1097fda9f2b31$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9af1097fda9f2b31$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9af1097fda9f2b31$var$Zg(a, c);
}
function $9af1097fda9f2b31$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9af1097fda9f2b31$var$Cc(a, c);
    }
}
function $9af1097fda9f2b31$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9af1097fda9f2b31$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $9af1097fda9f2b31$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9af1097fda9f2b31$var$A({}, q, r);
                            break a;
                        case 2:
                            $9af1097fda9f2b31$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9af1097fda9f2b31$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9af1097fda9f2b31$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9af1097fda9f2b31$var$p(191, e));
            e.call(d);
        }
    }
}
var $9af1097fda9f2b31$var$jh = (new $3aC2T.Component).refs;
function $9af1097fda9f2b31$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9af1097fda9f2b31$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9af1097fda9f2b31$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $9af1097fda9f2b31$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $9af1097fda9f2b31$var$L(), e = $9af1097fda9f2b31$var$lh(a), f = $9af1097fda9f2b31$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9af1097fda9f2b31$var$dh(a, f, e);
        null !== b && ($9af1097fda9f2b31$var$mh(b, a, e, d), $9af1097fda9f2b31$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $9af1097fda9f2b31$var$L(), e = $9af1097fda9f2b31$var$lh(a), f = $9af1097fda9f2b31$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9af1097fda9f2b31$var$dh(a, f, e);
        null !== b && ($9af1097fda9f2b31$var$mh(b, a, e, d), $9af1097fda9f2b31$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $9af1097fda9f2b31$var$L(), d = $9af1097fda9f2b31$var$lh(a), e = $9af1097fda9f2b31$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9af1097fda9f2b31$var$dh(a, e, d);
        null !== b && ($9af1097fda9f2b31$var$mh(b, a, d, c), $9af1097fda9f2b31$var$eh(b, a, d));
    }
};
function $9af1097fda9f2b31$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9af1097fda9f2b31$var$Ie(c, d) || !$9af1097fda9f2b31$var$Ie(e, f) : !0;
}
function $9af1097fda9f2b31$var$ph(a, b, c) {
    var d = !1, e = $9af1097fda9f2b31$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9af1097fda9f2b31$var$Vg(f) : (e = $9af1097fda9f2b31$var$Zf(b) ? $9af1097fda9f2b31$var$Xf : $9af1097fda9f2b31$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9af1097fda9f2b31$var$Yf(a, e) : $9af1097fda9f2b31$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9af1097fda9f2b31$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9af1097fda9f2b31$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9af1097fda9f2b31$var$nh.enqueueReplaceState(b, b.state, null);
}
function $9af1097fda9f2b31$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $9af1097fda9f2b31$var$jh;
    $9af1097fda9f2b31$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9af1097fda9f2b31$var$Vg(f) : (f = $9af1097fda9f2b31$var$Zf(b) ? $9af1097fda9f2b31$var$Xf : $9af1097fda9f2b31$var$H.current, e.context = $9af1097fda9f2b31$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9af1097fda9f2b31$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9af1097fda9f2b31$var$nh.enqueueReplaceState(e, e.state, null), $9af1097fda9f2b31$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9af1097fda9f2b31$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9af1097fda9f2b31$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9af1097fda9f2b31$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $9af1097fda9f2b31$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9af1097fda9f2b31$var$p(284));
        if (!c._owner) throw Error($9af1097fda9f2b31$var$p(290, a));
    }
    return a;
}
function $9af1097fda9f2b31$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9af1097fda9f2b31$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9af1097fda9f2b31$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $9af1097fda9f2b31$var$vh(a) {
    var b = function b(_b, c) {
        if (a) {
            var d = _b.deletions;
            null === d ? (_b.deletions = [
                c
            ], _b.flags |= 16) : d.push(c);
        }
    };
    var c = function c(_c, d) {
        if (!a) return null;
        for(; null !== d;)b(_c, d), d = d.sibling;
        return null;
    };
    var d = function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    };
    var e = function e(a, b) {
        a = $9af1097fda9f2b31$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    };
    var f = function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    };
    var g = function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    };
    var h = function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9af1097fda9f2b31$var$xh(c, a.mode, d), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    };
    var k = function k(a, b, c, d) {
        var f = c.type;
        if (f === $9af1097fda9f2b31$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9af1097fda9f2b31$var$Ha && $9af1097fda9f2b31$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $9af1097fda9f2b31$var$sh(a, b, c), d["return"] = a, d;
        d = $9af1097fda9f2b31$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9af1097fda9f2b31$var$sh(a, b, c);
        d["return"] = a;
        return d;
    };
    var l = function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9af1097fda9f2b31$var$zh(c, a.mode, d), b["return"] = a, b;
        b = e(b, c.children || []);
        b["return"] = a;
        return b;
    };
    var m = function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9af1097fda9f2b31$var$Ah(c, a.mode, d, f), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    };
    var n = function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u["delete"](null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w);
        return l;
    };
    var t = function t(e, g, h, k) {
        var l = $9af1097fda9f2b31$var$Ka(h);
        if ("function" !== typeof l) throw Error($9af1097fda9f2b31$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9af1097fda9f2b31$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m["delete"](null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w);
        return l;
    };
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9af1097fda9f2b31$var$xh("" + b, a.mode, c), b["return"] = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9af1097fda9f2b31$var$va:
                    return c = $9af1097fda9f2b31$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $9af1097fda9f2b31$var$sh(a, null, b), c["return"] = a, c;
                case $9af1097fda9f2b31$var$wa:
                    return b = $9af1097fda9f2b31$var$zh(b, a.mode, c), b["return"] = a, b;
                case $9af1097fda9f2b31$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9af1097fda9f2b31$var$eb(b) || $9af1097fda9f2b31$var$Ka(b)) return b = $9af1097fda9f2b31$var$Ah(b, a.mode, c, null), b["return"] = a, b;
            $9af1097fda9f2b31$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9af1097fda9f2b31$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9af1097fda9f2b31$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9af1097fda9f2b31$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9af1097fda9f2b31$var$eb(c) || $9af1097fda9f2b31$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9af1097fda9f2b31$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9af1097fda9f2b31$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9af1097fda9f2b31$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9af1097fda9f2b31$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9af1097fda9f2b31$var$eb(d) || $9af1097fda9f2b31$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9af1097fda9f2b31$var$th(b, d);
        }
        return null;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9af1097fda9f2b31$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9af1097fda9f2b31$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9af1097fda9f2b31$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d["return"] = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9af1097fda9f2b31$var$Ha && $9af1097fda9f2b31$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9af1097fda9f2b31$var$sh(a, l, f);
                                    d["return"] = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9af1097fda9f2b31$var$ya ? (d = $9af1097fda9f2b31$var$Ah(f.props.children, a.mode, h, f.key), d["return"] = a, a = d) : (h = $9af1097fda9f2b31$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $9af1097fda9f2b31$var$sh(a, d, f), h["return"] = a, a = h);
                    }
                    return g(a);
                case $9af1097fda9f2b31$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d["return"] = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9af1097fda9f2b31$var$zh(f, a.mode, h);
                        d["return"] = a;
                        a = d;
                    }
                    return g(a);
                case $9af1097fda9f2b31$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9af1097fda9f2b31$var$eb(f)) return n(a, d, f, h);
            if ($9af1097fda9f2b31$var$Ka(f)) return t(a, d, f, h);
            $9af1097fda9f2b31$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d["return"] = a, a = d) : (c(a, d), d = $9af1097fda9f2b31$var$xh(f, a.mode, h), d["return"] = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9af1097fda9f2b31$var$Bh = $9af1097fda9f2b31$var$vh(!0), $9af1097fda9f2b31$var$Ch = $9af1097fda9f2b31$var$vh(!1), $9af1097fda9f2b31$var$Dh = {}, $9af1097fda9f2b31$var$Eh = $9af1097fda9f2b31$var$Uf($9af1097fda9f2b31$var$Dh), $9af1097fda9f2b31$var$Fh = $9af1097fda9f2b31$var$Uf($9af1097fda9f2b31$var$Dh), $9af1097fda9f2b31$var$Gh = $9af1097fda9f2b31$var$Uf($9af1097fda9f2b31$var$Dh);
function $9af1097fda9f2b31$var$Hh(a) {
    if (a === $9af1097fda9f2b31$var$Dh) throw Error($9af1097fda9f2b31$var$p(174));
    return a;
}
function $9af1097fda9f2b31$var$Ih(a, b) {
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Gh, b);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Fh, a);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Eh, $9af1097fda9f2b31$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9af1097fda9f2b31$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9af1097fda9f2b31$var$lb(b, a);
    }
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Eh);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Eh, b);
}
function $9af1097fda9f2b31$var$Jh() {
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Eh);
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Fh);
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Gh);
}
function $9af1097fda9f2b31$var$Kh(a) {
    $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Gh.current);
    var b = $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Eh.current);
    var c = $9af1097fda9f2b31$var$lb(b, a.type);
    b !== c && ($9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Fh, a), $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Eh, c));
}
function $9af1097fda9f2b31$var$Lh(a) {
    $9af1097fda9f2b31$var$Fh.current === a && ($9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Eh), $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Fh));
}
var $9af1097fda9f2b31$var$M = $9af1097fda9f2b31$var$Uf(0);
function $9af1097fda9f2b31$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child["return"] = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b["return"] || b["return"] === a) return null;
            b = b["return"];
        }
        b.sibling["return"] = b["return"];
        b = b.sibling;
    }
    return null;
}
var $9af1097fda9f2b31$var$Nh = [];
function $9af1097fda9f2b31$var$Oh() {
    for(var a = 0; a < $9af1097fda9f2b31$var$Nh.length; a++)$9af1097fda9f2b31$var$Nh[a]._workInProgressVersionPrimary = null;
    $9af1097fda9f2b31$var$Nh.length = 0;
}
var $9af1097fda9f2b31$var$Ph = $9af1097fda9f2b31$var$ua.ReactCurrentDispatcher, $9af1097fda9f2b31$var$Qh = $9af1097fda9f2b31$var$ua.ReactCurrentBatchConfig, $9af1097fda9f2b31$var$Rh = 0, $9af1097fda9f2b31$var$N = null, $9af1097fda9f2b31$var$O = null, $9af1097fda9f2b31$var$P = null, $9af1097fda9f2b31$var$Sh = !1, $9af1097fda9f2b31$var$Th = !1, $9af1097fda9f2b31$var$Uh = 0, $9af1097fda9f2b31$var$Vh = 0;
function $9af1097fda9f2b31$var$Q() {
    throw Error($9af1097fda9f2b31$var$p(321));
}
function $9af1097fda9f2b31$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9af1097fda9f2b31$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9af1097fda9f2b31$var$Xh(a, b, c, d, e, f) {
    $9af1097fda9f2b31$var$Rh = f;
    $9af1097fda9f2b31$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9af1097fda9f2b31$var$Ph.current = null === a || null === a.memoizedState ? $9af1097fda9f2b31$var$Yh : $9af1097fda9f2b31$var$Zh;
    a = c(d, e);
    if ($9af1097fda9f2b31$var$Th) {
        f = 0;
        do {
            $9af1097fda9f2b31$var$Th = !1;
            $9af1097fda9f2b31$var$Uh = 0;
            if (25 <= f) throw Error($9af1097fda9f2b31$var$p(301));
            f += 1;
            $9af1097fda9f2b31$var$P = $9af1097fda9f2b31$var$O = null;
            b.updateQueue = null;
            $9af1097fda9f2b31$var$Ph.current = $9af1097fda9f2b31$var$$h;
            a = c(d, e);
        }while ($9af1097fda9f2b31$var$Th);
    }
    $9af1097fda9f2b31$var$Ph.current = $9af1097fda9f2b31$var$ai;
    b = null !== $9af1097fda9f2b31$var$O && null !== $9af1097fda9f2b31$var$O.next;
    $9af1097fda9f2b31$var$Rh = 0;
    $9af1097fda9f2b31$var$P = $9af1097fda9f2b31$var$O = $9af1097fda9f2b31$var$N = null;
    $9af1097fda9f2b31$var$Sh = !1;
    if (b) throw Error($9af1097fda9f2b31$var$p(300));
    return a;
}
function $9af1097fda9f2b31$var$bi() {
    var a = 0 !== $9af1097fda9f2b31$var$Uh;
    $9af1097fda9f2b31$var$Uh = 0;
    return a;
}
function $9af1097fda9f2b31$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9af1097fda9f2b31$var$P ? $9af1097fda9f2b31$var$N.memoizedState = $9af1097fda9f2b31$var$P = a : $9af1097fda9f2b31$var$P = $9af1097fda9f2b31$var$P.next = a;
    return $9af1097fda9f2b31$var$P;
}
function $9af1097fda9f2b31$var$di() {
    if (null === $9af1097fda9f2b31$var$O) {
        var a = $9af1097fda9f2b31$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9af1097fda9f2b31$var$O.next;
    var b = null === $9af1097fda9f2b31$var$P ? $9af1097fda9f2b31$var$N.memoizedState : $9af1097fda9f2b31$var$P.next;
    if (null !== b) $9af1097fda9f2b31$var$P = b, $9af1097fda9f2b31$var$O = a;
    else {
        if (null === a) throw Error($9af1097fda9f2b31$var$p(310));
        $9af1097fda9f2b31$var$O = a;
        a = {
            memoizedState: $9af1097fda9f2b31$var$O.memoizedState,
            baseState: $9af1097fda9f2b31$var$O.baseState,
            baseQueue: $9af1097fda9f2b31$var$O.baseQueue,
            queue: $9af1097fda9f2b31$var$O.queue,
            next: null
        };
        null === $9af1097fda9f2b31$var$P ? $9af1097fda9f2b31$var$N.memoizedState = $9af1097fda9f2b31$var$P = a : $9af1097fda9f2b31$var$P = $9af1097fda9f2b31$var$P.next = a;
    }
    return $9af1097fda9f2b31$var$P;
}
function $9af1097fda9f2b31$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9af1097fda9f2b31$var$fi(a) {
    var b = $9af1097fda9f2b31$var$di(), c = b.queue;
    if (null === c) throw Error($9af1097fda9f2b31$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9af1097fda9f2b31$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9af1097fda9f2b31$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9af1097fda9f2b31$var$N.lanes |= m;
                $9af1097fda9f2b31$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9af1097fda9f2b31$var$He(d, b.memoizedState) || ($9af1097fda9f2b31$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9af1097fda9f2b31$var$N.lanes |= f, $9af1097fda9f2b31$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9af1097fda9f2b31$var$gi(a) {
    var b = $9af1097fda9f2b31$var$di(), c = b.queue;
    if (null === c) throw Error($9af1097fda9f2b31$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9af1097fda9f2b31$var$He(f, b.memoizedState) || ($9af1097fda9f2b31$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9af1097fda9f2b31$var$hi() {}
function $9af1097fda9f2b31$var$ii(a, b) {
    var c = $9af1097fda9f2b31$var$N, d = $9af1097fda9f2b31$var$di(), e = b(), f = !$9af1097fda9f2b31$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9af1097fda9f2b31$var$Ug = !0);
    d = d.queue;
    $9af1097fda9f2b31$var$ji($9af1097fda9f2b31$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9af1097fda9f2b31$var$P && $9af1097fda9f2b31$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9af1097fda9f2b31$var$li(9, $9af1097fda9f2b31$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $9af1097fda9f2b31$var$R) throw Error($9af1097fda9f2b31$var$p(349));
        0 !== ($9af1097fda9f2b31$var$Rh & 30) || $9af1097fda9f2b31$var$ni(c, b, e);
    }
    return e;
}
function $9af1097fda9f2b31$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9af1097fda9f2b31$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9af1097fda9f2b31$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9af1097fda9f2b31$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9af1097fda9f2b31$var$oi(b) && $9af1097fda9f2b31$var$pi(a);
}
function $9af1097fda9f2b31$var$ki(a, b, c) {
    return c(function() {
        $9af1097fda9f2b31$var$oi(b) && $9af1097fda9f2b31$var$pi(a);
    });
}
function $9af1097fda9f2b31$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9af1097fda9f2b31$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9af1097fda9f2b31$var$pi(a) {
    var b = $9af1097fda9f2b31$var$Zg(a, 1);
    null !== b && $9af1097fda9f2b31$var$mh(b, a, 1, -1);
}
function $9af1097fda9f2b31$var$qi(a) {
    var b = $9af1097fda9f2b31$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9af1097fda9f2b31$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9af1097fda9f2b31$var$ri.bind(null, $9af1097fda9f2b31$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9af1097fda9f2b31$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9af1097fda9f2b31$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9af1097fda9f2b31$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9af1097fda9f2b31$var$si() {
    return $9af1097fda9f2b31$var$di().memoizedState;
}
function $9af1097fda9f2b31$var$ti(a, b, c, d) {
    var e = $9af1097fda9f2b31$var$ci();
    $9af1097fda9f2b31$var$N.flags |= a;
    e.memoizedState = $9af1097fda9f2b31$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9af1097fda9f2b31$var$ui(a, b, c, d) {
    var e = $9af1097fda9f2b31$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9af1097fda9f2b31$var$O) {
        var g = $9af1097fda9f2b31$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $9af1097fda9f2b31$var$Wh(d, g.deps)) {
            e.memoizedState = $9af1097fda9f2b31$var$li(b, c, f, d);
            return;
        }
    }
    $9af1097fda9f2b31$var$N.flags |= a;
    e.memoizedState = $9af1097fda9f2b31$var$li(1 | b, c, f, d);
}
function $9af1097fda9f2b31$var$vi(a, b) {
    return $9af1097fda9f2b31$var$ti(8390656, 8, a, b);
}
function $9af1097fda9f2b31$var$ji(a, b) {
    return $9af1097fda9f2b31$var$ui(2048, 8, a, b);
}
function $9af1097fda9f2b31$var$wi(a, b) {
    return $9af1097fda9f2b31$var$ui(4, 2, a, b);
}
function $9af1097fda9f2b31$var$xi(a, b) {
    return $9af1097fda9f2b31$var$ui(4, 4, a, b);
}
function $9af1097fda9f2b31$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9af1097fda9f2b31$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9af1097fda9f2b31$var$ui(4, 4, $9af1097fda9f2b31$var$yi.bind(null, b, a), c);
}
function $9af1097fda9f2b31$var$Ai() {}
function $9af1097fda9f2b31$var$Bi(a, b) {
    var c = $9af1097fda9f2b31$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9af1097fda9f2b31$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9af1097fda9f2b31$var$Ci(a, b) {
    var c = $9af1097fda9f2b31$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9af1097fda9f2b31$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9af1097fda9f2b31$var$Di(a, b, c) {
    if (0 === ($9af1097fda9f2b31$var$Rh & 21)) return a.baseState && (a.baseState = !1, $9af1097fda9f2b31$var$Ug = !0), a.memoizedState = c;
    $9af1097fda9f2b31$var$He(c, b) || (c = $9af1097fda9f2b31$var$yc(), $9af1097fda9f2b31$var$N.lanes |= c, $9af1097fda9f2b31$var$hh |= c, a.baseState = !0);
    return b;
}
function $9af1097fda9f2b31$var$Ei(a, b) {
    var c = $9af1097fda9f2b31$var$C;
    $9af1097fda9f2b31$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9af1097fda9f2b31$var$Qh.transition;
    $9af1097fda9f2b31$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9af1097fda9f2b31$var$C = c, $9af1097fda9f2b31$var$Qh.transition = d;
    }
}
function $9af1097fda9f2b31$var$Fi() {
    return $9af1097fda9f2b31$var$di().memoizedState;
}
function $9af1097fda9f2b31$var$Gi(a, b, c) {
    var d = $9af1097fda9f2b31$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9af1097fda9f2b31$var$Hi(a)) $9af1097fda9f2b31$var$Ii(b, c);
    else if (c = $9af1097fda9f2b31$var$Yg(a, b, c, d), null !== c) {
        var e = $9af1097fda9f2b31$var$L();
        $9af1097fda9f2b31$var$mh(c, a, d, e);
        $9af1097fda9f2b31$var$Ji(c, b, d);
    }
}
function $9af1097fda9f2b31$var$ri(a, b, c) {
    var d = $9af1097fda9f2b31$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9af1097fda9f2b31$var$Hi(a)) $9af1097fda9f2b31$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9af1097fda9f2b31$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9af1097fda9f2b31$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9af1097fda9f2b31$var$Yg(a, b, e, d);
        null !== c && (e = $9af1097fda9f2b31$var$L(), $9af1097fda9f2b31$var$mh(c, a, d, e), $9af1097fda9f2b31$var$Ji(c, b, d));
    }
}
function $9af1097fda9f2b31$var$Hi(a) {
    var b = a.alternate;
    return a === $9af1097fda9f2b31$var$N || null !== b && b === $9af1097fda9f2b31$var$N;
}
function $9af1097fda9f2b31$var$Ii(a, b) {
    $9af1097fda9f2b31$var$Th = $9af1097fda9f2b31$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9af1097fda9f2b31$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9af1097fda9f2b31$var$Cc(a, c);
    }
}
var $9af1097fda9f2b31$var$ai = {
    readContext: $9af1097fda9f2b31$var$Vg,
    useCallback: $9af1097fda9f2b31$var$Q,
    useContext: $9af1097fda9f2b31$var$Q,
    useEffect: $9af1097fda9f2b31$var$Q,
    useImperativeHandle: $9af1097fda9f2b31$var$Q,
    useInsertionEffect: $9af1097fda9f2b31$var$Q,
    useLayoutEffect: $9af1097fda9f2b31$var$Q,
    useMemo: $9af1097fda9f2b31$var$Q,
    useReducer: $9af1097fda9f2b31$var$Q,
    useRef: $9af1097fda9f2b31$var$Q,
    useState: $9af1097fda9f2b31$var$Q,
    useDebugValue: $9af1097fda9f2b31$var$Q,
    useDeferredValue: $9af1097fda9f2b31$var$Q,
    useTransition: $9af1097fda9f2b31$var$Q,
    useMutableSource: $9af1097fda9f2b31$var$Q,
    useSyncExternalStore: $9af1097fda9f2b31$var$Q,
    useId: $9af1097fda9f2b31$var$Q,
    unstable_isNewReconciler: !1
}, $9af1097fda9f2b31$var$Yh = {
    readContext: $9af1097fda9f2b31$var$Vg,
    useCallback: function useCallback(a, b) {
        $9af1097fda9f2b31$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9af1097fda9f2b31$var$Vg,
    useEffect: $9af1097fda9f2b31$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9af1097fda9f2b31$var$ti(4194308, 4, $9af1097fda9f2b31$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $9af1097fda9f2b31$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $9af1097fda9f2b31$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $9af1097fda9f2b31$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $9af1097fda9f2b31$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9af1097fda9f2b31$var$Gi.bind(null, $9af1097fda9f2b31$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $9af1097fda9f2b31$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9af1097fda9f2b31$var$qi,
    useDebugValue: $9af1097fda9f2b31$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $9af1097fda9f2b31$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $9af1097fda9f2b31$var$qi(!1), b = a[0];
        a = $9af1097fda9f2b31$var$Ei.bind(null, a[1]);
        $9af1097fda9f2b31$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $9af1097fda9f2b31$var$N, e = $9af1097fda9f2b31$var$ci();
        if ($9af1097fda9f2b31$var$I) {
            if (void 0 === c) throw Error($9af1097fda9f2b31$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9af1097fda9f2b31$var$R) throw Error($9af1097fda9f2b31$var$p(349));
            0 !== ($9af1097fda9f2b31$var$Rh & 30) || $9af1097fda9f2b31$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9af1097fda9f2b31$var$vi($9af1097fda9f2b31$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9af1097fda9f2b31$var$li(9, $9af1097fda9f2b31$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $9af1097fda9f2b31$var$ci(), b = $9af1097fda9f2b31$var$R.identifierPrefix;
        if ($9af1097fda9f2b31$var$I) {
            var c = $9af1097fda9f2b31$var$sg;
            var d = $9af1097fda9f2b31$var$rg;
            c = (d & ~(1 << 32 - $9af1097fda9f2b31$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9af1097fda9f2b31$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9af1097fda9f2b31$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9af1097fda9f2b31$var$Zh = {
    readContext: $9af1097fda9f2b31$var$Vg,
    useCallback: $9af1097fda9f2b31$var$Bi,
    useContext: $9af1097fda9f2b31$var$Vg,
    useEffect: $9af1097fda9f2b31$var$ji,
    useImperativeHandle: $9af1097fda9f2b31$var$zi,
    useInsertionEffect: $9af1097fda9f2b31$var$wi,
    useLayoutEffect: $9af1097fda9f2b31$var$xi,
    useMemo: $9af1097fda9f2b31$var$Ci,
    useReducer: $9af1097fda9f2b31$var$fi,
    useRef: $9af1097fda9f2b31$var$si,
    useState: function useState() {
        return $9af1097fda9f2b31$var$fi($9af1097fda9f2b31$var$ei);
    },
    useDebugValue: $9af1097fda9f2b31$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $9af1097fda9f2b31$var$di();
        return $9af1097fda9f2b31$var$Di(b, $9af1097fda9f2b31$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $9af1097fda9f2b31$var$fi($9af1097fda9f2b31$var$ei)[0], b = $9af1097fda9f2b31$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9af1097fda9f2b31$var$hi,
    useSyncExternalStore: $9af1097fda9f2b31$var$ii,
    useId: $9af1097fda9f2b31$var$Fi,
    unstable_isNewReconciler: !1
}, $9af1097fda9f2b31$var$$h = {
    readContext: $9af1097fda9f2b31$var$Vg,
    useCallback: $9af1097fda9f2b31$var$Bi,
    useContext: $9af1097fda9f2b31$var$Vg,
    useEffect: $9af1097fda9f2b31$var$ji,
    useImperativeHandle: $9af1097fda9f2b31$var$zi,
    useInsertionEffect: $9af1097fda9f2b31$var$wi,
    useLayoutEffect: $9af1097fda9f2b31$var$xi,
    useMemo: $9af1097fda9f2b31$var$Ci,
    useReducer: $9af1097fda9f2b31$var$gi,
    useRef: $9af1097fda9f2b31$var$si,
    useState: function useState() {
        return $9af1097fda9f2b31$var$gi($9af1097fda9f2b31$var$ei);
    },
    useDebugValue: $9af1097fda9f2b31$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $9af1097fda9f2b31$var$di();
        return null === $9af1097fda9f2b31$var$O ? b.memoizedState = a : $9af1097fda9f2b31$var$Di(b, $9af1097fda9f2b31$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $9af1097fda9f2b31$var$gi($9af1097fda9f2b31$var$ei)[0], b = $9af1097fda9f2b31$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9af1097fda9f2b31$var$hi,
    useSyncExternalStore: $9af1097fda9f2b31$var$ii,
    useId: $9af1097fda9f2b31$var$Fi,
    unstable_isNewReconciler: !1
};
function $9af1097fda9f2b31$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $9af1097fda9f2b31$var$Pa(d), d = d["return"];
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9af1097fda9f2b31$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9af1097fda9f2b31$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9af1097fda9f2b31$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $9af1097fda9f2b31$var$Oi(a, b, c) {
    c = $9af1097fda9f2b31$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9af1097fda9f2b31$var$Pi || ($9af1097fda9f2b31$var$Pi = !0, $9af1097fda9f2b31$var$Qi = d);
        $9af1097fda9f2b31$var$Mi(a, b);
    };
    return c;
}
function $9af1097fda9f2b31$var$Ri(a, b, c) {
    c = $9af1097fda9f2b31$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9af1097fda9f2b31$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9af1097fda9f2b31$var$Mi(a, b);
        "function" !== typeof d && (null === $9af1097fda9f2b31$var$Si ? $9af1097fda9f2b31$var$Si = new Set([
            this
        ]) : $9af1097fda9f2b31$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $9af1097fda9f2b31$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9af1097fda9f2b31$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9af1097fda9f2b31$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $9af1097fda9f2b31$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a["return"];
    }while (null !== a);
    return null;
}
function $9af1097fda9f2b31$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9af1097fda9f2b31$var$ch(-1, 1), b.tag = 2, $9af1097fda9f2b31$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9af1097fda9f2b31$var$Xi = $9af1097fda9f2b31$var$ua.ReactCurrentOwner, $9af1097fda9f2b31$var$Ug = !1;
function $9af1097fda9f2b31$var$Yi(a, b, c, d) {
    b.child = null === a ? $9af1097fda9f2b31$var$Ch(b, null, c, d) : $9af1097fda9f2b31$var$Bh(b, a.child, c, d);
}
function $9af1097fda9f2b31$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9af1097fda9f2b31$var$Tg(b, e);
    d = $9af1097fda9f2b31$var$Xh(a, b, c, d, f, e);
    c = $9af1097fda9f2b31$var$bi();
    if (null !== a && !$9af1097fda9f2b31$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9af1097fda9f2b31$var$$i(a, b, e);
    $9af1097fda9f2b31$var$I && c && $9af1097fda9f2b31$var$vg(b);
    b.flags |= 1;
    $9af1097fda9f2b31$var$Yi(a, b, d, e);
    return b.child;
}
function $9af1097fda9f2b31$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9af1097fda9f2b31$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9af1097fda9f2b31$var$cj(a, b, f, d, e);
        a = $9af1097fda9f2b31$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a["return"] = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9af1097fda9f2b31$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9af1097fda9f2b31$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $9af1097fda9f2b31$var$wh(f, d);
    a.ref = b.ref;
    a["return"] = b;
    return b.child = a;
}
function $9af1097fda9f2b31$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9af1097fda9f2b31$var$Ie(f, d) && a.ref === b.ref) {
            if ($9af1097fda9f2b31$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9af1097fda9f2b31$var$Ug = !0);
            else return b.lanes = a.lanes, $9af1097fda9f2b31$var$$i(a, b, e);
        }
    }
    return $9af1097fda9f2b31$var$dj(a, b, c, d, e);
}
function $9af1097fda9f2b31$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$fj, $9af1097fda9f2b31$var$gj), $9af1097fda9f2b31$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$fj, $9af1097fda9f2b31$var$gj), $9af1097fda9f2b31$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$fj, $9af1097fda9f2b31$var$gj);
            $9af1097fda9f2b31$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$fj, $9af1097fda9f2b31$var$gj), $9af1097fda9f2b31$var$gj |= d;
    $9af1097fda9f2b31$var$Yi(a, b, e, c);
    return b.child;
}
function $9af1097fda9f2b31$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9af1097fda9f2b31$var$dj(a, b, c, d, e) {
    var f = $9af1097fda9f2b31$var$Zf(c) ? $9af1097fda9f2b31$var$Xf : $9af1097fda9f2b31$var$H.current;
    f = $9af1097fda9f2b31$var$Yf(b, f);
    $9af1097fda9f2b31$var$Tg(b, e);
    c = $9af1097fda9f2b31$var$Xh(a, b, c, d, f, e);
    d = $9af1097fda9f2b31$var$bi();
    if (null !== a && !$9af1097fda9f2b31$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9af1097fda9f2b31$var$$i(a, b, e);
    $9af1097fda9f2b31$var$I && d && $9af1097fda9f2b31$var$vg(b);
    b.flags |= 1;
    $9af1097fda9f2b31$var$Yi(a, b, c, e);
    return b.child;
}
function $9af1097fda9f2b31$var$ij(a, b, c, d, e) {
    if ($9af1097fda9f2b31$var$Zf(c)) {
        var f = !0;
        $9af1097fda9f2b31$var$cg(b);
    } else f = !1;
    $9af1097fda9f2b31$var$Tg(b, e);
    if (null === b.stateNode) $9af1097fda9f2b31$var$jj(a, b), $9af1097fda9f2b31$var$ph(b, c, d), $9af1097fda9f2b31$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9af1097fda9f2b31$var$Vg(l) : (l = $9af1097fda9f2b31$var$Zf(c) ? $9af1097fda9f2b31$var$Xf : $9af1097fda9f2b31$var$H.current, l = $9af1097fda9f2b31$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9af1097fda9f2b31$var$qh(b, g, d, l);
        $9af1097fda9f2b31$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $9af1097fda9f2b31$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9af1097fda9f2b31$var$Wf.current || $9af1097fda9f2b31$var$$g ? ("function" === typeof m && ($9af1097fda9f2b31$var$kh(b, c, m, d), k = b.memoizedState), (h = $9af1097fda9f2b31$var$$g || $9af1097fda9f2b31$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9af1097fda9f2b31$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9af1097fda9f2b31$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9af1097fda9f2b31$var$Vg(k) : (k = $9af1097fda9f2b31$var$Zf(c) ? $9af1097fda9f2b31$var$Xf : $9af1097fda9f2b31$var$H.current, k = $9af1097fda9f2b31$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9af1097fda9f2b31$var$qh(b, g, d, k);
        $9af1097fda9f2b31$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $9af1097fda9f2b31$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9af1097fda9f2b31$var$Wf.current || $9af1097fda9f2b31$var$$g ? ("function" === typeof y && ($9af1097fda9f2b31$var$kh(b, c, y, d), n = b.memoizedState), (l = $9af1097fda9f2b31$var$$g || $9af1097fda9f2b31$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9af1097fda9f2b31$var$kj(a, b, c, d, f, e);
}
function $9af1097fda9f2b31$var$kj(a, b, c, d, e, f) {
    $9af1097fda9f2b31$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9af1097fda9f2b31$var$dg(b, c, !1), $9af1097fda9f2b31$var$$i(a, b, f);
    d = b.stateNode;
    $9af1097fda9f2b31$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9af1097fda9f2b31$var$Bh(b, a.child, null, f), b.child = $9af1097fda9f2b31$var$Bh(b, null, h, f)) : $9af1097fda9f2b31$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9af1097fda9f2b31$var$dg(b, c, !0);
    return b.child;
}
function $9af1097fda9f2b31$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9af1097fda9f2b31$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9af1097fda9f2b31$var$ag(a, b.context, !1);
    $9af1097fda9f2b31$var$Ih(a, b.containerInfo);
}
function $9af1097fda9f2b31$var$mj(a, b, c, d, e) {
    $9af1097fda9f2b31$var$Ig();
    $9af1097fda9f2b31$var$Jg(e);
    b.flags |= 256;
    $9af1097fda9f2b31$var$Yi(a, b, c, d);
    return b.child;
}
var $9af1097fda9f2b31$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9af1097fda9f2b31$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9af1097fda9f2b31$var$pj(a, b, c) {
    var d = b.pendingProps, e = $9af1097fda9f2b31$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, e & 1);
    if (null === a) {
        $9af1097fda9f2b31$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9af1097fda9f2b31$var$qj(g, d, 0, null), a = $9af1097fda9f2b31$var$Ah(a, d, c, null), f["return"] = b, a["return"] = b, f.sibling = a, b.child = f, b.child.memoizedState = $9af1097fda9f2b31$var$oj(c), b.memoizedState = $9af1097fda9f2b31$var$nj, a) : $9af1097fda9f2b31$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9af1097fda9f2b31$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9af1097fda9f2b31$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9af1097fda9f2b31$var$wh(h, f) : (f = $9af1097fda9f2b31$var$Ah(f, g, c, null), f.flags |= 2);
        f["return"] = b;
        d["return"] = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9af1097fda9f2b31$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9af1097fda9f2b31$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9af1097fda9f2b31$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d["return"] = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9af1097fda9f2b31$var$rj(a, b) {
    b = $9af1097fda9f2b31$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b["return"] = a;
    return a.child = b;
}
function $9af1097fda9f2b31$var$tj(a, b, c, d) {
    null !== d && $9af1097fda9f2b31$var$Jg(d);
    $9af1097fda9f2b31$var$Bh(b, a.child, null, c);
    a = $9af1097fda9f2b31$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9af1097fda9f2b31$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9af1097fda9f2b31$var$Li(Error($9af1097fda9f2b31$var$p(422))), $9af1097fda9f2b31$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9af1097fda9f2b31$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9af1097fda9f2b31$var$Ah(f, e, g, null);
        f.flags |= 2;
        d["return"] = b;
        f["return"] = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9af1097fda9f2b31$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $9af1097fda9f2b31$var$oj(g);
        b.memoizedState = $9af1097fda9f2b31$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9af1097fda9f2b31$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9af1097fda9f2b31$var$p(419));
        d = $9af1097fda9f2b31$var$Li(f, d, void 0);
        return $9af1097fda9f2b31$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9af1097fda9f2b31$var$Ug || h) {
        d = $9af1097fda9f2b31$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9af1097fda9f2b31$var$Zg(a, e), $9af1097fda9f2b31$var$mh(d, a, e, -1));
        }
        $9af1097fda9f2b31$var$uj();
        d = $9af1097fda9f2b31$var$Li(Error($9af1097fda9f2b31$var$p(421)));
        return $9af1097fda9f2b31$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9af1097fda9f2b31$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$Lf(e.nextSibling);
    $9af1097fda9f2b31$var$xg = b;
    $9af1097fda9f2b31$var$I = !0;
    $9af1097fda9f2b31$var$zg = null;
    null !== a && ($9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$rg, $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$sg, $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$qg, $9af1097fda9f2b31$var$rg = a.id, $9af1097fda9f2b31$var$sg = a.overflow, $9af1097fda9f2b31$var$qg = b);
    b = $9af1097fda9f2b31$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9af1097fda9f2b31$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9af1097fda9f2b31$var$Sg(a["return"], b, c);
}
function $9af1097fda9f2b31$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9af1097fda9f2b31$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9af1097fda9f2b31$var$Yi(a, b, d.children, c);
    d = $9af1097fda9f2b31$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9af1097fda9f2b31$var$wj(a, c, b);
            else if (19 === a.tag) $9af1097fda9f2b31$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child["return"] = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a["return"] || a["return"] === b) break a;
                a = a["return"];
            }
            a.sibling["return"] = a["return"];
            a = a.sibling;
        }
        d &= 1;
    }
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9af1097fda9f2b31$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9af1097fda9f2b31$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9af1097fda9f2b31$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9af1097fda9f2b31$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $9af1097fda9f2b31$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9af1097fda9f2b31$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9af1097fda9f2b31$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9af1097fda9f2b31$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9af1097fda9f2b31$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9af1097fda9f2b31$var$wh(a, a.pendingProps);
        b.child = c;
        for(c["return"] = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9af1097fda9f2b31$var$wh(a, a.pendingProps), c["return"] = b;
        c.sibling = null;
    }
    return b.child;
}
function $9af1097fda9f2b31$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $9af1097fda9f2b31$var$lj(b);
            $9af1097fda9f2b31$var$Ig();
            break;
        case 5:
            $9af1097fda9f2b31$var$Kh(b);
            break;
        case 1:
            $9af1097fda9f2b31$var$Zf(b.type) && $9af1097fda9f2b31$var$cg(b);
            break;
        case 4:
            $9af1097fda9f2b31$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, $9af1097fda9f2b31$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9af1097fda9f2b31$var$pj(a, b, c);
                $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, $9af1097fda9f2b31$var$M.current & 1);
                a = $9af1097fda9f2b31$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, $9af1097fda9f2b31$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9af1097fda9f2b31$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, $9af1097fda9f2b31$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9af1097fda9f2b31$var$ej(a, b, c);
    }
    return $9af1097fda9f2b31$var$$i(a, b, c);
}
var $9af1097fda9f2b31$var$Aj, $9af1097fda9f2b31$var$Bj, $9af1097fda9f2b31$var$Cj, $9af1097fda9f2b31$var$Dj;
$9af1097fda9f2b31$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child["return"] = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c["return"] || c["return"] === b) return;
            c = c["return"];
        }
        c.sibling["return"] = c["return"];
        c = c.sibling;
    }
};
$9af1097fda9f2b31$var$Bj = function Bj() {};
$9af1097fda9f2b31$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9af1097fda9f2b31$var$Ya(a, e);
                d = $9af1097fda9f2b31$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9af1097fda9f2b31$var$A({}, e, {
                    value: void 0
                });
                d = $9af1097fda9f2b31$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9af1097fda9f2b31$var$gb(a, e);
                d = $9af1097fda9f2b31$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9af1097fda9f2b31$var$Bf);
        }
        $9af1097fda9f2b31$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9af1097fda9f2b31$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9af1097fda9f2b31$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9af1097fda9f2b31$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9af1097fda9f2b31$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9af1097fda9f2b31$var$Ej(a, b) {
    if (!$9af1097fda9f2b31$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9af1097fda9f2b31$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e["return"] = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e["return"] = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9af1097fda9f2b31$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $9af1097fda9f2b31$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9af1097fda9f2b31$var$S(b), null;
        case 1:
            return $9af1097fda9f2b31$var$Zf(b.type) && $9af1097fda9f2b31$var$$f(), $9af1097fda9f2b31$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9af1097fda9f2b31$var$Jh();
            $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf);
            $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$H);
            $9af1097fda9f2b31$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9af1097fda9f2b31$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9af1097fda9f2b31$var$zg && ($9af1097fda9f2b31$var$Gj($9af1097fda9f2b31$var$zg), $9af1097fda9f2b31$var$zg = null));
            $9af1097fda9f2b31$var$Bj(a, b);
            $9af1097fda9f2b31$var$S(b);
            return null;
        case 5:
            $9af1097fda9f2b31$var$Lh(b);
            var e = $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9af1097fda9f2b31$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9af1097fda9f2b31$var$p(166));
                    $9af1097fda9f2b31$var$S(b);
                    return null;
                }
                a = $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Eh.current);
                if ($9af1097fda9f2b31$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9af1097fda9f2b31$var$Of] = b;
                    d[$9af1097fda9f2b31$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9af1097fda9f2b31$var$D("cancel", d);
                            $9af1097fda9f2b31$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9af1097fda9f2b31$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9af1097fda9f2b31$var$lf.length; e++)$9af1097fda9f2b31$var$D($9af1097fda9f2b31$var$lf[e], d);
                            break;
                        case "source":
                            $9af1097fda9f2b31$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9af1097fda9f2b31$var$D("error", d);
                            $9af1097fda9f2b31$var$D("load", d);
                            break;
                        case "details":
                            $9af1097fda9f2b31$var$D("toggle", d);
                            break;
                        case "input":
                            $9af1097fda9f2b31$var$Za(d, f);
                            $9af1097fda9f2b31$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9af1097fda9f2b31$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9af1097fda9f2b31$var$hb(d, f), $9af1097fda9f2b31$var$D("invalid", d);
                    }
                    $9af1097fda9f2b31$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9af1097fda9f2b31$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9af1097fda9f2b31$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9af1097fda9f2b31$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9af1097fda9f2b31$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9af1097fda9f2b31$var$Va(d);
                            $9af1097fda9f2b31$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9af1097fda9f2b31$var$Va(d);
                            $9af1097fda9f2b31$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9af1097fda9f2b31$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9af1097fda9f2b31$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9af1097fda9f2b31$var$Of] = b;
                    a[$9af1097fda9f2b31$var$Pf] = d;
                    $9af1097fda9f2b31$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9af1097fda9f2b31$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9af1097fda9f2b31$var$D("cancel", a);
                                $9af1097fda9f2b31$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9af1097fda9f2b31$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9af1097fda9f2b31$var$lf.length; e++)$9af1097fda9f2b31$var$D($9af1097fda9f2b31$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9af1097fda9f2b31$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9af1097fda9f2b31$var$D("error", a);
                                $9af1097fda9f2b31$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9af1097fda9f2b31$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9af1097fda9f2b31$var$Za(a, d);
                                e = $9af1097fda9f2b31$var$Ya(a, d);
                                $9af1097fda9f2b31$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9af1097fda9f2b31$var$A({}, d, {
                                    value: void 0
                                });
                                $9af1097fda9f2b31$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9af1097fda9f2b31$var$hb(a, d);
                                e = $9af1097fda9f2b31$var$gb(a, d);
                                $9af1097fda9f2b31$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9af1097fda9f2b31$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9af1097fda9f2b31$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9af1097fda9f2b31$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9af1097fda9f2b31$var$ob(a, k) : "number" === typeof k && $9af1097fda9f2b31$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9af1097fda9f2b31$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9af1097fda9f2b31$var$D("scroll", a) : null != k && $9af1097fda9f2b31$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9af1097fda9f2b31$var$Va(a);
                                $9af1097fda9f2b31$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9af1097fda9f2b31$var$Va(a);
                                $9af1097fda9f2b31$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9af1097fda9f2b31$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9af1097fda9f2b31$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9af1097fda9f2b31$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9af1097fda9f2b31$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9af1097fda9f2b31$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9af1097fda9f2b31$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9af1097fda9f2b31$var$p(166));
                c = $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Gh.current);
                $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Eh.current);
                if ($9af1097fda9f2b31$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9af1097fda9f2b31$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9af1097fda9f2b31$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9af1097fda9f2b31$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9af1097fda9f2b31$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9af1097fda9f2b31$var$Of] = b, b.stateNode = d;
            }
            $9af1097fda9f2b31$var$S(b);
            return null;
        case 13:
            $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9af1097fda9f2b31$var$I && null !== $9af1097fda9f2b31$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9af1097fda9f2b31$var$Hg(), $9af1097fda9f2b31$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9af1097fda9f2b31$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9af1097fda9f2b31$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9af1097fda9f2b31$var$p(317));
                        f[$9af1097fda9f2b31$var$Of] = b;
                    } else $9af1097fda9f2b31$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9af1097fda9f2b31$var$S(b);
                    f = !1;
                } else null !== $9af1097fda9f2b31$var$zg && ($9af1097fda9f2b31$var$Gj($9af1097fda9f2b31$var$zg), $9af1097fda9f2b31$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9af1097fda9f2b31$var$M.current & 1) ? 0 === $9af1097fda9f2b31$var$T && ($9af1097fda9f2b31$var$T = 3) : $9af1097fda9f2b31$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9af1097fda9f2b31$var$S(b);
            return null;
        case 4:
            return $9af1097fda9f2b31$var$Jh(), $9af1097fda9f2b31$var$Bj(a, b), null === a && $9af1097fda9f2b31$var$sf(b.stateNode.containerInfo), $9af1097fda9f2b31$var$S(b), null;
        case 10:
            return $9af1097fda9f2b31$var$Rg(b.type._context), $9af1097fda9f2b31$var$S(b), null;
        case 17:
            return $9af1097fda9f2b31$var$Zf(b.type) && $9af1097fda9f2b31$var$$f(), $9af1097fda9f2b31$var$S(b), null;
        case 19:
            $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M);
            f = b.memoizedState;
            if (null === f) return $9af1097fda9f2b31$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9af1097fda9f2b31$var$Ej(f, !1);
                else {
                    if (0 !== $9af1097fda9f2b31$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9af1097fda9f2b31$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9af1097fda9f2b31$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, $9af1097fda9f2b31$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9af1097fda9f2b31$var$B() > $9af1097fda9f2b31$var$Hj && (b.flags |= 128, d = !0, $9af1097fda9f2b31$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9af1097fda9f2b31$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9af1097fda9f2b31$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9af1097fda9f2b31$var$I) return $9af1097fda9f2b31$var$S(b), null;
                    } else 2 * $9af1097fda9f2b31$var$B() - f.renderingStartTime > $9af1097fda9f2b31$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $9af1097fda9f2b31$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9af1097fda9f2b31$var$B(), b.sibling = null, c = $9af1097fda9f2b31$var$M.current, $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, d ? c & 1 | 2 : c & 1), b;
            $9af1097fda9f2b31$var$S(b);
            return null;
        case 22:
        case 23:
            return $9af1097fda9f2b31$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9af1097fda9f2b31$var$gj & 1073741824) && ($9af1097fda9f2b31$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9af1097fda9f2b31$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9af1097fda9f2b31$var$p(156, b.tag));
}
function $9af1097fda9f2b31$var$Jj(a, b) {
    $9af1097fda9f2b31$var$wg(b);
    switch(b.tag){
        case 1:
            return $9af1097fda9f2b31$var$Zf(b.type) && $9af1097fda9f2b31$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9af1097fda9f2b31$var$Jh(), $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf), $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$H), $9af1097fda9f2b31$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9af1097fda9f2b31$var$Lh(b), null;
        case 13:
            $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9af1097fda9f2b31$var$p(340));
                $9af1097fda9f2b31$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M), null;
        case 4:
            return $9af1097fda9f2b31$var$Jh(), null;
        case 10:
            return $9af1097fda9f2b31$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $9af1097fda9f2b31$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9af1097fda9f2b31$var$Kj = !1, $9af1097fda9f2b31$var$U = !1, $9af1097fda9f2b31$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $9af1097fda9f2b31$var$V = null;
function $9af1097fda9f2b31$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9af1097fda9f2b31$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9af1097fda9f2b31$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9af1097fda9f2b31$var$W(a, b, d);
    }
}
var $9af1097fda9f2b31$var$Oj = !1;
function $9af1097fda9f2b31$var$Pj(a, b) {
    $9af1097fda9f2b31$var$Cf = $9af1097fda9f2b31$var$dd;
    a = $9af1097fda9f2b31$var$Me();
    if ($9af1097fda9f2b31$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9af1097fda9f2b31$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9af1097fda9f2b31$var$dd = !1;
    for($9af1097fda9f2b31$var$V = b; null !== $9af1097fda9f2b31$var$V;)if (b = $9af1097fda9f2b31$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a["return"] = b, $9af1097fda9f2b31$var$V = a;
    else for(; null !== $9af1097fda9f2b31$var$V;){
        b = $9af1097fda9f2b31$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9af1097fda9f2b31$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9af1097fda9f2b31$var$p(163));
            }
        } catch (F) {
            $9af1097fda9f2b31$var$W(b, b["return"], F);
        }
        a = b.sibling;
        if (null !== a) {
            a["return"] = b["return"];
            $9af1097fda9f2b31$var$V = a;
            break;
        }
        $9af1097fda9f2b31$var$V = b["return"];
    }
    n = $9af1097fda9f2b31$var$Oj;
    $9af1097fda9f2b31$var$Oj = !1;
    return n;
}
function $9af1097fda9f2b31$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9af1097fda9f2b31$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9af1097fda9f2b31$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9af1097fda9f2b31$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9af1097fda9f2b31$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9af1097fda9f2b31$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9af1097fda9f2b31$var$Of], delete b[$9af1097fda9f2b31$var$Pf], delete b[$9af1097fda9f2b31$var$of], delete b[$9af1097fda9f2b31$var$Qf], delete b[$9af1097fda9f2b31$var$Rf]));
    a.stateNode = null;
    a["return"] = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9af1097fda9f2b31$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9af1097fda9f2b31$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a["return"] || $9af1097fda9f2b31$var$Uj(a["return"])) return null;
            a = a["return"];
        }
        a.sibling["return"] = a["return"];
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child["return"] = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9af1097fda9f2b31$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9af1097fda9f2b31$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9af1097fda9f2b31$var$Wj(a, b, c), a = a.sibling; null !== a;)$9af1097fda9f2b31$var$Wj(a, b, c), a = a.sibling;
}
function $9af1097fda9f2b31$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9af1097fda9f2b31$var$Xj(a, b, c), a = a.sibling; null !== a;)$9af1097fda9f2b31$var$Xj(a, b, c), a = a.sibling;
}
var $9af1097fda9f2b31$var$X = null, $9af1097fda9f2b31$var$Yj = !1;
function $9af1097fda9f2b31$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$9af1097fda9f2b31$var$ak(a, b, c), c = c.sibling;
}
function $9af1097fda9f2b31$var$ak(a, b, c) {
    if ($9af1097fda9f2b31$var$lc && "function" === typeof $9af1097fda9f2b31$var$lc.onCommitFiberUnmount) try {
        $9af1097fda9f2b31$var$lc.onCommitFiberUnmount($9af1097fda9f2b31$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9af1097fda9f2b31$var$U || $9af1097fda9f2b31$var$Mj(c, b);
        case 6:
            var d = $9af1097fda9f2b31$var$X, e = $9af1097fda9f2b31$var$Yj;
            $9af1097fda9f2b31$var$X = null;
            $9af1097fda9f2b31$var$Zj(a, b, c);
            $9af1097fda9f2b31$var$X = d;
            $9af1097fda9f2b31$var$Yj = e;
            null !== $9af1097fda9f2b31$var$X && ($9af1097fda9f2b31$var$Yj ? (a = $9af1097fda9f2b31$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9af1097fda9f2b31$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9af1097fda9f2b31$var$X && ($9af1097fda9f2b31$var$Yj ? (a = $9af1097fda9f2b31$var$X, c = c.stateNode, 8 === a.nodeType ? $9af1097fda9f2b31$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9af1097fda9f2b31$var$Kf(a, c), $9af1097fda9f2b31$var$bd(a)) : $9af1097fda9f2b31$var$Kf($9af1097fda9f2b31$var$X, c.stateNode));
            break;
        case 4:
            d = $9af1097fda9f2b31$var$X;
            e = $9af1097fda9f2b31$var$Yj;
            $9af1097fda9f2b31$var$X = c.stateNode.containerInfo;
            $9af1097fda9f2b31$var$Yj = !0;
            $9af1097fda9f2b31$var$Zj(a, b, c);
            $9af1097fda9f2b31$var$X = d;
            $9af1097fda9f2b31$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9af1097fda9f2b31$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9af1097fda9f2b31$var$Nj(c, b, g) : 0 !== (f & 4) && $9af1097fda9f2b31$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9af1097fda9f2b31$var$Zj(a, b, c);
            break;
        case 1:
            if (!$9af1097fda9f2b31$var$U && ($9af1097fda9f2b31$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9af1097fda9f2b31$var$W(c, b, h);
            }
            $9af1097fda9f2b31$var$Zj(a, b, c);
            break;
        case 21:
            $9af1097fda9f2b31$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9af1097fda9f2b31$var$U = (d = $9af1097fda9f2b31$var$U) || null !== c.memoizedState, $9af1097fda9f2b31$var$Zj(a, b, c), $9af1097fda9f2b31$var$U = d) : $9af1097fda9f2b31$var$Zj(a, b, c);
            break;
        default:
            $9af1097fda9f2b31$var$Zj(a, b, c);
    }
}
function $9af1097fda9f2b31$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9af1097fda9f2b31$var$Lj);
        b.forEach(function(b) {
            var d = $9af1097fda9f2b31$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9af1097fda9f2b31$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9af1097fda9f2b31$var$X = h.stateNode;
                        $9af1097fda9f2b31$var$Yj = !1;
                        break a;
                    case 3:
                        $9af1097fda9f2b31$var$X = h.stateNode.containerInfo;
                        $9af1097fda9f2b31$var$Yj = !0;
                        break a;
                    case 4:
                        $9af1097fda9f2b31$var$X = h.stateNode.containerInfo;
                        $9af1097fda9f2b31$var$Yj = !0;
                        break a;
                }
                h = h["return"];
            }
            if (null === $9af1097fda9f2b31$var$X) throw Error($9af1097fda9f2b31$var$p(160));
            $9af1097fda9f2b31$var$ak(f, g, e);
            $9af1097fda9f2b31$var$X = null;
            $9af1097fda9f2b31$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k["return"] = null);
            e["return"] = null;
        } catch (l) {
            $9af1097fda9f2b31$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9af1097fda9f2b31$var$ek(b, a), b = b.sibling;
}
function $9af1097fda9f2b31$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            if (d & 4) {
                try {
                    $9af1097fda9f2b31$var$Qj(3, a, a["return"]), $9af1097fda9f2b31$var$Rj(3, a);
                } catch (t) {
                    $9af1097fda9f2b31$var$W(a, a["return"], t);
                }
                try {
                    $9af1097fda9f2b31$var$Qj(5, a, a["return"]);
                } catch (t) {
                    $9af1097fda9f2b31$var$W(a, a["return"], t);
                }
            }
            break;
        case 1:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            d & 512 && null !== c && $9af1097fda9f2b31$var$Mj(c, c["return"]);
            break;
        case 5:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            d & 512 && null !== c && $9af1097fda9f2b31$var$Mj(c, c["return"]);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9af1097fda9f2b31$var$ob(e, "");
                } catch (t) {
                    $9af1097fda9f2b31$var$W(a, a["return"], t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9af1097fda9f2b31$var$ab(e, f);
                    $9af1097fda9f2b31$var$vb(h, g);
                    var l = $9af1097fda9f2b31$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9af1097fda9f2b31$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9af1097fda9f2b31$var$nb(e, q) : "children" === m ? $9af1097fda9f2b31$var$ob(e, q) : $9af1097fda9f2b31$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9af1097fda9f2b31$var$bb(e, f);
                            break;
                        case "textarea":
                            $9af1097fda9f2b31$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9af1097fda9f2b31$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9af1097fda9f2b31$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9af1097fda9f2b31$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9af1097fda9f2b31$var$Pf] = f;
                } catch (t) {
                    $9af1097fda9f2b31$var$W(a, a["return"], t);
                }
            }
            break;
        case 6:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9af1097fda9f2b31$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9af1097fda9f2b31$var$W(a, a["return"], t);
                }
            }
            break;
        case 3:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9af1097fda9f2b31$var$bd(b.containerInfo);
            } catch (t) {
                $9af1097fda9f2b31$var$W(a, a["return"], t);
            }
            break;
        case 4:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            break;
        case 13:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9af1097fda9f2b31$var$gk = $9af1097fda9f2b31$var$B()));
            d & 4 && $9af1097fda9f2b31$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9af1097fda9f2b31$var$U = (l = $9af1097fda9f2b31$var$U) || m, $9af1097fda9f2b31$var$dk(b, a), $9af1097fda9f2b31$var$U = l) : $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9af1097fda9f2b31$var$V = a, m = a.child; null !== m;){
                    for(q = $9af1097fda9f2b31$var$V = m; null !== $9af1097fda9f2b31$var$V;){
                        r = $9af1097fda9f2b31$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9af1097fda9f2b31$var$Qj(4, r, r["return"]);
                                break;
                            case 1:
                                $9af1097fda9f2b31$var$Mj(r, r["return"]);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r["return"];
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9af1097fda9f2b31$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9af1097fda9f2b31$var$Mj(r, r["return"]);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9af1097fda9f2b31$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y["return"] = r, $9af1097fda9f2b31$var$V = y) : $9af1097fda9f2b31$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9af1097fda9f2b31$var$rb("display", g));
                            } catch (t) {
                                $9af1097fda9f2b31$var$W(a, a["return"], t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9af1097fda9f2b31$var$W(a, a["return"], t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child["return"] = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q["return"] || q["return"] === a) break a;
                        m === q && (m = null);
                        q = q["return"];
                    }
                    m === q && (m = null);
                    q.sibling["return"] = q["return"];
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            d & 4 && $9af1097fda9f2b31$var$bk(a);
            break;
        case 21:
            break;
        default:
            $9af1097fda9f2b31$var$dk(b, a), $9af1097fda9f2b31$var$fk(a);
    }
}
function $9af1097fda9f2b31$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a["return"]; null !== c;){
                    if ($9af1097fda9f2b31$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c["return"];
                }
                throw Error($9af1097fda9f2b31$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9af1097fda9f2b31$var$ob(e, ""), d.flags &= -33);
                    var f = $9af1097fda9f2b31$var$Vj(a);
                    $9af1097fda9f2b31$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9af1097fda9f2b31$var$Vj(a);
                    $9af1097fda9f2b31$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($9af1097fda9f2b31$var$p(161));
            }
        } catch (k) {
            $9af1097fda9f2b31$var$W(a, a["return"], k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9af1097fda9f2b31$var$ik(a, b, c) {
    $9af1097fda9f2b31$var$V = a;
    $9af1097fda9f2b31$var$jk(a, b, c);
}
function $9af1097fda9f2b31$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9af1097fda9f2b31$var$V;){
        var e = $9af1097fda9f2b31$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9af1097fda9f2b31$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9af1097fda9f2b31$var$U;
                h = $9af1097fda9f2b31$var$Kj;
                var l = $9af1097fda9f2b31$var$U;
                $9af1097fda9f2b31$var$Kj = g;
                if (($9af1097fda9f2b31$var$U = k) && !l) for($9af1097fda9f2b31$var$V = e; null !== $9af1097fda9f2b31$var$V;)g = $9af1097fda9f2b31$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9af1097fda9f2b31$var$kk(e) : null !== k ? (k["return"] = g, $9af1097fda9f2b31$var$V = k) : $9af1097fda9f2b31$var$kk(e);
                for(; null !== f;)$9af1097fda9f2b31$var$V = f, $9af1097fda9f2b31$var$jk(f, b, c), f = f.sibling;
                $9af1097fda9f2b31$var$V = e;
                $9af1097fda9f2b31$var$Kj = h;
                $9af1097fda9f2b31$var$U = l;
            }
            $9af1097fda9f2b31$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f["return"] = e, $9af1097fda9f2b31$var$V = f) : $9af1097fda9f2b31$var$lk(a, b, c);
    }
}
function $9af1097fda9f2b31$var$lk(a) {
    for(; null !== $9af1097fda9f2b31$var$V;){
        var b = $9af1097fda9f2b31$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9af1097fda9f2b31$var$U || $9af1097fda9f2b31$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9af1097fda9f2b31$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9af1097fda9f2b31$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9af1097fda9f2b31$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9af1097fda9f2b31$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9af1097fda9f2b31$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9af1097fda9f2b31$var$p(163));
                }
                $9af1097fda9f2b31$var$U || b.flags & 512 && $9af1097fda9f2b31$var$Sj(b);
            } catch (r) {
                $9af1097fda9f2b31$var$W(b, b["return"], r);
            }
        }
        if (b === a) {
            $9af1097fda9f2b31$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c["return"] = b["return"];
            $9af1097fda9f2b31$var$V = c;
            break;
        }
        $9af1097fda9f2b31$var$V = b["return"];
    }
}
function $9af1097fda9f2b31$var$hk(a) {
    for(; null !== $9af1097fda9f2b31$var$V;){
        var b = $9af1097fda9f2b31$var$V;
        if (b === a) {
            $9af1097fda9f2b31$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c["return"] = b["return"];
            $9af1097fda9f2b31$var$V = c;
            break;
        }
        $9af1097fda9f2b31$var$V = b["return"];
    }
}
function $9af1097fda9f2b31$var$kk(a) {
    for(; null !== $9af1097fda9f2b31$var$V;){
        var b = $9af1097fda9f2b31$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b["return"];
                    try {
                        $9af1097fda9f2b31$var$Rj(4, b);
                    } catch (k) {
                        $9af1097fda9f2b31$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b["return"];
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9af1097fda9f2b31$var$W(b, e, k);
                        }
                    }
                    var f = b["return"];
                    try {
                        $9af1097fda9f2b31$var$Sj(b);
                    } catch (k) {
                        $9af1097fda9f2b31$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b["return"];
                    try {
                        $9af1097fda9f2b31$var$Sj(b);
                    } catch (k) {
                        $9af1097fda9f2b31$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9af1097fda9f2b31$var$W(b, b["return"], k);
        }
        if (b === a) {
            $9af1097fda9f2b31$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h["return"] = b["return"];
            $9af1097fda9f2b31$var$V = h;
            break;
        }
        $9af1097fda9f2b31$var$V = b["return"];
    }
}
var $9af1097fda9f2b31$var$mk = Math.ceil, $9af1097fda9f2b31$var$nk = $9af1097fda9f2b31$var$ua.ReactCurrentDispatcher, $9af1097fda9f2b31$var$ok = $9af1097fda9f2b31$var$ua.ReactCurrentOwner, $9af1097fda9f2b31$var$pk = $9af1097fda9f2b31$var$ua.ReactCurrentBatchConfig, $9af1097fda9f2b31$var$K = 0, $9af1097fda9f2b31$var$R = null, $9af1097fda9f2b31$var$Y = null, $9af1097fda9f2b31$var$Z = 0, $9af1097fda9f2b31$var$gj = 0, $9af1097fda9f2b31$var$fj = $9af1097fda9f2b31$var$Uf(0), $9af1097fda9f2b31$var$T = 0, $9af1097fda9f2b31$var$qk = null, $9af1097fda9f2b31$var$hh = 0, $9af1097fda9f2b31$var$rk = 0, $9af1097fda9f2b31$var$sk = 0, $9af1097fda9f2b31$var$tk = null, $9af1097fda9f2b31$var$uk = null, $9af1097fda9f2b31$var$gk = 0, $9af1097fda9f2b31$var$Hj = Infinity, $9af1097fda9f2b31$var$vk = null, $9af1097fda9f2b31$var$Pi = !1, $9af1097fda9f2b31$var$Qi = null, $9af1097fda9f2b31$var$Si = null, $9af1097fda9f2b31$var$wk = !1, $9af1097fda9f2b31$var$xk = null, $9af1097fda9f2b31$var$yk = 0, $9af1097fda9f2b31$var$zk = 0, $9af1097fda9f2b31$var$Ak = null, $9af1097fda9f2b31$var$Bk = -1, $9af1097fda9f2b31$var$Ck = 0;
function $9af1097fda9f2b31$var$L() {
    return 0 !== ($9af1097fda9f2b31$var$K & 6) ? $9af1097fda9f2b31$var$B() : -1 !== $9af1097fda9f2b31$var$Bk ? $9af1097fda9f2b31$var$Bk : $9af1097fda9f2b31$var$Bk = $9af1097fda9f2b31$var$B();
}
function $9af1097fda9f2b31$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9af1097fda9f2b31$var$K & 2) && 0 !== $9af1097fda9f2b31$var$Z) return $9af1097fda9f2b31$var$Z & -$9af1097fda9f2b31$var$Z;
    if (null !== $9af1097fda9f2b31$var$Kg.transition) return 0 === $9af1097fda9f2b31$var$Ck && ($9af1097fda9f2b31$var$Ck = $9af1097fda9f2b31$var$yc()), $9af1097fda9f2b31$var$Ck;
    a = $9af1097fda9f2b31$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9af1097fda9f2b31$var$jd(a.type);
    return a;
}
function $9af1097fda9f2b31$var$mh(a, b, c, d) {
    if (50 < $9af1097fda9f2b31$var$zk) throw $9af1097fda9f2b31$var$zk = 0, $9af1097fda9f2b31$var$Ak = null, Error($9af1097fda9f2b31$var$p(185));
    $9af1097fda9f2b31$var$Ac(a, c, d);
    if (0 === ($9af1097fda9f2b31$var$K & 2) || a !== $9af1097fda9f2b31$var$R) a === $9af1097fda9f2b31$var$R && (0 === ($9af1097fda9f2b31$var$K & 2) && ($9af1097fda9f2b31$var$rk |= c), 4 === $9af1097fda9f2b31$var$T && $9af1097fda9f2b31$var$Dk(a, $9af1097fda9f2b31$var$Z)), $9af1097fda9f2b31$var$Ek(a, d), 1 === c && 0 === $9af1097fda9f2b31$var$K && 0 === (b.mode & 1) && ($9af1097fda9f2b31$var$Hj = $9af1097fda9f2b31$var$B() + 500, $9af1097fda9f2b31$var$fg && $9af1097fda9f2b31$var$jg());
}
function $9af1097fda9f2b31$var$Ek(a, b) {
    var c = a.callbackNode;
    $9af1097fda9f2b31$var$wc(a, b);
    var d = $9af1097fda9f2b31$var$uc(a, a === $9af1097fda9f2b31$var$R ? $9af1097fda9f2b31$var$Z : 0);
    if (0 === d) null !== c && $9af1097fda9f2b31$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9af1097fda9f2b31$var$bc(c);
        if (1 === b) 0 === a.tag ? $9af1097fda9f2b31$var$ig($9af1097fda9f2b31$var$Fk.bind(null, a)) : $9af1097fda9f2b31$var$hg($9af1097fda9f2b31$var$Fk.bind(null, a)), $9af1097fda9f2b31$var$Jf(function() {
            0 === ($9af1097fda9f2b31$var$K & 6) && $9af1097fda9f2b31$var$jg();
        }), c = null;
        else {
            switch($9af1097fda9f2b31$var$Dc(d)){
                case 1:
                    c = $9af1097fda9f2b31$var$fc;
                    break;
                case 4:
                    c = $9af1097fda9f2b31$var$gc;
                    break;
                case 16:
                    c = $9af1097fda9f2b31$var$hc;
                    break;
                case 536870912:
                    c = $9af1097fda9f2b31$var$jc;
                    break;
                default:
                    c = $9af1097fda9f2b31$var$hc;
            }
            c = $9af1097fda9f2b31$var$Gk(c, $9af1097fda9f2b31$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9af1097fda9f2b31$var$Hk(a, b) {
    $9af1097fda9f2b31$var$Bk = -1;
    $9af1097fda9f2b31$var$Ck = 0;
    if (0 !== ($9af1097fda9f2b31$var$K & 6)) throw Error($9af1097fda9f2b31$var$p(327));
    var c = a.callbackNode;
    if ($9af1097fda9f2b31$var$Ik() && a.callbackNode !== c) return null;
    var d = $9af1097fda9f2b31$var$uc(a, a === $9af1097fda9f2b31$var$R ? $9af1097fda9f2b31$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9af1097fda9f2b31$var$Jk(a, d);
    else {
        b = d;
        var e = $9af1097fda9f2b31$var$K;
        $9af1097fda9f2b31$var$K |= 2;
        var f = $9af1097fda9f2b31$var$Kk();
        if ($9af1097fda9f2b31$var$R !== a || $9af1097fda9f2b31$var$Z !== b) $9af1097fda9f2b31$var$vk = null, $9af1097fda9f2b31$var$Hj = $9af1097fda9f2b31$var$B() + 500, $9af1097fda9f2b31$var$Lk(a, b);
        for(;;)try {
            $9af1097fda9f2b31$var$Mk();
            break;
        } catch (h) {
            $9af1097fda9f2b31$var$Nk(a, h);
        }
        $9af1097fda9f2b31$var$Qg();
        $9af1097fda9f2b31$var$nk.current = f;
        $9af1097fda9f2b31$var$K = e;
        null !== $9af1097fda9f2b31$var$Y ? b = 0 : ($9af1097fda9f2b31$var$R = null, $9af1097fda9f2b31$var$Z = 0, b = $9af1097fda9f2b31$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9af1097fda9f2b31$var$xc(a), 0 !== e && (d = e, b = $9af1097fda9f2b31$var$Ok(a, e)));
        if (1 === b) throw c = $9af1097fda9f2b31$var$qk, $9af1097fda9f2b31$var$Lk(a, 0), $9af1097fda9f2b31$var$Dk(a, d), $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B()), c;
        if (6 === b) $9af1097fda9f2b31$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9af1097fda9f2b31$var$Pk(e) && (b = $9af1097fda9f2b31$var$Jk(a, d), 2 === b && (f = $9af1097fda9f2b31$var$xc(a), 0 !== f && (d = f, b = $9af1097fda9f2b31$var$Ok(a, f))), 1 === b)) throw c = $9af1097fda9f2b31$var$qk, $9af1097fda9f2b31$var$Lk(a, 0), $9af1097fda9f2b31$var$Dk(a, d), $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9af1097fda9f2b31$var$p(345));
                case 2:
                    $9af1097fda9f2b31$var$Qk(a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk);
                    break;
                case 3:
                    $9af1097fda9f2b31$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $9af1097fda9f2b31$var$gk + 500 - $9af1097fda9f2b31$var$B(), 10 < b)) {
                        if (0 !== $9af1097fda9f2b31$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9af1097fda9f2b31$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9af1097fda9f2b31$var$Ff($9af1097fda9f2b31$var$Qk.bind(null, a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk), b);
                        break;
                    }
                    $9af1097fda9f2b31$var$Qk(a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk);
                    break;
                case 4:
                    $9af1097fda9f2b31$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9af1097fda9f2b31$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9af1097fda9f2b31$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9af1097fda9f2b31$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9af1097fda9f2b31$var$Ff($9af1097fda9f2b31$var$Qk.bind(null, a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk), d);
                        break;
                    }
                    $9af1097fda9f2b31$var$Qk(a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk);
                    break;
                case 5:
                    $9af1097fda9f2b31$var$Qk(a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk);
                    break;
                default:
                    throw Error($9af1097fda9f2b31$var$p(329));
            }
        }
    }
    $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B());
    return a.callbackNode === c ? $9af1097fda9f2b31$var$Hk.bind(null, a) : null;
}
function $9af1097fda9f2b31$var$Ok(a, b) {
    var c = $9af1097fda9f2b31$var$tk;
    a.current.memoizedState.isDehydrated && ($9af1097fda9f2b31$var$Lk(a, b).flags |= 256);
    a = $9af1097fda9f2b31$var$Jk(a, b);
    2 !== a && (b = $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$uk = c, null !== b && $9af1097fda9f2b31$var$Gj(b));
    return a;
}
function $9af1097fda9f2b31$var$Gj(a) {
    null === $9af1097fda9f2b31$var$uk ? $9af1097fda9f2b31$var$uk = a : $9af1097fda9f2b31$var$uk.push.apply($9af1097fda9f2b31$var$uk, a);
}
function $9af1097fda9f2b31$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9af1097fda9f2b31$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c["return"] = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b["return"] || b["return"] === a) return !0;
                b = b["return"];
            }
            b.sibling["return"] = b["return"];
            b = b.sibling;
        }
    }
    return !0;
}
function $9af1097fda9f2b31$var$Dk(a, b) {
    b &= ~$9af1097fda9f2b31$var$sk;
    b &= ~$9af1097fda9f2b31$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9af1097fda9f2b31$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9af1097fda9f2b31$var$Fk(a) {
    if (0 !== ($9af1097fda9f2b31$var$K & 6)) throw Error($9af1097fda9f2b31$var$p(327));
    $9af1097fda9f2b31$var$Ik();
    var b = $9af1097fda9f2b31$var$uc(a, 0);
    if (0 === (b & 1)) return $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B()), null;
    var c = $9af1097fda9f2b31$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9af1097fda9f2b31$var$xc(a);
        0 !== d && (b = d, c = $9af1097fda9f2b31$var$Ok(a, d));
    }
    if (1 === c) throw c = $9af1097fda9f2b31$var$qk, $9af1097fda9f2b31$var$Lk(a, 0), $9af1097fda9f2b31$var$Dk(a, b), $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B()), c;
    if (6 === c) throw Error($9af1097fda9f2b31$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9af1097fda9f2b31$var$Qk(a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk);
    $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B());
    return null;
}
function $9af1097fda9f2b31$var$Rk(a, b) {
    var c = $9af1097fda9f2b31$var$K;
    $9af1097fda9f2b31$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9af1097fda9f2b31$var$K = c, 0 === $9af1097fda9f2b31$var$K && ($9af1097fda9f2b31$var$Hj = $9af1097fda9f2b31$var$B() + 500, $9af1097fda9f2b31$var$fg && $9af1097fda9f2b31$var$jg());
    }
}
function $9af1097fda9f2b31$var$Sk(a) {
    null !== $9af1097fda9f2b31$var$xk && 0 === $9af1097fda9f2b31$var$xk.tag && 0 === ($9af1097fda9f2b31$var$K & 6) && $9af1097fda9f2b31$var$Ik();
    var b = $9af1097fda9f2b31$var$K;
    $9af1097fda9f2b31$var$K |= 1;
    var c = $9af1097fda9f2b31$var$pk.transition, d = $9af1097fda9f2b31$var$C;
    try {
        if ($9af1097fda9f2b31$var$pk.transition = null, $9af1097fda9f2b31$var$C = 1, a) return a();
    } finally{
        $9af1097fda9f2b31$var$C = d, $9af1097fda9f2b31$var$pk.transition = c, $9af1097fda9f2b31$var$K = b, 0 === ($9af1097fda9f2b31$var$K & 6) && $9af1097fda9f2b31$var$jg();
    }
}
function $9af1097fda9f2b31$var$Ij() {
    $9af1097fda9f2b31$var$gj = $9af1097fda9f2b31$var$fj.current;
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$fj);
}
function $9af1097fda9f2b31$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9af1097fda9f2b31$var$Gf(c));
    if (null !== $9af1097fda9f2b31$var$Y) for(c = $9af1097fda9f2b31$var$Y["return"]; null !== c;){
        var d = c;
        $9af1097fda9f2b31$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9af1097fda9f2b31$var$$f();
                break;
            case 3:
                $9af1097fda9f2b31$var$Jh();
                $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf);
                $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$H);
                $9af1097fda9f2b31$var$Oh();
                break;
            case 5:
                $9af1097fda9f2b31$var$Lh(d);
                break;
            case 4:
                $9af1097fda9f2b31$var$Jh();
                break;
            case 13:
                $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M);
                break;
            case 19:
                $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M);
                break;
            case 10:
                $9af1097fda9f2b31$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $9af1097fda9f2b31$var$Ij();
        }
        c = c["return"];
    }
    $9af1097fda9f2b31$var$R = a;
    $9af1097fda9f2b31$var$Y = a = $9af1097fda9f2b31$var$wh(a.current, null);
    $9af1097fda9f2b31$var$Z = $9af1097fda9f2b31$var$gj = b;
    $9af1097fda9f2b31$var$T = 0;
    $9af1097fda9f2b31$var$qk = null;
    $9af1097fda9f2b31$var$sk = $9af1097fda9f2b31$var$rk = $9af1097fda9f2b31$var$hh = 0;
    $9af1097fda9f2b31$var$uk = $9af1097fda9f2b31$var$tk = null;
    if (null !== $9af1097fda9f2b31$var$Wg) {
        for(b = 0; b < $9af1097fda9f2b31$var$Wg.length; b++)if (c = $9af1097fda9f2b31$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9af1097fda9f2b31$var$Wg = null;
    }
    return a;
}
function $9af1097fda9f2b31$var$Nk(a, b) {
    do {
        var c = $9af1097fda9f2b31$var$Y;
        try {
            $9af1097fda9f2b31$var$Qg();
            $9af1097fda9f2b31$var$Ph.current = $9af1097fda9f2b31$var$ai;
            if ($9af1097fda9f2b31$var$Sh) {
                for(var d = $9af1097fda9f2b31$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9af1097fda9f2b31$var$Sh = !1;
            }
            $9af1097fda9f2b31$var$Rh = 0;
            $9af1097fda9f2b31$var$P = $9af1097fda9f2b31$var$O = $9af1097fda9f2b31$var$N = null;
            $9af1097fda9f2b31$var$Th = !1;
            $9af1097fda9f2b31$var$Uh = 0;
            $9af1097fda9f2b31$var$ok.current = null;
            if (null === c || null === c["return"]) {
                $9af1097fda9f2b31$var$T = 1;
                $9af1097fda9f2b31$var$qk = b;
                $9af1097fda9f2b31$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c["return"], h = c, k = b;
                b = $9af1097fda9f2b31$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9af1097fda9f2b31$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9af1097fda9f2b31$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $9af1097fda9f2b31$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9af1097fda9f2b31$var$Ti(f, l, b);
                            $9af1097fda9f2b31$var$uj();
                            break a;
                        }
                        k = Error($9af1097fda9f2b31$var$p(426));
                    }
                } else if ($9af1097fda9f2b31$var$I && h.mode & 1) {
                    var J = $9af1097fda9f2b31$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9af1097fda9f2b31$var$Wi(J, g, h, f, b);
                        $9af1097fda9f2b31$var$Jg($9af1097fda9f2b31$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $9af1097fda9f2b31$var$Ki(k, h);
                4 !== $9af1097fda9f2b31$var$T && ($9af1097fda9f2b31$var$T = 2);
                null === $9af1097fda9f2b31$var$tk ? $9af1097fda9f2b31$var$tk = [
                    f
                ] : $9af1097fda9f2b31$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9af1097fda9f2b31$var$Oi(f, k, b);
                            $9af1097fda9f2b31$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9af1097fda9f2b31$var$Si || !$9af1097fda9f2b31$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9af1097fda9f2b31$var$Ri(f, h, b);
                                $9af1097fda9f2b31$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f["return"];
                }while (null !== f);
            }
            $9af1097fda9f2b31$var$Tk(c);
        } catch (na) {
            b = na;
            $9af1097fda9f2b31$var$Y === c && null !== c && ($9af1097fda9f2b31$var$Y = c = c["return"]);
            continue;
        }
        break;
    }while (1);
}
function $9af1097fda9f2b31$var$Kk() {
    var a = $9af1097fda9f2b31$var$nk.current;
    $9af1097fda9f2b31$var$nk.current = $9af1097fda9f2b31$var$ai;
    return null === a ? $9af1097fda9f2b31$var$ai : a;
}
function $9af1097fda9f2b31$var$uj() {
    if (0 === $9af1097fda9f2b31$var$T || 3 === $9af1097fda9f2b31$var$T || 2 === $9af1097fda9f2b31$var$T) $9af1097fda9f2b31$var$T = 4;
    null === $9af1097fda9f2b31$var$R || 0 === ($9af1097fda9f2b31$var$hh & 268435455) && 0 === ($9af1097fda9f2b31$var$rk & 268435455) || $9af1097fda9f2b31$var$Dk($9af1097fda9f2b31$var$R, $9af1097fda9f2b31$var$Z);
}
function $9af1097fda9f2b31$var$Jk(a, b) {
    var c = $9af1097fda9f2b31$var$K;
    $9af1097fda9f2b31$var$K |= 2;
    var d = $9af1097fda9f2b31$var$Kk();
    if ($9af1097fda9f2b31$var$R !== a || $9af1097fda9f2b31$var$Z !== b) $9af1097fda9f2b31$var$vk = null, $9af1097fda9f2b31$var$Lk(a, b);
    for(;;)try {
        $9af1097fda9f2b31$var$Uk();
        break;
    } catch (e) {
        $9af1097fda9f2b31$var$Nk(a, e);
    }
    $9af1097fda9f2b31$var$Qg();
    $9af1097fda9f2b31$var$K = c;
    $9af1097fda9f2b31$var$nk.current = d;
    if (null !== $9af1097fda9f2b31$var$Y) throw Error($9af1097fda9f2b31$var$p(261));
    $9af1097fda9f2b31$var$R = null;
    $9af1097fda9f2b31$var$Z = 0;
    return $9af1097fda9f2b31$var$T;
}
function $9af1097fda9f2b31$var$Uk() {
    for(; null !== $9af1097fda9f2b31$var$Y;)$9af1097fda9f2b31$var$Vk($9af1097fda9f2b31$var$Y);
}
function $9af1097fda9f2b31$var$Mk() {
    for(; null !== $9af1097fda9f2b31$var$Y && !$9af1097fda9f2b31$var$cc();)$9af1097fda9f2b31$var$Vk($9af1097fda9f2b31$var$Y);
}
function $9af1097fda9f2b31$var$Vk(a) {
    var b = $9af1097fda9f2b31$var$Wk(a.alternate, a, $9af1097fda9f2b31$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9af1097fda9f2b31$var$Tk(a) : $9af1097fda9f2b31$var$Y = b;
    $9af1097fda9f2b31$var$ok.current = null;
}
function $9af1097fda9f2b31$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b["return"];
        if (0 === (b.flags & 32768)) {
            if (c = $9af1097fda9f2b31$var$Fj(c, b, $9af1097fda9f2b31$var$gj), null !== c) {
                $9af1097fda9f2b31$var$Y = c;
                return;
            }
        } else {
            c = $9af1097fda9f2b31$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9af1097fda9f2b31$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9af1097fda9f2b31$var$T = 6;
                $9af1097fda9f2b31$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9af1097fda9f2b31$var$Y = b;
            return;
        }
        $9af1097fda9f2b31$var$Y = b = a;
    }while (null !== b);
    0 === $9af1097fda9f2b31$var$T && ($9af1097fda9f2b31$var$T = 5);
}
function $9af1097fda9f2b31$var$Qk(a, b, c) {
    var d = $9af1097fda9f2b31$var$C, e = $9af1097fda9f2b31$var$pk.transition;
    try {
        $9af1097fda9f2b31$var$pk.transition = null, $9af1097fda9f2b31$var$C = 1, $9af1097fda9f2b31$var$Xk(a, b, c, d);
    } finally{
        $9af1097fda9f2b31$var$pk.transition = e, $9af1097fda9f2b31$var$C = d;
    }
    return null;
}
function $9af1097fda9f2b31$var$Xk(a, b, c, d) {
    do $9af1097fda9f2b31$var$Ik();
    while (null !== $9af1097fda9f2b31$var$xk);
    if (0 !== ($9af1097fda9f2b31$var$K & 6)) throw Error($9af1097fda9f2b31$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9af1097fda9f2b31$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9af1097fda9f2b31$var$Bc(a, f);
    a === $9af1097fda9f2b31$var$R && ($9af1097fda9f2b31$var$Y = $9af1097fda9f2b31$var$R = null, $9af1097fda9f2b31$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9af1097fda9f2b31$var$wk || ($9af1097fda9f2b31$var$wk = !0, $9af1097fda9f2b31$var$Gk($9af1097fda9f2b31$var$hc, function() {
        $9af1097fda9f2b31$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9af1097fda9f2b31$var$pk.transition;
        $9af1097fda9f2b31$var$pk.transition = null;
        var g = $9af1097fda9f2b31$var$C;
        $9af1097fda9f2b31$var$C = 1;
        var h = $9af1097fda9f2b31$var$K;
        $9af1097fda9f2b31$var$K |= 4;
        $9af1097fda9f2b31$var$ok.current = null;
        $9af1097fda9f2b31$var$Pj(a, c);
        $9af1097fda9f2b31$var$ek(c, a);
        $9af1097fda9f2b31$var$Oe($9af1097fda9f2b31$var$Df);
        $9af1097fda9f2b31$var$dd = !!$9af1097fda9f2b31$var$Cf;
        $9af1097fda9f2b31$var$Df = $9af1097fda9f2b31$var$Cf = null;
        a.current = c;
        $9af1097fda9f2b31$var$ik(c, a, e);
        $9af1097fda9f2b31$var$dc();
        $9af1097fda9f2b31$var$K = h;
        $9af1097fda9f2b31$var$C = g;
        $9af1097fda9f2b31$var$pk.transition = f;
    } else a.current = c;
    $9af1097fda9f2b31$var$wk && ($9af1097fda9f2b31$var$wk = !1, $9af1097fda9f2b31$var$xk = a, $9af1097fda9f2b31$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($9af1097fda9f2b31$var$Si = null);
    $9af1097fda9f2b31$var$mc(c.stateNode, d);
    $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9af1097fda9f2b31$var$Pi) throw $9af1097fda9f2b31$var$Pi = !1, a = $9af1097fda9f2b31$var$Qi, $9af1097fda9f2b31$var$Qi = null, a;
    0 !== ($9af1097fda9f2b31$var$yk & 1) && 0 !== a.tag && $9af1097fda9f2b31$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9af1097fda9f2b31$var$Ak ? $9af1097fda9f2b31$var$zk++ : ($9af1097fda9f2b31$var$zk = 0, $9af1097fda9f2b31$var$Ak = a) : $9af1097fda9f2b31$var$zk = 0;
    $9af1097fda9f2b31$var$jg();
    return null;
}
function $9af1097fda9f2b31$var$Ik() {
    if (null !== $9af1097fda9f2b31$var$xk) {
        var a = $9af1097fda9f2b31$var$Dc($9af1097fda9f2b31$var$yk), b = $9af1097fda9f2b31$var$pk.transition, c = $9af1097fda9f2b31$var$C;
        try {
            $9af1097fda9f2b31$var$pk.transition = null;
            $9af1097fda9f2b31$var$C = 16 > a ? 16 : a;
            if (null === $9af1097fda9f2b31$var$xk) var d = !1;
            else {
                a = $9af1097fda9f2b31$var$xk;
                $9af1097fda9f2b31$var$xk = null;
                $9af1097fda9f2b31$var$yk = 0;
                if (0 !== ($9af1097fda9f2b31$var$K & 6)) throw Error($9af1097fda9f2b31$var$p(331));
                var e = $9af1097fda9f2b31$var$K;
                $9af1097fda9f2b31$var$K |= 4;
                for($9af1097fda9f2b31$var$V = a.current; null !== $9af1097fda9f2b31$var$V;){
                    var f = $9af1097fda9f2b31$var$V, g = f.child;
                    if (0 !== ($9af1097fda9f2b31$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9af1097fda9f2b31$var$V = l; null !== $9af1097fda9f2b31$var$V;){
                                    var m = $9af1097fda9f2b31$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9af1097fda9f2b31$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q["return"] = m, $9af1097fda9f2b31$var$V = q;
                                    else for(; null !== $9af1097fda9f2b31$var$V;){
                                        m = $9af1097fda9f2b31$var$V;
                                        var r = m.sibling, y = m["return"];
                                        $9af1097fda9f2b31$var$Tj(m);
                                        if (m === l) {
                                            $9af1097fda9f2b31$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r["return"] = y;
                                            $9af1097fda9f2b31$var$V = r;
                                            break;
                                        }
                                        $9af1097fda9f2b31$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9af1097fda9f2b31$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g["return"] = f, $9af1097fda9f2b31$var$V = g;
                    else b: for(; null !== $9af1097fda9f2b31$var$V;){
                        f = $9af1097fda9f2b31$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9af1097fda9f2b31$var$Qj(9, f, f["return"]);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x["return"] = f["return"];
                            $9af1097fda9f2b31$var$V = x;
                            break b;
                        }
                        $9af1097fda9f2b31$var$V = f["return"];
                    }
                }
                var w = a.current;
                for($9af1097fda9f2b31$var$V = w; null !== $9af1097fda9f2b31$var$V;){
                    g = $9af1097fda9f2b31$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u["return"] = g, $9af1097fda9f2b31$var$V = u;
                    else b: for(g = w; null !== $9af1097fda9f2b31$var$V;){
                        h = $9af1097fda9f2b31$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9af1097fda9f2b31$var$Rj(9, h);
                            }
                        } catch (na) {
                            $9af1097fda9f2b31$var$W(h, h["return"], na);
                        }
                        if (h === g) {
                            $9af1097fda9f2b31$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F["return"] = h["return"];
                            $9af1097fda9f2b31$var$V = F;
                            break b;
                        }
                        $9af1097fda9f2b31$var$V = h["return"];
                    }
                }
                $9af1097fda9f2b31$var$K = e;
                $9af1097fda9f2b31$var$jg();
                if ($9af1097fda9f2b31$var$lc && "function" === typeof $9af1097fda9f2b31$var$lc.onPostCommitFiberRoot) try {
                    $9af1097fda9f2b31$var$lc.onPostCommitFiberRoot($9af1097fda9f2b31$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9af1097fda9f2b31$var$C = c, $9af1097fda9f2b31$var$pk.transition = b;
        }
    }
    return !1;
}
function $9af1097fda9f2b31$var$Yk(a, b, c) {
    b = $9af1097fda9f2b31$var$Ki(c, b);
    b = $9af1097fda9f2b31$var$Oi(a, b, 1);
    a = $9af1097fda9f2b31$var$dh(a, b, 1);
    b = $9af1097fda9f2b31$var$L();
    null !== a && ($9af1097fda9f2b31$var$Ac(a, 1, b), $9af1097fda9f2b31$var$Ek(a, b));
}
function $9af1097fda9f2b31$var$W(a, b, c) {
    if (3 === a.tag) $9af1097fda9f2b31$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9af1097fda9f2b31$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9af1097fda9f2b31$var$Si || !$9af1097fda9f2b31$var$Si.has(d))) {
                a = $9af1097fda9f2b31$var$Ki(c, a);
                a = $9af1097fda9f2b31$var$Ri(b, a, 1);
                b = $9af1097fda9f2b31$var$dh(b, a, 1);
                a = $9af1097fda9f2b31$var$L();
                null !== b && ($9af1097fda9f2b31$var$Ac(b, 1, a), $9af1097fda9f2b31$var$Ek(b, a));
                break;
            }
        }
        b = b["return"];
    }
}
function $9af1097fda9f2b31$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d["delete"](b);
    b = $9af1097fda9f2b31$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $9af1097fda9f2b31$var$R === a && ($9af1097fda9f2b31$var$Z & c) === c && (4 === $9af1097fda9f2b31$var$T || 3 === $9af1097fda9f2b31$var$T && ($9af1097fda9f2b31$var$Z & 130023424) === $9af1097fda9f2b31$var$Z && 500 > $9af1097fda9f2b31$var$B() - $9af1097fda9f2b31$var$gk ? $9af1097fda9f2b31$var$Lk(a, 0) : $9af1097fda9f2b31$var$sk |= c);
    $9af1097fda9f2b31$var$Ek(a, b);
}
function $9af1097fda9f2b31$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9af1097fda9f2b31$var$sc, $9af1097fda9f2b31$var$sc <<= 1, 0 === ($9af1097fda9f2b31$var$sc & 130023424) && ($9af1097fda9f2b31$var$sc = 4194304)));
    var c = $9af1097fda9f2b31$var$L();
    a = $9af1097fda9f2b31$var$Zg(a, b);
    null !== a && ($9af1097fda9f2b31$var$Ac(a, b, c), $9af1097fda9f2b31$var$Ek(a, c));
}
function $9af1097fda9f2b31$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9af1097fda9f2b31$var$Zk(a, c);
}
function $9af1097fda9f2b31$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9af1097fda9f2b31$var$p(314));
    }
    null !== d && d["delete"](b);
    $9af1097fda9f2b31$var$Zk(a, c);
}
var $9af1097fda9f2b31$var$Wk;
$9af1097fda9f2b31$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9af1097fda9f2b31$var$Wf.current) $9af1097fda9f2b31$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9af1097fda9f2b31$var$Ug = !1, $9af1097fda9f2b31$var$zj(a, b, c);
            $9af1097fda9f2b31$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9af1097fda9f2b31$var$Ug = !1, $9af1097fda9f2b31$var$I && 0 !== (b.flags & 1048576) && $9af1097fda9f2b31$var$ug(b, $9af1097fda9f2b31$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9af1097fda9f2b31$var$jj(a, b);
            a = b.pendingProps;
            var e = $9af1097fda9f2b31$var$Yf(b, $9af1097fda9f2b31$var$H.current);
            $9af1097fda9f2b31$var$Tg(b, c);
            e = $9af1097fda9f2b31$var$Xh(null, b, d, a, e, c);
            var f = $9af1097fda9f2b31$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9af1097fda9f2b31$var$Zf(d) ? (f = !0, $9af1097fda9f2b31$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9af1097fda9f2b31$var$ah(b), e.updater = $9af1097fda9f2b31$var$nh, b.stateNode = e, e._reactInternals = b, $9af1097fda9f2b31$var$rh(b, d, a, c), b = $9af1097fda9f2b31$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $9af1097fda9f2b31$var$I && f && $9af1097fda9f2b31$var$vg(b), $9af1097fda9f2b31$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9af1097fda9f2b31$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9af1097fda9f2b31$var$$k(d);
                a = $9af1097fda9f2b31$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $9af1097fda9f2b31$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9af1097fda9f2b31$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9af1097fda9f2b31$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9af1097fda9f2b31$var$aj(null, b, d, $9af1097fda9f2b31$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($9af1097fda9f2b31$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9af1097fda9f2b31$var$Lg(d, e), $9af1097fda9f2b31$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9af1097fda9f2b31$var$Lg(d, e), $9af1097fda9f2b31$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $9af1097fda9f2b31$var$lj(b);
                if (null === a) throw Error($9af1097fda9f2b31$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9af1097fda9f2b31$var$bh(a, b);
                $9af1097fda9f2b31$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9af1097fda9f2b31$var$Ki(Error($9af1097fda9f2b31$var$p(423)), b);
                        b = $9af1097fda9f2b31$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9af1097fda9f2b31$var$Ki(Error($9af1097fda9f2b31$var$p(424)), b);
                        b = $9af1097fda9f2b31$var$mj(a, b, d, c, e);
                        break a;
                    } else for($9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$Lf(b.stateNode.containerInfo.firstChild), $9af1097fda9f2b31$var$xg = b, $9af1097fda9f2b31$var$I = !0, $9af1097fda9f2b31$var$zg = null, c = $9af1097fda9f2b31$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9af1097fda9f2b31$var$Ig();
                    if (d === e) {
                        b = $9af1097fda9f2b31$var$$i(a, b, c);
                        break a;
                    }
                    $9af1097fda9f2b31$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9af1097fda9f2b31$var$Kh(b), null === a && $9af1097fda9f2b31$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9af1097fda9f2b31$var$Ef(d, e) ? g = null : null !== f && $9af1097fda9f2b31$var$Ef(d, f) && (b.flags |= 32), $9af1097fda9f2b31$var$hj(a, b), $9af1097fda9f2b31$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $9af1097fda9f2b31$var$Eg(b), null;
        case 13:
            return $9af1097fda9f2b31$var$pj(a, b, c);
        case 4:
            return $9af1097fda9f2b31$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9af1097fda9f2b31$var$Bh(b, null, d, c) : $9af1097fda9f2b31$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9af1097fda9f2b31$var$Lg(d, e), $9af1097fda9f2b31$var$Zi(a, b, d, e, c);
        case 7:
            return $9af1097fda9f2b31$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9af1097fda9f2b31$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9af1097fda9f2b31$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9af1097fda9f2b31$var$He(f.value, g)) {
                        if (f.children === e.children && !$9af1097fda9f2b31$var$Wf.current) {
                            b = $9af1097fda9f2b31$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f["return"] = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9af1097fda9f2b31$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9af1097fda9f2b31$var$Sg(f["return"], c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f["return"];
                            if (null === g) throw Error($9af1097fda9f2b31$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9af1097fda9f2b31$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g["return"] = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f["return"] = g["return"];
                                g = f;
                                break;
                            }
                            g = g["return"];
                        }
                        f = g;
                    }
                }
                $9af1097fda9f2b31$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9af1097fda9f2b31$var$Tg(b, c), e = $9af1097fda9f2b31$var$Vg(e), d = d(e), b.flags |= 1, $9af1097fda9f2b31$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9af1097fda9f2b31$var$Lg(d, b.pendingProps), e = $9af1097fda9f2b31$var$Lg(d.type, e), $9af1097fda9f2b31$var$aj(a, b, d, e, c);
        case 15:
            return $9af1097fda9f2b31$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9af1097fda9f2b31$var$Lg(d, e), $9af1097fda9f2b31$var$jj(a, b), b.tag = 1, $9af1097fda9f2b31$var$Zf(d) ? (a = !0, $9af1097fda9f2b31$var$cg(b)) : a = !1, $9af1097fda9f2b31$var$Tg(b, c), $9af1097fda9f2b31$var$ph(b, d, e), $9af1097fda9f2b31$var$rh(b, d, e, c), $9af1097fda9f2b31$var$kj(null, b, d, !0, a, c);
        case 19:
            return $9af1097fda9f2b31$var$yj(a, b, c);
        case 22:
            return $9af1097fda9f2b31$var$ej(a, b, c);
    }
    throw Error($9af1097fda9f2b31$var$p(156, b.tag));
};
function $9af1097fda9f2b31$var$Gk(a, b) {
    return $9af1097fda9f2b31$var$ac(a, b);
}
function $9af1097fda9f2b31$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9af1097fda9f2b31$var$Bg(a, b, c, d) {
    return new $9af1097fda9f2b31$var$al(a, b, c, d);
}
function $9af1097fda9f2b31$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9af1097fda9f2b31$var$$k(a) {
    if ("function" === typeof a) return $9af1097fda9f2b31$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9af1097fda9f2b31$var$Da) return 11;
        if (a === $9af1097fda9f2b31$var$Ga) return 14;
    }
    return 2;
}
function $9af1097fda9f2b31$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $9af1097fda9f2b31$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9af1097fda9f2b31$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9af1097fda9f2b31$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9af1097fda9f2b31$var$ya:
            return $9af1097fda9f2b31$var$Ah(c.children, e, f, b);
        case $9af1097fda9f2b31$var$za:
            g = 8;
            e |= 8;
            break;
        case $9af1097fda9f2b31$var$Aa:
            return a = $9af1097fda9f2b31$var$Bg(12, c, b, e | 2), a.elementType = $9af1097fda9f2b31$var$Aa, a.lanes = f, a;
        case $9af1097fda9f2b31$var$Ea:
            return a = $9af1097fda9f2b31$var$Bg(13, c, b, e), a.elementType = $9af1097fda9f2b31$var$Ea, a.lanes = f, a;
        case $9af1097fda9f2b31$var$Fa:
            return a = $9af1097fda9f2b31$var$Bg(19, c, b, e), a.elementType = $9af1097fda9f2b31$var$Fa, a.lanes = f, a;
        case $9af1097fda9f2b31$var$Ia:
            return $9af1097fda9f2b31$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9af1097fda9f2b31$var$Ba:
                    g = 10;
                    break a;
                case $9af1097fda9f2b31$var$Ca:
                    g = 9;
                    break a;
                case $9af1097fda9f2b31$var$Da:
                    g = 11;
                    break a;
                case $9af1097fda9f2b31$var$Ga:
                    g = 14;
                    break a;
                case $9af1097fda9f2b31$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9af1097fda9f2b31$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $qb7pP._)(a), ""));
    }
    b = $9af1097fda9f2b31$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9af1097fda9f2b31$var$Ah(a, b, c, d) {
    a = $9af1097fda9f2b31$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9af1097fda9f2b31$var$qj(a, b, c, d) {
    a = $9af1097fda9f2b31$var$Bg(22, a, d, b);
    a.elementType = $9af1097fda9f2b31$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9af1097fda9f2b31$var$xh(a, b, c) {
    a = $9af1097fda9f2b31$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9af1097fda9f2b31$var$zh(a, b, c) {
    b = $9af1097fda9f2b31$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9af1097fda9f2b31$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9af1097fda9f2b31$var$zc(0);
    this.expirationTimes = $9af1097fda9f2b31$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9af1097fda9f2b31$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9af1097fda9f2b31$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $9af1097fda9f2b31$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9af1097fda9f2b31$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9af1097fda9f2b31$var$ah(f);
    return a;
}
function $9af1097fda9f2b31$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9af1097fda9f2b31$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9af1097fda9f2b31$var$el(a) {
    if (!a) return $9af1097fda9f2b31$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9af1097fda9f2b31$var$Vb(a) !== a || 1 !== a.tag) throw Error($9af1097fda9f2b31$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9af1097fda9f2b31$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b["return"];
        }while (null !== b);
        throw Error($9af1097fda9f2b31$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9af1097fda9f2b31$var$Zf(c)) return $9af1097fda9f2b31$var$bg(a, c, b);
    }
    return b;
}
function $9af1097fda9f2b31$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $9af1097fda9f2b31$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $9af1097fda9f2b31$var$el(null);
    c = a.current;
    d = $9af1097fda9f2b31$var$L();
    e = $9af1097fda9f2b31$var$lh(c);
    f = $9af1097fda9f2b31$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9af1097fda9f2b31$var$dh(c, f, e);
    a.current.lanes = e;
    $9af1097fda9f2b31$var$Ac(a, e, d);
    $9af1097fda9f2b31$var$Ek(a, d);
    return a;
}
function $9af1097fda9f2b31$var$gl(a, b, c, d) {
    var e = b.current, f = $9af1097fda9f2b31$var$L(), g = $9af1097fda9f2b31$var$lh(e);
    c = $9af1097fda9f2b31$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9af1097fda9f2b31$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9af1097fda9f2b31$var$dh(e, b, g);
    null !== a && ($9af1097fda9f2b31$var$mh(a, e, g, f), $9af1097fda9f2b31$var$eh(a, e, g));
    return g;
}
function $9af1097fda9f2b31$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9af1097fda9f2b31$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9af1097fda9f2b31$var$jl(a, b) {
    $9af1097fda9f2b31$var$il(a, b);
    (a = a.alternate) && $9af1097fda9f2b31$var$il(a, b);
}
function $9af1097fda9f2b31$var$kl() {
    return null;
}
var $9af1097fda9f2b31$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $9af1097fda9f2b31$var$ml(a) {
    this._internalRoot = a;
}
$9af1097fda9f2b31$var$nl.prototype.render = $9af1097fda9f2b31$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9af1097fda9f2b31$var$p(409));
    $9af1097fda9f2b31$var$gl(a, b, null, null);
};
$9af1097fda9f2b31$var$nl.prototype.unmount = $9af1097fda9f2b31$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9af1097fda9f2b31$var$Sk(function() {
            $9af1097fda9f2b31$var$gl(null, a, null, null);
        });
        b[$9af1097fda9f2b31$var$uf] = null;
    }
};
function $9af1097fda9f2b31$var$nl(a) {
    this._internalRoot = a;
}
$9af1097fda9f2b31$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9af1097fda9f2b31$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9af1097fda9f2b31$var$Qc.length && 0 !== b && b < $9af1097fda9f2b31$var$Qc[c].priority; c++);
        $9af1097fda9f2b31$var$Qc.splice(c, 0, a);
        0 === c && $9af1097fda9f2b31$var$Vc(a);
    }
};
function $9af1097fda9f2b31$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9af1097fda9f2b31$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9af1097fda9f2b31$var$ql() {}
function $9af1097fda9f2b31$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $9af1097fda9f2b31$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $9af1097fda9f2b31$var$fl(b, d, a, 0, null, !1, !1, "", $9af1097fda9f2b31$var$ql);
        a._reactRootContainer = g;
        a[$9af1097fda9f2b31$var$uf] = g.current;
        $9af1097fda9f2b31$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9af1097fda9f2b31$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $9af1097fda9f2b31$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $9af1097fda9f2b31$var$cl(a, 0, !1, null, null, !1, !1, "", $9af1097fda9f2b31$var$ql);
    a._reactRootContainer = k;
    a[$9af1097fda9f2b31$var$uf] = k.current;
    $9af1097fda9f2b31$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9af1097fda9f2b31$var$Sk(function() {
        $9af1097fda9f2b31$var$gl(b, k, c, d);
    });
    return k;
}
function $9af1097fda9f2b31$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $9af1097fda9f2b31$var$hl(g);
                h.call(_$a);
            };
        }
        $9af1097fda9f2b31$var$gl(b, g, a, e);
    } else g = $9af1097fda9f2b31$var$rl(c, b, a, e, d);
    return $9af1097fda9f2b31$var$hl(g);
}
$9af1097fda9f2b31$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9af1097fda9f2b31$var$tc(b.pendingLanes);
                0 !== c && ($9af1097fda9f2b31$var$Cc(b, c | 1), $9af1097fda9f2b31$var$Ek(b, $9af1097fda9f2b31$var$B()), 0 === ($9af1097fda9f2b31$var$K & 6) && ($9af1097fda9f2b31$var$Hj = $9af1097fda9f2b31$var$B() + 500, $9af1097fda9f2b31$var$jg()));
            }
            break;
        case 13:
            $9af1097fda9f2b31$var$Sk(function() {
                var b = $9af1097fda9f2b31$var$Zg(a, 1);
                if (null !== b) {
                    var c = $9af1097fda9f2b31$var$L();
                    $9af1097fda9f2b31$var$mh(b, a, 1, c);
                }
            }), $9af1097fda9f2b31$var$jl(a, 1);
    }
};
$9af1097fda9f2b31$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $9af1097fda9f2b31$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $9af1097fda9f2b31$var$L();
            $9af1097fda9f2b31$var$mh(b, a, 134217728, c);
        }
        $9af1097fda9f2b31$var$jl(a, 134217728);
    }
};
$9af1097fda9f2b31$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $9af1097fda9f2b31$var$lh(a), c = $9af1097fda9f2b31$var$Zg(a, b);
        if (null !== c) {
            var d = $9af1097fda9f2b31$var$L();
            $9af1097fda9f2b31$var$mh(c, a, b, d);
        }
        $9af1097fda9f2b31$var$jl(a, b);
    }
};
$9af1097fda9f2b31$var$Hc = function Hc() {
    return $9af1097fda9f2b31$var$C;
};
$9af1097fda9f2b31$var$Ic = function Ic(a, b) {
    var c = $9af1097fda9f2b31$var$C;
    try {
        return $9af1097fda9f2b31$var$C = a, b();
    } finally{
        $9af1097fda9f2b31$var$C = c;
    }
};
$9af1097fda9f2b31$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $9af1097fda9f2b31$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9af1097fda9f2b31$var$Db(d);
                        if (!e) throw Error($9af1097fda9f2b31$var$p(90));
                        $9af1097fda9f2b31$var$Wa(d);
                        $9af1097fda9f2b31$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9af1097fda9f2b31$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9af1097fda9f2b31$var$fb(a, !!c.multiple, b, !1);
    }
};
$9af1097fda9f2b31$var$Gb = $9af1097fda9f2b31$var$Rk;
$9af1097fda9f2b31$var$Hb = $9af1097fda9f2b31$var$Sk;
var $9af1097fda9f2b31$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $9af1097fda9f2b31$var$Cb,
        $9af1097fda9f2b31$var$ue,
        $9af1097fda9f2b31$var$Db,
        $9af1097fda9f2b31$var$Eb,
        $9af1097fda9f2b31$var$Fb,
        $9af1097fda9f2b31$var$Rk
    ]
}, $9af1097fda9f2b31$var$ul = {
    findFiberByHostInstance: $9af1097fda9f2b31$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $9af1097fda9f2b31$var$vl = {
    bundleType: $9af1097fda9f2b31$var$ul.bundleType,
    version: $9af1097fda9f2b31$var$ul.version,
    rendererPackageName: $9af1097fda9f2b31$var$ul.rendererPackageName,
    rendererConfig: $9af1097fda9f2b31$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9af1097fda9f2b31$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $9af1097fda9f2b31$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9af1097fda9f2b31$var$ul.findFiberByHostInstance || $9af1097fda9f2b31$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9af1097fda9f2b31$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9af1097fda9f2b31$var$wl.isDisabled && $9af1097fda9f2b31$var$wl.supportsFiber) try {
        $9af1097fda9f2b31$var$kc = $9af1097fda9f2b31$var$wl.inject($9af1097fda9f2b31$var$vl), $9af1097fda9f2b31$var$lc = $9af1097fda9f2b31$var$wl;
    } catch (a) {}
}
$9af1097fda9f2b31$export$ae55be85d98224ed = $9af1097fda9f2b31$var$tl;
$9af1097fda9f2b31$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9af1097fda9f2b31$var$ol(b)) throw Error($9af1097fda9f2b31$var$p(200));
    return $9af1097fda9f2b31$var$dl(a, b, null, c);
};
$9af1097fda9f2b31$export$882461b6382ed46c = function(a, b) {
    if (!$9af1097fda9f2b31$var$ol(a)) throw Error($9af1097fda9f2b31$var$p(299));
    var c = !1, d = "", e = $9af1097fda9f2b31$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9af1097fda9f2b31$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$9af1097fda9f2b31$var$uf] = b.current;
    $9af1097fda9f2b31$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9af1097fda9f2b31$var$ml(b);
};
$9af1097fda9f2b31$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9af1097fda9f2b31$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9af1097fda9f2b31$var$p(268, a));
    }
    a = $9af1097fda9f2b31$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9af1097fda9f2b31$export$cd75ccfd720a3cd4 = function(a) {
    return $9af1097fda9f2b31$var$Sk(a);
};
$9af1097fda9f2b31$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9af1097fda9f2b31$var$pl(b)) throw Error($9af1097fda9f2b31$var$p(200));
    return $9af1097fda9f2b31$var$sl(null, a, b, !0, c);
};
$9af1097fda9f2b31$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9af1097fda9f2b31$var$ol(a)) throw Error($9af1097fda9f2b31$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9af1097fda9f2b31$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9af1097fda9f2b31$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9af1097fda9f2b31$var$uf] = b.current;
    $9af1097fda9f2b31$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9af1097fda9f2b31$var$nl(b);
};
$9af1097fda9f2b31$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9af1097fda9f2b31$var$pl(b)) throw Error($9af1097fda9f2b31$var$p(200));
    return $9af1097fda9f2b31$var$sl(null, a, b, !1, c);
};
$9af1097fda9f2b31$export$502457920280e6be = function(a) {
    if (!$9af1097fda9f2b31$var$pl(a)) throw Error($9af1097fda9f2b31$var$p(40));
    return a._reactRootContainer ? ($9af1097fda9f2b31$var$Sk(function() {
        $9af1097fda9f2b31$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9af1097fda9f2b31$var$uf] = null;
        });
    }), !0) : !1;
};
$9af1097fda9f2b31$export$c78a37762a8d58e1 = $9af1097fda9f2b31$var$Rk;
$9af1097fda9f2b31$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9af1097fda9f2b31$var$pl(c)) throw Error($9af1097fda9f2b31$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9af1097fda9f2b31$var$p(38));
    return $9af1097fda9f2b31$var$sl(a, b, c, !1, d);
};
$9af1097fda9f2b31$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("uOv5F", function(module, exports) {
"use strict";

module.exports = (parcelRequire("b9vhv"));

});
parcelRequire.register("b9vhv", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $81e8ccd2b0929bab$export$c4744153514ff05d; }, function (v) { return $81e8ccd2b0929bab$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $81e8ccd2b0929bab$export$3e506c1ccc9cc1a7; }, function (v) { return $81e8ccd2b0929bab$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $81e8ccd2b0929bab$export$e26fe2ed2fa76875; }, function (v) { return $81e8ccd2b0929bab$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $81e8ccd2b0929bab$export$502329bbf4b505b1; }, function (v) { return $81e8ccd2b0929bab$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $81e8ccd2b0929bab$export$6e3807111c4874c4; }, function (v) { return $81e8ccd2b0929bab$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $81e8ccd2b0929bab$export$c27134553091fb3a; }, function (v) { return $81e8ccd2b0929bab$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $81e8ccd2b0929bab$export$33ee1acdc04fd2a2; }, function (v) { return $81e8ccd2b0929bab$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $81e8ccd2b0929bab$export$b00a404bbd5edef2; }, function (v) { return $81e8ccd2b0929bab$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $81e8ccd2b0929bab$export$8352ce38b91d0c62; }, function (v) { return $81e8ccd2b0929bab$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $81e8ccd2b0929bab$export$d66a1c1c77bd778b; }, function (v) { return $81e8ccd2b0929bab$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $81e8ccd2b0929bab$export$d3dfb8e4810cb555; }, function (v) { return $81e8ccd2b0929bab$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $81e8ccd2b0929bab$export$839f9183b0465a69; }, function (v) { return $81e8ccd2b0929bab$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $81e8ccd2b0929bab$export$72fdf0e06517287b; }, function (v) { return $81e8ccd2b0929bab$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $81e8ccd2b0929bab$export$4b844e58a3e414b4; }, function (v) { return $81e8ccd2b0929bab$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $81e8ccd2b0929bab$export$816d2913ae6b83b1; }, function (v) { return $81e8ccd2b0929bab$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $81e8ccd2b0929bab$export$61bcfe829111a1d0; }, function (v) { return $81e8ccd2b0929bab$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $81e8ccd2b0929bab$export$7ee8c9beb337bc3f; }, function (v) { return $81e8ccd2b0929bab$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $81e8ccd2b0929bab$export$b5836b71941fa3ed; }, function (v) { return $81e8ccd2b0929bab$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $81e8ccd2b0929bab$export$cf845f2c119da08a; }, function (v) { return $81e8ccd2b0929bab$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $81e8ccd2b0929bab$export$c4744153514ff05d;
var $81e8ccd2b0929bab$export$3e506c1ccc9cc1a7;
var $81e8ccd2b0929bab$export$e26fe2ed2fa76875;
var $81e8ccd2b0929bab$export$502329bbf4b505b1;
var $81e8ccd2b0929bab$export$6e3807111c4874c4;
var $81e8ccd2b0929bab$export$c27134553091fb3a;
var $81e8ccd2b0929bab$export$33ee1acdc04fd2a2;
var $81e8ccd2b0929bab$export$b00a404bbd5edef2;
var $81e8ccd2b0929bab$export$8352ce38b91d0c62;
var $81e8ccd2b0929bab$export$d66a1c1c77bd778b;
var $81e8ccd2b0929bab$export$d3dfb8e4810cb555;
var $81e8ccd2b0929bab$export$839f9183b0465a69;
var $81e8ccd2b0929bab$export$72fdf0e06517287b;
var $81e8ccd2b0929bab$export$4b844e58a3e414b4;
var $81e8ccd2b0929bab$export$816d2913ae6b83b1;
var $81e8ccd2b0929bab$export$61bcfe829111a1d0;
var $81e8ccd2b0929bab$export$7ee8c9beb337bc3f;
var $81e8ccd2b0929bab$export$b5836b71941fa3ed;
var $81e8ccd2b0929bab$export$cf845f2c119da08a;
"use strict";
function $81e8ccd2b0929bab$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $81e8ccd2b0929bab$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $81e8ccd2b0929bab$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $81e8ccd2b0929bab$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $81e8ccd2b0929bab$var$g(C, c)) n < e && 0 > $81e8ccd2b0929bab$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $81e8ccd2b0929bab$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $81e8ccd2b0929bab$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $81e8ccd2b0929bab$var$l = performance;
    $81e8ccd2b0929bab$export$c4744153514ff05d = function() {
        return $81e8ccd2b0929bab$var$l.now();
    };
} else {
    var $81e8ccd2b0929bab$var$p = Date, $81e8ccd2b0929bab$var$q = $81e8ccd2b0929bab$var$p.now();
    $81e8ccd2b0929bab$export$c4744153514ff05d = function() {
        return $81e8ccd2b0929bab$var$p.now() - $81e8ccd2b0929bab$var$q;
    };
}
var $81e8ccd2b0929bab$var$r = [], $81e8ccd2b0929bab$var$t = [], $81e8ccd2b0929bab$var$u = 1, $81e8ccd2b0929bab$var$v = null, $81e8ccd2b0929bab$var$y = 3, $81e8ccd2b0929bab$var$z = !1, $81e8ccd2b0929bab$var$A = !1, $81e8ccd2b0929bab$var$B = !1, $81e8ccd2b0929bab$var$D = "function" === typeof setTimeout ? setTimeout : null, $81e8ccd2b0929bab$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $81e8ccd2b0929bab$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $81e8ccd2b0929bab$var$G(a) {
    for(var b = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$t); null !== b;){
        if (null === b.callback) $81e8ccd2b0929bab$var$k($81e8ccd2b0929bab$var$t);
        else if (b.startTime <= a) $81e8ccd2b0929bab$var$k($81e8ccd2b0929bab$var$t), b.sortIndex = b.expirationTime, $81e8ccd2b0929bab$var$f($81e8ccd2b0929bab$var$r, b);
        else break;
        b = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$t);
    }
}
function $81e8ccd2b0929bab$var$H(a) {
    $81e8ccd2b0929bab$var$B = !1;
    $81e8ccd2b0929bab$var$G(a);
    if (!$81e8ccd2b0929bab$var$A) {
        if (null !== $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r)) $81e8ccd2b0929bab$var$A = !0, $81e8ccd2b0929bab$var$I($81e8ccd2b0929bab$var$J);
        else {
            var b = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$t);
            null !== b && $81e8ccd2b0929bab$var$K($81e8ccd2b0929bab$var$H, b.startTime - a);
        }
    }
}
function $81e8ccd2b0929bab$var$J(a, b) {
    $81e8ccd2b0929bab$var$A = !1;
    $81e8ccd2b0929bab$var$B && ($81e8ccd2b0929bab$var$B = !1, $81e8ccd2b0929bab$var$E($81e8ccd2b0929bab$var$L), $81e8ccd2b0929bab$var$L = -1);
    $81e8ccd2b0929bab$var$z = !0;
    var c = $81e8ccd2b0929bab$var$y;
    try {
        $81e8ccd2b0929bab$var$G(b);
        for($81e8ccd2b0929bab$var$v = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r); null !== $81e8ccd2b0929bab$var$v && (!($81e8ccd2b0929bab$var$v.expirationTime > b) || a && !$81e8ccd2b0929bab$var$M());){
            var d = $81e8ccd2b0929bab$var$v.callback;
            if ("function" === typeof d) {
                $81e8ccd2b0929bab$var$v.callback = null;
                $81e8ccd2b0929bab$var$y = $81e8ccd2b0929bab$var$v.priorityLevel;
                var e = d($81e8ccd2b0929bab$var$v.expirationTime <= b);
                b = $81e8ccd2b0929bab$export$c4744153514ff05d();
                "function" === typeof e ? $81e8ccd2b0929bab$var$v.callback = e : $81e8ccd2b0929bab$var$v === $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r) && $81e8ccd2b0929bab$var$k($81e8ccd2b0929bab$var$r);
                $81e8ccd2b0929bab$var$G(b);
            } else $81e8ccd2b0929bab$var$k($81e8ccd2b0929bab$var$r);
            $81e8ccd2b0929bab$var$v = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r);
        }
        if (null !== $81e8ccd2b0929bab$var$v) var w = !0;
        else {
            var m = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$t);
            null !== m && $81e8ccd2b0929bab$var$K($81e8ccd2b0929bab$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $81e8ccd2b0929bab$var$v = null, $81e8ccd2b0929bab$var$y = c, $81e8ccd2b0929bab$var$z = !1;
    }
}
var $81e8ccd2b0929bab$var$N = !1, $81e8ccd2b0929bab$var$O = null, $81e8ccd2b0929bab$var$L = -1, $81e8ccd2b0929bab$var$P = 5, $81e8ccd2b0929bab$var$Q = -1;
function $81e8ccd2b0929bab$var$M() {
    return $81e8ccd2b0929bab$export$c4744153514ff05d() - $81e8ccd2b0929bab$var$Q < $81e8ccd2b0929bab$var$P ? !1 : !0;
}
function $81e8ccd2b0929bab$var$R() {
    if (null !== $81e8ccd2b0929bab$var$O) {
        var a = $81e8ccd2b0929bab$export$c4744153514ff05d();
        $81e8ccd2b0929bab$var$Q = a;
        var b = !0;
        try {
            b = $81e8ccd2b0929bab$var$O(!0, a);
        } finally{
            b ? $81e8ccd2b0929bab$var$S() : ($81e8ccd2b0929bab$var$N = !1, $81e8ccd2b0929bab$var$O = null);
        }
    } else $81e8ccd2b0929bab$var$N = !1;
}
var $81e8ccd2b0929bab$var$S;
if ("function" === typeof $81e8ccd2b0929bab$var$F) $81e8ccd2b0929bab$var$S = function S() {
    $81e8ccd2b0929bab$var$F($81e8ccd2b0929bab$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $81e8ccd2b0929bab$var$T = new MessageChannel, $81e8ccd2b0929bab$var$U = $81e8ccd2b0929bab$var$T.port2;
    $81e8ccd2b0929bab$var$T.port1.onmessage = $81e8ccd2b0929bab$var$R;
    $81e8ccd2b0929bab$var$S = function S() {
        $81e8ccd2b0929bab$var$U.postMessage(null);
    };
} else $81e8ccd2b0929bab$var$S = function S() {
    $81e8ccd2b0929bab$var$D($81e8ccd2b0929bab$var$R, 0);
};
function $81e8ccd2b0929bab$var$I(a) {
    $81e8ccd2b0929bab$var$O = a;
    $81e8ccd2b0929bab$var$N || ($81e8ccd2b0929bab$var$N = !0, $81e8ccd2b0929bab$var$S());
}
function $81e8ccd2b0929bab$var$K(a, b) {
    $81e8ccd2b0929bab$var$L = $81e8ccd2b0929bab$var$D(function() {
        a($81e8ccd2b0929bab$export$c4744153514ff05d());
    }, b);
}
$81e8ccd2b0929bab$export$3e506c1ccc9cc1a7 = 5;
$81e8ccd2b0929bab$export$e26fe2ed2fa76875 = 1;
$81e8ccd2b0929bab$export$502329bbf4b505b1 = 4;
$81e8ccd2b0929bab$export$6e3807111c4874c4 = 3;
$81e8ccd2b0929bab$export$c27134553091fb3a = null;
$81e8ccd2b0929bab$export$33ee1acdc04fd2a2 = 2;
$81e8ccd2b0929bab$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$81e8ccd2b0929bab$export$8352ce38b91d0c62 = function() {
    $81e8ccd2b0929bab$var$A || $81e8ccd2b0929bab$var$z || ($81e8ccd2b0929bab$var$A = !0, $81e8ccd2b0929bab$var$I($81e8ccd2b0929bab$var$J));
};
$81e8ccd2b0929bab$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $81e8ccd2b0929bab$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$81e8ccd2b0929bab$export$d3dfb8e4810cb555 = function() {
    return $81e8ccd2b0929bab$var$y;
};
$81e8ccd2b0929bab$export$839f9183b0465a69 = function() {
    return $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r);
};
$81e8ccd2b0929bab$export$72fdf0e06517287b = function(a) {
    switch($81e8ccd2b0929bab$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $81e8ccd2b0929bab$var$y;
    }
    var c = $81e8ccd2b0929bab$var$y;
    $81e8ccd2b0929bab$var$y = b;
    try {
        return a();
    } finally{
        $81e8ccd2b0929bab$var$y = c;
    }
};
$81e8ccd2b0929bab$export$4b844e58a3e414b4 = function() {};
$81e8ccd2b0929bab$export$816d2913ae6b83b1 = function() {};
$81e8ccd2b0929bab$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $81e8ccd2b0929bab$var$y;
    $81e8ccd2b0929bab$var$y = a;
    try {
        return b();
    } finally{
        $81e8ccd2b0929bab$var$y = c;
    }
};
$81e8ccd2b0929bab$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $81e8ccd2b0929bab$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $81e8ccd2b0929bab$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $81e8ccd2b0929bab$var$f($81e8ccd2b0929bab$var$t, a), null === $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r) && a === $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$t) && ($81e8ccd2b0929bab$var$B ? ($81e8ccd2b0929bab$var$E($81e8ccd2b0929bab$var$L), $81e8ccd2b0929bab$var$L = -1) : $81e8ccd2b0929bab$var$B = !0, $81e8ccd2b0929bab$var$K($81e8ccd2b0929bab$var$H, c - d))) : (a.sortIndex = e, $81e8ccd2b0929bab$var$f($81e8ccd2b0929bab$var$r, a), $81e8ccd2b0929bab$var$A || $81e8ccd2b0929bab$var$z || ($81e8ccd2b0929bab$var$A = !0, $81e8ccd2b0929bab$var$I($81e8ccd2b0929bab$var$J)));
    return a;
};
$81e8ccd2b0929bab$export$b5836b71941fa3ed = $81e8ccd2b0929bab$var$M;
$81e8ccd2b0929bab$export$cf845f2c119da08a = function(a) {
    var b = $81e8ccd2b0929bab$var$y;
    return function() {
        var c = $81e8ccd2b0929bab$var$y;
        $81e8ccd2b0929bab$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $81e8ccd2b0929bab$var$y = c;
        }
    };
};

});



parcelRequire.register("aFlA4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c3e793a633fa807$export$2e2bcd8739ae039; });

var $5Pgs2 = parcelRequire("5Pgs2");

var $aSMts = parcelRequire("aSMts");

var $1XfpH = parcelRequire("1XfpH");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");

var $kDmJt = parcelRequire("kDmJt");

var $5FEp6 = parcelRequire("5FEp6");

var $9Tlr6 = parcelRequire("9Tlr6");

var $52eXO = parcelRequire("52eXO");
var $f8Nug = parcelRequire("f8Nug");
var $kDFB6 = parcelRequire("kDFB6");
var $4Jn3R = parcelRequire("4Jn3R");
var $2wbWF = parcelRequire("2wbWF");
parcelRequire("5WuyH");
var $awSZB = parcelRequire("awSZB");
var $5WuyH = parcelRequire("5WuyH");

var $4ghiA = parcelRequire("4ghiA");
parcelRequire("l2BLr");
var $qmPZq = parcelRequire("qmPZq");
parcelRequire("ez2pC");
var $49c73 = parcelRequire("49c73");

var $ar9jW = parcelRequire("ar9jW");

var $fSXf2 = parcelRequire("fSXf2");

var $1zAyK = parcelRequire("1zAyK");
var $7c3e793a633fa807$var$Navbar = function() {
    // Using Context
    var _useContext = (0, $3aC2T.useContext)((0, $4ghiA.default)), loggedInUser = _useContext.loggedInUser, userName = _useContext.userName, user = _useContext.user;
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(""), 2), profilePic = _useState[0], setProfilePic = _useState[1];
    var _useState1 = (0, $aSMts._)((0, $3aC2T.useState)(false), 2), showMenu = _useState1[0], setShowMenu = _useState1[1]; // State to manage mobile menu visibility
    (0, $3aC2T.useEffect)(function() {
        (0, $qmPZq.y)((0, $ar9jW.firebaseAuth), function(currentUser) {
            if (currentUser) setProfilePic(currentUser.photoURL || ""); // Update the profile picture URL
        });
    }, []);
    var navigate = (0, $awSZB.useNavigate)();
    var handleSignOut = function() {
        var _ref = (0, $5Pgs2._)(function(e) {
            var error;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $qmPZq.C)((0, $ar9jW.firebaseAuth))
                        ];
                    case 2:
                        _state.sent();
                        navigate("/");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        navigate("/error");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSignOut(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleMenu = function() {
        setShowMenu(!showMenu);
    };
    var navLinkStyle = function(param) {
        var isActive = param.isActive;
        return {
            color: isActive ? "rgb(211,47,47)" : "",
            fontWeight: isActive ? "bolder" : ""
        };
    };
    // Subscribing to the store using Selector
    var cartItems = (0, $49c73.useSelector)(function(store) {
        return store.items;
    });
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $52eXO.default), {
        sx: {
            boxShadow: "none"
        },
        children: /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.HeaderBox), {
            children: [
                /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.FoodLogoBox), {
                    children: [
                        /*#__PURE__*/ (0, $esXub.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($kDmJt))),
                            alt: "FoodLogo",
                            onClick: function() {
                                return navigate("/home");
                            }
                        }),
                        /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.HeadingBox), {
                            children: [
                                /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                    children: "The Foodie Zone"
                                }),
                                /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                    children: "Taste of Everything"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $esXub.jsx)((0, $1zAyK.NavItems), {
                    children: /*#__PURE__*/ (0, $esXub.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5WuyH.NavLink), {
                                    style: navLinkStyle,
                                    to: "/home",
                                    children: "Home"
                                })
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5WuyH.NavLink), {
                                    style: navLinkStyle,
                                    to: "/restaurants",
                                    children: "Menu"
                                })
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5WuyH.NavLink), {
                                    style: navLinkStyle,
                                    to: "/about",
                                    children: "About"
                                })
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5WuyH.NavLink), {
                                    style: navLinkStyle,
                                    to: "/help",
                                    children: "Help"
                                })
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5WuyH.NavLink), {
                                    style: navLinkStyle,
                                    to: "/cart",
                                    children: /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.MainBox), {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                                                children: "Cart"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.CartBox), {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FEp6))), {}),
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $1zAyK.CartItemBox), {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $1zAyK.Item), {
                                                            children: cartItems === null || cartItems === void 0 ? void 0 : cartItems.length
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.LogOutUserBox), {
                    children: [
                        /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.LoggedOutBox), {
                            children: [
                                profilePic && /*#__PURE__*/ (0, $esXub.jsx)((0, $f8Nug.default), {
                                    src: profilePic,
                                    alt: "Profile Picture"
                                }),
                                userName ? loggedInUser : user === null || user === void 0 ? void 0 : user.displayName
                            ]
                        }),
                        /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.ButtonBox), {
                            onClick: handleSignOut,
                            variant: "outlined",
                            color: "error",
                            children: [
                                "LogOut",
                                /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Tlr6))), {
                                    sx: {
                                        ml: "4px",
                                        fontSize: "18px"
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $esXub.jsx)((0, $4Jn3R.default), {
                    color: "inherit",
                    "aria-label": "menu",
                    sx: {
                        display: {
                            xs: "block",
                            md: "none"
                        }
                    },
                    onClick: toggleMenu,
                    children: /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fSXf2))), {
                        sx: {
                            color: "black",
                            fontSize: "2rem"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.MobileNavItems), {
                    visible: showMenu,
                    children: [
                        /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.LoggedOutBox), {
                            children: [
                                profilePic && /*#__PURE__*/ (0, $esXub.jsx)((0, $f8Nug.default), {
                                    src: profilePic,
                                    alt: "Profile Picture"
                                }),
                                userName ? loggedInUser : user === null || user === void 0 ? void 0 : user.displayName
                            ]
                        }),
                        /*#__PURE__*/ (0, $esXub.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5WuyH.NavLink), {
                                        style: navLinkStyle,
                                        to: "/home",
                                        children: "Home"
                                    })
                                }),
                                /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5WuyH.NavLink), {
                                        style: navLinkStyle,
                                        to: "/restaurants",
                                        children: "Menu"
                                    })
                                }),
                                /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5WuyH.NavLink), {
                                        style: navLinkStyle,
                                        to: "/about",
                                        children: "About"
                                    })
                                }),
                                /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5WuyH.NavLink), {
                                        style: navLinkStyle,
                                        to: "/help",
                                        children: "Help"
                                    })
                                }),
                                /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5WuyH.NavLink), {
                                        style: navLinkStyle,
                                        to: "/cart",
                                        children: /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.MainBox), {
                                            children: [
                                                /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                                                    children: "Cart"
                                                }),
                                                /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.CartBox), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FEp6))), {}),
                                                        /*#__PURE__*/ (0, $esXub.jsx)((0, $1zAyK.CartItemBox), {
                                                            children: /*#__PURE__*/ (0, $esXub.jsx)((0, $1zAyK.Item), {
                                                                children: cartItems === null || cartItems === void 0 ? void 0 : cartItems.length
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $esXub.jsxs)((0, $1zAyK.ButtonBox), {
                            onClick: handleSignOut,
                            variant: "outlined",
                            color: "error",
                            className: "logout-button",
                            children: [
                                "LogOut",
                                /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Tlr6))), {
                                    sx: {
                                        ml: "4px",
                                        fontSize: "18px"
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $7c3e793a633fa807$export$2e2bcd8739ae039 = $7c3e793a633fa807$var$Navbar;

});
parcelRequire.register("5Pgs2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $43de7a0b82198241$export$7c398597f8905a1; });
function $43de7a0b82198241$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $43de7a0b82198241$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $43de7a0b82198241$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $43de7a0b82198241$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRequire.register("1XfpH", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $16c741eabde15b91$export$3c9a16f847548506; });
$parcel$export(module.exports, "__generator", function () { return $16c741eabde15b91$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $16c741eabde15b91$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $qb7pP = parcelRequire("qb7pP");
var $16c741eabde15b91$var$extendStatics = function extendStatics1(d, b) {
    $16c741eabde15b91$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $16c741eabde15b91$var$extendStatics(d, b);
};
function $16c741eabde15b91$export$a8ba968b8961cb8a(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $16c741eabde15b91$var$extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $16c741eabde15b91$export$18ce0697a983be9b = function __assign1() {
    $16c741eabde15b91$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16c741eabde15b91$export$18ce0697a983be9b.apply(this, arguments);
};
function $16c741eabde15b91$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $16c741eabde15b91$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $16c741eabde15b91$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $16c741eabde15b91$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    var accept = function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    };
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $16c741eabde15b91$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $16c741eabde15b91$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $qb7pP._)(x)) === "symbol" ? x : "".concat(x);
}
function $16c741eabde15b91$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $qb7pP._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $16c741eabde15b91$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $16c741eabde15b91$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $16c741eabde15b91$export$67ebef60e6f28a6(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var $16c741eabde15b91$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $16c741eabde15b91$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $16c741eabde15b91$export$45d3717a4c69092e(o, m, p);
}
function $16c741eabde15b91$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $16c741eabde15b91$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $16c741eabde15b91$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($16c741eabde15b91$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $16c741eabde15b91$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $16c741eabde15b91$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $16c741eabde15b91$export$10c90e4f7922046c(v) {
    return this instanceof $16c741eabde15b91$export$10c90e4f7922046c ? (this.v = v, this) : new $16c741eabde15b91$export$10c90e4f7922046c(v);
}
function $16c741eabde15b91$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof $16c741eabde15b91$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function $16c741eabde15b91$export$bbd80228419bb833(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $16c741eabde15b91$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function $16c741eabde15b91$export$e3b29a3d6162315f(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $16c741eabde15b91$export$19a8beecd37a4c45 === "function" ? $16c741eabde15b91$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function $16c741eabde15b91$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $16c741eabde15b91$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $16c741eabde15b91$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $16c741eabde15b91$export$45d3717a4c69092e(result, mod, k);
    }
    $16c741eabde15b91$var$__setModuleDefault(result, mod);
    return result;
}
function $16c741eabde15b91$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $16c741eabde15b91$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $16c741eabde15b91$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $16c741eabde15b91$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $16c741eabde15b91$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $16c741eabde15b91$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $16c741eabde15b91$export$8f076105dc360e92(env) {
    var fail = function fail(e) {
        env.error = env.hasError ? new $16c741eabde15b91$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    };
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $16c741eabde15b91$export$2e2bcd8739ae039 = {
    __extends: $16c741eabde15b91$export$a8ba968b8961cb8a,
    __assign: $16c741eabde15b91$export$18ce0697a983be9b,
    __rest: $16c741eabde15b91$export$3c9a16f847548506,
    __decorate: $16c741eabde15b91$export$29e00dfd3077644b,
    __param: $16c741eabde15b91$export$d5ad3fd78186038f,
    __metadata: $16c741eabde15b91$export$f1db080c865becb9,
    __awaiter: $16c741eabde15b91$export$1050f835b63b671e,
    __generator: $16c741eabde15b91$export$67ebef60e6f28a6,
    __createBinding: $16c741eabde15b91$export$45d3717a4c69092e,
    __exportStar: $16c741eabde15b91$export$f33643c0debef087,
    __values: $16c741eabde15b91$export$19a8beecd37a4c45,
    __read: $16c741eabde15b91$export$8d051b38c9118094,
    __spread: $16c741eabde15b91$export$afc72e2116322959,
    __spreadArrays: $16c741eabde15b91$export$6388937ca91ccae8,
    __spreadArray: $16c741eabde15b91$export$1216008129fb82ed,
    __await: $16c741eabde15b91$export$10c90e4f7922046c,
    __asyncGenerator: $16c741eabde15b91$export$e427f37a30a4de9b,
    __asyncDelegator: $16c741eabde15b91$export$bbd80228419bb833,
    __asyncValues: $16c741eabde15b91$export$e3b29a3d6162315f,
    __makeTemplateObject: $16c741eabde15b91$export$4fb47efe1390b86f,
    __importStar: $16c741eabde15b91$export$c21735bcef00d192,
    __importDefault: $16c741eabde15b91$export$da59b14a69baef04,
    __classPrivateFieldGet: $16c741eabde15b91$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $16c741eabde15b91$export$d40a35129aaff81f,
    __classPrivateFieldIn: $16c741eabde15b91$export$81fdc39f203e4e04,
    __addDisposableResource: $16c741eabde15b91$export$88ac25d8e944e405,
    __disposeResources: $16c741eabde15b91$export$8f076105dc360e92
};

});

parcelRequire.register("kDmJt", function(module, exports) {


module.exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("lIoGD");

});
parcelRequire.register("c6lZy", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $8cf71ab048827416$export$bdfd709ae4826697; }, function (v) { return $8cf71ab048827416$export$bdfd709ae4826697 = v; });
var $8cf71ab048827416$export$bdfd709ae4826697;
var $8cf71ab048827416$export$c9e73fbda7da57b6;
var $8cf71ab048827416$export$5a759dc7a1cfb72a;
"use strict";
var $8cf71ab048827416$var$bundleURL = {};
function $8cf71ab048827416$var$getBundleURLCached(id) {
    var value = $8cf71ab048827416$var$bundleURL[id];
    if (!value) {
        value = $8cf71ab048827416$var$getBundleURL();
        $8cf71ab048827416$var$bundleURL[id] = value;
    }
    return value;
}
function $8cf71ab048827416$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $8cf71ab048827416$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $8cf71ab048827416$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $8cf71ab048827416$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$8cf71ab048827416$export$bdfd709ae4826697 = $8cf71ab048827416$var$getBundleURLCached;
$8cf71ab048827416$export$c9e73fbda7da57b6 = $8cf71ab048827416$var$getBaseURL;
$8cf71ab048827416$export$5a759dc7a1cfb72a = $8cf71ab048827416$var$getOrigin;

});


parcelRequire.register("5FEp6", function(module, exports) {
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $42101f79e8306801$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
var $42101f79e8306801$var$_default = (0, $42101f79e8306801$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "m17.21 9-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
}), "ShoppingBasket");
module.exports["default"] = $42101f79e8306801$var$_default;

});
parcelRequire.register("iJeGA", function(module, exports) {
function $da27d243fab3c6f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $da27d243fab3c6f4$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("66GhS", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $3rjC7.default;
    }
});

var $3rjC7 = parcelRequire("3rjC7");

});
parcelRequire.register("3rjC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28131b9cf691d704$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");

var $jP6vr = parcelRequire("jP6vr");

var $esXub = parcelRequire("esXub");
"use client";
function $28131b9cf691d704$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, $esXub.jsx)((0, $jP6vr.default), (0, $3hDKy.default)({
            "data-testid": "".concat(displayName, "Icon"),
            ref: ref
        }, props, {
            children: path
        }));
    };
    Component.muiName = (0, $jP6vr.default).muiName;
    return /*#__PURE__*/ $3aC2T.memo(/*#__PURE__*/ $3aC2T.forwardRef(Component));
}

});
parcelRequire.register("3hDKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2641cb1ee5dd360d$export$2e2bcd8739ae039; });
function $2641cb1ee5dd360d$export$2e2bcd8739ae039() {
    $2641cb1ee5dd360d$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2641cb1ee5dd360d$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("jP6vr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6e7d3bba1606c59$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $lqmBd = parcelRequire("lqmBd");

var $4WGW4 = parcelRequire("4WGW4");

var $gSv8W = parcelRequire("gSv8W");

var $jDsI7 = parcelRequire("jDsI7");

var $esXub = parcelRequire("esXub");
"use client";
var $e6e7d3bba1606c59$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
var $e6e7d3bba1606c59$var$useUtilityClasses = function(ownerState) {
    var color = ownerState.color, fontSize = ownerState.fontSize, classes = ownerState.classes;
    var slots = {
        root: [
            "root",
            color !== "inherit" && "color".concat((0, $lqmBd.default)(color)),
            "fontSize".concat((0, $lqmBd.default)(fontSize))
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $jDsI7.getSvgIconUtilityClass), classes);
};
var $e6e7d3bba1606c59$var$SvgIconRoot = (0, $gSv8W.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles["color".concat((0, $lqmBd.default)(ownerState.color))],
            styles["fontSize".concat((0, $lqmBd.default)(ownerState.fontSize))]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
var $e6e7d3bba1606c59$var$SvgIcon = /*#__PURE__*/ $3aC2T.forwardRef(function SvgIcon(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    var children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? "inherit" : _props_color, _props_component = props.component, component = _props_component === void 0 ? "svg" : _props_component, _props_fontSize = props.fontSize, fontSize = _props_fontSize === void 0 ? "medium" : _props_fontSize, htmlColor = props.htmlColor, _props_inheritViewBox = props.inheritViewBox, inheritViewBox = _props_inheritViewBox === void 0 ? false : _props_inheritViewBox, titleAccess = props.titleAccess, _props_viewBox = props.viewBox, viewBox = _props_viewBox === void 0 ? "0 0 24 24" : _props_viewBox, other = (0, $8vpQL.default)(props, $e6e7d3bba1606c59$var$_excluded);
    var hasSvgAsChild = /*#__PURE__*/ $3aC2T.isValidElement(children) && children.type === "svg";
    var ownerState = (0, $3hDKy.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    var more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    var classes = $e6e7d3bba1606c59$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsxs)($e6e7d3bba1606c59$var$SvgIconRoot, (0, $3hDKy.default)({
        as: component,
        className: (0, $5i80G.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $esXub.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$e6e7d3bba1606c59$var$SvgIcon.muiName = "SvgIcon";
var $e6e7d3bba1606c59$export$2e2bcd8739ae039 = $e6e7d3bba1606c59$var$SvgIcon;

});
parcelRequire.register("8vpQL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63154540a45e19b4$export$2e2bcd8739ae039; });
function $63154540a45e19b4$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("5i80G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6affdfacec5d5dfb$export$2e2bcd8739ae039; });
function $6affdfacec5d5dfb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $6affdfacec5d5dfb$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $6affdfacec5d5dfb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $6affdfacec5d5dfb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $6affdfacec5d5dfb$export$2e2bcd8739ae039 = $6affdfacec5d5dfb$export$4f5d2d50c9deca37;

});

parcelRequire.register("i7SXW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d323847f4655e165$export$2e2bcd8739ae039; });
function $d323847f4655e165$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    var output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    function(slot) {
        output[slot] = slots[slot].reduce(function(acc, key) {
            if (key) {
                var utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRequire.register("lqmBd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f98d8e6ebe0e34bd$export$2e2bcd8739ae039; });

var $hLNbW = parcelRequire("hLNbW");
var $f98d8e6ebe0e34bd$export$2e2bcd8739ae039 = (0, $hLNbW.default);

});
parcelRequire.register("hLNbW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cefcfbe047831c03$export$2e2bcd8739ae039; });

var $cZvD6 = parcelRequire("cZvD6");
function $cefcfbe047831c03$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $cZvD6.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRequire.register("cZvD6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9753b78a574af51a$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $9753b78a574af51a$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = "https://mui.com/production-error/?code=" + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRequire.register("4WGW4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $399de24df3563ec7$export$2e2bcd8739ae039; });

var $2kJDj = parcelRequire("2kJDj");

var $fc9Ou = parcelRequire("fc9Ou");

var $gH0Wp = parcelRequire("gH0Wp");
"use client";
function $399de24df3563ec7$export$2e2bcd8739ae039(param) {
    var props = param.props, name = param.name;
    return (0, $2kJDj.default)({
        props: props,
        name: name,
        defaultTheme: (0, $fc9Ou.default),
        themeId: (0, $gH0Wp.default)
    });
}

});
parcelRequire.register("2kJDj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b30d8d2657bbbda$export$2e2bcd8739ae039; });

var $2ms4z = parcelRequire("2ms4z");

var $j7n4p = parcelRequire("j7n4p");
"use client";
function $1b30d8d2657bbbda$export$2e2bcd8739ae039(param) {
    var props = param.props, name = param.name, defaultTheme = param.defaultTheme, themeId = param.themeId;
    var theme = (0, $j7n4p.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    var mergedProps = (0, $2ms4z.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRequire.register("2ms4z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b83697f1b5ad48a$export$2e2bcd8739ae039; });

var $3JnWc = parcelRequire("3JnWc");
function $1b83697f1b5ad48a$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $3JnWc.default)(theme.components[name].defaultProps, props);
}

});
parcelRequire.register("3JnWc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b78249d32222c11$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");
function $2b78249d32222c11$export$2e2bcd8739ae039(defaultProps, props) {
    var output = (0, $3hDKy.default)({}, props);
    Object.keys(defaultProps).forEach(function(propName) {
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $3hDKy.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            var defaultSlotProps = defaultProps[propName] || {};
            var slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $3hDKy.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach(function(slotPropName) {
                    output[propName][slotPropName] = $2b78249d32222c11$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRequire.register("j7n4p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $deb09101b97bd29d$export$2e2bcd8739ae039; });

var $2KWlR = parcelRequire("2KWlR");

var $40DmL = parcelRequire("40DmL");
"use client";
var $deb09101b97bd29d$export$35e57303dbd8a66 = (0, $2KWlR.default)();
function $deb09101b97bd29d$var$useTheme() {
    var defaultTheme = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $deb09101b97bd29d$export$35e57303dbd8a66;
    return (0, $40DmL.default)(defaultTheme);
}
var $deb09101b97bd29d$export$2e2bcd8739ae039 = $deb09101b97bd29d$var$useTheme;

});
parcelRequire.register("2KWlR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $201d241062f3e1a7$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $luotc = parcelRequire("luotc");

var $aEF82 = parcelRequire("aEF82");

var $7Uevi = parcelRequire("7Uevi");

var $89tq9 = parcelRequire("89tq9");

var $hQA2V = parcelRequire("hQA2V");

var $fsdeC = parcelRequire("fsdeC");
var $201d241062f3e1a7$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $201d241062f3e1a7$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var tmp = options.breakpoints, breakpointsInput = tmp === void 0 ? {} : tmp, tmp1 = options.palette, paletteInput = tmp1 === void 0 ? {} : tmp1, spacingInput = options.spacing, tmp2 = options.shape, shapeInput = tmp2 === void 0 ? {} : tmp2, other = (0, $8vpQL.default)(options, $201d241062f3e1a7$var$_excluded);
    var breakpoints = (0, $aEF82.default)(breakpointsInput);
    var spacing = (0, $89tq9.default)(spacingInput);
    var muiTheme = (0, $luotc.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $3hDKy.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $3hDKy.default)({}, (0, $7Uevi.default), shapeInput)
    }, other);
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $luotc.default)(acc, argument);
    }, muiTheme);
    muiTheme.unstable_sxConfig = (0, $3hDKy.default)({}, (0, $fsdeC.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $hQA2V.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $201d241062f3e1a7$export$2e2bcd8739ae039 = $201d241062f3e1a7$var$createTheme;

});
parcelRequire.register("luotc", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $fa4f6188836f9ee5$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $fa4f6188836f9ee5$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");
function $fa4f6188836f9ee5$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $fa4f6188836f9ee5$var$deepClone(source) {
    if (!$fa4f6188836f9ee5$export$53b83ca8eaab0383(source)) return source;
    var output = {};
    Object.keys(source).forEach(function(key) {
        output[key] = $fa4f6188836f9ee5$var$deepClone(source[key]);
    });
    return output;
}
function $fa4f6188836f9ee5$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $3hDKy.default)({}, target) : target;
    if ($fa4f6188836f9ee5$export$53b83ca8eaab0383(target) && $fa4f6188836f9ee5$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($fa4f6188836f9ee5$export$53b83ca8eaab0383(source[key]) && key in target && $fa4f6188836f9ee5$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $fa4f6188836f9ee5$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $fa4f6188836f9ee5$export$53b83ca8eaab0383(source[key]) ? $fa4f6188836f9ee5$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRequire.register("aEF82", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c1d8b203c227976$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");
var $7c1d8b203c227976$var$_excluded = [
    "values",
    "unit",
    "step"
];
var $7c1d8b203c227976$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
var $7c1d8b203c227976$var$sortBreakpointsValues = function(values) {
    var breakpointsAsArray = Object.keys(values).map(function(key) {
        return {
            key: key,
            val: values[key]
        };
    }) || [];
    // Sort in ascending order
    breakpointsAsArray.sort(function(breakpoint1, breakpoint2) {
        return breakpoint1.val - breakpoint2.val;
    });
    return breakpointsAsArray.reduce(function(acc, obj) {
        return (0, $3hDKy.default)({}, acc, (0, $2iBlG._)({}, obj.key, obj.val));
    }, {});
};
function $7c1d8b203c227976$export$2e2bcd8739ae039(breakpoints) {
    var up = function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    };
    var down = function down(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    };
    var between = function between(start, end) {
        var endIndex = keys.indexOf(end);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100).concat(unit, ")");
    };
    var only = function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    };
    var not = function not(key) {
        // handle first and last key separately, for better readability
        var keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    };
    var _breakpoints_values = breakpoints.// The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values, values = _breakpoints_values === void 0 ? {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    } : _breakpoints_values, _breakpoints_unit = breakpoints.unit, unit = _breakpoints_unit === void 0 ? "px" : _breakpoints_unit, _breakpoints_step = breakpoints.step, step = _breakpoints_step === void 0 ? 5 : _breakpoints_step, other = (0, $8vpQL.default)(breakpoints, $7c1d8b203c227976$var$_excluded);
    var sortedValues = $7c1d8b203c227976$var$sortBreakpointsValues(values);
    var keys = Object.keys(sortedValues);
    return (0, $3hDKy.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});
parcelRequire.register("2iBlG", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $1aca3bdf51b67d66$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $1aca3bdf51b67d66$export$1e71eb4bef00f6b0; });
function $1aca3bdf51b67d66$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRequire.register("7Uevi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c19037e73b0a4d0$export$2e2bcd8739ae039; });
var $5c19037e73b0a4d0$var$shape = {
    borderRadius: 4
};
var $5c19037e73b0a4d0$export$2e2bcd8739ae039 = $5c19037e73b0a4d0$var$shape;

});

parcelRequire.register("89tq9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ef5fc59a6def2db$export$2e2bcd8739ae039; });

var $b9zmB = parcelRequire("b9zmB");
function $5ef5fc59a6def2db$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    var transform = (0, $b9zmB.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function() {
        for(var _len = arguments.length, argsInput = new Array(_len), _key = 0; _key < _len; _key++){
            argsInput[_key] = arguments[_key];
        }
        var args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map(function(argument) {
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("b9zmB", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $81ebf7769b6085f4$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $81ebf7769b6085f4$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $81ebf7769b6085f4$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $81ebf7769b6085f4$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $81ebf7769b6085f4$export$6f98e8eaf0be1996; });

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");


var $kf05Q = parcelRequire("kf05Q");

var $fpsdE = parcelRequire("fpsdE");

var $eSTRY = parcelRequire("eSTRY");

var $hiM19 = parcelRequire("hiM19");
var $81ebf7769b6085f4$var$properties = {
    m: "margin",
    p: "padding"
};
var $81ebf7769b6085f4$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
var $81ebf7769b6085f4$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $81ebf7769b6085f4$var$getCssProperties = (0, $hiM19.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($81ebf7769b6085f4$var$aliases[prop]) prop = $81ebf7769b6085f4$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop_split = (0, $aSMts._)(prop.split(""), 2), a = _prop_split[0], b = _prop_split[1];
    var property = $81ebf7769b6085f4$var$properties[a];
    var direction = $81ebf7769b6085f4$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $81ebf7769b6085f4$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
var $81ebf7769b6085f4$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
var $81ebf7769b6085f4$var$spacingKeys = (0, $dHvbf._)($81ebf7769b6085f4$export$aab52a0dde05ad8a).concat((0, $dHvbf._)($81ebf7769b6085f4$export$f8397d44f03ab6ad));
function $81ebf7769b6085f4$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    var themeSpacing = (_getPath = (0, $fpsdE.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return function(abs) {
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return function() {
        return undefined;
    };
}
function $81ebf7769b6085f4$export$1def6f833384e3d1(theme) {
    return $81ebf7769b6085f4$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $81ebf7769b6085f4$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return "-".concat(transformed);
}
function $81ebf7769b6085f4$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $81ebf7769b6085f4$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
    };
}
function $81ebf7769b6085f4$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    var cssProperties = $81ebf7769b6085f4$var$getCssProperties(prop);
    var styleFromPropValue = $81ebf7769b6085f4$export$1dc0036b298ea8d1(cssProperties, transformer);
    var propValue = props[prop];
    return (0, $kf05Q.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $81ebf7769b6085f4$var$style(props, keys) {
    var transformer = $81ebf7769b6085f4$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map(function(prop) {
        return $81ebf7769b6085f4$var$resolveCssProperty(props, keys, prop, transformer);
    }).reduce((0, $eSTRY.default), {});
}
function $81ebf7769b6085f4$export$7ede87f9b603dd3c(props) {
    return $81ebf7769b6085f4$var$style(props, $81ebf7769b6085f4$export$aab52a0dde05ad8a);
}
$81ebf7769b6085f4$export$7ede87f9b603dd3c.propTypes = {};
$81ebf7769b6085f4$export$7ede87f9b603dd3c.filterProps = $81ebf7769b6085f4$export$aab52a0dde05ad8a;
function $81ebf7769b6085f4$export$6f98e8eaf0be1996(props) {
    return $81ebf7769b6085f4$var$style(props, $81ebf7769b6085f4$export$f8397d44f03ab6ad);
}
$81ebf7769b6085f4$export$6f98e8eaf0be1996.propTypes = {};
$81ebf7769b6085f4$export$6f98e8eaf0be1996.filterProps = $81ebf7769b6085f4$export$f8397d44f03ab6ad;
function $81ebf7769b6085f4$var$spacing(props) {
    return $81ebf7769b6085f4$var$style(props, $81ebf7769b6085f4$var$spacingKeys);
}
$81ebf7769b6085f4$var$spacing.propTypes = {};
$81ebf7769b6085f4$var$spacing.filterProps = $81ebf7769b6085f4$var$spacingKeys;
var $81ebf7769b6085f4$export$2e2bcd8739ae039 = $81ebf7769b6085f4$var$spacing;

});
parcelRequire.register("dHvbf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9f977a4a91aacb97$export$1b5e630bc3aea29f; });

var $hKgIo = parcelRequire("hKgIo");

var $2j9E4 = parcelRequire("2j9E4");

var $55t4W = parcelRequire("55t4W");

var $fXGmO = parcelRequire("fXGmO");
function $9f977a4a91aacb97$export$1b5e630bc3aea29f(arr) {
    return (0, $hKgIo._array_without_holes)(arr) || (0, $2j9E4._iterable_to_array)(arr) || (0, $fXGmO._unsupported_iterable_to_array)(arr) || (0, $55t4W._non_iterable_spread)();
}

});
parcelRequire.register("hKgIo", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $ceb3b2d1d8d8e799$export$7e0947b5ad3404e2; });

var $5B3Hz = parcelRequire("5B3Hz");
function $ceb3b2d1d8d8e799$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $5B3Hz._array_like_to_array)(arr);
}

});

parcelRequire.register("2j9E4", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $1ae4d67339a61e6c$export$1eb58a6e75231000; });
function $1ae4d67339a61e6c$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("55t4W", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $3b43f9d018915a54$export$e6f3c4780d19eb2b; });
function $3b43f9d018915a54$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRequire.register("kf05Q", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $ebc547e553f90334$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $ebc547e553f90334$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $ebc547e553f90334$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $ebc547e553f90334$export$8922c90b6e020726; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $ebc547e553f90334$export$980e6a259d807490; });

var $dHvbf = parcelRequire("dHvbf");

var $3hDKy = parcelRequire("3hDKy");


var $luotc = parcelRequire("luotc");

var $eSTRY = parcelRequire("eSTRY");
var $ebc547e553f90334$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
var $ebc547e553f90334$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: function(key) {
        return "@media (min-width:".concat($ebc547e553f90334$export$68c286be0e7e55b7[key], "px)");
    }
};
function $ebc547e553f90334$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    var theme = props.theme || {};
    if (Array.isArray(propValue)) {
        var themeBreakpoints = theme.breakpoints || $ebc547e553f90334$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        var themeBreakpoints1 = theme.breakpoints || $ebc547e553f90334$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            // key is breakpoint
            if (Object.keys(themeBreakpoints1.values || $ebc547e553f90334$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                var mediaKey = themeBreakpoints1.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                var cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $ebc547e553f90334$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    var newStyleFunction = function(props) {
        var theme = props.theme || {};
        var base = styleFunction(props);
        var themeBreakpoints = theme.breakpoints || $ebc547e553f90334$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $3hDKy.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $eSTRY.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].concat((0, $dHvbf._)(styleFunction.filterProps));
    return newStyleFunction;
}
function $ebc547e553f90334$export$1f2600516e91381f() {
    var breakpointsInput = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _breakpointsInput$key;
    var breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce(function(acc, key) {
        var breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $ebc547e553f90334$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce(function(acc, key) {
        var breakpointOutput = acc[key];
        var isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $ebc547e553f90334$export$b89a003a1e05c0ee(breakpointsInput) {
    for(var _len = arguments.length, styles = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        styles[_key - 1] = arguments[_key];
    }
    var emptyBreakpoints = $ebc547e553f90334$export$1f2600516e91381f(breakpointsInput);
    var mergedOutput = [
        emptyBreakpoints
    ].concat((0, $dHvbf._)(styles)).reduce(function(prev, next) {
        return (0, $luotc.default)(prev, next);
    }, {});
    return $ebc547e553f90334$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $ebc547e553f90334$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    var base = {};
    var breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach(function(breakpoint, i) {
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach(function(breakpoint) {
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $ebc547e553f90334$export$980e6a259d807490(param) {
    var breakpointValues = param.values, themeBreakpoints = param.breakpoints, customBase = param.base;
    var base = customBase || $ebc547e553f90334$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    var keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    var previous;
    return keys.reduce(function(acc, breakpoint, i) {
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $ebc547e553f90334$export$2e2bcd8739ae039 = $ebc547e553f90334$var$breakpoints;

});
parcelRequire.register("eSTRY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad61725639d2773a$export$2e2bcd8739ae039; });

var $luotc = parcelRequire("luotc");
function $ad61725639d2773a$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $luotc.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $ad61725639d2773a$export$2e2bcd8739ae039 = $ad61725639d2773a$var$merge;

});


parcelRequire.register("fpsdE", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $b37f148f96459875$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $b37f148f96459875$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $b37f148f96459875$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $hLNbW = parcelRequire("hLNbW");


var $kf05Q = parcelRequire("kf05Q");
function $b37f148f96459875$export$2aa3fd96c49a84a8(obj, path) {
    var checkVars = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        var val = "vars.".concat(path).split(".").reduce(function(acc, item) {
            return acc && acc[item] ? acc[item] : null;
        }, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce(function(acc, item) {
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $b37f148f96459875$export$741ad47189a64aa0(themeMapping, transform, propValueFinal) {
    var userValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : propValueFinal;
    var value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $b37f148f96459875$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $b37f148f96459875$var$style(options) {
    var prop = options.prop, _options_cssProperty = options.cssProperty, cssProperty = _options_cssProperty === void 0 ? options.prop : _options_cssProperty, themeKey = options.themeKey, transform = options.transform;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    var fn = function(props) {
        if (props[prop] == null) return null;
        var propValue = props[prop];
        var theme = props.theme;
        var themeMapping = $b37f148f96459875$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        var styleFromPropValue = function(propValueFinal) {
            var value = $b37f148f96459875$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $b37f148f96459875$export$741ad47189a64aa0(themeMapping, transform, "".concat(prop).concat(propValueFinal === "default" ? "" : (0, $hLNbW.default)(propValueFinal)), propValueFinal);
            if (cssProperty === false) return value;
            return (0, $2iBlG._)({}, cssProperty, value);
        };
        return (0, $kf05Q.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $b37f148f96459875$export$2e2bcd8739ae039 = $b37f148f96459875$var$style;

});

parcelRequire.register("hiM19", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9895d64b1d38e85$export$2e2bcd8739ae039; });
function $c9895d64b1d38e85$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("hQA2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfe34106259a448f$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $hLNbW = parcelRequire("hLNbW");

var $eSTRY = parcelRequire("eSTRY");

var $fpsdE = parcelRequire("fpsdE");

var $kf05Q = parcelRequire("kf05Q");

var $fsdeC = parcelRequire("fsdeC");
function $cfe34106259a448f$var$objectsHaveSameKeys() {
    for(var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++){
        objects[_key] = arguments[_key];
    }
    var allKeys = objects.reduce(function(keys, object) {
        return keys.concat(Object.keys(object));
    }, []);
    var union = new Set(allKeys);
    return objects.every(function(object) {
        return union.size === Object.keys(object).length;
    });
}
function $cfe34106259a448f$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $cfe34106259a448f$export$7d53d8bf2911e013() {
    var getThemeValue = function getThemeValue(prop, val, theme, config) {
        var _obj;
        var props = (_obj = {}, (0, $2iBlG._)(_obj, prop, val), (0, $2iBlG._)(_obj, "theme", theme), _obj);
        var options = config[prop];
        if (!options) return (0, $2iBlG._)({}, prop, val);
        var _options_cssProperty = options.cssProperty, cssProperty = _options_cssProperty === void 0 ? prop : _options_cssProperty, themeKey = options.themeKey, transform = options.transform, style = options.style;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return (0, $2iBlG._)({}, prop, val);
        var themeMapping = (0, $fpsdE.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        var styleFromPropValue = function(propValueFinal) {
            var value = (0, $fpsdE.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $fpsdE.getStyleValue)(themeMapping, transform, "".concat(prop).concat(propValueFinal === "default" ? "" : (0, $hLNbW.default)(propValueFinal)), propValueFinal);
            if (cssProperty === false) return value;
            return (0, $2iBlG._)({}, cssProperty, value);
        };
        return (0, $kf05Q.handleBreakpoints)(props, val, styleFromPropValue);
    };
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        var _ref = props || {}, sx = _ref.sx, _ref_theme = _ref.theme, theme = _ref_theme === void 0 ? {} : _ref_theme;
        if (!sx) return null; // Emotion & styled-components will neglect null
        var config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $fsdeC.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            var sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            var emptyBreakpoints = (0, $kf05Q.createEmptyBreakpointObject)(theme.breakpoints);
            var breakpointsKeys = Object.keys(emptyBreakpoints);
            var css = emptyBreakpoints;
            Object.keys(sxObject).forEach(function(styleKey) {
                var value = $cfe34106259a448f$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $eSTRY.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            var breakpointsValues = (0, $kf05Q.handleBreakpoints)({
                                theme: theme
                            }, value, function(x) {
                                return (0, $2iBlG._)({}, styleKey, x);
                            });
                            if ($cfe34106259a448f$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $eSTRY.default)(css, breakpointsValues);
                        }
                    } else css = (0, $eSTRY.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $kf05Q.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
var $cfe34106259a448f$var$styleFunctionSx = $cfe34106259a448f$export$7d53d8bf2911e013();
$cfe34106259a448f$var$styleFunctionSx.filterProps = [
    "sx"
];
var $cfe34106259a448f$export$2e2bcd8739ae039 = $cfe34106259a448f$var$styleFunctionSx;

});
parcelRequire.register("fsdeC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b403bcab2b096541$export$2e2bcd8739ae039; });

var $b9zmB = parcelRequire("b9zmB");

var $4jXpz = parcelRequire("4jXpz");

var $b5y1T = parcelRequire("b5y1T");

var $4yu9q = parcelRequire("4yu9q");

var $kgQvE = parcelRequire("kgQvE");
var $b403bcab2b096541$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $4jXpz.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $4jXpz.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $4jXpz.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $4jXpz.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $4jXpz.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $4jXpz.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $4yu9q.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $4yu9q.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $4yu9q.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $b9zmB.padding)
    },
    pt: {
        style: (0, $b9zmB.padding)
    },
    pr: {
        style: (0, $b9zmB.padding)
    },
    pb: {
        style: (0, $b9zmB.padding)
    },
    pl: {
        style: (0, $b9zmB.padding)
    },
    px: {
        style: (0, $b9zmB.padding)
    },
    py: {
        style: (0, $b9zmB.padding)
    },
    padding: {
        style: (0, $b9zmB.padding)
    },
    paddingTop: {
        style: (0, $b9zmB.padding)
    },
    paddingRight: {
        style: (0, $b9zmB.padding)
    },
    paddingBottom: {
        style: (0, $b9zmB.padding)
    },
    paddingLeft: {
        style: (0, $b9zmB.padding)
    },
    paddingX: {
        style: (0, $b9zmB.padding)
    },
    paddingY: {
        style: (0, $b9zmB.padding)
    },
    paddingInline: {
        style: (0, $b9zmB.padding)
    },
    paddingInlineStart: {
        style: (0, $b9zmB.padding)
    },
    paddingInlineEnd: {
        style: (0, $b9zmB.padding)
    },
    paddingBlock: {
        style: (0, $b9zmB.padding)
    },
    paddingBlockStart: {
        style: (0, $b9zmB.padding)
    },
    paddingBlockEnd: {
        style: (0, $b9zmB.padding)
    },
    m: {
        style: (0, $b9zmB.margin)
    },
    mt: {
        style: (0, $b9zmB.margin)
    },
    mr: {
        style: (0, $b9zmB.margin)
    },
    mb: {
        style: (0, $b9zmB.margin)
    },
    ml: {
        style: (0, $b9zmB.margin)
    },
    mx: {
        style: (0, $b9zmB.margin)
    },
    my: {
        style: (0, $b9zmB.margin)
    },
    margin: {
        style: (0, $b9zmB.margin)
    },
    marginTop: {
        style: (0, $b9zmB.margin)
    },
    marginRight: {
        style: (0, $b9zmB.margin)
    },
    marginBottom: {
        style: (0, $b9zmB.margin)
    },
    marginLeft: {
        style: (0, $b9zmB.margin)
    },
    marginX: {
        style: (0, $b9zmB.margin)
    },
    marginY: {
        style: (0, $b9zmB.margin)
    },
    marginInline: {
        style: (0, $b9zmB.margin)
    },
    marginInlineStart: {
        style: (0, $b9zmB.margin)
    },
    marginInlineEnd: {
        style: (0, $b9zmB.margin)
    },
    marginBlock: {
        style: (0, $b9zmB.margin)
    },
    marginBlockStart: {
        style: (0, $b9zmB.margin)
    },
    marginBlockEnd: {
        style: (0, $b9zmB.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: function(value) {
            return {
                "@media print": {
                    display: value
                }
            };
        }
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $b5y1T.gap)
    },
    rowGap: {
        style: (0, $b5y1T.rowGap)
    },
    columnGap: {
        style: (0, $b5y1T.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $kgQvE.sizingTransform)
    },
    maxWidth: {
        style: (0, $kgQvE.maxWidth)
    },
    minWidth: {
        transform: (0, $kgQvE.sizingTransform)
    },
    height: {
        transform: (0, $kgQvE.sizingTransform)
    },
    maxHeight: {
        transform: (0, $kgQvE.sizingTransform)
    },
    minHeight: {
        transform: (0, $kgQvE.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $b403bcab2b096541$export$2e2bcd8739ae039 = $b403bcab2b096541$var$defaultSxConfig;

});
parcelRequire.register("4jXpz", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $325705a37aaf6e32$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $325705a37aaf6e32$export$7a57f79000377ca2; });


var $fpsdE = parcelRequire("fpsdE");

var $4lo0a = parcelRequire("4lo0a");

var $b9zmB = parcelRequire("b9zmB");

var $kf05Q = parcelRequire("kf05Q");
function $325705a37aaf6e32$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return "".concat(value, "px solid");
}
var $325705a37aaf6e32$export$1edee58a52776cd9 = (0, $fpsdE.default)({
    prop: "border",
    themeKey: "borders",
    transform: $325705a37aaf6e32$export$34e2febe53ae29cc
});
var $325705a37aaf6e32$export$f9a7b6bd24892946 = (0, $fpsdE.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $325705a37aaf6e32$export$34e2febe53ae29cc
});
var $325705a37aaf6e32$export$5abca33e6be905d2 = (0, $fpsdE.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $325705a37aaf6e32$export$34e2febe53ae29cc
});
var $325705a37aaf6e32$export$e2ce9f12a980a822 = (0, $fpsdE.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $325705a37aaf6e32$export$34e2febe53ae29cc
});
var $325705a37aaf6e32$export$47658cca1a909427 = (0, $fpsdE.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $325705a37aaf6e32$export$34e2febe53ae29cc
});
var $325705a37aaf6e32$export$e7fb0694ba2404fc = (0, $fpsdE.default)({
    prop: "borderColor",
    themeKey: "palette"
});
var $325705a37aaf6e32$export$126a92c968acdb85 = (0, $fpsdE.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
var $325705a37aaf6e32$export$85cc51cb8fbb8c0e = (0, $fpsdE.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
var $325705a37aaf6e32$export$340b0327727f6d1a = (0, $fpsdE.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
var $325705a37aaf6e32$export$60beef91a985b4bf = (0, $fpsdE.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
var $325705a37aaf6e32$export$7a57f79000377ca2 = function(props) {
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        var transformer = (0, $b9zmB.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        var styleFromPropValue = function(propValue) {
            return {
                borderRadius: (0, $b9zmB.getValue)(transformer, propValue)
            };
        };
        return (0, $kf05Q.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$325705a37aaf6e32$export$7a57f79000377ca2.propTypes = {};
$325705a37aaf6e32$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
var $325705a37aaf6e32$var$borders = (0, $4lo0a.default)($325705a37aaf6e32$export$1edee58a52776cd9, $325705a37aaf6e32$export$f9a7b6bd24892946, $325705a37aaf6e32$export$5abca33e6be905d2, $325705a37aaf6e32$export$e2ce9f12a980a822, $325705a37aaf6e32$export$47658cca1a909427, $325705a37aaf6e32$export$e7fb0694ba2404fc, $325705a37aaf6e32$export$126a92c968acdb85, $325705a37aaf6e32$export$85cc51cb8fbb8c0e, $325705a37aaf6e32$export$340b0327727f6d1a, $325705a37aaf6e32$export$60beef91a985b4bf, $325705a37aaf6e32$export$7a57f79000377ca2);
var $325705a37aaf6e32$export$2e2bcd8739ae039 = $325705a37aaf6e32$var$borders;

});
parcelRequire.register("4lo0a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $329bbdd1f5313e99$export$2e2bcd8739ae039; });

var $eSTRY = parcelRequire("eSTRY");
function $329bbdd1f5313e99$var$compose() {
    for(var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++){
        styles[_key] = arguments[_key];
    }
    var handlers = styles.reduce(function(acc, style) {
        style.filterProps.forEach(function(prop) {
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    var fn = function(props) {
        return Object.keys(props).reduce(function(acc, prop) {
            if (handlers[prop]) return (0, $eSTRY.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce(function(acc, style) {
        return acc.concat(style.filterProps);
    }, []);
    return fn;
}
var $329bbdd1f5313e99$export$2e2bcd8739ae039 = $329bbdd1f5313e99$var$compose;

});


parcelRequire.register("b5y1T", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $812a8eea8e15736f$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $812a8eea8e15736f$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $812a8eea8e15736f$export$8a833ffa5f5dbeda; });

var $fpsdE = parcelRequire("fpsdE");

var $4lo0a = parcelRequire("4lo0a");

var $b9zmB = parcelRequire("b9zmB");

var $kf05Q = parcelRequire("kf05Q");

var $812a8eea8e15736f$export$5df9adcb0db95e1e = function(props) {
    if (props.gap !== undefined && props.gap !== null) {
        var transformer = (0, $b9zmB.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        var styleFromPropValue = function(propValue) {
            return {
                gap: (0, $b9zmB.getValue)(transformer, propValue)
            };
        };
        return (0, $kf05Q.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$812a8eea8e15736f$export$5df9adcb0db95e1e.propTypes = {};
$812a8eea8e15736f$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
var $812a8eea8e15736f$export$ec60d70ff941a580 = function(props) {
    if (props.columnGap !== undefined && props.columnGap !== null) {
        var transformer = (0, $b9zmB.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        var styleFromPropValue = function(propValue) {
            return {
                columnGap: (0, $b9zmB.getValue)(transformer, propValue)
            };
        };
        return (0, $kf05Q.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$812a8eea8e15736f$export$ec60d70ff941a580.propTypes = {};
$812a8eea8e15736f$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
var $812a8eea8e15736f$export$8a833ffa5f5dbeda = function(props) {
    if (props.rowGap !== undefined && props.rowGap !== null) {
        var transformer = (0, $b9zmB.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        var styleFromPropValue = function(propValue) {
            return {
                rowGap: (0, $b9zmB.getValue)(transformer, propValue)
            };
        };
        return (0, $kf05Q.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$812a8eea8e15736f$export$8a833ffa5f5dbeda.propTypes = {};
$812a8eea8e15736f$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
var $812a8eea8e15736f$export$baf44164ca3a34e8 = (0, $fpsdE.default)({
    prop: "gridColumn"
});
var $812a8eea8e15736f$export$8f7213a1cd01e832 = (0, $fpsdE.default)({
    prop: "gridRow"
});
var $812a8eea8e15736f$export$b0e0abbc49ba668 = (0, $fpsdE.default)({
    prop: "gridAutoFlow"
});
var $812a8eea8e15736f$export$bcd8b929d4b4142 = (0, $fpsdE.default)({
    prop: "gridAutoColumns"
});
var $812a8eea8e15736f$export$e5039a674e14c828 = (0, $fpsdE.default)({
    prop: "gridAutoRows"
});
var $812a8eea8e15736f$export$42bd9088661ffb03 = (0, $fpsdE.default)({
    prop: "gridTemplateColumns"
});
var $812a8eea8e15736f$export$920682ae05b999bc = (0, $fpsdE.default)({
    prop: "gridTemplateRows"
});
var $812a8eea8e15736f$export$1b88fbdd482fd33a = (0, $fpsdE.default)({
    prop: "gridTemplateAreas"
});
var $812a8eea8e15736f$export$bdb486e40d52d26f = (0, $fpsdE.default)({
    prop: "gridArea"
});
var $812a8eea8e15736f$var$grid = (0, $4lo0a.default)($812a8eea8e15736f$export$5df9adcb0db95e1e, $812a8eea8e15736f$export$ec60d70ff941a580, $812a8eea8e15736f$export$8a833ffa5f5dbeda, $812a8eea8e15736f$export$baf44164ca3a34e8, $812a8eea8e15736f$export$8f7213a1cd01e832, $812a8eea8e15736f$export$b0e0abbc49ba668, $812a8eea8e15736f$export$bcd8b929d4b4142, $812a8eea8e15736f$export$e5039a674e14c828, $812a8eea8e15736f$export$42bd9088661ffb03, $812a8eea8e15736f$export$920682ae05b999bc, $812a8eea8e15736f$export$1b88fbdd482fd33a, $812a8eea8e15736f$export$bdb486e40d52d26f);
var $812a8eea8e15736f$export$2e2bcd8739ae039 = $812a8eea8e15736f$var$grid;

});

parcelRequire.register("4yu9q", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $3511b9c4456b232b$export$dbaffd4420ea0ac6; });

var $fpsdE = parcelRequire("fpsdE");

var $4lo0a = parcelRequire("4lo0a");
function $3511b9c4456b232b$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
var $3511b9c4456b232b$export$35e9368ef982300f = (0, $fpsdE.default)({
    prop: "color",
    themeKey: "palette",
    transform: $3511b9c4456b232b$export$dbaffd4420ea0ac6
});
var $3511b9c4456b232b$export$2506f56c10355b33 = (0, $fpsdE.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $3511b9c4456b232b$export$dbaffd4420ea0ac6
});
var $3511b9c4456b232b$export$8c5a050822fd698c = (0, $fpsdE.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $3511b9c4456b232b$export$dbaffd4420ea0ac6
});
var $3511b9c4456b232b$var$palette = (0, $4lo0a.default)($3511b9c4456b232b$export$35e9368ef982300f, $3511b9c4456b232b$export$2506f56c10355b33, $3511b9c4456b232b$export$8c5a050822fd698c);
var $3511b9c4456b232b$export$2e2bcd8739ae039 = $3511b9c4456b232b$var$palette;

});

parcelRequire.register("kgQvE", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $ec1e088c725e410d$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $ec1e088c725e410d$export$488fda99655ff65a; });

var $fpsdE = parcelRequire("fpsdE");

var $4lo0a = parcelRequire("4lo0a");

var $kf05Q = parcelRequire("kf05Q");
function $ec1e088c725e410d$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? "".concat(value * 100, "%") : value;
}
var $ec1e088c725e410d$export$7e3df82ee760448c = (0, $fpsdE.default)({
    prop: "width",
    transform: $ec1e088c725e410d$export$8afece71750ec241
});
var $ec1e088c725e410d$export$488fda99655ff65a = function(props) {
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        var styleFromPropValue = function(propValue) {
            var _props$theme, _props$theme2;
            var breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $kf05Q.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $ec1e088c725e410d$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: "".concat(breakpoint).concat(props.theme.breakpoints.unit)
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $kf05Q.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$ec1e088c725e410d$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
var $ec1e088c725e410d$export$ee148fbbe8357dd2 = (0, $fpsdE.default)({
    prop: "minWidth",
    transform: $ec1e088c725e410d$export$8afece71750ec241
});
var $ec1e088c725e410d$export$ac607276a8fe9f0a = (0, $fpsdE.default)({
    prop: "height",
    transform: $ec1e088c725e410d$export$8afece71750ec241
});
var $ec1e088c725e410d$export$dc0d8bd0b94f8570 = (0, $fpsdE.default)({
    prop: "maxHeight",
    transform: $ec1e088c725e410d$export$8afece71750ec241
});
var $ec1e088c725e410d$export$a43cf604e12f3b17 = (0, $fpsdE.default)({
    prop: "minHeight",
    transform: $ec1e088c725e410d$export$8afece71750ec241
});
var $ec1e088c725e410d$export$ffed9f14fb65e276 = (0, $fpsdE.default)({
    prop: "size",
    cssProperty: "width",
    transform: $ec1e088c725e410d$export$8afece71750ec241
});
var $ec1e088c725e410d$export$905076ed6620e671 = (0, $fpsdE.default)({
    prop: "size",
    cssProperty: "height",
    transform: $ec1e088c725e410d$export$8afece71750ec241
});
var $ec1e088c725e410d$export$6ccc93f785106a58 = (0, $fpsdE.default)({
    prop: "boxSizing"
});
var $ec1e088c725e410d$var$sizing = (0, $4lo0a.default)($ec1e088c725e410d$export$7e3df82ee760448c, $ec1e088c725e410d$export$488fda99655ff65a, $ec1e088c725e410d$export$ee148fbbe8357dd2, $ec1e088c725e410d$export$ac607276a8fe9f0a, $ec1e088c725e410d$export$dc0d8bd0b94f8570, $ec1e088c725e410d$export$a43cf604e12f3b17, $ec1e088c725e410d$export$6ccc93f785106a58);
var $ec1e088c725e410d$export$2e2bcd8739ae039 = $ec1e088c725e410d$var$sizing;

});




parcelRequire.register("40DmL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2eb5b2cba07ed3dc$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
parcelRequire("e1IhQ");
var $dltLJ = parcelRequire("dltLJ");
"use client";
function $2eb5b2cba07ed3dc$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $2eb5b2cba07ed3dc$var$useTheme() {
    var defaultTheme = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var contextTheme = $3aC2T.useContext((0, $dltLJ.T));
    return !contextTheme || $2eb5b2cba07ed3dc$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $2eb5b2cba07ed3dc$export$2e2bcd8739ae039 = $2eb5b2cba07ed3dc$var$useTheme;

});
parcelRequire.register("e1IhQ", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $a363831a836b5619$export$98f03c5d19621d70; });
$parcel$export(module.exports, "keyframes", function () { return $a363831a836b5619$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("dltLJ")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("dltLJ")).w; });

var $qb7pP = parcelRequire("qb7pP");

var $dltLJ = parcelRequire("dltLJ");

var $3aC2T = parcelRequire("3aC2T");

var $7GAnB = parcelRequire("7GAnB");

var $30yNu = parcelRequire("30yNu");

var $bgQcD = parcelRequire("bgQcD");
parcelRequire("4bdpy");
parcelRequire("l82yu");
parcelRequire("6Rp72");

parcelRequire("6Sh9t");
var $a363831a836b5619$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $a363831a836b5619$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $dltLJ.h).call(props, "css")) // $FlowFixMe
    return $3aC2T.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $dltLJ.E);
    createElementArgArray[1] = (0, $dltLJ.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $3aC2T.createElement.apply(null, createElementArgArray);
};
var $a363831a836b5619$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $a363831a836b5619$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $dltLJ.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $bgQcD.serializeStyles)([
        styles
    ], undefined, $3aC2T.useContext((0, $dltLJ.T)));
    if (!(0, $dltLJ.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $3aC2T.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $3aC2T.useRef();
    (0, $30yNu.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $30yNu.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $7GAnB.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $a363831a836b5619$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $bgQcD.serializeStyles)(args);
}
var $a363831a836b5619$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $a363831a836b5619$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $a363831a836b5619$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg === "undefined" ? "undefined" : (0, $qb7pP._)(arg)){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $a363831a836b5619$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $7GAnB.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $a363831a836b5619$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $30yNu.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $7GAnB.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $a363831a836b5619$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $dltLJ.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $bgQcD.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $7GAnB.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $a363831a836b5619$var$merge(cache.registered, css, $a363831a836b5619$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $3aC2T.useContext((0, $dltLJ.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $3aC2T.createElement($3aC2T.Fragment, null, /*#__PURE__*/ $3aC2T.createElement($a363831a836b5619$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $a363831a836b5619$var$isBrowser, $a363831a836b5619$var$isTestEnv, $a363831a836b5619$var$globalContext, $a363831a836b5619$var$globalKey;

});
parcelRequire.register("dltLJ", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $9b7453fbf9db6595$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $9b7453fbf9db6595$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $9b7453fbf9db6595$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $9b7453fbf9db6595$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $9b7453fbf9db6595$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $9b7453fbf9db6595$export$a9c23c6ac3fc3eca; });

var $3aC2T = parcelRequire("3aC2T");

var $4bdpy = parcelRequire("4bdpy");

var $3hDKy = parcelRequire("3hDKy");

var $6Rp72 = parcelRequire("6Rp72");

var $aohox = parcelRequire("aohox");

var $7GAnB = parcelRequire("7GAnB");

var $bgQcD = parcelRequire("bgQcD");

var $30yNu = parcelRequire("30yNu");
var $9b7453fbf9db6595$export$23f2a1d2818174ef = true;
var $9b7453fbf9db6595$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $9b7453fbf9db6595$var$EmotionCacheContext = /* #__PURE__ */ $3aC2T.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $4bdpy.default)({
    key: "css"
}) : null);
var $9b7453fbf9db6595$export$e7094788287c5e9b = $9b7453fbf9db6595$var$EmotionCacheContext.Provider;
var $9b7453fbf9db6595$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $3aC2T.useContext)($9b7453fbf9db6595$var$EmotionCacheContext);
};
var $9b7453fbf9db6595$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $3aC2T.useContext)($9b7453fbf9db6595$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$9b7453fbf9db6595$export$23f2a1d2818174ef) $9b7453fbf9db6595$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $3aC2T.useContext)($9b7453fbf9db6595$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $4bdpy.default)({
                key: "css"
            });
            return /*#__PURE__*/ $3aC2T.createElement($9b7453fbf9db6595$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $9b7453fbf9db6595$export$971d5caa766a69d7 = /* #__PURE__ */ $3aC2T.createContext({});
var $9b7453fbf9db6595$export$3b14a55fb2447963 = function useTheme() {
    return $3aC2T.useContext($9b7453fbf9db6595$export$971d5caa766a69d7);
};
var $9b7453fbf9db6595$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $3hDKy.default)({}, outerTheme, theme);
};
var $9b7453fbf9db6595$var$createCacheWithTheme = /* #__PURE__ */ (0, $6Rp72.default)(function(outerTheme) {
    return (0, $6Rp72.default)(function(theme) {
        return $9b7453fbf9db6595$var$getTheme(outerTheme, theme);
    });
});
var $9b7453fbf9db6595$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $3aC2T.useContext($9b7453fbf9db6595$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $9b7453fbf9db6595$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $3aC2T.createElement($9b7453fbf9db6595$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $9b7453fbf9db6595$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $3aC2T.useContext($9b7453fbf9db6595$export$971d5caa766a69d7);
        return /*#__PURE__*/ $3aC2T.createElement(Component, (0, $3hDKy.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $3aC2T.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $aohox.default)(WithTheme, Component);
}
var $9b7453fbf9db6595$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $9b7453fbf9db6595$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $9b7453fbf9db6595$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $9b7453fbf9db6595$var$getLastPart(match[1]);
    return undefined;
};
var $9b7453fbf9db6595$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $9b7453fbf9db6595$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $9b7453fbf9db6595$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $9b7453fbf9db6595$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($9b7453fbf9db6595$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $9b7453fbf9db6595$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $9b7453fbf9db6595$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $9b7453fbf9db6595$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $9b7453fbf9db6595$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($9b7453fbf9db6595$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$9b7453fbf9db6595$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $9b7453fbf9db6595$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7GAnB.registerStyles)(cache, serialized, isStringTag);
    (0, $30yNu.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7GAnB.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $9b7453fbf9db6595$var$Emotion = /* #__PURE__ */ $9b7453fbf9db6595$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$9b7453fbf9db6595$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $7GAnB.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $bgQcD.serializeStyles)(registeredStyles, undefined, $3aC2T.useContext($9b7453fbf9db6595$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($9b7453fbf9db6595$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $9b7453fbf9db6595$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $3aC2T.createElement($3aC2T.Fragment, null, /*#__PURE__*/ $3aC2T.createElement($9b7453fbf9db6595$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $3aC2T.createElement(WrappedComponent, newProps));
});
var $9b7453fbf9db6595$export$a9c23c6ac3fc3eca = $9b7453fbf9db6595$var$Emotion;

});
parcelRequire.register("4bdpy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30b297af278fcdcc$export$2e2bcd8739ae039; });

var $hCFUf = parcelRequire("hCFUf");

var $1hq8f = parcelRequire("1hq8f");
parcelRequire("6Rp72");
parcelRequire("ieQbk");
var $30b297af278fcdcc$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $1hq8f.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $1hq8f.token)(character)) break;
        (0, $1hq8f.next)();
    }
    return (0, $1hq8f.slice)(begin, (0, $1hq8f.position));
};
var $30b297af278fcdcc$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $1hq8f.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $1hq8f.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $30b297af278fcdcc$var$identifierWithPointTracking((0, $1hq8f.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $1hq8f.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $1hq8f.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $1hq8f.from)(character);
    }
    while (character = (0, $1hq8f.next)());
    return parsed;
};
var $30b297af278fcdcc$var$getRules = function getRules(value, points) {
    return (0, $1hq8f.dealloc)($30b297af278fcdcc$var$toRules((0, $1hq8f.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $30b297af278fcdcc$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $30b297af278fcdcc$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$30b297af278fcdcc$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $30b297af278fcdcc$var$fixedElements.set(element, true);
    var points = [];
    var rules = $30b297af278fcdcc$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $30b297af278fcdcc$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $30b297af278fcdcc$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $30b297af278fcdcc$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($30b297af278fcdcc$var$ignoreFlag) > -1;
};
var $30b297af278fcdcc$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($30b297af278fcdcc$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $30b297af278fcdcc$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $30b297af278fcdcc$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$30b297af278fcdcc$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $30b297af278fcdcc$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $30b297af278fcdcc$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$30b297af278fcdcc$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $30b297af278fcdcc$var$nullifyElement(element);
    } else if ($30b297af278fcdcc$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $30b297af278fcdcc$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $30b297af278fcdcc$var$prefix(value, length) {
    switch((0, $1hq8f.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $1hq8f.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $1hq8f.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MOZ) + value + (0, $1hq8f.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + value + value;
        // order
        case 6165:
            return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.replace)(value, /(\w+).+(:[^]+)/, (0, $1hq8f.WEBKIT) + "box-$1$2" + (0, $1hq8f.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + "flex-item-" + (0, $1hq8f.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + "flex-line-pack" + (0, $1hq8f.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + (0, $1hq8f.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + (0, $1hq8f.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $1hq8f.WEBKIT) + "box-" + (0, $1hq8f.replace)(value, "-grow", "") + (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + (0, $1hq8f.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $1hq8f.WEBKIT) + (0, $1hq8f.replace)(value, /([^-])(transform)/g, "$1" + (0, $1hq8f.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $1hq8f.replace)((0, $1hq8f.replace)((0, $1hq8f.replace)(value, /(zoom-|grab)/, (0, $1hq8f.WEBKIT) + "$1"), /(image-set)/, (0, $1hq8f.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $1hq8f.replace)(value, /(image-set\([^]*)/, (0, $1hq8f.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $1hq8f.replace)((0, $1hq8f.replace)(value, /(.+:)(flex-)?(.*)/, (0, $1hq8f.WEBKIT) + "box-pack:$3" + (0, $1hq8f.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $1hq8f.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $1hq8f.replace)(value, /(.+)-inline(.+)/, (0, $1hq8f.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $1hq8f.strlen)(value) - 1 - length > 6) switch((0, $1hq8f.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $1hq8f.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $1hq8f.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $1hq8f.WEBKIT) + "$2-$3" + "$1" + (0, $1hq8f.MOZ) + ((0, $1hq8f.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $1hq8f.indexof)(value, "stretch") ? $30b297af278fcdcc$var$prefix((0, $1hq8f.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $1hq8f.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $1hq8f.charat)(value, (0, $1hq8f.strlen)(value) - 3 - (~(0, $1hq8f.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $1hq8f.replace)(value, ":", ":" + (0, $1hq8f.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $1hq8f.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $1hq8f.WEBKIT) + ((0, $1hq8f.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $1hq8f.WEBKIT) + "$2$3" + "$1" + (0, $1hq8f.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $1hq8f.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + (0, $1hq8f.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + (0, $1hq8f.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + (0, $1hq8f.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $1hq8f.WEBKIT) + value + (0, $1hq8f.MS) + value + value;
    }
    return value;
}
var $30b297af278fcdcc$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $1hq8f.DECLARATION:
                element["return"] = $30b297af278fcdcc$var$prefix(element.value, element.length);
                break;
            case 0, $1hq8f.KEYFRAMES:
                return (0, $1hq8f.serialize)([
                    (0, $1hq8f.copy)(element, {
                        value: (0, $1hq8f.replace)(element.value, "@", "@" + (0, $1hq8f.WEBKIT))
                    })
                ], callback);
            case 0, $1hq8f.RULESET:
                if (element.length) return (0, $1hq8f.combine)(element.props, function(value) {
                    switch((0, $1hq8f.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $1hq8f.serialize)([
                                (0, $1hq8f.copy)(element, {
                                    props: [
                                        (0, $1hq8f.replace)(value, /:(read-\w+)/, ":" + (0, $1hq8f.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $1hq8f.serialize)([
                                (0, $1hq8f.copy)(element, {
                                    props: [
                                        (0, $1hq8f.replace)(value, /:(plac\w+)/, ":" + (0, $1hq8f.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $1hq8f.copy)(element, {
                                    props: [
                                        (0, $1hq8f.replace)(value, /:(plac\w+)/, ":" + (0, $1hq8f.MOZ) + "$1")
                                    ]
                                }),
                                (0, $1hq8f.copy)(element, {
                                    props: [
                                        (0, $1hq8f.replace)(value, /:(plac\w+)/, (0, $1hq8f.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $30b297af278fcdcc$var$defaultStylisPlugins = [
    $30b297af278fcdcc$var$prefixer
];
var $30b297af278fcdcc$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $30b297af278fcdcc$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $30b297af278fcdcc$var$compat,
        $30b297af278fcdcc$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $1hq8f.stringify),
        (0, $1hq8f.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $1hq8f.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $1hq8f.serialize)((0, $1hq8f.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $hCFUf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRequire.register("hCFUf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $cd467dffc468727d$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $cd467dffc468727d$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $cd467dffc468727d$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $cd467dffc468727d$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    var StyleSheet = // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    };
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($cd467dffc468727d$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $cd467dffc468727d$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("1hq8f", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $65b85aae980709ad$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $65b85aae980709ad$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $65b85aae980709ad$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $65b85aae980709ad$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $65b85aae980709ad$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $65b85aae980709ad$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $65b85aae980709ad$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $65b85aae980709ad$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $65b85aae980709ad$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $65b85aae980709ad$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $65b85aae980709ad$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $65b85aae980709ad$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $65b85aae980709ad$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $65b85aae980709ad$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $65b85aae980709ad$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $65b85aae980709ad$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $65b85aae980709ad$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $65b85aae980709ad$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $65b85aae980709ad$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $65b85aae980709ad$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $65b85aae980709ad$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $65b85aae980709ad$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $65b85aae980709ad$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $65b85aae980709ad$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $65b85aae980709ad$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $65b85aae980709ad$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $65b85aae980709ad$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $65b85aae980709ad$export$38bcb760f1d4871c; });
var $65b85aae980709ad$export$71ad59f2e432cfe8 = "-ms-";
var $65b85aae980709ad$export$2c0f367103c8d01c = "-moz-";
var $65b85aae980709ad$export$39dfd62a25e0fe93 = "-webkit-";
var $65b85aae980709ad$export$a29989082612d0d9 = "comm";
var $65b85aae980709ad$export$aa3a2e812ca8570d = "rule";
var $65b85aae980709ad$export$527d108ccf083c2b = "decl";
var $65b85aae980709ad$export$d3d35020fa5b54f0 = "@page";
var $65b85aae980709ad$export$500415a86c544f73 = "@media";
var $65b85aae980709ad$export$a763edbf796b780a = "@import";
var $65b85aae980709ad$export$2790aeb8b4e5c826 = "@charset";
var $65b85aae980709ad$export$1cc683e23b84b133 = "@viewport";
var $65b85aae980709ad$export$9447a5efea57e862 = "@supports";
var $65b85aae980709ad$export$ef011b4e114b1fba = "@document";
var $65b85aae980709ad$export$6aad947bda0f3f46 = "@namespace";
var $65b85aae980709ad$export$b44a8529a35fcb60 = "@keyframes";
var $65b85aae980709ad$export$2c16de31893252e6 = "@font-face";
var $65b85aae980709ad$export$3d846dd52e150c6f = "@counter-style";
var $65b85aae980709ad$export$22314bfbb57653fe = "@font-feature-values";
var $65b85aae980709ad$export$d773506282b3cfe6 = "@layer";
var $65b85aae980709ad$export$2335f513bbd82c6d = Math.abs;
var $65b85aae980709ad$export$6788812c4e6611e6 = String.fromCharCode;
var $65b85aae980709ad$export$e6e34fd1f2686227 = Object.assign;
function $65b85aae980709ad$export$d6af199866bfb566(e, r) {
    return $65b85aae980709ad$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $65b85aae980709ad$export$a9db5e087081082d(e, 0)) << 2 ^ $65b85aae980709ad$export$a9db5e087081082d(e, 1)) << 2 ^ $65b85aae980709ad$export$a9db5e087081082d(e, 2)) << 2 ^ $65b85aae980709ad$export$a9db5e087081082d(e, 3) : 0;
}
function $65b85aae980709ad$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $65b85aae980709ad$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $65b85aae980709ad$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $65b85aae980709ad$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $65b85aae980709ad$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $65b85aae980709ad$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $65b85aae980709ad$export$36776f635604f274(e) {
    return e.length;
}
function $65b85aae980709ad$export$f9084667e487ed46(e) {
    return e.length;
}
function $65b85aae980709ad$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $65b85aae980709ad$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $65b85aae980709ad$export$53f1d5ea8de3d7c = 1;
var $65b85aae980709ad$export$4e0c71f277ca26b3 = 1;
var $65b85aae980709ad$export$f24224f1c91d8156 = 0;
var $65b85aae980709ad$export$5880b8b5730aff45 = 0;
var $65b85aae980709ad$export$c0306caf338ac095 = 0;
var $65b85aae980709ad$export$30a86d91af8ff6e6 = "";
function $65b85aae980709ad$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $65b85aae980709ad$export$53f1d5ea8de3d7c,
        column: $65b85aae980709ad$export$4e0c71f277ca26b3,
        length: t,
        "return": ""
    };
}
function $65b85aae980709ad$export$784d13d8ee351f07(e, r) {
    return $65b85aae980709ad$export$e6e34fd1f2686227($65b85aae980709ad$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $65b85aae980709ad$export$eba6f6f03b0a92e7() {
    return $65b85aae980709ad$export$c0306caf338ac095;
}
function $65b85aae980709ad$export$232faf9add678146() {
    $65b85aae980709ad$export$c0306caf338ac095 = $65b85aae980709ad$export$5880b8b5730aff45 > 0 ? $65b85aae980709ad$export$a9db5e087081082d($65b85aae980709ad$export$30a86d91af8ff6e6, --$65b85aae980709ad$export$5880b8b5730aff45) : 0;
    if ($65b85aae980709ad$export$4e0c71f277ca26b3--, $65b85aae980709ad$export$c0306caf338ac095 === 10) $65b85aae980709ad$export$4e0c71f277ca26b3 = 1, $65b85aae980709ad$export$53f1d5ea8de3d7c--;
    return $65b85aae980709ad$export$c0306caf338ac095;
}
function $65b85aae980709ad$export$48cfd1e771a65c4f() {
    $65b85aae980709ad$export$c0306caf338ac095 = $65b85aae980709ad$export$5880b8b5730aff45 < $65b85aae980709ad$export$f24224f1c91d8156 ? $65b85aae980709ad$export$a9db5e087081082d($65b85aae980709ad$export$30a86d91af8ff6e6, $65b85aae980709ad$export$5880b8b5730aff45++) : 0;
    if ($65b85aae980709ad$export$4e0c71f277ca26b3++, $65b85aae980709ad$export$c0306caf338ac095 === 10) $65b85aae980709ad$export$4e0c71f277ca26b3 = 1, $65b85aae980709ad$export$53f1d5ea8de3d7c++;
    return $65b85aae980709ad$export$c0306caf338ac095;
}
function $65b85aae980709ad$export$4d3fb11e950abb9e() {
    return $65b85aae980709ad$export$a9db5e087081082d($65b85aae980709ad$export$30a86d91af8ff6e6, $65b85aae980709ad$export$5880b8b5730aff45);
}
function $65b85aae980709ad$export$e88cb2efb12ae807() {
    return $65b85aae980709ad$export$5880b8b5730aff45;
}
function $65b85aae980709ad$export$58adb3bec8346d0f(e, r) {
    return $65b85aae980709ad$export$2f35ab04d2335697($65b85aae980709ad$export$30a86d91af8ff6e6, e, r);
}
function $65b85aae980709ad$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $65b85aae980709ad$export$2de70f21292aac9e(e) {
    return $65b85aae980709ad$export$53f1d5ea8de3d7c = $65b85aae980709ad$export$4e0c71f277ca26b3 = 1, $65b85aae980709ad$export$f24224f1c91d8156 = $65b85aae980709ad$export$36776f635604f274($65b85aae980709ad$export$30a86d91af8ff6e6 = e), $65b85aae980709ad$export$5880b8b5730aff45 = 0, [];
}
function $65b85aae980709ad$export$45918ac1574455b1(e) {
    return $65b85aae980709ad$export$30a86d91af8ff6e6 = "", e;
}
function $65b85aae980709ad$export$410ac95b9ec204b8(e) {
    return $65b85aae980709ad$export$87c2784dc9fc4ab($65b85aae980709ad$export$58adb3bec8346d0f($65b85aae980709ad$export$5880b8b5730aff45 - 1, $65b85aae980709ad$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $65b85aae980709ad$export$660b2ee2d4fb4eff(e) {
    return $65b85aae980709ad$export$45918ac1574455b1($65b85aae980709ad$export$5f8c09e3ae6f64e1($65b85aae980709ad$export$2de70f21292aac9e(e)));
}
function $65b85aae980709ad$export$7af1228ff777d175(e) {
    while($65b85aae980709ad$export$c0306caf338ac095 = $65b85aae980709ad$export$4d3fb11e950abb9e())if ($65b85aae980709ad$export$c0306caf338ac095 < 33) $65b85aae980709ad$export$48cfd1e771a65c4f();
    else break;
    return $65b85aae980709ad$export$9e1725a4cfeada27(e) > 2 || $65b85aae980709ad$export$9e1725a4cfeada27($65b85aae980709ad$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $65b85aae980709ad$export$5f8c09e3ae6f64e1(e) {
    while($65b85aae980709ad$export$48cfd1e771a65c4f())switch($65b85aae980709ad$export$9e1725a4cfeada27($65b85aae980709ad$export$c0306caf338ac095)){
        case 0:
            $65b85aae980709ad$export$10d8903dec122b9d($65b85aae980709ad$export$c2ab62c7bf24634($65b85aae980709ad$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $65b85aae980709ad$export$10d8903dec122b9d($65b85aae980709ad$export$410ac95b9ec204b8($65b85aae980709ad$export$c0306caf338ac095), e);
            break;
        default:
            $65b85aae980709ad$export$10d8903dec122b9d($65b85aae980709ad$export$6788812c4e6611e6($65b85aae980709ad$export$c0306caf338ac095), e);
    }
    return e;
}
function $65b85aae980709ad$export$955ba06d119e085e(e, r) {
    while(--r && $65b85aae980709ad$export$48cfd1e771a65c4f())if ($65b85aae980709ad$export$c0306caf338ac095 < 48 || $65b85aae980709ad$export$c0306caf338ac095 > 102 || $65b85aae980709ad$export$c0306caf338ac095 > 57 && $65b85aae980709ad$export$c0306caf338ac095 < 65 || $65b85aae980709ad$export$c0306caf338ac095 > 70 && $65b85aae980709ad$export$c0306caf338ac095 < 97) break;
    return $65b85aae980709ad$export$58adb3bec8346d0f(e, $65b85aae980709ad$export$e88cb2efb12ae807() + (r < 6 && $65b85aae980709ad$export$4d3fb11e950abb9e() == 32 && $65b85aae980709ad$export$48cfd1e771a65c4f() == 32));
}
function $65b85aae980709ad$export$c889f2fcc19dbf12(e) {
    while($65b85aae980709ad$export$48cfd1e771a65c4f())switch($65b85aae980709ad$export$c0306caf338ac095){
        case e:
            return $65b85aae980709ad$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $65b85aae980709ad$export$c889f2fcc19dbf12($65b85aae980709ad$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $65b85aae980709ad$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $65b85aae980709ad$export$48cfd1e771a65c4f();
            break;
    }
    return $65b85aae980709ad$export$5880b8b5730aff45;
}
function $65b85aae980709ad$export$4254d4e2b3745c4c(e, r) {
    while($65b85aae980709ad$export$48cfd1e771a65c4f())if (e + $65b85aae980709ad$export$c0306caf338ac095 === 57) break;
    else if (e + $65b85aae980709ad$export$c0306caf338ac095 === 84 && $65b85aae980709ad$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $65b85aae980709ad$export$58adb3bec8346d0f(r, $65b85aae980709ad$export$5880b8b5730aff45 - 1) + "*" + $65b85aae980709ad$export$6788812c4e6611e6(e === 47 ? e : $65b85aae980709ad$export$48cfd1e771a65c4f());
}
function $65b85aae980709ad$export$c2ab62c7bf24634(e) {
    while(!$65b85aae980709ad$export$9e1725a4cfeada27($65b85aae980709ad$export$4d3fb11e950abb9e()))$65b85aae980709ad$export$48cfd1e771a65c4f();
    return $65b85aae980709ad$export$58adb3bec8346d0f(e, $65b85aae980709ad$export$5880b8b5730aff45);
}
function $65b85aae980709ad$export$ef7acd7185315e22(e) {
    return $65b85aae980709ad$export$45918ac1574455b1($65b85aae980709ad$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $65b85aae980709ad$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $65b85aae980709ad$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $65b85aae980709ad$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $65b85aae980709ad$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($65b85aae980709ad$export$f8e21b1e77979a08(j += $65b85aae980709ad$export$77ad94ebf1c2b9ed($65b85aae980709ad$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $65b85aae980709ad$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $65b85aae980709ad$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $65b85aae980709ad$export$955ba06d119e085e($65b85aae980709ad$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($65b85aae980709ad$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $65b85aae980709ad$export$10d8903dec122b9d($65b85aae980709ad$export$4a34f930e789283c($65b85aae980709ad$export$4254d4e2b3745c4c($65b85aae980709ad$export$48cfd1e771a65c4f(), $65b85aae980709ad$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $65b85aae980709ad$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $65b85aae980709ad$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $65b85aae980709ad$export$36776f635604f274(j) - l) $65b85aae980709ad$export$10d8903dec122b9d(p > 32 ? $65b85aae980709ad$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $65b85aae980709ad$export$f8483753829ec8f3($65b85aae980709ad$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $65b85aae980709ad$export$10d8903dec122b9d(y = $65b85aae980709ad$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $65b85aae980709ad$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $65b85aae980709ad$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $65b85aae980709ad$export$98e6a39c04603d36(e, y, y, n && $65b85aae980709ad$export$10d8903dec122b9d($65b85aae980709ad$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $65b85aae980709ad$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $65b85aae980709ad$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $65b85aae980709ad$export$232faf9add678146() == 125) continue;
            }
            switch(j += $65b85aae980709ad$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($65b85aae980709ad$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($65b85aae980709ad$export$4d3fb11e950abb9e() === 45) j += $65b85aae980709ad$export$410ac95b9ec204b8($65b85aae980709ad$export$48cfd1e771a65c4f());
                    v = $65b85aae980709ad$export$4d3fb11e950abb9e(), o = l = $65b85aae980709ad$export$36776f635604f274(g = j += $65b85aae980709ad$export$c2ab62c7bf24634($65b85aae980709ad$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $65b85aae980709ad$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $65b85aae980709ad$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $65b85aae980709ad$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $65b85aae980709ad$export$2f35ab04d2335697(e, v + 1, v = $65b85aae980709ad$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $65b85aae980709ad$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $65b85aae980709ad$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $65b85aae980709ad$export$35059013cd4a06db(e, r, a, s === 0 ? $65b85aae980709ad$export$aa3a2e812ca8570d : i, f, o, l);
}
function $65b85aae980709ad$export$4a34f930e789283c(e, r, a) {
    return $65b85aae980709ad$export$35059013cd4a06db(e, r, a, $65b85aae980709ad$export$a29989082612d0d9, $65b85aae980709ad$export$6788812c4e6611e6($65b85aae980709ad$export$eba6f6f03b0a92e7()), $65b85aae980709ad$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $65b85aae980709ad$export$f8483753829ec8f3(e, r, a, n) {
    return $65b85aae980709ad$export$35059013cd4a06db(e, r, a, $65b85aae980709ad$export$527d108ccf083c2b, $65b85aae980709ad$export$2f35ab04d2335697(e, 0, n), $65b85aae980709ad$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $65b85aae980709ad$export$82e9f45cca5ba907(n, c, s) {
    switch($65b85aae980709ad$export$d6af199866bfb566(n, c)){
        case 5103:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $65b85aae980709ad$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$2c0f367103c8d01c + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($65b85aae980709ad$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $65b85aae980709ad$export$39dfd62a25e0fe93 + "box-$1$2" + $65b85aae980709ad$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + "flex-item-" + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$65b85aae980709ad$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $65b85aae980709ad$export$71ad59f2e432cfe8 + "grid-row-" + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + "flex-line-pack" + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + "box-" + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, "-grow", "") + $65b85aae980709ad$export$39dfd62a25e0fe93 + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $65b85aae980709ad$export$39dfd62a25e0fe93 + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $65b85aae980709ad$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $65b85aae980709ad$export$77ad94ebf1c2b9ed($65b85aae980709ad$export$77ad94ebf1c2b9ed($65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $65b85aae980709ad$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $65b85aae980709ad$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $65b85aae980709ad$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $65b85aae980709ad$export$77ad94ebf1c2b9ed($65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $65b85aae980709ad$export$39dfd62a25e0fe93 + "box-pack:$3" + $65b85aae980709ad$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $65b85aae980709ad$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$65b85aae980709ad$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $65b85aae980709ad$export$71ad59f2e432cfe8 + "grid-column-align" + $65b85aae980709ad$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $65b85aae980709ad$export$71ad59f2e432cfe8 + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $65b85aae980709ad$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$65b85aae980709ad$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $65b85aae980709ad$export$71ad59f2e432cfe8 + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $65b85aae980709ad$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$65b85aae980709ad$export$f8e21b1e77979a08(s, "span") ? $65b85aae980709ad$export$4659b591c19bdf3d(s, /\d+/) : +$65b85aae980709ad$export$4659b591c19bdf3d(s, /\d+/) - +$65b85aae980709ad$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $65b85aae980709ad$export$71ad59f2e432cfe8 + $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $65b85aae980709ad$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $65b85aae980709ad$export$71ad59f2e432cfe8 + $65b85aae980709ad$export$77ad94ebf1c2b9ed($65b85aae980709ad$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $65b85aae980709ad$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($65b85aae980709ad$export$36776f635604f274(n) - 1 - c > 6) switch($65b85aae980709ad$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($65b85aae980709ad$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $65b85aae980709ad$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $65b85aae980709ad$export$2c0f367103c8d01c + ($65b85aae980709ad$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$65b85aae980709ad$export$f8e21b1e77979a08(n, "stretch") ? $65b85aae980709ad$export$82e9f45cca5ba907($65b85aae980709ad$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $65b85aae980709ad$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $65b85aae980709ad$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($65b85aae980709ad$export$a9db5e087081082d(n, c + 6) === 121) return $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, ":", ":" + $65b85aae980709ad$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($65b85aae980709ad$export$a9db5e087081082d(n, $65b85aae980709ad$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $65b85aae980709ad$export$39dfd62a25e0fe93 + ($65b85aae980709ad$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $65b85aae980709ad$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $65b85aae980709ad$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, ":", ":" + $65b85aae980709ad$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $65b85aae980709ad$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $65b85aae980709ad$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $65b85aae980709ad$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $65b85aae980709ad$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $65b85aae980709ad$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $65b85aae980709ad$export$a763edbf796b780a:
        case $65b85aae980709ad$export$527d108ccf083c2b:
            return e["return"] = e["return"] || e.value;
        case $65b85aae980709ad$export$a29989082612d0d9:
            return "";
        case $65b85aae980709ad$export$b44a8529a35fcb60:
            return e["return"] = e.value + "{" + $65b85aae980709ad$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $65b85aae980709ad$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $65b85aae980709ad$export$36776f635604f274(a = $65b85aae980709ad$export$dfdc1655ccc5b9cb(e.children, t)) ? e["return"] = e.value + "{" + a + "}" : "";
}
function $65b85aae980709ad$export$5a7767152ae0305f(e) {
    var r = $65b85aae980709ad$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $65b85aae980709ad$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r["return"]) e(r);
        }
    };
}
function $65b85aae980709ad$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n["return"]) switch(n.type){
            case $65b85aae980709ad$export$527d108ccf083c2b:
                n["return"] = $65b85aae980709ad$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $65b85aae980709ad$export$b44a8529a35fcb60:
                return $65b85aae980709ad$export$dfdc1655ccc5b9cb([
                    $65b85aae980709ad$export$784d13d8ee351f07(n, {
                        value: $65b85aae980709ad$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $65b85aae980709ad$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $65b85aae980709ad$export$aa3a2e812ca8570d:
                if (n.length) return $65b85aae980709ad$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($65b85aae980709ad$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $65b85aae980709ad$export$dfdc1655ccc5b9cb([
                                $65b85aae980709ad$export$784d13d8ee351f07(n, {
                                    props: [
                                        $65b85aae980709ad$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $65b85aae980709ad$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $65b85aae980709ad$export$dfdc1655ccc5b9cb([
                                $65b85aae980709ad$export$784d13d8ee351f07(n, {
                                    props: [
                                        $65b85aae980709ad$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $65b85aae980709ad$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $65b85aae980709ad$export$784d13d8ee351f07(n, {
                                    props: [
                                        $65b85aae980709ad$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $65b85aae980709ad$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $65b85aae980709ad$export$784d13d8ee351f07(n, {
                                    props: [
                                        $65b85aae980709ad$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $65b85aae980709ad$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $65b85aae980709ad$export$76a88f7de6507443(e) {
    switch(e.type){
        case $65b85aae980709ad$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $65b85aae980709ad$export$1be1fc439b849fdf($65b85aae980709ad$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($65b85aae980709ad$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $65b85aae980709ad$export$2f35ab04d2335697(r, 1, $65b85aae980709ad$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $65b85aae980709ad$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $65b85aae980709ad$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $65b85aae980709ad$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("6Rp72", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4feb2c22b13f36f2$export$2e2bcd8739ae039; });
var $4feb2c22b13f36f2$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRequire.register("ieQbk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d472030208224d82$export$2e2bcd8739ae039; });
function $d472030208224d82$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("aohox", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7909a3878acf7ff7$export$2e2bcd8739ae039; });

var $6Sh9t = parcelRequire("6Sh9t");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $7909a3878acf7ff7$export$2e2bcd8739ae039 = function hoistNonReactStatics(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6Sh9t)))(targetComponent, sourceComponent);
};

});
parcelRequire.register("6Sh9t", function(module, exports) {
"use strict";

var $e0HhP = parcelRequire("e0HhP");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $50151735aee27402$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $50151735aee27402$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $50151735aee27402$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $50151735aee27402$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $50151735aee27402$var$TYPE_STATICS = {};
$50151735aee27402$var$TYPE_STATICS[$e0HhP.ForwardRef] = $50151735aee27402$var$FORWARD_REF_STATICS;
$50151735aee27402$var$TYPE_STATICS[$e0HhP.Memo] = $50151735aee27402$var$MEMO_STATICS;
function $50151735aee27402$var$getStatics(component) {
    // React v16.11 and below
    if ($e0HhP.isMemo(component)) return $50151735aee27402$var$MEMO_STATICS;
     // React v16.12 and above
    return $50151735aee27402$var$TYPE_STATICS[component["$$typeof"]] || $50151735aee27402$var$REACT_STATICS;
}
var $50151735aee27402$var$defineProperty = Object.defineProperty;
var $50151735aee27402$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $50151735aee27402$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $50151735aee27402$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $50151735aee27402$var$getPrototypeOf = Object.getPrototypeOf;
var $50151735aee27402$var$objectPrototype = Object.prototype;
function $50151735aee27402$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($50151735aee27402$var$objectPrototype) {
            var inheritedComponent = $50151735aee27402$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $50151735aee27402$var$objectPrototype) $50151735aee27402$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $50151735aee27402$var$getOwnPropertyNames(sourceComponent);
        if ($50151735aee27402$var$getOwnPropertySymbols) keys = keys.concat($50151735aee27402$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $50151735aee27402$var$getStatics(targetComponent);
        var sourceStatics = $50151735aee27402$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$50151735aee27402$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $50151735aee27402$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $50151735aee27402$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $50151735aee27402$var$hoistNonReactStatics;

});
parcelRequire.register("e0HhP", function(module, exports) {
"use strict";

module.exports = (parcelRequire("V5uyP"));

});
parcelRequire.register("V5uyP", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $0ab99590dcd1d6f1$export$2b8d127b894957b9; }, function (v) { return $0ab99590dcd1d6f1$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $0ab99590dcd1d6f1$export$cea3a54a6425200c; }, function (v) { return $0ab99590dcd1d6f1$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $0ab99590dcd1d6f1$export$a7c73072b1a182ae; }, function (v) { return $0ab99590dcd1d6f1$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $0ab99590dcd1d6f1$export$9f27bc3417b4524d; }, function (v) { return $0ab99590dcd1d6f1$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $0ab99590dcd1d6f1$export$db77ccec0bb4ccac; }, function (v) { return $0ab99590dcd1d6f1$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $0ab99590dcd1d6f1$export$8392c0c9d3dcbd35; }, function (v) { return $0ab99590dcd1d6f1$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0ab99590dcd1d6f1$export$ffb0004e005737fa; }, function (v) { return $0ab99590dcd1d6f1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $0ab99590dcd1d6f1$export$b624eff549462981; }, function (v) { return $0ab99590dcd1d6f1$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $0ab99590dcd1d6f1$export$7897aa7841a5380c; }, function (v) { return $0ab99590dcd1d6f1$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $0ab99590dcd1d6f1$export$602eac185826482c; }, function (v) { return $0ab99590dcd1d6f1$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $0ab99590dcd1d6f1$export$e2c29f18771995cb; }, function (v) { return $0ab99590dcd1d6f1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0ab99590dcd1d6f1$export$5f8d39834fd61797; }, function (v) { return $0ab99590dcd1d6f1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0ab99590dcd1d6f1$export$74bf444e3cd11ea5; }, function (v) { return $0ab99590dcd1d6f1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $0ab99590dcd1d6f1$export$92387174baf9b227; }, function (v) { return $0ab99590dcd1d6f1$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $0ab99590dcd1d6f1$export$ec112efeb987d9c6; }, function (v) { return $0ab99590dcd1d6f1$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $0ab99590dcd1d6f1$export$b706b080d889d2c9; }, function (v) { return $0ab99590dcd1d6f1$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $0ab99590dcd1d6f1$export$5be5a87408f70ddc; }, function (v) { return $0ab99590dcd1d6f1$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $0ab99590dcd1d6f1$export$45a5e7f76e0caa8d; }, function (v) { return $0ab99590dcd1d6f1$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $0ab99590dcd1d6f1$export$455c2e768291efa6; }, function (v) { return $0ab99590dcd1d6f1$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $0ab99590dcd1d6f1$export$9522e17588c12572; }, function (v) { return $0ab99590dcd1d6f1$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $0ab99590dcd1d6f1$export$2110ac352bb060b9; }, function (v) { return $0ab99590dcd1d6f1$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $0ab99590dcd1d6f1$export$56885ab8b9c456ab; }, function (v) { return $0ab99590dcd1d6f1$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $0ab99590dcd1d6f1$export$d927fcb6adf8f9de; }, function (v) { return $0ab99590dcd1d6f1$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $0ab99590dcd1d6f1$export$b82d16f27459e05a; }, function (v) { return $0ab99590dcd1d6f1$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $0ab99590dcd1d6f1$export$522c17b4f5e123e8; }, function (v) { return $0ab99590dcd1d6f1$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $0ab99590dcd1d6f1$export$1aabd8a0274ecfd6; }, function (v) { return $0ab99590dcd1d6f1$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $0ab99590dcd1d6f1$export$9b621391a187a31a; }, function (v) { return $0ab99590dcd1d6f1$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $0ab99590dcd1d6f1$export$f5bbd400c2f4426f; }, function (v) { return $0ab99590dcd1d6f1$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0ab99590dcd1d6f1$export$2b8d127b894957b9;
var $0ab99590dcd1d6f1$export$cea3a54a6425200c;
var $0ab99590dcd1d6f1$export$a7c73072b1a182ae;
var $0ab99590dcd1d6f1$export$9f27bc3417b4524d;
var $0ab99590dcd1d6f1$export$db77ccec0bb4ccac;
var $0ab99590dcd1d6f1$export$8392c0c9d3dcbd35;
var $0ab99590dcd1d6f1$export$ffb0004e005737fa;
var $0ab99590dcd1d6f1$export$b624eff549462981;
var $0ab99590dcd1d6f1$export$7897aa7841a5380c;
var $0ab99590dcd1d6f1$export$602eac185826482c;
var $0ab99590dcd1d6f1$export$e2c29f18771995cb;
var $0ab99590dcd1d6f1$export$5f8d39834fd61797;
var $0ab99590dcd1d6f1$export$74bf444e3cd11ea5;
var $0ab99590dcd1d6f1$export$92387174baf9b227;
var $0ab99590dcd1d6f1$export$ec112efeb987d9c6;
var $0ab99590dcd1d6f1$export$b706b080d889d2c9;
var $0ab99590dcd1d6f1$export$5be5a87408f70ddc;
var $0ab99590dcd1d6f1$export$45a5e7f76e0caa8d;
var $0ab99590dcd1d6f1$export$455c2e768291efa6;
var $0ab99590dcd1d6f1$export$9522e17588c12572;
var $0ab99590dcd1d6f1$export$2110ac352bb060b9;
var $0ab99590dcd1d6f1$export$56885ab8b9c456ab;
var $0ab99590dcd1d6f1$export$d927fcb6adf8f9de;
var $0ab99590dcd1d6f1$export$b82d16f27459e05a;
var $0ab99590dcd1d6f1$export$522c17b4f5e123e8;
var $0ab99590dcd1d6f1$export$1aabd8a0274ecfd6;
var $0ab99590dcd1d6f1$export$9b621391a187a31a;
var $0ab99590dcd1d6f1$export$f5bbd400c2f4426f;
"use strict";
var $0ab99590dcd1d6f1$var$b = "function" === typeof Symbol && Symbol["for"], $0ab99590dcd1d6f1$var$c = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.element") : 60103, $0ab99590dcd1d6f1$var$d = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.portal") : 60106, $0ab99590dcd1d6f1$var$e = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.fragment") : 60107, $0ab99590dcd1d6f1$var$f = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.strict_mode") : 60108, $0ab99590dcd1d6f1$var$g = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.profiler") : 60114, $0ab99590dcd1d6f1$var$h = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.provider") : 60109, $0ab99590dcd1d6f1$var$k = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.context") : 60110, $0ab99590dcd1d6f1$var$l = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.async_mode") : 60111, $0ab99590dcd1d6f1$var$m = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.concurrent_mode") : 60111, $0ab99590dcd1d6f1$var$n = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.forward_ref") : 60112, $0ab99590dcd1d6f1$var$p = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.suspense") : 60113, $0ab99590dcd1d6f1$var$q = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.suspense_list") : 60120, $0ab99590dcd1d6f1$var$r = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.memo") : 60115, $0ab99590dcd1d6f1$var$t = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.lazy") : 60116, $0ab99590dcd1d6f1$var$v = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.block") : 60121, $0ab99590dcd1d6f1$var$w = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.fundamental") : 60117, $0ab99590dcd1d6f1$var$x = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.responder") : 60118, $0ab99590dcd1d6f1$var$y = $0ab99590dcd1d6f1$var$b ? Symbol["for"]("react.scope") : 60119;
function $0ab99590dcd1d6f1$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $0ab99590dcd1d6f1$var$c:
                switch(a = a.type, a){
                    case $0ab99590dcd1d6f1$var$l:
                    case $0ab99590dcd1d6f1$var$m:
                    case $0ab99590dcd1d6f1$var$e:
                    case $0ab99590dcd1d6f1$var$g:
                    case $0ab99590dcd1d6f1$var$f:
                    case $0ab99590dcd1d6f1$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $0ab99590dcd1d6f1$var$k:
                            case $0ab99590dcd1d6f1$var$n:
                            case $0ab99590dcd1d6f1$var$t:
                            case $0ab99590dcd1d6f1$var$r:
                            case $0ab99590dcd1d6f1$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $0ab99590dcd1d6f1$var$d:
                return u;
        }
    }
}
function $0ab99590dcd1d6f1$var$A(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$m;
}
$0ab99590dcd1d6f1$export$2b8d127b894957b9 = $0ab99590dcd1d6f1$var$l;
$0ab99590dcd1d6f1$export$cea3a54a6425200c = $0ab99590dcd1d6f1$var$m;
$0ab99590dcd1d6f1$export$a7c73072b1a182ae = $0ab99590dcd1d6f1$var$k;
$0ab99590dcd1d6f1$export$9f27bc3417b4524d = $0ab99590dcd1d6f1$var$h;
$0ab99590dcd1d6f1$export$db77ccec0bb4ccac = $0ab99590dcd1d6f1$var$c;
$0ab99590dcd1d6f1$export$8392c0c9d3dcbd35 = $0ab99590dcd1d6f1$var$n;
$0ab99590dcd1d6f1$export$ffb0004e005737fa = $0ab99590dcd1d6f1$var$e;
$0ab99590dcd1d6f1$export$b624eff549462981 = $0ab99590dcd1d6f1$var$t;
$0ab99590dcd1d6f1$export$7897aa7841a5380c = $0ab99590dcd1d6f1$var$r;
$0ab99590dcd1d6f1$export$602eac185826482c = $0ab99590dcd1d6f1$var$d;
$0ab99590dcd1d6f1$export$e2c29f18771995cb = $0ab99590dcd1d6f1$var$g;
$0ab99590dcd1d6f1$export$5f8d39834fd61797 = $0ab99590dcd1d6f1$var$f;
$0ab99590dcd1d6f1$export$74bf444e3cd11ea5 = $0ab99590dcd1d6f1$var$p;
$0ab99590dcd1d6f1$export$92387174baf9b227 = function(a) {
    return $0ab99590dcd1d6f1$var$A(a) || $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$l;
};
$0ab99590dcd1d6f1$export$ec112efeb987d9c6 = $0ab99590dcd1d6f1$var$A;
$0ab99590dcd1d6f1$export$b706b080d889d2c9 = function(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$k;
};
$0ab99590dcd1d6f1$export$5be5a87408f70ddc = function(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$h;
};
$0ab99590dcd1d6f1$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0ab99590dcd1d6f1$var$c;
};
$0ab99590dcd1d6f1$export$455c2e768291efa6 = function(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$n;
};
$0ab99590dcd1d6f1$export$9522e17588c12572 = function(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$e;
};
$0ab99590dcd1d6f1$export$2110ac352bb060b9 = function(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$t;
};
$0ab99590dcd1d6f1$export$56885ab8b9c456ab = function(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$r;
};
$0ab99590dcd1d6f1$export$d927fcb6adf8f9de = function(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$d;
};
$0ab99590dcd1d6f1$export$b82d16f27459e05a = function(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$g;
};
$0ab99590dcd1d6f1$export$522c17b4f5e123e8 = function(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$f;
};
$0ab99590dcd1d6f1$export$1aabd8a0274ecfd6 = function(a) {
    return $0ab99590dcd1d6f1$var$z(a) === $0ab99590dcd1d6f1$var$p;
};
$0ab99590dcd1d6f1$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $0ab99590dcd1d6f1$var$e || a === $0ab99590dcd1d6f1$var$m || a === $0ab99590dcd1d6f1$var$g || a === $0ab99590dcd1d6f1$var$f || a === $0ab99590dcd1d6f1$var$p || a === $0ab99590dcd1d6f1$var$q || "object" === typeof a && null !== a && (a.$$typeof === $0ab99590dcd1d6f1$var$t || a.$$typeof === $0ab99590dcd1d6f1$var$r || a.$$typeof === $0ab99590dcd1d6f1$var$h || a.$$typeof === $0ab99590dcd1d6f1$var$k || a.$$typeof === $0ab99590dcd1d6f1$var$n || a.$$typeof === $0ab99590dcd1d6f1$var$w || a.$$typeof === $0ab99590dcd1d6f1$var$x || a.$$typeof === $0ab99590dcd1d6f1$var$y || a.$$typeof === $0ab99590dcd1d6f1$var$v);
};
$0ab99590dcd1d6f1$export$f5bbd400c2f4426f = $0ab99590dcd1d6f1$var$z;

});




parcelRequire.register("7GAnB", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $5988ace4a0a32dd8$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $5988ace4a0a32dd8$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $5988ace4a0a32dd8$export$6f077d94b33a01aa; });
var $5988ace4a0a32dd8$var$isBrowser = true;
function $5988ace4a0a32dd8$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $5988ace4a0a32dd8$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5988ace4a0a32dd8$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5988ace4a0a32dd8$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5988ace4a0a32dd8$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRequire.register("bgQcD", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $8349aebdf30f259a$export$6321afa313b251b5; });

var $qb7pP = parcelRequire("qb7pP");

var $1za6M = parcelRequire("1za6M");

var $eHfxV = parcelRequire("eHfxV");

var $ieQbk = parcelRequire("ieQbk");
var $8349aebdf30f259a$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $8349aebdf30f259a$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $8349aebdf30f259a$var$hyphenateRegex = /[A-Z]|^ms/g;
var $8349aebdf30f259a$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $8349aebdf30f259a$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $8349aebdf30f259a$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $8349aebdf30f259a$var$processStyleName = /* #__PURE__ */ (0, $ieQbk.default)(function(styleName) {
    return $8349aebdf30f259a$var$isCustomProperty(styleName) ? styleName : styleName.replace($8349aebdf30f259a$var$hyphenateRegex, "-$&").toLowerCase();
});
var $8349aebdf30f259a$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($8349aebdf30f259a$var$animationRegex, function(match, p1, p2) {
                $8349aebdf30f259a$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $8349aebdf30f259a$var$cursor
                };
                return p1;
            });
    }
    if ((0, $eHfxV.default)[key] !== 1 && !$8349aebdf30f259a$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $8349aebdf30f259a$var$contentValuePattern, $8349aebdf30f259a$var$contentValues, $8349aebdf30f259a$var$oldProcessStyleValue, $8349aebdf30f259a$var$msPattern, $8349aebdf30f259a$var$hyphenPattern, $8349aebdf30f259a$var$hyphenatedCache;
var $8349aebdf30f259a$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $8349aebdf30f259a$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation === "undefined" ? "undefined" : (0, $qb7pP._)(interpolation)){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $8349aebdf30f259a$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $8349aebdf30f259a$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $8349aebdf30f259a$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $8349aebdf30f259a$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $8349aebdf30f259a$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $8349aebdf30f259a$var$cursor;
                var result = interpolation(mergedProps);
                $8349aebdf30f259a$var$cursor = previousCursor;
                return $8349aebdf30f259a$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $8349aebdf30f259a$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $8349aebdf30f259a$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($8349aebdf30f259a$var$isProcessableValue(value)) string += $8349aebdf30f259a$var$processStyleName(_key) + ":" + $8349aebdf30f259a$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($8349aebdf30f259a$var$isProcessableValue(value[_i])) string += $8349aebdf30f259a$var$processStyleName(_key) + ":" + $8349aebdf30f259a$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $8349aebdf30f259a$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $8349aebdf30f259a$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $8349aebdf30f259a$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $8349aebdf30f259a$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $8349aebdf30f259a$var$cursor;
var $8349aebdf30f259a$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $8349aebdf30f259a$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $8349aebdf30f259a$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $8349aebdf30f259a$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $8349aebdf30f259a$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $8349aebdf30f259a$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $1za6M.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $8349aebdf30f259a$var$cursor
    };
};

});
parcelRequire.register("1za6M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1240e69fa53217a4$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1240e69fa53217a4$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRequire.register("eHfxV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab3123ffe31eb69d$export$2e2bcd8739ae039; });
var $ab3123ffe31eb69d$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRequire.register("30yNu", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $230c5d2d207134a8$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $230c5d2d207134a8$export$811a713a7276cb9d; });

var $3aC2T = parcelRequire("3aC2T");
var $230c5d2d207134a8$var$syncFallback = function syncFallback(create) {
    return create();
};
var $230c5d2d207134a8$var$useInsertionEffect = $3aC2T.useInsertionEffect ? $3aC2T.useInsertionEffect : false;
var $230c5d2d207134a8$export$db21c7ffa21794e7 = $230c5d2d207134a8$var$useInsertionEffect || $230c5d2d207134a8$var$syncFallback;
var $230c5d2d207134a8$export$811a713a7276cb9d = $230c5d2d207134a8$var$useInsertionEffect || $3aC2T.useLayoutEffect;

});


parcelRequire.register("l82yu", function(module, exports) {
function $f61c53c435f13ec0$var$_extends() {
    module.exports = $f61c53c435f13ec0$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $f61c53c435f13ec0$var$_extends.apply(this, arguments);
}
module.exports = $f61c53c435f13ec0$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRequire.register("fc9Ou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0ff96befbec130c$export$2e2bcd8739ae039; });

var $iA7xR = parcelRequire("iA7xR");
"use client";
var $b0ff96befbec130c$var$defaultTheme = (0, $iA7xR.default)();
var $b0ff96befbec130c$export$2e2bcd8739ae039 = $b0ff96befbec130c$var$defaultTheme;

});
parcelRequire.register("iA7xR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8717119f18b1eeb$export$2e2bcd8739ae039; });

var $dHvbf = parcelRequire("dHvbf");

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $luotc = parcelRequire("luotc");
var $cZvD6 = parcelRequire("cZvD6");

var $2KWlR = parcelRequire("2KWlR");
var $fsdeC = parcelRequire("fsdeC");
var $hQA2V = parcelRequire("hQA2V");


var $g9Ude = parcelRequire("g9Ude");

var $eeOJ3 = parcelRequire("eeOJ3");

var $hCMx4 = parcelRequire("hCMx4");

var $2FWYu = parcelRequire("2FWYu");

var $duWiL = parcelRequire("duWiL");

var $7xRX5 = parcelRequire("7xRX5");
var $d8717119f18b1eeb$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $d8717119f18b1eeb$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var tmp = options.mixins, mixinsInput = tmp === void 0 ? {} : tmp, tmp1 = options.palette, paletteInput = tmp1 === void 0 ? {} : tmp1, tmp2 = options.transitions, transitionsInput = tmp2 === void 0 ? {} : tmp2, tmp3 = options.typography, typographyInput = tmp3 === void 0 ? {} : tmp3, other = (0, $8vpQL.default)(options, $d8717119f18b1eeb$var$_excluded);
    if (options.vars) throw new Error((0, $cZvD6.default)(18));
    var palette = (0, $eeOJ3.default)(paletteInput);
    var systemTheme = (0, $2KWlR.default)(options);
    var muiTheme = (0, $luotc.default)(systemTheme, {
        mixins: (0, $g9Ude.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $2FWYu.default).slice(),
        typography: (0, $hCMx4.default)(palette, typographyInput),
        transitions: (0, $duWiL.default)(transitionsInput),
        zIndex: (0, $3hDKy.default)({}, (0, $7xRX5.default))
    });
    muiTheme = (0, $luotc.default)(muiTheme, other);
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $luotc.default)(acc, argument);
    }, muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $3hDKy.default)({}, (0, $fsdeC.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $hQA2V.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $d8717119f18b1eeb$var$warnedOnce = false;
function $d8717119f18b1eeb$export$c469355549431d9b() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $d8717119f18b1eeb$var$createTheme.apply(void 0, (0, $dHvbf._)(args));
}
var $d8717119f18b1eeb$export$2e2bcd8739ae039 = $d8717119f18b1eeb$var$createTheme;

});
parcelRequire.register("g9Ude", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc3917348ab1bd7a$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $3hDKy = parcelRequire("3hDKy");
function $bc3917348ab1bd7a$export$2e2bcd8739ae039(breakpoints, mixins) {
    var _obj;
    return (0, $3hDKy.default)({
        toolbar: (_obj = {
            minHeight: 56
        }, (0, $2iBlG._)(_obj, breakpoints.up("xs"), {
            "@media (orientation: landscape)": {
                minHeight: 48
            }
        }), (0, $2iBlG._)(_obj, breakpoints.up("sm"), {
            minHeight: 64
        }), _obj)
    }, mixins);
}

});

parcelRequire.register("eeOJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5d9b892010a0738$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $luotc = parcelRequire("luotc");
var $cZvD6 = parcelRequire("cZvD6");

var $6Fcce = parcelRequire("6Fcce");

var $boWaw = parcelRequire("boWaw");

var $3zZOc = parcelRequire("3zZOc");

var $aaMBR = parcelRequire("aaMBR");

var $9s2pe = parcelRequire("9s2pe");

var $k9aL2 = parcelRequire("k9aL2");

var $kHGq8 = parcelRequire("kHGq8");

var $1JRxY = parcelRequire("1JRxY");

var $koQ3W = parcelRequire("koQ3W");
var $a5d9b892010a0738$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
var $a5d9b892010a0738$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $boWaw.default).white,
        "default": (0, $boWaw.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $a5d9b892010a0738$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $boWaw.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        "default": "#121212"
    },
    action: {
        active: (0, $boWaw.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $a5d9b892010a0738$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $6Fcce.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $6Fcce.darken)(intent.main, tonalOffsetDark);
    }
}
function $a5d9b892010a0738$var$getDefaultPrimary() {
    var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light";
    if (mode === "dark") return {
        main: (0, $kHGq8.default)[200],
        light: (0, $kHGq8.default)[50],
        dark: (0, $kHGq8.default)[400]
    };
    return {
        main: (0, $kHGq8.default)[700],
        light: (0, $kHGq8.default)[400],
        dark: (0, $kHGq8.default)[800]
    };
}
function $a5d9b892010a0738$var$getDefaultSecondary() {
    var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light";
    if (mode === "dark") return {
        main: (0, $aaMBR.default)[200],
        light: (0, $aaMBR.default)[50],
        dark: (0, $aaMBR.default)[400]
    };
    return {
        main: (0, $aaMBR.default)[500],
        light: (0, $aaMBR.default)[300],
        dark: (0, $aaMBR.default)[700]
    };
}
function $a5d9b892010a0738$var$getDefaultError() {
    var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light";
    if (mode === "dark") return {
        main: (0, $9s2pe.default)[500],
        light: (0, $9s2pe.default)[300],
        dark: (0, $9s2pe.default)[700]
    };
    return {
        main: (0, $9s2pe.default)[700],
        light: (0, $9s2pe.default)[400],
        dark: (0, $9s2pe.default)[800]
    };
}
function $a5d9b892010a0738$var$getDefaultInfo() {
    var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light";
    if (mode === "dark") return {
        main: (0, $1JRxY.default)[400],
        light: (0, $1JRxY.default)[300],
        dark: (0, $1JRxY.default)[700]
    };
    return {
        main: (0, $1JRxY.default)[700],
        light: (0, $1JRxY.default)[500],
        dark: (0, $1JRxY.default)[900]
    };
}
function $a5d9b892010a0738$var$getDefaultSuccess() {
    var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light";
    if (mode === "dark") return {
        main: (0, $koQ3W.default)[400],
        light: (0, $koQ3W.default)[300],
        dark: (0, $koQ3W.default)[700]
    };
    return {
        main: (0, $koQ3W.default)[800],
        light: (0, $koQ3W.default)[500],
        dark: (0, $koQ3W.default)[900]
    };
}
function $a5d9b892010a0738$var$getDefaultWarning() {
    var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "light";
    if (mode === "dark") return {
        main: (0, $k9aL2.default)[400],
        light: (0, $k9aL2.default)[300],
        dark: (0, $k9aL2.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $k9aL2.default)[500],
        dark: (0, $k9aL2.default)[900]
    };
}
function $a5d9b892010a0738$export$2e2bcd8739ae039(palette) {
    var getContrastText = // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $6Fcce.getContrastRatio)(background, $a5d9b892010a0738$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $a5d9b892010a0738$export$55ce6f3a06c59543.text.primary : $a5d9b892010a0738$export$a43af521ac8c3202.text.primary;
        return contrastText;
    };
    var _palette_mode = palette.mode, mode = _palette_mode === void 0 ? "light" : _palette_mode, _palette_contrastThreshold = palette.contrastThreshold, contrastThreshold = _palette_contrastThreshold === void 0 ? 3 : _palette_contrastThreshold, _palette_tonalOffset = palette.tonalOffset, tonalOffset = _palette_tonalOffset === void 0 ? 0.2 : _palette_tonalOffset, other = (0, $8vpQL.default)(palette, $a5d9b892010a0738$var$_excluded);
    var primary = palette.primary || $a5d9b892010a0738$var$getDefaultPrimary(mode);
    var secondary = palette.secondary || $a5d9b892010a0738$var$getDefaultSecondary(mode);
    var error = palette.error || $a5d9b892010a0738$var$getDefaultError(mode);
    var info = palette.info || $a5d9b892010a0738$var$getDefaultInfo(mode);
    var success = palette.success || $a5d9b892010a0738$var$getDefaultSuccess(mode);
    var warning = palette.warning || $a5d9b892010a0738$var$getDefaultWarning(mode);
    var augmentColor = function(param) {
        var color = param.color, name = param.name, _param_mainShade = param.mainShade, mainShade = _param_mainShade === void 0 ? 500 : _param_mainShade, _param_lightShade = param.lightShade, lightShade = _param_lightShade === void 0 ? 300 : _param_lightShade, _param_darkShade = param.darkShade, darkShade = _param_darkShade === void 0 ? 700 : _param_darkShade;
        color = (0, $3hDKy.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $cZvD6.default)(11, name ? " (".concat(name, ")") : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $cZvD6.default)(12, name ? " (".concat(name, ")") : "", JSON.stringify(color.main)));
        $a5d9b892010a0738$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $a5d9b892010a0738$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var modes = {
        dark: $a5d9b892010a0738$export$55ce6f3a06c59543,
        light: $a5d9b892010a0738$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $luotc.default)((0, $3hDKy.default)({
        // A collection of common colors.
        common: (0, $3hDKy.default)({}, (0, $boWaw.default)),
        // prevent mutable object.
        // The palette mode, can be light or dark.
        mode: mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        // The grey colors.
        grey: (0, $3zZOc.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRequire.register("6Fcce", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $4da0085adaa9ea3e$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $4da0085adaa9ea3e$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $4da0085adaa9ea3e$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $4da0085adaa9ea3e$export$c0816ed86df316af; });

var $cZvD6 = parcelRequire("cZvD6");
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $4da0085adaa9ea3e$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $4da0085adaa9ea3e$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $4da0085adaa9ea3e$var$intToHex(_int) {
    var hex = _int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $4da0085adaa9ea3e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $4da0085adaa9ea3e$export$677b39864803984e($4da0085adaa9ea3e$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $cZvD6.default)(9, color));
    var values = color.substring(marker + 1, color.length - 1);
    var colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $cZvD6.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
var $4da0085adaa9ea3e$export$1b91fc959f7ee5a7 = function(color) {
    var decomposedColor = $4da0085adaa9ea3e$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map(function(val, idx) {
        return decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? "".concat(val, "%") : val;
    }).join(" ");
};
var $4da0085adaa9ea3e$export$427365fc3db6fc5e = function(color, warning) {
    try {
        return $4da0085adaa9ea3e$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $4da0085adaa9ea3e$export$211a73f2b8c10ce4(color) {
    var type = color.type, colorSpace = color.colorSpace;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    if (type.indexOf("color") !== -1) values = "".concat(colorSpace, " ").concat(values.join(" "));
    else values = "".concat(values.join(", "));
    return "".concat(type, "(").concat(values, ")");
}
function $4da0085adaa9ea3e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var values = $4da0085adaa9ea3e$export$677b39864803984e(color).values;
    return "#".concat(values.map(function(n, i) {
        return $4da0085adaa9ea3e$var$intToHex(i === 3 ? Math.round(255 * n) : n);
    }).join(""));
}
function $4da0085adaa9ea3e$export$29fb7152bd3f781a(color) {
    color = $4da0085adaa9ea3e$export$677b39864803984e(color);
    var values = color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function(n) {
        var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $4da0085adaa9ea3e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $4da0085adaa9ea3e$export$c852d90bf7403b62(color) {
    color = $4da0085adaa9ea3e$export$677b39864803984e(color);
    var rgb = color.type === "hsl" || color.type === "hsla" ? $4da0085adaa9ea3e$export$677b39864803984e($4da0085adaa9ea3e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $4da0085adaa9ea3e$export$d061e26956a60b0a(foreground, background) {
    var lumA = $4da0085adaa9ea3e$export$c852d90bf7403b62(foreground);
    var lumB = $4da0085adaa9ea3e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $4da0085adaa9ea3e$export$58f0f39f63f3cf42(color, value) {
    color = $4da0085adaa9ea3e$export$677b39864803984e(color);
    value = $4da0085adaa9ea3e$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = "/".concat(value);
    else color.values[3] = value;
    return $4da0085adaa9ea3e$export$211a73f2b8c10ce4(color);
}
function $4da0085adaa9ea3e$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $4da0085adaa9ea3e$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $4da0085adaa9ea3e$export$4b073707ff63303(color, coefficient) {
    color = $4da0085adaa9ea3e$export$677b39864803984e(color);
    coefficient = $4da0085adaa9ea3e$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $4da0085adaa9ea3e$export$211a73f2b8c10ce4(color);
}
function $4da0085adaa9ea3e$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $4da0085adaa9ea3e$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $4da0085adaa9ea3e$export$c0816ed86df316af(color, coefficient) {
    color = $4da0085adaa9ea3e$export$677b39864803984e(color);
    coefficient = $4da0085adaa9ea3e$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(var i1 = 0; i1 < 3; i1 += 1)color.values[i1] += (1 - color.values[i1]) * coefficient;
    return $4da0085adaa9ea3e$export$211a73f2b8c10ce4(color);
}
function $4da0085adaa9ea3e$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $4da0085adaa9ea3e$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $4da0085adaa9ea3e$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.15;
    return $4da0085adaa9ea3e$export$c852d90bf7403b62(color) > 0.5 ? $4da0085adaa9ea3e$export$4b073707ff63303(color, coefficient) : $4da0085adaa9ea3e$export$c0816ed86df316af(color, coefficient);
}
function $4da0085adaa9ea3e$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $4da0085adaa9ea3e$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});

parcelRequire.register("boWaw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84cf0eac3a5213de$export$2e2bcd8739ae039; });
var $84cf0eac3a5213de$var$common = {
    black: "#000",
    white: "#fff"
};
var $84cf0eac3a5213de$export$2e2bcd8739ae039 = $84cf0eac3a5213de$var$common;

});

parcelRequire.register("3zZOc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29b495e988507d80$export$2e2bcd8739ae039; });
var $29b495e988507d80$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $29b495e988507d80$export$2e2bcd8739ae039 = $29b495e988507d80$var$grey;

});

parcelRequire.register("aaMBR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76808b68764640c2$export$2e2bcd8739ae039; });
var $76808b68764640c2$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $76808b68764640c2$export$2e2bcd8739ae039 = $76808b68764640c2$var$purple;

});

parcelRequire.register("9s2pe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e18985e6beb1eb1$export$2e2bcd8739ae039; });
var $6e18985e6beb1eb1$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $6e18985e6beb1eb1$export$2e2bcd8739ae039 = $6e18985e6beb1eb1$var$red;

});

parcelRequire.register("k9aL2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaacfe29360baf5d$export$2e2bcd8739ae039; });
var $eaacfe29360baf5d$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $eaacfe29360baf5d$export$2e2bcd8739ae039 = $eaacfe29360baf5d$var$orange;

});

parcelRequire.register("kHGq8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f128baa892d9720f$export$2e2bcd8739ae039; });
var $f128baa892d9720f$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $f128baa892d9720f$export$2e2bcd8739ae039 = $f128baa892d9720f$var$blue;

});

parcelRequire.register("1JRxY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $144387b89f65ae6d$export$2e2bcd8739ae039; });
var $144387b89f65ae6d$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $144387b89f65ae6d$export$2e2bcd8739ae039 = $144387b89f65ae6d$var$lightBlue;

});

parcelRequire.register("koQ3W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed9e6f0e427992d5$export$2e2bcd8739ae039; });
var $ed9e6f0e427992d5$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $ed9e6f0e427992d5$export$2e2bcd8739ae039 = $ed9e6f0e427992d5$var$green;

});


parcelRequire.register("hCMx4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd4ba1d18c289428$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $luotc = parcelRequire("luotc");
var $cd4ba1d18c289428$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $cd4ba1d18c289428$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $cd4ba1d18c289428$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $cd4ba1d18c289428$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $cd4ba1d18c289428$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref_fontFamily = _ref.fontFamily, fontFamily = _ref_fontFamily === void 0 ? $cd4ba1d18c289428$var$defaultFontFamily : _ref_fontFamily, _ref_fontSize = _ref.// The default font size of the Material Specification.
    fontSize, fontSize = _ref_fontSize === void 0 ? 14 : _ref_fontSize, _ref_fontWeightLight = _ref.// px
    fontWeightLight, fontWeightLight = _ref_fontWeightLight === void 0 ? 300 : _ref_fontWeightLight, _ref_fontWeightRegular = _ref.fontWeightRegular, fontWeightRegular = _ref_fontWeightRegular === void 0 ? 400 : _ref_fontWeightRegular, _ref_fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref_fontWeightMedium === void 0 ? 500 : _ref_fontWeightMedium, _ref_fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref_fontWeightBold === void 0 ? 700 : _ref_fontWeightBold, _ref_htmlFontSize = _ref.// Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize, htmlFontSize = _ref_htmlFontSize === void 0 ? 16 : _ref_htmlFontSize, // Apply the CSS properties to all the variants.
    allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $8vpQL.default)(_ref, $cd4ba1d18c289428$var$_excluded);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $3hDKy.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $cd4ba1d18c289428$var$defaultFontFamily ? {
            letterSpacing: "".concat($cd4ba1d18c289428$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $cd4ba1d18c289428$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $cd4ba1d18c289428$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $luotc.default)((0, $3hDKy.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("2FWYu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f2d284234a74c0d$export$2e2bcd8739ae039; });
var $1f2d284234a74c0d$var$shadowKeyUmbraOpacity = 0.2;
var $1f2d284234a74c0d$var$shadowKeyPenumbraOpacity = 0.14;
var $1f2d284234a74c0d$var$shadowAmbientShadowOpacity = 0.12;
function $1f2d284234a74c0d$var$createShadow() {
    for(var _len = arguments.length, px = new Array(_len), _key = 0; _key < _len; _key++){
        px[_key] = arguments[_key];
    }
    return [
        "".concat(px[0], "px ").concat(px[1], "px ").concat(px[2], "px ").concat(px[3], "px rgba(0,0,0,").concat($1f2d284234a74c0d$var$shadowKeyUmbraOpacity, ")"),
        "".concat(px[4], "px ").concat(px[5], "px ").concat(px[6], "px ").concat(px[7], "px rgba(0,0,0,").concat($1f2d284234a74c0d$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(px[8], "px ").concat(px[9], "px ").concat(px[10], "px ").concat(px[11], "px rgba(0,0,0,").concat($1f2d284234a74c0d$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $1f2d284234a74c0d$var$shadows = [
    "none",
    $1f2d284234a74c0d$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $1f2d284234a74c0d$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $1f2d284234a74c0d$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $1f2d284234a74c0d$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $1f2d284234a74c0d$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $1f2d284234a74c0d$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $1f2d284234a74c0d$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $1f2d284234a74c0d$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $1f2d284234a74c0d$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $1f2d284234a74c0d$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $1f2d284234a74c0d$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $1f2d284234a74c0d$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $1f2d284234a74c0d$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $1f2d284234a74c0d$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $1f2d284234a74c0d$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $1f2d284234a74c0d$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $1f2d284234a74c0d$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $1f2d284234a74c0d$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $1f2d284234a74c0d$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $1f2d284234a74c0d$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $1f2d284234a74c0d$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $1f2d284234a74c0d$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $1f2d284234a74c0d$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $1f2d284234a74c0d$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $1f2d284234a74c0d$export$2e2bcd8739ae039 = $1f2d284234a74c0d$var$shadows;

});

parcelRequire.register("duWiL", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $9d3b4d2d62fe4589$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $9d3b4d2d62fe4589$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");
var $9d3b4d2d62fe4589$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
var $9d3b4d2d62fe4589$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
var $9d3b4d2d62fe4589$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $9d3b4d2d62fe4589$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
function $9d3b4d2d62fe4589$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    var constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
function $9d3b4d2d62fe4589$export$2e2bcd8739ae039(inputTransitions) {
    var mergedEasing = (0, $3hDKy.default)({}, $9d3b4d2d62fe4589$export$24c5ac7c37452e7d, inputTransitions.easing);
    var mergedDuration = (0, $3hDKy.default)({}, $9d3b4d2d62fe4589$export$1f34108aa9eb96ab, inputTransitions.duration);
    var create = function() {
        var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            "all"
        ], options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.duration, durationOption = tmp === void 0 ? mergedDuration.standard : tmp, tmp1 = options.easing, easingOption = tmp1 === void 0 ? mergedEasing.easeInOut : tmp1, _options_delay = options.delay, delay = _options_delay === void 0 ? 0 : _options_delay, other = (0, $8vpQL.default)(options, $9d3b4d2d62fe4589$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $9d3b4d2d62fe4589$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $9d3b4d2d62fe4589$var$formatMs(delay));
        }).join(",");
    };
    return (0, $3hDKy.default)({
        getAutoHeightDuration: $9d3b4d2d62fe4589$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRequire.register("7xRX5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57e5773d37cbe505$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $57e5773d37cbe505$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $57e5773d37cbe505$export$2e2bcd8739ae039 = $57e5773d37cbe505$var$zIndex;

});



parcelRequire.register("gH0Wp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c271645d70e7da03$export$2e2bcd8739ae039; });
var $c271645d70e7da03$export$2e2bcd8739ae039 = "$$material";

});


parcelRequire.register("gSv8W", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $c499d8e3fd98f05b$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $c499d8e3fd98f05b$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $c499d8e3fd98f05b$export$2e2bcd8739ae039; });

var $iZmEG = parcelRequire("iZmEG");

var $fc9Ou = parcelRequire("fc9Ou");

var $gH0Wp = parcelRequire("gH0Wp");
"use client";
var $c499d8e3fd98f05b$export$effb20ecdbf4d6aa = function(prop) {
    return (0, $iZmEG.shouldForwardProp)(prop) && prop !== "classes";
};
var $c499d8e3fd98f05b$export$f10c5a10d27438e5 = (0, $iZmEG.shouldForwardProp);
var $c499d8e3fd98f05b$var$styled = (0, $iZmEG.default)({
    themeId: (0, $gH0Wp.default),
    defaultTheme: (0, $fc9Ou.default),
    rootShouldForwardProp: $c499d8e3fd98f05b$export$effb20ecdbf4d6aa
});
var $c499d8e3fd98f05b$export$2e2bcd8739ae039 = $c499d8e3fd98f05b$var$styled;

});
parcelRequire.register("iZmEG", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $dd2f7f5b81d63f76$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $dd2f7f5b81d63f76$export$2e2bcd8739ae039; });

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $LUxKr = parcelRequire("LUxKr");


var $2KWlR = parcelRequire("2KWlR");

var $925dm = parcelRequire("925dm");

var $hQA2V = parcelRequire("hQA2V");
var $dd2f7f5b81d63f76$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $dd2f7f5b81d63f76$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $dd2f7f5b81d63f76$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
var $dd2f7f5b81d63f76$var$getStyleOverrides = function(name, theme) {
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
var $dd2f7f5b81d63f76$var$getVariantStyles = function(name, theme) {
    var variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    var variantsStyles = {};
    variants.forEach(function(definition) {
        var key = (0, $925dm.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
var $dd2f7f5b81d63f76$var$variantsResolver = function(props, styles, theme, name) {
    var _theme$components;
    var _props_ownerState = props.ownerState, ownerState = _props_ownerState === void 0 ? {} : _props_ownerState;
    var variantsStyles = [];
    var themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
    if (themeVariants) themeVariants.forEach(function(themeVariant) {
        var isMatch = true;
        Object.keys(themeVariant.props).forEach(function(key) {
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $925dm.default)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $dd2f7f5b81d63f76$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $dd2f7f5b81d63f76$export$35e57303dbd8a66 = (0, $2KWlR.default)();
var $dd2f7f5b81d63f76$var$lowercaseFirstLetter = function(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $dd2f7f5b81d63f76$var$resolveTheme(param) {
    var defaultTheme = param.defaultTheme, theme = param.theme, themeId = param.themeId;
    return $dd2f7f5b81d63f76$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $dd2f7f5b81d63f76$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return function(props, styles) {
        return styles[slot];
    };
}
function $dd2f7f5b81d63f76$export$2e2bcd8739ae039() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var themeId = input.themeId, _input_defaultTheme = input.defaultTheme, defaultTheme = _input_defaultTheme === void 0 ? $dd2f7f5b81d63f76$export$35e57303dbd8a66 : _input_defaultTheme, _input_rootShouldForwardProp = input.rootShouldForwardProp, rootShouldForwardProp = _input_rootShouldForwardProp === void 0 ? $dd2f7f5b81d63f76$export$3ba67b570e26eea0 : _input_rootShouldForwardProp, _input_slotShouldForwardProp = input.slotShouldForwardProp, slotShouldForwardProp = _input_slotShouldForwardProp === void 0 ? $dd2f7f5b81d63f76$export$3ba67b570e26eea0 : _input_slotShouldForwardProp;
    var systemSx = function(props) {
        return (0, $hQA2V.default)((0, $3hDKy.default)({}, props, {
            theme: $dd2f7f5b81d63f76$var$resolveTheme((0, $3hDKy.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return function(tag) {
        var inputOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $LUxKr.internal_processStyles)(tag, function(styles) {
            return styles.filter(function(style) {
                return !(style != null && style.__mui_systemSx);
            });
        });
        var componentName = inputOptions.name, componentSlot = inputOptions.slot, inputSkipVariantsResolver = inputOptions.skipVariantsResolver, inputSkipSx = inputOptions.skipSx, _inputOptions_overridesResolver = inputOptions.// TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver, overridesResolver = _inputOptions_overridesResolver === void 0 ? $dd2f7f5b81d63f76$var$defaultOverridesResolver($dd2f7f5b81d63f76$var$lowercaseFirstLetter(componentSlot)) : _inputOptions_overridesResolver, options = (0, $8vpQL.default)(inputOptions, $dd2f7f5b81d63f76$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        var skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        var skipSx = inputSkipSx || false;
        var label;
        var shouldForwardPropOption = $dd2f7f5b81d63f76$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($dd2f7f5b81d63f76$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        var defaultStyledResolver = (0, $LUxKr.default)(tag, (0, $3hDKy.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        var muiStyledResolver = function(styleArg) {
            for(var _len = arguments.length, expressions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                expressions[_key - 1] = arguments[_key];
            }
            var expressionsWithDefaultTheme = expressions ? expressions.map(function(stylesArg) {
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? function(props) {
                    return stylesArg((0, $3hDKy.default)({}, props, {
                        theme: $dd2f7f5b81d63f76$var$resolveTheme((0, $3hDKy.default)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            var transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push(function(props) {
                var theme = $dd2f7f5b81d63f76$var$resolveTheme((0, $3hDKy.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                var styleOverrides = $dd2f7f5b81d63f76$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    var resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(function(param) {
                        var _param = (0, $aSMts._)(param, 2), slotKey = _param[0], slotStyle = _param[1];
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $3hDKy.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push(function(props) {
                var theme = $dd2f7f5b81d63f76$var$resolveTheme((0, $3hDKy.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $dd2f7f5b81d63f76$var$variantsResolver(props, $dd2f7f5b81d63f76$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            var numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                var placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = (0, $dHvbf._)(styleArg).concat((0, $dHvbf._)(placeholders));
                transformedStyleArg.raw = (0, $dHvbf._)(styleArg.raw).concat((0, $dHvbf._)(placeholders));
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = function(props) {
                return styleArg((0, $3hDKy.default)({}, props, {
                    theme: $dd2f7f5b81d63f76$var$resolveTheme((0, $3hDKy.default)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            };
            var Component = defaultStyledResolver.apply(void 0, [
                transformedStyleArg
            ].concat((0, $dHvbf._)(expressionsWithDefaultTheme)));
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRequire.register("LUxKr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0900403a30f72792$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $0900403a30f72792$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.14.10
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $aXQnW = parcelRequire("aXQnW");
parcelRequire("e1IhQ");
var $dltLJ = parcelRequire("dltLJ");
var $e1IhQ = parcelRequire("e1IhQ");


var $7xThp = parcelRequire("7xThp");
"use client";
function $0900403a30f72792$export$2e2bcd8739ae039(tag, options) {
    var stylesFactory = (0, $aXQnW.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
var $0900403a30f72792$export$e00380445f2b9e0c = function(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRequire.register("aXQnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fb80cb1bea91fb1$export$2e2bcd8739ae039; });

var $3XBLc = parcelRequire("3XBLc");
parcelRequire("l82yu");
parcelRequire("3aC2T");
parcelRequire("jPiUe");

parcelRequire("7GAnB");
parcelRequire("bgQcD");
parcelRequire("30yNu");
var $7fb80cb1bea91fb1$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $7fb80cb1bea91fb1$export$2e2bcd8739ae039 = (0, $3XBLc.default).bind();
$7fb80cb1bea91fb1$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $7fb80cb1bea91fb1$export$2e2bcd8739ae039[tagName] = $7fb80cb1bea91fb1$export$2e2bcd8739ae039(tagName);
});

});
parcelRequire.register("3XBLc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e242c34686a8a15$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");

var $jPiUe = parcelRequire("jPiUe");
parcelRequire("e1IhQ");
var $dltLJ = parcelRequire("dltLJ");

var $7GAnB = parcelRequire("7GAnB");

var $bgQcD = parcelRequire("bgQcD");

var $30yNu = parcelRequire("30yNu");
var $2e242c34686a8a15$var$testOmitPropsOnStringTag = (0, $jPiUe.default);
var $2e242c34686a8a15$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $2e242c34686a8a15$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2e242c34686a8a15$var$testOmitPropsOnStringTag : $2e242c34686a8a15$var$testOmitPropsOnComponent;
};
var $2e242c34686a8a15$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function shouldForwardProp(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $2e242c34686a8a15$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $2e242c34686a8a15$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7GAnB.registerStyles)(cache, serialized, isStringTag);
    (0, $30yNu.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7GAnB.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $2e242c34686a8a15$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $2e242c34686a8a15$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $2e242c34686a8a15$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $dltLJ.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $3aC2T.useContext((0, $dltLJ.T));
            }
            if (typeof props.className === "string") className = (0, $7GAnB.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $bgQcD.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2e242c34686a8a15$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $3aC2T.createElement($3aC2T.Fragment, null, /*#__PURE__*/ $3aC2T.createElement($2e242c34686a8a15$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $3aC2T.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $3hDKy.default)({}, options, nextOptions, {
                shouldForwardProp: $2e242c34686a8a15$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRequire.register("jPiUe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6f1720de0682617$export$2e2bcd8739ae039; });

var $ieQbk = parcelRequire("ieQbk");
var $e6f1720de0682617$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e6f1720de0682617$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $ieQbk.default)(function(prop) {
    return $e6f1720de0682617$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRequire.register("7xThp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57e67ee0341b8a6a$export$2e2bcd8739ae039; });
parcelRequire("3aC2T");


var $e1IhQ = parcelRequire("e1IhQ");

var $esXub = parcelRequire("esXub");
"use client";
function $57e67ee0341b8a6a$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $57e67ee0341b8a6a$export$2e2bcd8739ae039(props) {
    var styles = props.styles, _props_defaultTheme = props.defaultTheme, defaultTheme = _props_defaultTheme === void 0 ? {} : _props_defaultTheme;
    var globalStyles = typeof styles === "function" ? function(themeInput) {
        return styles($57e67ee0341b8a6a$var$isEmpty(themeInput) ? defaultTheme : themeInput);
    } : styles;
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $e1IhQ.Global), {
        styles: globalStyles
    });
}

});


parcelRequire.register("925dm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69385873ea219940$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $hLNbW = parcelRequire("hLNbW");
var $69385873ea219940$var$_excluded = [
    "variant"
];
function $69385873ea219940$var$isEmpty(string) {
    return string.length === 0;
}
function $69385873ea219940$export$2e2bcd8739ae039(props) {
    var variant = props.variant, other = (0, $8vpQL.default)(props, $69385873ea219940$var$_excluded);
    var classKey = variant || "";
    Object.keys(other).sort().forEach(function(key) {
        if (key === "color") classKey += $69385873ea219940$var$isEmpty(classKey) ? props[key] : (0, $hLNbW.default)(props[key]);
        else classKey += "".concat($69385873ea219940$var$isEmpty(classKey) ? key : (0, $hLNbW.default)(key)).concat((0, $hLNbW.default)(props[key].toString()));
    });
    return classKey;
}

});



parcelRequire.register("jDsI7", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $e4b7ee24b8014a84$export$c7c50641356bdfa5; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $e4b7ee24b8014a84$export$c7c50641356bdfa5(slot) {
    return (0, $iZWB2.default)("MuiSvgIcon", slot);
}
var $e4b7ee24b8014a84$var$svgIconClasses = (0, $1Zd5c.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $e4b7ee24b8014a84$export$2e2bcd8739ae039 = $e4b7ee24b8014a84$var$svgIconClasses;

});
parcelRequire.register("1Zd5c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1725a2ea7da7abf5$export$2e2bcd8739ae039; });

var $iZWB2 = parcelRequire("iZWB2");
function $1725a2ea7da7abf5$export$2e2bcd8739ae039(componentName, slots) {
    var globalStatePrefix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Mui";
    var result = {};
    slots.forEach(function(slot) {
        result[slot] = (0, $iZWB2.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRequire.register("iZWB2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd4b60814355987e$export$2e2bcd8739ae039; });

var $5cWr8 = parcelRequire("5cWr8");
// If GlobalStateSlot is changed, GLOBAL_STATE_CLASSES in
// \packages\api-docs-builder\utils\parseSlotsAndClasses.ts must be updated accordingly.
var $dd4b60814355987e$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $dd4b60814355987e$export$2e2bcd8739ae039(componentName, slot) {
    var globalStatePrefix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Mui";
    var globalStateClass = $dd4b60814355987e$var$globalStateClassesMapping[slot];
    return globalStateClass ? "".concat(globalStatePrefix, "-").concat(globalStateClass) : "".concat((0, $5cWr8.default).generate(componentName), "-").concat(slot);
}

});
parcelRequire.register("5cWr8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cab670543efa51d$export$2e2bcd8739ae039; });
var $3cab670543efa51d$var$defaultGenerator = function(componentName) {
    return componentName;
};
var $3cab670543efa51d$var$createClassNameGenerator = function() {
    var generate = $3cab670543efa51d$var$defaultGenerator;
    return {
        configure: function(generator) {
            generate = generator;
        },
        generate: function(componentName) {
            return generate(componentName);
        },
        reset: function() {
            generate = $3cab670543efa51d$var$defaultGenerator;
        }
    };
};
var $3cab670543efa51d$var$ClassNameGenerator = $3cab670543efa51d$var$createClassNameGenerator();
var $3cab670543efa51d$export$2e2bcd8739ae039 = $3cab670543efa51d$var$ClassNameGenerator;

});








parcelRequire.register("9Tlr6", function(module, exports) {
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7339e0e6a56271bf$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
var $7339e0e6a56271bf$var$_default = (0, $7339e0e6a56271bf$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "M13 3h-2v10h2V3zm4.83 2.17-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
}), "PowerSettingsNew");
module.exports["default"] = $7339e0e6a56271bf$var$_default;

});

parcelRequire.register("52eXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aa8bf25ddf2b811$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $lqmBd = parcelRequire("lqmBd");

var $1LxH8 = parcelRequire("1LxH8");

var $dyvzP = parcelRequire("dyvzP");

var $esXub = parcelRequire("esXub");
"use client";
var $3aa8bf25ddf2b811$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
var $3aa8bf25ddf2b811$var$useUtilityClasses = function(ownerState) {
    var color = ownerState.color, position = ownerState.position, classes = ownerState.classes;
    var slots = {
        root: [
            "root",
            "color".concat((0, $lqmBd.default)(color)),
            "position".concat((0, $lqmBd.default)(position))
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $dyvzP.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
var $3aa8bf25ddf2b811$var$joinVars = function(var1, var2) {
    return var1 ? "".concat(var1 == null ? void 0 : var1.replace(")", ""), ", ").concat(var2, ")") : var2;
};
var $3aa8bf25ddf2b811$var$AppBarRoot = (0, $gSv8W.default)((0, $1LxH8.default), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles["position".concat((0, $lqmBd.default)(ownerState.position))],
            styles["color".concat((0, $lqmBd.default)(ownerState.color))]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $3hDKy.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $3hDKy.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $3hDKy.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $3hDKy.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $3aa8bf25ddf2b811$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $3aa8bf25ddf2b811$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $3aa8bf25ddf2b811$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $3aa8bf25ddf2b811$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
var $3aa8bf25ddf2b811$var$AppBar = /*#__PURE__*/ $3aC2T.forwardRef(function AppBar(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    var className = props.className, _props_color = props.color, color = _props_color === void 0 ? "primary" : _props_color, _props_enableColorOnDark = props.enableColorOnDark, enableColorOnDark = _props_enableColorOnDark === void 0 ? false : _props_enableColorOnDark, _props_position = props.position, position = _props_position === void 0 ? "fixed" : _props_position, other = (0, $8vpQL.default)(props, $3aa8bf25ddf2b811$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    var classes = $3aa8bf25ddf2b811$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsx)($3aa8bf25ddf2b811$var$AppBarRoot, (0, $3hDKy.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $5i80G.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $3aa8bf25ddf2b811$export$2e2bcd8739ae039 = $3aa8bf25ddf2b811$var$AppBar;

});
parcelRequire.register("1LxH8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14945148db816d4a$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");


var $i7SXW = parcelRequire("i7SXW");

var $6Fcce = parcelRequire("6Fcce");

var $gSv8W = parcelRequire("gSv8W");

var $k51tM = parcelRequire("k51tM");

var $4WGW4 = parcelRequire("4WGW4");


var $bwlJh = parcelRequire("bwlJh");

var $esXub = parcelRequire("esXub");
"use client";
var $14945148db816d4a$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
var $14945148db816d4a$var$useUtilityClasses = function(ownerState) {
    var square = ownerState.square, elevation = ownerState.elevation, variant = ownerState.variant, classes = ownerState.classes;
    var slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && "elevation".concat(elevation)
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $bwlJh.getPaperUtilityClass), classes);
};
var $14945148db816d4a$var$PaperRoot = (0, $gSv8W.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles["elevation".concat(ownerState.elevation)]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var _theme$vars$overlays;
    return (0, $3hDKy.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: "1px solid ".concat((theme.vars || theme).palette.divider)
    }, ownerState.variant === "elevation" && (0, $3hDKy.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: "linear-gradient(".concat((0, $6Fcce.alpha)("#fff", (0, $k51tM.default)(ownerState.elevation)), ", ").concat((0, $6Fcce.alpha)("#fff", (0, $k51tM.default)(ownerState.elevation)), ")")
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
var $14945148db816d4a$var$Paper = /*#__PURE__*/ $3aC2T.forwardRef(function Paper(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiPaper"
    });
    var className = props.className, _props_component = props.component, component = _props_component === void 0 ? "div" : _props_component, _props_elevation = props.elevation, elevation = _props_elevation === void 0 ? 1 : _props_elevation, _props_square = props.square, square = _props_square === void 0 ? false : _props_square, _props_variant = props.variant, variant = _props_variant === void 0 ? "elevation" : _props_variant, other = (0, $8vpQL.default)(props, $14945148db816d4a$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    var classes = $14945148db816d4a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsx)($14945148db816d4a$var$PaperRoot, (0, $3hDKy.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $5i80G.default)(classes.root, className),
        ref: ref
    }, other));
});
var $14945148db816d4a$export$2e2bcd8739ae039 = $14945148db816d4a$var$Paper;

});
parcelRequire.register("k51tM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9e56c0bac504e37$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
var $e9e56c0bac504e37$var$getOverlayAlpha = function(elevation) {
    var alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * Math.pow(elevation, 2);
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $e9e56c0bac504e37$export$2e2bcd8739ae039 = $e9e56c0bac504e37$var$getOverlayAlpha;

});

parcelRequire.register("bwlJh", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $863389db806e70d9$export$29cdb466b9b6f20b; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $863389db806e70d9$export$29cdb466b9b6f20b(slot) {
    return (0, $iZWB2.default)("MuiPaper", slot);
}
var $863389db806e70d9$var$paperClasses = (0, $1Zd5c.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $863389db806e70d9$export$2e2bcd8739ae039 = $863389db806e70d9$var$paperClasses;

});


parcelRequire.register("dyvzP", function(module, exports) {

$parcel$export(module.exports, "getAppBarUtilityClass", function () { return $9de6f1d8a3d9175d$export$47a2da616e55e8e9; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $9de6f1d8a3d9175d$export$47a2da616e55e8e9(slot) {
    return (0, $iZWB2.default)("MuiAppBar", slot);
}
var $9de6f1d8a3d9175d$var$appBarClasses = (0, $1Zd5c.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent"
]);
var $9de6f1d8a3d9175d$export$2e2bcd8739ae039 = $9de6f1d8a3d9175d$var$appBarClasses;

});


parcelRequire.register("f8Nug", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b05dfd782740d651$export$2e2bcd8739ae039; });

var $aSMts = parcelRequire("aSMts");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $cViJR = parcelRequire("cViJR");

var $6xXoO = parcelRequire("6xXoO");

var $esXub = parcelRequire("esXub");
"use client";
var $b05dfd782740d651$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
var $b05dfd782740d651$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, variant = ownerState.variant, colorDefault = ownerState.colorDefault;
    var slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $6xXoO.getAvatarUtilityClass), classes);
};
var $b05dfd782740d651$var$AvatarRoot = (0, $gSv8W.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "square" && {
        borderRadius: 0
    }, ownerState.colorDefault && (0, $3hDKy.default)({
        color: (theme.vars || theme).palette.background["default"]
    }, theme.vars ? {
        backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : {
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    }));
});
var $b05dfd782740d651$var$AvatarImg = (0, $gSv8W.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: function(props, styles) {
        return styles.img;
    }
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
var $b05dfd782740d651$var$AvatarFallback = (0, $gSv8W.default)((0, $cViJR.default), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: function(props, styles) {
        return styles.fallback;
    }
})({
    width: "75%",
    height: "75%"
});
function $b05dfd782740d651$var$useLoaded(param) {
    var crossOrigin = param.crossOrigin, referrerPolicy = param.referrerPolicy, src = param.src, srcSet = param.srcSet;
    var _React_useState = (0, $aSMts._)($3aC2T.useState(false), 2), loaded = _React_useState[0], setLoaded = _React_useState[1];
    $3aC2T.useEffect(function() {
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        var active = true;
        var image = new Image();
        image.onload = function() {
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = function() {
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return function() {
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
var $b05dfd782740d651$var$Avatar = /*#__PURE__*/ $3aC2T.forwardRef(function Avatar(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    var alt = props.alt, childrenProp = props.children, className = props.className, _props_component = props.component, component = _props_component === void 0 ? "div" : _props_component, imgProps = props.imgProps, sizes = props.sizes, src = props.src, srcSet = props.srcSet, _props_variant = props.variant, variant = _props_variant === void 0 ? "circular" : _props_variant, other = (0, $8vpQL.default)(props, $b05dfd782740d651$var$_excluded);
    var children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    var loaded = $b05dfd782740d651$var$useLoaded((0, $3hDKy.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    var hasImg = src || srcSet;
    var hasImgNotFailing = hasImg && loaded !== "error";
    var ownerState = (0, $3hDKy.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    var classes = $b05dfd782740d651$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $esXub.jsx)($b05dfd782740d651$var$AvatarImg, (0, $3hDKy.default)({
        alt: alt,
        srcSet: srcSet,
        src: src,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $esXub.jsx)($b05dfd782740d651$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $esXub.jsx)($b05dfd782740d651$var$AvatarRoot, (0, $3hDKy.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $5i80G.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $b05dfd782740d651$export$2e2bcd8739ae039 = $b05dfd782740d651$var$Avatar;

});
parcelRequire.register("cViJR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9689580934105f37$export$2e2bcd8739ae039; });
parcelRequire("3aC2T");

var $3rjC7 = parcelRequire("3rjC7");

var $esXub = parcelRequire("esXub");
"use client";
var $9689580934105f37$export$2e2bcd8739ae039 = (0, $3rjC7.default)(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");

});

parcelRequire.register("6xXoO", function(module, exports) {

$parcel$export(module.exports, "getAvatarUtilityClass", function () { return $4c43e695d68504e9$export$ffd560f22c0ecf04; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $4c43e695d68504e9$export$ffd560f22c0ecf04(slot) {
    return (0, $iZWB2.default)("MuiAvatar", slot);
}
var $4c43e695d68504e9$var$avatarClasses = (0, $1Zd5c.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $4c43e695d68504e9$export$2e2bcd8739ae039 = $4c43e695d68504e9$var$avatarClasses;

});


parcelRequire.register("kDFB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f067b78e56f4749a$export$2e2bcd8739ae039; });

var $fZDgR = parcelRequire("fZDgR");


var $5cWr8 = parcelRequire("5cWr8");

var $iA7xR = parcelRequire("iA7xR");

var $gH0Wp = parcelRequire("gH0Wp");
"use client";
var $f067b78e56f4749a$var$defaultTheme = (0, $iA7xR.default)();
var $f067b78e56f4749a$var$Box = (0, $fZDgR.default)({
    themeId: (0, $gH0Wp.default),
    defaultTheme: $f067b78e56f4749a$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $5cWr8.default).generate
});
var $f067b78e56f4749a$export$2e2bcd8739ae039 = $f067b78e56f4749a$var$Box;

});
parcelRequire.register("fZDgR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $030135bd86ac5e89$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");

var $5i80G = parcelRequire("5i80G");

var $LUxKr = parcelRequire("LUxKr");

var $hQA2V = parcelRequire("hQA2V");
var $2m5wd = parcelRequire("2m5wd");

var $j7n4p = parcelRequire("j7n4p");

var $esXub = parcelRequire("esXub");
"use client";
var $030135bd86ac5e89$var$_excluded = [
    "className",
    "component"
];
function $030135bd86ac5e89$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var themeId = options.themeId, defaultTheme = options.defaultTheme, _options_defaultClassName = options.defaultClassName, defaultClassName = _options_defaultClassName === void 0 ? "MuiBox-root" : _options_defaultClassName, generateClassName = options.generateClassName;
    var BoxRoot = (0, $LUxKr.default)("div", {
        shouldForwardProp: function(prop) {
            return prop !== "theme" && prop !== "sx" && prop !== "as";
        }
    })((0, $hQA2V.default));
    var Box = /*#__PURE__*/ $3aC2T.forwardRef(function Box(inProps, ref) {
        var theme = (0, $j7n4p.default)(defaultTheme);
        var _extendSxProp = (0, $2m5wd.default)(inProps), className = _extendSxProp.className, _extendSxProp_component = _extendSxProp.component, component = _extendSxProp_component === void 0 ? "div" : _extendSxProp_component, other = (0, $8vpQL.default)(_extendSxProp, $030135bd86ac5e89$var$_excluded);
        return /*#__PURE__*/ (0, $esXub.jsx)(BoxRoot, (0, $3hDKy.default)({
            as: component,
            ref: ref,
            className: (0, $5i80G.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

});
parcelRequire.register("2m5wd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b71eab9ce3c95fa$export$2e2bcd8739ae039; });

var $dHvbf = parcelRequire("dHvbf");

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $luotc = parcelRequire("luotc");

var $fsdeC = parcelRequire("fsdeC");
var $1b71eab9ce3c95fa$var$_excluded = [
    "sx"
];
var $1b71eab9ce3c95fa$var$splitProps = function(props) {
    var _props$theme$unstable, _props$theme;
    var result = {
        systemProps: {},
        otherProps: {}
    };
    var config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $fsdeC.default);
    Object.keys(props).forEach(function(prop) {
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $1b71eab9ce3c95fa$export$2e2bcd8739ae039(props) {
    var inSx = props.sx, other = (0, $8vpQL.default)(props, $1b71eab9ce3c95fa$var$_excluded);
    var _splitProps = $1b71eab9ce3c95fa$var$splitProps(other), systemProps = _splitProps.systemProps, otherProps = _splitProps.otherProps;
    var finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps
    ].concat((0, $dHvbf._)(inSx));
    else if (typeof inSx === "function") finalSx = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var result = inSx.apply(void 0, (0, $dHvbf._)(args));
        if (!(0, $luotc.isPlainObject)(result)) return systemProps;
        return (0, $3hDKy.default)({}, systemProps, result);
    };
    else finalSx = (0, $3hDKy.default)({}, systemProps, inSx);
    return (0, $3hDKy.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRequire.register("4Jn3R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $371d40e5adc01632$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");


var $i7SXW = parcelRequire("i7SXW");

var $6Fcce = parcelRequire("6Fcce");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $db1CZ = parcelRequire("db1CZ");

var $lqmBd = parcelRequire("lqmBd");

var $5QMBH = parcelRequire("5QMBH");

var $esXub = parcelRequire("esXub");
"use client";
var $371d40e5adc01632$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
var $371d40e5adc01632$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, disabled = ownerState.disabled, color = ownerState.color, edge = ownerState.edge, size = ownerState.size;
    var slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && "color".concat((0, $lqmBd.default)(color)),
            edge && "edge".concat((0, $lqmBd.default)(edge)),
            "size".concat((0, $lqmBd.default)(size))
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $5QMBH.getIconButtonUtilityClass), classes);
};
var $371d40e5adc01632$var$IconButtonRoot = (0, $gSv8W.default)((0, $db1CZ.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.color !== "default" && styles["color".concat((0, $lqmBd.default)(ownerState.color))],
            ownerState.edge && styles["edge".concat((0, $lqmBd.default)(ownerState.edge))],
            styles["size".concat((0, $lqmBd.default)(ownerState.size))]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.action.activeChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : (0, $6Fcce.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    });
}, function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var _palette;
    var palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $3hDKy.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $3hDKy.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $3hDKy.default)({}, palette && {
            backgroundColor: theme.vars ? "rgba(".concat(palette.mainChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : (0, $6Fcce.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, (0, $2iBlG._)({}, "&.".concat((0, $5QMBH.default).disabled), {
        backgroundColor: "transparent",
        color: (theme.vars || theme).palette.action.disabled
    }));
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ var $371d40e5adc01632$var$IconButton = /*#__PURE__*/ $3aC2T.forwardRef(function IconButton(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    var _props_edge = props.edge, edge = _props_edge === void 0 ? false : _props_edge, children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? "default" : _props_color, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_disableFocusRipple = props.disableFocusRipple, disableFocusRipple = _props_disableFocusRipple === void 0 ? false : _props_disableFocusRipple, _props_size = props.size, size = _props_size === void 0 ? "medium" : _props_size, other = (0, $8vpQL.default)(props, $371d40e5adc01632$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    var classes = $371d40e5adc01632$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsx)($371d40e5adc01632$var$IconButtonRoot, (0, $3hDKy.default)({
        className: (0, $5i80G.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $371d40e5adc01632$export$2e2bcd8739ae039 = $371d40e5adc01632$var$IconButton;

});
parcelRequire.register("db1CZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $997d90b4e4e32b3b$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $aSMts = parcelRequire("aSMts");

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");


var $i7SXW = parcelRequire("i7SXW");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $gcZH1 = parcelRequire("gcZH1");

var $35AKr = parcelRequire("35AKr");

var $l6Dnm = parcelRequire("l6Dnm");

var $aWVhq = parcelRequire("aWVhq");

var $5sRJY = parcelRequire("5sRJY");

var $esXub = parcelRequire("esXub");
"use client";
var $997d90b4e4e32b3b$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
var $997d90b4e4e32b3b$var$useUtilityClasses = function(ownerState) {
    var disabled = ownerState.disabled, focusVisible = ownerState.focusVisible, focusVisibleClassName = ownerState.focusVisibleClassName, classes = ownerState.classes;
    var slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    var composedClasses = (0, $i7SXW.default)(slots, (0, $5sRJY.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += " ".concat(focusVisibleClassName);
    return composedClasses;
};
var $997d90b4e4e32b3b$var$_obj;
var $997d90b4e4e32b3b$export$7ec0dcc5e3cdcd36 = (0, $gSv8W.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: function(props, styles) {
        return styles.root;
    }
})(($997d90b4e4e32b3b$var$_obj = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    }
}, (0, $2iBlG._)($997d90b4e4e32b3b$var$_obj, "&.".concat((0, $5sRJY.default).disabled), {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
}), (0, $2iBlG._)($997d90b4e4e32b3b$var$_obj, "@media print", {
    colorAdjust: "exact"
}), $997d90b4e4e32b3b$var$_obj));
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $997d90b4e4e32b3b$var$ButtonBase = /*#__PURE__*/ $3aC2T.forwardRef(function ButtonBase(inProps, ref) {
    var useRippleHandler = function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : disableTouchRipple;
        return (0, $35AKr.default)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    };
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    var action = props.action, _props_centerRipple = props.centerRipple, centerRipple = _props_centerRipple === void 0 ? false : _props_centerRipple, children = props.children, className = props.className, _props_component = props.component, component = _props_component === void 0 ? "button" : _props_component, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_disableRipple = props.disableRipple, disableRipple = _props_disableRipple === void 0 ? false : _props_disableRipple, _props_disableTouchRipple = props.disableTouchRipple, disableTouchRipple = _props_disableTouchRipple === void 0 ? false : _props_disableTouchRipple, _props_focusRipple = props.focusRipple, focusRipple = _props_focusRipple === void 0 ? false : _props_focusRipple, _props_LinkComponent = props.LinkComponent, LinkComponent = _props_LinkComponent === void 0 ? "a" : _props_LinkComponent, onBlur = props.onBlur, onClick = props.onClick, onContextMenu = props.onContextMenu, onDragLeave = props.onDragLeave, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, _props_tabIndex = props.tabIndex, tabIndex = _props_tabIndex === void 0 ? 0 : _props_tabIndex, TouchRippleProps = props.TouchRippleProps, touchRippleRef = props.touchRippleRef, type = props.type, other = (0, $8vpQL.default)(props, $997d90b4e4e32b3b$var$_excluded);
    var buttonRef = $3aC2T.useRef(null);
    var rippleRef = $3aC2T.useRef(null);
    var handleRippleRef = (0, $gcZH1.default)(rippleRef, touchRippleRef);
    var _useIsFocusVisible = (0, $l6Dnm.default)(), isFocusVisibleRef = _useIsFocusVisible.isFocusVisibleRef, handleFocusVisible = _useIsFocusVisible.onFocus, handleBlurVisible = _useIsFocusVisible.onBlur, focusVisibleRef = _useIsFocusVisible.ref;
    var _React_useState = (0, $aSMts._)($3aC2T.useState(false), 2), focusVisible = _React_useState[0], setFocusVisible = _React_useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    $3aC2T.useImperativeHandle(action, function() {
        return {
            focusVisible: function() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    var _React_useState1 = (0, $aSMts._)($3aC2T.useState(false), 2), mountedState = _React_useState1[0], setMountedState = _React_useState1[1];
    $3aC2T.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    $3aC2T.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    var handleMouseDown = useRippleHandler("start", onMouseDown);
    var handleContextMenu = useRippleHandler("stop", onContextMenu);
    var handleDragLeave = useRippleHandler("stop", onDragLeave);
    var handleMouseUp = useRippleHandler("stop", onMouseUp);
    var handleMouseLeave = useRippleHandler("stop", function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler("start", onTouchStart);
    var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    var handleTouchMove = useRippleHandler("stop", onTouchMove);
    var handleBlur = useRippleHandler("stop", function(event) {
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $35AKr.default)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function() {
        var button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $3aC2T.useRef(false);
    var handleKeyDown = (0, $35AKr.default)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $35AKr.default)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    var buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    var handleRef = (0, $gcZH1.default)(ref, focusVisibleRef, buttonRef);
    var ownerState = (0, $3hDKy.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    var classes = $997d90b4e4e32b3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsxs)($997d90b4e4e32b3b$export$7ec0dcc5e3cdcd36, (0, $3hDKy.default)({
        as: ComponentProp,
        className: (0, $5i80G.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $esXub.jsx)((0, $aWVhq.default), (0, $3hDKy.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $997d90b4e4e32b3b$export$2e2bcd8739ae039 = $997d90b4e4e32b3b$var$ButtonBase;

});
parcelRequire.register("gcZH1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bccd9f4822a6c52d$export$2e2bcd8739ae039; });

var $6mnDc = parcelRequire("6mnDc");
"use client";
var $bccd9f4822a6c52d$export$2e2bcd8739ae039 = (0, $6mnDc.default);

});
parcelRequire.register("6mnDc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a1720cd56809002$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");

var $rUaL0 = parcelRequire("rUaL0");
"use client";
function $4a1720cd56809002$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $3aC2T.useMemo(function() {
        if (refs.every(function(ref) {
            return ref == null;
        })) return null;
        return function(instance) {
            refs.forEach(function(ref) {
                (0, $rUaL0.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRequire.register("rUaL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $053e186b8e9b6fad$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $053e186b8e9b6fad$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});



parcelRequire.register("35AKr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23fe581af5e5e2cb$export$2e2bcd8739ae039; });

var $9EdjO = parcelRequire("9EdjO");
"use client";
var $23fe581af5e5e2cb$export$2e2bcd8739ae039 = (0, $9EdjO.default);

});
parcelRequire.register("9EdjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70622e455ffa9de0$export$2e2bcd8739ae039; });

var $dHvbf = parcelRequire("dHvbf");

var $3aC2T = parcelRequire("3aC2T");

var $7GrSn = parcelRequire("7GrSn");
"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $70622e455ffa9de0$var$useEventCallback(fn) {
    var _this = this;
    var ref = $3aC2T.useRef(fn);
    (0, $7GrSn.default)(function() {
        ref.current = fn;
    });
    return $3aC2T.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return(// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current).apply(_this, (0, $dHvbf._)(args)));
    }, []);
}
var $70622e455ffa9de0$export$2e2bcd8739ae039 = $70622e455ffa9de0$var$useEventCallback;

});
parcelRequire.register("7GrSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5982143e6571ceb5$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
"use client";
var $5982143e6571ceb5$var$useEnhancedEffect = typeof window !== "undefined" ? $3aC2T.useLayoutEffect : $3aC2T.useEffect;
var $5982143e6571ceb5$export$2e2bcd8739ae039 = $5982143e6571ceb5$var$useEnhancedEffect;

});



parcelRequire.register("l6Dnm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5d8b3bb7e5dbce8$export$2e2bcd8739ae039; });

var $65ejT = parcelRequire("65ejT");
"use client";
var $f5d8b3bb7e5dbce8$export$2e2bcd8739ae039 = (0, $65ejT.default);

});
parcelRequire.register("65ejT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46de5151becdfcf5$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
"use client";
var $46de5151becdfcf5$var$hadKeyboardEvent = true;
var $46de5151becdfcf5$var$hadFocusVisibleRecently = false;
var $46de5151becdfcf5$var$hadFocusVisibleRecentlyTimeout;
var $46de5151becdfcf5$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $46de5151becdfcf5$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === "INPUT" && $46de5151becdfcf5$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $46de5151becdfcf5$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $46de5151becdfcf5$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $46de5151becdfcf5$var$handlePointerDown() {
    $46de5151becdfcf5$var$hadKeyboardEvent = false;
}
function $46de5151becdfcf5$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($46de5151becdfcf5$var$hadFocusVisibleRecently) $46de5151becdfcf5$var$hadKeyboardEvent = true;
    }
}
function $46de5151becdfcf5$var$prepare(doc) {
    doc.addEventListener("keydown", $46de5151becdfcf5$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $46de5151becdfcf5$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $46de5151becdfcf5$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $46de5151becdfcf5$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $46de5151becdfcf5$var$handleVisibilityChange, true);
}
function $46de5151becdfcf5$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $46de5151becdfcf5$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $46de5151becdfcf5$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $46de5151becdfcf5$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $46de5151becdfcf5$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $46de5151becdfcf5$var$handleVisibilityChange, true);
}
function $46de5151becdfcf5$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $46de5151becdfcf5$var$hadKeyboardEvent || $46de5151becdfcf5$var$focusTriggersKeyboardModality(target);
}
function $46de5151becdfcf5$export$2e2bcd8739ae039() {
    var handleBlurVisible = /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $46de5151becdfcf5$var$hadFocusVisibleRecently = true;
            window.clearTimeout($46de5151becdfcf5$var$hadFocusVisibleRecentlyTimeout);
            $46de5151becdfcf5$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
                $46de5151becdfcf5$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    };
    var handleFocusVisible = /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($46de5151becdfcf5$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    };
    var ref = $3aC2T.useCallback(function(node) {
        if (node != null) $46de5151becdfcf5$var$prepare(node.ownerDocument);
    }, []);
    var isFocusVisibleRef = $3aC2T.useRef(false);
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});


parcelRequire.register("aWVhq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f8bc0c3b441f526$export$2e2bcd8739ae039; });

var $aSMts = parcelRequire("aSMts");

var $jjHBq = parcelRequire("jjHBq");

var $dHvbf = parcelRequire("dHvbf");

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");


var $4njOW = parcelRequire("4njOW");

var $5i80G = parcelRequire("5i80G");

var $e1IhQ = parcelRequire("e1IhQ");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $l07Zx = parcelRequire("l07Zx");

var $5k2hH = parcelRequire("5k2hH");

var $esXub = parcelRequire("esXub");
"use client";
function $7f8bc0c3b441f526$var$_templateObject() {
    var data = (0, $jjHBq._)([
        "\n  0% {\n    transform: scale(0);\n    opacity: 0.1;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 0.3;\n  }\n"
    ]);
    $7f8bc0c3b441f526$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $7f8bc0c3b441f526$var$_templateObject1() {
    var data = (0, $jjHBq._)([
        "\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"
    ]);
    $7f8bc0c3b441f526$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $7f8bc0c3b441f526$var$_templateObject2() {
    var data = (0, $jjHBq._)([
        "\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(0.92);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n"
    ]);
    $7f8bc0c3b441f526$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $7f8bc0c3b441f526$var$_templateObject3() {
    var data = (0, $jjHBq._)([
        "\n  opacity: 0;\n  position: absolute;\n\n  &.",
        " {\n    opacity: 0.3;\n    transform: scale(1);\n    animation-name: ",
        ";\n    animation-duration: ",
        "ms;\n    animation-timing-function: ",
        ";\n  }\n\n  &.",
        " {\n    animation-duration: ",
        "ms;\n  }\n\n  & .",
        " {\n    opacity: 1;\n    display: block;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-color: currentColor;\n  }\n\n  & .",
        " {\n    opacity: 0;\n    animation-name: ",
        ";\n    animation-duration: ",
        "ms;\n    animation-timing-function: ",
        ";\n  }\n\n  & .",
        " {\n    position: absolute;\n    /* @noflip */\n    left: 0px;\n    top: 0;\n    animation-name: ",
        ";\n    animation-duration: 2500ms;\n    animation-timing-function: ",
        ";\n    animation-iteration-count: infinite;\n    animation-delay: 200ms;\n  }\n"
    ]);
    $7f8bc0c3b441f526$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $7f8bc0c3b441f526$var$_excluded = [
    "center",
    "classes",
    "className"
];
var $7f8bc0c3b441f526$var$_ = function(t) {
    return t;
}, $7f8bc0c3b441f526$var$_t, $7f8bc0c3b441f526$var$_t2, $7f8bc0c3b441f526$var$_t3, $7f8bc0c3b441f526$var$_t4;
var $7f8bc0c3b441f526$var$DURATION = 550;
var $7f8bc0c3b441f526$export$95d0c9356b2231a3 = 80;
var $7f8bc0c3b441f526$var$enterKeyframe = (0, $e1IhQ.keyframes)($7f8bc0c3b441f526$var$_t || ($7f8bc0c3b441f526$var$_t = $7f8bc0c3b441f526$var$_($7f8bc0c3b441f526$var$_templateObject())));
var $7f8bc0c3b441f526$var$exitKeyframe = (0, $e1IhQ.keyframes)($7f8bc0c3b441f526$var$_t2 || ($7f8bc0c3b441f526$var$_t2 = $7f8bc0c3b441f526$var$_($7f8bc0c3b441f526$var$_templateObject1())));
var $7f8bc0c3b441f526$var$pulsateKeyframe = (0, $e1IhQ.keyframes)($7f8bc0c3b441f526$var$_t3 || ($7f8bc0c3b441f526$var$_t3 = $7f8bc0c3b441f526$var$_($7f8bc0c3b441f526$var$_templateObject2())));
var $7f8bc0c3b441f526$export$f6b7418508c72c25 = (0, $gSv8W.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
var $7f8bc0c3b441f526$export$676cfe7b12693c4b = (0, $gSv8W.default)((0, $l07Zx.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($7f8bc0c3b441f526$var$_t4 || ($7f8bc0c3b441f526$var$_t4 = $7f8bc0c3b441f526$var$_($7f8bc0c3b441f526$var$_templateObject3(), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), (0, $5k2hH.default).rippleVisible, $7f8bc0c3b441f526$var$enterKeyframe, $7f8bc0c3b441f526$var$DURATION, function(param) {
    var theme = param.theme;
    return theme.transitions.easing.easeInOut;
}, (0, $5k2hH.default).ripplePulsate, function(param) {
    var theme = param.theme;
    return theme.transitions.duration.shorter;
}, (0, $5k2hH.default).child, (0, $5k2hH.default).childLeaving, $7f8bc0c3b441f526$var$exitKeyframe, $7f8bc0c3b441f526$var$DURATION, function(param) {
    var theme = param.theme;
    return theme.transitions.easing.easeInOut;
}, (0, $5k2hH.default).childPulsate, $7f8bc0c3b441f526$var$pulsateKeyframe, function(param) {
    var theme = param.theme;
    return theme.transitions.easing.easeInOut;
});
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $7f8bc0c3b441f526$var$TouchRipple = /*#__PURE__*/ $3aC2T.forwardRef(function TouchRipple(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    var tmp = props.center, centerProp = tmp === void 0 ? false : tmp, _props_classes = props.classes, classes = _props_classes === void 0 ? {} : _props_classes, className = props.className, other = (0, $8vpQL.default)(props, $7f8bc0c3b441f526$var$_excluded);
    var _React_useState = (0, $aSMts._)($3aC2T.useState([]), 2), ripples = _React_useState[0], setRipples = _React_useState[1];
    var nextKey = $3aC2T.useRef(0);
    var rippleCallback = $3aC2T.useRef(null);
    $3aC2T.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $3aC2T.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $3aC2T.useRef(0);
    // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $3aC2T.useRef(null);
    var container = $3aC2T.useRef(null);
    $3aC2T.useEffect(function() {
        return function() {
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $3aC2T.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return (0, $dHvbf._)(oldRipples).concat([
                /*#__PURE__*/ (0, $esXub.jsx)($7f8bc0c3b441f526$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $5i80G.default)(classes.ripple, (0, $5k2hH.default).ripple),
                        rippleVisible: (0, $5i80G.default)(classes.rippleVisible, (0, $5k2hH.default).rippleVisible),
                        ripplePulsate: (0, $5i80G.default)(classes.ripplePulsate, (0, $5k2hH.default).ripplePulsate),
                        child: (0, $5i80G.default)(classes.child, (0, $5k2hH.default).child),
                        childLeaving: (0, $5i80G.default)(classes.childLeaving, (0, $5k2hH.default).childLeaving),
                        childPulsate: (0, $5i80G.default)(classes.childPulsate, (0, $5k2hH.default).childPulsate)
                    },
                    timeout: $7f8bc0c3b441f526$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $3aC2T.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, cb = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
        var _options_pulsate = options.pulsate, pulsate = _options_pulsate === void 0 ? false : _options_pulsate, _options_center = options.center, center = _options_center === void 0 ? centerProp || options.pulsate : _options_center, _options_fakeElement = options.fakeElement, fakeElement = _options_fakeElement === void 0 ? false // For test purposes
         : _options_fakeElement;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches && event.touches.length > 0 ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $7f8bc0c3b441f526$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $3aC2T.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $3aC2T.useCallback(function(event, cb) {
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $3aC2T.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $esXub.jsx)($7f8bc0c3b441f526$export$f6b7418508c72c25, (0, $3hDKy.default)({
        className: (0, $5i80G.default)((0, $5k2hH.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $4njOW.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $7f8bc0c3b441f526$export$2e2bcd8739ae039 = $7f8bc0c3b441f526$var$TouchRipple;

});
parcelRequire.register("jjHBq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e1019d3d6ceb708a$export$263b15b19e6ed8f; });
function $e1019d3d6ceb708a$export$263b15b19e6ed8f(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRequire.register("4njOW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32f8af5b1dcee88d$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $hLdII = parcelRequire("hLdII");

var $3BGRq = parcelRequire("3BGRq");


var $3aC2T = parcelRequire("3aC2T");

var $5dFAS = parcelRequire("5dFAS");

var $XCq97 = parcelRequire("XCq97");
var $32f8af5b1dcee88d$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $32f8af5b1dcee88d$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $32f8af5b1dcee88d$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    var TransitionGroup = function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hLdII.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    };
    (0, $3BGRq.default)(TransitionGroup, _React$Component);
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $XCq97.getInitialChildMapping)(nextProps, handleExited) : (0, $XCq97.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $XCq97.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $3hDKy.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $8vpQL.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $32f8af5b1dcee88d$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement((0, $5dFAS.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement((0, $5dFAS.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).Component);
$32f8af5b1dcee88d$var$TransitionGroup.propTypes = {};
$32f8af5b1dcee88d$var$TransitionGroup.defaultProps = $32f8af5b1dcee88d$var$defaultProps;
var $32f8af5b1dcee88d$export$2e2bcd8739ae039 = $32f8af5b1dcee88d$var$TransitionGroup;

});
parcelRequire.register("hLdII", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cee1780649cf925a$export$2e2bcd8739ae039; });
function $cee1780649cf925a$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRequire.register("3BGRq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a06130d5a3fdf05$export$2e2bcd8739ae039; });

var $e057y = parcelRequire("e057y");
function $2a06130d5a3fdf05$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $e057y.default)(subClass, superClass);
}

});
parcelRequire.register("e057y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a31509af9c4d717c$export$2e2bcd8739ae039; });
function $a31509af9c4d717c$export$2e2bcd8739ae039(o, p) {
    $a31509af9c4d717c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a31509af9c4d717c$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("5dFAS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cce6e54bde2237f$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
var $3cce6e54bde2237f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createContext(null);

});

parcelRequire.register("XCq97", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $0b33505b1b0d9f19$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $0b33505b1b0d9f19$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $0b33505b1b0d9f19$export$36fd1af28d383ec0; });

var $3aC2T = parcelRequire("3aC2T");
function $0b33505b1b0d9f19$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $3aC2T.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $3aC2T.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $0b33505b1b0d9f19$export$7a874f95ccf533dd(prev, next) {
    var getValueForKey = function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    ;
    prev = prev || {};
    next = next || {};
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $0b33505b1b0d9f19$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $0b33505b1b0d9f19$export$fa71e2345c31d7a2(props, onExited) {
    return $0b33505b1b0d9f19$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $3aC2T.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            "in": true,
            appear: $0b33505b1b0d9f19$var$getProp(child, "appear", props),
            enter: $0b33505b1b0d9f19$var$getProp(child, "enter", props),
            exit: $0b33505b1b0d9f19$var$getProp(child, "exit", props)
        });
    });
}
function $0b33505b1b0d9f19$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $0b33505b1b0d9f19$export$bbc8a025727ea824(nextProps.children);
    var children = $0b33505b1b0d9f19$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $3aC2T.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $3aC2T.isValidElement)(prevChild) && !prevChild.props["in"]; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $3aC2T.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            "in": true,
            exit: $0b33505b1b0d9f19$var$getProp(child, "exit", nextProps),
            enter: $0b33505b1b0d9f19$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $3aC2T.cloneElement)(child, {
            "in": false
        });
        else if (hasNext && hasPrev && (0, $3aC2T.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $3aC2T.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            "in": prevChild.props["in"],
            exit: $0b33505b1b0d9f19$var$getProp(child, "exit", nextProps),
            enter: $0b33505b1b0d9f19$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRequire.register("l07Zx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f49fcbfeeff85bb1$export$2e2bcd8739ae039; });

var $aSMts = parcelRequire("aSMts");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $esXub = parcelRequire("esXub");
"use client";
function $f49fcbfeeff85bb1$var$Ripple(props) {
    var className = props.className, classes = props.classes, _props_pulsate = props.pulsate, pulsate = _props_pulsate === void 0 ? false : _props_pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props["in"], onExited = props.onExited, timeout = props.timeout;
    var _React_useState = (0, $aSMts._)($3aC2T.useState(false), 2), leaving = _React_useState[0], setLeaving = _React_useState[1];
    var rippleClassName = (0, $5i80G.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $5i80G.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $3aC2T.useEffect(function() {
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            var timeoutId = setTimeout(onExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $esXub.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $esXub.jsx)("span", {
            className: childClassName
        })
    });
}
var $f49fcbfeeff85bb1$export$2e2bcd8739ae039 = $f49fcbfeeff85bb1$var$Ripple;

});

parcelRequire.register("5k2hH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e0097a708a68f21$export$2e2bcd8739ae039; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $3e0097a708a68f21$export$b464606f735ab902(slot) {
    return (0, $iZWB2.default)("MuiTouchRipple", slot);
}
var $3e0097a708a68f21$var$touchRippleClasses = (0, $1Zd5c.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $3e0097a708a68f21$export$2e2bcd8739ae039 = $3e0097a708a68f21$var$touchRippleClasses;

});


parcelRequire.register("5sRJY", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $3fa941030574cdd2$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $3fa941030574cdd2$export$2e2bcd8739ae039; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $3fa941030574cdd2$export$fccb0498dcd99783(slot) {
    return (0, $iZWB2.default)("MuiButtonBase", slot);
}
var $3fa941030574cdd2$var$buttonBaseClasses = (0, $1Zd5c.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $3fa941030574cdd2$export$2e2bcd8739ae039 = $3fa941030574cdd2$var$buttonBaseClasses;

});


parcelRequire.register("5QMBH", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $4427836993b8895e$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $4427836993b8895e$export$2e2bcd8739ae039; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $4427836993b8895e$export$5e8702d71474f093(slot) {
    return (0, $iZWB2.default)("MuiIconButton", slot);
}
var $4427836993b8895e$var$iconButtonClasses = (0, $1Zd5c.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $4427836993b8895e$export$2e2bcd8739ae039 = $4427836993b8895e$var$iconButtonClasses;

});


parcelRequire.register("2wbWF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d57d603a50e0766$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $2m5wd = parcelRequire("2m5wd");

var $i7SXW = parcelRequire("i7SXW");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $lqmBd = parcelRequire("lqmBd");

var $cIS8W = parcelRequire("cIS8W");

var $esXub = parcelRequire("esXub");
"use client";
var $1d57d603a50e0766$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
var $1d57d603a50e0766$var$useUtilityClasses = function(ownerState) {
    var align = ownerState.align, gutterBottom = ownerState.gutterBottom, noWrap = ownerState.noWrap, paragraph = ownerState.paragraph, variant = ownerState.variant, classes = ownerState.classes;
    var slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && "align".concat((0, $lqmBd.default)(align)),
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $cIS8W.getTypographyUtilityClass), classes);
};
var $1d57d603a50e0766$export$140e2f5526d3cad8 = (0, $gSv8W.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles["align".concat((0, $lqmBd.default)(ownerState.align))],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    });
});
var $1d57d603a50e0766$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
var $1d57d603a50e0766$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
var $1d57d603a50e0766$var$transformDeprecatedColors = function(color) {
    return $1d57d603a50e0766$var$colorTransformations[color] || color;
};
var $1d57d603a50e0766$var$Typography = /*#__PURE__*/ $3aC2T.forwardRef(function Typography(inProps, ref) {
    var themeProps = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiTypography"
    });
    var color = $1d57d603a50e0766$var$transformDeprecatedColors(themeProps.color);
    var props = (0, $2m5wd.default)((0, $3hDKy.default)({}, themeProps, {
        color: color
    }));
    var _props_align = props.align, align = _props_align === void 0 ? "inherit" : _props_align, className = props.className, component = props.component, _props_gutterBottom = props.gutterBottom, gutterBottom = _props_gutterBottom === void 0 ? false : _props_gutterBottom, _props_noWrap = props.noWrap, noWrap = _props_noWrap === void 0 ? false : _props_noWrap, _props_paragraph = props.paragraph, paragraph = _props_paragraph === void 0 ? false : _props_paragraph, _props_variant = props.variant, variant = _props_variant === void 0 ? "body1" : _props_variant, _props_variantMapping = props.variantMapping, variantMapping = _props_variantMapping === void 0 ? $1d57d603a50e0766$var$defaultVariantMapping : _props_variantMapping, other = (0, $8vpQL.default)(props, $1d57d603a50e0766$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    var Component = component || (paragraph ? "p" : variantMapping[variant] || $1d57d603a50e0766$var$defaultVariantMapping[variant]) || "span";
    var classes = $1d57d603a50e0766$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsx)($1d57d603a50e0766$export$140e2f5526d3cad8, (0, $3hDKy.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $5i80G.default)(classes.root, className)
    }, other));
});
var $1d57d603a50e0766$export$2e2bcd8739ae039 = $1d57d603a50e0766$var$Typography;

});
parcelRequire.register("cIS8W", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $943397d5f894a212$export$24c1f8f60cbac79e; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $943397d5f894a212$export$24c1f8f60cbac79e(slot) {
    return (0, $iZWB2.default)("MuiTypography", slot);
}
var $943397d5f894a212$var$typographyClasses = (0, $1Zd5c.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $943397d5f894a212$export$2e2bcd8739ae039 = $943397d5f894a212$var$typographyClasses;

});


parcelRequire.register("5WuyH", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", function () { return $453a12ddee1c3125$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "Link", function () { return $453a12ddee1c3125$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $453a12ddee1c3125$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("awSZB")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("awSZB")).useNavigate; });
/**
 * React Router DOM v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $3aC2T = parcelRequire("3aC2T");

var $7jR2L = parcelRequire("7jR2L");
var $awSZB = parcelRequire("awSZB");

var $7jR2L = parcelRequire("7jR2L");
function $453a12ddee1c3125$var$_extends() {
    $453a12ddee1c3125$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $453a12ddee1c3125$var$_extends.apply(this, arguments);
}
function $453a12ddee1c3125$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $453a12ddee1c3125$var$defaultMethod = "get";
var $453a12ddee1c3125$var$defaultEncType = "application/x-www-form-urlencoded";
function $453a12ddee1c3125$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $453a12ddee1c3125$var$isButtonElement(object) {
    return $453a12ddee1c3125$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $453a12ddee1c3125$var$isFormElement(object) {
    return $453a12ddee1c3125$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $453a12ddee1c3125$var$isInputElement(object) {
    return $453a12ddee1c3125$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $453a12ddee1c3125$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $453a12ddee1c3125$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$453a12ddee1c3125$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $453a12ddee1c3125$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $453a12ddee1c3125$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $453a12ddee1c3125$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $453a12ddee1c3125$var$_formDataSupportsSubmitter = null;
function $453a12ddee1c3125$var$isFormDataSubmitterSupported() {
    if ($453a12ddee1c3125$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $453a12ddee1c3125$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $453a12ddee1c3125$var$_formDataSupportsSubmitter = true;
    }
    return $453a12ddee1c3125$var$_formDataSupportsSubmitter;
}
var $453a12ddee1c3125$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $453a12ddee1c3125$var$getFormEncType(encType) {
    if (encType != null && !$453a12ddee1c3125$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $453a12ddee1c3125$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($453a12ddee1c3125$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $7jR2L.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $453a12ddee1c3125$var$defaultMethod;
        encType = $453a12ddee1c3125$var$getFormEncType(target.getAttribute("enctype")) || $453a12ddee1c3125$var$defaultEncType;
        formData = new FormData(target);
    } else if ($453a12ddee1c3125$var$isButtonElement(target) || $453a12ddee1c3125$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $7jR2L.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $453a12ddee1c3125$var$defaultMethod;
        encType = $453a12ddee1c3125$var$getFormEncType(target.getAttribute("formenctype")) || $453a12ddee1c3125$var$getFormEncType(form.getAttribute("enctype")) || $453a12ddee1c3125$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$453a12ddee1c3125$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($453a12ddee1c3125$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $453a12ddee1c3125$var$defaultMethod;
        action = null;
        encType = $453a12ddee1c3125$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $453a12ddee1c3125$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $453a12ddee1c3125$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $453a12ddee1c3125$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $453a12ddee1c3125$export$1f3f55432a00e06d(routes, opts) {
    return (0, $7jR2L.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $453a12ddee1c3125$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7jR2L.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $453a12ddee1c3125$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $awSZB.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $453a12ddee1c3125$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $7jR2L.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $453a12ddee1c3125$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7jR2L.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $453a12ddee1c3125$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $awSZB.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $453a12ddee1c3125$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $453a12ddee1c3125$var$_extends({}, state, {
        errors: $453a12ddee1c3125$var$deserializeErrors(state.errors)
    });
    return state;
}
function $453a12ddee1c3125$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $7jR2L.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $453a12ddee1c3125$var$START_TRANSITION = "startTransition";
var $453a12ddee1c3125$var$startTransitionImpl = $3aC2T[$453a12ddee1c3125$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $453a12ddee1c3125$export$9ba4e89fdfa1fc54(_ref) {
    var basename = _ref.basename, children = _ref.children, future = _ref.future, _$window = _ref.window;
    var historyRef = $3aC2T.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7jR2L.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $aSMts._)($3aC2T.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $3aC2T.useCallback(function(newState) {
        v7_startTransition && $453a12ddee1c3125$var$startTransitionImpl ? $453a12ddee1c3125$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3aC2T.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3aC2T.createElement((0, $awSZB.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $453a12ddee1c3125$export$7221d69dcfc8e36b(_ref2) {
    var basename = _ref2.basename, children = _ref2.children, future = _ref2.future, _$window = _ref2.window;
    var historyRef = $3aC2T.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7jR2L.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $aSMts._)($3aC2T.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $3aC2T.useCallback(function(newState) {
        v7_startTransition && $453a12ddee1c3125$var$startTransitionImpl ? $453a12ddee1c3125$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3aC2T.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3aC2T.createElement((0, $awSZB.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $453a12ddee1c3125$export$eefb0c834599897e(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, future = _ref3.future, history = _ref3.history;
    var _React_useState = (0, $aSMts._)($3aC2T.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $3aC2T.useCallback(function(newState) {
        v7_startTransition && $453a12ddee1c3125$var$startTransitionImpl ? $453a12ddee1c3125$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3aC2T.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3aC2T.createElement((0, $awSZB.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
var $453a12ddee1c3125$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $453a12ddee1c3125$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ var $453a12ddee1c3125$export$a6c7ac8248d6e38a = /*#__PURE__*/ $3aC2T.forwardRef(function LinkWithRef(_ref4, ref) {
    var handleClick = function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    };
    var onClick = _ref4.onClick, relative = _ref4.relative, reloadDocument = _ref4.reloadDocument, replace = _ref4.replace, state = _ref4.state, target = _ref4.target, to = _ref4.to, preventScrollReset = _ref4.preventScrollReset, rest = $453a12ddee1c3125$var$_objectWithoutPropertiesLoose(_ref4, $453a12ddee1c3125$var$_excluded);
    var basename = $3aC2T.useContext((0, $awSZB.UNSAFE_NavigationContext)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $453a12ddee1c3125$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($453a12ddee1c3125$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $7jR2L.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $awSZB.useHref)(to, {
        relative: relative
    });
    var internalOnClick = $453a12ddee1c3125$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $3aC2T.createElement("a", $453a12ddee1c3125$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $453a12ddee1c3125$export$b0d92dbee9b5b60d = /*#__PURE__*/ $3aC2T.forwardRef(function NavLinkWithRef(_ref5, ref) {
    var tmp = _ref5["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref5_caseSensitive = _ref5.caseSensitive, caseSensitive = _ref5_caseSensitive === void 0 ? false : _ref5_caseSensitive, tmp1 = _ref5.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref5_end = _ref5.end, end = _ref5_end === void 0 ? false : _ref5_end, styleProp = _ref5.style, to = _ref5.to, children = _ref5.children, rest = $453a12ddee1c3125$var$_objectWithoutPropertiesLoose(_ref5, $453a12ddee1c3125$var$_excluded2);
    var path = (0, $awSZB.useResolvedPath)(to, {
        relative: rest.relative
    });
    var location = (0, $awSZB.useLocation)();
    var routerState = $3aC2T.useContext((0, $awSZB.UNSAFE_DataRouterStateContext));
    var navigator = $3aC2T.useContext((0, $awSZB.UNSAFE_NavigationContext)).navigator;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $3aC2T.createElement($453a12ddee1c3125$export$a6c7ac8248d6e38a, $453a12ddee1c3125$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $453a12ddee1c3125$export$a7fed597f4b8afd8 = /*#__PURE__*/ $3aC2T.forwardRef(function(props, ref) {
    var submit = $453a12ddee1c3125$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $3aC2T.createElement($453a12ddee1c3125$var$FormImpl, $453a12ddee1c3125$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
var $453a12ddee1c3125$var$FormImpl = /*#__PURE__*/ $3aC2T.forwardRef(function(_ref6, forwardedRef) {
    var reloadDocument = _ref6.reloadDocument, replace = _ref6.replace, state = _ref6.state, _ref6_method = _ref6.method, method = _ref6_method === void 0 ? $453a12ddee1c3125$var$defaultMethod : _ref6_method, action = _ref6.action, onSubmit = _ref6.onSubmit, submit = _ref6.submit, relative = _ref6.relative, preventScrollReset = _ref6.preventScrollReset, props = $453a12ddee1c3125$var$_objectWithoutPropertiesLoose(_ref6, $453a12ddee1c3125$var$_excluded3);
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var formAction = $453a12ddee1c3125$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $3aC2T.createElement("form", $453a12ddee1c3125$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $453a12ddee1c3125$export$11aac1aab828f1fa(_ref7) {
    var getKey = _ref7.getKey, storageKey = _ref7.storageKey;
    $453a12ddee1c3125$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $453a12ddee1c3125$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($453a12ddee1c3125$var$DataRouterHook || ($453a12ddee1c3125$var$DataRouterHook = {}));
var $453a12ddee1c3125$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($453a12ddee1c3125$var$DataRouterStateHook || ($453a12ddee1c3125$var$DataRouterStateHook = {}));
function $453a12ddee1c3125$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $453a12ddee1c3125$var$useDataRouterContext(hookName) {
    var ctx = $3aC2T.useContext((0, $awSZB.UNSAFE_DataRouterContext));
    !ctx && (0, $7jR2L.UNSAFE_invariant)(false);
    return ctx;
}
function $453a12ddee1c3125$var$useDataRouterState(hookName) {
    var state = $3aC2T.useContext((0, $awSZB.UNSAFE_DataRouterStateContext));
    !state && (0, $7jR2L.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $453a12ddee1c3125$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative;
    var navigate = (0, $awSZB.useNavigate)();
    var location = (0, $awSZB.useLocation)();
    var path = (0, $awSZB.useResolvedPath)(to, {
        relative: relative
    });
    return $3aC2T.useCallback(function(event) {
        if ($453a12ddee1c3125$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $7jR2L.createPath)(location) === (0, $7jR2L.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $453a12ddee1c3125$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $3aC2T.useRef($453a12ddee1c3125$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $3aC2T.useRef(false);
    var location = (0, $awSZB.useLocation)();
    var searchParams = $3aC2T.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $453a12ddee1c3125$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $awSZB.useNavigate)();
    var setSearchParams = $3aC2T.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $453a12ddee1c3125$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $453a12ddee1c3125$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $453a12ddee1c3125$export$47c85c6e3a081d3() {
    var router = $453a12ddee1c3125$var$useDataRouterContext($453a12ddee1c3125$var$DataRouterHook.UseSubmit).router;
    var basename = $3aC2T.useContext((0, $awSZB.UNSAFE_NavigationContext)).basename;
    var currentRouteId = (0, $awSZB.UNSAFE_useRouteId)();
    return $3aC2T.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $453a12ddee1c3125$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $453a12ddee1c3125$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $453a12ddee1c3125$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    var router = $453a12ddee1c3125$var$useDataRouterContext($453a12ddee1c3125$var$DataRouterHook.UseSubmitFetcher).router;
    var basename = $3aC2T.useContext((0, $awSZB.UNSAFE_NavigationContext)).basename;
    return $3aC2T.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $453a12ddee1c3125$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $453a12ddee1c3125$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        !(fetcherRouteId != null) && (0, $7jR2L.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $453a12ddee1c3125$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $3aC2T.useContext((0, $awSZB.UNSAFE_NavigationContext)).basename;
    var routeContext = $3aC2T.useContext((0, $awSZB.UNSAFE_RouteContext));
    !routeContext && (0, $7jR2L.UNSAFE_invariant)(false);
    var _routeContext_matches_slice = (0, $aSMts._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $453a12ddee1c3125$var$_extends({}, (0, $awSZB.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $awSZB.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            var params = new URLSearchParams(path.search);
            params["delete"]("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7jR2L.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $7jR2L.createPath)(path);
}
function $453a12ddee1c3125$var$createFetcherForm(fetcherKey, routeId) {
    var FetcherForm = /*#__PURE__*/ $3aC2T.forwardRef(function(props, ref) {
        var submit = $453a12ddee1c3125$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $3aC2T.createElement($453a12ddee1c3125$var$FormImpl, $453a12ddee1c3125$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
var $453a12ddee1c3125$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $453a12ddee1c3125$export$5b0d2d9a9921565a() {
    var _route$matches;
    var router = $453a12ddee1c3125$var$useDataRouterContext($453a12ddee1c3125$var$DataRouterHook.UseFetcher).router;
    var route = $3aC2T.useContext((0, $awSZB.UNSAFE_RouteContext));
    !route && (0, $7jR2L.UNSAFE_invariant)(false);
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $7jR2L.UNSAFE_invariant)(false);
    var _React_useState = (0, $aSMts._)($3aC2T.useState(function() {
        return String(++$453a12ddee1c3125$var$fetcherId);
    }), 1), fetcherKey = _React_useState[0];
    var _React_useState1 = (0, $aSMts._)($3aC2T.useState(function() {
        !routeId && (0, $7jR2L.UNSAFE_invariant)(false);
        return $453a12ddee1c3125$var$createFetcherForm(fetcherKey, routeId);
    }), 1), Form = _React_useState1[0];
    var _React_useState2 = (0, $aSMts._)($3aC2T.useState(function() {
        return function(href) {
            !router && (0, $7jR2L.UNSAFE_invariant)(false);
            !routeId && (0, $7jR2L.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        };
    }), 1), load = _React_useState2[0];
    var submit = $453a12ddee1c3125$var$useSubmitFetcher(fetcherKey, routeId);
    var fetcher = router.getFetcher(fetcherKey);
    var fetcherWithComponents = $3aC2T.useMemo(function() {
        return $453a12ddee1c3125$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher);
    }, [
        fetcher,
        Form,
        submit,
        load
    ]);
    $3aC2T.useEffect(function() {
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return function() {
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $453a12ddee1c3125$export$fa996778a3a31087() {
    var state = $453a12ddee1c3125$var$useDataRouterState($453a12ddee1c3125$var$DataRouterStateHook.UseFetchers);
    return (0, $dHvbf._)(state.fetchers.values());
}
var $453a12ddee1c3125$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $453a12ddee1c3125$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $453a12ddee1c3125$export$25057cfe5591e3e9(_temp3) {
    var _ref = _temp3 === void 0 ? {} : _temp3, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $453a12ddee1c3125$var$useDataRouterContext($453a12ddee1c3125$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $453a12ddee1c3125$var$useDataRouterState($453a12ddee1c3125$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $3aC2T.useContext((0, $awSZB.UNSAFE_NavigationContext)).basename;
    var location = (0, $awSZB.useLocation)();
    var matches = (0, $awSZB.useMatches)();
    var navigation = (0, $awSZB.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $3aC2T.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $453a12ddee1c3125$var$usePageHide($3aC2T.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $453a12ddee1c3125$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $453a12ddee1c3125$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($453a12ddee1c3125$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3aC2T.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $453a12ddee1c3125$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $453a12ddee1c3125$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3aC2T.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($453a12ddee1c3125$var$_extends({}, location, {
                    pathname: (0, $7jR2L.stripBasename)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($453a12ddee1c3125$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3aC2T.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $453a12ddee1c3125$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $3aC2T.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $453a12ddee1c3125$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $3aC2T.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $453a12ddee1c3125$export$39f4eb3dbd812741(_ref8) {
    var when = _ref8.when, message = _ref8.message;
    var blocker = (0, $awSZB.unstable_useBlocker)(when);
    $3aC2T.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $3aC2T.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}

});
parcelRequire.register("7jR2L", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $55437416549418ff$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $55437416549418ff$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $55437416549418ff$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $55437416549418ff$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $55437416549418ff$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $55437416549418ff$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $55437416549418ff$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $55437416549418ff$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $55437416549418ff$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $55437416549418ff$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $55437416549418ff$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $55437416549418ff$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", function () { return $55437416549418ff$export$90ba53ce1c7fdff2; });
$parcel$export(module.exports, "resolveTo", function () { return $55437416549418ff$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $55437416549418ff$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $55437416549418ff$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $55437416549418ff$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $55437416549418ff$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $55437416549418ff$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.9.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $2iBlG = parcelRequire("2iBlG");

var $1atwj = parcelRequire("1atwj");

var $aSMts = parcelRequire("aSMts");

var $cOVqQ = parcelRequire("cOVqQ");

var $dHvbf = parcelRequire("dHvbf");

var $jc6v0 = parcelRequire("jc6v0");

var $iD0Am = parcelRequire("iD0Am");

var $1XfpH = parcelRequire("1XfpH");

var $1XfpH = parcelRequire("1XfpH");
function $55437416549418ff$var$_extends() {
    $55437416549418ff$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55437416549418ff$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55437416549418ff$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55437416549418ff$export$e19cd5f9376f8cee || ($55437416549418ff$export$e19cd5f9376f8cee = {}));
var $55437416549418ff$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55437416549418ff$export$2b76ad033c6e6d08(options) {
    var clampIndex = function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    };
    var getCurrentLocation = function getCurrentLocation() {
        return entries[index];
    };
    var createMemoryLocation = function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $55437416549418ff$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55437416549418ff$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    };
    var createHref = function createHref(to) {
        return typeof to === "string" ? to : $55437416549418ff$export$fe53371bee54353d(to);
    };
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $55437416549418ff$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $55437416549418ff$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55437416549418ff$export$719fc203c4e16dee(options) {
    var createBrowserLocation = function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $55437416549418ff$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    };
    var createBrowserHref = function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55437416549418ff$export$fe53371bee54353d(to);
    };
    if (options === void 0) options = {};
    return $55437416549418ff$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55437416549418ff$export$b71fdd3798280242(options) {
    var createHashLocation = function createHashLocation(window1, globalHistory) {
        var _parsePath = $55437416549418ff$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55437416549418ff$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    };
    var createHashHref = function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55437416549418ff$export$fe53371bee54353d(to));
    };
    var validateHashLocation = function validateHashLocation(location, to) {
        $55437416549418ff$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    };
    if (options === void 0) options = {};
    return $55437416549418ff$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55437416549418ff$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55437416549418ff$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55437416549418ff$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55437416549418ff$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55437416549418ff$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $55437416549418ff$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55437416549418ff$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55437416549418ff$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55437416549418ff$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55437416549418ff$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    var getIndex = function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    };
    var handlePop = function handlePop() {
        action = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    };
    var push = function push(to, state) {
        action = $55437416549418ff$export$e19cd5f9376f8cee.Push;
        var location = $55437416549418ff$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $55437416549418ff$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    };
    var replace = function replace(to, state) {
        action = $55437416549418ff$export$e19cd5f9376f8cee.Replace;
        var location = $55437416549418ff$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $55437416549418ff$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    };
    var createURL = function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $55437416549418ff$export$fe53371bee54353d(to);
        $55437416549418ff$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    };
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55437416549418ff$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55437416549418ff$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($55437416549418ff$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55437416549418ff$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55437416549418ff$var$ResultType || ($55437416549418ff$var$ResultType = {}));
var $55437416549418ff$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55437416549418ff$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55437416549418ff$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $dHvbf._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55437416549418ff$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55437416549418ff$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($55437416549418ff$var$isIndexRoute(route)) {
            var indexRoute = $55437416549418ff$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $55437416549418ff$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55437416549418ff$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $55437416549418ff$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $55437416549418ff$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $55437416549418ff$var$flattenRoutes(routes);
    $55437416549418ff$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $55437416549418ff$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $55437416549418ff$var$safelyDecodeURI(pathname));
    return matches;
}
function $55437416549418ff$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55437416549418ff$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55437416549418ff$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $55437416549418ff$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55437416549418ff$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $55437416549418ff$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55437416549418ff$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $55437416549418ff$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55437416549418ff$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $cOVqQ._)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $55437416549418ff$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $dHvbf._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $dHvbf._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $55437416549418ff$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $55437416549418ff$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $55437416549418ff$var$paramRe = /^:\w+$/;
var $55437416549418ff$var$dynamicSegmentValue = 3;
var $55437416549418ff$var$indexRouteValue = 2;
var $55437416549418ff$var$emptySegmentValue = 1;
var $55437416549418ff$var$staticSegmentValue = 10;
var $55437416549418ff$var$splatPenalty = -2;
var $55437416549418ff$var$isSplat = function(s) {
    return s === "*";
};
function $55437416549418ff$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($55437416549418ff$var$isSplat)) initialScore += $55437416549418ff$var$splatPenalty;
    if (index) initialScore += $55437416549418ff$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$55437416549418ff$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($55437416549418ff$var$paramRe.test(segment) ? $55437416549418ff$var$dynamicSegmentValue : segment === "" ? $55437416549418ff$var$emptySegmentValue : $55437416549418ff$var$staticSegmentValue);
    }, initialScore);
}
function $55437416549418ff$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55437416549418ff$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $55437416549418ff$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55437416549418ff$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55437416549418ff$export$a5c6d149b50c1d86($55437416549418ff$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55437416549418ff$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $55437416549418ff$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55437416549418ff$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $aSMts._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $55437416549418ff$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $55437416549418ff$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $aSMts._)($55437416549418ff$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], paramNames = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = paramNames.reduce(function(memo, paramName, index) {
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $55437416549418ff$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55437416549418ff$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55437416549418ff$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var paramNames = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, function(_, paramName) {
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $55437416549418ff$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $55437416549418ff$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $55437416549418ff$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $55437416549418ff$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55437416549418ff$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $55437416549418ff$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $55437416549418ff$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $55437416549418ff$var$normalizeSearch(search),
        hash: $55437416549418ff$var$normalizeHash(hash)
    };
}
function $55437416549418ff$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55437416549418ff$var$getInvalidPathError(_char, field, dest, path) {
    return "Cannot include a '" + _char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55437416549418ff$export$90ba53ce1c7fdff2(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
/**
 * @private
 */ function $55437416549418ff$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $55437416549418ff$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55437416549418ff$var$_extends({}, toArg);
        $55437416549418ff$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55437416549418ff$var$getInvalidPathError("?", "pathname", "search", to));
        $55437416549418ff$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55437416549418ff$var$getInvalidPathError("#", "pathname", "hash", to));
        $55437416549418ff$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55437416549418ff$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $55437416549418ff$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55437416549418ff$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $55437416549418ff$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $55437416549418ff$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $55437416549418ff$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $55437416549418ff$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $55437416549418ff$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55437416549418ff$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $55437416549418ff$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $1atwj._)(AbortedDeferredError, Error1);
    var _super = (0, $iD0Am._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $50OuQ._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $jc6v0._)(Error));
var $55437416549418ff$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $50OuQ._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55437416549418ff$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $55437416549418ff$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref) {
            var _$_ref = (0, $aSMts._)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            return Object.assign(acc, (0, $2iBlG._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $fGdZr._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise["catch"](function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $55437416549418ff$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet["delete"](key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers["delete"](fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet["delete"](k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var aborted, onAbort;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $55437416549418ff$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref2) {
                    var _$_ref2 = (0, $aSMts._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
                    return Object.assign(acc, (0, $2iBlG._)({}, key, $55437416549418ff$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $55437416549418ff$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55437416549418ff$var$unwrapTrackedPromise(value) {
    if (!$55437416549418ff$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $55437416549418ff$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55437416549418ff$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $55437416549418ff$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55437416549418ff$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $55437416549418ff$export$a6cd19cd1951a23c = function(url, init) {
    var response = $55437416549418ff$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ var $55437416549418ff$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $50OuQ._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55437416549418ff$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $55437416549418ff$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $55437416549418ff$var$validMutationMethods = new Set($55437416549418ff$var$validMutationMethodsArr);
var $55437416549418ff$var$validRequestMethodsArr = [
    "get"
].concat((0, $dHvbf._)($55437416549418ff$var$validMutationMethodsArr));
var $55437416549418ff$var$validRequestMethods = new Set($55437416549418ff$var$validRequestMethodsArr);
var $55437416549418ff$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $55437416549418ff$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $55437416549418ff$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $55437416549418ff$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $55437416549418ff$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $55437416549418ff$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $55437416549418ff$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55437416549418ff$export$baddd0131ee8c05b(init) {
    var initialize = // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $55437416549418ff$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55437416549418ff$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55437416549418ff$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    };
    var dispose = // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    };
    var subscribe = // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers["delete"](fn);
        };
    };
    var updateState = // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $55437416549418ff$var$_extends({}, state, newState);
        subscribers.forEach(function(subscriber) {
            return subscriber(state);
        });
    };
    var completeNavigation = // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $55437416549418ff$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $55437416549418ff$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $55437416549418ff$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55437416549418ff$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55437416549418ff$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55437416549418ff$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55437416549418ff$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($55437416549418ff$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55437416549418ff$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    };
    var revalidate = // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    };
    var getFetcher = function getFetcher(key) {
        return state.fetchers.get(key) || $55437416549418ff$export$52eace9c284d3585;
    };
    var fetch = // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $55437416549418ff$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        var matches = $55437416549418ff$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $55437416549418ff$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        var _normalizeNavigateOptions = $55437416549418ff$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        var match = $55437416549418ff$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55437416549418ff$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    };
    var interruptActiveLoads = function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $dHvbf._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    };
    var setFetcherError = function setFetcherError(key, routeId, error) {
        var boundaryMatch = $55437416549418ff$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $2iBlG._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        });
    };
    var deleteFetcher = function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches["delete"](key);
        fetchReloadIds["delete"](key);
        fetchRedirectIds["delete"](key);
        state.fetchers["delete"](key);
    };
    var abortFetcher = function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $55437416549418ff$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers["delete"](key);
    };
    var markFetchersDone = function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $55437416549418ff$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var markFetchRedirectsDone = function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $55437416549418ff$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds["delete"](key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    };
    var abortStaleFetchLoads = function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $55437416549418ff$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds["delete"](key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    };
    var getBlocker = function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $55437416549418ff$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    };
    var deleteBlocker = function deleteBlocker(key) {
        state.blockers["delete"](key);
        blockerFunctions["delete"](key);
    };
    var updateBlocker = // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $55437416549418ff$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55437416549418ff$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    };
    var shouldBlockNavigation = function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55437416549418ff$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $aSMts._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    };
    var cancelActiveDeferreds = function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds["delete"](routeId);
            }
        });
        return cancelledRouteIds;
    };
    var enableScrollRestoration = // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55437416549418ff$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    };
    var getScrollKey = function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $55437416549418ff$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    };
    var saveScrollPosition = function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    };
    var getSavedScrollPosition = function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    };
    var _internalSetRoutes = function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55437416549418ff$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    };
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $55437416549418ff$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $55437416549418ff$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $55437416549418ff$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $55437416549418ff$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $55437416549418ff$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $55437416549418ff$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $55437416549418ff$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $2iBlG._)({}, route.id, error);
    }
    var initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some(function(m) {
        return m.route.lazy;
    }) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some(function(m) {
        return m.route.loader;
    }) || init.hydrationData != null);
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55437416549418ff$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $5Pgs2._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, blockerKey;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $55437416549418ff$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $55437416549418ff$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $55437416549418ff$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $55437416549418ff$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $55437416549418ff$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $55437416549418ff$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $55437416549418ff$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $55437416549418ff$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $55437416549418ff$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $5Pgs2._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $55437416549418ff$export$2708184779ceb39d(routesToUse, location, basename);
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $55437416549418ff$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $55437416549418ff$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $2iBlG._)({}, route.id, error)
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $55437416549418ff$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55437416549418ff$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $55437416549418ff$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $2iBlG._)({}, $55437416549418ff$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $55437416549418ff$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $55437416549418ff$var$getLoadingNavigation(location, opts.submission);
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $55437416549418ff$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $5Pgs2._)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        navigation = $55437416549418ff$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        });
                        actionMatch = $55437416549418ff$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $55437416549418ff$var$ResultType.error,
                            error: $55437416549418ff$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $55437416549418ff$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$55437416549418ff$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($55437416549418ff$var$isErrorResult(result)) {
                            boundaryMatch = $55437416549418ff$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $55437416549418ff$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $2iBlG._)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($55437416549418ff$var$isDeferredResult(result)) throw $55437416549418ff$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $2iBlG._)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $5Pgs2._)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation || $55437416549418ff$var$getLoadingNavigation(location, submission);
                        activeSubmission = submission || fetcherSubmission || $55437416549418ff$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $aSMts._)($55437416549418ff$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $55437416549418ff$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        if (!isUninterruptedRevalidation) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $55437416549418ff$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($55437416549418ff$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers["delete"](rf.key);
                        });
                        redirect = $55437416549418ff$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(state, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        _processLoaderData = $55437416549418ff$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds["delete"](routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $55437416549418ff$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $5Pgs2._)(function(key, routeId, path, match, requestMatches, submission) {
            var error, existingFetcher, fetcher, abortController, fetchRequest, originatingLoadId, actionResult, doneFetcher, loadingFetcher, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher1, didAbortFetchLoads;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches["delete"](key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $55437416549418ff$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error);
                            return [
                                2
                            ];
                        }
                        existingFetcher = state.fetchers.get(key);
                        fetcher = $55437416549418ff$var$getSubmittingFetcher(submission, existingFetcher);
                        state.fetchers.set(key, fetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortController = new AbortController();
                        fetchRequest = $55437416549418ff$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $55437416549418ff$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by ou our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers["delete"](key);
                            return [
                                2
                            ];
                        }
                        if ($55437416549418ff$var$isRedirectResult(actionResult)) {
                            fetchControllers["delete"](key);
                            if (pendingNavigationLoadId > originatingLoadId) {
                                doneFetcher = $55437416549418ff$var$getDoneFetcher(undefined);
                                state.fetchers.set(key, doneFetcher);
                                updateState({
                                    fetchers: new Map(state.fetchers)
                                });
                                return [
                                    2
                                ];
                            } else {
                                fetchRedirectIds.add(key);
                                loadingFetcher = $55437416549418ff$var$getLoadingFetcher(submission);
                                state.fetchers.set(key, loadingFetcher);
                                updateState({
                                    fetchers: new Map(state.fetchers)
                                });
                                return [
                                    2,
                                    startRedirectNavigation(state, actionResult, {
                                        fetcherSubmission: submission
                                    })
                                ];
                            }
                        }
                        // Process any non-redirect errors thrown
                        if ($55437416549418ff$var$isErrorResult(actionResult)) {
                            setFetcherError(key, routeId, actionResult.error);
                            return [
                                2
                            ];
                        }
                        if ($55437416549418ff$var$isDeferredResult(actionResult)) throw $55437416549418ff$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $55437416549418ff$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $55437416549418ff$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $55437416549418ff$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $55437416549418ff$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $aSMts._)($55437416549418ff$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $2iBlG._)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $55437416549418ff$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds["delete"](key);
                        fetchControllers["delete"](key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers["delete"](r.key);
                        });
                        redirect = $55437416549418ff$var$findRedirect(results);
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(state, redirect.result)
                            ];
                        }
                        _processLoaderData = $55437416549418ff$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher1 = $55437416549418ff$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher1);
                        }
                        didAbortFetchLoads = abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $55437416549418ff$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState($55437416549418ff$var$_extends({
                                errors: errors,
                                loaderData: $55437416549418ff$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
                            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $5Pgs2._)(function(key, routeId, path, match, matches, submission) {
            var existingFetcher, loadingFetcher, abortController, fetchRequest, originatingLoadId, result, doneFetcher, boundaryMatch, doneFetcher1;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        loadingFetcher = $55437416549418ff$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
                        state.fetchers.set(key, loadingFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortController = new AbortController();
                        fetchRequest = $55437416549418ff$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $55437416549418ff$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$55437416549418ff$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $55437416549418ff$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers["delete"](key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (!$55437416549418ff$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        doneFetcher = $55437416549418ff$var$getDoneFetcher(undefined);
                        state.fetchers.set(key, doneFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($55437416549418ff$var$isErrorResult(result)) {
                            boundaryMatch = $55437416549418ff$var$findNearestBoundary(state.matches, routeId);
                            state.fetchers["delete"](key);
                            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
                            // do we need to behave any differently with our non-redirect errors?
                            // What if it was a non-redirect Response?
                            updateState({
                                fetchers: new Map(state.fetchers),
                                errors: (0, $2iBlG._)({}, boundaryMatch.route.id, result.error)
                            });
                            return [
                                2
                            ];
                        }
                        $55437416549418ff$export$3e9cee6b33872309(!$55437416549418ff$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        doneFetcher1 = $55437416549418ff$var$getDoneFetcher(result.data);
                        state.fetchers.set(key, doneFetcher1);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $5Pgs2._)(function(state, redirect, _temp) {
            var _ref, submission, fetcherSubmission, replace, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp === void 0 ? {} : _temp, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $55437416549418ff$var$createLocation(state.location, redirect.location, {
                            _isRedirect: true
                        });
                        $55437416549418ff$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($55437416549418ff$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                                url = init.history.createURL(redirect.location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $55437416549418ff$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $55437416549418ff$export$e19cd5f9376f8cee.Replace : $55437416549418ff$export$e19cd5f9376f8cee.Push;
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55437416549418ff$var$getSubmissionFromNavigation(state.navigation);
                        activeSubmission = submission || fetcherSubmission;
                        if (!($55437416549418ff$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $55437416549418ff$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $55437416549418ff$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        overrideNavigation = $55437416549418ff$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $5Pgs2._)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $dHvbf._)(matchesToLoad.map(function(match) {
                                return $55437416549418ff$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename);
                            })).concat((0, $dHvbf._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $55437416549418ff$var$callLoaderOrAction("loader", $55437416549418ff$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                                else {
                                    var error = {
                                        type: $55437416549418ff$var$ResultType.error,
                                        error: $55437416549418ff$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $55437416549418ff$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $55437416549418ff$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $55437416549418ff$export$4d0306f8f6a4585b = Symbol("deferred");
function $55437416549418ff$export$3336b097a6fbc59a(routes, opts) {
    $55437416549418ff$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $55437416549418ff$var$defaultMapRouteProperties;
    var dataRoutes = $55437416549418ff$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp2) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $5Pgs2._)(function(request, _temp2) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp2 === void 0 ? {} : _temp2).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $55437416549418ff$var$createLocation("", $55437416549418ff$export$fe53371bee54353d(url), null, "default");
                        matches = $55437416549418ff$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$55437416549418ff$var$isValidMethod(method) && method !== "HEAD") {
                            error = $55437416549418ff$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $55437416549418ff$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $2iBlG._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $55437416549418ff$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $55437416549418ff$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $2iBlG._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($55437416549418ff$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $55437416549418ff$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp3) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $5Pgs2._)(function(request, _temp3) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $55437416549418ff$var$createLocation("", $55437416549418ff$export$fe53371bee54353d(url), null, "default");
                        matches = $55437416549418ff$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$55437416549418ff$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55437416549418ff$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $55437416549418ff$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $55437416549418ff$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $55437416549418ff$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $55437416549418ff$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($55437416549418ff$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55437416549418ff$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $5Pgs2._)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $55437416549418ff$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$55437416549418ff$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $55437416549418ff$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $55437416549418ff$var$isResponse(result1) ? result1 : $55437416549418ff$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($55437416549418ff$var$isQueryRouteResponse(e)) {
                            if (e.type === $55437416549418ff$var$ResultType.error) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($55437416549418ff$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $5Pgs2._)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $55437416549418ff$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $55437416549418ff$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $55437416549418ff$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
                        }
                        _state.label = 3;
                    case 3:
                        if ($55437416549418ff$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($55437416549418ff$var$isDeferredResult(result)) {
                            error1 = $55437416549418ff$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $55437416549418ff$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($55437416549418ff$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $2iBlG._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$55437416549418ff$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        boundaryMatch = $55437416549418ff$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $2iBlG._)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $55437416549418ff$var$_extends({}, context, {
                                statusCode: $55437416549418ff$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $55437416549418ff$var$_extends({}, result.headers ? (0, $2iBlG._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $55437416549418ff$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $2iBlG._)({}, actionMatch.route.id, result.data),
                                actionHeaders: $55437416549418ff$var$_extends({}, result.headers ? (0, $2iBlG._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $5Pgs2._)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55437416549418ff$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $55437416549418ff$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $2iBlG._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $dHvbf._)(matchesToLoad.map(function(match) {
                                return $55437416549418ff$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
                        }
                        activeDeferreds = new Map();
                        context = $55437416549418ff$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $55437416549418ff$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55437416549418ff$export$fec11da027c70692(routes, context, error) {
    var newContext = $55437416549418ff$var$_extends({}, context, {
        statusCode: 500,
        errors: (0, $2iBlG._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $55437416549418ff$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55437416549418ff$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $55437416549418ff$export$cae722b0cc860f13(to ? to : ".", $55437416549418ff$export$90ba53ce1c7fdff2(contextualMatches).map(function(m) {
        return m.pathnameBase;
    }), $55437416549418ff$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$55437416549418ff$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55437416549418ff$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55437416549418ff$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55437416549418ff$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55437416549418ff$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55437416549418ff$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55437416549418ff$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $55437416549418ff$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $55437416549418ff$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55437416549418ff$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $aSMts._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55437416549418ff$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55437416549418ff$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $55437416549418ff$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55437416549418ff$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55437416549418ff$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55437416549418ff$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55437416549418ff$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $55437416549418ff$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55437416549418ff$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55437416549418ff$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $55437416549418ff$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $55437416549418ff$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $55437416549418ff$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($55437416549418ff$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $55437416549418ff$var$shouldRevalidateLoader(match, $55437416549418ff$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55437416549418ff$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some(function(m) {
            return m.route.id === f.routeId;
        })) return;
        var fetcherMatches = $55437416549418ff$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $55437416549418ff$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55437416549418ff$var$shouldRevalidateLoader(fetcherMatch, $55437416549418ff$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55437416549418ff$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55437416549418ff$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55437416549418ff$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $55437416549418ff$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $55437416549418ff$var$_loadLazyRouteModule.apply(this, arguments);
}
function $55437416549418ff$var$_loadLazyRouteModule() {
    $55437416549418ff$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $5Pgs2._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $55437416549418ff$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $55437416549418ff$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$55437416549418ff$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $55437416549418ff$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $55437416549418ff$var$_loadLazyRouteModule.apply(this, arguments);
}
function $55437416549418ff$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    return $55437416549418ff$var$_callLoaderOrAction.apply(this, arguments);
}
function $55437416549418ff$var$_callLoaderOrAction() {
    $55437416549418ff$var$_callLoaderOrAction = (0, $5Pgs2._)(function(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
        var resultType, result, onReject, runHandler, handler, handlerError, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, queryRouteResponse, data, contentType, _result$init, _result$init2;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler)["catch"](function(e) {
                                handlerError = e;
                            }),
                            $55437416549418ff$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    if (handlerError) throw handlerError;
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $55437416549418ff$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $55437416549418ff$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $55437416549418ff$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $55437416549418ff$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $55437416549418ff$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $55437416549418ff$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$55437416549418ff$var$isResponse(result)) return [
                        3,
                        19
                    ];
                    status = result.status;
                    // Process redirects
                    if ($55437416549418ff$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $55437416549418ff$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$55437416549418ff$var$ABSOLUTE_URL_REGEX.test(location)) location = $55437416549418ff$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
                        else if (!opts.isStaticRequest) {
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $55437416549418ff$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $55437416549418ff$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) {
                        queryRouteResponse = {
                            type: resultType === $55437416549418ff$var$ResultType.error ? $55437416549418ff$var$ResultType.error : $55437416549418ff$var$ResultType.data,
                            response: result
                        };
                        throw queryRouteResponse;
                    }
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        result.json()
                    ];
                case 15:
                    data = _state.sent();
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.text()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    if (resultType === $55437416549418ff$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $55437416549418ff$export$6c6580e81da25755(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $55437416549418ff$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 19:
                    if (resultType === $55437416549418ff$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($55437416549418ff$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $55437416549418ff$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $55437416549418ff$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $55437416549418ff$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55437416549418ff$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($55437416549418ff$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $55437416549418ff$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55437416549418ff$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55437416549418ff$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $55437416549418ff$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $55437416549418ff$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $55437416549418ff$export$3e9cee6b33872309(!$55437416549418ff$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55437416549418ff$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $55437416549418ff$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55437416549418ff$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($55437416549418ff$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55437416549418ff$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $55437416549418ff$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $55437416549418ff$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($55437416549418ff$var$isErrorResult(result)) {
            var boundaryMatch = $55437416549418ff$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55437416549418ff$var$_extends({}, errors, (0, $2iBlG._)({}, boundaryMatch.route.id, result.error));
            state.fetchers["delete"](key);
        } else if ($55437416549418ff$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55437416549418ff$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55437416549418ff$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55437416549418ff$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $55437416549418ff$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55437416549418ff$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $55437416549418ff$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55437416549418ff$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $dHvbf._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $55437416549418ff$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55437416549418ff$var$getInternalRouterError(status, _temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $55437416549418ff$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55437416549418ff$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($55437416549418ff$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $55437416549418ff$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(path) : path;
    return $55437416549418ff$export$fe53371bee54353d($55437416549418ff$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55437416549418ff$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55437416549418ff$var$isDeferredResult(result) {
    return result.type === $55437416549418ff$var$ResultType.deferred;
}
function $55437416549418ff$var$isErrorResult(result) {
    return result.type === $55437416549418ff$var$ResultType.error;
}
function $55437416549418ff$var$isRedirectResult(result) {
    return (result && result.type) === $55437416549418ff$var$ResultType.redirect;
}
function $55437416549418ff$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55437416549418ff$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55437416549418ff$var$isRedirectResponse(result) {
    if (!$55437416549418ff$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55437416549418ff$var$isQueryRouteResponse(obj) {
    return obj && $55437416549418ff$var$isResponse(obj.response) && (obj.type === $55437416549418ff$var$ResultType.data || obj.type === $55437416549418ff$var$ResultType.error);
}
function $55437416549418ff$var$isValidMethod(method) {
    return $55437416549418ff$var$validRequestMethods.has(method.toLowerCase());
}
function $55437416549418ff$var$isMutationMethod(method) {
    return $55437416549418ff$var$validMutationMethods.has(method.toLowerCase());
}
function $55437416549418ff$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $55437416549418ff$var$_resolveDeferredResults.apply(this, arguments);
}
function $55437416549418ff$var$_resolveDeferredResults() {
    $55437416549418ff$var$_resolveDeferredResults = (0, $5Pgs2._)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $1XfpH.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$55437416549418ff$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($55437416549418ff$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    signal = signals[index];
                                    $55437416549418ff$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $55437416549418ff$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $1XfpH.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $55437416549418ff$var$_resolveDeferredResults.apply(this, arguments);
}
function $55437416549418ff$var$resolveDeferredData(result, signal, unwrap) {
    return $55437416549418ff$var$_resolveDeferredData.apply(this, arguments);
}
function $55437416549418ff$var$_resolveDeferredData() {
    $55437416549418ff$var$_resolveDeferredData = (0, $5Pgs2._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $55437416549418ff$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $55437416549418ff$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $55437416549418ff$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $55437416549418ff$var$_resolveDeferredData.apply(this, arguments);
}
function $55437416549418ff$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $55437416549418ff$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55437416549418ff$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $55437416549418ff$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55437416549418ff$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55437416549418ff$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $55437416549418ff$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55437416549418ff$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $55437416549418ff$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55437416549418ff$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}

});
parcelRequire.register("50OuQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3a641f6367a2e6bd$export$2996f80ef42b8419; });
function $3a641f6367a2e6bd$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("fGdZr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b6a5a160ea364895$export$d60067ff2358eee8; });
function $b6a5a160ea364895$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b6a5a160ea364895$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $b6a5a160ea364895$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b6a5a160ea364895$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRequire.register("1atwj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0d9d9fb902e40dd3$export$7e4530ad35d3bb8; });

var $4USSx = parcelRequire("4USSx");
function $0d9d9fb902e40dd3$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $4USSx._set_prototype_of)(subClass, superClass);
}

});
parcelRequire.register("4USSx", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $3946f6227d05c830$export$c2c98ac76e997b63; });
function $3946f6227d05c830$export$c2c98ac76e997b63(o, p) {
    $3946f6227d05c830$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3946f6227d05c830$export$c2c98ac76e997b63(o, p);
}

});


parcelRequire.register("cOVqQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9556b458da292bff$export$e62c166da838fa3; });

var $jG3FW = parcelRequire("jG3FW");

var $2j9E4 = parcelRequire("2j9E4");

var $8V4Ru = parcelRequire("8V4Ru");

var $fXGmO = parcelRequire("fXGmO");
function $9556b458da292bff$export$e62c166da838fa3(arr) {
    return (0, $jG3FW._array_with_holes)(arr) || (0, $2j9E4._iterable_to_array)(arr) || (0, $fXGmO._unsupported_iterable_to_array)(arr) || (0, $8V4Ru._non_iterable_rest)();
}

});

parcelRequire.register("jc6v0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $df942de5c60d7946$export$2466d533fda16e33; });

var $kkvIW = parcelRequire("kkvIW");

var $bykok = parcelRequire("bykok");

var $lCPdn = parcelRequire("lCPdn");

var $4USSx = parcelRequire("4USSx");
function $df942de5c60d7946$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $df942de5c60d7946$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $lCPdn._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $kkvIW._construct)(Class, arguments, (0, $bykok._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $4USSx._set_prototype_of)(Wrapper, Class);
    };
    return $df942de5c60d7946$export$2466d533fda16e33(Class);
}

});
parcelRequire.register("kkvIW", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $ecce489e508aa395$export$2d841144c5f8c4ab; });

var $kW87r = parcelRequire("kW87r");

var $4USSx = parcelRequire("4USSx");
function $ecce489e508aa395$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $kW87r._is_native_reflect_construct)()) $ecce489e508aa395$export$2d841144c5f8c4ab = Reflect.construct;
    else $ecce489e508aa395$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $4USSx._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $ecce489e508aa395$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRequire.register("kW87r", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $f3df85b7abd0198b$export$685354647fba1516; });
function $f3df85b7abd0198b$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRequire.register("bykok", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $8692aff7579d247b$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $8692aff7579d247b$export$f09211a7d3c496a1; });
function $8692aff7579d247b$export$f09211a7d3c496a1(o) {
    $8692aff7579d247b$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8692aff7579d247b$export$f09211a7d3c496a1(o);
}

});

parcelRequire.register("lCPdn", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $fbe4dfc35693931c$export$514eda94019f4334; });
function $fbe4dfc35693931c$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRequire.register("iD0Am", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d8fc52c99c9971ba$export$8dd05c13f5255580; });

var $bykok = parcelRequire("bykok");

var $kW87r = parcelRequire("kW87r");

var $9FVhl = parcelRequire("9FVhl");
function $d8fc52c99c9971ba$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $kW87r._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $bykok._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $bykok._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9FVhl._possible_constructor_return)(this, result);
    };
}

});
parcelRequire.register("9FVhl", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $70b45fc14ae715f9$export$ef97c660ca164e52; });

var $dMjkN = parcelRequire("dMjkN");

var $qb7pP = parcelRequire("qb7pP");
function $70b45fc14ae715f9$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $qb7pP._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $dMjkN._assert_this_initialized)(self);
}

});
parcelRequire.register("dMjkN", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $a07ec17282910409$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $a07ec17282910409$export$f3b8ed2e4a5d10b8; });
function $a07ec17282910409$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});




parcelRequire.register("awSZB", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $7aa78ce6d363d479$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $7aa78ce6d363d479$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $7aa78ce6d363d479$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $7aa78ce6d363d479$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $7aa78ce6d363d479$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $7aa78ce6d363d479$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $7aa78ce6d363d479$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $7aa78ce6d363d479$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $7aa78ce6d363d479$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRouteError", function () { return $7aa78ce6d363d479$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $7aa78ce6d363d479$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $7aa78ce6d363d479$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $7aa78ce6d363d479$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "unstable_useBlocker", function () { return $7aa78ce6d363d479$export$2af03a1de5c0910; });
$parcel$export(module.exports, "RouterProvider", function () { return $7aa78ce6d363d479$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Router", function () { return $7aa78ce6d363d479$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Outlet", function () { return $7aa78ce6d363d479$export$910ae8079b2c2852; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $7aa78ce6d363d479$export$52b333d321859367; });
/**
 * React Router v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $iD0Am = parcelRequire("iD0Am");

var $3aC2T = parcelRequire("3aC2T");

var $7jR2L = parcelRequire("7jR2L");
function $7aa78ce6d363d479$var$_extends() {
    $7aa78ce6d363d479$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7aa78ce6d363d479$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $7aa78ce6d363d479$export$3add0d5dce533e2e = /*#__PURE__*/ $3aC2T.createContext(null);
var $7aa78ce6d363d479$export$145dfa71566a64dc = /*#__PURE__*/ $3aC2T.createContext(null);
var $7aa78ce6d363d479$var$AwaitContext = /*#__PURE__*/ $3aC2T.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $7aa78ce6d363d479$export$26749e8557646306 = /*#__PURE__*/ $3aC2T.createContext(null);
var $7aa78ce6d363d479$export$c7914228fb69b0f5 = /*#__PURE__*/ $3aC2T.createContext(null);
var $7aa78ce6d363d479$export$9072aa6dd1f93057 = /*#__PURE__*/ $3aC2T.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $7aa78ce6d363d479$var$RouteErrorContext = /*#__PURE__*/ $3aC2T.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7aa78ce6d363d479$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $7jR2L.UNSAFE_invariant)(false);
    var _React_useContext = $3aC2T.useContext($7aa78ce6d363d479$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $7aa78ce6d363d479$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $7jR2L.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7aa78ce6d363d479$export$9c954a9d03d32f4a() {
    return $3aC2T.useContext($7aa78ce6d363d479$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7aa78ce6d363d479$export$45d76561a5302f2b() {
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $7jR2L.UNSAFE_invariant)(false);
    return $3aC2T.useContext($7aa78ce6d363d479$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7aa78ce6d363d479$export$1b3f31771c5d07c() {
    return $3aC2T.useContext($7aa78ce6d363d479$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7aa78ce6d363d479$export$6c330e8992e8a295(pattern) {
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $7jR2L.UNSAFE_invariant)(false);
    var pathname = $7aa78ce6d363d479$export$45d76561a5302f2b().pathname;
    return $3aC2T.useMemo(function() {
        return (0, $7jR2L.matchPath)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $7aa78ce6d363d479$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7aa78ce6d363d479$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $3aC2T.useContext($7aa78ce6d363d479$export$26749e8557646306)["static"];
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3aC2T.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7aa78ce6d363d479$export$9770f232ac06a008() {
    var isDataRoute = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7aa78ce6d363d479$var$useNavigateStable() : $7aa78ce6d363d479$var$useNavigateUnstable();
}
function $7aa78ce6d363d479$var$useNavigateUnstable() {
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $7jR2L.UNSAFE_invariant)(false);
    var dataRouterContext = $3aC2T.useContext($7aa78ce6d363d479$export$3add0d5dce533e2e);
    var _React_useContext = $3aC2T.useContext($7aa78ce6d363d479$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var matches = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).matches;
    var _useLocation = $7aa78ce6d363d479$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $7jR2L.UNSAFE_getPathContributingMatches)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    var activeRef = $3aC2T.useRef(false);
    $7aa78ce6d363d479$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $3aC2T.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $7jR2L.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7jR2L.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $7aa78ce6d363d479$var$OutletContext = /*#__PURE__*/ $3aC2T.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7aa78ce6d363d479$export$4138103a3ae699cc() {
    return $3aC2T.useContext($7aa78ce6d363d479$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7aa78ce6d363d479$export$a3be3530d8e40d0b(context) {
    var outlet = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7aa78ce6d363d479$export$99eaa27ddbbb95ef() {
    var matches = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7aa78ce6d363d479$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var matches = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).matches;
    var _useLocation = $7aa78ce6d363d479$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $7jR2L.UNSAFE_getPathContributingMatches)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    return $3aC2T.useMemo(function() {
        return (0, $7jR2L.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7aa78ce6d363d479$export$5d3fca4a98652595(routes, locationArg) {
    return $7aa78ce6d363d479$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7aa78ce6d363d479$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $7jR2L.UNSAFE_invariant)(false);
    var navigator = $3aC2T.useContext($7aa78ce6d363d479$export$26749e8557646306).navigator;
    var _React_useContext = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $7aa78ce6d363d479$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $7jR2L.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $7jR2L.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $7jR2L.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $7aa78ce6d363d479$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $7jR2L.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $7jR2L.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7aa78ce6d363d479$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $7jR2L.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7aa78ce6d363d479$var$DefaultErrorComponent() {
    var error = $7aa78ce6d363d479$export$ed527bf60f6e05f2();
    var message = (0, $7jR2L.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $3aC2T.createElement($3aC2T.Fragment, null, /*#__PURE__*/ $3aC2T.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $3aC2T.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $3aC2T.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $7aa78ce6d363d479$var$defaultErrorElement = /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$DefaultErrorComponent, null);
var $7aa78ce6d363d479$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $1atwj._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $iD0Am._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $50OuQ._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $fGdZr._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error || state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($3aC2T.Component);
function $7aa78ce6d363d479$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $3aC2T.useContext($7aa78ce6d363d479$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext["static"] && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7aa78ce6d363d479$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $7jR2L.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        var errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7aa78ce6d363d479$var$defaultErrorElement;
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $3aC2T.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7aa78ce6d363d479$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7aa78ce6d363d479$var$DataRouterHook || {});
var $7aa78ce6d363d479$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7aa78ce6d363d479$var$DataRouterStateHook || {});
function $7aa78ce6d363d479$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7aa78ce6d363d479$var$useDataRouterContext(hookName) {
    var ctx = $3aC2T.useContext($7aa78ce6d363d479$export$3add0d5dce533e2e);
    !ctx && (0, $7jR2L.UNSAFE_invariant)(false);
    return ctx;
}
function $7aa78ce6d363d479$var$useDataRouterState(hookName) {
    var state = $3aC2T.useContext($7aa78ce6d363d479$export$145dfa71566a64dc);
    !state && (0, $7jR2L.UNSAFE_invariant)(false);
    return state;
}
function $7aa78ce6d363d479$var$useRouteContext(hookName) {
    var route = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057);
    !route && (0, $7jR2L.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7aa78ce6d363d479$var$useCurrentRouteId(hookName) {
    var route = $7aa78ce6d363d479$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $7jR2L.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7aa78ce6d363d479$export$5fc8298006ad9e58() {
    return $7aa78ce6d363d479$var$useCurrentRouteId($7aa78ce6d363d479$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7aa78ce6d363d479$export$d0fd4b7106de2769() {
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7aa78ce6d363d479$export$600dc272ed516c15() {
    var dataRouterContext = $7aa78ce6d363d479$var$useDataRouterContext($7aa78ce6d363d479$var$DataRouterHook.UseRevalidator);
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseRevalidator);
    return $3aC2T.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7aa78ce6d363d479$export$2378eb7f5ff86053() {
    var _useDataRouterState = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $3aC2T.useMemo(function() {
        return matches.map(function(m) {
            return (0, $7jR2L.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7aa78ce6d363d479$export$1448a5050d252c4d() {
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseLoaderData);
    var routeId = $7aa78ce6d363d479$var$useCurrentRouteId($7aa78ce6d363d479$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7aa78ce6d363d479$export$fd5d37484eab868d(routeId) {
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7aa78ce6d363d479$export$fdc00f3f26066d5e() {
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseActionData);
    var route = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057);
    !route && (0, $7jR2L.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7aa78ce6d363d479$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $3aC2T.useContext($7aa78ce6d363d479$var$RouteErrorContext);
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseRouteError);
    var routeId = $7aa78ce6d363d479$var$useCurrentRouteId($7aa78ce6d363d479$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7aa78ce6d363d479$export$78a72ddb39bdd145() {
    var value = $3aC2T.useContext($7aa78ce6d363d479$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7aa78ce6d363d479$export$17f53340677d5831() {
    var value = $3aC2T.useContext($7aa78ce6d363d479$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $7aa78ce6d363d479$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7aa78ce6d363d479$export$2af03a1de5c0910(shouldBlock) {
    var _useDataRouterContext = $7aa78ce6d363d479$var$useDataRouterContext($7aa78ce6d363d479$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $aSMts._)($3aC2T.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $3aC2T.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $7aa78ce6d363d479$var$_extends({}, currentLocation, {
                pathname: (0, $7jR2L.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7aa78ce6d363d479$var$_extends({}, nextLocation, {
                pathname: (0, $7jR2L.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $3aC2T.useEffect(function() {
        var key = String(++$7aa78ce6d363d479$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $3aC2T.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $7jR2L.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7aa78ce6d363d479$var$useNavigateStable() {
    var router = $7aa78ce6d363d479$var$useDataRouterContext($7aa78ce6d363d479$var$DataRouterHook.UseNavigateStable).router;
    var id = $7aa78ce6d363d479$var$useCurrentRouteId($7aa78ce6d363d479$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $3aC2T.useRef(false);
    $7aa78ce6d363d479$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $3aC2T.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7aa78ce6d363d479$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $7aa78ce6d363d479$var$alreadyWarned = {};
function $7aa78ce6d363d479$var$warningOnce(key, cond, message) {
    if (!cond && !$7aa78ce6d363d479$var$alreadyWarned[key]) $7aa78ce6d363d479$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $7aa78ce6d363d479$var$START_TRANSITION = "startTransition";
var $7aa78ce6d363d479$var$startTransitionImpl = $3aC2T[$7aa78ce6d363d479$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7aa78ce6d363d479$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    var _React_useState = (0, $aSMts._)($3aC2T.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $3aC2T.useCallback(function(newState) {
        v7_startTransition && $7aa78ce6d363d479$var$startTransitionImpl ? $7aa78ce6d363d479$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3aC2T.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    var navigator = $3aC2T.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $3aC2T.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3aC2T.createElement($3aC2T.Fragment, null, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7aa78ce6d363d479$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, state = _ref2.state;
    return $7aa78ce6d363d479$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7aa78ce6d363d479$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $3aC2T.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7jR2L.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $aSMts._)($3aC2T.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $3aC2T.useCallback(function(newState) {
        v7_startTransition && $7aa78ce6d363d479$var$startTransitionImpl ? $7aa78ce6d363d479$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3aC2T.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7aa78ce6d363d479$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $7jR2L.UNSAFE_invariant)(false);
    var matches = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).matches;
    var _useLocation = $7aa78ce6d363d479$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $7aa78ce6d363d479$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $7jR2L.resolveTo)(to, (0, $7jR2L.UNSAFE_getPathContributingMatches)(matches).map(function(match) {
        return match.pathnameBase;
    }), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $3aC2T.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7aa78ce6d363d479$export$910ae8079b2c2852(props) {
    return $7aa78ce6d363d479$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7aa78ce6d363d479$export$e7b0ac011bb776c6(_props) {
    (0, $7jR2L.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7aa78ce6d363d479$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $7jR2L.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5["static"], staticProp = tmp1 === void 0 ? false : tmp1;
    !!$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $7jR2L.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $3aC2T.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $7jR2L.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $3aC2T.useMemo(function() {
        var trailingPathname = (0, $7jR2L.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7aa78ce6d363d479$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $7aa78ce6d363d479$export$5d3fca4a98652595($7aa78ce6d363d479$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7aa78ce6d363d479$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$ResolveAwait, null, children));
}
var $7aa78ce6d363d479$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7aa78ce6d363d479$var$AwaitRenderStatus || {});
var $7aa78ce6d363d479$var$neverSettledPromise = new Promise(function() {});
var $7aa78ce6d363d479$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $1atwj._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $iD0Am._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $50OuQ._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $fGdZr._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $7aa78ce6d363d479$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $7aa78ce6d363d479$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $7aa78ce6d363d479$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject()["catch"](function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $7aa78ce6d363d479$var$AwaitRenderStatus.error : promise._data !== undefined ? $7aa78ce6d363d479$var$AwaitRenderStatus.success : $7aa78ce6d363d479$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $7aa78ce6d363d479$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $7aa78ce6d363d479$var$AwaitRenderStatus.error && promise._error instanceof (0, $7jR2L.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw $7aa78ce6d363d479$var$neverSettledPromise;
                if (status === $7aa78ce6d363d479$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $7aa78ce6d363d479$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $7aa78ce6d363d479$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($3aC2T.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7aa78ce6d363d479$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $7aa78ce6d363d479$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $3aC2T.createElement($3aC2T.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7aa78ce6d363d479$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $3aC2T.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $3aC2T.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $dHvbf._)(parentPath).concat([
            index
        ]);
        if (element.type === $3aC2T.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7aa78ce6d363d479$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7aa78ce6d363d479$export$e7b0ac011bb776c6) && (0, $7jR2L.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $7jR2L.UNSAFE_invariant)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7aa78ce6d363d479$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7aa78ce6d363d479$export$daf73786167a7f72(matches) {
    return $7aa78ce6d363d479$var$_renderMatches(matches);
}
function $7aa78ce6d363d479$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $3aC2T.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $3aC2T.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7aa78ce6d363d479$export$f30f7e456d254e83(routes, opts) {
    return (0, $7jR2L.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7aa78ce6d363d479$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7jR2L.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7aa78ce6d363d479$export$52b333d321859367
    }).initialize();
}

});


parcelRequire.register("4ghiA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31a6133549725d84$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
// Creating a React Context
var $31a6133549725d84$var$UserContext = /*#__PURE__*/ (0, $3aC2T.createContext)({
    loggedInUser: "Default User"
});
var $31a6133549725d84$export$2e2bcd8739ae039 = $31a6133549725d84$var$UserContext;

});

parcelRequire.register("l2BLr", function(module, exports) {
$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("qmPZq")).a9; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("qmPZq")).o; });
$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("qmPZq")).W; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("qmPZq")).y; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("qmPZq")).aa; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("qmPZq")).c; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("qmPZq")).C; });
parcelRequire("6zcel");

});
parcelRequire.register("6zcel", function(module, exports) {

$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("qmPZq")).W; });
$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("qmPZq")).a9; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("qmPZq")).o; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("qmPZq")).y; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("qmPZq")).aa; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("qmPZq")).c; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("qmPZq")).C; });

var $qmPZq = parcelRequire("qmPZq");
parcelRequire("cxgyp");
parcelRequire("2Ldjj");
parcelRequire("1dgkP");

parcelRequire("bDt5L");

});
parcelRequire.register("qmPZq", function(module, exports) {

$parcel$export(module.exports, "W", function () { return $04f424e220a55f33$export$71cec2538cb2c617; });
$parcel$export(module.exports, "a9", function () { return $04f424e220a55f33$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "aa", function () { return $04f424e220a55f33$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "y", function () { return $04f424e220a55f33$export$4a5767248b18ef41; });
$parcel$export(module.exports, "C", function () { return $04f424e220a55f33$export$e7094788287c5e9b; });
$parcel$export(module.exports, "c", function () { return $04f424e220a55f33$export$db3b6bfb95261072; });
$parcel$export(module.exports, "o", function () { return $04f424e220a55f33$export$ae1af26003f05816; });

var $dMjkN = parcelRequire("dMjkN");

var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $2iBlG = parcelRequire("2iBlG");

var $ats3c = parcelRequire("ats3c");

var $bykok = parcelRequire("bykok");

var $1atwj = parcelRequire("1atwj");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $iD0Am = parcelRequire("iD0Am");

var $1XfpH = parcelRequire("1XfpH");

var $cxgyp = parcelRequire("cxgyp");

var $2Ldjj = parcelRequire("2Ldjj");

var $1dgkP = parcelRequire("1dgkP");

var $1XfpH = parcelRequire("1XfpH");

var $bDt5L = parcelRequire("bDt5L");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ var $04f424e220a55f33$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ var $04f424e220a55f33$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ var $04f424e220a55f33$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ var $04f424e220a55f33$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ var $04f424e220a55f33$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $04f424e220a55f33$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
var $04f424e220a55f33$var$RecaptchaConfig = function RecaptchaConfig(response) {
    "use strict";
    (0, $50OuQ._)(this, RecaptchaConfig);
    /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
    /**
         * The reCAPTCHA enablement status of the {@link EmailAuthProvider} for the current tenant.
         */ this.emailPasswordEnabled = false;
    if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
    // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
    this.siteKey = response.recaptchaKey.split("/")[3];
    this.emailPasswordEnabled = response.recaptchaEnforcementState.some(function(enforcementState) {
        return enforcementState.provider === "EMAIL_PASSWORD_PROVIDER" && enforcementState.enforcementState !== "OFF";
    });
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$_debugErrorMap() {
    var _obj;
    return(_obj = {}, (0, $2iBlG._)(_obj, "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ , "This operation is restricted to administrators only."), (0, $2iBlG._)(_obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , ""), (0, $2iBlG._)(_obj, "app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ , "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console."), (0, $2iBlG._)(_obj, "app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ , "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device."), (0, $2iBlG._)(_obj, "captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ , "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains."), (0, $2iBlG._)(_obj, "code-expired" /* AuthErrorCode.CODE_EXPIRED */ , "The SMS code has expired. Please re-send the verification code to try again."), (0, $2iBlG._)(_obj, "cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ , "Cordova framework is not ready."), (0, $2iBlG._)(_obj, "cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ , "This browser is not supported."), (0, $2iBlG._)(_obj, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , "This credential is already associated with a different user account."), (0, $2iBlG._)(_obj, "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ , "The custom token corresponds to a different audience."), (0, $2iBlG._)(_obj, "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ , "This operation is sensitive and requires recent authentication. Log in again before retrying this request."), (0, $2iBlG._)(_obj, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ , "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."), (0, $2iBlG._)(_obj, "dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ , "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions."), (0, $2iBlG._)(_obj, "email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ , "Multi-factor users must always have a verified email."), (0, $2iBlG._)(_obj, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , "The email address is already in use by another account."), (0, $2iBlG._)(_obj, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ , 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.'), (0, $2iBlG._)(_obj, "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ , "The action code has expired."), (0, $2iBlG._)(_obj, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ , "This operation has been cancelled due to another conflicting popup being opened."), (0, $2iBlG._)(_obj, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , "An internal AuthError has occurred."), (0, $2iBlG._)(_obj, "invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ , "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired."), (0, $2iBlG._)(_obj, "invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ , "The mobile app identifier is not registed for the current project."), (0, $2iBlG._)(_obj, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ , "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key."), (0, $2iBlG._)(_obj, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ , "An internal AuthError has occurred."), (0, $2iBlG._)(_obj, "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ , "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user."), (0, $2iBlG._)(_obj, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ , "The continue URL provided in the request is invalid."), (0, $2iBlG._)(_obj, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme."), (0, $2iBlG._)(_obj, "invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ , "The custom token format is incorrect. Please check the documentation."), (0, $2iBlG._)(_obj, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ , "The provided dynamic link domain is not configured or authorized for the current project."), (0, $2iBlG._)(_obj, "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ , "The email address is badly formatted."), (0, $2iBlG._)(_obj, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ , "Emulator URL must start with a valid scheme (http:// or https://)."), (0, $2iBlG._)(_obj, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , "Your API key is invalid, please check you have copied it correctly."), (0, $2iBlG._)(_obj, "invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ , "The SHA-1 certificate hash provided is invalid."), (0, $2iBlG._)(_obj, "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ , "The supplied auth credential is malformed or has expired."), (0, $2iBlG._)(_obj, "invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ , "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console."), (0, $2iBlG._)(_obj, "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ , "The request does not contain a valid proof of first factor successful sign-in."), (0, $2iBlG._)(_obj, "invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ , "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers."), (0, $2iBlG._)(_obj, "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ , "The OAuth client ID provided is either invalid or does not match the specified API key."), (0, $2iBlG._)(_obj, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ , "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console."), (0, $2iBlG._)(_obj, "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ , "The action code is invalid. This can happen if the code is malformed, expired, or has already been used."), (0, $2iBlG._)(_obj, "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ , "The password is invalid or the user does not have a password."), (0, $2iBlG._)(_obj, "invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ , "The specified persistence type is invalid. It can only be local, session or none."), (0, $2iBlG._)(_obj, "invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ , "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code]."), (0, $2iBlG._)(_obj, "invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ , "The specified provider ID is invalid."), (0, $2iBlG._)(_obj, "invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ , "The email corresponding to this action failed to send as the provided recipient email address is invalid."), (0, $2iBlG._)(_obj, "invalid-sender" /* AuthErrorCode.INVALID_SENDER */ , "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console."), (0, $2iBlG._)(_obj, "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ , "The verification ID used to create the phone auth credential is invalid."), (0, $2iBlG._)(_obj, "invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ , "The Auth instance's tenant ID is invalid."), (0, $2iBlG._)(_obj, "login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , "Login blocked by user-provided method: {$originalMessage}"), (0, $2iBlG._)(_obj, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ , "An Android Package Name must be provided if the Android App is required to be installed."), (0, $2iBlG._)(_obj, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ , "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console."), (0, $2iBlG._)(_obj, "missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ , "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided."), (0, $2iBlG._)(_obj, "missing-verification-code" /* AuthErrorCode.MISSING_CODE */ , "The phone auth credential was created with an empty SMS verification code."), (0, $2iBlG._)(_obj, "missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ , "A continue URL must be provided in the request."), (0, $2iBlG._)(_obj, "missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ , "An internal AuthError has occurred."), (0, $2iBlG._)(_obj, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ , "An iOS Bundle ID must be provided if an App Store ID is provided."), (0, $2iBlG._)(_obj, "missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ , "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload."), (0, $2iBlG._)(_obj, "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ , "A non-empty password must be provided"), (0, $2iBlG._)(_obj, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ , "No second factor identifier is provided."), (0, $2iBlG._)(_obj, "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ , "The request is missing proof of first factor successful sign-in."), (0, $2iBlG._)(_obj, "missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ , "To send verification codes, provide a phone number for the recipient."), (0, $2iBlG._)(_obj, "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ , "The phone auth credential was created with an empty verification ID."), (0, $2iBlG._)(_obj, "app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ , "This instance of FirebaseApp has been deleted."), (0, $2iBlG._)(_obj, "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ , "The user does not have a second factor matching the identifier provided."), (0, $2iBlG._)(_obj, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , "Proof of ownership of a second factor is required to complete sign-in."), (0, $2iBlG._)(_obj, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address."), (0, $2iBlG._)(_obj, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred."), (0, $2iBlG._)(_obj, "no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ , "An internal AuthError has occurred."), (0, $2iBlG._)(_obj, "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ , "User was not linked to an account with the given provider."), (0, $2iBlG._)(_obj, "null-user" /* AuthErrorCode.NULL_USER */ , "A null user object was provided as the argument for an operation which requires a non-null user object."), (0, $2iBlG._)(_obj, "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ , "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section."), (0, $2iBlG._)(_obj, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.'), (0, $2iBlG._)(_obj, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ , "Unable to establish a connection with the popup. It may have been blocked by the browser."), (0, $2iBlG._)(_obj, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ , "The popup has been closed by the user before finalizing the operation."), (0, $2iBlG._)(_obj, "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ , "User can only be linked to one identity for the given provider."), (0, $2iBlG._)(_obj, "quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ , "The project's quota for this operation has been exceeded."), (0, $2iBlG._)(_obj, "redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ , "The redirect operation has been cancelled by the user before finalizing."), (0, $2iBlG._)(_obj, "redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ , "A redirect sign-in operation is already pending."), (0, $2iBlG._)(_obj, "rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ , "The request contains malformed or mismatching credentials."), (0, $2iBlG._)(_obj, "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ , "The second factor is already enrolled on this account."), (0, $2iBlG._)(_obj, "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ , "The maximum allowed number of second factors on a user has been exceeded."), (0, $2iBlG._)(_obj, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ , "The provided tenant ID does not match the Auth instance's tenant ID"), (0, $2iBlG._)(_obj, "timeout" /* AuthErrorCode.TIMEOUT */ , "The operation has timed out."), (0, $2iBlG._)(_obj, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ , "The user's credential is no longer valid. The user must sign in again."), (0, $2iBlG._)(_obj, "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ , "We have blocked all requests from this device due to unusual activity. Try again later."), (0, $2iBlG._)(_obj, "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ , "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console."), (0, $2iBlG._)(_obj, "unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ , "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor."), (0, $2iBlG._)(_obj, "unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ , "The current environment does not support the specified persistence type."), (0, $2iBlG._)(_obj, "unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ , "This operation is not supported in a multi-tenant context."), (0, $2iBlG._)(_obj, "unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ , "The operation requires a verified email."), (0, $2iBlG._)(_obj, "user-cancelled" /* AuthErrorCode.USER_CANCELLED */ , "The user did not grant your application the permissions it requested."), (0, $2iBlG._)(_obj, "user-not-found" /* AuthErrorCode.USER_DELETED */ , "There is no user record corresponding to this identifier. The user may have been deleted."), (0, $2iBlG._)(_obj, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , "The user account has been disabled by an administrator."), (0, $2iBlG._)(_obj, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ , "The supplied credentials do not correspond to the previously signed in user."), (0, $2iBlG._)(_obj, "user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ , ""), (0, $2iBlG._)(_obj, "weak-password" /* AuthErrorCode.WEAK_PASSWORD */ , "The password must be 6 characters long or more."), (0, $2iBlG._)(_obj, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ , "This browser is not supported or 3rd party cookies and data may be disabled."), (0, $2iBlG._)(_obj, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ , "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance."), (0, $2iBlG._)(_obj, "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ , "The reCAPTCHA token is missing when sending request to the backend."), (0, $2iBlG._)(_obj, "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ , "The reCAPTCHA token is invalid when sending request to the backend."), (0, $2iBlG._)(_obj, "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ , "The reCAPTCHA action is invalid when sending request to the backend."), (0, $2iBlG._)(_obj, "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ , "reCAPTCHA Enterprise integration is not enabled for this project."), (0, $2iBlG._)(_obj, "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ , "The reCAPTCHA client type is missing when sending request to the backend."), (0, $2iBlG._)(_obj, "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ , "The reCAPTCHA version is missing when sending request to the backend."), (0, $2iBlG._)(_obj, "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ , "Invalid request parameters."), (0, $2iBlG._)(_obj, "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ , "The reCAPTCHA version is invalid when sending request to the backend."), (0, $2iBlG._)(_obj, "unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK."), (0, $2iBlG._)(_obj, "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ , "The password does not meet the requirements."), _obj);
}
function $04f424e220a55f33$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return (0, $2iBlG._)({}, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ , "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.");
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ var $04f424e220a55f33$export$a9c23c6ac3fc3eca = $04f424e220a55f33$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ var $04f424e220a55f33$export$2329c99376c9d0a4 = $04f424e220a55f33$var$_prodErrorMap;
var $04f424e220a55f33$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $cxgyp.ErrorFactory)("auth", "Firebase", $04f424e220a55f33$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ var $04f424e220a55f33$export$7f8ddf7c7c20b3cd = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$logClient = new (0, $1dgkP.Logger)("@firebase/auth");
function $04f424e220a55f33$var$_logWarn(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _logClient;
    if ($04f424e220a55f33$var$logClient.logLevel <= (0, $1dgkP.LogLevel).WARN) (_logClient = $04f424e220a55f33$var$logClient).warn.apply(_logClient, [
        "Auth (".concat((0, $2Ldjj.SDK_VERSION), "): ").concat(msg)
    ].concat((0, $dHvbf._)(args)));
}
function $04f424e220a55f33$var$_logError(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _logClient;
    if ($04f424e220a55f33$var$logClient.logLevel <= (0, $1dgkP.LogLevel).ERROR) (_logClient = $04f424e220a55f33$var$logClient).error.apply(_logClient, [
        "Auth (".concat((0, $2Ldjj.SDK_VERSION), "): ").concat(msg)
    ].concat((0, $dHvbf._)(args)));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$export$92108d983e8ee699(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    throw $04f424e220a55f33$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $dHvbf._)(rest)));
}
function $04f424e220a55f33$export$91c6e00c14e7e6fd(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    return $04f424e220a55f33$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $dHvbf._)(rest)));
}
function $04f424e220a55f33$var$_errorWithCustomMessage(auth, code, message) {
    var errorMap = Object.assign(Object.assign({}, $04f424e220a55f33$export$2329c99376c9d0a4()), (0, $2iBlG._)({}, code, message));
    var factory = new (0, $cxgyp.ErrorFactory)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $04f424e220a55f33$var$_assertInstanceOf(auth, object, instance) {
    var constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $04f424e220a55f33$export$92108d983e8ee699(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $04f424e220a55f33$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , "Type of ".concat(object.constructor.name, " does not match expected instance.") + "Did you pass a reference from a different Auth SDK?");
    }
}
function $04f424e220a55f33$var$createErrorInternal(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    var _DEFAULT_AUTH_ERROR_FACTORY1;
    if (typeof authOrCode !== "string") {
        var _authOrCode__errorFactory;
        var code = rest[0];
        var fullParams = (0, $dHvbf._)(rest.slice(1));
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return (_authOrCode__errorFactory = authOrCode._errorFactory).create.apply(_authOrCode__errorFactory, [
            code
        ].concat((0, $dHvbf._)(fullParams)));
    }
    return (_DEFAULT_AUTH_ERROR_FACTORY1 = $04f424e220a55f33$var$_DEFAULT_AUTH_ERROR_FACTORY).create.apply(_DEFAULT_AUTH_ERROR_FACTORY1, [
        authOrCode
    ].concat((0, $dHvbf._)(rest)));
}
function $04f424e220a55f33$export$9d398bebfec1c039(assertion, authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rest[_key - 2] = arguments[_key];
    }
    if (!assertion) throw $04f424e220a55f33$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $dHvbf._)(rest)));
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $04f424e220a55f33$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var message = "INTERNAL ASSERTION FAILED: " + failure;
    $04f424e220a55f33$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $04f424e220a55f33$export$493d36ec626b6698(assertion, message) {
    if (!assertion) $04f424e220a55f33$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $04f424e220a55f33$var$_isHttpOrHttps() {
    return $04f424e220a55f33$var$_getCurrentScheme() === "http:" || $04f424e220a55f33$var$_getCurrentScheme() === "https:";
}
function $04f424e220a55f33$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $04f424e220a55f33$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($04f424e220a55f33$var$_isHttpOrHttps() || (0, $cxgyp.isBrowserExtension)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $04f424e220a55f33$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    var navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ var $04f424e220a55f33$var$Delay = /*#__PURE__*/ function() {
    "use strict";
    function Delay(shortDelay, longDelay) {
        (0, $50OuQ._)(this, Delay);
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $04f424e220a55f33$export$493d36ec626b6698(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $cxgyp.isMobileCordova)() || (0, $cxgyp.isReactNative)();
    }
    (0, $fGdZr._)(Delay, [
        {
            key: "get",
            value: function get() {
                if (!$04f424e220a55f33$var$_isOnline()) // Pick the shorter timeout.
                return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
                // If running in a mobile environment, return the long delay, otherwise
                // return the short delay.
                // This could be improved in the future to dynamically change based on other
                // variables instead of just reading the current environment.
                return this.isMobile ? this.longDelay : this.shortDelay;
            }
        }
    ]);
    return Delay;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$_emulatorUrl(config, path) {
    $04f424e220a55f33$export$493d36ec626b6698(config.emulator, "Emulator should always be set here");
    var url = config.emulator.url;
    if (!path) return url;
    return "".concat(url).concat(path.startsWith("/") ? path.slice(1) : path);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$export$c03999cb2f36933f = /*#__PURE__*/ function() {
    "use strict";
    function FetchProvider() {
        (0, $50OuQ._)(this, FetchProvider);
    }
    (0, $fGdZr._)(FetchProvider, null, [
        {
            key: "initialize",
            value: function initialize(fetchImpl, headersImpl, responseImpl) {
                this.fetchImpl = fetchImpl;
                if (headersImpl) this.headersImpl = headersImpl;
                if (responseImpl) this.responseImpl = responseImpl;
            }
        },
        {
            key: "fetch",
            value: function fetch1() {
                if (this.fetchImpl) return this.fetchImpl;
                if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
                $04f424e220a55f33$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        },
        {
            key: "headers",
            value: function headers() {
                if (this.headersImpl) return this.headersImpl;
                if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
                $04f424e220a55f33$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        },
        {
            key: "response",
            value: function response() {
                if (this.responseImpl) return this.responseImpl;
                if (typeof self !== "undefined" && "Response" in self) return self.Response;
                $04f424e220a55f33$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        }
    ]);
    return FetchProvider;
}();
var $04f424e220a55f33$var$_obj;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ var $04f424e220a55f33$var$SERVER_ERROR_MAP = ($04f424e220a55f33$var$_obj = {}, // Custom token errors.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ , "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ), // This can only happen if the SDK sends a bad request.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Create Auth URI errors.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ , "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ), // This can only happen if the SDK sends a bad request.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Sign in with email and password errors (some apply to sign up too).
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ , "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ), // This can only happen if the SDK sends a bad request.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ , "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ), // Sign up with email and password errors.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ , "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ , "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ), // Verify assertion for sign in with credential errors:
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ , "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ , "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ , "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ), // This can only happen if the SDK sends a bad request.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Send Password reset email errors:
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ , "user-not-found" /* AuthErrorCode.USER_DELETED */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ , "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ , "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ , "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ), // This can only happen if the SDK sends a bad request.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Operations that require ID token in request:
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ , "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ , "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ , "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ , "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ), // Other errors.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ , "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ , "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ), // Phone Auth related errors.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_CODE" /* ServerError.INVALID_CODE */ , "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ , "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ , "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ , "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ , "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ), // Other action code errors when additional settings passed.
// MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
// This is OK as this error will be caught by client side validation.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ , "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ , "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ), // getProjectConfig errors when clientId is passed.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ , "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ), // User actions (sign-up or deletion) disabled errors.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ , "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ), // Multi factor related errors.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ , "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ , "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ , "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ , "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ , "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ , "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ), // Blocking functions related errors.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Recaptcha related errors.
(0, $2iBlG._)($04f424e220a55f33$var$_obj, "RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ , "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ , "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ , "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ , "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ , "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ , "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ , "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ), (0, $2iBlG._)($04f424e220a55f33$var$_obj, "INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ , "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ), $04f424e220a55f33$var$_obj);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$DEFAULT_API_TIMEOUT_MS = new $04f424e220a55f33$var$Delay(30000, 60000);
function $04f424e220a55f33$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
function $04f424e220a55f33$var$_performApiRequest(auth, method, path, request) {
    return $04f424e220a55f33$var$__performApiRequest.apply(this, arguments);
}
function $04f424e220a55f33$var$__performApiRequest() {
    $04f424e220a55f33$var$__performApiRequest = (0, $5Pgs2._)(function(auth, method, path, request) {
        var customErrorMap;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            customErrorMap = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
            return [
                2,
                $04f424e220a55f33$var$_performFetchWithErrorHandling(auth, customErrorMap, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                    var body, params, query, headers;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = {};
                                params = {};
                                if (request) {
                                    if (method === "GET" /* HttpMethod.GET */ ) params = request;
                                    else body = {
                                        body: JSON.stringify(request)
                                    };
                                }
                                query = (0, $cxgyp.querystring)(Object.assign({
                                    key: auth.config.apiKey
                                }, params)).slice(1);
                                return [
                                    4,
                                    auth._getAdditionalHeaders()
                                ];
                            case 1:
                                headers = _state.sent();
                                headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
                                if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
                                return [
                                    2,
                                    $04f424e220a55f33$export$c03999cb2f36933f.fetch()($04f424e220a55f33$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
                                        method: method,
                                        headers: headers,
                                        referrerPolicy: "no-referrer"
                                    }, body))
                                ];
                        }
                    });
                }))
            ];
        });
    });
    return $04f424e220a55f33$var$__performApiRequest.apply(this, arguments);
}
function $04f424e220a55f33$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    return $04f424e220a55f33$var$__performFetchWithErrorHandling.apply(this, arguments);
}
function $04f424e220a55f33$var$__performFetchWithErrorHandling() {
    $04f424e220a55f33$var$__performFetchWithErrorHandling = (0, $5Pgs2._)(function(auth, customErrorMap, fetchFn) {
        var errorMap, networkTimeout, response, json, errorMessage, _errorMessage_split, serverErrorCode, serverErrorMessage, authError, e;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth._canInitEmulator = false;
                    errorMap = Object.assign(Object.assign({}, $04f424e220a55f33$var$SERVER_ERROR_MAP), customErrorMap);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    networkTimeout = new $04f424e220a55f33$var$NetworkTimeout(auth);
                    return [
                        4,
                        Promise.race([
                            fetchFn(),
                            networkTimeout.promise
                        ])
                    ];
                case 2:
                    response = _state.sent();
                    // If we've reached this point, the fetch succeeded and the networkTimeout
                    // didn't throw; clear the network timeout delay so that Node won't hang
                    networkTimeout.clearNetworkTimeout();
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    json = _state.sent();
                    if ("needConfirmation" in json) throw $04f424e220a55f33$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
                    if (response.ok && !("errorMessage" in json)) return [
                        2,
                        json
                    ];
                    else {
                        errorMessage = response.ok ? json.errorMessage : json.error.message;
                        _errorMessage_split = (0, $aSMts._)(errorMessage.split(" : "), 2), serverErrorCode = _errorMessage_split[0], serverErrorMessage = _errorMessage_split[1];
                        if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $04f424e220a55f33$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
                        else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $04f424e220a55f33$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
                        else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $04f424e220a55f33$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
                        authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
                        if (serverErrorMessage) throw $04f424e220a55f33$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
                        else $04f424e220a55f33$export$92108d983e8ee699(auth, authError);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $cxgyp.FirebaseError)) throw e;
                    // Changing this to a different error code will log user out when there is a network error
                    // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
                    // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
                    $04f424e220a55f33$export$92108d983e8ee699(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
                        message: String(e)
                    });
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__performFetchWithErrorHandling.apply(this, arguments);
}
function $04f424e220a55f33$var$_performSignInRequest(auth, method, path, request) {
    return $04f424e220a55f33$var$__performSignInRequest.apply(this, arguments);
}
function $04f424e220a55f33$var$__performSignInRequest() {
    $04f424e220a55f33$var$__performSignInRequest = (0, $5Pgs2._)(function(auth, method, path, request) {
        var customErrorMap, serverResponse;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    customErrorMap = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
                    return [
                        4,
                        $04f424e220a55f33$var$_performApiRequest(auth, method, path, request, customErrorMap)
                    ];
                case 1:
                    serverResponse = _state.sent();
                    if ("mfaPendingCredential" in serverResponse) $04f424e220a55f33$export$92108d983e8ee699(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
                        _serverResponse: serverResponse
                    });
                    return [
                        2,
                        serverResponse
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__performSignInRequest.apply(this, arguments);
}
function $04f424e220a55f33$var$_getFinalTarget(auth, host, path, query) {
    var base = "".concat(host).concat(path, "?").concat(query);
    if (!auth.config.emulator) return "".concat(auth.config.apiScheme, "://").concat(base);
    return $04f424e220a55f33$var$_emulatorUrl(auth.config, base);
}
var $04f424e220a55f33$var$NetworkTimeout = /*#__PURE__*/ function() {
    "use strict";
    function NetworkTimeout(auth) {
        var _this = this;
        (0, $50OuQ._)(this, NetworkTimeout);
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise(function(_, reject) {
            _this.timer = setTimeout(function() {
                return reject($04f424e220a55f33$export$91c6e00c14e7e6fd(_this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $04f424e220a55f33$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    (0, $fGdZr._)(NetworkTimeout, [
        {
            key: "clearNetworkTimeout",
            value: function clearNetworkTimeout() {
                clearTimeout(this.timer);
            }
        }
    ]);
    return NetworkTimeout;
}();
function $04f424e220a55f33$var$_makeTaggedError(auth, code, response) {
    var errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    var error = $04f424e220a55f33$export$91c6e00c14e7e6fd(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
function $04f424e220a55f33$var$getRecaptchaParams(auth) {
    return $04f424e220a55f33$var$_getRecaptchaParams.apply(this, arguments);
}
function $04f424e220a55f33$var$_getRecaptchaParams() {
    $04f424e220a55f33$var$_getRecaptchaParams = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04f424e220a55f33$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().recaptchaSiteKey || ""
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_getRecaptchaParams.apply(this, arguments);
}
function $04f424e220a55f33$var$getRecaptchaConfig(auth, request) {
    return $04f424e220a55f33$var$_getRecaptchaConfig.apply(this, arguments);
}
function $04f424e220a55f33$var$_getRecaptchaConfig() {
    $04f424e220a55f33$var$_getRecaptchaConfig = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_getRecaptchaConfig.apply(this, arguments);
}
function $04f424e220a55f33$var$deleteAccount(auth, request) {
    return $04f424e220a55f33$var$_deleteAccount.apply(this, arguments);
}
function $04f424e220a55f33$var$_deleteAccount() {
    $04f424e220a55f33$var$_deleteAccount = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request)
            ];
        });
    });
    return $04f424e220a55f33$var$_deleteAccount.apply(this, arguments);
}
function $04f424e220a55f33$var$deleteLinkedAccounts(auth, request) {
    return $04f424e220a55f33$var$_deleteLinkedAccounts.apply(this, arguments);
}
function $04f424e220a55f33$var$_deleteLinkedAccounts() {
    $04f424e220a55f33$var$_deleteLinkedAccounts = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $04f424e220a55f33$var$_deleteLinkedAccounts.apply(this, arguments);
}
function $04f424e220a55f33$var$getAccountInfo(auth, request) {
    return $04f424e220a55f33$var$_getAccountInfo.apply(this, arguments);
}
function $04f424e220a55f33$var$_getAccountInfo() {
    $04f424e220a55f33$var$_getAccountInfo = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $04f424e220a55f33$var$_getAccountInfo.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        var date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $04f424e220a55f33$export$1a82df3d29112e01(user) {
    var forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0, $cxgyp.getModularInstance)(user).getIdToken(forceRefresh);
}
function $04f424e220a55f33$export$306ddfe3a8403e2(user) {
    return $04f424e220a55f33$var$_getIdTokenResult.apply(this, arguments);
}
function $04f424e220a55f33$var$_getIdTokenResult() {
    $04f424e220a55f33$var$_getIdTokenResult = /**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ (0, $5Pgs2._)(function(user) {
        var forceRefresh, userInternal, token, claims, firebase, signInProvider;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    forceRefresh = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    return [
                        4,
                        userInternal.getIdToken(forceRefresh)
                    ];
                case 1:
                    token = _state.sent();
                    claims = $04f424e220a55f33$var$_parseToken(token);
                    $04f424e220a55f33$export$9d398bebfec1c039(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
                    signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
                    return [
                        2,
                        {
                            claims: claims,
                            token: token,
                            authTime: $04f424e220a55f33$var$utcTimestampToDateString($04f424e220a55f33$var$secondsStringToMilliseconds(claims.auth_time)),
                            issuedAtTime: $04f424e220a55f33$var$utcTimestampToDateString($04f424e220a55f33$var$secondsStringToMilliseconds(claims.iat)),
                            expirationTime: $04f424e220a55f33$var$utcTimestampToDateString($04f424e220a55f33$var$secondsStringToMilliseconds(claims.exp)),
                            signInProvider: signInProvider || null,
                            signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
                        }
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_getIdTokenResult.apply(this, arguments);
}
function $04f424e220a55f33$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $04f424e220a55f33$var$_parseToken(token) {
    var _token_split = (0, $aSMts._)(token.split("."), 3), algorithm = _token_split[0], payload = _token_split[1], signature = _token_split[2];
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $04f424e220a55f33$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        var decoded = (0, $cxgyp.base64Decode)(payload);
        if (!decoded) {
            $04f424e220a55f33$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $04f424e220a55f33$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $04f424e220a55f33$var$_tokenExpiresIn(token) {
    var parsedToken = $04f424e220a55f33$var$_parseToken(token);
    $04f424e220a55f33$export$9d398bebfec1c039(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $04f424e220a55f33$export$9d398bebfec1c039(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $04f424e220a55f33$export$9d398bebfec1c039(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
function $04f424e220a55f33$var$_logoutIfInvalidated(user, promise) {
    return $04f424e220a55f33$var$__logoutIfInvalidated.apply(this, arguments);
}
function $04f424e220a55f33$var$__logoutIfInvalidated() {
    $04f424e220a55f33$var$__logoutIfInvalidated = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(user, promise) {
        var bypassAuthState, e;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    if (bypassAuthState) return [
                        2,
                        promise
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        promise
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    if (!(e instanceof (0, $cxgyp.FirebaseError) && $04f424e220a55f33$var$isUserInvalidated(e))) return [
                        3,
                        5
                    ];
                    if (!(user.auth.currentUser === user)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        user.auth.signOut()
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    throw e;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__logoutIfInvalidated.apply(this, arguments);
}
function $04f424e220a55f33$var$isUserInvalidated(param) {
    var code = param.code;
    return code === "auth/user-disabled" /* AuthErrorCode.USER_DISABLED */  || code === "auth/user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$ProactiveRefresh = /*#__PURE__*/ function() {
    "use strict";
    function ProactiveRefresh(user) {
        (0, $50OuQ._)(this, ProactiveRefresh);
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    (0, $fGdZr._)(ProactiveRefresh, [
        {
            key: "_start",
            value: function _start() {
                if (this.isRunning) return;
                this.isRunning = true;
                this.schedule();
            }
        },
        {
            key: "_stop",
            value: function _stop() {
                if (!this.isRunning) return;
                this.isRunning = false;
                if (this.timerId !== null) clearTimeout(this.timerId);
            }
        },
        {
            key: "getInterval",
            value: function getInterval(wasError) {
                var _a;
                if (wasError) {
                    var interval = this.errorBackoff;
                    this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
                    return interval;
                } else {
                    // Reset the error backoff
                    this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
                    var expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
                    var interval1 = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
                    return Math.max(0, interval1);
                }
            }
        },
        {
            key: "schedule",
            value: function schedule() {
                var wasError = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (!this.isRunning) // Just in case...
                return;
                var interval = this.getInterval(wasError);
                var _this = this;
                this.timerId = setTimeout(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.iteration()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }), interval);
            }
        },
        {
            key: "iteration",
            value: function iteration() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var e;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.user.getIdToken(true)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                // Only retry on network errors
                                if ((e === null || e === void 0 ? void 0 : e.code) === "auth/network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ) _this.schedule(/* wasError */ true);
                                return [
                                    2
                                ];
                            case 3:
                                _this.schedule();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ProactiveRefresh;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$UserMetadata = /*#__PURE__*/ function() {
    "use strict";
    function UserMetadata(createdAt, lastLoginAt) {
        (0, $50OuQ._)(this, UserMetadata);
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    (0, $fGdZr._)(UserMetadata, [
        {
            key: "_initializeTime",
            value: function _initializeTime() {
                this.lastSignInTime = $04f424e220a55f33$var$utcTimestampToDateString(this.lastLoginAt);
                this.creationTime = $04f424e220a55f33$var$utcTimestampToDateString(this.createdAt);
            }
        },
        {
            key: "_copy",
            value: function _copy(metadata) {
                this.createdAt = metadata.createdAt;
                this.lastLoginAt = metadata.lastLoginAt;
                this._initializeTime();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    createdAt: this.createdAt,
                    lastLoginAt: this.lastLoginAt
                };
            }
        }
    ]);
    return UserMetadata;
}();
function $04f424e220a55f33$var$_reloadWithoutSaving(user) {
    return $04f424e220a55f33$var$__reloadWithoutSaving.apply(this, arguments);
}
function $04f424e220a55f33$var$__reloadWithoutSaving() {
    $04f424e220a55f33$var$__reloadWithoutSaving = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(user) {
        var _a, auth, idToken, response, coreAccount, newProviderData, providerData, oldIsAnonymous, newIsAnonymous, isAnonymous, updates;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth = user.auth;
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    return [
                        4,
                        $04f424e220a55f33$var$_logoutIfInvalidated(user, $04f424e220a55f33$var$getAccountInfo(auth, {
                            idToken: idToken
                        }))
                    ];
                case 2:
                    response = _state.sent();
                    $04f424e220a55f33$export$9d398bebfec1c039(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    coreAccount = response.users[0];
                    user._notifyReloadListener(coreAccount);
                    newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $04f424e220a55f33$var$extractProviderData(coreAccount.providerUserInfo) : [];
                    providerData = $04f424e220a55f33$var$mergeProviderData(user.providerData, newProviderData);
                    oldIsAnonymous = user.isAnonymous;
                    newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
                    isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
                    updates = {
                        uid: coreAccount.localId,
                        displayName: coreAccount.displayName || null,
                        photoURL: coreAccount.photoUrl || null,
                        email: coreAccount.email || null,
                        emailVerified: coreAccount.emailVerified || false,
                        phoneNumber: coreAccount.phoneNumber || null,
                        tenantId: coreAccount.tenantId || null,
                        providerData: providerData,
                        metadata: new $04f424e220a55f33$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
                        isAnonymous: isAnonymous
                    };
                    Object.assign(user, updates);
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__reloadWithoutSaving.apply(this, arguments);
}
function $04f424e220a55f33$export$8a5498727ef6be21(user) {
    return $04f424e220a55f33$var$_reload.apply(this, arguments);
}
function $04f424e220a55f33$var$_reload() {
    $04f424e220a55f33$var$_reload = /**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ (0, $5Pgs2._)(function(user) {
        var userInternal;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    return [
                        4,
                        $04f424e220a55f33$var$_reloadWithoutSaving(userInternal)
                    ];
                case 1:
                    _state.sent();
                    // Even though the current user hasn't changed, update
                    // current user will trigger a persistence update w/ the
                    // new info.
                    return [
                        4,
                        userInternal.auth._persistUserIfCurrent(userInternal)
                    ];
                case 2:
                    _state.sent();
                    userInternal.auth._notifyListenersIfCurrent(userInternal);
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_reload.apply(this, arguments);
}
function $04f424e220a55f33$var$mergeProviderData(original, newData) {
    var deduped = original.filter(function(o) {
        return !newData.some(function(n) {
            return n.providerId === o.providerId;
        });
    });
    return (0, $dHvbf._)(deduped).concat((0, $dHvbf._)(newData));
}
function $04f424e220a55f33$var$extractProviderData(providers) {
    return providers.map(function(_a) {
        var providerId = _a.providerId, provider = (0, $1XfpH.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
function $04f424e220a55f33$var$requestStsToken(auth, refreshToken) {
    return $04f424e220a55f33$var$_requestStsToken.apply(this, arguments);
}
function $04f424e220a55f33$var$_requestStsToken() {
    $04f424e220a55f33$var$_requestStsToken = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, refreshToken) {
        var response;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04f424e220a55f33$var$_performFetchWithErrorHandling(auth, {}, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                            var body, _auth_config, tokenApiHost, apiKey, url, headers;
                            return (0, $1XfpH.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        body = (0, $cxgyp.querystring)({
                                            grant_type: "refresh_token",
                                            refresh_token: refreshToken
                                        }).slice(1);
                                        _auth_config = auth.config, tokenApiHost = _auth_config.tokenApiHost, apiKey = _auth_config.apiKey;
                                        url = $04f424e220a55f33$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , "key=".concat(apiKey));
                                        return [
                                            4,
                                            auth._getAdditionalHeaders()
                                        ];
                                    case 1:
                                        headers = _state.sent();
                                        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
                                        return [
                                            2,
                                            $04f424e220a55f33$export$c03999cb2f36933f.fetch()(url, {
                                                method: "POST" /* HttpMethod.POST */ ,
                                                headers: headers,
                                                body: body
                                            })
                                        ];
                                }
                            });
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    // The response comes back in snake_case. Convert to camel:
                    return [
                        2,
                        {
                            accessToken: response.access_token,
                            expiresIn: response.expires_in,
                            refreshToken: response.refresh_token
                        }
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_requestStsToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ var $04f424e220a55f33$var$StsTokenManager = /*#__PURE__*/ function() {
    "use strict";
    function StsTokenManager() {
        (0, $50OuQ._)(this, StsTokenManager);
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    (0, $fGdZr._)(StsTokenManager, [
        {
            key: "isExpired",
            get: function get() {
                return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
            }
        },
        {
            key: "updateFromServerResponse",
            value: function updateFromServerResponse(response) {
                $04f424e220a55f33$export$9d398bebfec1c039(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $04f424e220a55f33$export$9d398bebfec1c039(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $04f424e220a55f33$export$9d398bebfec1c039(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $04f424e220a55f33$var$_tokenExpiresIn(response.idToken);
                this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
            }
        },
        {
            key: "getToken",
            value: function getToken(auth) {
                var forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $04f424e220a55f33$export$9d398bebfec1c039(!_this.accessToken || _this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
                                if (!forceRefresh && _this.accessToken && !_this.isExpired) return [
                                    2,
                                    _this.accessToken
                                ];
                                if (!_this.refreshToken) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.refresh(auth, _this.refreshToken)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.accessToken
                                ];
                            case 2:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clearRefreshToken",
            value: function clearRefreshToken() {
                this.refreshToken = null;
            }
        },
        {
            key: "refresh",
            value: function refresh(auth, oldToken) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _ref, accessToken, refreshToken, expiresIn;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $04f424e220a55f33$var$requestStsToken(auth, oldToken)
                                ];
                            case 1:
                                _ref = _state.sent(), accessToken = _ref.accessToken, refreshToken = _ref.refreshToken, expiresIn = _ref.expiresIn;
                                _this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateTokensAndExpiration",
            value: function updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
                this.refreshToken = refreshToken || null;
                this.accessToken = accessToken || null;
                this.expirationTime = Date.now() + expiresInSec * 1000;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    refreshToken: this.refreshToken,
                    accessToken: this.accessToken,
                    expirationTime: this.expirationTime
                };
            }
        },
        {
            key: "_assign",
            value: function _assign(stsTokenManager) {
                this.accessToken = stsTokenManager.accessToken;
                this.refreshToken = stsTokenManager.refreshToken;
                this.expirationTime = stsTokenManager.expirationTime;
            }
        },
        {
            key: "_clone",
            value: function _clone() {
                return Object.assign(new StsTokenManager(), this.toJSON());
            }
        },
        {
            key: "_performRefresh",
            value: function _performRefresh() {
                return $04f424e220a55f33$var$debugFail("not implemented");
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(appName, object) {
                var refreshToken = object.refreshToken, accessToken = object.accessToken, expirationTime = object.expirationTime;
                var manager = new StsTokenManager();
                if (refreshToken) {
                    $04f424e220a55f33$export$9d398bebfec1c039(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.refreshToken = refreshToken;
                }
                if (accessToken) {
                    $04f424e220a55f33$export$9d398bebfec1c039(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.accessToken = accessToken;
                }
                if (expirationTime) {
                    $04f424e220a55f33$export$9d398bebfec1c039(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.expirationTime = expirationTime;
                }
                return manager;
            }
        }
    ]);
    return StsTokenManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$assertStringOrUndefined(assertion, appName) {
    $04f424e220a55f33$export$9d398bebfec1c039(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
var $04f424e220a55f33$export$a05254e7c3aeba6e = /*#__PURE__*/ function() {
    "use strict";
    function UserImpl(_a) {
        (0, $50OuQ._)(this, UserImpl);
        var uid = _a.uid, auth = _a.auth, stsTokenManager = _a.stsTokenManager, opt = (0, $1XfpH.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $04f424e220a55f33$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? (0, $dHvbf._)(opt.providerData) : [];
        this.metadata = new $04f424e220a55f33$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    (0, $fGdZr._)(UserImpl, [
        {
            key: "getIdToken",
            value: function getIdToken(forceRefresh) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var accessToken;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $04f424e220a55f33$var$_logoutIfInvalidated(_this, _this.stsTokenManager.getToken(_this.auth, forceRefresh))
                                ];
                            case 1:
                                accessToken = _state.sent();
                                $04f424e220a55f33$export$9d398bebfec1c039(accessToken, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                if (!(_this.accessToken !== accessToken)) return [
                                    3,
                                    3
                                ];
                                _this.accessToken = accessToken;
                                return [
                                    4,
                                    _this.auth._persistUserIfCurrent(_this)
                                ];
                            case 2:
                                _state.sent();
                                _this.auth._notifyListenersIfCurrent(_this);
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    accessToken
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getIdTokenResult",
            value: function getIdTokenResult1(forceRefresh) {
                return $04f424e220a55f33$export$306ddfe3a8403e2(this, forceRefresh);
            }
        },
        {
            key: "reload",
            value: function reload1() {
                return $04f424e220a55f33$export$8a5498727ef6be21(this);
            }
        },
        {
            key: "_assign",
            value: function _assign(user) {
                if (this === user) return;
                $04f424e220a55f33$export$9d398bebfec1c039(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                this.displayName = user.displayName;
                this.photoURL = user.photoURL;
                this.email = user.email;
                this.emailVerified = user.emailVerified;
                this.phoneNumber = user.phoneNumber;
                this.isAnonymous = user.isAnonymous;
                this.tenantId = user.tenantId;
                this.providerData = user.providerData.map(function(userInfo) {
                    return Object.assign({}, userInfo);
                });
                this.metadata._copy(user.metadata);
                this.stsTokenManager._assign(user.stsTokenManager);
            }
        },
        {
            key: "_clone",
            value: function _clone(auth) {
                var newUser = new UserImpl(Object.assign(Object.assign({}, this), {
                    auth: auth,
                    stsTokenManager: this.stsTokenManager._clone()
                }));
                newUser.metadata._copy(this.metadata);
                return newUser;
            }
        },
        {
            key: "_onReload",
            value: function _onReload(callback) {
                // There should only ever be one listener, and that is a single instance of MultiFactorUser
                $04f424e220a55f33$export$9d398bebfec1c039(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                this.reloadListener = callback;
                if (this.reloadUserInfo) {
                    this._notifyReloadListener(this.reloadUserInfo);
                    this.reloadUserInfo = null;
                }
            }
        },
        {
            key: "_notifyReloadListener",
            value: function _notifyReloadListener(userInfo) {
                if (this.reloadListener) this.reloadListener(userInfo);
                else // If no listener is subscribed yet, save the result so it's available when they do subscribe
                this.reloadUserInfo = userInfo;
            }
        },
        {
            key: "_startProactiveRefresh",
            value: function _startProactiveRefresh() {
                this.proactiveRefresh._start();
            }
        },
        {
            key: "_stopProactiveRefresh",
            value: function _stopProactiveRefresh() {
                this.proactiveRefresh._stop();
            }
        },
        {
            key: "_updateTokensIfNecessary",
            value: function _updateTokensIfNecessary(response) {
                var reload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var tokensRefreshed;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                tokensRefreshed = false;
                                if (response.idToken && response.idToken !== _this.stsTokenManager.accessToken) {
                                    _this.stsTokenManager.updateFromServerResponse(response);
                                    tokensRefreshed = true;
                                }
                                if (!reload) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $04f424e220a55f33$var$_reloadWithoutSaving(_this)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _this.auth._persistUserIfCurrent(_this)
                                ];
                            case 3:
                                _state.sent();
                                if (tokensRefreshed) _this.auth._notifyListenersIfCurrent(_this);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var idToken;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getIdToken()
                                ];
                            case 1:
                                idToken = _state.sent();
                                return [
                                    4,
                                    $04f424e220a55f33$var$_logoutIfInvalidated(_this, $04f424e220a55f33$var$deleteAccount(_this.auth, {
                                        idToken: idToken
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                _this.stsTokenManager.clearRefreshToken();
                                // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
                                //       cancels pending actions...
                                return [
                                    2,
                                    _this.auth.signOut()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return Object.assign(Object.assign({
                    uid: this.uid,
                    email: this.email || undefined,
                    emailVerified: this.emailVerified,
                    displayName: this.displayName || undefined,
                    isAnonymous: this.isAnonymous,
                    photoURL: this.photoURL || undefined,
                    phoneNumber: this.phoneNumber || undefined,
                    tenantId: this.tenantId || undefined,
                    providerData: this.providerData.map(function(userInfo) {
                        return Object.assign({}, userInfo);
                    }),
                    stsTokenManager: this.stsTokenManager.toJSON(),
                    // Redirect event ID must be maintained in case there is a pending
                    // redirect event.
                    _redirectEventId: this._redirectEventId
                }, this.metadata.toJSON()), {
                    // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
                    apiKey: this.auth.config.apiKey,
                    appName: this.auth.name
                });
            }
        },
        {
            key: "refreshToken",
            get: function get() {
                return this.stsTokenManager.refreshToken || "";
            }
        }
    ], [
        {
            key: "_fromJSON",
            value: function _fromJSON(auth, object) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
                var email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
                var phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
                var photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
                var tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
                var _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
                var createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
                var lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
                var uid = object.uid, emailVerified = object.emailVerified, isAnonymous = object.isAnonymous, providerData = object.providerData, plainObjectTokenManager = object.stsTokenManager;
                $04f424e220a55f33$export$9d398bebfec1c039(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var stsTokenManager = $04f424e220a55f33$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
                $04f424e220a55f33$export$9d398bebfec1c039(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $04f424e220a55f33$var$assertStringOrUndefined(displayName, auth.name);
                $04f424e220a55f33$var$assertStringOrUndefined(email, auth.name);
                $04f424e220a55f33$export$9d398bebfec1c039(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $04f424e220a55f33$export$9d398bebfec1c039(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $04f424e220a55f33$var$assertStringOrUndefined(phoneNumber, auth.name);
                $04f424e220a55f33$var$assertStringOrUndefined(photoURL, auth.name);
                $04f424e220a55f33$var$assertStringOrUndefined(tenantId, auth.name);
                $04f424e220a55f33$var$assertStringOrUndefined(_redirectEventId, auth.name);
                $04f424e220a55f33$var$assertStringOrUndefined(createdAt, auth.name);
                $04f424e220a55f33$var$assertStringOrUndefined(lastLoginAt, auth.name);
                var user = new UserImpl({
                    uid: uid,
                    auth: auth,
                    email: email,
                    emailVerified: emailVerified,
                    displayName: displayName,
                    isAnonymous: isAnonymous,
                    photoURL: photoURL,
                    phoneNumber: phoneNumber,
                    tenantId: tenantId,
                    stsTokenManager: stsTokenManager,
                    createdAt: createdAt,
                    lastLoginAt: lastLoginAt
                });
                if (providerData && Array.isArray(providerData)) user.providerData = providerData.map(function(userInfo) {
                    return Object.assign({}, userInfo);
                });
                if (_redirectEventId) user._redirectEventId = _redirectEventId;
                return user;
            }
        },
        {
            key: "_fromIdTokenResponse",
            value: /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ function _fromIdTokenResponse(auth, idTokenResponse) {
                var isAnonymous = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return (0, $5Pgs2._)(function() {
                    var stsTokenManager, user;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                stsTokenManager = new $04f424e220a55f33$var$StsTokenManager();
                                stsTokenManager.updateFromServerResponse(idTokenResponse);
                                user = new UserImpl({
                                    uid: idTokenResponse.localId,
                                    auth: auth,
                                    stsTokenManager: stsTokenManager,
                                    isAnonymous: isAnonymous
                                });
                                // Updates the user info and data and resolves with a user instance.
                                return [
                                    4,
                                    $04f424e220a55f33$var$_reloadWithoutSaving(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    user
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return UserImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$instanceCache = new Map();
function $04f424e220a55f33$export$24baa2b76016ce0e(cls) {
    $04f424e220a55f33$export$493d36ec626b6698(cls instanceof Function, "Expected a class definition");
    var instance = $04f424e220a55f33$var$instanceCache.get(cls);
    if (instance) {
        $04f424e220a55f33$export$493d36ec626b6698(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $04f424e220a55f33$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$InMemoryPersistence = /*#__PURE__*/ function() {
    "use strict";
    function InMemoryPersistence() {
        (0, $50OuQ._)(this, InMemoryPersistence);
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    (0, $fGdZr._)(InMemoryPersistence, [
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            true
                        ];
                    });
                })();
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        _this.storage[key] = value;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var value;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        value = _this.storage[key];
                        return [
                            2,
                            value === undefined ? null : value
                        ];
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        delete _this.storage[key];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_addListener",
            value: function _addListener(_key, _listener) {
                // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
                return;
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(_key, _listener) {
                // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
                return;
            }
        }
    ]);
    return InMemoryPersistence;
}();
$04f424e220a55f33$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ var $04f424e220a55f33$export$3722cfe417b6ed86 = $04f424e220a55f33$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$export$158acd800e1ef08b(key, apiKey, appName) {
    return "firebase:".concat(key, ":").concat(apiKey, ":").concat(appName);
}
var $04f424e220a55f33$var$PersistenceUserManager = /*#__PURE__*/ function() {
    "use strict";
    function PersistenceUserManager(persistence, auth, userKey) {
        (0, $50OuQ._)(this, PersistenceUserManager);
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        var _this_auth = this.auth, config = _this_auth.config, name = _this_auth.name;
        this.fullUserKey = $04f424e220a55f33$export$158acd800e1ef08b(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $04f424e220a55f33$export$158acd800e1ef08b("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    (0, $fGdZr._)(PersistenceUserManager, [
        {
            key: "setCurrentUser",
            value: function setCurrentUser(user) {
                return this.persistence._set(this.fullUserKey, user.toJSON());
            }
        },
        {
            key: "getCurrentUser",
            value: function getCurrentUser() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var blob;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.persistence._get(_this.fullUserKey)
                                ];
                            case 1:
                                blob = _state.sent();
                                return [
                                    2,
                                    blob ? $04f424e220a55f33$export$a05254e7c3aeba6e._fromJSON(_this.auth, blob) : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeCurrentUser",
            value: function removeCurrentUser() {
                return this.persistence._remove(this.fullUserKey);
            }
        },
        {
            key: "savePersistenceForRedirect",
            value: function savePersistenceForRedirect() {
                return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
            }
        },
        {
            key: "setPersistence",
            value: function setPersistence(newPersistence) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var currentUser;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.persistence === newPersistence) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.getCurrentUser()
                                ];
                            case 1:
                                currentUser = _state.sent();
                                return [
                                    4,
                                    _this.removeCurrentUser()
                                ];
                            case 2:
                                _state.sent();
                                _this.persistence = newPersistence;
                                if (currentUser) return [
                                    2,
                                    _this.setCurrentUser(currentUser)
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete() {
                this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
            }
        }
    ], [
        {
            key: "create",
            value: function create(auth, persistenceHierarchy) {
                var userKey = arguments.length > 2 && arguments[2] !== void 0 /* KeyName.AUTH_USER */  ? arguments[2] : "authUser";
                return (0, $5Pgs2._)(function() {
                    var availablePersistences, selectedPersistence, key, userToMigrate, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, persistence, blob, user, _a, err, migrationHierarchy;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!persistenceHierarchy.length) return [
                                    2,
                                    new PersistenceUserManager($04f424e220a55f33$export$24baa2b76016ce0e($04f424e220a55f33$export$3722cfe417b6ed86), auth, userKey)
                                ];
                                return [
                                    4,
                                    Promise.all(persistenceHierarchy.map(function() {
                                        var _ref = (0, $5Pgs2._)(function(persistence) {
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            persistence._isAvailable()
                                                        ];
                                                    case 1:
                                                        if (_state.sent()) return [
                                                            2,
                                                            persistence
                                                        ];
                                                        return [
                                                            2,
                                                            undefined
                                                        ];
                                                }
                                            });
                                        });
                                        return function(persistence) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                availablePersistences = _state.sent().filter(function(persistence) {
                                    return persistence;
                                });
                                selectedPersistence = availablePersistences[0] || $04f424e220a55f33$export$24baa2b76016ce0e($04f424e220a55f33$export$3722cfe417b6ed86);
                                key = $04f424e220a55f33$export$158acd800e1ef08b(userKey, auth.config.apiKey, auth.name);
                                userToMigrate = null;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = persistenceHierarchy[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                persistence = _step.value;
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    persistence._get(key)
                                ];
                            case 5:
                                blob = _state.sent();
                                if (blob) {
                                    user = $04f424e220a55f33$export$a05254e7c3aeba6e._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                                    if (persistence !== selectedPersistence) userToMigrate = user;
                                    selectedPersistence = persistence;
                                    return [
                                        3,
                                        8
                                    ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _a = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                migrationHierarchy = availablePersistences.filter(function(p) {
                                    return p._shouldAllowMigration;
                                });
                                // If the persistence does _not_ allow migration, just finish off here
                                if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return [
                                    2,
                                    new PersistenceUserManager(selectedPersistence, auth, userKey)
                                ];
                                selectedPersistence = migrationHierarchy[0];
                                if (!userToMigrate) return [
                                    3,
                                    13
                                ];
                                // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
                                // we'll just let it bubble to surface the error.
                                return [
                                    4,
                                    selectedPersistence._set(key, userToMigrate.toJSON())
                                ];
                            case 12:
                                _state.sent();
                                _state.label = 13;
                            case 13:
                                // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
                                // such as users getting stuck with a previous account after signing out and refreshing the tab.
                                return [
                                    4,
                                    Promise.all(persistenceHierarchy.map(function() {
                                        var _ref = (0, $5Pgs2._)(function(persistence) {
                                            var _a;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!(persistence !== selectedPersistence)) return [
                                                            3,
                                                            4
                                                        ];
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            persistence._remove(key)
                                                        ];
                                                    case 2:
                                                        _state.sent();
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        _a = _state.sent();
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(persistence) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 14:
                                _state.sent();
                                return [
                                    2,
                                    new PersistenceUserManager(selectedPersistence, auth, userKey)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PersistenceUserManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $04f424e220a55f33$var$_getBrowserName(userAgent) {
    var ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($04f424e220a55f33$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($04f424e220a55f33$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($04f424e220a55f33$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($04f424e220a55f33$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($04f424e220a55f33$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $04f424e220a55f33$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($04f424e220a55f33$export$d66dc83d8cfc8dd(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        var re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        var matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $04f424e220a55f33$var$_isFirefox() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    return /firefox\//i.test(ua);
}
function $04f424e220a55f33$var$_isSafari() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    var ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $04f424e220a55f33$var$_isChromeIOS() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    return /crios\//i.test(ua);
}
function $04f424e220a55f33$var$_isIEMobile() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    return /iemobile/i.test(ua);
}
function $04f424e220a55f33$export$d66dc83d8cfc8dd() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    return /android/i.test(ua);
}
function $04f424e220a55f33$var$_isBlackBerry() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    return /blackberry/i.test(ua);
}
function $04f424e220a55f33$var$_isWebOS() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    return /webos/i.test(ua);
}
function $04f424e220a55f33$export$1fbe638ecf81657e() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $04f424e220a55f33$export$3d12bd131bb975d1() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $04f424e220a55f33$var$_isIOSStandalone() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    var _a;
    return $04f424e220a55f33$export$1fbe638ecf81657e(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $04f424e220a55f33$var$_isIE10() {
    return (0, $cxgyp.isIE)() && document.documentMode === 10;
}
function $04f424e220a55f33$var$_isMobileBrowser() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $cxgyp.getUA)();
    // TODO: implement getBrowserName equivalent for OS.
    return $04f424e220a55f33$export$1fbe638ecf81657e(ua) || $04f424e220a55f33$export$d66dc83d8cfc8dd(ua) || $04f424e220a55f33$var$_isWebOS(ua) || $04f424e220a55f33$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $04f424e220a55f33$var$_isIEMobile(ua);
}
function $04f424e220a55f33$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $04f424e220a55f33$export$91477dc880baac21(clientPlatform) {
    var frameworks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $04f424e220a55f33$var$_getBrowserName((0, $cxgyp.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = "".concat($04f424e220a55f33$var$_getBrowserName((0, $cxgyp.getUA)()), "-").concat(clientPlatform);
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    var reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return "".concat(reportedPlatform, "/", "JsCore" /* ClientImplementation.CORE */ , "/").concat((0, $2Ldjj.SDK_VERSION), "/").concat(reportedFrameworks);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$AuthMiddlewareQueue = /*#__PURE__*/ function() {
    "use strict";
    function AuthMiddlewareQueue(auth) {
        (0, $50OuQ._)(this, AuthMiddlewareQueue);
        this.auth = auth;
        this.queue = [];
    }
    (0, $fGdZr._)(AuthMiddlewareQueue, [
        {
            key: "pushCallback",
            value: function pushCallback(callback, onAbort) {
                var _this = this;
                // The callback could be sync or async. Wrap it into a
                // function that is always async.
                var wrappedCallback = function(user) {
                    return new Promise(function(resolve, reject) {
                        try {
                            var result = callback(user);
                            // Either resolve with existing promise or wrap a non-promise
                            // return value into a promise.
                            resolve(result);
                        } catch (e) {
                            // Sync callback throws.
                            reject(e);
                        }
                    });
                };
                // Attach the onAbort if present
                wrappedCallback.onAbort = onAbort;
                this.queue.push(wrappedCallback);
                var index = this.queue.length - 1;
                return function() {
                    // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
                    // indexing of other elements.
                    _this.queue[index] = function() {
                        return Promise.resolve();
                    };
                };
            }
        },
        {
            key: "runMiddleware",
            value: function runMiddleware(nextUser) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var onAbortStack, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, beforeStateCallback, err, e, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, onAbort;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.auth.currentUser === nextUser) return [
                                    2
                                ];
                                onAbortStack = [];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    ,
                                    11
                                ]);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = _this.queue[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                beforeStateCallback = _step.value;
                                return [
                                    4,
                                    beforeStateCallback(nextUser)
                                ];
                            case 4:
                                _state.sent();
                                // Only push the onAbort if the callback succeeds
                                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                e = _state.sent();
                                // Run all onAbort, with separate try/catch to ignore any errors and
                                // continue
                                onAbortStack.reverse();
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = onAbortStack[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        onAbort = _step1.value;
                                        try {
                                            onAbort();
                                        } catch (_) {
                                        /* swallow error */ }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                throw _this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                                    originalMessage: e === null || e === void 0 ? void 0 : e.message
                                });
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthMiddlewareQueue;
}();
function $04f424e220a55f33$var$_getPasswordPolicy(auth) {
    return $04f424e220a55f33$var$__getPasswordPolicy.apply(this, arguments);
}
function $04f424e220a55f33$var$__getPasswordPolicy() {
    $04f424e220a55f33$var$__getPasswordPolicy = /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ (0, $5Pgs2._)(function(auth) {
        var request;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            request = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$__getPasswordPolicy.apply(this, arguments);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
var $04f424e220a55f33$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ var $04f424e220a55f33$var$PasswordPolicyImpl = /*#__PURE__*/ function() {
    "use strict";
    function PasswordPolicyImpl(response) {
        (0, $50OuQ._)(this, PasswordPolicyImpl);
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        var responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $04f424e220a55f33$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    (0, $fGdZr._)(PasswordPolicyImpl, [
        {
            key: "validatePassword",
            value: function validatePassword(password) {
                var _a, _b, _c, _d, _e, _f;
                var status = {
                    isValid: true,
                    passwordPolicy: this
                };
                // Check the password length and character options.
                this.validatePasswordLengthOptions(password, status);
                this.validatePasswordCharacterOptions(password, status);
                // Combine the status into single isValid property.
                status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
                status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
                status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
                status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
                status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
                status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
                return status;
            }
        },
        {
            /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ key: "validatePasswordLengthOptions",
            value: function validatePasswordLengthOptions(password, status) {
                var minPasswordLength = this.customStrengthOptions.minPasswordLength;
                var maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
                if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
                if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
            }
        },
        {
            /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ key: "validatePasswordCharacterOptions",
            value: function validatePasswordCharacterOptions(password, status) {
                // Assign statuses for requirements even if the password is an empty string.
                this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
                var passwordChar;
                for(var i = 0; i < password.length; i++){
                    passwordChar = password.charAt(i);
                    this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
                }
            }
        },
        {
            /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ key: "updatePasswordCharacterOptionsStatuses",
            value: function updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
                if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
                if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
                if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
                if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
            }
        }
    ]);
    return PasswordPolicyImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$export$23ebac1979863676 = /*#__PURE__*/ function() {
    "use strict";
    function AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config) {
        (0, $50OuQ._)(this, AuthImpl);
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $04f424e220a55f33$var$Subscription(this);
        this.idTokenSubscription = new $04f424e220a55f33$var$Subscription(this);
        this.beforeStateQueue = new $04f424e220a55f33$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $04f424e220a55f33$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    (0, $fGdZr._)(AuthImpl, [
        {
            key: "_initializeWithPersistence",
            value: function _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
                if (popupRedirectResolver) this._popupRedirectResolver = $04f424e220a55f33$export$24baa2b76016ce0e(popupRedirectResolver);
                var _this = this;
                // Have to check for app deletion throughout initialization (after each
                // promise resolution)
                this._initializationPromise = this.queue(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                    var _a, _b, e;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                return [
                                    4,
                                    $04f424e220a55f33$var$PersistenceUserManager.create(_this, persistenceHierarchy)
                                ];
                            case 1:
                                _this.persistenceManager = _state.sent();
                                if (_this._deleted) return [
                                    2
                                ];
                                if (!((_a = _this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively)) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this._popupRedirectResolver._initialize(_this)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    4,
                                    _this.initializeCurrentUser(popupRedirectResolver)
                                ];
                            case 6:
                                _state.sent();
                                _this.lastNotifiedUid = ((_b = _this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
                                if (_this._deleted) return [
                                    2
                                ];
                                _this._isInitialized = true;
                                return [
                                    2
                                ];
                        }
                    });
                }));
                return this._initializationPromise;
            }
        },
        {
            key: "_onStorageEvent",
            value: /**
     * If the persistence is changed in another window, the user manager will let us know
     */ function _onStorageEvent() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var user;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.assertedPersistence.getCurrentUser()
                                ];
                            case 1:
                                user = _state.sent();
                                if (!_this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
                                return [
                                    2
                                ];
                                if (!(_this.currentUser && user && _this.currentUser.uid === user.uid)) return [
                                    3,
                                    3
                                ];
                                // Data update, simply copy data changes.
                                _this._currentUser._assign(user);
                                // If tokens changed from previous user tokens, this will trigger
                                // notifyAuthListeners_.
                                return [
                                    4,
                                    _this.currentUser.getIdToken()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 3:
                                // Update current Auth state. Either a new login or logout.
                                // Skip blocking callbacks, they should not apply to a change in another tab.
                                return [
                                    4,
                                    _this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeCurrentUser",
            value: function initializeCurrentUser(popupRedirectResolver) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, previouslyStoredUser, futureCurrentUser, needsTocheckMiddleware, redirectUserEventId, storedUserEventId, result, e;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.assertedPersistence.getCurrentUser()
                                ];
                            case 1:
                                previouslyStoredUser = _state.sent();
                                futureCurrentUser = previouslyStoredUser;
                                needsTocheckMiddleware = false;
                                if (!(popupRedirectResolver && _this.config.authDomain)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager()
                                ];
                            case 2:
                                _state.sent();
                                redirectUserEventId = (_a = _this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
                                storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
                                return [
                                    4,
                                    _this.tryRedirectSignIn(popupRedirectResolver)
                                ];
                            case 3:
                                result = _state.sent();
                                // If the stored user (i.e. the old "currentUser") has a redirectId that
                                // matches the redirect user, then we want to initially sign in with the
                                // new user object from result.
                                // TODO(samgho): More thoroughly test all of this
                                if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                                    futureCurrentUser = result.user;
                                    needsTocheckMiddleware = true;
                                }
                                _state.label = 4;
                            case 4:
                                // If no user in persistence, there is no current user. Set to null.
                                if (!futureCurrentUser) return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                if (!!futureCurrentUser._redirectEventId) return [
                                    3,
                                    9
                                ];
                                if (!needsTocheckMiddleware) return [
                                    3,
                                    8
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(futureCurrentUser)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                e = _state.sent();
                                futureCurrentUser = previouslyStoredUser;
                                // We know this is available since the bit is only set when the
                                // resolver is available
                                _this._popupRedirectResolver._overrideRedirectResult(_this, function() {
                                    return Promise.reject(e);
                                });
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                if (futureCurrentUser) return [
                                    2,
                                    _this.reloadAndSetCurrentUserOrClear(futureCurrentUser)
                                ];
                                else return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                _state.label = 9;
                            case 9:
                                $04f424e220a55f33$export$9d398bebfec1c039(_this._popupRedirectResolver, _this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager()
                                ];
                            case 10:
                                _state.sent();
                                // If the redirect user's event ID matches the current user's event ID,
                                // DO NOT reload the current user, otherwise they'll be cleared from storage.
                                // This is important for the reauthenticateWithRedirect() flow.
                                if (_this.redirectUser && _this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return [
                                    2,
                                    _this.directlySetCurrentUser(futureCurrentUser)
                                ];
                                return [
                                    2,
                                    _this.reloadAndSetCurrentUserOrClear(futureCurrentUser)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "tryRedirectSignIn",
            value: function tryRedirectSignIn(redirectResolver) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var result, e;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                result = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this._popupRedirectResolver._completeRedirectFn(_this, redirectResolver, true)
                                ];
                            case 2:
                                // We know this._popupRedirectResolver is set since redirectResolver
                                // is passed in. The _completeRedirectFn expects the unwrapped extern.
                                result = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                e = _state.sent();
                                // Swallow any errors here; the code can retrieve them in
                                // getRedirectResult().
                                return [
                                    4,
                                    _this._setRedirectUser(null)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reloadAndSetCurrentUserOrClear",
            value: function reloadAndSetCurrentUserOrClear(user) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var e;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    $04f424e220a55f33$var$_reloadWithoutSaving(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                if ((e === null || e === void 0 ? void 0 : e.code) !== "auth/network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ) // Something's wrong with the user's token. Log them out and remove
                                // them from storage
                                return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2,
                                    _this.directlySetCurrentUser(user)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "useDeviceLanguage",
            value: function useDeviceLanguage() {
                this.languageCode = $04f424e220a55f33$var$_getUserLanguage();
            }
        },
        {
            key: "_delete",
            value: function _delete() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        _this._deleted = true;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "updateCurrentUser",
            value: function updateCurrentUser(userExtern) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var user;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        user = userExtern ? (0, $cxgyp.getModularInstance)(userExtern) : null;
                        if (user) $04f424e220a55f33$export$9d398bebfec1c039(user.auth.config.apiKey === _this.config.apiKey, _this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
                        return [
                            2,
                            _this._updateCurrentUser(user && user._clone(_this))
                        ];
                    });
                })();
            }
        },
        {
            key: "_updateCurrentUser",
            value: function _updateCurrentUser(user) {
                var skipBeforeStateCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                if (user) $04f424e220a55f33$export$9d398bebfec1c039(_this.tenantId === user.tenantId, _this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
                                if (!!skipBeforeStateCallbacks) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(user)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    _this.queue(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this.directlySetCurrentUser(user)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _this.notifyAuthListeners();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signOut",
            value: function signOut() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Run first, to block _setRedirectUser() if any callbacks fail.
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(null)
                                ];
                            case 1:
                                _state.sent();
                                if (!(_this.redirectPersistenceManager || _this._popupRedirectResolver)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this._setRedirectUser(null)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                // Prevent callbacks from being called again in _updateCurrentUser, as
                                // they were already called in the first line.
                                return [
                                    2,
                                    _this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setPersistence",
            value: function setPersistence(persistence) {
                var _this = this;
                return this.queue(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.assertedPersistence.setPersistence($04f424e220a55f33$export$24baa2b76016ce0e(persistence))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        },
        {
            key: "_getRecaptchaConfig",
            value: function _getRecaptchaConfig() {
                if (this.tenantId == null) return this._agentRecaptchaConfig;
                else return this._tenantRecaptchaConfigs[this.tenantId];
            }
        },
        {
            key: "validatePassword",
            value: function validatePassword(password) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var passwordPolicy;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this._getPasswordPolicyInternal()) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._updatePasswordPolicy()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                passwordPolicy = _this._getPasswordPolicyInternal();
                                // Check that the policy schema version is supported by the SDK.
                                // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
                                if (passwordPolicy.schemaVersion !== _this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return [
                                    2,
                                    Promise.reject(_this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}))
                                ];
                                return [
                                    2,
                                    passwordPolicy.validatePassword(password)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getPasswordPolicyInternal",
            value: function _getPasswordPolicyInternal() {
                if (this.tenantId === null) return this._projectPasswordPolicy;
                else return this._tenantPasswordPolicies[this.tenantId];
            }
        },
        {
            key: "_updatePasswordPolicy",
            value: function _updatePasswordPolicy() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var response, passwordPolicy;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $04f424e220a55f33$var$_getPasswordPolicy(_this)
                                ];
                            case 1:
                                response = _state.sent();
                                passwordPolicy = new $04f424e220a55f33$var$PasswordPolicyImpl(response);
                                if (_this.tenantId === null) _this._projectPasswordPolicy = passwordPolicy;
                                else _this._tenantPasswordPolicies[_this.tenantId] = passwordPolicy;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getPersistence",
            value: function _getPersistence() {
                return this.assertedPersistence.persistence.type;
            }
        },
        {
            key: "_updateErrorMap",
            value: function _updateErrorMap(errorMap) {
                this._errorFactory = new (0, $cxgyp.ErrorFactory)("auth", "Firebase", errorMap());
            }
        },
        {
            key: "onAuthStateChanged",
            value: function onAuthStateChanged(nextOrObserver, error, completed) {
                return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
            }
        },
        {
            key: "beforeAuthStateChanged",
            value: function beforeAuthStateChanged(callback, onAbort) {
                return this.beforeStateQueue.pushCallback(callback, onAbort);
            }
        },
        {
            key: "onIdTokenChanged",
            value: function onIdTokenChanged(nextOrObserver, error, completed) {
                return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
            }
        },
        {
            key: "authStateReady",
            value: function authStateReady() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (_this.currentUser) resolve();
                    else {
                        var unsubscribe = _this.onAuthStateChanged(function() {
                            unsubscribe();
                            resolve();
                        }, reject);
                    }
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var _a;
                return {
                    apiKey: this.config.apiKey,
                    authDomain: this.config.authDomain,
                    appName: this.name,
                    currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
                };
            }
        },
        {
            key: "_setRedirectUser",
            value: function _setRedirectUser(user, popupRedirectResolver) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var redirectManager;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager(popupRedirectResolver)
                                ];
                            case 1:
                                redirectManager = _state.sent();
                                return [
                                    2,
                                    user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOrInitRedirectPersistenceManager",
            value: function getOrInitRedirectPersistenceManager(popupRedirectResolver) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var resolver;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.redirectPersistenceManager) return [
                                    3,
                                    3
                                ];
                                resolver = popupRedirectResolver && $04f424e220a55f33$export$24baa2b76016ce0e(popupRedirectResolver) || _this._popupRedirectResolver;
                                $04f424e220a55f33$export$9d398bebfec1c039(resolver, _this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                                return [
                                    4,
                                    $04f424e220a55f33$var$PersistenceUserManager.create(_this, [
                                        $04f424e220a55f33$export$24baa2b76016ce0e(resolver._redirectPersistence)
                                    ], "redirectUser" /* KeyName.REDIRECT_USER */ )
                                ];
                            case 1:
                                _this.redirectPersistenceManager = _state.sent();
                                return [
                                    4,
                                    _this.redirectPersistenceManager.getCurrentUser()
                                ];
                            case 2:
                                _this.redirectUser = _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _this.redirectPersistenceManager
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_redirectUserForId",
            value: function _redirectUserForId(id) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this._isInitialized) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.queue(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            return [
                                                2
                                            ];
                                        });
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (((_a = _this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return [
                                    2,
                                    _this._currentUser
                                ];
                                if (((_b = _this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return [
                                    2,
                                    _this.redirectUser
                                ];
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_persistUserIfCurrent",
            value: function _persistUserIfCurrent(user) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        if (user === _this.currentUser) return [
                            2,
                            _this.queue(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        _this.directlySetCurrentUser(user)
                                    ];
                                });
                            }))
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** Notifies listeners only if the user is current */ key: "_notifyListenersIfCurrent",
            value: function _notifyListenersIfCurrent(user) {
                if (user === this.currentUser) this.notifyAuthListeners();
            }
        },
        {
            key: "_key",
            value: function _key() {
                return "".concat(this.config.authDomain, ":").concat(this.config.apiKey, ":").concat(this.name);
            }
        },
        {
            key: "_startProactiveRefresh",
            value: function _startProactiveRefresh() {
                this.isProactiveRefreshEnabled = true;
                if (this.currentUser) this._currentUser._startProactiveRefresh();
            }
        },
        {
            key: "_stopProactiveRefresh",
            value: function _stopProactiveRefresh() {
                this.isProactiveRefreshEnabled = false;
                if (this.currentUser) this._currentUser._stopProactiveRefresh();
            }
        },
        {
            key: "_currentUser",
            get: /** Returns the current user cast as the internal type */ function get() {
                return this.currentUser;
            }
        },
        {
            key: "notifyAuthListeners",
            value: function notifyAuthListeners() {
                var _a, _b;
                if (!this._isInitialized) return;
                this.idTokenSubscription.next(this.currentUser);
                var currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
                if (this.lastNotifiedUid !== currentUid) {
                    this.lastNotifiedUid = currentUid;
                    this.authStateSubscription.next(this.currentUser);
                }
            }
        },
        {
            key: "registerStateListener",
            value: function registerStateListener(subscription, nextOrObserver, error, completed) {
                var _this = this;
                if (this._deleted) return function() {};
                var cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
                var isUnsubscribed = false;
                var promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
                $04f424e220a55f33$export$9d398bebfec1c039(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                // The callback needs to be called asynchronously per the spec.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                promise.then(function() {
                    if (isUnsubscribed) return;
                    cb(_this.currentUser);
                });
                if (typeof nextOrObserver === "function") {
                    var unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
                    return function() {
                        isUnsubscribed = true;
                        unsubscribe();
                    };
                } else {
                    var unsubscribe1 = subscription.addObserver(nextOrObserver);
                    return function() {
                        isUnsubscribed = true;
                        unsubscribe1();
                    };
                }
            }
        },
        {
            key: "directlySetCurrentUser",
            value: /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ function directlySetCurrentUser(user) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.currentUser && _this.currentUser !== user) _this._currentUser._stopProactiveRefresh();
                                if (user && _this.isProactiveRefreshEnabled) user._startProactiveRefresh();
                                _this.currentUser = user;
                                if (!user) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.assertedPersistence.setCurrentUser(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.assertedPersistence.removeCurrentUser()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "queue",
            value: function queue(action) {
                // In case something errors, the callback still should be called in order
                // to keep the promise chain alive
                this.operations = this.operations.then(action, action);
                return this.operations;
            }
        },
        {
            key: "assertedPersistence",
            get: function get() {
                $04f424e220a55f33$export$9d398bebfec1c039(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.persistenceManager;
            }
        },
        {
            key: "_logFramework",
            value: function _logFramework(framework) {
                if (!framework || this.frameworks.includes(framework)) return;
                this.frameworks.push(framework);
                // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
                // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
                this.frameworks.sort();
                this.clientVersion = $04f424e220a55f33$export$91477dc880baac21(this.config.clientPlatform, this._getFrameworks());
            }
        },
        {
            key: "_getFrameworks",
            value: function _getFrameworks() {
                return this.frameworks;
            }
        },
        {
            key: "_getAdditionalHeaders",
            value: function _getAdditionalHeaders() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, headers, heartbeatsHeader, appCheckToken;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = (0, $2iBlG._)({}, "X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ , _this.clientVersion);
                                if (_this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = _this.app.options.appId;
                                return [
                                    4,
                                    (_a = _this.heartbeatServiceProvider.getImmediate({
                                        optional: true
                                    })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader()
                                ];
                            case 1:
                                heartbeatsHeader = _state.sent();
                                if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
                                return [
                                    4,
                                    _this._getAppCheckToken()
                                ];
                            case 2:
                                appCheckToken = _state.sent();
                                if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
                                return [
                                    2,
                                    headers
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getAppCheckToken",
            value: function _getAppCheckToken() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, appCheckTokenResult;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (_a = _this.appCheckServiceProvider.getImmediate({
                                        optional: true
                                    })) === null || _a === void 0 ? void 0 : _a.getToken()
                                ];
                            case 1:
                                appCheckTokenResult = _state.sent();
                                if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
                                // In the error case, a dummy token will be returned along with an error field describing
                                // the error. In general, we shouldn't care about the error condition and just use
                                // the token (actual or dummy) to send requests.
                                $04f424e220a55f33$var$_logWarn("Error while retrieving App Check token: ".concat(appCheckTokenResult.error));
                                return [
                                    2,
                                    appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthImpl;
}();
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $04f424e220a55f33$export$b9a6b53f9be3734(auth) {
    return (0, $cxgyp.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ var $04f424e220a55f33$var$Subscription = /*#__PURE__*/ function() {
    "use strict";
    function Subscription(auth) {
        var _this = this;
        (0, $50OuQ._)(this, Subscription);
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $cxgyp.createSubscribe)(function(observer) {
            return _this.observer = observer;
        });
    }
    (0, $fGdZr._)(Subscription, [
        {
            key: "next",
            get: function get() {
                $04f424e220a55f33$export$9d398bebfec1c039(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.observer.next.bind(this.observer);
            }
        }
    ]);
    return Subscription;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $04f424e220a55f33$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise(function(resolve, reject) {
        var el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = function(e) {
            var error = $04f424e220a55f33$export$91c6e00c14e7e6fd("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $04f424e220a55f33$var$getScriptParentElement().appendChild(el);
    });
}
function $04f424e220a55f33$var$_generateCallbackName(prefix) {
    return "__".concat(prefix).concat(Math.floor(Math.random() * 1000000));
}
/* eslint-disable @typescript-eslint/no-require-imports */ var $04f424e220a55f33$var$RECAPTCHA_ENTERPRISE_URL = "https://www.google.com/recaptcha/enterprise.js?render=";
var $04f424e220a55f33$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
var $04f424e220a55f33$var$FAKE_TOKEN = "NO_RECAPTCHA";
var $04f424e220a55f33$var$RecaptchaEnterpriseVerifier = /*#__PURE__*/ function() {
    "use strict";
    function RecaptchaEnterpriseVerifier(authExtern) {
        (0, $50OuQ._)(this, RecaptchaEnterpriseVerifier);
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $04f424e220a55f33$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $04f424e220a55f33$export$b9a6b53f9be3734(authExtern);
    }
    (0, $fGdZr._)(RecaptchaEnterpriseVerifier, [
        {
            key: "verify",
            value: /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ function verify() {
                var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "verify", forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    function retrieveSiteKey(auth) {
                        return _retrieveSiteKey.apply(this, arguments);
                    }
                    function _retrieveSiteKey() {
                        _retrieveSiteKey = (0, $5Pgs2._)(function(auth) {
                            return (0, $1XfpH.__generator)(this, function(_state) {
                                if (!forceRefresh) {
                                    if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return [
                                        2,
                                        auth._agentRecaptchaConfig.siteKey
                                    ];
                                    if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return [
                                        2,
                                        auth._tenantRecaptchaConfigs[auth.tenantId].siteKey
                                    ];
                                }
                                return [
                                    2,
                                    new Promise(function() {
                                        var _ref = (0, $5Pgs2._)(function(resolve, reject) {
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                $04f424e220a55f33$var$getRecaptchaConfig(auth, {
                                                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                                                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                                                }).then(function(response) {
                                                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                                                    else {
                                                        var config = new $04f424e220a55f33$var$RecaptchaConfig(response);
                                                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                                                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                                                        return resolve(config.siteKey);
                                                    }
                                                })["catch"](function(error) {
                                                    reject(error);
                                                });
                                                return [
                                                    2
                                                ];
                                            });
                                        });
                                        return function(resolve, reject) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            });
                        });
                        return _retrieveSiteKey.apply(this, arguments);
                    }
                    function retrieveRecaptchaToken(siteKey, resolve, reject) {
                        var grecaptcha = window.grecaptcha;
                        if ($04f424e220a55f33$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(function() {
                            grecaptcha.enterprise.execute(siteKey, {
                                action: action
                            }).then(function(token) {
                                resolve(token);
                            })["catch"](function() {
                                resolve($04f424e220a55f33$var$FAKE_TOKEN);
                            });
                        });
                        else reject(Error("No reCAPTCHA enterprise script loaded."));
                    }
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                retrieveSiteKey(_this.auth).then(function(siteKey) {
                                    if (!forceRefresh && $04f424e220a55f33$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                                    else {
                                        if (typeof window === "undefined") {
                                            reject(new Error("RecaptchaVerifier is only supported in browser"));
                                            return;
                                        }
                                        $04f424e220a55f33$var$_loadJS($04f424e220a55f33$var$RECAPTCHA_ENTERPRISE_URL + siteKey).then(function() {
                                            retrieveRecaptchaToken(siteKey, resolve, reject);
                                        })["catch"](function(error) {
                                            reject(error);
                                        });
                                    }
                                })["catch"](function(error) {
                                    reject(error);
                                });
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return RecaptchaEnterpriseVerifier;
}();
function $04f424e220a55f33$var$injectRecaptchaFields(auth, request, action) {
    return $04f424e220a55f33$var$_injectRecaptchaFields.apply(this, arguments);
}
function $04f424e220a55f33$var$_injectRecaptchaFields() {
    $04f424e220a55f33$var$_injectRecaptchaFields = (0, $5Pgs2._)(function(auth, request, action) {
        var captchaResp, verifier, captchaResponse, error, newRequest;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    captchaResp = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false;
                    verifier = new $04f424e220a55f33$var$RecaptchaEnterpriseVerifier(auth);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        verifier.verify(action)
                    ];
                case 2:
                    captchaResponse = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        4,
                        verifier.verify(action, true)
                    ];
                case 4:
                    captchaResponse = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    newRequest = Object.assign({}, request);
                    if (!captchaResp) Object.assign(newRequest, {
                        captchaResponse: captchaResponse
                    });
                    else Object.assign(newRequest, {
                        captchaResp: captchaResponse
                    });
                    Object.assign(newRequest, {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    });
                    Object.assign(newRequest, {
                        recaptchaVersion: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                    });
                    return [
                        2,
                        newRequest
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_injectRecaptchaFields.apply(this, arguments);
}
function $04f424e220a55f33$var$_initializeRecaptchaConfig(auth) {
    return $04f424e220a55f33$var$__initializeRecaptchaConfig.apply(this, arguments);
}
function $04f424e220a55f33$var$__initializeRecaptchaConfig() {
    $04f424e220a55f33$var$__initializeRecaptchaConfig = (0, $5Pgs2._)(function(auth) {
        var authInternal, response, config, verifier;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
                    return [
                        4,
                        $04f424e220a55f33$var$getRecaptchaConfig(authInternal, {
                            clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                            version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                        })
                    ];
                case 1:
                    response = _state.sent();
                    config = new $04f424e220a55f33$var$RecaptchaConfig(response);
                    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
                    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
                    if (config.emailPasswordEnabled) {
                        verifier = new $04f424e220a55f33$var$RecaptchaEnterpriseVerifier(authInternal);
                        verifier.verify();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__initializeRecaptchaConfig.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $04f424e220a55f33$export$9bb611d729802a56(app, deps) {
    var provider = (0, $2Ldjj._getProvider)(app, "auth");
    if (provider.isInitialized()) {
        var auth = provider.getImmediate();
        var initialOptions = provider.getOptions();
        if ((0, $cxgyp.deepEqual)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $04f424e220a55f33$export$92108d983e8ee699(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    var auth1 = provider.initialize({
        options: deps
    });
    return auth1;
}
function $04f424e220a55f33$var$_initializeAuthInstance(auth, deps) {
    var persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    var hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($04f424e220a55f33$export$24baa2b76016ce0e);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $04f424e220a55f33$export$b4171a6734a65d42(auth, url, options) {
    var authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
    $04f424e220a55f33$export$9d398bebfec1c039(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $04f424e220a55f33$export$9d398bebfec1c039(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    var disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    var protocol = $04f424e220a55f33$var$extractProtocol(url);
    var _extractHostAndPort = $04f424e220a55f33$var$extractHostAndPort(url), host = _extractHostAndPort.host, port = _extractHostAndPort.port;
    var portStr = port === null ? "" : ":".concat(port);
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: "".concat(protocol, "//").concat(host).concat(portStr, "/")
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $04f424e220a55f33$var$emitEmulatorWarning();
}
function $04f424e220a55f33$var$extractProtocol(url) {
    var protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $04f424e220a55f33$var$extractHostAndPort(url) {
    var protocol = $04f424e220a55f33$var$extractProtocol(url);
    var authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    var hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    var bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        var host = bracketedIPv6[1];
        return {
            host: host,
            port: $04f424e220a55f33$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        var _hostAndPort_split = (0, $aSMts._)(hostAndPort.split(":"), 2), host1 = _hostAndPort_split[0], port = _hostAndPort_split[1];
        return {
            host: host1,
            port: $04f424e220a55f33$var$parsePort(port)
        };
    }
}
function $04f424e220a55f33$var$parsePort(portStr) {
    if (!portStr) return null;
    var port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $04f424e220a55f33$var$emitEmulatorWarning() {
    var attachBanner = function attachBanner() {
        var el = document.createElement("p");
        var sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    };
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ var $04f424e220a55f33$export$3466f893ebf79586 = /*#__PURE__*/ function() {
    "use strict";
    function AuthCredential(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod) {
        (0, $50OuQ._)(this, AuthCredential);
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    (0, $fGdZr._)(AuthCredential, [
        {
            /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ key: "toJSON",
            value: function toJSON() {
                return $04f424e220a55f33$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(_auth) {
                return $04f424e220a55f33$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(_auth, _idToken) {
                return $04f424e220a55f33$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(_auth) {
                return $04f424e220a55f33$var$debugFail("not implemented");
            }
        }
    ]);
    return AuthCredential;
}();
function $04f424e220a55f33$var$resetPassword(auth, request) {
    return $04f424e220a55f33$var$_resetPassword.apply(this, arguments);
}
function $04f424e220a55f33$var$_resetPassword() {
    $04f424e220a55f33$var$_resetPassword = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_resetPassword.apply(this, arguments);
}
function $04f424e220a55f33$var$updateEmailPassword(auth, request) {
    return $04f424e220a55f33$var$_updateEmailPassword.apply(this, arguments);
}
function $04f424e220a55f33$var$_updateEmailPassword() {
    $04f424e220a55f33$var$_updateEmailPassword = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $04f424e220a55f33$var$_updateEmailPassword.apply(this, arguments);
}
function $04f424e220a55f33$var$applyActionCode$1(auth, request) {
    return $04f424e220a55f33$var$_applyActionCode$1.apply(this, arguments);
}
function $04f424e220a55f33$var$_applyActionCode$1() {
    $04f424e220a55f33$var$_applyActionCode$1 = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_applyActionCode$1.apply(this, arguments);
}
function $04f424e220a55f33$var$signInWithPassword(auth, request) {
    return $04f424e220a55f33$var$_signInWithPassword.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithPassword() {
    $04f424e220a55f33$var$_signInWithPassword = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_signInWithPassword.apply(this, arguments);
}
function $04f424e220a55f33$var$sendOobCode(auth, request) {
    return $04f424e220a55f33$var$_sendOobCode.apply(this, arguments);
}
function $04f424e220a55f33$var$_sendOobCode() {
    $04f424e220a55f33$var$_sendOobCode = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_sendOobCode.apply(this, arguments);
}
function $04f424e220a55f33$var$sendEmailVerification$1(auth, request) {
    return $04f424e220a55f33$var$_sendEmailVerification$1.apply(this, arguments);
}
function $04f424e220a55f33$var$_sendEmailVerification$1() {
    $04f424e220a55f33$var$_sendEmailVerification$1 = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$sendOobCode(auth, request)
            ];
        });
    });
    return $04f424e220a55f33$var$_sendEmailVerification$1.apply(this, arguments);
}
function $04f424e220a55f33$var$sendPasswordResetEmail$1(auth, request) {
    return $04f424e220a55f33$var$_sendPasswordResetEmail$1.apply(this, arguments);
}
function $04f424e220a55f33$var$_sendPasswordResetEmail$1() {
    $04f424e220a55f33$var$_sendPasswordResetEmail$1 = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$sendOobCode(auth, request)
            ];
        });
    });
    return $04f424e220a55f33$var$_sendPasswordResetEmail$1.apply(this, arguments);
}
function $04f424e220a55f33$var$sendSignInLinkToEmail$1(auth, request) {
    return $04f424e220a55f33$var$_sendSignInLinkToEmail$1.apply(this, arguments);
}
function $04f424e220a55f33$var$_sendSignInLinkToEmail$1() {
    $04f424e220a55f33$var$_sendSignInLinkToEmail$1 = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$sendOobCode(auth, request)
            ];
        });
    });
    return $04f424e220a55f33$var$_sendSignInLinkToEmail$1.apply(this, arguments);
}
function $04f424e220a55f33$var$verifyAndChangeEmail(auth, request) {
    return $04f424e220a55f33$var$_verifyAndChangeEmail.apply(this, arguments);
}
function $04f424e220a55f33$var$_verifyAndChangeEmail() {
    $04f424e220a55f33$var$_verifyAndChangeEmail = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$sendOobCode(auth, request)
            ];
        });
    });
    return $04f424e220a55f33$var$_verifyAndChangeEmail.apply(this, arguments);
}
function $04f424e220a55f33$var$signInWithEmailLink$1(auth, request) {
    return $04f424e220a55f33$var$_signInWithEmailLink$1.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithEmailLink$1() {
    $04f424e220a55f33$var$_signInWithEmailLink$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_signInWithEmailLink$1.apply(this, arguments);
}
function $04f424e220a55f33$var$signInWithEmailLinkForLinking(auth, request) {
    return $04f424e220a55f33$var$_signInWithEmailLinkForLinking.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithEmailLinkForLinking() {
    $04f424e220a55f33$var$_signInWithEmailLinkForLinking = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_signInWithEmailLinkForLinking.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ var $04f424e220a55f33$export$61196ced6d74a310 = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $1atwj._)(EmailAuthCredential, AuthCredential);
    var _super = (0, $iD0Am._)(EmailAuthCredential);
    function EmailAuthCredential(/** @internal */ _email, /** @internal */ _password, signInMethod) {
        var /** @internal */ _tenantId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        (0, $50OuQ._)(this, EmailAuthCredential);
        var _this;
        _this = _super.call(this, "password" /* ProviderId.PASSWORD */ , signInMethod);
        _this._email = _email;
        _this._password = _password;
        _this._tenantId = _tenantId;
        return _this;
    }
    (0, $fGdZr._)(EmailAuthCredential, [
        {
            /** {@inheritdoc AuthCredential.toJSON} */ key: "toJSON",
            value: function toJSON() {
                return {
                    email: this._email,
                    password: this._password,
                    signInMethod: this.signInMethod,
                    tenantId: this._tenantId
                };
            }
        },
        {
            key: "_getIdTokenResponse",
            value: /** @internal */ function _getIdTokenResponse(auth) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _, request, requestWithRecaptcha;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.signInMethod;
                                switch(_){
                                    case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                                        return [
                                            3,
                                            1
                                        ];
                                    case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                                        return [
                                            3,
                                            4
                                        ];
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 1:
                                request = {
                                    returnSecureToken: true,
                                    email: _this._email,
                                    password: _this._password,
                                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                                };
                                if (!((_a = auth._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    $04f424e220a55f33$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ )
                                ];
                            case 2:
                                requestWithRecaptcha = _state.sent();
                                return [
                                    2,
                                    $04f424e220a55f33$var$signInWithPassword(auth, requestWithRecaptcha)
                                ];
                            case 3:
                                return [
                                    2,
                                    $04f424e220a55f33$var$signInWithPassword(auth, request)["catch"](function() {
                                        var _ref = (0, $5Pgs2._)(function(error) {
                                            var requestWithRecaptcha;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!(error.code === "auth/missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ )) return [
                                                            3,
                                                            2
                                                        ];
                                                        console.log("Sign-in with email address and password is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                                                        return [
                                                            4,
                                                            $04f424e220a55f33$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ )
                                                        ];
                                                    case 1:
                                                        requestWithRecaptcha = _state.sent();
                                                        return [
                                                            2,
                                                            $04f424e220a55f33$var$signInWithPassword(auth, requestWithRecaptcha)
                                                        ];
                                                    case 2:
                                                        return [
                                                            2,
                                                            Promise.reject(error)
                                                        ];
                                                    case 3:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(error) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 4:
                                return [
                                    2,
                                    $04f424e220a55f33$var$signInWithEmailLink$1(auth, {
                                        email: _this._email,
                                        oobCode: _this._password
                                    })
                                ];
                            case 5:
                                $04f424e220a55f33$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_linkToIdToken",
            value: /** @internal */ function _linkToIdToken(auth, idToken) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_this.signInMethod){
                            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                                return [
                                    2,
                                    $04f424e220a55f33$var$updateEmailPassword(auth, {
                                        idToken: idToken,
                                        returnSecureToken: true,
                                        email: _this._email,
                                        password: _this._password
                                    })
                                ];
                            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                                return [
                                    2,
                                    $04f424e220a55f33$var$signInWithEmailLinkForLinking(auth, {
                                        idToken: idToken,
                                        email: _this._email,
                                        oobCode: _this._password
                                    })
                                ];
                            default:
                                $04f424e220a55f33$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return this._getIdTokenResponse(auth);
            }
        }
    ], [
        {
            key: "_fromEmailAndPassword",
            value: /** @internal */ function _fromEmailAndPassword(email, password) {
                return new EmailAuthCredential(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
            }
        },
        {
            key: "_fromEmailAndCode",
            value: /** @internal */ function _fromEmailAndCode(email, oobCode) {
                var tenantId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                return new EmailAuthCredential(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
            }
        },
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
                    if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
                    else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
                }
                return null;
            }
        }
    ]);
    return EmailAuthCredential;
}($04f424e220a55f33$export$3466f893ebf79586);
function $04f424e220a55f33$var$signInWithIdp(auth, request) {
    return $04f424e220a55f33$var$_signInWithIdp.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithIdp() {
    $04f424e220a55f33$var$_signInWithIdp = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_signInWithIdp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ var $04f424e220a55f33$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $1atwj._)(OAuthCredential, AuthCredential);
    var _super = (0, $iD0Am._)(OAuthCredential);
    function OAuthCredential() {
        (0, $50OuQ._)(this, OAuthCredential);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.pendingToken = null;
        return _this;
    }
    (0, $fGdZr._)(OAuthCredential, [
        {
            /** {@inheritdoc AuthCredential.toJSON}  */ key: "toJSON",
            value: function toJSON() {
                return {
                    idToken: this.idToken,
                    accessToken: this.accessToken,
                    secret: this.secret,
                    nonce: this.nonce,
                    pendingToken: this.pendingToken,
                    providerId: this.providerId,
                    signInMethod: this.signInMethod
                };
            }
        },
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                var request = this.buildRequest();
                return $04f424e220a55f33$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                var request = this.buildRequest();
                request.idToken = idToken;
                return $04f424e220a55f33$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                var request = this.buildRequest();
                request.autoCreate = false;
                return $04f424e220a55f33$var$signInWithIdp(auth, request);
            }
        },
        {
            key: "buildRequest",
            value: function buildRequest() {
                var request = {
                    requestUri: $04f424e220a55f33$var$IDP_REQUEST_URI$1,
                    returnSecureToken: true
                };
                if (this.pendingToken) request.pendingToken = this.pendingToken;
                else {
                    var postBody = {};
                    if (this.idToken) postBody["id_token"] = this.idToken;
                    if (this.accessToken) postBody["access_token"] = this.accessToken;
                    if (this.secret) postBody["oauth_token_secret"] = this.secret;
                    postBody["providerId"] = this.providerId;
                    if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
                    request.postBody = (0, $cxgyp.querystring)(postBody);
                }
                return request;
            }
        }
    ], [
        {
            key: "_fromParams",
            value: /** @internal */ function _fromParams(params) {
                var cred = new OAuthCredential(params.providerId, params.signInMethod);
                if (params.idToken || params.accessToken) {
                    // OAuth 2 and either ID token or access token.
                    if (params.idToken) cred.idToken = params.idToken;
                    if (params.accessToken) cred.accessToken = params.accessToken;
                    // Add nonce if available and no pendingToken is present.
                    if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
                    if (params.pendingToken) cred.pendingToken = params.pendingToken;
                } else if (params.oauthToken && params.oauthTokenSecret) {
                    // OAuth 1 and OAuth token with token secret
                    cred.accessToken = params.oauthToken;
                    cred.secret = params.oauthTokenSecret;
                } else $04f424e220a55f33$export$92108d983e8ee699("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return cred;
            }
        },
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                var providerId = obj.providerId, signInMethod = obj.signInMethod, rest = (0, $1XfpH.__rest)(obj, [
                    "providerId",
                    "signInMethod"
                ]);
                if (!providerId || !signInMethod) return null;
                var cred = new OAuthCredential(providerId, signInMethod);
                cred.idToken = rest.idToken || undefined;
                cred.accessToken = rest.accessToken || undefined;
                cred.secret = rest.secret;
                cred.nonce = rest.nonce;
                cred.pendingToken = rest.pendingToken || null;
                return cred;
            }
        }
    ]);
    return OAuthCredential;
}($04f424e220a55f33$export$3466f893ebf79586);
function $04f424e220a55f33$var$sendPhoneVerificationCode(auth, request) {
    return $04f424e220a55f33$var$_sendPhoneVerificationCode.apply(this, arguments);
}
function $04f424e220a55f33$var$_sendPhoneVerificationCode() {
    $04f424e220a55f33$var$_sendPhoneVerificationCode = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_sendPhoneVerificationCode.apply(this, arguments);
}
function $04f424e220a55f33$var$signInWithPhoneNumber$1(auth, request) {
    return $04f424e220a55f33$var$_signInWithPhoneNumber$1.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithPhoneNumber$1() {
    $04f424e220a55f33$var$_signInWithPhoneNumber$1 = (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_signInWithPhoneNumber$1.apply(this, arguments);
}
function $04f424e220a55f33$var$linkWithPhoneNumber$1(auth, request) {
    return $04f424e220a55f33$var$_linkWithPhoneNumber$1.apply(this, arguments);
}
function $04f424e220a55f33$var$_linkWithPhoneNumber$1() {
    $04f424e220a55f33$var$_linkWithPhoneNumber$1 = (0, $5Pgs2._)(function(auth, request) {
        var response;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04f424e220a55f33$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.temporaryProof) throw $04f424e220a55f33$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_linkWithPhoneNumber$1.apply(this, arguments);
}
var $04f424e220a55f33$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = (0, $2iBlG._)({}, "USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ , "user-not-found" /* AuthErrorCode.USER_DELETED */ );
function $04f424e220a55f33$var$verifyPhoneNumberForExisting(auth, request) {
    return $04f424e220a55f33$var$_verifyPhoneNumberForExisting.apply(this, arguments);
}
function $04f424e220a55f33$var$_verifyPhoneNumberForExisting() {
    $04f424e220a55f33$var$_verifyPhoneNumberForExisting = (0, $5Pgs2._)(function(auth, request) {
        var apiRequest;
        return (0, $1XfpH.__generator)(this, function(_state) {
            apiRequest = Object.assign(Object.assign({}, request), {
                operation: "REAUTH"
            });
            return [
                2,
                $04f424e220a55f33$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, apiRequest), $04f424e220a55f33$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_)
            ];
        });
    });
    return $04f424e220a55f33$var$_verifyPhoneNumberForExisting.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ var $04f424e220a55f33$export$a07804094c3ecf2d = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $1atwj._)(PhoneAuthCredential, AuthCredential);
    var _super = (0, $iD0Am._)(PhoneAuthCredential);
    function PhoneAuthCredential(params) {
        (0, $50OuQ._)(this, PhoneAuthCredential);
        var _this;
        _this = _super.call(this, "phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        _this.params = params;
        return _this;
    }
    (0, $fGdZr._)(PhoneAuthCredential, [
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                return $04f424e220a55f33$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                return $04f424e220a55f33$var$linkWithPhoneNumber$1(auth, Object.assign({
                    idToken: idToken
                }, this._makeVerificationRequest()));
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return $04f424e220a55f33$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
            }
        },
        {
            /** @internal */ key: "_makeVerificationRequest",
            value: function _makeVerificationRequest() {
                var _this_params = this.params, temporaryProof = _this_params.temporaryProof, phoneNumber = _this_params.phoneNumber, verificationId = _this_params.verificationId, verificationCode = _this_params.verificationCode;
                if (temporaryProof && phoneNumber) return {
                    temporaryProof: temporaryProof,
                    phoneNumber: phoneNumber
                };
                return {
                    sessionInfo: verificationId,
                    code: verificationCode
                };
            }
        },
        {
            /** {@inheritdoc AuthCredential.toJSON} */ key: "toJSON",
            value: function toJSON() {
                var obj = {
                    providerId: this.providerId
                };
                if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
                if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
                if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
                if (this.params.verificationId) obj.verificationId = this.params.verificationId;
                return obj;
            }
        }
    ], [
        {
            key: "_fromVerification",
            value: /** @internal */ function _fromVerification(verificationId, verificationCode) {
                return new PhoneAuthCredential({
                    verificationId: verificationId,
                    verificationCode: verificationCode
                });
            }
        },
        {
            key: "_fromTokenResponse",
            value: /** @internal */ function _fromTokenResponse(phoneNumber, temporaryProof) {
                return new PhoneAuthCredential({
                    phoneNumber: phoneNumber,
                    temporaryProof: temporaryProof
                });
            }
        },
        {
            key: "fromJSON",
            value: /** Generates a phone credential based on a plain object or a JSON string. */ function fromJSON(json) {
                if (typeof json === "string") json = JSON.parse(json);
                var verificationId = json.verificationId, verificationCode = json.verificationCode, phoneNumber = json.phoneNumber, temporaryProof = json.temporaryProof;
                if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
                return new PhoneAuthCredential({
                    verificationId: verificationId,
                    verificationCode: verificationCode,
                    phoneNumber: phoneNumber,
                    temporaryProof: temporaryProof
                });
            }
        }
    ]);
    return PhoneAuthCredential;
}($04f424e220a55f33$export$3466f893ebf79586);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $04f424e220a55f33$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $04f424e220a55f33$var$parseDeepLink(url) {
    var link = (0, $cxgyp.querystringDecode)((0, $cxgyp.extractQuerystring)(url))["link"];
    // Double link case (automatic redirect).
    var doubleDeepLink = link ? (0, $cxgyp.querystringDecode)((0, $cxgyp.extractQuerystring)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    var iOSDeepLink = (0, $cxgyp.querystringDecode)((0, $cxgyp.extractQuerystring)(url))["deep_link_id"];
    var iOSDoubleDeepLink = iOSDeepLink ? (0, $cxgyp.querystringDecode)((0, $cxgyp.extractQuerystring)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ var $04f424e220a55f33$export$995eb9fca571757 = /*#__PURE__*/ function() {
    "use strict";
    function ActionCodeURL(actionLink) {
        (0, $50OuQ._)(this, ActionCodeURL);
        var _a, _b, _c, _d, _e, _f;
        var searchParams = (0, $cxgyp.querystringDecode)((0, $cxgyp.extractQuerystring)(actionLink));
        var apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        var code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        var operation = $04f424e220a55f33$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $04f424e220a55f33$export$9d398bebfec1c039(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    (0, $fGdZr._)(ActionCodeURL, null, [
        {
            key: "parseLink",
            value: /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ function parseLink(link) {
                var actionLink = $04f424e220a55f33$var$parseDeepLink(link);
                try {
                    return new ActionCodeURL(actionLink);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return ActionCodeURL;
}();
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $04f424e220a55f33$export$f38c853ae54ed474(link) {
    return $04f424e220a55f33$export$995eb9fca571757.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ var $04f424e220a55f33$export$3a6d5c9ae78a2c08 = /*#__PURE__*/ function() {
    "use strict";
    function EmailAuthProvider() {
        (0, $50OuQ._)(this, EmailAuthProvider);
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = EmailAuthProvider.PROVIDER_ID;
    }
    (0, $fGdZr._)(EmailAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ function credential(email, password) {
                return $04f424e220a55f33$export$61196ced6d74a310._fromEmailAndPassword(email, password);
            }
        },
        {
            key: "credentialWithLink",
            value: /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ function credentialWithLink(email, emailLink) {
                var actionCodeUrl = $04f424e220a55f33$export$995eb9fca571757.parseLink(emailLink);
                $04f424e220a55f33$export$9d398bebfec1c039(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return $04f424e220a55f33$export$61196ced6d74a310._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
            }
        }
    ]);
    return EmailAuthProvider;
}();
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $04f424e220a55f33$export$3a6d5c9ae78a2c08.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $04f424e220a55f33$export$3a6d5c9ae78a2c08.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $04f424e220a55f33$export$3a6d5c9ae78a2c08.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ var $04f424e220a55f33$var$FederatedAuthProvider = /*#__PURE__*/ function() {
    "use strict";
    function FederatedAuthProvider(providerId) {
        (0, $50OuQ._)(this, FederatedAuthProvider);
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    (0, $fGdZr._)(FederatedAuthProvider, [
        {
            /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ key: "setDefaultLanguage",
            value: function setDefaultLanguage(languageCode) {
                this.defaultLanguageCode = languageCode;
            }
        },
        {
            /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ key: "setCustomParameters",
            value: function setCustomParameters(customOAuthParameters) {
                this.customParameters = customOAuthParameters;
                return this;
            }
        },
        {
            /**
     * Retrieve the current list of {@link CustomParameters}.
     */ key: "getCustomParameters",
            value: function getCustomParameters() {
                return this.customParameters;
            }
        }
    ]);
    return FederatedAuthProvider;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ var $04f424e220a55f33$var$BaseOAuthProvider = /*#__PURE__*/ function(FederatedAuthProvider) {
    "use strict";
    (0, $1atwj._)(BaseOAuthProvider, FederatedAuthProvider);
    var _super = (0, $iD0Am._)(BaseOAuthProvider);
    function BaseOAuthProvider() {
        (0, $50OuQ._)(this, BaseOAuthProvider);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        /** @internal */ _this.scopes = [];
        return _this;
    }
    (0, $fGdZr._)(BaseOAuthProvider, [
        {
            /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ key: "addScope",
            value: function addScope(scope) {
                // If not already added, add scope to list.
                if (!this.scopes.includes(scope)) this.scopes.push(scope);
                return this;
            }
        },
        {
            /**
     * Retrieve the current list of OAuth scopes.
     */ key: "getScopes",
            value: function getScopes() {
                return (0, $dHvbf._)(this.scopes);
            }
        }
    ]);
    return BaseOAuthProvider;
}($04f424e220a55f33$var$FederatedAuthProvider);
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ var $04f424e220a55f33$export$8743009a87fcb00f = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $1atwj._)(OAuthProvider, BaseOAuthProvider);
    var _super = (0, $iD0Am._)(OAuthProvider);
    function OAuthProvider() {
        (0, $50OuQ._)(this, OAuthProvider);
        return _super.apply(this, arguments);
    }
    (0, $fGdZr._)(OAuthProvider, [
        {
            /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ key: "credential",
            value: function credential(params) {
                return this._credential(Object.assign(Object.assign({}, params), {
                    nonce: params.rawNonce
                }));
            }
        },
        {
            /** An internal credential method that accepts more permissive options */ key: "_credential",
            value: function _credential(params) {
                $04f424e220a55f33$export$9d398bebfec1c039(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                // For OAuthCredential, sign in method is same as providerId.
                return $04f424e220a55f33$export$3a1a48c8f6ef640e._fromParams(Object.assign(Object.assign({}, params), {
                    providerId: this.providerId,
                    signInMethod: this.providerId
                }));
            }
        }
    ], [
        {
            key: "credentialFromJSON",
            value: /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ function credentialFromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                $04f424e220a55f33$export$9d398bebfec1c039("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return $04f424e220a55f33$export$3a1a48c8f6ef640e._fromParams(obj);
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return OAuthProvider.oauthCredentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return OAuthProvider.oauthCredentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "oauthCredentialFromTaggedObject",
            value: function oauthCredentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthIdToken = tokenResponse.oauthIdToken, oauthAccessToken = tokenResponse.oauthAccessToken, oauthTokenSecret = tokenResponse.oauthTokenSecret, pendingToken = tokenResponse.pendingToken, nonce = tokenResponse.nonce, providerId = tokenResponse.providerId;
                if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
                if (!providerId) return null;
                try {
                    return new OAuthProvider(providerId)._credential({
                        idToken: oauthIdToken,
                        accessToken: oauthAccessToken,
                        nonce: nonce,
                        pendingToken: pendingToken
                    });
                } catch (e) {
                    return null;
                }
            }
        }
    ]);
    return OAuthProvider;
}($04f424e220a55f33$var$BaseOAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ var $04f424e220a55f33$export$e7c866399fa523f5 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $1atwj._)(FacebookAuthProvider, BaseOAuthProvider);
    var _super = (0, $iD0Am._)(FacebookAuthProvider);
    function FacebookAuthProvider() {
        (0, $50OuQ._)(this, FacebookAuthProvider);
        return _super.call(this, "facebook.com" /* ProviderId.FACEBOOK */ );
    }
    (0, $fGdZr._)(FacebookAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ function credential(accessToken) {
                return $04f424e220a55f33$export$3a1a48c8f6ef640e._fromParams({
                    providerId: FacebookAuthProvider.PROVIDER_ID,
                    signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return FacebookAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
                if (!tokenResponse.oauthAccessToken) return null;
                try {
                    return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return FacebookAuthProvider;
}($04f424e220a55f33$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.FACEBOOK. */ $04f424e220a55f33$export$e7c866399fa523f5.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $04f424e220a55f33$export$e7c866399fa523f5.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ var $04f424e220a55f33$export$71cec2538cb2c617 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $1atwj._)(GoogleAuthProvider, BaseOAuthProvider);
    var _super = (0, $iD0Am._)(GoogleAuthProvider);
    function GoogleAuthProvider() {
        (0, $50OuQ._)(this, GoogleAuthProvider);
        var _this;
        _this = _super.call(this, "google.com" /* ProviderId.GOOGLE */ );
        _this.addScope("profile");
        return _this;
    }
    (0, $fGdZr._)(GoogleAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ function credential(idToken, accessToken) {
                return $04f424e220a55f33$export$3a1a48c8f6ef640e._fromParams({
                    providerId: GoogleAuthProvider.PROVIDER_ID,
                    signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
                    idToken: idToken,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return GoogleAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthIdToken = tokenResponse.oauthIdToken, oauthAccessToken = tokenResponse.oauthAccessToken;
                if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
                return null;
                try {
                    return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return GoogleAuthProvider;
}($04f424e220a55f33$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.GOOGLE. */ $04f424e220a55f33$export$71cec2538cb2c617.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $04f424e220a55f33$export$71cec2538cb2c617.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ var $04f424e220a55f33$export$78acf4525d8a74c4 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $1atwj._)(GithubAuthProvider, BaseOAuthProvider);
    var _super = (0, $iD0Am._)(GithubAuthProvider);
    function GithubAuthProvider() {
        (0, $50OuQ._)(this, GithubAuthProvider);
        return _super.call(this, "github.com" /* ProviderId.GITHUB */ );
    }
    (0, $fGdZr._)(GithubAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ function credential(accessToken) {
                return $04f424e220a55f33$export$3a1a48c8f6ef640e._fromParams({
                    providerId: GithubAuthProvider.PROVIDER_ID,
                    signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return GithubAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return GithubAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
                if (!tokenResponse.oauthAccessToken) return null;
                try {
                    return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return GithubAuthProvider;
}($04f424e220a55f33$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.GITHUB. */ $04f424e220a55f33$export$78acf4525d8a74c4.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $04f424e220a55f33$export$78acf4525d8a74c4.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ var $04f424e220a55f33$export$2ed0fc6709e59212 = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $1atwj._)(SAMLAuthCredential, AuthCredential);
    var _super = (0, $iD0Am._)(SAMLAuthCredential);
    function SAMLAuthCredential(providerId, pendingToken) {
        (0, $50OuQ._)(this, SAMLAuthCredential);
        var _this;
        _this = _super.call(this, providerId, providerId);
        _this.pendingToken = pendingToken;
        return _this;
    }
    (0, $fGdZr._)(SAMLAuthCredential, [
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                var request = this.buildRequest();
                return $04f424e220a55f33$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                var request = this.buildRequest();
                request.idToken = idToken;
                return $04f424e220a55f33$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                var request = this.buildRequest();
                request.autoCreate = false;
                return $04f424e220a55f33$var$signInWithIdp(auth, request);
            }
        },
        {
            /** {@inheritdoc AuthCredential.toJSON}  */ key: "toJSON",
            value: function toJSON() {
                return {
                    signInMethod: this.signInMethod,
                    providerId: this.providerId,
                    pendingToken: this.pendingToken
                };
            }
        },
        {
            key: "buildRequest",
            value: function buildRequest() {
                return {
                    requestUri: $04f424e220a55f33$var$IDP_REQUEST_URI,
                    returnSecureToken: true,
                    pendingToken: this.pendingToken
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                var providerId = obj.providerId, signInMethod = obj.signInMethod, pendingToken = obj.pendingToken;
                if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
                return new SAMLAuthCredential(providerId, pendingToken);
            }
        },
        {
            key: "_create",
            value: /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ function _create(providerId, pendingToken) {
                return new SAMLAuthCredential(providerId, pendingToken);
            }
        }
    ]);
    return SAMLAuthCredential;
}($04f424e220a55f33$export$3466f893ebf79586);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ var $04f424e220a55f33$export$dc98b0b04f4c7758 = /*#__PURE__*/ function(FederatedAuthProvider) {
    "use strict";
    (0, $1atwj._)(SAMLAuthProvider, FederatedAuthProvider);
    var _super = (0, $iD0Am._)(SAMLAuthProvider);
    function SAMLAuthProvider(providerId) {
        (0, $50OuQ._)(this, SAMLAuthProvider);
        $04f424e220a55f33$export$9d398bebfec1c039(providerId.startsWith($04f424e220a55f33$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return _super.call(this, providerId);
    }
    (0, $fGdZr._)(SAMLAuthProvider, null, [
        {
            key: "credentialFromResult",
            value: /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return SAMLAuthProvider.samlCredentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return SAMLAuthProvider.samlCredentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromJSON",
            value: /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ function credentialFromJSON(json) {
                var credential = $04f424e220a55f33$export$2ed0fc6709e59212.fromJSON(json);
                $04f424e220a55f33$export$9d398bebfec1c039(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return credential;
            }
        },
        {
            key: "samlCredentialFromTaggedObject",
            value: function samlCredentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var pendingToken = tokenResponse.pendingToken, providerId = tokenResponse.providerId;
                if (!pendingToken || !providerId) return null;
                try {
                    return $04f424e220a55f33$export$2ed0fc6709e59212._create(providerId, pendingToken);
                } catch (e) {
                    return null;
                }
            }
        }
    ]);
    return SAMLAuthProvider;
}($04f424e220a55f33$var$FederatedAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ var $04f424e220a55f33$export$71511d61b312f219 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $1atwj._)(TwitterAuthProvider, BaseOAuthProvider);
    var _super = (0, $iD0Am._)(TwitterAuthProvider);
    function TwitterAuthProvider() {
        (0, $50OuQ._)(this, TwitterAuthProvider);
        return _super.call(this, "twitter.com" /* ProviderId.TWITTER */ );
    }
    (0, $fGdZr._)(TwitterAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ function credential(token, secret) {
                return $04f424e220a55f33$export$3a1a48c8f6ef640e._fromParams({
                    providerId: TwitterAuthProvider.PROVIDER_ID,
                    signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
                    oauthToken: token,
                    oauthTokenSecret: secret
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return TwitterAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthAccessToken = tokenResponse.oauthAccessToken, oauthTokenSecret = tokenResponse.oauthTokenSecret;
                if (!oauthAccessToken || !oauthTokenSecret) return null;
                try {
                    return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return TwitterAuthProvider;
}($04f424e220a55f33$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.TWITTER. */ $04f424e220a55f33$export$71511d61b312f219.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $04f424e220a55f33$export$71511d61b312f219.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
function $04f424e220a55f33$var$signUp(auth, request) {
    return $04f424e220a55f33$var$_signUp.apply(this, arguments);
}
function $04f424e220a55f33$var$_signUp() {
    $04f424e220a55f33$var$_signUp = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_signUp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$UserCredentialImpl = /*#__PURE__*/ function() {
    "use strict";
    function UserCredentialImpl(params) {
        (0, $50OuQ._)(this, UserCredentialImpl);
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    (0, $fGdZr._)(UserCredentialImpl, null, [
        {
            key: "_fromIdTokenResponse",
            value: function _fromIdTokenResponse(auth, operationType, idTokenResponse) {
                var isAnonymous = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                return (0, $5Pgs2._)(function() {
                    var user, providerId, userCred;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $04f424e220a55f33$export$a05254e7c3aeba6e._fromIdTokenResponse(auth, idTokenResponse, isAnonymous)
                                ];
                            case 1:
                                user = _state.sent();
                                providerId = $04f424e220a55f33$var$providerIdForResponse(idTokenResponse);
                                userCred = new UserCredentialImpl({
                                    user: user,
                                    providerId: providerId,
                                    _tokenResponse: idTokenResponse,
                                    operationType: operationType
                                });
                                return [
                                    2,
                                    userCred
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_forOperation",
            value: function _forOperation(user, operationType, response) {
                return (0, $5Pgs2._)(function() {
                    var providerId;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    user._updateTokensIfNecessary(response, /* reload */ true)
                                ];
                            case 1:
                                _state.sent();
                                providerId = $04f424e220a55f33$var$providerIdForResponse(response);
                                return [
                                    2,
                                    new UserCredentialImpl({
                                        user: user,
                                        providerId: providerId,
                                        _tokenResponse: response,
                                        operationType: operationType
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return UserCredentialImpl;
}();
function $04f424e220a55f33$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
function $04f424e220a55f33$export$3d8c2f653ac9d0b9(auth) {
    return $04f424e220a55f33$var$_signInAnonymously.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInAnonymously() {
    $04f424e220a55f33$var$_signInAnonymously = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth) {
        var _a, authInternal, response, userCredential;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
                    return [
                        4,
                        authInternal._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
                    return [
                        2,
                        new $04f424e220a55f33$var$UserCredentialImpl({
                            user: authInternal.currentUser,
                            providerId: null,
                            operationType: "signIn" /* OperationType.SIGN_IN */ 
                        })
                    ];
                    return [
                        4,
                        $04f424e220a55f33$var$signUp(authInternal, {
                            returnSecureToken: true
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        $04f424e220a55f33$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true)
                    ];
                case 3:
                    userCredential = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(userCredential.user)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_signInAnonymously.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$MultiFactorError = /*#__PURE__*/ function(FirebaseError) {
    "use strict";
    (0, $1atwj._)(MultiFactorError, FirebaseError);
    var _super = (0, $iD0Am._)(MultiFactorError);
    function MultiFactorError(auth, error, operationType, user) {
        (0, $50OuQ._)(this, MultiFactorError);
        var _this;
        var _a;
        _this = _super.call(this, error.code, error.message);
        _this.operationType = operationType;
        _this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $dMjkN._)(_this), MultiFactorError.prototype);
        _this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
        return _this;
    }
    (0, $fGdZr._)(MultiFactorError, null, [
        {
            key: "_fromErrorAndOperation",
            value: function _fromErrorAndOperation(auth, error, operationType, user) {
                return new MultiFactorError(auth, error, operationType, user);
            }
        }
    ]);
    return MultiFactorError;
}((0, $cxgyp.FirebaseError));
function $04f424e220a55f33$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    var idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider["catch"](function(error) {
        if (error.code === "auth/multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ) throw $04f424e220a55f33$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $04f424e220a55f33$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(function(param) {
        var providerId = param.providerId;
        return providerId;
    }).filter(function(pid) {
        return !!pid;
    }));
}
function $04f424e220a55f33$export$7a38258bbe170828(user, providerId) {
    return $04f424e220a55f33$var$_unlink.apply(this, arguments);
}
function $04f424e220a55f33$var$_unlink() {
    $04f424e220a55f33$var$_unlink = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, providerId) {
        var userInternal, providerUserInfo, _tmp, _tmp1, providersLeft;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    return [
                        4,
                        $04f424e220a55f33$var$_assertLinkedStatus(true, userInternal, providerId)
                    ];
                case 1:
                    _state.sent();
                    _tmp = [
                        userInternal.auth
                    ];
                    _tmp1 = {};
                    return [
                        4,
                        userInternal.getIdToken()
                    ];
                case 2:
                    return [
                        4,
                        $04f424e220a55f33$var$deleteLinkedAccounts.apply(void 0, _tmp.concat([
                            (_tmp1.idToken = _state.sent(), _tmp1.deleteProvider = [
                                providerId
                            ], _tmp1)
                        ]))
                    ];
                case 3:
                    providerUserInfo = _state.sent().providerUserInfo;
                    providersLeft = $04f424e220a55f33$var$providerDataAsNames(providerUserInfo || []);
                    userInternal.providerData = userInternal.providerData.filter(function(pd) {
                        return providersLeft.has(pd.providerId);
                    });
                    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
                    return [
                        4,
                        userInternal.auth._persistUserIfCurrent(userInternal)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        userInternal
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_unlink.apply(this, arguments);
}
function $04f424e220a55f33$var$_link$1(user, credential) {
    return $04f424e220a55f33$var$__link$1.apply(this, arguments);
}
function $04f424e220a55f33$var$__link$1() {
    $04f424e220a55f33$var$__link$1 = (0, $5Pgs2._)(function(user, credential) {
        var bypassAuthState, response, _tmp, _, _tmp1;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _tmp = [
                        user
                    ];
                    _ = credential._linkToIdToken;
                    _tmp1 = [
                        user.auth
                    ];
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    return [
                        4,
                        $04f424e220a55f33$var$_logoutIfInvalidated.apply(void 0, _tmp.concat([
                            _.apply(credential, _tmp1.concat([
                                _state.sent()
                            ])),
                            bypassAuthState
                        ]))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        $04f424e220a55f33$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response)
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__link$1.apply(this, arguments);
}
function $04f424e220a55f33$var$_assertLinkedStatus(expected, user, provider) {
    return $04f424e220a55f33$var$__assertLinkedStatus.apply(this, arguments);
}
function $04f424e220a55f33$var$__assertLinkedStatus() {
    $04f424e220a55f33$var$__assertLinkedStatus = (0, $5Pgs2._)(function(expected, user, provider) {
        var providerIds, code;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04f424e220a55f33$var$_reloadWithoutSaving(user)
                    ];
                case 1:
                    _state.sent();
                    providerIds = $04f424e220a55f33$var$providerDataAsNames(user.providerData);
                    code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
                    $04f424e220a55f33$export$9d398bebfec1c039(providerIds.has(provider) === expected, user.auth, code);
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__assertLinkedStatus.apply(this, arguments);
}
function $04f424e220a55f33$var$_reauthenticate(user, credential) {
    return $04f424e220a55f33$var$__reauthenticate.apply(this, arguments);
}
function $04f424e220a55f33$var$__reauthenticate() {
    $04f424e220a55f33$var$__reauthenticate = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(user, credential) {
        var bypassAuthState, auth, operationType, response, parsed, localId, e;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    auth = user.auth;
                    operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $04f424e220a55f33$var$_logoutIfInvalidated(user, $04f424e220a55f33$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState)
                    ];
                case 2:
                    response = _state.sent();
                    $04f424e220a55f33$export$9d398bebfec1c039(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    parsed = $04f424e220a55f33$var$_parseToken(response.idToken);
                    $04f424e220a55f33$export$9d398bebfec1c039(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    localId = parsed.sub;
                    $04f424e220a55f33$export$9d398bebfec1c039(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
                    return [
                        2,
                        $04f424e220a55f33$var$UserCredentialImpl._forOperation(user, operationType, response)
                    ];
                case 3:
                    e = _state.sent();
                    // Convert user deleted error into user mismatch
                    if ((e === null || e === void 0 ? void 0 : e.code) === "auth/user-not-found" /* AuthErrorCode.USER_DELETED */ ) $04f424e220a55f33$export$92108d983e8ee699(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
                    throw e;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__reauthenticate.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithCredential(auth, credential) {
    return $04f424e220a55f33$var$__signInWithCredential.apply(this, arguments);
}
function $04f424e220a55f33$var$__signInWithCredential() {
    $04f424e220a55f33$var$__signInWithCredential = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, credential) {
        var bypassAuthState, operationType, response, userCredential;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    operationType = "signIn" /* OperationType.SIGN_IN */ ;
                    return [
                        4,
                        $04f424e220a55f33$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        $04f424e220a55f33$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response)
                    ];
                case 2:
                    userCredential = _state.sent();
                    if (!!bypassAuthState) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        auth._updateCurrentUser(userCredential.user)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__signInWithCredential.apply(this, arguments);
}
function $04f424e220a55f33$export$34aec0b863436764(auth, credential) {
    return $04f424e220a55f33$var$_signInWithCredential1.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithCredential1() {
    $04f424e220a55f33$var$_signInWithCredential1 = /**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, credential) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_signInWithCredential($04f424e220a55f33$export$b9a6b53f9be3734(auth), credential)
            ];
        });
    });
    return $04f424e220a55f33$var$_signInWithCredential1.apply(this, arguments);
}
function $04f424e220a55f33$export$3c2fa207a37baaea(user, credential) {
    return $04f424e220a55f33$var$_linkWithCredential.apply(this, arguments);
}
function $04f424e220a55f33$var$_linkWithCredential() {
    $04f424e220a55f33$var$_linkWithCredential = /**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, credential) {
        var userInternal;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    return [
                        4,
                        $04f424e220a55f33$var$_assertLinkedStatus(false, userInternal, credential.providerId)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        $04f424e220a55f33$var$_link$1(userInternal, credential)
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_linkWithCredential.apply(this, arguments);
}
function $04f424e220a55f33$export$ce26c07117d59d6a(user, credential) {
    return $04f424e220a55f33$var$_reauthenticateWithCredential.apply(this, arguments);
}
function $04f424e220a55f33$var$_reauthenticateWithCredential() {
    $04f424e220a55f33$var$_reauthenticateWithCredential = /**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, credential) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_reauthenticate((0, $cxgyp.getModularInstance)(user), credential)
            ];
        });
    });
    return $04f424e220a55f33$var$_reauthenticateWithCredential.apply(this, arguments);
}
function $04f424e220a55f33$var$signInWithCustomToken$1(auth, request) {
    return $04f424e220a55f33$var$_signInWithCustomToken$1.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithCustomToken$1() {
    $04f424e220a55f33$var$_signInWithCustomToken$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_signInWithCustomToken$1.apply(this, arguments);
}
function $04f424e220a55f33$export$6559d589eb85fbb6(auth, customToken) {
    return $04f424e220a55f33$var$_signInWithCustomToken.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithCustomToken() {
    $04f424e220a55f33$var$_signInWithCustomToken = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, customToken) {
        var authInternal, response, cred;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
                    return [
                        4,
                        $04f424e220a55f33$var$signInWithCustomToken$1(authInternal, {
                            token: customToken,
                            returnSecureToken: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        $04f424e220a55f33$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response)
                    ];
                case 2:
                    cred = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(cred.user)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        cred
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_signInWithCustomToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$MultiFactorInfoImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorInfoImpl(factorId, response) {
        (0, $50OuQ._)(this, MultiFactorInfoImpl);
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    (0, $fGdZr._)(MultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(auth, enrollment) {
                if ("phoneInfo" in enrollment) return $04f424e220a55f33$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                else if ("totpInfo" in enrollment) return $04f424e220a55f33$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                return $04f424e220a55f33$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        }
    ]);
    return MultiFactorInfoImpl;
}();
var $04f424e220a55f33$var$PhoneMultiFactorInfoImpl = /*#__PURE__*/ function(MultiFactorInfoImpl) {
    "use strict";
    (0, $1atwj._)(PhoneMultiFactorInfoImpl, MultiFactorInfoImpl);
    var _super = (0, $iD0Am._)(PhoneMultiFactorInfoImpl);
    function PhoneMultiFactorInfoImpl(response) {
        (0, $50OuQ._)(this, PhoneMultiFactorInfoImpl);
        var _this;
        _this = _super.call(this, "phone" /* FactorId.PHONE */ , response);
        _this.phoneNumber = response.phoneInfo;
        return _this;
    }
    (0, $fGdZr._)(PhoneMultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(_auth, enrollment) {
                return new PhoneMultiFactorInfoImpl(enrollment);
            }
        }
    ]);
    return PhoneMultiFactorInfoImpl;
}($04f424e220a55f33$var$MultiFactorInfoImpl);
var $04f424e220a55f33$var$TotpMultiFactorInfoImpl = /*#__PURE__*/ function(MultiFactorInfoImpl) {
    "use strict";
    (0, $1atwj._)(TotpMultiFactorInfoImpl, MultiFactorInfoImpl);
    var _super = (0, $iD0Am._)(TotpMultiFactorInfoImpl);
    function TotpMultiFactorInfoImpl(response) {
        (0, $50OuQ._)(this, TotpMultiFactorInfoImpl);
        return _super.call(this, "totp" /* FactorId.TOTP */ , response);
    }
    (0, $fGdZr._)(TotpMultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(_auth, enrollment) {
                return new TotpMultiFactorInfoImpl(enrollment);
            }
        }
    ]);
    return TotpMultiFactorInfoImpl;
}($04f424e220a55f33$var$MultiFactorInfoImpl);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $04f424e220a55f33$export$9d398bebfec1c039(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $04f424e220a55f33$export$9d398bebfec1c039(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $04f424e220a55f33$export$9d398bebfec1c039(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $04f424e220a55f33$export$9d398bebfec1c039(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
function $04f424e220a55f33$var$recachePasswordPolicy(auth) {
    return $04f424e220a55f33$var$_recachePasswordPolicy.apply(this, arguments);
}
function $04f424e220a55f33$var$_recachePasswordPolicy() {
    $04f424e220a55f33$var$_recachePasswordPolicy = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ (0, $5Pgs2._)(function(auth) {
        var authInternal;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
                    if (!authInternal._getPasswordPolicyInternal()) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        authInternal._updatePasswordPolicy()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_recachePasswordPolicy.apply(this, arguments);
}
function $04f424e220a55f33$export$efca4cbe5dd06740(auth, email, actionCodeSettings) {
    return $04f424e220a55f33$var$_sendPasswordResetEmail.apply(this, arguments);
}
function $04f424e220a55f33$var$_sendPasswordResetEmail() {
    $04f424e220a55f33$var$_sendPasswordResetEmail = /**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, email, actionCodeSettings) {
        var _a, authInternal, request, requestWithRecaptcha;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
                    request = {
                        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
                        email: email,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    if (!((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $04f424e220a55f33$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true)
                    ];
                case 1:
                    requestWithRecaptcha = _state.sent();
                    if (actionCodeSettings) $04f424e220a55f33$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
                    return [
                        4,
                        $04f424e220a55f33$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    if (actionCodeSettings) $04f424e220a55f33$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
                    return [
                        4,
                        $04f424e220a55f33$var$sendPasswordResetEmail$1(authInternal, request)["catch"](function() {
                            var _ref = (0, $5Pgs2._)(function(error) {
                                var requestWithRecaptcha;
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(error.code === "auth/missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ )) return [
                                                3,
                                                3
                                            ];
                                            console.log("Password resets are protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the password reset flow.");
                                            return [
                                                4,
                                                $04f424e220a55f33$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true)
                                            ];
                                        case 1:
                                            requestWithRecaptcha = _state.sent();
                                            if (actionCodeSettings) $04f424e220a55f33$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
                                            return [
                                                4,
                                                $04f424e220a55f33$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha)
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            return [
                                                2,
                                                Promise.reject(error)
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_sendPasswordResetEmail.apply(this, arguments);
}
function $04f424e220a55f33$export$a8550f7dbe79f93a(auth, oobCode, newPassword) {
    return $04f424e220a55f33$var$_confirmPasswordReset.apply(this, arguments);
}
function $04f424e220a55f33$var$_confirmPasswordReset() {
    $04f424e220a55f33$var$_confirmPasswordReset = /**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, oobCode, newPassword) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04f424e220a55f33$var$resetPassword((0, $cxgyp.getModularInstance)(auth), {
                            oobCode: oobCode,
                            newPassword: newPassword
                        })["catch"](function() {
                            var _ref = (0, $5Pgs2._)(function(error) {
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $04f424e220a55f33$var$recachePasswordPolicy(auth);
                                    throw error;
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    // Do not return the email.
    });
    return $04f424e220a55f33$var$_confirmPasswordReset.apply(this, arguments);
}
function $04f424e220a55f33$export$2e2af4578d910ddf(auth, oobCode) {
    return $04f424e220a55f33$var$_applyActionCode.apply(this, arguments);
}
function $04f424e220a55f33$var$_applyActionCode() {
    $04f424e220a55f33$var$_applyActionCode = /**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, oobCode) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04f424e220a55f33$var$applyActionCode$1((0, $cxgyp.getModularInstance)(auth), {
                            oobCode: oobCode
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_applyActionCode.apply(this, arguments);
}
function $04f424e220a55f33$export$a93c5207d687da10(auth, oobCode) {
    return $04f424e220a55f33$var$_checkActionCode.apply(this, arguments);
}
function $04f424e220a55f33$var$_checkActionCode() {
    $04f424e220a55f33$var$_checkActionCode = /**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, oobCode) {
        var authModular, response, operation, multiFactorInfo;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authModular = (0, $cxgyp.getModularInstance)(auth);
                    return [
                        4,
                        $04f424e220a55f33$var$resetPassword(authModular, {
                            oobCode: oobCode
                        })
                    ];
                case 1:
                    response = _state.sent();
                    operation = response.requestType;
                    $04f424e220a55f33$export$9d398bebfec1c039(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    switch(operation){
                        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
                            break;
                        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
                            $04f424e220a55f33$export$9d398bebfec1c039(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                            break;
                        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
                            $04f424e220a55f33$export$9d398bebfec1c039(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        // fall through
                        default:
                            $04f424e220a55f33$export$9d398bebfec1c039(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    }
                    multiFactorInfo = null;
                    if (response.mfaInfo) multiFactorInfo = $04f424e220a55f33$var$MultiFactorInfoImpl._fromServerResponse($04f424e220a55f33$export$b9a6b53f9be3734(authModular), response.mfaInfo);
                    return [
                        2,
                        {
                            data: {
                                email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
                                previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
                                multiFactorInfo: multiFactorInfo
                            },
                            operation: operation
                        }
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_checkActionCode.apply(this, arguments);
}
function $04f424e220a55f33$export$c3950d9923825c02(auth, code) {
    return $04f424e220a55f33$var$_verifyPasswordResetCode.apply(this, arguments);
}
function $04f424e220a55f33$var$_verifyPasswordResetCode() {
    $04f424e220a55f33$var$_verifyPasswordResetCode = /**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, code) {
        var data;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04f424e220a55f33$export$a93c5207d687da10((0, $cxgyp.getModularInstance)(auth), code)
                    ];
                case 1:
                    data = _state.sent().data;
                    // Email should always be present since a code was sent to it
                    return [
                        2,
                        data.email
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_verifyPasswordResetCode.apply(this, arguments);
}
function $04f424e220a55f33$export$a9c996f45e5784d0(auth, email, password) {
    return $04f424e220a55f33$var$_createUserWithEmailAndPassword.apply(this, arguments);
}
function $04f424e220a55f33$var$_createUserWithEmailAndPassword() {
    $04f424e220a55f33$var$_createUserWithEmailAndPassword = /**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, email, password) {
        var _a, authInternal, request, signUpResponse, requestWithRecaptcha, response, userCredential;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
                    request = {
                        returnSecureToken: true,
                        email: email,
                        password: password,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    if (!((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $04f424e220a55f33$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ )
                    ];
                case 1:
                    requestWithRecaptcha = _state.sent();
                    signUpResponse = $04f424e220a55f33$var$signUp(authInternal, requestWithRecaptcha);
                    return [
                        3,
                        3
                    ];
                case 2:
                    signUpResponse = $04f424e220a55f33$var$signUp(authInternal, request)["catch"](function() {
                        var _ref = (0, $5Pgs2._)(function(error) {
                            var requestWithRecaptcha;
                            return (0, $1XfpH.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!(error.code === "auth/missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ )) return [
                                            3,
                                            2
                                        ];
                                        console.log("Sign-up is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-up flow.");
                                        return [
                                            4,
                                            $04f424e220a55f33$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ )
                                        ];
                                    case 1:
                                        requestWithRecaptcha = _state.sent();
                                        return [
                                            2,
                                            $04f424e220a55f33$var$signUp(authInternal, requestWithRecaptcha)
                                        ];
                                    case 2:
                                        throw error;
                                }
                            });
                        });
                        return function(error) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        signUpResponse["catch"](function(error) {
                            if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $04f424e220a55f33$var$recachePasswordPolicy(auth);
                            throw error;
                        })
                    ];
                case 4:
                    response = _state.sent();
                    return [
                        4,
                        $04f424e220a55f33$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response)
                    ];
                case 5:
                    userCredential = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(userCredential.user)
                    ];
                case 6:
                    _state.sent();
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_createUserWithEmailAndPassword.apply(this, arguments);
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $04f424e220a55f33$export$7910e0436ed8d1de(auth, email, password) {
    return $04f424e220a55f33$export$34aec0b863436764((0, $cxgyp.getModularInstance)(auth), $04f424e220a55f33$export$3a6d5c9ae78a2c08.credential(email, password))["catch"](function() {
        var _ref = (0, $5Pgs2._)(function(error) {
            return (0, $1XfpH.__generator)(this, function(_state) {
                if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $04f424e220a55f33$var$recachePasswordPolicy(auth);
                throw error;
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
}
function $04f424e220a55f33$export$555508cbc6add439(auth, email, actionCodeSettings) {
    return $04f424e220a55f33$var$_sendSignInLinkToEmail.apply(this, arguments);
}
function $04f424e220a55f33$var$_sendSignInLinkToEmail() {
    $04f424e220a55f33$var$_sendSignInLinkToEmail = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, email, actionCodeSettings) {
        var _a, authInternal, request, requestWithRecaptcha;
        function setActionCodeSettings(request, actionCodeSettings) {
            $04f424e220a55f33$export$9d398bebfec1c039(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            if (actionCodeSettings) $04f424e220a55f33$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
        }
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
                    request = {
                        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
                        email: email,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    if (!((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $04f424e220a55f33$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true)
                    ];
                case 1:
                    requestWithRecaptcha = _state.sent();
                    setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
                    return [
                        4,
                        $04f424e220a55f33$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    setActionCodeSettings(request, actionCodeSettings);
                    return [
                        4,
                        $04f424e220a55f33$var$sendSignInLinkToEmail$1(authInternal, request)["catch"](function() {
                            var _ref = (0, $5Pgs2._)(function(error) {
                                var requestWithRecaptcha;
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(error.code === "auth/missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ )) return [
                                                3,
                                                3
                                            ];
                                            console.log("Email link sign-in is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                                            return [
                                                4,
                                                $04f424e220a55f33$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true)
                                            ];
                                        case 1:
                                            requestWithRecaptcha = _state.sent();
                                            setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
                                            return [
                                                4,
                                                $04f424e220a55f33$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha)
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            return [
                                                2,
                                                Promise.reject(error)
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_sendSignInLinkToEmail.apply(this, arguments);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $04f424e220a55f33$export$2219238a014317b0(auth, emailLink) {
    var actionCodeUrl = $04f424e220a55f33$export$995eb9fca571757.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
function $04f424e220a55f33$export$4c3d22f3d993c33f(auth, email, emailLink) {
    return $04f424e220a55f33$var$_signInWithEmailLink.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithEmailLink() {
    $04f424e220a55f33$var$_signInWithEmailLink = /**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, email, emailLink) {
        var authModular, credential;
        return (0, $1XfpH.__generator)(this, function(_state) {
            authModular = (0, $cxgyp.getModularInstance)(auth);
            credential = $04f424e220a55f33$export$3a6d5c9ae78a2c08.credentialWithLink(email, emailLink || $04f424e220a55f33$var$_getCurrentUrl());
            // Check if the tenant ID in the email link matches the tenant ID on Auth
            // instance.
            $04f424e220a55f33$export$9d398bebfec1c039(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
            return [
                2,
                $04f424e220a55f33$export$34aec0b863436764(authModular, credential)
            ];
        });
    });
    return $04f424e220a55f33$var$_signInWithEmailLink.apply(this, arguments);
}
function $04f424e220a55f33$var$createAuthUri(auth, request) {
    return $04f424e220a55f33$var$_createAuthUri.apply(this, arguments);
}
function $04f424e220a55f33$var$_createAuthUri() {
    $04f424e220a55f33$var$_createAuthUri = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $04f424e220a55f33$var$_createAuthUri.apply(this, arguments);
}
function $04f424e220a55f33$export$f787f51d84a910ad(auth, email) {
    return $04f424e220a55f33$var$_fetchSignInMethodsForEmail.apply(this, arguments);
}
function $04f424e220a55f33$var$_fetchSignInMethodsForEmail() {
    $04f424e220a55f33$var$_fetchSignInMethodsForEmail = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, email) {
        var continueUri, request, signinMethods;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    continueUri = $04f424e220a55f33$var$_isHttpOrHttps() ? $04f424e220a55f33$var$_getCurrentUrl() : "http://localhost";
                    request = {
                        identifier: email,
                        continueUri: continueUri
                    };
                    return [
                        4,
                        $04f424e220a55f33$var$createAuthUri((0, $cxgyp.getModularInstance)(auth), request)
                    ];
                case 1:
                    signinMethods = _state.sent().signinMethods;
                    return [
                        2,
                        signinMethods || []
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_fetchSignInMethodsForEmail.apply(this, arguments);
}
function $04f424e220a55f33$export$c9170ad7d4cd7e57(user, actionCodeSettings) {
    return $04f424e220a55f33$var$_sendEmailVerification.apply(this, arguments);
}
function $04f424e220a55f33$var$_sendEmailVerification() {
    $04f424e220a55f33$var$_sendEmailVerification = /**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, actionCodeSettings) {
        var userInternal, idToken, request, email;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
                        idToken: idToken
                    };
                    if (actionCodeSettings) $04f424e220a55f33$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
                    return [
                        4,
                        $04f424e220a55f33$var$sendEmailVerification$1(userInternal.auth, request)
                    ];
                case 2:
                    email = _state.sent().email;
                    if (!(email !== user.email)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        user.reload()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_sendEmailVerification.apply(this, arguments);
}
function $04f424e220a55f33$export$ee7c8ad385a60b7b(user, newEmail, actionCodeSettings) {
    return $04f424e220a55f33$var$_verifyBeforeUpdateEmail.apply(this, arguments);
}
function $04f424e220a55f33$var$_verifyBeforeUpdateEmail() {
    $04f424e220a55f33$var$_verifyBeforeUpdateEmail = /**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, newEmail, actionCodeSettings) {
        var userInternal, idToken, request, email;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
                        idToken: idToken,
                        newEmail: newEmail
                    };
                    if (actionCodeSettings) $04f424e220a55f33$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
                    return [
                        4,
                        $04f424e220a55f33$var$verifyAndChangeEmail(userInternal.auth, request)
                    ];
                case 2:
                    email = _state.sent().email;
                    if (!(email !== user.email)) return [
                        3,
                        4
                    ];
                    // If the local copy of the email on user is outdated, reload the
                    // user.
                    return [
                        4,
                        user.reload()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_verifyBeforeUpdateEmail.apply(this, arguments);
}
function $04f424e220a55f33$var$updateProfile$1(auth, request) {
    return $04f424e220a55f33$var$_updateProfile$1.apply(this, arguments);
}
function $04f424e220a55f33$var$_updateProfile$1() {
    $04f424e220a55f33$var$_updateProfile$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth, request) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $04f424e220a55f33$var$_updateProfile$1.apply(this, arguments);
}
function $04f424e220a55f33$export$3b513254972cfc9c(user, _) {
    return $04f424e220a55f33$var$_updateProfile.apply(this, arguments);
}
function $04f424e220a55f33$var$_updateProfile() {
    $04f424e220a55f33$var$_updateProfile = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, param) {
        var displayName, photoUrl, userInternal, idToken, profileRequest, response, passwordProvider;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    displayName = param.displayName, photoUrl = param.photoURL;
                    if (displayName === undefined && photoUrl === undefined) return [
                        2
                    ];
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    return [
                        4,
                        userInternal.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    profileRequest = {
                        idToken: idToken,
                        displayName: displayName,
                        photoUrl: photoUrl,
                        returnSecureToken: true
                    };
                    return [
                        4,
                        $04f424e220a55f33$var$_logoutIfInvalidated(userInternal, $04f424e220a55f33$var$updateProfile$1(userInternal.auth, profileRequest))
                    ];
                case 2:
                    response = _state.sent();
                    userInternal.displayName = response.displayName || null;
                    userInternal.photoURL = response.photoUrl || null;
                    passwordProvider = userInternal.providerData.find(function(param) {
                        var providerId = param.providerId;
                        return providerId === "password" /* ProviderId.PASSWORD */ ;
                    });
                    if (passwordProvider) {
                        passwordProvider.displayName = userInternal.displayName;
                        passwordProvider.photoURL = userInternal.photoURL;
                    }
                    return [
                        4,
                        userInternal._updateTokensIfNecessary(response)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_updateProfile.apply(this, arguments);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $04f424e220a55f33$export$21579262ef46735b(user, newEmail) {
    return $04f424e220a55f33$var$updateEmailOrPassword((0, $cxgyp.getModularInstance)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $04f424e220a55f33$export$ab83b03e4111b1d0(user, newPassword) {
    return $04f424e220a55f33$var$updateEmailOrPassword((0, $cxgyp.getModularInstance)(user), null, newPassword);
}
function $04f424e220a55f33$var$updateEmailOrPassword(user, email, password) {
    return $04f424e220a55f33$var$_updateEmailOrPassword.apply(this, arguments);
}
function $04f424e220a55f33$var$_updateEmailOrPassword() {
    $04f424e220a55f33$var$_updateEmailOrPassword = (0, $5Pgs2._)(function(user, email, password) {
        var auth, idToken, request, response;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth = user.auth;
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        idToken: idToken,
                        returnSecureToken: true
                    };
                    if (email) request.email = email;
                    if (password) request.password = password;
                    return [
                        4,
                        $04f424e220a55f33$var$_logoutIfInvalidated(user, $04f424e220a55f33$var$updateEmailPassword(auth, request))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        user._updateTokensIfNecessary(response, /* reload */ true)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_updateEmailOrPassword.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $04f424e220a55f33$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    var providerId = idTokenResponse.providerId;
    var profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    var isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        var signInProvider = (_b = (_a = $04f424e220a55f33$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            var filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $04f424e220a55f33$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $04f424e220a55f33$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $04f424e220a55f33$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $04f424e220a55f33$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $04f424e220a55f33$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $04f424e220a55f33$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $04f424e220a55f33$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
var $04f424e220a55f33$var$GenericAdditionalUserInfo = function GenericAdditionalUserInfo(isNewUser, providerId) {
    "use strict";
    var profile = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, $50OuQ._)(this, GenericAdditionalUserInfo);
    this.isNewUser = isNewUser;
    this.providerId = providerId;
    this.profile = profile;
};
var $04f424e220a55f33$var$FederatedAdditionalUserInfoWithUsername = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $1atwj._)(FederatedAdditionalUserInfoWithUsername, GenericAdditionalUserInfo);
    var _super = (0, $iD0Am._)(FederatedAdditionalUserInfoWithUsername);
    function FederatedAdditionalUserInfoWithUsername(isNewUser, providerId, profile, username) {
        (0, $50OuQ._)(this, FederatedAdditionalUserInfoWithUsername);
        var _this;
        _this = _super.call(this, isNewUser, providerId, profile);
        _this.username = username;
        return _this;
    }
    return FederatedAdditionalUserInfoWithUsername;
}($04f424e220a55f33$var$GenericAdditionalUserInfo);
var $04f424e220a55f33$var$FacebookAdditionalUserInfo = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $1atwj._)(FacebookAdditionalUserInfo, GenericAdditionalUserInfo);
    var _super = (0, $iD0Am._)(FacebookAdditionalUserInfo);
    function FacebookAdditionalUserInfo(isNewUser, profile) {
        (0, $50OuQ._)(this, FacebookAdditionalUserInfo);
        return _super.call(this, isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
    return FacebookAdditionalUserInfo;
}($04f424e220a55f33$var$GenericAdditionalUserInfo);
var $04f424e220a55f33$var$GithubAdditionalUserInfo = /*#__PURE__*/ function(FederatedAdditionalUserInfoWithUsername) {
    "use strict";
    (0, $1atwj._)(GithubAdditionalUserInfo, FederatedAdditionalUserInfoWithUsername);
    var _super = (0, $iD0Am._)(GithubAdditionalUserInfo);
    function GithubAdditionalUserInfo(isNewUser, profile) {
        (0, $50OuQ._)(this, GithubAdditionalUserInfo);
        return _super.call(this, isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
    return GithubAdditionalUserInfo;
}($04f424e220a55f33$var$FederatedAdditionalUserInfoWithUsername);
var $04f424e220a55f33$var$GoogleAdditionalUserInfo = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $1atwj._)(GoogleAdditionalUserInfo, GenericAdditionalUserInfo);
    var _super = (0, $iD0Am._)(GoogleAdditionalUserInfo);
    function GoogleAdditionalUserInfo(isNewUser, profile) {
        (0, $50OuQ._)(this, GoogleAdditionalUserInfo);
        return _super.call(this, isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
    return GoogleAdditionalUserInfo;
}($04f424e220a55f33$var$GenericAdditionalUserInfo);
var $04f424e220a55f33$var$TwitterAdditionalUserInfo = /*#__PURE__*/ function(FederatedAdditionalUserInfoWithUsername) {
    "use strict";
    (0, $1atwj._)(TwitterAdditionalUserInfo, FederatedAdditionalUserInfoWithUsername);
    var _super = (0, $iD0Am._)(TwitterAdditionalUserInfo);
    function TwitterAdditionalUserInfo(isNewUser, profile, screenName) {
        (0, $50OuQ._)(this, TwitterAdditionalUserInfo);
        return _super.call(this, isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
    return TwitterAdditionalUserInfo;
}($04f424e220a55f33$var$FederatedAdditionalUserInfoWithUsername);
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $04f424e220a55f33$export$2f6ca3d3b1f80bf5(userCredential) {
    var user = userCredential.user, _tokenResponse = userCredential._tokenResponse;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $04f424e220a55f33$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $04f424e220a55f33$export$9e5f44173e64f162(auth, persistence) {
    return (0, $cxgyp.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $04f424e220a55f33$export$625550452a3fa3ec(auth) {
    return $04f424e220a55f33$var$_initializeRecaptchaConfig(auth);
}
function $04f424e220a55f33$export$90a7f3efeed30595(auth, password) {
    return $04f424e220a55f33$var$_validatePassword.apply(this, arguments);
}
function $04f424e220a55f33$var$_validatePassword() {
    $04f424e220a55f33$var$_validatePassword = /**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, password) {
        var authInternal;
        return (0, $1XfpH.__generator)(this, function(_state) {
            authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
            return [
                2,
                authInternal.validatePassword(password)
            ];
        });
    });
    return $04f424e220a55f33$var$_validatePassword.apply(this, arguments);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $04f424e220a55f33$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $cxgyp.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $04f424e220a55f33$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $cxgyp.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $04f424e220a55f33$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $cxgyp.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $04f424e220a55f33$export$df995fae86a55f06(auth) {
    (0, $cxgyp.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $04f424e220a55f33$export$ef35774e6d314e91(auth, user) {
    return (0, $cxgyp.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $04f424e220a55f33$export$e7094788287c5e9b(auth) {
    return (0, $cxgyp.getModularInstance)(auth).signOut();
}
function $04f424e220a55f33$export$96f57966bedc81b4(user) {
    return $04f424e220a55f33$var$_deleteUser.apply(this, arguments);
}
function $04f424e220a55f33$var$_deleteUser() {
    $04f424e220a55f33$var$_deleteUser = /**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ (0, $5Pgs2._)(function(user) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                (0, $cxgyp.getModularInstance)(user)["delete"]()
            ];
        });
    });
    return $04f424e220a55f33$var$_deleteUser.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$MultiFactorSessionImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorSessionImpl(type, credential, user) {
        (0, $50OuQ._)(this, MultiFactorSessionImpl);
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    (0, $fGdZr._)(MultiFactorSessionImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                var key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
                return {
                    multiFactorSession: (0, $2iBlG._)({}, key, this.credential)
                };
            }
        }
    ], [
        {
            key: "_fromIdtoken",
            value: function _fromIdtoken(idToken, user) {
                return new MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
            }
        },
        {
            key: "_fromMfaPendingCredential",
            value: function _fromMfaPendingCredential(mfaPendingCredential) {
                return new MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(obj) {
                var _a, _b;
                if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
                    if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
                    else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
                }
                return null;
            }
        }
    ]);
    return MultiFactorSessionImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$MultiFactorResolverImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorResolverImpl(session, hints, signInResolver) {
        (0, $50OuQ._)(this, MultiFactorResolverImpl);
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    (0, $fGdZr._)(MultiFactorResolverImpl, [
        {
            key: "resolveSignIn",
            value: function resolveSignIn(assertionExtern) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var assertion;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        assertion = assertionExtern;
                        return [
                            2,
                            _this.signInResolver(assertion)
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromError",
            value: /** @internal */ function _fromError(authExtern, error) {
                var auth = $04f424e220a55f33$export$b9a6b53f9be3734(authExtern);
                var serverResponse = error.customData._serverResponse;
                var hints = (serverResponse.mfaInfo || []).map(function(enrollment) {
                    return $04f424e220a55f33$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                });
                $04f424e220a55f33$export$9d398bebfec1c039(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var session = $04f424e220a55f33$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
                return new MultiFactorResolverImpl(session, hints, function() {
                    var _ref = (0, $5Pgs2._)(function(assertion) {
                        var mfaResponse, idTokenResponse, _, userCredential;
                        return (0, $1XfpH.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        assertion._process(auth, session)
                                    ];
                                case 1:
                                    mfaResponse = _state.sent();
                                    // Clear out the unneeded fields from the old login response
                                    delete serverResponse.mfaInfo;
                                    delete serverResponse.mfaPendingCredential;
                                    idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                                        idToken: mfaResponse.idToken,
                                        refreshToken: mfaResponse.refreshToken
                                    });
                                    _ = error.operationType;
                                    switch(_){
                                        case "signIn" /* OperationType.SIGN_IN */ :
                                            return [
                                                3,
                                                2
                                            ];
                                        case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                                            return [
                                                3,
                                                5
                                            ];
                                    }
                                    return [
                                        3,
                                        6
                                    ];
                                case 2:
                                    return [
                                        4,
                                        $04f424e220a55f33$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse)
                                    ];
                                case 3:
                                    userCredential = _state.sent();
                                    return [
                                        4,
                                        auth._updateCurrentUser(userCredential.user)
                                    ];
                                case 4:
                                    _state.sent();
                                    return [
                                        2,
                                        userCredential
                                    ];
                                case 5:
                                    $04f424e220a55f33$export$9d398bebfec1c039(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                    return [
                                        2,
                                        $04f424e220a55f33$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse)
                                    ];
                                case 6:
                                    $04f424e220a55f33$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                    _state.label = 7;
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(assertion) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    ]);
    return MultiFactorResolverImpl;
}();
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $04f424e220a55f33$export$d24c54395ce0c509(auth, error) {
    var _a;
    var authModular = (0, $cxgyp.getModularInstance)(auth);
    var errorInternal = error;
    $04f424e220a55f33$export$9d398bebfec1c039(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $04f424e220a55f33$export$9d398bebfec1c039((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $04f424e220a55f33$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$startEnrollPhoneMfa(auth, request) {
    return $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request));
}
function $04f424e220a55f33$var$finalizeEnrollPhoneMfa(auth, request) {
    return $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request));
}
function $04f424e220a55f33$var$startEnrollTotpMfa(auth, request) {
    return $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request));
}
function $04f424e220a55f33$var$finalizeEnrollTotpMfa(auth, request) {
    return $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request));
}
function $04f424e220a55f33$var$withdrawMfa(auth, request) {
    return $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request));
}
var $04f424e220a55f33$var$MultiFactorUserImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorUserImpl(user) {
        var _this = this;
        (0, $50OuQ._)(this, MultiFactorUserImpl);
        this.user = user;
        this.enrolledFactors = [];
        user._onReload(function(userInfo) {
            if (userInfo.mfaInfo) _this.enrolledFactors = userInfo.mfaInfo.map(function(enrollment) {
                return $04f424e220a55f33$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment);
            });
        });
    }
    (0, $fGdZr._)(MultiFactorUserImpl, [
        {
            key: "getSession",
            value: function getSession() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = $04f424e220a55f33$var$MultiFactorSessionImpl._fromIdtoken;
                                return [
                                    4,
                                    _this.user.getIdToken()
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply($04f424e220a55f33$var$MultiFactorSessionImpl, [
                                        _state.sent(),
                                        _this.user
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "enroll",
            value: function enroll(assertionExtern, displayName) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var assertion, session, finalizeMfaResponse;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                assertion = assertionExtern;
                                return [
                                    4,
                                    _this.getSession()
                                ];
                            case 1:
                                session = _state.sent();
                                return [
                                    4,
                                    $04f424e220a55f33$var$_logoutIfInvalidated(_this.user, assertion._process(_this.user.auth, session, displayName))
                                ];
                            case 2:
                                finalizeMfaResponse = _state.sent();
                                // New tokens will be issued after enrollment of the new second factors.
                                // They need to be updated on the user.
                                return [
                                    4,
                                    _this.user._updateTokensIfNecessary(finalizeMfaResponse)
                                ];
                            case 3:
                                _state.sent();
                                // The user needs to be reloaded to get the new multi-factor information
                                // from server. USER_RELOADED event will be triggered and `enrolledFactors`
                                // will be updated.
                                return [
                                    2,
                                    _this.user.reload()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unenroll",
            value: function unenroll(infoOrUid) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var mfaEnrollmentId, idToken, idTokenResponse, e;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
                                return [
                                    4,
                                    _this.user.getIdToken()
                                ];
                            case 1:
                                idToken = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    $04f424e220a55f33$var$_logoutIfInvalidated(_this.user, $04f424e220a55f33$var$withdrawMfa(_this.user.auth, {
                                        idToken: idToken,
                                        mfaEnrollmentId: mfaEnrollmentId
                                    }))
                                ];
                            case 3:
                                idTokenResponse = _state.sent();
                                // Remove the second factor from the user's list.
                                _this.enrolledFactors = _this.enrolledFactors.filter(function(param) {
                                    var uid = param.uid;
                                    return uid !== mfaEnrollmentId;
                                });
                                // Depending on whether the backend decided to revoke the user's session,
                                // the tokenResponse may be empty. If the tokens were not updated (and they
                                // are now invalid), reloading the user will discover this and invalidate
                                // the user's state accordingly.
                                return [
                                    4,
                                    _this.user._updateTokensIfNecessary(idTokenResponse)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this.user.reload()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                throw e;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromUser",
            value: function _fromUser(user) {
                return new MultiFactorUserImpl(user);
            }
        }
    ]);
    return MultiFactorUserImpl;
}();
var $04f424e220a55f33$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $04f424e220a55f33$export$6554612db691658e(user) {
    var userModular = (0, $cxgyp.getModularInstance)(user);
    if (!$04f424e220a55f33$var$multiFactorUserCache.has(userModular)) $04f424e220a55f33$var$multiFactorUserCache.set(userModular, $04f424e220a55f33$var$MultiFactorUserImpl._fromUser(userModular));
    return $04f424e220a55f33$var$multiFactorUserCache.get(userModular);
}
var $04f424e220a55f33$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
var $04f424e220a55f33$var$BrowserPersistenceClass = /*#__PURE__*/ function() {
    "use strict";
    function BrowserPersistenceClass(storageRetriever, type) {
        (0, $50OuQ._)(this, BrowserPersistenceClass);
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    (0, $fGdZr._)(BrowserPersistenceClass, [
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                try {
                    if (!this.storage) return Promise.resolve(false);
                    this.storage.setItem($04f424e220a55f33$var$STORAGE_AVAILABLE_KEY, "1");
                    this.storage.removeItem($04f424e220a55f33$var$STORAGE_AVAILABLE_KEY);
                    return Promise.resolve(true);
                } catch (_a) {
                    return Promise.resolve(false);
                }
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                this.storage.setItem(key, JSON.stringify(value));
                return Promise.resolve();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var json = this.storage.getItem(key);
                return Promise.resolve(json ? JSON.parse(json) : null);
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                this.storage.removeItem(key);
                return Promise.resolve();
            }
        },
        {
            key: "storage",
            get: function get() {
                return this.storageRetriever();
            }
        }
    ]);
    return BrowserPersistenceClass;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$_iframeCannotSyncWebStorage() {
    var ua = (0, $cxgyp.getUA)();
    return $04f424e220a55f33$var$_isSafari(ua) || $04f424e220a55f33$export$1fbe638ecf81657e(ua);
}
// The polling period in case events are not supported
var $04f424e220a55f33$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
var $04f424e220a55f33$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
var $04f424e220a55f33$var$BrowserLocalPersistence = /*#__PURE__*/ function(BrowserPersistenceClass) {
    "use strict";
    (0, $1atwj._)(BrowserLocalPersistence, BrowserPersistenceClass);
    var _super = (0, $iD0Am._)(BrowserLocalPersistence);
    function BrowserLocalPersistence() {
        (0, $50OuQ._)(this, BrowserLocalPersistence);
        var _this;
        _this = _super.call(this, function() {
            return window.localStorage;
        }, "LOCAL" /* PersistenceType.LOCAL */ );
        _this.boundEventHandler = function(event, poll) {
            return _this.onStorageEvent(event, poll);
        };
        _this.listeners = {};
        _this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        _this.safariLocalStorageNotSynced = $04f424e220a55f33$var$_iframeCannotSyncWebStorage() && $04f424e220a55f33$var$_isIframe();
        // Whether to use polling instead of depending on window events
        _this.fallbackToPolling = $04f424e220a55f33$var$_isMobileBrowser();
        _this._shouldAllowMigration = true;
        return _this;
    }
    (0, $fGdZr._)(BrowserLocalPersistence, [
        {
            key: "forAllChangedKeys",
            value: function forAllChangedKeys(cb) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Check all keys with listeners on them.
                    for(var _iterator = Object.keys(this.listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Get value from localStorage.
                        var newValue = this.storage.getItem(key);
                        var oldValue = this.localCache[key];
                        // If local map value does not match, trigger listener with storage event.
                        // Differentiate this simulated event from the real storage event.
                        if (newValue !== oldValue) cb(key, oldValue, newValue);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "onStorageEvent",
            value: function onStorageEvent(event) {
                var poll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                // Key would be null in some situations, like when localStorage is cleared
                if (!event.key) {
                    this.forAllChangedKeys(function(key, _oldValue, newValue) {
                        _this.notifyListeners(key, newValue);
                    });
                    return;
                }
                var key = event.key;
                // Check the mechanism how this event was detected.
                // The first event will dictate the mechanism to be used.
                if (poll) // Environment detects storage changes via polling.
                // Remove storage event listener to prevent possible event duplication.
                this.detachListener();
                else // Environment detects storage changes via storage event listener.
                // Remove polling listener to prevent possible event duplication.
                this.stopPolling();
                // Safari embedded iframe. Storage event will trigger with the delta
                // changes but no changes will be applied to the iframe localStorage.
                if (this.safariLocalStorageNotSynced) {
                    // Get current iframe page value.
                    var storedValue = this.storage.getItem(key);
                    // Value not synchronized, synchronize manually.
                    if (event.newValue !== storedValue) {
                        if (event.newValue !== null) // Value changed from current value.
                        this.storage.setItem(key, event.newValue);
                        else // Current value deleted.
                        this.storage.removeItem(key);
                    } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
                    return;
                }
                var triggerListeners = function() {
                    // Keep local map up to date in case storage event is triggered before
                    // poll.
                    var storedValue = _this.storage.getItem(key);
                    if (!poll && _this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
                    // This seems to trigger in some IE browsers for some reason.
                    return;
                    _this.notifyListeners(key, storedValue);
                };
                var storedValue1 = this.storage.getItem(key);
                if ($04f424e220a55f33$var$_isIE10() && storedValue1 !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
                // correct key, oldValue and newValue but localStorage.getItem(key) does
                // not yield the updated value until a few milliseconds. This ensures
                // this recovers from that situation.
                setTimeout(triggerListeners, $04f424e220a55f33$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
                else triggerListeners();
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners(key, value) {
                this.localCache[key] = value;
                var listeners = this.listeners[key];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (listeners) try {
                    for(var _iterator = Array.from(listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener(value ? JSON.parse(value) : value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "startPolling",
            value: function startPolling() {
                var _this = this;
                this.stopPolling();
                this.pollTimer = setInterval(function() {
                    _this.forAllChangedKeys(function(key, oldValue, newValue) {
                        _this.onStorageEvent(new StorageEvent("storage", {
                            key: key,
                            oldValue: oldValue,
                            newValue: newValue
                        }), /* poll */ true);
                    });
                }, $04f424e220a55f33$var$_POLLING_INTERVAL_MS$1);
            }
        },
        {
            key: "stopPolling",
            value: function stopPolling() {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        },
        {
            key: "attachListener",
            value: function attachListener() {
                window.addEventListener("storage", this.boundEventHandler);
            }
        },
        {
            key: "detachListener",
            value: function detachListener() {
                window.removeEventListener("storage", this.boundEventHandler);
            }
        },
        {
            key: "_addListener",
            value: function _addListener(key, listener) {
                if (Object.keys(this.listeners).length === 0) {
                    // Whether browser can detect storage event when it had already been pushed to the background.
                    // This may happen in some mobile browsers. A localStorage change in the foreground window
                    // will not be detected in the background window via the storage event.
                    // This was detected in iOS 7.x mobile browsers
                    if (this.fallbackToPolling) this.startPolling();
                    else this.attachListener();
                }
                if (!this.listeners[key]) {
                    this.listeners[key] = new Set();
                    // Populate the cache to avoid spuriously triggering on first poll.
                    this.localCache[key] = this.storage.getItem(key);
                }
                this.listeners[key].add(listener);
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(key, listener) {
                if (this.listeners[key]) {
                    this.listeners[key]["delete"](listener);
                    if (this.listeners[key].size === 0) delete this.listeners[key];
                }
                if (Object.keys(this.listeners).length === 0) {
                    this.detachListener();
                    this.stopPolling();
                }
            }
        },
        {
            key: "_set",
            value: // Update local cache on base operations:
            function _set(key, value) {
                var _this = this;
                var _this1 = this, _superprop_get__set = function() {
                    return (0, $ats3c._)((0, $bykok._)(BrowserLocalPersistence.prototype), "_set", _this);
                };
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__set().call(_this1, key, value)
                                ];
                            case 1:
                                _state.sent();
                                _this1.localCache[key] = JSON.stringify(value);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get1(key) {
                var _this = this;
                var _this1 = this, _superprop_get__get = function() {
                    return (0, $ats3c._)((0, $bykok._)(BrowserLocalPersistence.prototype), "_get", _this);
                };
                return (0, $5Pgs2._)(function() {
                    var value;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__get().call(_this1, key)
                                ];
                            case 1:
                                value = _state.sent();
                                _this1.localCache[key] = JSON.stringify(value);
                                return [
                                    2,
                                    value
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                var _this1 = this, _superprop_get__remove = function() {
                    return (0, $ats3c._)((0, $bykok._)(BrowserLocalPersistence.prototype), "_remove", _this);
                };
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__remove().call(_this1, key)
                                ];
                            case 1:
                                _state.sent();
                                delete _this1.localCache[key];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BrowserLocalPersistence;
}($04f424e220a55f33$var$BrowserPersistenceClass);
$04f424e220a55f33$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ var $04f424e220a55f33$export$8b22cf2602fb60ce = $04f424e220a55f33$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$BrowserSessionPersistence = /*#__PURE__*/ function(BrowserPersistenceClass) {
    "use strict";
    (0, $1atwj._)(BrowserSessionPersistence, BrowserPersistenceClass);
    var _super = (0, $iD0Am._)(BrowserSessionPersistence);
    function BrowserSessionPersistence() {
        (0, $50OuQ._)(this, BrowserSessionPersistence);
        return _super.call(this, function() {
            return window.sessionStorage;
        }, "SESSION" /* PersistenceType.SESSION */ );
    }
    (0, $fGdZr._)(BrowserSessionPersistence, [
        {
            key: "_addListener",
            value: function _addListener(_key, _listener) {
                // Listeners are not supported for session storage since it cannot be shared across windows
                return;
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(_key, _listener) {
                // Listeners are not supported for session storage since it cannot be shared across windows
                return;
            }
        }
    ]);
    return BrowserSessionPersistence;
}($04f424e220a55f33$var$BrowserPersistenceClass);
$04f424e220a55f33$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ var $04f424e220a55f33$export$407448d2b89b1813 = $04f424e220a55f33$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $04f424e220a55f33$var$_allSettled(promises) {
    return Promise.all(promises.map(function() {
        var _ref = (0, $5Pgs2._)(function(promise) {
            var value, reason;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 1:
                        value = _state.sent();
                        return [
                            2,
                            {
                                fulfilled: true,
                                value: value
                            }
                        ];
                    case 2:
                        reason = _state.sent();
                        return [
                            2,
                            {
                                fulfilled: false,
                                reason: reason
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(promise) {
            return _ref.apply(this, arguments);
        };
    }()));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ var $04f424e220a55f33$var$Receiver = /*#__PURE__*/ function() {
    "use strict";
    function Receiver(eventTarget) {
        (0, $50OuQ._)(this, Receiver);
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    (0, $fGdZr._)(Receiver, [
        {
            key: "isListeningto",
            value: function isListeningto(eventTarget) {
                return this.eventTarget === eventTarget;
            }
        },
        {
            key: "handleEvent",
            value: /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ function handleEvent(event) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var messageEvent, _messageEvent_data, eventId, eventType, data, handlers, promises, response;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                messageEvent = event;
                                _messageEvent_data = messageEvent.data, eventId = _messageEvent_data.eventId, eventType = _messageEvent_data.eventType, data = _messageEvent_data.data;
                                handlers = _this.handlersMap[eventType];
                                if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return [
                                    2
                                ];
                                messageEvent.ports[0].postMessage({
                                    status: "ack" /* _Status.ACK */ ,
                                    eventId: eventId,
                                    eventType: eventType
                                });
                                promises = Array.from(handlers).map(function() {
                                    var _ref = (0, $5Pgs2._)(function(handler) {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            return [
                                                2,
                                                handler(messageEvent.origin, data)
                                            ];
                                        });
                                    });
                                    return function(handler) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                return [
                                    4,
                                    $04f424e220a55f33$var$_allSettled(promises)
                                ];
                            case 1:
                                response = _state.sent();
                                messageEvent.ports[0].postMessage({
                                    status: "done" /* _Status.DONE */ ,
                                    eventId: eventId,
                                    eventType: eventType,
                                    response: response
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ key: "_subscribe",
            value: function _subscribe(eventType, eventHandler) {
                if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
                if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
                this.handlersMap[eventType].add(eventHandler);
            }
        },
        {
            /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ key: "_unsubscribe",
            value: function _unsubscribe(eventType, eventHandler) {
                if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType]["delete"](eventHandler);
                if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
                if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
            }
        }
    ], [
        {
            key: "_getInstance",
            value: /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ function _getInstance(eventTarget) {
                // The results are stored in an array since objects can't be keys for other
                // objects. In addition, setting a unique property on an event target as a
                // hash map key may not be allowed due to CORS restrictions.
                var existingInstance = this.receivers.find(function(receiver) {
                    return receiver.isListeningto(eventTarget);
                });
                if (existingInstance) return existingInstance;
                var newInstance = new Receiver(eventTarget);
                this.receivers.push(newInstance);
                return newInstance;
            }
        }
    ]);
    return Receiver;
}();
$04f424e220a55f33$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$export$9f4f30ee63539e24() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var random = "";
    for(var i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ var $04f424e220a55f33$var$Sender = /*#__PURE__*/ function() {
    "use strict";
    function Sender(target) {
        (0, $50OuQ._)(this, Sender);
        this.target = target;
        this.handlers = new Set();
    }
    (0, $fGdZr._)(Sender, [
        {
            /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ key: "removeMessageHandler",
            value: function removeMessageHandler(handler) {
                if (handler.messageChannel) {
                    handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
                    handler.messageChannel.port1.close();
                }
                this.handlers["delete"](handler);
            }
        },
        {
            key: "_send",
            value: /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ function _send(eventType, data) {
                var timeout = arguments.length > 2 && arguments[2] !== void 0 /* _TimeoutDuration.ACK */  ? arguments[2] : 50;
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var messageChannel, completionTimer, handler;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
                        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var eventId = $04f424e220a55f33$export$9f4f30ee63539e24("", 20);
                                messageChannel.port1.start();
                                var ackTimer = setTimeout(function() {
                                    reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
                                }, timeout);
                                handler = {
                                    messageChannel: messageChannel,
                                    onMessage: function(event) {
                                        var messageEvent = event;
                                        if (messageEvent.data.eventId !== eventId) return;
                                        switch(messageEvent.data.status){
                                            case "ack" /* _Status.ACK */ :
                                                // The receiver should ACK first.
                                                clearTimeout(ackTimer);
                                                completionTimer = setTimeout(function() {
                                                    reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                                                }, 3000 /* _TimeoutDuration.COMPLETION */ );
                                                break;
                                            case "done" /* _Status.DONE */ :
                                                // Once the receiver's handlers are finished we will get the results.
                                                clearTimeout(completionTimer);
                                                resolve(messageEvent.data.response);
                                                break;
                                            default:
                                                clearTimeout(ackTimer);
                                                clearTimeout(completionTimer);
                                                reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                                                break;
                                        }
                                    }
                                };
                                _this.handlers.add(handler);
                                messageChannel.port1.addEventListener("message", handler.onMessage);
                                _this.target.postMessage({
                                    eventType: eventType,
                                    eventId: eventId,
                                    data: data
                                }, [
                                    messageChannel.port2
                                ]);
                            })["finally"](function() {
                                if (handler) _this.removeMessageHandler(handler);
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return Sender;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $04f424e220a55f33$var$_window() {
    return window;
}
function $04f424e220a55f33$var$_setWindowLocation(url) {
    $04f424e220a55f33$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$_isWorker() {
    return typeof $04f424e220a55f33$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $04f424e220a55f33$var$_window()["importScripts"] === "function";
}
function $04f424e220a55f33$var$_getActiveServiceWorker() {
    return $04f424e220a55f33$var$__getActiveServiceWorker.apply(this, arguments);
}
function $04f424e220a55f33$var$__getActiveServiceWorker() {
    $04f424e220a55f33$var$__getActiveServiceWorker = (0, $5Pgs2._)(function() {
        var registration, _a;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return [
                        2,
                        null
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        navigator.serviceWorker.ready
                    ];
                case 2:
                    registration = _state.sent();
                    return [
                        2,
                        registration.active
                    ];
                case 3:
                    _a = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__getActiveServiceWorker.apply(this, arguments);
}
function $04f424e220a55f33$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $04f424e220a55f33$var$_getWorkerGlobalScope() {
    return $04f424e220a55f33$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$DB_NAME = "firebaseLocalStorageDb";
var $04f424e220a55f33$var$DB_VERSION = 1;
var $04f424e220a55f33$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
var $04f424e220a55f33$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ var $04f424e220a55f33$var$DBPromise = /*#__PURE__*/ function() {
    "use strict";
    function DBPromise(request) {
        (0, $50OuQ._)(this, DBPromise);
        this.request = request;
    }
    (0, $fGdZr._)(DBPromise, [
        {
            key: "toPromise",
            value: function toPromise() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    _this.request.addEventListener("success", function() {
                        resolve(_this.request.result);
                    });
                    _this.request.addEventListener("error", function() {
                        reject(_this.request.error);
                    });
                });
            }
        }
    ]);
    return DBPromise;
}();
function $04f424e220a55f33$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $04f424e220a55f33$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($04f424e220a55f33$var$DB_OBJECTSTORE_NAME);
}
function $04f424e220a55f33$var$_deleteDatabase() {
    var request = indexedDB.deleteDatabase($04f424e220a55f33$var$DB_NAME);
    return new $04f424e220a55f33$var$DBPromise(request).toPromise();
}
function $04f424e220a55f33$var$_openDatabase() {
    var request = indexedDB.open($04f424e220a55f33$var$DB_NAME, $04f424e220a55f33$var$DB_VERSION);
    return new Promise(function(resolve, reject) {
        request.addEventListener("error", function() {
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", function() {
            var db = request.result;
            try {
                db.createObjectStore($04f424e220a55f33$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $04f424e220a55f33$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", /*#__PURE__*/ (0, $5Pgs2._)(function() {
            var db;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        db = request.result;
                        if (!!db.objectStoreNames.contains($04f424e220a55f33$var$DB_OBJECTSTORE_NAME)) return [
                            3,
                            3
                        ];
                        // Need to close the database or else you get a `blocked` event
                        db.close();
                        return [
                            4,
                            $04f424e220a55f33$var$_deleteDatabase()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            $04f424e220a55f33$var$_openDatabase()
                        ];
                    case 2:
                        resolve.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        resolve(db);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }));
    });
}
function $04f424e220a55f33$var$_putObject(db, key, value) {
    return $04f424e220a55f33$var$__putObject.apply(this, arguments);
}
function $04f424e220a55f33$var$__putObject() {
    $04f424e220a55f33$var$__putObject = (0, $5Pgs2._)(function(db, key, value) {
        var _obj, request;
        return (0, $1XfpH.__generator)(this, function(_state) {
            request = $04f424e220a55f33$var$getObjectStore(db, true).put((_obj = {}, (0, $2iBlG._)(_obj, $04f424e220a55f33$var$DB_DATA_KEYPATH, key), (0, $2iBlG._)(_obj, "value", value), _obj));
            return [
                2,
                new $04f424e220a55f33$var$DBPromise(request).toPromise()
            ];
        });
    });
    return $04f424e220a55f33$var$__putObject.apply(this, arguments);
}
function $04f424e220a55f33$var$getObject(db, key) {
    return $04f424e220a55f33$var$_getObject.apply(this, arguments);
}
function $04f424e220a55f33$var$_getObject() {
    $04f424e220a55f33$var$_getObject = (0, $5Pgs2._)(function(db, key) {
        var request, data;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = $04f424e220a55f33$var$getObjectStore(db, false).get(key);
                    return [
                        4,
                        new $04f424e220a55f33$var$DBPromise(request).toPromise()
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data === undefined ? null : data.value
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_getObject.apply(this, arguments);
}
function $04f424e220a55f33$var$_deleteObject(db, key) {
    var request = $04f424e220a55f33$var$getObjectStore(db, true)["delete"](key);
    return new $04f424e220a55f33$var$DBPromise(request).toPromise();
}
var $04f424e220a55f33$var$_POLLING_INTERVAL_MS = 800;
var $04f424e220a55f33$var$_TRANSACTION_RETRY_COUNT = 3;
var $04f424e220a55f33$var$IndexedDBLocalPersistence = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDBLocalPersistence() {
        (0, $50OuQ._)(this, IndexedDBLocalPersistence);
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(function() {}, function() {});
    }
    (0, $fGdZr._)(IndexedDBLocalPersistence, [
        {
            key: "_openDb",
            value: function _openDb() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.db) return [
                                    2,
                                    _this.db
                                ];
                                return [
                                    4,
                                    $04f424e220a55f33$var$_openDatabase()
                                ];
                            case 1:
                                _this.db = _state.sent();
                                return [
                                    2,
                                    _this.db
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_withRetries",
            value: function _withRetries(op) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var numAttempts, db, e;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                numAttempts = 0;
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    7
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this._openDb()
                                ];
                            case 3:
                                db = _state.sent();
                                return [
                                    4,
                                    op(db)
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                e = _state.sent();
                                if (numAttempts++ > $04f424e220a55f33$var$_TRANSACTION_RETRY_COUNT) throw e;
                                if (_this.db) {
                                    _this.db.close();
                                    _this.db = undefined;
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    1
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeServiceWorkerMessaging",
            value: /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ function initializeServiceWorkerMessaging() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            $04f424e220a55f33$var$_isWorker() ? _this.initializeReceiver() : _this.initializeSender()
                        ];
                    });
                })();
            }
        },
        {
            key: "initializeReceiver",
            value: /**
     * As the worker we should listen to events from the main window.
     */ function initializeReceiver() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        _this.receiver = $04f424e220a55f33$var$Receiver._getInstance($04f424e220a55f33$var$_getWorkerGlobalScope());
                        // Refresh from persistence if we receive a KeyChanged message.
                        _this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , function() {
                            var _ref = (0, $5Pgs2._)(function(_origin, data) {
                                var keys;
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._poll()
                                            ];
                                        case 1:
                                            keys = _state.sent();
                                            return [
                                                2,
                                                {
                                                    keyProcessed: keys.includes(data.key)
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(_origin, data) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        // Let the sender know that we are listening so they give us more timeout.
                        _this.receiver._subscribe("ping" /* _EventType.PING */ , function() {
                            var _ref = (0, $5Pgs2._)(function(_origin, _data) {
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        [
                                            "keyChanged" /* _EventType.KEY_CHANGED */ 
                                        ]
                                    ];
                                });
                            });
                            return function(_origin, _data) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "initializeSender",
            value: /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ function initializeSender() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b, results;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $04f424e220a55f33$var$_getActiveServiceWorker()
                                ];
                            case 1:
                                // Check to see if there's an active service worker.
                                _this.activeServiceWorker = _state.sent();
                                if (!_this.activeServiceWorker) return [
                                    2
                                ];
                                _this.sender = new $04f424e220a55f33$var$Sender(_this.activeServiceWorker);
                                return [
                                    4,
                                    _this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ )
                                ];
                            case 2:
                                results = _state.sent();
                                if (!results) return [
                                    2
                                ];
                                if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) _this.serviceWorkerReceiverAvailable = true;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifyServiceWorker",
            value: /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ function notifyServiceWorker(key) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.sender || !_this.activeServiceWorker || $04f424e220a55f33$var$_getServiceWorkerController() !== _this.activeServiceWorker) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                                        key: key
                                    }, // Use long timeout if receiver has previously responded to a ping from us.
                                    _this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ )
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                return (0, $5Pgs2._)(function() {
                    var db, _a;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                if (!indexedDB) return [
                                    2,
                                    false
                                ];
                                return [
                                    4,
                                    $04f424e220a55f33$var$_openDatabase()
                                ];
                            case 1:
                                db = _state.sent();
                                return [
                                    4,
                                    $04f424e220a55f33$var$_putObject(db, $04f424e220a55f33$var$STORAGE_AVAILABLE_KEY, "1")
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    $04f424e220a55f33$var$_deleteObject(db, $04f424e220a55f33$var$STORAGE_AVAILABLE_KEY)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    true
                                ];
                            case 4:
                                _a = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_withPendingWrite",
            value: function _withPendingWrite(write) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.pendingWrites++;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    write()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.pendingWrites--;
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._withPendingWrite(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._withRetries(function(db) {
                                                    return $04f424e220a55f33$var$_putObject(db, key, value);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            _this.localCache[key] = value;
                                            return [
                                                2,
                                                _this.notifyServiceWorker(key)
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var obj;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._withRetries(function(db) {
                                        return $04f424e220a55f33$var$getObject(db, key);
                                    })
                                ];
                            case 1:
                                obj = _state.sent();
                                _this.localCache[key] = obj;
                                return [
                                    2,
                                    obj
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._withPendingWrite(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._withRetries(function(db) {
                                                    return $04f424e220a55f33$var$_deleteObject(db, key);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            delete _this.localCache[key];
                                            return [
                                                2,
                                                _this.notifyServiceWorker(key)
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "_poll",
            value: function _poll() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var result, keys, keysInResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, localKey;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._withRetries(function(db) {
                                        var getAllRequest = $04f424e220a55f33$var$getObjectStore(db, false).getAll();
                                        return new $04f424e220a55f33$var$DBPromise(getAllRequest).toPromise();
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (!result) return [
                                    2,
                                    []
                                ];
                                // If we have pending writes in progress abort, we'll get picked up on the next poll
                                if (_this.pendingWrites !== 0) return [
                                    2,
                                    []
                                ];
                                keys = [];
                                keysInResult = new Set();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = result[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        _step_value = _step.value, key = _step_value.fbase_key, value = _step_value.value;
                                        keysInResult.add(key);
                                        if (JSON.stringify(_this.localCache[key]) !== JSON.stringify(value)) {
                                            _this.notifyListeners(key, value);
                                            keys.push(key);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = Object.keys(_this.localCache)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        localKey = _step1.value;
                                        if (_this.localCache[localKey] && !keysInResult.has(localKey)) {
                                            // Deleted
                                            _this.notifyListeners(localKey, null);
                                            keys.push(localKey);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    keys
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners(key, newValue) {
                this.localCache[key] = newValue;
                var listeners = this.listeners[key];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (listeners) try {
                    for(var _iterator = Array.from(listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener(newValue);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "startPolling",
            value: function startPolling() {
                this.stopPolling();
                var _this = this;
                this.pollTimer = setInterval(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._poll()
                        ];
                    });
                }), $04f424e220a55f33$var$_POLLING_INTERVAL_MS);
            }
        },
        {
            key: "stopPolling",
            value: function stopPolling() {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        },
        {
            key: "_addListener",
            value: function _addListener(key, listener) {
                if (Object.keys(this.listeners).length === 0) this.startPolling();
                if (!this.listeners[key]) {
                    this.listeners[key] = new Set();
                    this._get(key); // This can happen in the background async and we can return immediately.
                }
                this.listeners[key].add(listener);
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(key, listener) {
                if (this.listeners[key]) {
                    this.listeners[key]["delete"](listener);
                    if (this.listeners[key].size === 0) delete this.listeners[key];
                }
                if (Object.keys(this.listeners).length === 0) this.stopPolling();
            }
        }
    ]);
    return IndexedDBLocalPersistence;
}();
$04f424e220a55f33$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ var $04f424e220a55f33$export$23f2a1d2818174ef = $04f424e220a55f33$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$startSignInPhoneMfa(auth, request) {
    return $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request));
}
function $04f424e220a55f33$var$finalizeSignInPhoneMfa(auth, request) {
    return $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request));
}
function $04f424e220a55f33$var$finalizeSignInTotpMfa(auth, request) {
    return $04f424e220a55f33$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $04f424e220a55f33$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$_SOLVE_TIME_MS = 500;
var $04f424e220a55f33$var$_EXPIRATION_TIME_MS = 60000;
var $04f424e220a55f33$var$_WIDGET_ID_START = 1000000000000;
var $04f424e220a55f33$var$MockReCaptcha = /*#__PURE__*/ function() {
    "use strict";
    function MockReCaptcha(auth) {
        (0, $50OuQ._)(this, MockReCaptcha);
        this.auth = auth;
        this.counter = $04f424e220a55f33$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    (0, $fGdZr._)(MockReCaptcha, [
        {
            key: "render",
            value: function render(container, parameters) {
                var id = this.counter;
                this._widgets.set(id, new $04f424e220a55f33$var$MockWidget(container, this.auth.name, parameters || {}));
                this.counter++;
                return id;
            }
        },
        {
            key: "reset",
            value: function reset(optWidgetId) {
                var _a;
                var id = optWidgetId || $04f424e220a55f33$var$_WIDGET_ID_START;
                (_a = this._widgets.get(id)) === null || _a === void 0 || _a["delete"]();
                this._widgets["delete"](id);
            }
        },
        {
            key: "getResponse",
            value: function getResponse(optWidgetId) {
                var _a;
                var id = optWidgetId || $04f424e220a55f33$var$_WIDGET_ID_START;
                return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
            }
        },
        {
            key: "execute",
            value: function execute(optWidgetId) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, id;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        id = optWidgetId || $04f424e220a55f33$var$_WIDGET_ID_START;
                        (_a = _this._widgets.get(id)) === null || _a === void 0 || _a.execute();
                        return [
                            2,
                            ""
                        ];
                    });
                })();
            }
        }
    ]);
    return MockReCaptcha;
}();
var $04f424e220a55f33$var$MockWidget = /*#__PURE__*/ function() {
    "use strict";
    function MockWidget(containerOrId, appName, params) {
        var _this = this;
        (0, $50OuQ._)(this, MockWidget);
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = function() {
            _this.execute();
        };
        var container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $04f424e220a55f33$export$9d398bebfec1c039(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    (0, $fGdZr._)(MockWidget, [
        {
            key: "getResponse",
            value: function getResponse() {
                this.checkIfDeleted();
                return this.responseToken;
            }
        },
        {
            key: "delete",
            value: function _delete() {
                this.checkIfDeleted();
                this.deleted = true;
                if (this.timerId) {
                    clearTimeout(this.timerId);
                    this.timerId = null;
                }
                this.container.removeEventListener("click", this.clickHandler);
            }
        },
        {
            key: "execute",
            value: function execute() {
                var _this = this;
                this.checkIfDeleted();
                if (this.timerId) return;
                this.timerId = window.setTimeout(function() {
                    _this.responseToken = $04f424e220a55f33$var$generateRandomAlphaNumericString(50);
                    var _this_params = _this.params, callback = _this_params.callback, expiredCallback = _this_params["expired-callback"];
                    if (callback) try {
                        callback(_this.responseToken);
                    } catch (e) {}
                    _this.timerId = window.setTimeout(function() {
                        _this.timerId = null;
                        _this.responseToken = null;
                        if (expiredCallback) try {
                            expiredCallback();
                        } catch (e) {}
                        if (_this.isVisible) _this.execute();
                    }, $04f424e220a55f33$var$_EXPIRATION_TIME_MS);
                }, $04f424e220a55f33$var$_SOLVE_TIME_MS);
            }
        },
        {
            key: "checkIfDeleted",
            value: function checkIfDeleted() {
                if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
            }
        }
    ]);
    return MockWidget;
}();
function $04f424e220a55f33$var$generateRandomAlphaNumericString(len) {
    var chars = [];
    var allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(var i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
var $04f424e220a55f33$var$_JSLOAD_CALLBACK = $04f424e220a55f33$var$_generateCallbackName("rcb");
var $04f424e220a55f33$var$NETWORK_TIMEOUT_DELAY = new $04f424e220a55f33$var$Delay(30000, 60000);
var $04f424e220a55f33$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ var $04f424e220a55f33$var$ReCaptchaLoaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function ReCaptchaLoaderImpl() {
        (0, $50OuQ._)(this, ReCaptchaLoaderImpl);
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $04f424e220a55f33$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    (0, $fGdZr._)(ReCaptchaLoaderImpl, [
        {
            key: "load",
            value: function load(auth) {
                var hl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                var _this = this;
                $04f424e220a55f33$export$9d398bebfec1c039($04f424e220a55f33$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                if (this.shouldResolveImmediately(hl) && $04f424e220a55f33$var$isV2($04f424e220a55f33$var$_window().grecaptcha)) return Promise.resolve($04f424e220a55f33$var$_window().grecaptcha);
                return new Promise(function(resolve, reject) {
                    var networkTimeout = $04f424e220a55f33$var$_window().setTimeout(function() {
                        reject($04f424e220a55f33$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                    }, $04f424e220a55f33$var$NETWORK_TIMEOUT_DELAY.get());
                    $04f424e220a55f33$var$_window()[$04f424e220a55f33$var$_JSLOAD_CALLBACK] = function() {
                        $04f424e220a55f33$var$_window().clearTimeout(networkTimeout);
                        delete $04f424e220a55f33$var$_window()[$04f424e220a55f33$var$_JSLOAD_CALLBACK];
                        var recaptcha = $04f424e220a55f33$var$_window().grecaptcha;
                        if (!recaptcha || !$04f424e220a55f33$var$isV2(recaptcha)) {
                            reject($04f424e220a55f33$export$91c6e00c14e7e6fd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                            return;
                        }
                        // Wrap the greptcha render function so that we know if the developer has
                        // called it separately
                        var render = recaptcha.render;
                        recaptcha.render = function(container, params) {
                            var widgetId = render(container, params);
                            _this.counter++;
                            return widgetId;
                        };
                        _this.hostLanguage = hl;
                        resolve(recaptcha);
                    };
                    var url = "".concat($04f424e220a55f33$var$RECAPTCHA_BASE, "?").concat((0, $cxgyp.querystring)({
                        onload: $04f424e220a55f33$var$_JSLOAD_CALLBACK,
                        render: "explicit",
                        hl: hl
                    }));
                    $04f424e220a55f33$var$_loadJS(url)["catch"](function() {
                        clearTimeout(networkTimeout);
                        reject($04f424e220a55f33$export$91c6e00c14e7e6fd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    });
                });
            }
        },
        {
            key: "clearedOneInstance",
            value: function clearedOneInstance() {
                this.counter--;
            }
        },
        {
            key: "shouldResolveImmediately",
            value: function shouldResolveImmediately(hl) {
                var _a;
                // We can resolve immediately if:
                //   • grecaptcha is already defined AND (
                //     1. the requested language codes are the same OR
                //     2. there exists already a ReCaptcha on the page
                //     3. the library was already loaded by the app
                // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
                // that are already in the page
                return !!((_a = $04f424e220a55f33$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
            }
        }
    ]);
    return ReCaptchaLoaderImpl;
}();
function $04f424e220a55f33$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
var $04f424e220a55f33$var$MockReCaptchaLoaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function MockReCaptchaLoaderImpl() {
        (0, $50OuQ._)(this, MockReCaptchaLoaderImpl);
    }
    (0, $fGdZr._)(MockReCaptchaLoaderImpl, [
        {
            key: "load",
            value: function load(auth) {
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            new $04f424e220a55f33$var$MockReCaptcha(auth)
                        ];
                    });
                })();
            }
        },
        {
            key: "clearedOneInstance",
            value: function clearedOneInstance() {}
        }
    ]);
    return MockReCaptchaLoaderImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
var $04f424e220a55f33$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ var $04f424e220a55f33$export$db202ddc8be9136 = /*#__PURE__*/ function() {
    "use strict";
    function RecaptchaVerifier(authExtern, containerOrId) {
        var parameters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Object.assign({}, $04f424e220a55f33$var$DEFAULT_PARAMS);
        (0, $50OuQ._)(this, RecaptchaVerifier);
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $04f424e220a55f33$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $04f424e220a55f33$export$b9a6b53f9be3734(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $04f424e220a55f33$export$9d398bebfec1c039(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        var container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $04f424e220a55f33$export$9d398bebfec1c039(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $04f424e220a55f33$var$MockReCaptchaLoaderImpl() : new $04f424e220a55f33$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    }
    (0, $fGdZr._)(RecaptchaVerifier, [
        {
            key: "verify",
            value: /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ function verify() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var id, recaptcha, response;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.assertNotDestroyed();
                                return [
                                    4,
                                    _this.render()
                                ];
                            case 1:
                                id = _state.sent();
                                recaptcha = _this.getAssertedRecaptcha();
                                response = recaptcha.getResponse(id);
                                if (response) return [
                                    2,
                                    response
                                ];
                                return [
                                    2,
                                    new Promise(function(resolve) {
                                        var tokenChange = function(token) {
                                            if (!token) return; // Ignore token expirations.
                                            _this.tokenChangeListeners["delete"](tokenChange);
                                            resolve(token);
                                        };
                                        _this.tokenChangeListeners.add(tokenChange);
                                        if (_this.isInvisible) recaptcha.execute(id);
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ key: "render",
            value: function render() {
                var _this = this;
                try {
                    this.assertNotDestroyed();
                } catch (e) {
                    // This method returns a promise. Since it's not async (we want to return the
                    // _same_ promise if rendering is still occurring), the API surface should
                    // reject with the error rather than just throw
                    return Promise.reject(e);
                }
                if (this.renderPromise) return this.renderPromise;
                this.renderPromise = this.makeRenderPromise()["catch"](function(e) {
                    _this.renderPromise = null;
                    throw e;
                });
                return this.renderPromise;
            }
        },
        {
            /** @internal */ key: "_reset",
            value: function _reset() {
                this.assertNotDestroyed();
                if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
            }
        },
        {
            /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ key: "clear",
            value: function clear() {
                var _this = this;
                this.assertNotDestroyed();
                this.destroyed = true;
                this._recaptchaLoader.clearedOneInstance();
                if (!this.isInvisible) this.container.childNodes.forEach(function(node) {
                    _this.container.removeChild(node);
                });
            }
        },
        {
            key: "validateStartingState",
            value: function validateStartingState() {
                $04f424e220a55f33$export$9d398bebfec1c039(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                $04f424e220a55f33$export$9d398bebfec1c039(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                $04f424e220a55f33$export$9d398bebfec1c039(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
            }
        },
        {
            key: "makeTokenCallback",
            value: function makeTokenCallback(existing) {
                var _this = this;
                return function(token) {
                    _this.tokenChangeListeners.forEach(function(listener) {
                        return listener(token);
                    });
                    if (typeof existing === "function") existing(token);
                    else if (typeof existing === "string") {
                        var globalFunc = $04f424e220a55f33$var$_window()[existing];
                        if (typeof globalFunc === "function") globalFunc(token);
                    }
                };
            }
        },
        {
            key: "assertNotDestroyed",
            value: function assertNotDestroyed() {
                $04f424e220a55f33$export$9d398bebfec1c039(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        },
        {
            key: "makeRenderPromise",
            value: function makeRenderPromise() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var container, guaranteedEmpty;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.init()
                                ];
                            case 1:
                                _state.sent();
                                if (!_this.widgetId) {
                                    container = _this.container;
                                    if (!_this.isInvisible) {
                                        guaranteedEmpty = document.createElement("div");
                                        container.appendChild(guaranteedEmpty);
                                        container = guaranteedEmpty;
                                    }
                                    _this.widgetId = _this.getAssertedRecaptcha().render(container, _this.parameters);
                                }
                                return [
                                    2,
                                    _this.widgetId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var siteKey;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $04f424e220a55f33$export$9d398bebfec1c039($04f424e220a55f33$var$_isHttpOrHttps() && !$04f424e220a55f33$var$_isWorker(), _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    4,
                                    $04f424e220a55f33$var$domReady()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._recaptchaLoader.load(_this.auth, _this.auth.languageCode || undefined)
                                ];
                            case 2:
                                _this.recaptcha = _state.sent();
                                return [
                                    4,
                                    $04f424e220a55f33$var$getRecaptchaParams(_this.auth)
                                ];
                            case 3:
                                siteKey = _state.sent();
                                $04f424e220a55f33$export$9d398bebfec1c039(siteKey, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                _this.parameters.sitekey = siteKey;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAssertedRecaptcha",
            value: function getAssertedRecaptcha() {
                $04f424e220a55f33$export$9d398bebfec1c039(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.recaptcha;
            }
        }
    ]);
    return RecaptchaVerifier;
}();
function $04f424e220a55f33$var$domReady() {
    var resolver = null;
    return new Promise(function(resolve) {
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = function() {
            return resolve();
        };
        window.addEventListener("load", resolver);
    })["catch"](function(e) {
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$ConfirmationResultImpl = /*#__PURE__*/ function() {
    "use strict";
    function ConfirmationResultImpl(verificationId, onConfirmation) {
        (0, $50OuQ._)(this, ConfirmationResultImpl);
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    (0, $fGdZr._)(ConfirmationResultImpl, [
        {
            key: "confirm",
            value: function confirm(verificationCode) {
                var authCredential = $04f424e220a55f33$export$a07804094c3ecf2d._fromVerification(this.verificationId, verificationCode);
                return this.onConfirmation(authCredential);
            }
        }
    ]);
    return ConfirmationResultImpl;
}();
function $04f424e220a55f33$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    return $04f424e220a55f33$var$_signInWithPhoneNumber.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithPhoneNumber() {
    $04f424e220a55f33$var$_signInWithPhoneNumber = /**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, phoneNumber, appVerifier) {
        var authInternal, verificationId;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
                    return [
                        4,
                        $04f424e220a55f33$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $cxgyp.getModularInstance)(appVerifier))
                    ];
                case 1:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $04f424e220a55f33$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $04f424e220a55f33$export$34aec0b863436764(authInternal, cred);
                        })
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_signInWithPhoneNumber.apply(this, arguments);
}
function $04f424e220a55f33$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    return $04f424e220a55f33$var$_linkWithPhoneNumber.apply(this, arguments);
}
function $04f424e220a55f33$var$_linkWithPhoneNumber() {
    $04f424e220a55f33$var$_linkWithPhoneNumber = /**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, phoneNumber, appVerifier) {
        var userInternal, verificationId;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    return [
                        4,
                        $04f424e220a55f33$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ )
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        $04f424e220a55f33$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $cxgyp.getModularInstance)(appVerifier))
                    ];
                case 2:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $04f424e220a55f33$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $04f424e220a55f33$export$3c2fa207a37baaea(userInternal, cred);
                        })
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_linkWithPhoneNumber.apply(this, arguments);
}
function $04f424e220a55f33$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    return $04f424e220a55f33$var$_reauthenticateWithPhoneNumber.apply(this, arguments);
}
function $04f424e220a55f33$var$_reauthenticateWithPhoneNumber() {
    $04f424e220a55f33$var$_reauthenticateWithPhoneNumber = /**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, phoneNumber, appVerifier) {
        var userInternal, verificationId;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    return [
                        4,
                        $04f424e220a55f33$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $cxgyp.getModularInstance)(appVerifier))
                    ];
                case 1:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $04f424e220a55f33$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $04f424e220a55f33$export$ce26c07117d59d6a(userInternal, cred);
                        })
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_reauthenticateWithPhoneNumber.apply(this, arguments);
}
function $04f424e220a55f33$var$_verifyPhoneNumber(auth, options, verifier) {
    return $04f424e220a55f33$var$__verifyPhoneNumber.apply(this, arguments);
}
function $04f424e220a55f33$var$__verifyPhoneNumber() {
    $04f424e220a55f33$var$__verifyPhoneNumber = /**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ (0, $5Pgs2._)(function(auth, options, verifier) {
        var _a, recaptchaToken, phoneInfoOptions, session, response, mfaEnrollmentId, response1, sessionInfo;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        verifier.verify()
                    ];
                case 1:
                    recaptchaToken = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        ,
                        10,
                        11
                    ]);
                    $04f424e220a55f33$export$9d398bebfec1c039(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    $04f424e220a55f33$export$9d398bebfec1c039(verifier.type === $04f424e220a55f33$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    if (typeof options === "string") phoneInfoOptions = {
                        phoneNumber: options
                    };
                    else phoneInfoOptions = options;
                    if (!("session" in phoneInfoOptions)) return [
                        3,
                        7
                    ];
                    session = phoneInfoOptions.session;
                    if (!("phoneNumber" in phoneInfoOptions)) return [
                        3,
                        4
                    ];
                    $04f424e220a55f33$export$9d398bebfec1c039(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return [
                        4,
                        $04f424e220a55f33$var$startEnrollPhoneMfa(auth, {
                            idToken: session.credential,
                            phoneEnrollmentInfo: {
                                phoneNumber: phoneInfoOptions.phoneNumber,
                                recaptchaToken: recaptchaToken
                            }
                        })
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        2,
                        response.phoneSessionInfo.sessionInfo
                    ];
                case 4:
                    $04f424e220a55f33$export$9d398bebfec1c039(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                    $04f424e220a55f33$export$9d398bebfec1c039(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                    return [
                        4,
                        $04f424e220a55f33$var$startSignInPhoneMfa(auth, {
                            mfaPendingCredential: session.credential,
                            mfaEnrollmentId: mfaEnrollmentId,
                            phoneSignInInfo: {
                                recaptchaToken: recaptchaToken
                            }
                        })
                    ];
                case 5:
                    response1 = _state.sent();
                    return [
                        2,
                        response1.phoneResponseInfo.sessionInfo
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        $04f424e220a55f33$var$sendPhoneVerificationCode(auth, {
                            phoneNumber: phoneInfoOptions.phoneNumber,
                            recaptchaToken: recaptchaToken
                        })
                    ];
                case 8:
                    sessionInfo = _state.sent().sessionInfo;
                    return [
                        2,
                        sessionInfo
                    ];
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    verifier._reset();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__verifyPhoneNumber.apply(this, arguments);
}
function $04f424e220a55f33$export$3b14a55fb2447963(user, credential) {
    return $04f424e220a55f33$var$_updatePhoneNumber.apply(this, arguments);
}
function $04f424e220a55f33$var$_updatePhoneNumber() {
    $04f424e220a55f33$var$_updatePhoneNumber = /**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, credential) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04f424e220a55f33$var$_link$1((0, $cxgyp.getModularInstance)(user), credential)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_updatePhoneNumber.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ var $04f424e220a55f33$export$56c0d5a1e737357d = /*#__PURE__*/ function() {
    "use strict";
    function PhoneAuthProvider(auth) {
        (0, $50OuQ._)(this, PhoneAuthProvider);
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = PhoneAuthProvider.PROVIDER_ID;
        this.auth = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
    }
    (0, $fGdZr._)(PhoneAuthProvider, [
        {
            /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ key: "verifyPhoneNumber",
            value: function verifyPhoneNumber(phoneOptions, applicationVerifier) {
                return $04f424e220a55f33$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $cxgyp.getModularInstance)(applicationVerifier));
            }
        }
    ], [
        {
            key: "credential",
            value: /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ function credential(verificationId, verificationCode) {
                return $04f424e220a55f33$export$a07804094c3ecf2d._fromVerification(verificationId, verificationCode);
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                var credential = userCredential;
                return PhoneAuthProvider.credentialFromTaggedObject(credential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ function credentialFromError(error) {
                return PhoneAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var phoneNumber = tokenResponse.phoneNumber, temporaryProof = tokenResponse.temporaryProof;
                if (phoneNumber && temporaryProof) return $04f424e220a55f33$export$a07804094c3ecf2d._fromTokenResponse(phoneNumber, temporaryProof);
                return null;
            }
        }
    ]);
    return PhoneAuthProvider;
}();
/** Always set to {@link ProviderId}.PHONE. */ $04f424e220a55f33$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $04f424e220a55f33$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $04f424e220a55f33$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $04f424e220a55f33$export$24baa2b76016ce0e(resolverOverride);
    $04f424e220a55f33$export$9d398bebfec1c039(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$IdpCredential = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $1atwj._)(IdpCredential, AuthCredential);
    var _super = (0, $iD0Am._)(IdpCredential);
    function IdpCredential(params) {
        (0, $50OuQ._)(this, IdpCredential);
        var _this;
        _this = _super.call(this, "custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        _this.params = params;
        return _this;
    }
    (0, $fGdZr._)(IdpCredential, [
        {
            key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                return $04f424e220a55f33$var$signInWithIdp(auth, this._buildIdpRequest());
            }
        },
        {
            key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                return $04f424e220a55f33$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
            }
        },
        {
            key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return $04f424e220a55f33$var$signInWithIdp(auth, this._buildIdpRequest());
            }
        },
        {
            key: "_buildIdpRequest",
            value: function _buildIdpRequest(idToken) {
                var request = {
                    requestUri: this.params.requestUri,
                    sessionId: this.params.sessionId,
                    postBody: this.params.postBody,
                    tenantId: this.params.tenantId,
                    pendingToken: this.params.pendingToken,
                    returnSecureToken: true,
                    returnIdpCredential: true
                };
                if (idToken) request.idToken = idToken;
                return request;
            }
        }
    ]);
    return IdpCredential;
}($04f424e220a55f33$export$3466f893ebf79586);
function $04f424e220a55f33$var$_signIn(params) {
    return $04f424e220a55f33$var$_signInWithCredential(params.auth, new $04f424e220a55f33$var$IdpCredential(params), params.bypassAuthState);
}
function $04f424e220a55f33$var$_reauth(params) {
    var auth = params.auth, user = params.user;
    $04f424e220a55f33$export$9d398bebfec1c039(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $04f424e220a55f33$var$_reauthenticate(user, new $04f424e220a55f33$var$IdpCredential(params), params.bypassAuthState);
}
function $04f424e220a55f33$var$_link(params) {
    return $04f424e220a55f33$var$__link.apply(this, arguments);
}
function $04f424e220a55f33$var$__link() {
    $04f424e220a55f33$var$__link = (0, $5Pgs2._)(function(params) {
        var auth, user;
        return (0, $1XfpH.__generator)(this, function(_state) {
            auth = params.auth, user = params.user;
            $04f424e220a55f33$export$9d398bebfec1c039(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            return [
                2,
                $04f424e220a55f33$var$_link$1(user, new $04f424e220a55f33$var$IdpCredential(params), params.bypassAuthState)
            ];
        });
    });
    return $04f424e220a55f33$var$__link.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ var $04f424e220a55f33$var$AbstractPopupRedirectOperation = /*#__PURE__*/ function() {
    "use strict";
    function AbstractPopupRedirectOperation(auth, filter, resolver, user) {
        var bypassAuthState = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        (0, $50OuQ._)(this, AbstractPopupRedirectOperation);
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    (0, $fGdZr._)(AbstractPopupRedirectOperation, [
        {
            key: "execute",
            value: function execute() {
                var _this = this;
                return new Promise(function() {
                    var _ref = (0, $5Pgs2._)(function(resolve, reject) {
                        var e;
                        return (0, $1XfpH.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this.pendingPromise = {
                                        resolve: resolve,
                                        reject: reject
                                    };
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        4,
                                        ,
                                        5
                                    ]);
                                    return [
                                        4,
                                        _this.resolver._initialize(_this.auth)
                                    ];
                                case 2:
                                    _this.eventManager = _state.sent();
                                    return [
                                        4,
                                        _this.onExecution()
                                    ];
                                case 3:
                                    _state.sent();
                                    _this.eventManager.registerConsumer(_this);
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    e = _state.sent();
                                    _this.reject(e);
                                    return [
                                        3,
                                        5
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(resolve, reject) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "onAuthEvent",
            value: function onAuthEvent(event) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var urlResponse, sessionId, postBody, tenantId, error, type, params, _, e;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                urlResponse = event.urlResponse, sessionId = event.sessionId, postBody = event.postBody, tenantId = event.tenantId, error = event.error, type = event.type;
                                if (error) {
                                    _this.reject(error);
                                    return [
                                        2
                                    ];
                                }
                                params = {
                                    auth: _this.auth,
                                    requestUri: urlResponse,
                                    sessionId: sessionId,
                                    tenantId: tenantId || undefined,
                                    postBody: postBody || undefined,
                                    user: _this.user,
                                    bypassAuthState: _this.bypassAuthState
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _ = _this.resolve;
                                return [
                                    4,
                                    _this.getIdpTask(type)(params)
                                ];
                            case 2:
                                _.apply(_this, [
                                    _state.sent()
                                ]);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.reject(e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onError",
            value: function onError(error) {
                this.reject(error);
            }
        },
        {
            key: "getIdpTask",
            value: function getIdpTask(type) {
                switch(type){
                    case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
                    case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                        return $04f424e220a55f33$var$_signIn;
                    case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
                    case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                        return $04f424e220a55f33$var$_link;
                    case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
                    case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                        return $04f424e220a55f33$var$_reauth;
                    default:
                        $04f424e220a55f33$export$92108d983e8ee699(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                }
            }
        },
        {
            key: "resolve",
            value: function resolve(cred) {
                $04f424e220a55f33$export$493d36ec626b6698(this.pendingPromise, "Pending promise was never set");
                this.pendingPromise.resolve(cred);
                this.unregisterAndCleanUp();
            }
        },
        {
            key: "reject",
            value: function reject(error) {
                $04f424e220a55f33$export$493d36ec626b6698(this.pendingPromise, "Pending promise was never set");
                this.pendingPromise.reject(error);
                this.unregisterAndCleanUp();
            }
        },
        {
            key: "unregisterAndCleanUp",
            value: function unregisterAndCleanUp() {
                if (this.eventManager) this.eventManager.unregisterConsumer(this);
                this.pendingPromise = null;
                this.cleanUp();
            }
        }
    ]);
    return AbstractPopupRedirectOperation;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $04f424e220a55f33$var$Delay(2000, 10000);
function $04f424e220a55f33$export$db3b6bfb95261072(auth, provider, resolver) {
    return $04f424e220a55f33$var$_signInWithPopup.apply(this, arguments);
}
function $04f424e220a55f33$var$_signInWithPopup() {
    $04f424e220a55f33$var$_signInWithPopup = /**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, provider, resolver) {
        var authInternal, resolverInternal, action;
        return (0, $1XfpH.__generator)(this, function(_state) {
            authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
            $04f424e220a55f33$var$_assertInstanceOf(auth, provider, $04f424e220a55f33$var$FederatedAuthProvider);
            resolverInternal = $04f424e220a55f33$var$_withDefaultResolver(authInternal, resolver);
            action = new $04f424e220a55f33$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $04f424e220a55f33$var$_signInWithPopup.apply(this, arguments);
}
function $04f424e220a55f33$export$f1e1789686576879(user, provider, resolver) {
    return $04f424e220a55f33$var$_reauthenticateWithPopup.apply(this, arguments);
}
function $04f424e220a55f33$var$_reauthenticateWithPopup() {
    $04f424e220a55f33$var$_reauthenticateWithPopup = /**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, provider, resolver) {
        var userInternal, resolverInternal, action;
        return (0, $1XfpH.__generator)(this, function(_state) {
            userInternal = (0, $cxgyp.getModularInstance)(user);
            $04f424e220a55f33$var$_assertInstanceOf(userInternal.auth, provider, $04f424e220a55f33$var$FederatedAuthProvider);
            resolverInternal = $04f424e220a55f33$var$_withDefaultResolver(userInternal.auth, resolver);
            action = new $04f424e220a55f33$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $04f424e220a55f33$var$_reauthenticateWithPopup.apply(this, arguments);
}
function $04f424e220a55f33$export$4368d992c4eafac0(user, provider, resolver) {
    return $04f424e220a55f33$var$_linkWithPopup.apply(this, arguments);
}
function $04f424e220a55f33$var$_linkWithPopup() {
    $04f424e220a55f33$var$_linkWithPopup = /**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $5Pgs2._)(function(user, provider, resolver) {
        var userInternal, resolverInternal, action;
        return (0, $1XfpH.__generator)(this, function(_state) {
            userInternal = (0, $cxgyp.getModularInstance)(user);
            $04f424e220a55f33$var$_assertInstanceOf(userInternal.auth, provider, $04f424e220a55f33$var$FederatedAuthProvider);
            resolverInternal = $04f424e220a55f33$var$_withDefaultResolver(userInternal.auth, resolver);
            action = new $04f424e220a55f33$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $04f424e220a55f33$var$_linkWithPopup.apply(this, arguments);
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ var $04f424e220a55f33$var$PopupOperation = /*#__PURE__*/ function(AbstractPopupRedirectOperation) {
    "use strict";
    (0, $1atwj._)(PopupOperation, AbstractPopupRedirectOperation);
    var _super = (0, $iD0Am._)(PopupOperation);
    function PopupOperation(auth, filter, provider, resolver, user) {
        (0, $50OuQ._)(this, PopupOperation);
        var _this;
        _this = _super.call(this, auth, filter, resolver, user);
        _this.provider = provider;
        _this.authWindow = null;
        _this.pollId = null;
        if (PopupOperation.currentPopupAction) PopupOperation.currentPopupAction.cancel();
        PopupOperation.currentPopupAction = (0, $dMjkN._)(_this);
        return _this;
    }
    (0, $fGdZr._)(PopupOperation, [
        {
            key: "executeNotNull",
            value: function executeNotNull() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var result;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.execute()
                                ];
                            case 1:
                                result = _state.sent();
                                $04f424e220a55f33$export$9d398bebfec1c039(result, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onExecution",
            value: function onExecution() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var eventId;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $04f424e220a55f33$export$493d36ec626b6698(_this.filter.length === 1, "Popup operations only handle one event");
                                eventId = $04f424e220a55f33$export$9f4f30ee63539e24();
                                return [
                                    4,
                                    _this.resolver._openPopup(_this.auth, _this.provider, _this.filter[0], eventId)
                                ];
                            case 1:
                                _this.authWindow = _state.sent();
                                _this.authWindow.associatedEvent = eventId;
                                // Check for web storage support and origin validation _after_ the popup is
                                // loaded. These operations are slow (~1 second or so) Rather than
                                // waiting on them before opening the window, optimistically open the popup
                                // and check for storage support at the same time. If storage support is
                                // not available, this will cause the whole thing to reject properly. It
                                // will also close the popup, but since the promise has already rejected,
                                // the popup closed by user poll will reject into the void.
                                _this.resolver._originValidation(_this.auth)["catch"](function(e) {
                                    _this.reject(e);
                                });
                                _this.resolver._isIframeWebStorageSupported(_this.auth, function(isSupported) {
                                    if (!isSupported) _this.reject($04f424e220a55f33$export$91c6e00c14e7e6fd(_this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
                                });
                                // Handle user closure. Notice this does *not* use await
                                _this.pollUserCancellation();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "eventId",
            get: function get() {
                var _a;
                return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                this.reject($04f424e220a55f33$export$91c6e00c14e7e6fd(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
            }
        },
        {
            key: "cleanUp",
            value: function cleanUp() {
                if (this.authWindow) this.authWindow.close();
                if (this.pollId) window.clearTimeout(this.pollId);
                this.authWindow = null;
                this.pollId = null;
                PopupOperation.currentPopupAction = null;
            }
        },
        {
            key: "pollUserCancellation",
            value: function pollUserCancellation() {
                var _this = this;
                var poll = function() {
                    var _a, _b;
                    if ((_b = (_a = _this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                        // Make sure that there is sufficient time for whatever action to
                        // complete. The window could have closed but the sign in network
                        // call could still be in flight. This is specifically true for
                        // Firefox or if the opener is in an iframe, in which case the oauth
                        // helper closes the popup.
                        _this.pollId = window.setTimeout(function() {
                            _this.pollId = null;
                            _this.reject($04f424e220a55f33$export$91c6e00c14e7e6fd(_this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                        }, 8000 /* _Timeout.AUTH_EVENT */ );
                        return;
                    }
                    _this.pollId = window.setTimeout(poll, $04f424e220a55f33$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
                };
                poll();
            }
        }
    ]);
    return PopupOperation;
}($04f424e220a55f33$var$AbstractPopupRedirectOperation);
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$04f424e220a55f33$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
var $04f424e220a55f33$var$redirectOutcomeMap = new Map();
var $04f424e220a55f33$var$RedirectAction = /*#__PURE__*/ function(AbstractPopupRedirectOperation) {
    "use strict";
    (0, $1atwj._)(RedirectAction, AbstractPopupRedirectOperation);
    var _super = (0, $iD0Am._)(RedirectAction);
    function RedirectAction(auth, resolver) {
        var bypassAuthState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        (0, $50OuQ._)(this, RedirectAction);
        var _this;
        _this = _super.call(this, auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        _this.eventId = null;
        return _this;
    }
    (0, $fGdZr._)(RedirectAction, [
        {
            key: "execute",
            value: /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ function execute() {
                var _this = this;
                var _this1 = this, _superprop_get_execute = function() {
                    return (0, $ats3c._)((0, $bykok._)(RedirectAction.prototype), "execute", _this);
                };
                return (0, $5Pgs2._)(function() {
                    var readyOutcome, hasPendingRedirect, result, _tmp, e;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                readyOutcome = $04f424e220a55f33$var$redirectOutcomeMap.get(_this1.auth._key());
                                if (!!readyOutcome) return [
                                    3,
                                    8
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    $04f424e220a55f33$var$_getAndClearPendingRedirectStatus(_this1.resolver, _this1.auth)
                                ];
                            case 2:
                                hasPendingRedirect = _state.sent();
                                if (!hasPendingRedirect) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _superprop_get_execute().call(_this1)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp = null;
                                _state.label = 5;
                            case 5:
                                result = _tmp;
                                readyOutcome = function() {
                                    return Promise.resolve(result);
                                };
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                readyOutcome = function() {
                                    return Promise.reject(e);
                                };
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                $04f424e220a55f33$var$redirectOutcomeMap.set(_this1.auth._key(), readyOutcome);
                                _state.label = 8;
                            case 8:
                                // If we're not bypassing auth state, the ready outcome should be set to
                                // null.
                                if (!_this1.bypassAuthState) $04f424e220a55f33$var$redirectOutcomeMap.set(_this1.auth._key(), function() {
                                    return Promise.resolve(null);
                                });
                                return [
                                    2,
                                    readyOutcome()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onAuthEvent",
            value: function onAuthEvent(event) {
                var _this = this;
                var _this1 = this, _superprop_get_onAuthEvent = function() {
                    return (0, $ats3c._)((0, $bykok._)(RedirectAction.prototype), "onAuthEvent", _this);
                };
                return (0, $5Pgs2._)(function() {
                    var user;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return [
                                    2,
                                    _superprop_get_onAuthEvent().call(_this1, event)
                                ];
                                else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
                                    // This is a sentinel value indicating there's no pending redirect
                                    _this1.resolve(null);
                                    return [
                                        2
                                    ];
                                }
                                if (!event.eventId) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this1.auth._redirectUserForId(event.eventId)
                                ];
                            case 1:
                                user = _state.sent();
                                if (user) {
                                    _this1.user = user;
                                    return [
                                        2,
                                        _superprop_get_onAuthEvent().call(_this1, event)
                                    ];
                                } else _this1.resolve(null);
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onExecution",
            value: function onExecution() {
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "cleanUp",
            value: function cleanUp() {}
        }
    ]);
    return RedirectAction;
}($04f424e220a55f33$var$AbstractPopupRedirectOperation);
function $04f424e220a55f33$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    return $04f424e220a55f33$var$__getAndClearPendingRedirectStatus.apply(this, arguments);
}
function $04f424e220a55f33$var$__getAndClearPendingRedirectStatus() {
    $04f424e220a55f33$var$__getAndClearPendingRedirectStatus = (0, $5Pgs2._)(function(resolver, auth) {
        var key, persistence, hasPendingRedirect;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = $04f424e220a55f33$var$pendingRedirectKey(auth);
                    persistence = $04f424e220a55f33$var$resolverPersistence(resolver);
                    return [
                        4,
                        persistence._isAvailable()
                    ];
                case 1:
                    if (!_state.sent()) return [
                        2,
                        false
                    ];
                    return [
                        4,
                        persistence._get(key)
                    ];
                case 2:
                    hasPendingRedirect = _state.sent() === "true";
                    return [
                        4,
                        persistence._remove(key)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        hasPendingRedirect
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__getAndClearPendingRedirectStatus.apply(this, arguments);
}
function $04f424e220a55f33$var$_setPendingRedirectStatus(resolver, auth) {
    return $04f424e220a55f33$var$__setPendingRedirectStatus.apply(this, arguments);
}
function $04f424e220a55f33$var$__setPendingRedirectStatus() {
    $04f424e220a55f33$var$__setPendingRedirectStatus = (0, $5Pgs2._)(function(resolver, auth) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $04f424e220a55f33$var$resolverPersistence(resolver)._set($04f424e220a55f33$var$pendingRedirectKey(auth), "true")
            ];
        });
    });
    return $04f424e220a55f33$var$__setPendingRedirectStatus.apply(this, arguments);
}
function $04f424e220a55f33$export$a33b77bbdbb8366c() {
    $04f424e220a55f33$var$redirectOutcomeMap.clear();
}
function $04f424e220a55f33$export$53a70dd1ebbae346(auth, result) {
    $04f424e220a55f33$var$redirectOutcomeMap.set(auth._key(), result);
}
function $04f424e220a55f33$var$resolverPersistence(resolver) {
    return $04f424e220a55f33$export$24baa2b76016ce0e(resolver._redirectPersistence);
}
function $04f424e220a55f33$var$pendingRedirectKey(auth) {
    return $04f424e220a55f33$export$158acd800e1ef08b($04f424e220a55f33$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $04f424e220a55f33$export$2d1720544b23b823(auth, provider, resolver) {
    return $04f424e220a55f33$var$_signInWithRedirect(auth, provider, resolver);
}
function $04f424e220a55f33$var$_signInWithRedirect(auth, provider, resolver) {
    return $04f424e220a55f33$var$__signInWithRedirect.apply(this, arguments);
}
function $04f424e220a55f33$var$__signInWithRedirect() {
    $04f424e220a55f33$var$__signInWithRedirect = (0, $5Pgs2._)(function(auth, provider, resolver) {
        var authInternal, resolverInternal;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
                    $04f424e220a55f33$var$_assertInstanceOf(auth, provider, $04f424e220a55f33$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        authInternal._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    resolverInternal = $04f424e220a55f33$var$_withDefaultResolver(authInternal, resolver);
                    return [
                        4,
                        $04f424e220a55f33$var$_setPendingRedirectStatus(resolverInternal, authInternal)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ )
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__signInWithRedirect.apply(this, arguments);
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $04f424e220a55f33$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $04f424e220a55f33$var$_reauthenticateWithRedirect(user, provider, resolver);
}
function $04f424e220a55f33$var$_reauthenticateWithRedirect(user, provider, resolver) {
    return $04f424e220a55f33$var$__reauthenticateWithRedirect.apply(this, arguments);
}
function $04f424e220a55f33$var$__reauthenticateWithRedirect() {
    $04f424e220a55f33$var$__reauthenticateWithRedirect = (0, $5Pgs2._)(function(user, provider, resolver) {
        var userInternal, resolverInternal, eventId;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    $04f424e220a55f33$var$_assertInstanceOf(userInternal.auth, provider, $04f424e220a55f33$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        userInternal.auth._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    resolverInternal = $04f424e220a55f33$var$_withDefaultResolver(userInternal.auth, resolver);
                    return [
                        4,
                        $04f424e220a55f33$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        $04f424e220a55f33$var$prepareUserForRedirect(userInternal)
                    ];
                case 3:
                    eventId = _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId)
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__reauthenticateWithRedirect.apply(this, arguments);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $04f424e220a55f33$export$39b482c5e57630a8(user, provider, resolver) {
    return $04f424e220a55f33$var$_linkWithRedirect(user, provider, resolver);
}
function $04f424e220a55f33$var$_linkWithRedirect(user, provider, resolver) {
    return $04f424e220a55f33$var$__linkWithRedirect.apply(this, arguments);
}
function $04f424e220a55f33$var$__linkWithRedirect() {
    $04f424e220a55f33$var$__linkWithRedirect = (0, $5Pgs2._)(function(user, provider, resolver) {
        var userInternal, resolverInternal, eventId;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $cxgyp.getModularInstance)(user);
                    $04f424e220a55f33$var$_assertInstanceOf(userInternal.auth, provider, $04f424e220a55f33$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        userInternal.auth._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    resolverInternal = $04f424e220a55f33$var$_withDefaultResolver(userInternal.auth, resolver);
                    return [
                        4,
                        $04f424e220a55f33$var$_assertLinkedStatus(false, userInternal, provider.providerId)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        $04f424e220a55f33$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        $04f424e220a55f33$var$prepareUserForRedirect(userInternal)
                    ];
                case 4:
                    eventId = _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId)
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__linkWithRedirect.apply(this, arguments);
}
function $04f424e220a55f33$export$35e795649ee09318(auth, resolver) {
    return $04f424e220a55f33$var$_getRedirectResult.apply(this, arguments);
}
function $04f424e220a55f33$var$_getRedirectResult() {
    $04f424e220a55f33$var$_getRedirectResult = /**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $5Pgs2._)(function(auth, resolver) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04f424e220a55f33$export$b9a6b53f9be3734(auth)._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        $04f424e220a55f33$export$cf2f7c5792f80b46(auth, resolver, false)
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_getRedirectResult.apply(this, arguments);
}
function $04f424e220a55f33$export$cf2f7c5792f80b46(auth, resolverExtern) {
    return $04f424e220a55f33$var$__getRedirectResult.apply(this, arguments);
}
function $04f424e220a55f33$var$__getRedirectResult() {
    $04f424e220a55f33$var$__getRedirectResult = (0, $5Pgs2._)(function(auth, resolverExtern) {
        var bypassAuthState, authInternal, resolver, action, result;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    authInternal = $04f424e220a55f33$export$b9a6b53f9be3734(auth);
                    resolver = $04f424e220a55f33$var$_withDefaultResolver(authInternal, resolverExtern);
                    action = new $04f424e220a55f33$var$RedirectAction(authInternal, resolver, bypassAuthState);
                    return [
                        4,
                        action.execute()
                    ];
                case 1:
                    result = _state.sent();
                    if (!(result && !bypassAuthState)) return [
                        3,
                        4
                    ];
                    delete result.user._redirectEventId;
                    return [
                        4,
                        authInternal._persistUserIfCurrent(result.user)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        authInternal._setRedirectUser(null, resolverExtern)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__getRedirectResult.apply(this, arguments);
}
function $04f424e220a55f33$var$prepareUserForRedirect(user) {
    return $04f424e220a55f33$var$_prepareUserForRedirect.apply(this, arguments);
}
function $04f424e220a55f33$var$_prepareUserForRedirect() {
    $04f424e220a55f33$var$_prepareUserForRedirect = (0, $5Pgs2._)(function(user) {
        var eventId;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    eventId = $04f424e220a55f33$export$9f4f30ee63539e24("".concat(user.uid, ":::"));
                    user._redirectEventId = eventId;
                    return [
                        4,
                        user.auth._setRedirectUser(user)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        user.auth._persistUserIfCurrent(user)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        eventId
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$_prepareUserForRedirect.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
var $04f424e220a55f33$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
var $04f424e220a55f33$export$890c4ad488842ce7 = /*#__PURE__*/ function() {
    "use strict";
    function AuthEventManager(auth) {
        (0, $50OuQ._)(this, AuthEventManager);
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    (0, $fGdZr._)(AuthEventManager, [
        {
            key: "registerConsumer",
            value: function registerConsumer(authEventConsumer) {
                this.consumers.add(authEventConsumer);
                if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
                    this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
                    this.saveEventToCache(this.queuedRedirectEvent);
                    this.queuedRedirectEvent = null;
                }
            }
        },
        {
            key: "unregisterConsumer",
            value: function unregisterConsumer(authEventConsumer) {
                this.consumers["delete"](authEventConsumer);
            }
        },
        {
            key: "onEvent",
            value: function onEvent(event) {
                var _this = this;
                // Check if the event has already been handled
                if (this.hasEventBeenHandled(event)) return false;
                var handled = false;
                this.consumers.forEach(function(consumer) {
                    if (_this.isEventForConsumer(event, consumer)) {
                        handled = true;
                        _this.sendToConsumer(event, consumer);
                        _this.saveEventToCache(event);
                    }
                });
                if (this.hasHandledPotentialRedirect || !$04f424e220a55f33$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
                // bail now
                return handled;
                this.hasHandledPotentialRedirect = true;
                // If the redirect wasn't handled, hang on to it
                if (!handled) {
                    this.queuedRedirectEvent = event;
                    handled = true;
                }
                return handled;
            }
        },
        {
            key: "sendToConsumer",
            value: function sendToConsumer(event, consumer) {
                var _a;
                if (event.error && !$04f424e220a55f33$var$isNullRedirectEvent(event)) {
                    var code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
                    consumer.onError($04f424e220a55f33$export$91c6e00c14e7e6fd(this.auth, code));
                } else consumer.onAuthEvent(event);
            }
        },
        {
            key: "isEventForConsumer",
            value: function isEventForConsumer(event, consumer) {
                var eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
                return consumer.filter.includes(event.type) && eventIdMatches;
            }
        },
        {
            key: "hasEventBeenHandled",
            value: function hasEventBeenHandled(event) {
                if (Date.now() - this.lastProcessedEventTime >= $04f424e220a55f33$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
                return this.cachedEventUids.has($04f424e220a55f33$var$eventUid(event));
            }
        },
        {
            key: "saveEventToCache",
            value: function saveEventToCache(event) {
                this.cachedEventUids.add($04f424e220a55f33$var$eventUid(event));
                this.lastProcessedEventTime = Date.now();
            }
        }
    ]);
    return AuthEventManager;
}();
function $04f424e220a55f33$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter(function(v) {
        return v;
    }).join("-");
}
function $04f424e220a55f33$var$isNullRedirectEvent(param) {
    var type = param.type, error = param.error;
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === "auth/no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ;
}
function $04f424e220a55f33$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $04f424e220a55f33$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
function $04f424e220a55f33$export$28f7fcd39efa255(auth) {
    return $04f424e220a55f33$var$__getProjectConfig.apply(this, arguments);
}
function $04f424e220a55f33$var$__getProjectConfig() {
    $04f424e220a55f33$var$__getProjectConfig = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5Pgs2._)(function(auth) {
        var request;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            request = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            return [
                2,
                $04f424e220a55f33$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request)
            ];
        });
    });
    return $04f424e220a55f33$var$__getProjectConfig.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
var $04f424e220a55f33$var$HTTP_REGEX = /^https?/;
function $04f424e220a55f33$var$_validateOrigin(auth) {
    return $04f424e220a55f33$var$__validateOrigin.apply(this, arguments);
}
function $04f424e220a55f33$var$__validateOrigin() {
    $04f424e220a55f33$var$__validateOrigin = (0, $5Pgs2._)(function(auth) {
        var authorizedDomains, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, domain;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Skip origin validation if we are in an emulated environment
                    if (auth.config.emulator) return [
                        2
                    ];
                    return [
                        4,
                        $04f424e220a55f33$export$28f7fcd39efa255(auth)
                    ];
                case 1:
                    authorizedDomains = _state.sent().authorizedDomains;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = authorizedDomains[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            domain = _step.value;
                            try {
                                if ($04f424e220a55f33$var$matchDomain(domain)) return [
                                    2
                                ];
                            } catch (_a) {
                            // Do nothing if there's a URL error; just continue searching
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // In the old SDK, this error also provides helpful messages.
                    $04f424e220a55f33$export$92108d983e8ee699(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
                    return [
                        2
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__validateOrigin.apply(this, arguments);
}
function $04f424e220a55f33$var$matchDomain(expected) {
    var currentUrl = $04f424e220a55f33$var$_getCurrentUrl();
    var _ref = new URL(currentUrl), protocol = _ref.protocol, hostname = _ref.hostname;
    if (expected.startsWith("chrome-extension://")) {
        var ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$04f424e220a55f33$var$HTTP_REGEX.test(protocol)) return false;
    if ($04f424e220a55f33$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    var escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    var re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$NETWORK_TIMEOUT = new $04f424e220a55f33$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $04f424e220a55f33$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    var beacon = $04f424e220a55f33$var$_window().___jsl;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) try {
        // Get gapi hint.
        for(var _iterator = Object.keys(beacon.H)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var hint = _step.value;
            // Requested modules.
            beacon.H[hint].r = beacon.H[hint].r || [];
            // Loaded modules.
            beacon.H[hint].L = beacon.H[hint].L || [];
            // Set requested modules to a copy of the loaded modules.
            beacon.H[hint].r = (0, $dHvbf._)(beacon.H[hint].L);
            // Clear pending callbacks.
            if (beacon.CP) for(var i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
            beacon.CP[i] = null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $04f424e220a55f33$var$loadGapi(auth) {
    return new Promise(function(resolve, reject) {
        var loadGapiIframe = // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $04f424e220a55f33$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: function() {
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: function() {
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $04f424e220a55f33$var$resetUnloadedGapiModules();
                    reject($04f424e220a55f33$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $04f424e220a55f33$var$NETWORK_TIMEOUT.get()
            });
        };
        var _a, _b, _c;
        if ((_b = (_a = $04f424e220a55f33$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $04f424e220a55f33$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            var cbName = $04f424e220a55f33$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $04f424e220a55f33$var$_window()[cbName] = function() {
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($04f424e220a55f33$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $04f424e220a55f33$var$_loadJS("https://apis.google.com/js/api.js?onload=".concat(cbName))["catch"](function(e) {
                return reject(e);
            });
        }
    })["catch"](function(error) {
        // Reset cached promise to allow for retrial.
        $04f424e220a55f33$var$cachedGApiLoader = null;
        throw error;
    });
}
var $04f424e220a55f33$var$cachedGApiLoader = null;
function $04f424e220a55f33$var$_loadGapi(auth) {
    $04f424e220a55f33$var$cachedGApiLoader = $04f424e220a55f33$var$cachedGApiLoader || $04f424e220a55f33$var$loadGapi(auth);
    return $04f424e220a55f33$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$PING_TIMEOUT = new $04f424e220a55f33$var$Delay(5000, 15000);
var $04f424e220a55f33$var$IFRAME_PATH = "__/auth/iframe";
var $04f424e220a55f33$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
var $04f424e220a55f33$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
var $04f424e220a55f33$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $04f424e220a55f33$var$getIframeUrl(auth) {
    var config = auth.config;
    $04f424e220a55f33$export$9d398bebfec1c039(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    var url = config.emulator ? $04f424e220a55f33$var$_emulatorUrl(config, $04f424e220a55f33$var$EMULATED_IFRAME_PATH) : "https://".concat(auth.config.authDomain, "/").concat($04f424e220a55f33$var$IFRAME_PATH);
    var params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $2Ldjj.SDK_VERSION)
    };
    var eid = $04f424e220a55f33$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    var frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return "".concat(url, "?").concat((0, $cxgyp.querystring)(params).slice(1));
}
function $04f424e220a55f33$var$_openIframe(auth) {
    return $04f424e220a55f33$var$__openIframe.apply(this, arguments);
}
function $04f424e220a55f33$var$__openIframe() {
    $04f424e220a55f33$var$__openIframe = (0, $5Pgs2._)(function(auth) {
        var context, gapi1;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $04f424e220a55f33$var$_loadGapi(auth)
                    ];
                case 1:
                    context = _state.sent();
                    gapi1 = $04f424e220a55f33$var$_window().gapi;
                    $04f424e220a55f33$export$9d398bebfec1c039(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return [
                        2,
                        context.open({
                            where: document.body,
                            url: $04f424e220a55f33$var$getIframeUrl(auth),
                            messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
                            attributes: $04f424e220a55f33$var$IFRAME_ATTRIBUTES,
                            dontclear: true
                        }, function(iframe) {
                            return new Promise(function() {
                                var _ref = (0, $5Pgs2._)(function(resolve, reject) {
                                    var networkError, networkErrorTimer;
                                    // Clear timer and resolve pending iframe ready promise.
                                    function clearTimerAndResolve() {
                                        $04f424e220a55f33$var$_window().clearTimeout(networkErrorTimer);
                                        resolve(iframe);
                                    }
                                    return (0, $1XfpH.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    iframe.restyle({
                                                        // Prevent iframe from closing on mouse out.
                                                        setHideOnLeave: false
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                networkError = $04f424e220a55f33$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
                                                networkErrorTimer = $04f424e220a55f33$var$_window().setTimeout(function() {
                                                    reject(networkError);
                                                }, $04f424e220a55f33$var$PING_TIMEOUT.get());
                                                // This returns an IThenable. However the reject part does not call
                                                // when the iframe is not loaded.
                                                iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, function() {
                                                    reject(networkError);
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(resolve, reject) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        })
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__openIframe.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
var $04f424e220a55f33$var$DEFAULT_WIDTH = 500;
var $04f424e220a55f33$var$DEFAULT_HEIGHT = 600;
var $04f424e220a55f33$var$TARGET_BLANK = "_blank";
var $04f424e220a55f33$var$FIREFOX_EMPTY_URL = "http://localhost";
var $04f424e220a55f33$export$faec65b429be379 = /*#__PURE__*/ function() {
    "use strict";
    function AuthPopup(window1) {
        (0, $50OuQ._)(this, AuthPopup);
        this.window = window1;
        this.associatedEvent = null;
    }
    (0, $fGdZr._)(AuthPopup, [
        {
            key: "close",
            value: function close() {
                if (this.window) try {
                    this.window.close();
                } catch (e) {}
            }
        }
    ]);
    return AuthPopup;
}();
function $04f424e220a55f33$var$_open(auth, url, name) {
    var width = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $04f424e220a55f33$var$DEFAULT_WIDTH, height = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $04f424e220a55f33$var$DEFAULT_HEIGHT;
    var top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    var left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    var target = "";
    var options = Object.assign(Object.assign({}, $04f424e220a55f33$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    var ua = (0, $cxgyp.getUA)().toLowerCase();
    if (name) target = $04f424e220a55f33$var$_isChromeIOS(ua) ? $04f424e220a55f33$var$TARGET_BLANK : name;
    if ($04f424e220a55f33$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $04f424e220a55f33$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    var optionsString = Object.entries(options).reduce(function(accum, param) {
        var _param = (0, $aSMts._)(param, 2), key = _param[0], value = _param[1];
        return "".concat(accum).concat(key, "=").concat(value, ",");
    }, "");
    if ($04f424e220a55f33$var$_isIOSStandalone(ua) && target !== "_self") {
        $04f424e220a55f33$var$openAsNewWindowIOS(url || "", target);
        return new $04f424e220a55f33$export$faec65b429be379(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    var newWin = window.open(url || "", target, optionsString);
    $04f424e220a55f33$export$9d398bebfec1c039(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $04f424e220a55f33$export$faec65b429be379(newWin);
}
function $04f424e220a55f33$var$openAsNewWindowIOS(url, target) {
    var el = document.createElement("a");
    el.href = url;
    el.target = target;
    var click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ var $04f424e220a55f33$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ var $04f424e220a55f33$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ var $04f424e220a55f33$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
function $04f424e220a55f33$export$9fa96a7d116ea3ce(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    return $04f424e220a55f33$var$__getRedirectUrl.apply(this, arguments);
}
function $04f424e220a55f33$var$__getRedirectUrl() {
    $04f424e220a55f33$var$__getRedirectUrl = (0, $5Pgs2._)(function(auth, provider, authType, redirectUrl, eventId, additionalParams) {
        var params, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value, scopes, paramsDict, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key1, appCheckToken, appCheckTokenFragment;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $04f424e220a55f33$export$9d398bebfec1c039(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
                    $04f424e220a55f33$export$9d398bebfec1c039(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
                    params = {
                        apiKey: auth.config.apiKey,
                        appName: auth.name,
                        authType: authType,
                        redirectUrl: redirectUrl,
                        v: (0, $2Ldjj.SDK_VERSION),
                        eventId: eventId
                    };
                    if (provider instanceof $04f424e220a55f33$var$FederatedAuthProvider) {
                        provider.setDefaultLanguage(auth.languageCode);
                        params.providerId = provider.providerId || "";
                        if (!(0, $cxgyp.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // TODO set additionalParams from the provider as well?
                            for(_iterator = Object.entries(additionalParams || {})[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                params[key] = value;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    if (provider instanceof $04f424e220a55f33$var$BaseOAuthProvider) {
                        scopes = provider.getScopes().filter(function(scope) {
                            return scope !== "";
                        });
                        if (scopes.length > 0) params.scopes = scopes.join(",");
                    }
                    if (auth.tenantId) params.tid = auth.tenantId;
                    paramsDict = params;
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = Object.keys(paramsDict)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            key1 = _step1.value;
                            if (paramsDict[key1] === undefined) delete paramsDict[key1];
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return [
                        4,
                        auth._getAppCheckToken()
                    ];
                case 1:
                    appCheckToken = _state.sent();
                    appCheckTokenFragment = appCheckToken ? "#".concat($04f424e220a55f33$var$FIREBASE_APP_CHECK_FRAGMENT_ID, "=").concat(encodeURIComponent(appCheckToken)) : "";
                    // Start at index 1 to skip the leading '&' in the query string
                    return [
                        2,
                        "".concat($04f424e220a55f33$var$getHandlerBase(auth), "?").concat((0, $cxgyp.querystring)(paramsDict).slice(1)).concat(appCheckTokenFragment)
                    ];
            }
        });
    });
    return $04f424e220a55f33$var$__getRedirectUrl.apply(this, arguments);
}
function $04f424e220a55f33$var$getHandlerBase(param) {
    var config = param.config;
    if (!config.emulator) return "https://".concat(config.authDomain, "/").concat($04f424e220a55f33$var$WIDGET_PATH);
    return $04f424e220a55f33$var$_emulatorUrl(config, $04f424e220a55f33$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ var $04f424e220a55f33$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
var $04f424e220a55f33$var$BrowserPopupRedirectResolver = /*#__PURE__*/ function() {
    "use strict";
    function BrowserPopupRedirectResolver() {
        (0, $50OuQ._)(this, BrowserPopupRedirectResolver);
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $04f424e220a55f33$export$407448d2b89b1813;
        this._completeRedirectFn = $04f424e220a55f33$export$cf2f7c5792f80b46;
        this._overrideRedirectResult = $04f424e220a55f33$export$53a70dd1ebbae346;
    }
    (0, $fGdZr._)(BrowserPopupRedirectResolver, [
        {
            key: "_openPopup",
            value: // Wrapping in async even though we don't await anywhere in order
            // to make sure errors are raised as promise rejections
            function _openPopup(auth, provider, authType, eventId) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, url;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $04f424e220a55f33$export$493d36ec626b6698((_a = _this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
                                return [
                                    4,
                                    $04f424e220a55f33$export$9fa96a7d116ea3ce(auth, provider, authType, $04f424e220a55f33$var$_getCurrentUrl(), eventId)
                                ];
                            case 1:
                                url = _state.sent();
                                return [
                                    2,
                                    $04f424e220a55f33$var$_open(auth, url, $04f424e220a55f33$export$9f4f30ee63539e24())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_openRedirect",
            value: function _openRedirect(auth, provider, authType, eventId) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var url;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._originValidation(auth)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    $04f424e220a55f33$export$9fa96a7d116ea3ce(auth, provider, authType, $04f424e220a55f33$var$_getCurrentUrl(), eventId)
                                ];
                            case 2:
                                url = _state.sent();
                                $04f424e220a55f33$var$_setWindowLocation(url);
                                return [
                                    2,
                                    new Promise(function() {})
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_initialize",
            value: function _initialize(auth) {
                var _this = this;
                var key = auth._key();
                if (this.eventManagers[key]) {
                    var _this_eventManagers_key = this.eventManagers[key], manager = _this_eventManagers_key.manager, promise = _this_eventManagers_key.promise;
                    if (manager) return Promise.resolve(manager);
                    else {
                        $04f424e220a55f33$export$493d36ec626b6698(promise, "If manager is not set, promise should be");
                        return promise;
                    }
                }
                var promise1 = this.initAndGetManager(auth);
                this.eventManagers[key] = {
                    promise: promise1
                };
                // If the promise is rejected, the key should be removed so that the
                // operation can be retried later.
                promise1["catch"](function() {
                    delete _this.eventManagers[key];
                });
                return promise1;
            }
        },
        {
            key: "initAndGetManager",
            value: function initAndGetManager(auth) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var iframe, manager;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $04f424e220a55f33$var$_openIframe(auth)
                                ];
                            case 1:
                                iframe = _state.sent();
                                manager = new $04f424e220a55f33$export$890c4ad488842ce7(auth);
                                iframe.register("authEvent", function(iframeEvent) {
                                    $04f424e220a55f33$export$9d398bebfec1c039(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
                                    // TODO: Consider splitting redirect and popup events earlier on
                                    var handled = manager.onEvent(iframeEvent.authEvent);
                                    return {
                                        status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
                                    };
                                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
                                _this.eventManagers[auth._key()] = {
                                    manager: manager
                                };
                                _this.iframes[auth._key()] = iframe;
                                return [
                                    2,
                                    manager
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_isIframeWebStorageSupported",
            value: function _isIframeWebStorageSupported(auth, cb) {
                var iframe = this.iframes[auth._key()];
                iframe.send($04f424e220a55f33$var$WEB_STORAGE_SUPPORT_KEY, {
                    type: $04f424e220a55f33$var$WEB_STORAGE_SUPPORT_KEY
                }, function(result) {
                    var _a;
                    var isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$04f424e220a55f33$var$WEB_STORAGE_SUPPORT_KEY];
                    if (isSupported !== undefined) cb(!!isSupported);
                    $04f424e220a55f33$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
            }
        },
        {
            key: "_originValidation",
            value: function _originValidation(auth) {
                var key = auth._key();
                if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $04f424e220a55f33$var$_validateOrigin(auth);
                return this.originValidationPromises[key];
            }
        },
        {
            key: "_shouldInitProactively",
            get: function get() {
                // Mobile browsers and Safari need to optimistically initialize
                return $04f424e220a55f33$var$_isMobileBrowser() || $04f424e220a55f33$var$_isSafari() || $04f424e220a55f33$export$1fbe638ecf81657e();
            }
        }
    ]);
    return BrowserPopupRedirectResolver;
}();
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ var $04f424e220a55f33$export$342063e11d6c3cad = $04f424e220a55f33$var$BrowserPopupRedirectResolver;
var $04f424e220a55f33$var$MultiFactorAssertionImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorAssertionImpl(factorId) {
        (0, $50OuQ._)(this, MultiFactorAssertionImpl);
        this.factorId = factorId;
    }
    (0, $fGdZr._)(MultiFactorAssertionImpl, [
        {
            key: "_process",
            value: function _process(auth, session, displayName) {
                switch(session.type){
                    case "enroll" /* MultiFactorSessionType.ENROLL */ :
                        return this._finalizeEnroll(auth, session.credential, displayName);
                    case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                        return this._finalizeSignIn(auth, session.credential);
                    default:
                        return $04f424e220a55f33$var$debugFail("unexpected MultiFactorSessionType");
                }
            }
        }
    ]);
    return MultiFactorAssertionImpl;
}();
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ var $04f424e220a55f33$var$PhoneMultiFactorAssertionImpl = /*#__PURE__*/ function(MultiFactorAssertionImpl) {
    "use strict";
    (0, $1atwj._)(PhoneMultiFactorAssertionImpl, MultiFactorAssertionImpl);
    var _super = (0, $iD0Am._)(PhoneMultiFactorAssertionImpl);
    function PhoneMultiFactorAssertionImpl(credential) {
        (0, $50OuQ._)(this, PhoneMultiFactorAssertionImpl);
        var _this;
        _this = _super.call(this, "phone" /* FactorId.PHONE */ );
        _this.credential = credential;
        return _this;
    }
    (0, $fGdZr._)(PhoneMultiFactorAssertionImpl, [
        {
            /** @internal */ key: "_finalizeEnroll",
            value: function _finalizeEnroll(auth, idToken, displayName) {
                return $04f424e220a55f33$var$finalizeEnrollPhoneMfa(auth, {
                    idToken: idToken,
                    displayName: displayName,
                    phoneVerificationInfo: this.credential._makeVerificationRequest()
                });
            }
        },
        {
            /** @internal */ key: "_finalizeSignIn",
            value: function _finalizeSignIn(auth, mfaPendingCredential) {
                return $04f424e220a55f33$var$finalizeSignInPhoneMfa(auth, {
                    mfaPendingCredential: mfaPendingCredential,
                    phoneVerificationInfo: this.credential._makeVerificationRequest()
                });
            }
        }
    ], [
        {
            key: "_fromCredential",
            value: /** @internal */ function _fromCredential(credential) {
                return new PhoneMultiFactorAssertionImpl(credential);
            }
        }
    ]);
    return PhoneMultiFactorAssertionImpl;
}($04f424e220a55f33$var$MultiFactorAssertionImpl);
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ var $04f424e220a55f33$export$953cecd6e717a553 = /*#__PURE__*/ function() {
    "use strict";
    function PhoneMultiFactorGenerator() {
        (0, $50OuQ._)(this, PhoneMultiFactorGenerator);
    }
    (0, $fGdZr._)(PhoneMultiFactorGenerator, null, [
        {
            key: "assertion",
            value: /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ function assertion(credential) {
                return $04f424e220a55f33$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
            }
        }
    ]);
    return PhoneMultiFactorGenerator;
}();
/**
 * The identifier of the phone second factor: `phone`.
 */ $04f424e220a55f33$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ var $04f424e220a55f33$export$971d5caa766a69d7 = /*#__PURE__*/ function() {
    "use strict";
    function TotpMultiFactorGenerator() {
        (0, $50OuQ._)(this, TotpMultiFactorGenerator);
    }
    (0, $fGdZr._)(TotpMultiFactorGenerator, null, [
        {
            key: "assertionForEnrollment",
            value: /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ function assertionForEnrollment(secret, oneTimePassword) {
                return $04f424e220a55f33$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
            }
        },
        {
            key: "assertionForSignIn",
            value: /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ function assertionForSignIn(enrollmentId, oneTimePassword) {
                return $04f424e220a55f33$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
            }
        },
        {
            key: "generateSecret",
            value: /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ function generateSecret(session) {
                return (0, $5Pgs2._)(function() {
                    var _a, mfaSession, response;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mfaSession = session;
                                $04f424e220a55f33$export$9d398bebfec1c039(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    4,
                                    $04f424e220a55f33$var$startEnrollTotpMfa(mfaSession.user.auth, {
                                        idToken: mfaSession.credential,
                                        totpEnrollmentInfo: {}
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    $04f424e220a55f33$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TotpMultiFactorGenerator;
}();
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $04f424e220a55f33$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
var $04f424e220a55f33$var$TotpMultiFactorAssertionImpl = /*#__PURE__*/ function(MultiFactorAssertionImpl) {
    "use strict";
    (0, $1atwj._)(TotpMultiFactorAssertionImpl, MultiFactorAssertionImpl);
    var _super = (0, $iD0Am._)(TotpMultiFactorAssertionImpl);
    function TotpMultiFactorAssertionImpl(otp, enrollmentId, secret) {
        (0, $50OuQ._)(this, TotpMultiFactorAssertionImpl);
        var _this;
        _this = _super.call(this, "totp" /* FactorId.TOTP */ );
        _this.otp = otp;
        _this.enrollmentId = enrollmentId;
        _this.secret = secret;
        return _this;
    }
    (0, $fGdZr._)(TotpMultiFactorAssertionImpl, [
        {
            key: "_finalizeEnroll",
            value: /** @internal */ function _finalizeEnroll(auth, idToken, displayName) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        $04f424e220a55f33$export$9d398bebfec1c039(typeof _this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        return [
                            2,
                            $04f424e220a55f33$var$finalizeEnrollTotpMfa(auth, {
                                idToken: idToken,
                                displayName: displayName,
                                totpVerificationInfo: _this.secret._makeTotpVerificationInfo(_this.otp)
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "_finalizeSignIn",
            value: /** @internal */ function _finalizeSignIn(auth, mfaPendingCredential) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var totpVerificationInfo;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        $04f424e220a55f33$export$9d398bebfec1c039(_this.enrollmentId !== undefined && _this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        totpVerificationInfo = {
                            verificationCode: _this.otp
                        };
                        return [
                            2,
                            $04f424e220a55f33$var$finalizeSignInTotpMfa(auth, {
                                mfaPendingCredential: mfaPendingCredential,
                                mfaEnrollmentId: _this.enrollmentId,
                                totpVerificationInfo: totpVerificationInfo
                            })
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromSecret",
            value: /** @internal */ function _fromSecret(secret, otp) {
                return new TotpMultiFactorAssertionImpl(otp, undefined, secret);
            }
        },
        {
            key: "_fromEnrollmentId",
            value: /** @internal */ function _fromEnrollmentId(enrollmentId, otp) {
                return new TotpMultiFactorAssertionImpl(otp, enrollmentId);
            }
        }
    ]);
    return TotpMultiFactorAssertionImpl;
}($04f424e220a55f33$var$MultiFactorAssertionImpl);
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ var $04f424e220a55f33$export$7ccc53e8f1e7dfc5 = /*#__PURE__*/ function() {
    "use strict";
    function TotpSecret(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth) {
        (0, $50OuQ._)(this, TotpSecret);
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    (0, $fGdZr._)(TotpSecret, [
        {
            /** @internal */ key: "_makeTotpVerificationInfo",
            value: function _makeTotpVerificationInfo(otp) {
                return {
                    sessionInfo: this.sessionInfo,
                    verificationCode: otp
                };
            }
        },
        {
            /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ key: "generateQrCodeUrl",
            value: function generateQrCodeUrl(accountName, issuer) {
                var _a;
                var useDefaults = false;
                if ($04f424e220a55f33$var$_isEmptyString(accountName) || $04f424e220a55f33$var$_isEmptyString(issuer)) useDefaults = true;
                if (useDefaults) {
                    if ($04f424e220a55f33$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
                    if ($04f424e220a55f33$var$_isEmptyString(issuer)) issuer = this.auth.name;
                }
                return "otpauth://totp/".concat(issuer, ":").concat(accountName, "?secret=").concat(this.secretKey, "&issuer=").concat(issuer, "&algorithm=").concat(this.hashingAlgorithm, "&digits=").concat(this.codeLength);
            }
        }
    ], [
        {
            key: "_fromStartTotpMfaEnrollmentResponse",
            value: /** @internal */ function _fromStartTotpMfaEnrollmentResponse(response, auth) {
                return new TotpSecret(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
            }
        }
    ]);
    return TotpSecret;
}();
/** @internal */ function $04f424e220a55f33$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $04f424e220a55f33$var$name = "@firebase/auth";
var $04f424e220a55f33$var$version = "1.3.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$AuthInterop = /*#__PURE__*/ function() {
    "use strict";
    function AuthInterop(auth) {
        (0, $50OuQ._)(this, AuthInterop);
        this.auth = auth;
        this.internalListeners = new Map();
    }
    (0, $fGdZr._)(AuthInterop, [
        {
            key: "getUid",
            value: function getUid() {
                var _a;
                this.assertAuthConfigured();
                return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
            }
        },
        {
            key: "getToken",
            value: function getToken(forceRefresh) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var accessToken;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.assertAuthConfigured();
                                return [
                                    4,
                                    _this.auth._initializationPromise
                                ];
                            case 1:
                                _state.sent();
                                if (!_this.auth.currentUser) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    _this.auth.currentUser.getIdToken(forceRefresh)
                                ];
                            case 2:
                                accessToken = _state.sent();
                                return [
                                    2,
                                    {
                                        accessToken: accessToken
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addAuthTokenListener",
            value: function addAuthTokenListener(listener) {
                this.assertAuthConfigured();
                if (this.internalListeners.has(listener)) return;
                var unsubscribe = this.auth.onIdTokenChanged(function(user) {
                    listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
                });
                this.internalListeners.set(listener, unsubscribe);
                this.updateProactiveRefresh();
            }
        },
        {
            key: "removeAuthTokenListener",
            value: function removeAuthTokenListener(listener) {
                this.assertAuthConfigured();
                var unsubscribe = this.internalListeners.get(listener);
                if (!unsubscribe) return;
                this.internalListeners["delete"](listener);
                unsubscribe();
                this.updateProactiveRefresh();
            }
        },
        {
            key: "assertAuthConfigured",
            value: function assertAuthConfigured() {
                $04f424e220a55f33$export$9d398bebfec1c039(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
            }
        },
        {
            key: "updateProactiveRefresh",
            value: function updateProactiveRefresh() {
                if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
                else this.auth._stopProactiveRefresh();
            }
        }
    ]);
    return AuthInterop;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $04f424e220a55f33$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $04f424e220a55f33$var$registerAuth(clientPlatform) {
    (0, $2Ldjj._registerComponent)(new (0, $bDt5L.Component)("auth" /* _ComponentName.AUTH */ , function(container, param) {
        var deps = param.options;
        var app = container.getProvider("app").getImmediate();
        var heartbeatServiceProvider = container.getProvider("heartbeat");
        var appCheckServiceProvider = container.getProvider("app-check-internal");
        var _app_options = app.options, apiKey = _app_options.apiKey, authDomain = _app_options.authDomain;
        $04f424e220a55f33$export$9d398bebfec1c039(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        var config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $04f424e220a55f33$export$91477dc880baac21(clientPlatform)
        };
        var authInstance = new $04f424e220a55f33$export$23ebac1979863676(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $04f424e220a55f33$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback(function(container, _instanceIdentifier, _instance) {
        var authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $2Ldjj._registerComponent)(new (0, $bDt5L.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , function(container) {
        var auth = $04f424e220a55f33$export$b9a6b53f9be3734(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return function(auth) {
            return new $04f424e220a55f33$var$AuthInterop(auth);
        }(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $2Ldjj.registerVersion)($04f424e220a55f33$var$name, $04f424e220a55f33$var$version, $04f424e220a55f33$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $2Ldjj.registerVersion)($04f424e220a55f33$var$name, $04f424e220a55f33$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $04f424e220a55f33$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
var $04f424e220a55f33$var$authIdTokenMaxAge = (0, $cxgyp.getExperimentalSetting)("authIdTokenMaxAge") || $04f424e220a55f33$var$DEFAULT_ID_TOKEN_MAX_AGE;
var $04f424e220a55f33$var$lastPostedIdToken = null;
var $04f424e220a55f33$var$mintCookieFactory = function(url) {
    return function() {
        var _ref = (0, $5Pgs2._)(function(user) {
            var idTokenResult, _tmp, idTokenAge, idToken;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = user;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            user.getIdTokenResult()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        idTokenResult = _tmp;
                        idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
                        if (idTokenAge && idTokenAge > $04f424e220a55f33$var$authIdTokenMaxAge) return [
                            2
                        ];
                        idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
                        if ($04f424e220a55f33$var$lastPostedIdToken === idToken) return [
                            2
                        ];
                        $04f424e220a55f33$var$lastPostedIdToken = idToken;
                        return [
                            4,
                            fetch(url, {
                                method: idToken ? "POST" : "DELETE",
                                headers: idToken ? {
                                    Authorization: "Bearer ".concat(idToken)
                                } : {}
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(user) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $04f424e220a55f33$export$ae1af26003f05816() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $2Ldjj.getApp)();
    var provider = (0, $2Ldjj._getProvider)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    var auth = $04f424e220a55f33$export$9bb611d729802a56(app, {
        popupRedirectResolver: $04f424e220a55f33$export$342063e11d6c3cad,
        persistence: [
            $04f424e220a55f33$export$23f2a1d2818174ef,
            $04f424e220a55f33$export$8b22cf2602fb60ce,
            $04f424e220a55f33$export$407448d2b89b1813
        ]
    });
    var authTokenSyncUrl = (0, $cxgyp.getExperimentalSetting)("authTokenSyncURL");
    if (authTokenSyncUrl) {
        var mintCookie = $04f424e220a55f33$var$mintCookieFactory(authTokenSyncUrl);
        $04f424e220a55f33$export$d141bba7fdc215a3(auth, mintCookie, function() {
            return mintCookie(auth.currentUser);
        });
        $04f424e220a55f33$export$efccba1c4a2ef57b(auth, function(user) {
            return mintCookie(user);
        });
    }
    var authEmulatorHost = (0, $cxgyp.getDefaultEmulatorHost)("auth");
    if (authEmulatorHost) $04f424e220a55f33$export$b4171a6734a65d42(auth, "http://".concat(authEmulatorHost));
    return auth;
}
$04f424e220a55f33$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );

});
parcelRequire.register("ats3c", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7a025f0ee85622d7$export$afb3516d9d608401; });

var $7BaMR = parcelRequire("7BaMR");
function $7a025f0ee85622d7$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $7a025f0ee85622d7$export$afb3516d9d608401 = Reflect.get;
    else $7a025f0ee85622d7$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $7BaMR._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $7a025f0ee85622d7$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRequire.register("7BaMR", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $58845b2ea49534ba$export$e4187255aefbc259; });

var $bykok = parcelRequire("bykok");
function $58845b2ea49534ba$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $bykok._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRequire.register("cxgyp", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $9205685afe5885ef$export$4b5284a3025a455; });
$parcel$export(module.exports, "base64Decode", function () { return $9205685afe5885ef$export$c62426fdd000a97e; });
$parcel$export(module.exports, "getDefaultEmulatorHost", function () { return $9205685afe5885ef$export$9c11895284c8adad; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $9205685afe5885ef$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "getExperimentalSetting", function () { return $9205685afe5885ef$export$5539a1a3afe87d6; });
$parcel$export(module.exports, "Deferred", function () { return $9205685afe5885ef$export$85f6557964517f1a; });
$parcel$export(module.exports, "getUA", function () { return $9205685afe5885ef$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $9205685afe5885ef$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $9205685afe5885ef$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $9205685afe5885ef$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $9205685afe5885ef$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $9205685afe5885ef$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $9205685afe5885ef$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "FirebaseError", function () { return $9205685afe5885ef$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $9205685afe5885ef$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "isEmpty", function () { return $9205685afe5885ef$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "deepEqual", function () { return $9205685afe5885ef$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "querystring", function () { return $9205685afe5885ef$export$ac4103b836844853; });
$parcel$export(module.exports, "querystringDecode", function () { return $9205685afe5885ef$export$c1271ca4c8a70741; });
$parcel$export(module.exports, "extractQuerystring", function () { return $9205685afe5885ef$export$1a8408415472d8ed; });
$parcel$export(module.exports, "createSubscribe", function () { return $9205685afe5885ef$export$364097d812234b3f; });
$parcel$export(module.exports, "getModularInstance", function () { return $9205685afe5885ef$export$4befe9b5fa509a1b; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $dMjkN = parcelRequire("dMjkN");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $jc6v0 = parcelRequire("jc6v0");

var $iD0Am = parcelRequire("iD0Am");

var $ffICS = parcelRequire("ffICS");
var $9205685afe5885ef$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ var $9205685afe5885ef$export$a7a9523472993e97 = function assert(assertion, message) {
    if (!assertion) throw $9205685afe5885ef$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ var $9205685afe5885ef$export$a39cad550e7ab28a = function assertionError(message) {
    return new Error("Firebase Database (" + $9205685afe5885ef$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9205685afe5885ef$var$stringToByteArray$1 = function stringToByteArray$1(str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ var $9205685afe5885ef$var$byteArrayToString = function byteArrayToString(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while(pos < bytes.length){
        var c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c21 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c21 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var c22 = bytes[pos++];
            var c31 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c22 & 63) << 6 | c31 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var $9205685afe5885ef$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray: function(input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for(var i = 0; i < input.length; i += 3){
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($9205685afe5885ef$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $9205685afe5885ef$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray: function(input, webSafe) {
        this.init_();
        var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for(var i = 0; i < input.length;){
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $9205685afe5885ef$export$55ca9d4bee46aeb3();
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_: function() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(var i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ var $9205685afe5885ef$export$55ca9d4bee46aeb3 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $1atwj._)(DecodeBase64StringError, Error1);
    var _super = (0, $iD0Am._)(DecodeBase64StringError);
    function DecodeBase64StringError() {
        (0, $50OuQ._)(this, DecodeBase64StringError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "DecodeBase64StringError";
        return _this;
    }
    return DecodeBase64StringError;
}((0, $jc6v0._)(Error));
/**
 * URL-safe base64 encoding
 */ var $9205685afe5885ef$export$e510a73ee562749 = function base64Encode(str) {
    var utf8Bytes = $9205685afe5885ef$var$stringToByteArray$1(str);
    return $9205685afe5885ef$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ var $9205685afe5885ef$export$4b5284a3025a455 = function base64urlEncodeWithoutPadding(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $9205685afe5885ef$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ var $9205685afe5885ef$export$c62426fdd000a97e = function base64Decode(str) {
    try {
        return $9205685afe5885ef$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $9205685afe5885ef$export$6c40052bed430212(value) {
    return $9205685afe5885ef$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $9205685afe5885ef$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(var prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$9205685afe5885ef$var$isValidKey(prop)) continue;
        target[prop] = $9205685afe5885ef$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $9205685afe5885ef$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $9205685afe5885ef$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9205685afe5885ef$var$getDefaultsFromGlobal = function() {
    return $9205685afe5885ef$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
};
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ var $9205685afe5885ef$var$getDefaultsFromEnvVariable = function() {
    if (typeof $ffICS === "undefined" || typeof $ffICS.env === "undefined") return;
    var defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
var $9205685afe5885ef$var$getDefaultsFromCookie = function() {
    if (typeof document === "undefined") return;
    var match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    var decoded = match && $9205685afe5885ef$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ var $9205685afe5885ef$export$212bb2fc580a90a8 = function() {
    try {
        return $9205685afe5885ef$var$getDefaultsFromGlobal() || $9205685afe5885ef$var$getDefaultsFromEnvVariable() || $9205685afe5885ef$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info("Unable to get __FIREBASE_DEFAULTS__ due to: ".concat(e));
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ var $9205685afe5885ef$export$9c11895284c8adad = function(productName) {
    var _a, _b;
    return (_b = (_a = $9205685afe5885ef$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ var $9205685afe5885ef$export$a3febcf1f14a3a0c = function(productName) {
    var host = $9205685afe5885ef$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    var separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error("Invalid host ".concat(host, " with no separate hostname and port!"));
    // eslint-disable-next-line no-restricted-globals
    var port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ var $9205685afe5885ef$export$3dfb6827a9f89756 = function() {
    var _a;
    return (_a = $9205685afe5885ef$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ var $9205685afe5885ef$export$5539a1a3afe87d6 = function(name) {
    var _a;
    return (_a = $9205685afe5885ef$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a["_".concat(name)];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9205685afe5885ef$export$85f6557964517f1a = /*#__PURE__*/ function() {
    "use strict";
    function Deferred() {
        var _this = this;
        (0, $50OuQ._)(this, Deferred);
        this.reject = function() {};
        this.resolve = function() {};
        this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    (0, $fGdZr._)(Deferred, [
        {
            /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ key: "wrapCallback",
            value: function wrapCallback(callback) {
                var _this = this;
                return function(error, value) {
                    if (error) _this.reject(error);
                    else _this.resolve(value);
                    if (typeof callback === "function") {
                        // Attaching noop handler just in case developer wasn't expecting
                        // promises
                        _this.promise["catch"](function() {});
                        // Some of our callbacks don't expect a value and our own tests
                        // assert that the parameter length is 1
                        if (callback.length === 1) callback(error);
                        else callback(error, value);
                    }
                };
            }
        }
    ]);
    return Deferred;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9205685afe5885ef$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    var header = {
        alg: "none",
        type: "JWT"
    };
    var project = projectId || "demo-project";
    var iat = token.iat || 0;
    var sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    var payload = Object.assign({
        // Set all required fields to decent defaults
        iss: "https://securetoken.google.com/".concat(project),
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    var signature = "";
    return [
        $9205685afe5885ef$export$4b5284a3025a455(JSON.stringify(header)),
        $9205685afe5885ef$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $9205685afe5885ef$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $9205685afe5885ef$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($9205685afe5885ef$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $9205685afe5885ef$export$8ee0fc9ee280b4ee() {
    var _a;
    var forceEnvironment = (_a = $9205685afe5885ef$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $9205685afe5885ef$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $9205685afe5885ef$export$caa8774a9107a58e() {
    var runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $9205685afe5885ef$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $9205685afe5885ef$export$f2f6a8999f8ebd30() {
    return $9205685afe5885ef$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $9205685afe5885ef$export$7e7b1a9668aaed8() {
    var ua = $9205685afe5885ef$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $9205685afe5885ef$export$202944b2d2824246() {
    return $9205685afe5885ef$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $9205685afe5885ef$export$5d1d834fbbf8bab7() {
    return $9205685afe5885ef$export$588c7fdda06fbb0a.NODE_CLIENT === true || $9205685afe5885ef$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $9205685afe5885ef$export$95df08bae54cb4df() {
    return !$9205685afe5885ef$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $9205685afe5885ef$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $9205685afe5885ef$export$a8a3018f3d187a4d() {
    return new Promise(function(resolve, reject) {
        try {
            var preExist = true;
            var DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            var request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = function() {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = function() {
                preExist = false;
            };
            request.onerror = function() {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $9205685afe5885ef$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ var $9205685afe5885ef$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var $9205685afe5885ef$export$dd24e9cd51226c56 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $1atwj._)(FirebaseError, Error1);
    var _super = (0, $iD0Am._)(FirebaseError);
    function FirebaseError(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData) {
        (0, $50OuQ._)(this, FirebaseError);
        var _this;
        _this = _super.call(this, message);
        _this.code = code;
        _this.customData = customData;
        /** The custom name for all FirebaseErrors. */ _this.name = $9205685afe5885ef$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $dMjkN._)(_this), FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace((0, $dMjkN._)(_this), $9205685afe5885ef$export$3fa6e1b18a3b2d40.prototype.create);
        return _this;
    }
    return FirebaseError;
}((0, $jc6v0._)(Error));
var $9205685afe5885ef$export$3fa6e1b18a3b2d40 = /*#__PURE__*/ function() {
    "use strict";
    function ErrorFactory(service, serviceName, errors) {
        (0, $50OuQ._)(this, ErrorFactory);
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    (0, $fGdZr._)(ErrorFactory, [
        {
            key: "create",
            value: function create(code) {
                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    data[_key - 1] = arguments[_key];
                }
                var customData = data[0] || {};
                var fullCode = "".concat(this.service, "/").concat(code);
                var template = this.errors[code];
                var message = template ? $9205685afe5885ef$var$replaceTemplate(template, customData) : "Error";
                // Service Name: Error message (service/code).
                var fullMessage = "".concat(this.serviceName, ": ").concat(message, " (").concat(fullCode, ").");
                var error = new $9205685afe5885ef$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
                return error;
            }
        }
    ]);
    return ErrorFactory;
}();
function $9205685afe5885ef$var$replaceTemplate(template, data) {
    return template.replace($9205685afe5885ef$var$PATTERN, function(_, key) {
        var value = data[key];
        return value != null ? String(value) : "<".concat(key, "?>");
    });
}
var $9205685afe5885ef$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $9205685afe5885ef$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $9205685afe5885ef$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $9205685afe5885ef$export$2f872c0f2117be69 = function decode(token) {
    var header = {}, claims = {}, data = {}, signature = "";
    try {
        var parts = token.split(".");
        header = $9205685afe5885ef$export$c5a53ce6a17cf18d($9205685afe5885ef$export$c62426fdd000a97e(parts[0]) || "");
        claims = $9205685afe5885ef$export$c5a53ce6a17cf18d($9205685afe5885ef$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $9205685afe5885ef$export$5f870fcca7ae6a88 = function isValidTimestamp(token) {
    var claims = $9205685afe5885ef$export$2f872c0f2117be69(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $9205685afe5885ef$export$701c661ec91095f2 = function issuedAtTime(token) {
    var claims = $9205685afe5885ef$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $9205685afe5885ef$export$9565ca3d387f8aa0 = function isValidFormat(token) {
    var decoded = $9205685afe5885ef$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $9205685afe5885ef$export$fc970ed23da99565 = function isAdmin(token) {
    var claims = $9205685afe5885ef$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9205685afe5885ef$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $9205685afe5885ef$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $9205685afe5885ef$export$dd1bc94b04021eeb(obj) {
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $9205685afe5885ef$export$871de8747c9eaa88(obj, fn, contextObj) {
    var res = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $9205685afe5885ef$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = aKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            if (!bKeys.includes(k)) return false;
            var aProp = a[k];
            var bProp = b[k];
            if ($9205685afe5885ef$var$isObject(aProp) && $9205685afe5885ef$var$isObject(bProp)) {
                if (!$9205685afe5885ef$export$9cb4719e2e525b7a(aProp, bProp)) return false;
            } else if (aProp !== bProp) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = bKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var k1 = _step1.value;
            if (!aKeys.includes(k1)) return false;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return true;
}
function $9205685afe5885ef$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $9205685afe5885ef$export$a9cd205a244d9f54(promise) {
    var timeInMS = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2000;
    var deferredPromise = new $9205685afe5885ef$export$85f6557964517f1a();
    setTimeout(function() {
        return deferredPromise.reject("timeout!");
    }, timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $9205685afe5885ef$export$ac4103b836844853(querystringParams) {
    var params = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (Array.isArray(value)) value.forEach(function(arrayVal) {
                params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
            });
            else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
        };
        for(var _iterator = Object.entries(querystringParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $9205685afe5885ef$export$c1271ca4c8a70741(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach(function(token) {
        if (token) {
            var _token_split = (0, $aSMts._)(token.split("="), 2), key = _token_split[0], value = _token_split[1];
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $9205685afe5885ef$export$1a8408415472d8ed(url) {
    var queryStart = url.indexOf("?");
    if (!queryStart) return "";
    var fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ var $9205685afe5885ef$export$c85d589bf4e25fef = /*#__PURE__*/ function() {
    "use strict";
    function Sha1() {
        (0, $50OuQ._)(this, Sha1);
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(var i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    (0, $fGdZr._)(Sha1, [
        {
            key: "reset",
            value: function reset() {
                this.chain_[0] = 0x67452301;
                this.chain_[1] = 0xefcdab89;
                this.chain_[2] = 0x98badcfe;
                this.chain_[3] = 0x10325476;
                this.chain_[4] = 0xc3d2e1f0;
                this.inbuf_ = 0;
                this.total_ = 0;
            }
        },
        {
            /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ key: "compress_",
            value: function compress_(buf, offset) {
                if (!offset) offset = 0;
                var W = this.W_;
                // get 16 big endian words
                if (typeof buf === "string") for(var i = 0; i < 16; i++){
                    // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                    // have a bug that turns the post-increment ++ operator into pre-increment
                    // during JIT compilation.  We have code that depends heavily on SHA-1 for
                    // correctness and which is affected by this bug, so I've removed all uses
                    // of post-increment ++ in which the result value is used.  We can revert
                    // this change once the Safari bug
                    // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                    // most clients have been updated.
                    W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
                    offset += 4;
                }
                else for(var i1 = 0; i1 < 16; i1++){
                    W[i1] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
                    offset += 4;
                }
                // expand to 80 words
                for(var i2 = 16; i2 < 80; i2++){
                    var t = W[i2 - 3] ^ W[i2 - 8] ^ W[i2 - 14] ^ W[i2 - 16];
                    W[i2] = (t << 1 | t >>> 31) & 0xffffffff;
                }
                var a = this.chain_[0];
                var b = this.chain_[1];
                var c = this.chain_[2];
                var d = this.chain_[3];
                var e = this.chain_[4];
                var f, k;
                // TODO(user): Try to unroll this loop to speed up the computation.
                for(var i3 = 0; i3 < 80; i3++){
                    if (i3 < 40) {
                        if (i3 < 20) {
                            f = d ^ b & (c ^ d);
                            k = 0x5a827999;
                        } else {
                            f = b ^ c ^ d;
                            k = 0x6ed9eba1;
                        }
                    } else if (i3 < 60) {
                        f = b & c | d & (b | c);
                        k = 0x8f1bbcdc;
                    } else {
                        f = b ^ c ^ d;
                        k = 0xca62c1d6;
                    }
                    var t1 = (a << 5 | a >>> 27) + f + e + k + W[i3] & 0xffffffff;
                    e = d;
                    d = c;
                    c = (b << 30 | b >>> 2) & 0xffffffff;
                    b = a;
                    a = t1;
                }
                this.chain_[0] = this.chain_[0] + a & 0xffffffff;
                this.chain_[1] = this.chain_[1] + b & 0xffffffff;
                this.chain_[2] = this.chain_[2] + c & 0xffffffff;
                this.chain_[3] = this.chain_[3] + d & 0xffffffff;
                this.chain_[4] = this.chain_[4] + e & 0xffffffff;
            }
        },
        {
            key: "update",
            value: function update(bytes, length) {
                // TODO(johnlenz): tighten the function signature and remove this check
                if (bytes == null) return;
                if (length === undefined) length = bytes.length;
                var lengthMinusBlock = length - this.blockSize;
                var n = 0;
                // Using local instead of member variables gives ~5% speedup on Firefox 16.
                var buf = this.buf_;
                var inbuf = this.inbuf_;
                // The outer while loop should execute at most twice.
                while(n < length){
                    // When we have no data in the block to top up, we can directly process the
                    // input buffer (assuming it contains sufficient data). This gives ~25%
                    // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
                    // the data is provided in large chunks (or in multiples of 64 bytes).
                    if (inbuf === 0) while(n <= lengthMinusBlock){
                        this.compress_(bytes, n);
                        n += this.blockSize;
                    }
                    if (typeof bytes === "string") while(n < length){
                        buf[inbuf] = bytes.charCodeAt(n);
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            break;
                        }
                    }
                    else while(n < length){
                        buf[inbuf] = bytes[n];
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            break;
                        }
                    }
                }
                this.inbuf_ = inbuf;
                this.total_ += length;
            }
        },
        {
            /** @override */ key: "digest",
            value: function digest() {
                var digest = [];
                var totalBits = this.total_ * 8;
                // Add pad 0x80 0x00*.
                if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
                else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
                // Add # bits.
                for(var i = this.blockSize - 1; i >= 56; i--){
                    this.buf_[i] = totalBits & 255;
                    totalBits /= 256; // Don't use bit-shifting here!
                }
                this.compress_(this.buf_);
                var n = 0;
                for(var i1 = 0; i1 < 5; i1++)for(var j = 24; j >= 0; j -= 8){
                    digest[n] = this.chain_[i1] >> j & 255;
                    ++n;
                }
                return digest;
            }
        }
    ]);
    return Sha1;
}();
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $9205685afe5885ef$export$364097d812234b3f(executor, onNoObservers) {
    var proxy = new $9205685afe5885ef$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ var $9205685afe5885ef$var$ObserverProxy = /*#__PURE__*/ function() {
    "use strict";
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        (0, $50OuQ._)(this, ObserverProxy);
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function() {
            executor(_this);
        })["catch"](function(e) {
            _this.error(e);
        });
    }
    (0, $fGdZr._)(ObserverProxy, [
        {
            key: "next",
            value: function next(value) {
                this.forEachObserver(function(observer) {
                    observer.next(value);
                });
            }
        },
        {
            key: "error",
            value: function error(error) {
                this.forEachObserver(function(observer) {
                    observer.error(error);
                });
                this.close(error);
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.forEachObserver(function(observer) {
                    observer.complete();
                });
                this.close();
            }
        },
        {
            /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ key: "subscribe",
            value: function subscribe(nextOrObserver, error, complete) {
                var _this = this;
                var observer;
                if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
                // Assemble an Observer object when passed as callback functions.
                if ($9205685afe5885ef$var$implementsAnyMethods(nextOrObserver, [
                    "next",
                    "error",
                    "complete"
                ])) observer = nextOrObserver;
                else observer = {
                    next: nextOrObserver,
                    error: error,
                    complete: complete
                };
                if (observer.next === undefined) observer.next = $9205685afe5885ef$var$noop;
                if (observer.error === undefined) observer.error = $9205685afe5885ef$var$noop;
                if (observer.complete === undefined) observer.complete = $9205685afe5885ef$var$noop;
                var unsub = this.unsubscribeOne.bind(this, this.observers.length);
                // Attempt to subscribe to a terminated Observable - we
                // just respond to the Observer with the final error or complete
                // event.
                if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    try {
                        if (_this.finalError) observer.error(_this.finalError);
                        else observer.complete();
                    } catch (e) {
                    // nothing
                    }
                    return;
                });
                this.observers.push(observer);
                return unsub;
            }
        },
        {
            // Unsubscribe is synchronous - we guarantee that no events are sent to
            // any unsubscribed Observer.
            key: "unsubscribeOne",
            value: function unsubscribeOne(i) {
                if (this.observers === undefined || this.observers[i] === undefined) return;
                delete this.observers[i];
                this.observerCount -= 1;
                if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
            }
        },
        {
            key: "forEachObserver",
            value: function forEachObserver(fn) {
                if (this.finalized) // Already closed by previous event....just eat the additional values.
                return;
                // Since sendOne calls asynchronously - there is no chance that
                // this.observers will become undefined.
                for(var i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
            }
        },
        {
            // Call the Observer via one of it's callback function. We are careful to
            // confirm that the observe has not been unsubscribed since this asynchronous
            // function had been queued.
            key: "sendOne",
            value: function sendOne(i, fn) {
                var _this = this;
                // Execute the callback asynchronously
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    if (_this.observers !== undefined && _this.observers[i] !== undefined) try {
                        fn(_this.observers[i]);
                    } catch (e) {
                        // Ignore exceptions raised in Observers or missing methods of an
                        // Observer.
                        // Log error to console. b/31404806
                        if (typeof console !== "undefined" && console.error) console.error(e);
                    }
                });
            }
        },
        {
            key: "close",
            value: function close(err) {
                var _this = this;
                if (this.finalized) return;
                this.finalized = true;
                if (err !== undefined) this.finalError = err;
                // Proxy is no longer needed - garbage collect references
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    _this.observers = undefined;
                    _this.onNoObservers = undefined;
                });
            }
        }
    ]);
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $9205685afe5885ef$export$12af436354f1a4f7(fn, onError) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        Promise.resolve(true).then(function() {
            fn.apply(void 0, (0, $dHvbf._)(args));
        })["catch"](function(error) {
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $9205685afe5885ef$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = methods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var method = _step.value;
            if (method in obj && typeof obj[method] === "function") return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $9205685afe5885ef$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ var $9205685afe5885ef$export$20164226a0ed35c3 = function validateArgCount(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        var error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $9205685afe5885ef$export$adea4917e02d93dc(fnName, argName) {
    return "".concat(fnName, " failed: ").concat(argName, " argument ");
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $9205685afe5885ef$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($9205685afe5885ef$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $9205685afe5885ef$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($9205685afe5885ef$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $9205685afe5885ef$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($9205685afe5885ef$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ var $9205685afe5885ef$export$655666783217a925 = function stringToByteArray(str) {
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            $9205685afe5885ef$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ var $9205685afe5885ef$export$9536dc0a75b20bf9 = function stringLength(str) {
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ var $9205685afe5885ef$export$abe4376e1bf796d6 = function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ var $9205685afe5885ef$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ var $9205685afe5885ef$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ var $9205685afe5885ef$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ var $9205685afe5885ef$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $9205685afe5885ef$export$4d810c0ca64ed8e9(backoffCount) {
    var intervalMillis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9205685afe5885ef$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $9205685afe5885ef$var$DEFAULT_BACKOFF_FACTOR;
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $9205685afe5885ef$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($9205685afe5885ef$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $9205685afe5885ef$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return "".concat(i);
    return i + $9205685afe5885ef$var$indicator(i);
}
function $9205685afe5885ef$var$indicator(i) {
    i = Math.abs(i);
    var cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    var dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9205685afe5885ef$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});
parcelRequire.register("ffICS", function(module, exports) {
// shim for using process in browser
var $b1aadf8304182be4$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $b1aadf8304182be4$var$cachedSetTimeout;
var $b1aadf8304182be4$var$cachedClearTimeout;
function $b1aadf8304182be4$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $b1aadf8304182be4$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $b1aadf8304182be4$var$cachedSetTimeout = setTimeout;
        else $b1aadf8304182be4$var$cachedSetTimeout = $b1aadf8304182be4$var$defaultSetTimout;
    } catch (e) {
        $b1aadf8304182be4$var$cachedSetTimeout = $b1aadf8304182be4$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $b1aadf8304182be4$var$cachedClearTimeout = clearTimeout;
        else $b1aadf8304182be4$var$cachedClearTimeout = $b1aadf8304182be4$var$defaultClearTimeout;
    } catch (e) {
        $b1aadf8304182be4$var$cachedClearTimeout = $b1aadf8304182be4$var$defaultClearTimeout;
    }
})();
function $b1aadf8304182be4$var$runTimeout(fun) {
    if ($b1aadf8304182be4$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($b1aadf8304182be4$var$cachedSetTimeout === $b1aadf8304182be4$var$defaultSetTimout || !$b1aadf8304182be4$var$cachedSetTimeout) && setTimeout) {
        $b1aadf8304182be4$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b1aadf8304182be4$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $b1aadf8304182be4$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $b1aadf8304182be4$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $b1aadf8304182be4$var$runClearTimeout(marker) {
    if ($b1aadf8304182be4$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($b1aadf8304182be4$var$cachedClearTimeout === $b1aadf8304182be4$var$defaultClearTimeout || !$b1aadf8304182be4$var$cachedClearTimeout) && clearTimeout) {
        $b1aadf8304182be4$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b1aadf8304182be4$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $b1aadf8304182be4$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $b1aadf8304182be4$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $b1aadf8304182be4$var$queue = [];
var $b1aadf8304182be4$var$draining = false;
var $b1aadf8304182be4$var$currentQueue;
var $b1aadf8304182be4$var$queueIndex = -1;
function $b1aadf8304182be4$var$cleanUpNextTick() {
    if (!$b1aadf8304182be4$var$draining || !$b1aadf8304182be4$var$currentQueue) return;
    $b1aadf8304182be4$var$draining = false;
    if ($b1aadf8304182be4$var$currentQueue.length) $b1aadf8304182be4$var$queue = $b1aadf8304182be4$var$currentQueue.concat($b1aadf8304182be4$var$queue);
    else $b1aadf8304182be4$var$queueIndex = -1;
    if ($b1aadf8304182be4$var$queue.length) $b1aadf8304182be4$var$drainQueue();
}
function $b1aadf8304182be4$var$drainQueue() {
    if ($b1aadf8304182be4$var$draining) return;
    var timeout = $b1aadf8304182be4$var$runTimeout($b1aadf8304182be4$var$cleanUpNextTick);
    $b1aadf8304182be4$var$draining = true;
    var len = $b1aadf8304182be4$var$queue.length;
    while(len){
        $b1aadf8304182be4$var$currentQueue = $b1aadf8304182be4$var$queue;
        $b1aadf8304182be4$var$queue = [];
        while(++$b1aadf8304182be4$var$queueIndex < len)if ($b1aadf8304182be4$var$currentQueue) $b1aadf8304182be4$var$currentQueue[$b1aadf8304182be4$var$queueIndex].run();
        $b1aadf8304182be4$var$queueIndex = -1;
        len = $b1aadf8304182be4$var$queue.length;
    }
    $b1aadf8304182be4$var$currentQueue = null;
    $b1aadf8304182be4$var$draining = false;
    $b1aadf8304182be4$var$runClearTimeout(timeout);
}
$b1aadf8304182be4$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $b1aadf8304182be4$var$queue.push(new $b1aadf8304182be4$var$Item(fun, args));
    if ($b1aadf8304182be4$var$queue.length === 1 && !$b1aadf8304182be4$var$draining) $b1aadf8304182be4$var$runTimeout($b1aadf8304182be4$var$drainQueue);
};
// v8 likes predictible objects
function $b1aadf8304182be4$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$b1aadf8304182be4$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$b1aadf8304182be4$var$process.title = "browser";
$b1aadf8304182be4$var$process.browser = true;
$b1aadf8304182be4$var$process.env = {};
$b1aadf8304182be4$var$process.argv = [];
$b1aadf8304182be4$var$process.version = ""; // empty string to avoid regexp issues
$b1aadf8304182be4$var$process.versions = {};
function $b1aadf8304182be4$var$noop() {}
$b1aadf8304182be4$var$process.on = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.addListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.once = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.off = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.removeListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.removeAllListeners = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.emit = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.prependListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.prependOnceListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.listeners = function(name) {
    return [];
};
$b1aadf8304182be4$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$b1aadf8304182be4$var$process.cwd = function() {
    return "/";
};
$b1aadf8304182be4$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$b1aadf8304182be4$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("2Ldjj", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $202a4bb9d1654d04$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $202a4bb9d1654d04$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $202a4bb9d1654d04$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $202a4bb9d1654d04$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $202a4bb9d1654d04$export$f9962582c9e66d99; });
$parcel$export(module.exports, "registerVersion", function () { return $202a4bb9d1654d04$export$d29d5299a7137abc; });

var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $2iBlG = parcelRequire("2iBlG");

var $dHvbf = parcelRequire("dHvbf");

var $1XfpH = parcelRequire("1XfpH");

var $bDt5L = parcelRequire("bDt5L");

var $1dgkP = parcelRequire("1dgkP");

var $cxgyp = parcelRequire("cxgyp");

var $2XDnt = parcelRequire("2XDnt");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $202a4bb9d1654d04$var$PlatformLoggerServiceImpl = /*#__PURE__*/ function() {
    "use strict";
    function PlatformLoggerServiceImpl(container) {
        (0, $50OuQ._)(this, PlatformLoggerServiceImpl);
        this.container = container;
    }
    (0, $fGdZr._)(PlatformLoggerServiceImpl, [
        {
            // In initial implementation, this will be called by installations on
            // auth token refresh, and installations will send this string.
            key: "getPlatformInfoString",
            value: function getPlatformInfoString() {
                var providers = this.container.getProviders();
                // Loop through providers and get library/version pairs from any that are
                // version components.
                return providers.map(function(provider) {
                    if ($202a4bb9d1654d04$var$isVersionServiceProvider(provider)) {
                        var service = provider.getImmediate();
                        return "".concat(service.library, "/").concat(service.version);
                    } else return null;
                }).filter(function(logString) {
                    return logString;
                }).join(" ");
            }
        }
    ]);
    return PlatformLoggerServiceImpl;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $202a4bb9d1654d04$var$isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
var $202a4bb9d1654d04$var$name$o = "@firebase/app";
var $202a4bb9d1654d04$var$version$1 = "0.9.19";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $202a4bb9d1654d04$var$logger = new (0, $1dgkP.Logger)("@firebase/app");
var $202a4bb9d1654d04$var$name$n = "@firebase/app-compat";
var $202a4bb9d1654d04$var$name$m = "@firebase/analytics-compat";
var $202a4bb9d1654d04$var$name$l = "@firebase/analytics";
var $202a4bb9d1654d04$var$name$k = "@firebase/app-check-compat";
var $202a4bb9d1654d04$var$name$j = "@firebase/app-check";
var $202a4bb9d1654d04$var$name$i = "@firebase/auth";
var $202a4bb9d1654d04$var$name$h = "@firebase/auth-compat";
var $202a4bb9d1654d04$var$name$g = "@firebase/database";
var $202a4bb9d1654d04$var$name$f = "@firebase/database-compat";
var $202a4bb9d1654d04$var$name$e = "@firebase/functions";
var $202a4bb9d1654d04$var$name$d = "@firebase/functions-compat";
var $202a4bb9d1654d04$var$name$c = "@firebase/installations";
var $202a4bb9d1654d04$var$name$b = "@firebase/installations-compat";
var $202a4bb9d1654d04$var$name$a = "@firebase/messaging";
var $202a4bb9d1654d04$var$name$9 = "@firebase/messaging-compat";
var $202a4bb9d1654d04$var$name$8 = "@firebase/performance";
var $202a4bb9d1654d04$var$name$7 = "@firebase/performance-compat";
var $202a4bb9d1654d04$var$name$6 = "@firebase/remote-config";
var $202a4bb9d1654d04$var$name$5 = "@firebase/remote-config-compat";
var $202a4bb9d1654d04$var$name$4 = "@firebase/storage";
var $202a4bb9d1654d04$var$name$3 = "@firebase/storage-compat";
var $202a4bb9d1654d04$var$name$2 = "@firebase/firestore";
var $202a4bb9d1654d04$var$name$1 = "@firebase/firestore-compat";
var $202a4bb9d1654d04$var$name = "firebase";
var $202a4bb9d1654d04$var$version = "10.4.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ var $202a4bb9d1654d04$export$9f30fa0c10967f7f = "[DEFAULT]";
var $202a4bb9d1654d04$var$_obj;
var $202a4bb9d1654d04$var$PLATFORM_LOG_STRING = ($202a4bb9d1654d04$var$_obj = {}, (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$o, "fire-core"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$n, "fire-core-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$l, "fire-analytics"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$m, "fire-analytics-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$j, "fire-app-check"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$k, "fire-app-check-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$i, "fire-auth"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$h, "fire-auth-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$g, "fire-rtdb"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$f, "fire-rtdb-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$e, "fire-fn"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$d, "fire-fn-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$c, "fire-iid"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$b, "fire-iid-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$a, "fire-fcm"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$9, "fire-fcm-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$8, "fire-perf"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$7, "fire-perf-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$6, "fire-rc"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$5, "fire-rc-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$4, "fire-gcs"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$3, "fire-gcs-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$2, "fire-fst"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name$1, "fire-fst-compat"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, "fire-js", "fire-js"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj, $202a4bb9d1654d04$var$name, "fire-js-all"), $202a4bb9d1654d04$var$_obj);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ var $202a4bb9d1654d04$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $202a4bb9d1654d04$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $202a4bb9d1654d04$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $202a4bb9d1654d04$var$logger.debug("Component ".concat(component.name, " failed to register with FirebaseApp ").concat(app.name), e);
    }
}
/**
 *
 * @internal
 */ function $202a4bb9d1654d04$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $202a4bb9d1654d04$export$c930050e7bb63965(component) {
    var componentName = component.name;
    if ($202a4bb9d1654d04$export$9566bce3835c0f28.has(componentName)) {
        $202a4bb9d1654d04$var$logger.debug("There were multiple attempts to register component ".concat(componentName, "."));
        return false;
    }
    $202a4bb9d1654d04$export$9566bce3835c0f28.set(componentName, component);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // add the component to existing app instances
        for(var _iterator = $202a4bb9d1654d04$export$b4e3c36c855b14b5.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var app = _step.value;
            $202a4bb9d1654d04$export$fa5244b94c62d36a(app, component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $202a4bb9d1654d04$export$fa0d6da0f5838f50(app, name) {
    var heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $202a4bb9d1654d04$export$48d18de2ff1c45a5(app, name) {
    var instanceIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $202a4bb9d1654d04$export$9f30fa0c10967f7f;
    $202a4bb9d1654d04$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $202a4bb9d1654d04$export$3685d89b9c3cdfaf() {
    $202a4bb9d1654d04$export$9566bce3835c0f28.clear();
}
var $202a4bb9d1654d04$var$_obj1;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $202a4bb9d1654d04$var$ERRORS = ($202a4bb9d1654d04$var$_obj1 = {}, (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "no-app" /* AppError.NO_APP */ , "No Firebase App '{$appName}' has been created - call initializeApp() first"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "bad-app-name" /* AppError.BAD_APP_NAME */ , "Illegal App name: '{$appName}"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "duplicate-app" /* AppError.DUPLICATE_APP */ , "Firebase App named '{$appName}' already exists with different options or config"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "app-deleted" /* AppError.APP_DELETED */ , "Firebase App named '{$appName}' already deleted"), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "no-options" /* AppError.NO_OPTIONS */ , "Need to provide options, when not being deployed to hosting via source."), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ , "firebase.{$appName}() takes either no argument or a Firebase App instance."), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ , "First argument to `onLog` must be null or a function."), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "idb-open" /* AppError.IDB_OPEN */ , "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}."), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "idb-get" /* AppError.IDB_GET */ , "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}."), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "idb-set" /* AppError.IDB_WRITE */ , "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}."), (0, $2iBlG._)($202a4bb9d1654d04$var$_obj1, "idb-delete" /* AppError.IDB_DELETE */ , "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."), $202a4bb9d1654d04$var$_obj1);
var $202a4bb9d1654d04$var$ERROR_FACTORY = new (0, $cxgyp.ErrorFactory)("app", "Firebase", $202a4bb9d1654d04$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $202a4bb9d1654d04$var$FirebaseAppImpl = /*#__PURE__*/ function() {
    "use strict";
    function FirebaseAppImpl(options, config, container) {
        var _this = this;
        (0, $50OuQ._)(this, FirebaseAppImpl);
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $bDt5L.Component)("app", function() {
            return _this;
        }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    (0, $fGdZr._)(FirebaseAppImpl, [
        {
            key: "automaticDataCollectionEnabled",
            get: function get() {
                this.checkDestroyed();
                return this._automaticDataCollectionEnabled;
            },
            set: function set(val) {
                this.checkDestroyed();
                this._automaticDataCollectionEnabled = val;
            }
        },
        {
            key: "name",
            get: function get() {
                this.checkDestroyed();
                return this._name;
            }
        },
        {
            key: "options",
            get: function get() {
                this.checkDestroyed();
                return this._options;
            }
        },
        {
            key: "config",
            get: function get() {
                this.checkDestroyed();
                return this._config;
            }
        },
        {
            key: "container",
            get: function get() {
                return this._container;
            }
        },
        {
            key: "isDeleted",
            get: function get() {
                return this._isDeleted;
            },
            set: function set(val) {
                this._isDeleted = val;
            }
        },
        {
            /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ key: "checkDestroyed",
            value: function checkDestroyed() {
                if (this.isDeleted) throw $202a4bb9d1654d04$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
                    appName: this._name
                });
            }
        }
    ]);
    return FirebaseAppImpl;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ var $202a4bb9d1654d04$export$31499a9cd224b78c = $202a4bb9d1654d04$var$version;
function $202a4bb9d1654d04$export$c55cfd413944906d(_options) {
    var rawConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = _options;
    if (typeof rawConfig !== "object") {
        var name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    var config = Object.assign({
        name: $202a4bb9d1654d04$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    var name1 = config.name;
    if (typeof name1 !== "string" || !name1) throw $202a4bb9d1654d04$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name1)
    });
    options || (options = (0, $cxgyp.getDefaultAppConfig)());
    if (!options) throw $202a4bb9d1654d04$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    var existingApp = $202a4bb9d1654d04$export$b4e3c36c855b14b5.get(name1);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $cxgyp.deepEqual)(options, existingApp.options) && (0, $cxgyp.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $202a4bb9d1654d04$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name1
        });
    }
    var container = new (0, $bDt5L.ComponentContainer)(name1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $202a4bb9d1654d04$export$9566bce3835c0f28.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var component = _step.value;
            container.addComponent(component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var newApp = new $202a4bb9d1654d04$var$FirebaseAppImpl(options, config, container);
    $202a4bb9d1654d04$export$b4e3c36c855b14b5.set(name1, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $202a4bb9d1654d04$export$f9962582c9e66d99() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $202a4bb9d1654d04$export$9f30fa0c10967f7f;
    var app = $202a4bb9d1654d04$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $202a4bb9d1654d04$export$9f30fa0c10967f7f && (0, $cxgyp.getDefaultAppConfig)()) return $202a4bb9d1654d04$export$c55cfd413944906d();
    if (!app) throw $202a4bb9d1654d04$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $202a4bb9d1654d04$export$68ddedf7d44b3bdf() {
    return Array.from($202a4bb9d1654d04$export$b4e3c36c855b14b5.values());
}
function $202a4bb9d1654d04$export$6eec44aa53d5ea34(app) {
    return $202a4bb9d1654d04$var$_deleteApp.apply(this, arguments);
}
function $202a4bb9d1654d04$var$_deleteApp() {
    $202a4bb9d1654d04$var$_deleteApp = /**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ (0, $5Pgs2._)(function(app) {
        var name;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    name = app.name;
                    if (!$202a4bb9d1654d04$export$b4e3c36c855b14b5.has(name)) return [
                        3,
                        2
                    ];
                    $202a4bb9d1654d04$export$b4e3c36c855b14b5["delete"](name);
                    return [
                        4,
                        Promise.all(app.container.getProviders().map(function(provider) {
                            return provider["delete"]();
                        }))
                    ];
                case 1:
                    _state.sent();
                    app.isDeleted = true;
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return $202a4bb9d1654d04$var$_deleteApp.apply(this, arguments);
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $202a4bb9d1654d04$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    var library = (_a = $202a4bb9d1654d04$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += "-".concat(variant);
    var libraryMismatch = library.match(/\s|\//);
    var versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        var warning = [
            'Unable to register library "'.concat(library, '" with version "').concat(version, '":')
        ];
        if (libraryMismatch) warning.push('library name "'.concat(library, '" contains illegal characters (whitespace or "/")'));
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push('version name "'.concat(version, '" contains illegal characters (whitespace or "/")'));
        $202a4bb9d1654d04$var$logger.warn(warning.join(" "));
        return;
    }
    $202a4bb9d1654d04$export$c930050e7bb63965(new (0, $bDt5L.Component)("".concat(library, "-version"), function() {
        return {
            library: library,
            version: version
        };
    }, "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $202a4bb9d1654d04$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $202a4bb9d1654d04$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $1dgkP.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $202a4bb9d1654d04$export$c622e99c0ce7b1c9(logLevel) {
    (0, $1dgkP.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $202a4bb9d1654d04$var$DB_NAME = "firebase-heartbeat-database";
var $202a4bb9d1654d04$var$DB_VERSION = 1;
var $202a4bb9d1654d04$var$STORE_NAME = "firebase-heartbeat-store";
var $202a4bb9d1654d04$var$dbPromise = null;
function $202a4bb9d1654d04$var$getDbPromise() {
    if (!$202a4bb9d1654d04$var$dbPromise) $202a4bb9d1654d04$var$dbPromise = (0, $2XDnt.openDB)($202a4bb9d1654d04$var$DB_NAME, $202a4bb9d1654d04$var$DB_VERSION, {
        upgrade: function(db, oldVersion) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($202a4bb9d1654d04$var$STORE_NAME);
            }
        }
    })["catch"](function(e) {
        throw $202a4bb9d1654d04$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $202a4bb9d1654d04$var$dbPromise;
}
function $202a4bb9d1654d04$var$readHeartbeatsFromIndexedDB(app) {
    return $202a4bb9d1654d04$var$_readHeartbeatsFromIndexedDB.apply(this, arguments);
}
function $202a4bb9d1654d04$var$_readHeartbeatsFromIndexedDB() {
    $202a4bb9d1654d04$var$_readHeartbeatsFromIndexedDB = (0, $5Pgs2._)(function(app) {
        var db, result, e, idbGetError;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $202a4bb9d1654d04$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    return [
                        4,
                        db.transaction($202a4bb9d1654d04$var$STORE_NAME).objectStore($202a4bb9d1654d04$var$STORE_NAME).get($202a4bb9d1654d04$var$computeKey(app))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
                case 3:
                    e = _state.sent();
                    if (e instanceof (0, $cxgyp.FirebaseError)) $202a4bb9d1654d04$var$logger.warn(e.message);
                    else {
                        idbGetError = $202a4bb9d1654d04$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                            originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                        });
                        $202a4bb9d1654d04$var$logger.warn(idbGetError.message);
                    }
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $202a4bb9d1654d04$var$_readHeartbeatsFromIndexedDB.apply(this, arguments);
}
function $202a4bb9d1654d04$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    return $202a4bb9d1654d04$var$_writeHeartbeatsToIndexedDB.apply(this, arguments);
}
function $202a4bb9d1654d04$var$_writeHeartbeatsToIndexedDB() {
    $202a4bb9d1654d04$var$_writeHeartbeatsToIndexedDB = (0, $5Pgs2._)(function(app, heartbeatObject) {
        var db, tx, objectStore, e, idbGetError;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $202a4bb9d1654d04$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($202a4bb9d1654d04$var$STORE_NAME, "readwrite");
                    objectStore = tx.objectStore($202a4bb9d1654d04$var$STORE_NAME);
                    return [
                        4,
                        objectStore.put(heartbeatObject, $202a4bb9d1654d04$var$computeKey(app))
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        tx.done
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $cxgyp.FirebaseError)) $202a4bb9d1654d04$var$logger.warn(e.message);
                    else {
                        idbGetError = $202a4bb9d1654d04$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                            originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                        });
                        $202a4bb9d1654d04$var$logger.warn(idbGetError.message);
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $202a4bb9d1654d04$var$_writeHeartbeatsToIndexedDB.apply(this, arguments);
}
function $202a4bb9d1654d04$var$computeKey(app) {
    return "".concat(app.name, "!").concat(app.options.appId);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $202a4bb9d1654d04$var$MAX_HEADER_BYTES = 1024;
// 30 days
var $202a4bb9d1654d04$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
var $202a4bb9d1654d04$var$HeartbeatServiceImpl = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatServiceImpl(container) {
        var _this = this;
        (0, $50OuQ._)(this, HeartbeatServiceImpl);
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        var app = this.container.getProvider("app").getImmediate();
        this._storage = new $202a4bb9d1654d04$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(function(result) {
            _this._heartbeatsCache = result;
            return result;
        });
    }
    (0, $fGdZr._)(HeartbeatServiceImpl, [
        {
            key: "triggerHeartbeat",
            value: /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ function triggerHeartbeat() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var platformLogger, agent, date;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                platformLogger = _this.container.getProvider("platform-logger").getImmediate();
                                agent = platformLogger.getPlatformInfoString();
                                date = $202a4bb9d1654d04$var$getUTCDateString();
                                if (!(_this._heartbeatsCache === null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._heartbeatsCachePromise
                                ];
                            case 1:
                                _this._heartbeatsCache = _state.sent();
                                _state.label = 2;
                            case 2:
                                // Do not store a heartbeat if one is already stored for this day
                                // or if a header has already been sent today.
                                if (_this._heartbeatsCache.lastSentHeartbeatDate === date || _this._heartbeatsCache.heartbeats.some(function(singleDateHeartbeat) {
                                    return singleDateHeartbeat.date === date;
                                })) return [
                                    2
                                ];
                                else // There is no entry for this date. Create one.
                                _this._heartbeatsCache.heartbeats.push({
                                    date: date,
                                    agent: agent
                                });
                                // Remove entries older than 30 days.
                                _this._heartbeatsCache.heartbeats = _this._heartbeatsCache.heartbeats.filter(function(singleDateHeartbeat) {
                                    var hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                                    var now = Date.now();
                                    return now - hbTimestamp <= $202a4bb9d1654d04$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
                                });
                                return [
                                    2,
                                    _this._storage.overwrite(_this._heartbeatsCache)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getHeartbeatsHeader",
            value: /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ function getHeartbeatsHeader() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var date, _extractHeartbeatsForHeader, heartbeatsToSend, unsentEntries, headerString;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this._heartbeatsCache === null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._heartbeatsCachePromise
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // If it's still null or the array is empty, there is no data to send.
                                if (_this._heartbeatsCache === null || _this._heartbeatsCache.heartbeats.length === 0) return [
                                    2,
                                    ""
                                ];
                                date = $202a4bb9d1654d04$var$getUTCDateString();
                                _extractHeartbeatsForHeader = $202a4bb9d1654d04$var$extractHeartbeatsForHeader(_this._heartbeatsCache.heartbeats), heartbeatsToSend = _extractHeartbeatsForHeader.heartbeatsToSend, unsentEntries = _extractHeartbeatsForHeader.unsentEntries;
                                headerString = (0, $cxgyp.base64urlEncodeWithoutPadding)(JSON.stringify({
                                    version: 2,
                                    heartbeats: heartbeatsToSend
                                }));
                                // Store last sent date to prevent another being logged/sent for the same day.
                                _this._heartbeatsCache.lastSentHeartbeatDate = date;
                                if (!(unsentEntries.length > 0)) return [
                                    3,
                                    4
                                ];
                                // Store any unsent entries if they exist.
                                _this._heartbeatsCache.heartbeats = unsentEntries;
                                // This seems more likely than emptying the array (below) to lead to some odd state
                                // since the cache isn't empty and this will be called again on the next request,
                                // and is probably safest if we await it.
                                return [
                                    4,
                                    _this._storage.overwrite(_this._heartbeatsCache)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _this._heartbeatsCache.heartbeats = [];
                                _this._storage.overwrite(_this._heartbeatsCache);
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    headerString
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return HeartbeatServiceImpl;
}();
function $202a4bb9d1654d04$var$getUTCDateString() {
    var today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $202a4bb9d1654d04$var$extractHeartbeatsForHeader(heartbeatsCache) {
    var maxSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $202a4bb9d1654d04$var$MAX_HEADER_BYTES;
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    var heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    var unsentEntries = heartbeatsCache.slice();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var singleDateHeartbeat = _step.value;
            // Look for an existing entry with the same user agent.
            var heartbeatEntry = heartbeatsToSend.find(function(hb) {
                return hb.agent === singleDateHeartbeat.agent;
            });
            if (!heartbeatEntry) {
                // If no entry for this user agent exists, create one.
                heartbeatsToSend.push({
                    agent: singleDateHeartbeat.agent,
                    dates: [
                        singleDateHeartbeat.date
                    ]
                });
                if ($202a4bb9d1654d04$var$countBytes(heartbeatsToSend) > maxSize) {
                    // If the header would exceed max size, remove the added heartbeat
                    // entry and stop adding to the header.
                    heartbeatsToSend.pop();
                    return "break";
                }
            } else {
                heartbeatEntry.dates.push(singleDateHeartbeat.date);
                // If the header would exceed max size, remove the added date
                // and stop adding to the header.
                if ($202a4bb9d1654d04$var$countBytes(heartbeatsToSend) > maxSize) {
                    heartbeatEntry.dates.pop();
                    return "break";
                }
            }
            // Pop unsent entry from queue. (Skipped if adding the entry exceeded
            // quota and the loop breaks early.)
            unsentEntries = unsentEntries.slice(1);
        };
        for(var _iterator = heartbeatsCache[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if (_ret === "break") break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
var $202a4bb9d1654d04$var$HeartbeatStorageImpl = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatStorageImpl(app) {
        (0, $50OuQ._)(this, HeartbeatStorageImpl);
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    (0, $fGdZr._)(HeartbeatStorageImpl, [
        {
            key: "runIndexedDBEnvironmentCheck",
            value: function runIndexedDBEnvironmentCheck() {
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        if (!(0, $cxgyp.isIndexedDBAvailable)()) return [
                            2,
                            false
                        ];
                        else return [
                            2,
                            (0, $cxgyp.validateIndexedDBOpenable)().then(function() {
                                return true;
                            })["catch"](function() {
                                return false;
                            })
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "read",
            value: /**
     * Read all heartbeats.
     */ function read() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var canUseIndexedDB, idbHeartbeatObject;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2,
                                    {
                                        heartbeats: []
                                    }
                                ];
                            case 2:
                                return [
                                    4,
                                    $202a4bb9d1654d04$var$readHeartbeatsFromIndexedDB(_this.app)
                                ];
                            case 3:
                                idbHeartbeatObject = _state.sent();
                                return [
                                    2,
                                    idbHeartbeatObject || {
                                        heartbeats: []
                                    }
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "overwrite",
            value: // overwrite the storage with the provided heartbeats
            function overwrite(heartbeatsObject) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, canUseIndexedDB, existingHeartbeatsObject;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.read()
                                ];
                            case 3:
                                existingHeartbeatsObject = _state.sent();
                                return [
                                    2,
                                    $202a4bb9d1654d04$var$writeHeartbeatsToIndexedDB(_this.app, {
                                        lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                                        heartbeats: heartbeatsObject.heartbeats
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "add",
            value: // add heartbeats
            function add(heartbeatsObject) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, canUseIndexedDB, existingHeartbeatsObject;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.read()
                                ];
                            case 3:
                                existingHeartbeatsObject = _state.sent();
                                return [
                                    2,
                                    $202a4bb9d1654d04$var$writeHeartbeatsToIndexedDB(_this.app, {
                                        lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                                        heartbeats: (0, $dHvbf._)(existingHeartbeatsObject.heartbeats).concat((0, $dHvbf._)(heartbeatsObject.heartbeats))
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return HeartbeatStorageImpl;
}();
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $202a4bb9d1654d04$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $cxgyp.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $202a4bb9d1654d04$var$registerCoreComponents(variant) {
    $202a4bb9d1654d04$export$c930050e7bb63965(new (0, $bDt5L.Component)("platform-logger", function(container) {
        return new $202a4bb9d1654d04$var$PlatformLoggerServiceImpl(container);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ));
    $202a4bb9d1654d04$export$c930050e7bb63965(new (0, $bDt5L.Component)("heartbeat", function(container) {
        return new $202a4bb9d1654d04$var$HeartbeatServiceImpl(container);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $202a4bb9d1654d04$export$d29d5299a7137abc($202a4bb9d1654d04$var$name$o, $202a4bb9d1654d04$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $202a4bb9d1654d04$export$d29d5299a7137abc($202a4bb9d1654d04$var$name$o, $202a4bb9d1654d04$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $202a4bb9d1654d04$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $202a4bb9d1654d04$var$registerCoreComponents("");

});
parcelRequire.register("bDt5L", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $8789e744931cd304$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $8789e744931cd304$export$436a80eea5d5c0c5; });

var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $1XfpH = parcelRequire("1XfpH");

var $cxgyp = parcelRequire("cxgyp");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ var $8789e744931cd304$export$16fa2f45be04daa8 = /*#__PURE__*/ function() {
    "use strict";
    function Component(name, instanceFactory, type) {
        (0, $50OuQ._)(this, Component);
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    (0, $fGdZr._)(Component, [
        {
            key: "setInstantiationMode",
            value: function setInstantiationMode(mode) {
                this.instantiationMode = mode;
                return this;
            }
        },
        {
            key: "setMultipleInstances",
            value: function setMultipleInstances(multipleInstances) {
                this.multipleInstances = multipleInstances;
                return this;
            }
        },
        {
            key: "setServiceProps",
            value: function setServiceProps(props) {
                this.serviceProps = props;
                return this;
            }
        },
        {
            key: "setInstanceCreatedCallback",
            value: function setInstanceCreatedCallback(callback) {
                this.onInstanceCreated = callback;
                return this;
            }
        }
    ]);
    return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8789e744931cd304$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ var $8789e744931cd304$export$2881499e37b75b9a = /*#__PURE__*/ function() {
    "use strict";
    function Provider(name, container) {
        (0, $50OuQ._)(this, Provider);
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    (0, $fGdZr._)(Provider, [
        {
            /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ key: "get",
            value: function get(identifier) {
                // if multipleInstances is not supported, use the default name
                var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
                if (!this.instancesDeferred.has(normalizedIdentifier)) {
                    var deferred = new (0, $cxgyp.Deferred)();
                    this.instancesDeferred.set(normalizedIdentifier, deferred);
                    if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
                    try {
                        var instance = this.getOrInitializeService({
                            instanceIdentifier: normalizedIdentifier
                        });
                        if (instance) deferred.resolve(instance);
                    } catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                    }
                }
                return this.instancesDeferred.get(normalizedIdentifier).promise;
            }
        },
        {
            key: "getImmediate",
            value: function getImmediate(options) {
                var _a;
                // if multipleInstances is not supported, use the default name
                var normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
                var optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
                if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
                    return this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                } catch (e) {
                    if (optional) return null;
                    else throw e;
                }
                else {
                    // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
                    if (optional) return null;
                    else throw Error("Service ".concat(this.name, " is not available"));
                }
            }
        },
        {
            key: "getComponent",
            value: function getComponent() {
                return this.component;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(component) {
                if (component.name !== this.name) throw Error("Mismatching Component ".concat(component.name, " for Provider ").concat(this.name, "."));
                if (this.component) throw Error("Component for ".concat(this.name, " has already been provided"));
                this.component = component;
                // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
                if (!this.shouldAutoInitialize()) return;
                // if the service is eager, initialize the default instance
                if ($8789e744931cd304$var$isComponentEager(component)) try {
                    this.getOrInitializeService({
                        instanceIdentifier: $8789e744931cd304$var$DEFAULT_ENTRY_NAME
                    });
                } catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Create service instances for the pending promises and resolve them
                    // NOTE: if this.multipleInstances is false, only the default instance will be created
                    // and all promises with resolve with it regardless of the identifier.
                    for(var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $aSMts._)(_step.value, 2), instanceIdentifier = _step_value[0], instanceDeferred = _step_value[1];
                        var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                        try {
                            // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                            var instance = this.getOrInitializeService({
                                instanceIdentifier: normalizedIdentifier
                            });
                            instanceDeferred.resolve(instance);
                        } catch (e) {
                        // when the instance factory throws an exception, it should not cause
                        // a fatal error. We just leave the promise unresolved.
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "clearInstance",
            value: function clearInstance() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $8789e744931cd304$var$DEFAULT_ENTRY_NAME;
                this.instancesDeferred["delete"](identifier);
                this.instancesOptions["delete"](identifier);
                this.instances["delete"](identifier);
            }
        },
        {
            key: "delete",
            value: // app.delete() will call this method on every provider to delete the services
            // TODO: should we mark the provider as deleted?
            function _delete() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var services;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                services = Array.from(_this.instances.values());
                                return [
                                    4,
                                    Promise.all((0, $dHvbf._)(services.filter(function(service) {
                                        return "INTERNAL" in service;
                                    }) // legacy services
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .map(function(service) {
                                        return service.INTERNAL["delete"]();
                                    })).concat((0, $dHvbf._)(services.filter(function(service) {
                                        return "_delete" in service;
                                    }) // modularized services
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .map(function(service) {
                                        return service._delete();
                                    }))))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isComponentSet",
            value: function isComponentSet() {
                return this.component != null;
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $8789e744931cd304$var$DEFAULT_ENTRY_NAME;
                return this.instances.has(identifier);
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $8789e744931cd304$var$DEFAULT_ENTRY_NAME;
                return this.instancesOptions.get(identifier) || {};
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _opts_options = opts.options, options = _opts_options === void 0 ? {} : _opts_options;
                var normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
                if (this.isInitialized(normalizedIdentifier)) throw Error("".concat(this.name, "(").concat(normalizedIdentifier, ") has already been initialized"));
                if (!this.isComponentSet()) throw Error("Component ".concat(this.name, " has not been registered yet"));
                var instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier,
                    options: options
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // resolve any pending promise waiting for the service instance
                    for(var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $aSMts._)(_step.value, 2), instanceIdentifier = _step_value[0], instanceDeferred = _step_value[1];
                        var normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                        if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return instance;
            }
        },
        {
            /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ key: "onInit",
            value: function onInit(callback, identifier) {
                var _a;
                var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
                var existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
                existingCallbacks.add(callback);
                this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
                var existingInstance = this.instances.get(normalizedIdentifier);
                if (existingInstance) callback(existingInstance, normalizedIdentifier);
                return function() {
                    existingCallbacks["delete"](callback);
                };
            }
        },
        {
            /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ key: "invokeOnInitCallbacks",
            value: function invokeOnInitCallbacks(instance, identifier) {
                var callbacks = this.onInitCallbacks.get(identifier);
                if (!callbacks) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var callback = _step.value;
                        try {
                            callback(instance, identifier);
                        } catch (_a) {
                        // ignore errors in the onInit callback
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getOrInitializeService",
            value: function getOrInitializeService(param) {
                var instanceIdentifier = param.instanceIdentifier, _param_options = param.options, options = _param_options === void 0 ? {} : _param_options;
                var instance = this.instances.get(instanceIdentifier);
                if (!instance && this.component) {
                    instance = this.component.instanceFactory(this.container, {
                        instanceIdentifier: $8789e744931cd304$var$normalizeIdentifierForFactory(instanceIdentifier),
                        options: options
                    });
                    this.instances.set(instanceIdentifier, instance);
                    this.instancesOptions.set(instanceIdentifier, options);
                    /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
                    /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                        this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                    } catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                    }
                }
                return instance || null;
            }
        },
        {
            key: "normalizeInstanceIdentifier",
            value: function normalizeInstanceIdentifier() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $8789e744931cd304$var$DEFAULT_ENTRY_NAME;
                if (this.component) return this.component.multipleInstances ? identifier : $8789e744931cd304$var$DEFAULT_ENTRY_NAME;
                else return identifier; // assume multiple instances are supported before the component is provided.
            }
        },
        {
            key: "shouldAutoInitialize",
            value: function shouldAutoInitialize() {
                return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
            }
        }
    ]);
    return Provider;
}();
// undefined should be passed to the service factory for the default instance
function $8789e744931cd304$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $8789e744931cd304$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $8789e744931cd304$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ var $8789e744931cd304$export$436a80eea5d5c0c5 = /*#__PURE__*/ function() {
    "use strict";
    function ComponentContainer(name) {
        (0, $50OuQ._)(this, ComponentContainer);
        this.name = name;
        this.providers = new Map();
    }
    (0, $fGdZr._)(ComponentContainer, [
        {
            /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ key: "addComponent",
            value: function addComponent(component) {
                var provider = this.getProvider(component.name);
                if (provider.isComponentSet()) throw new Error("Component ".concat(component.name, " has already been registered with ").concat(this.name));
                provider.setComponent(component);
            }
        },
        {
            key: "addOrOverwriteComponent",
            value: function addOrOverwriteComponent(component) {
                var provider = this.getProvider(component.name);
                if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
                this.providers["delete"](component.name);
                this.addComponent(component);
            }
        },
        {
            /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ key: "getProvider",
            value: function getProvider(name) {
                if (this.providers.has(name)) return this.providers.get(name);
                // create a Provider for a service that hasn't registered with Firebase
                var provider = new $8789e744931cd304$export$2881499e37b75b9a(name, this);
                this.providers.set(name, provider);
                return provider;
            }
        },
        {
            key: "getProviders",
            value: function getProviders() {
                return Array.from(this.providers.values());
            }
        }
    ]);
    return ComponentContainer;
}();

});

parcelRequire.register("1dgkP", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $0e23ad1f7febd798$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $0e23ad1f7febd798$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $0e23ad1f7febd798$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $0e23ad1f7febd798$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ 
var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $2iBlG = parcelRequire("2iBlG");

var $dHvbf = parcelRequire("dHvbf");
var $0e23ad1f7febd798$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $0e23ad1f7febd798$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($0e23ad1f7febd798$export$243e62d78d3b544d || ($0e23ad1f7febd798$export$243e62d78d3b544d = {}));
var $0e23ad1f7febd798$var$levelStringToEnum = {
    debug: $0e23ad1f7febd798$export$243e62d78d3b544d.DEBUG,
    verbose: $0e23ad1f7febd798$export$243e62d78d3b544d.VERBOSE,
    info: $0e23ad1f7febd798$export$243e62d78d3b544d.INFO,
    warn: $0e23ad1f7febd798$export$243e62d78d3b544d.WARN,
    error: $0e23ad1f7febd798$export$243e62d78d3b544d.ERROR,
    silent: $0e23ad1f7febd798$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ var $0e23ad1f7febd798$var$defaultLogLevel = $0e23ad1f7febd798$export$243e62d78d3b544d.INFO;
var $0e23ad1f7febd798$var$_obj;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ var $0e23ad1f7febd798$var$ConsoleMethod = ($0e23ad1f7febd798$var$_obj = {}, (0, $2iBlG._)($0e23ad1f7febd798$var$_obj, $0e23ad1f7febd798$export$243e62d78d3b544d.DEBUG, "log"), (0, $2iBlG._)($0e23ad1f7febd798$var$_obj, $0e23ad1f7febd798$export$243e62d78d3b544d.VERBOSE, "log"), (0, $2iBlG._)($0e23ad1f7febd798$var$_obj, $0e23ad1f7febd798$export$243e62d78d3b544d.INFO, "info"), (0, $2iBlG._)($0e23ad1f7febd798$var$_obj, $0e23ad1f7febd798$export$243e62d78d3b544d.WARN, "warn"), (0, $2iBlG._)($0e23ad1f7febd798$var$_obj, $0e23ad1f7febd798$export$243e62d78d3b544d.ERROR, "error"), $0e23ad1f7febd798$var$_obj);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ var $0e23ad1f7febd798$var$defaultLogHandler = function(instance, logType) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var _console;
    if (logType < instance.logLevel) return;
    var now = new Date().toISOString();
    var method = $0e23ad1f7febd798$var$ConsoleMethod[logType];
    if (method) (_console = console)[method].apply(_console, [
        "[".concat(now, "]  ").concat(instance.name, ":")
    ].concat((0, $dHvbf._)(args)));
    else throw new Error("Attempted to log a message with an invalid logType (value: ".concat(logType, ")"));
};
var $0e23ad1f7febd798$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    "use strict";
    function Logger(name) {
        (0, $50OuQ._)(this, Logger);
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $0e23ad1f7febd798$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $0e23ad1f7febd798$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $0e23ad1f7febd798$var$instances.push(this);
    }
    (0, $fGdZr._)(Logger, [
        {
            key: "logLevel",
            get: function get() {
                return this._logLevel;
            },
            set: function set(val) {
                if (!(val in $0e23ad1f7febd798$export$243e62d78d3b544d)) throw new TypeError('Invalid value "'.concat(val, '" assigned to `logLevel`'));
                this._logLevel = val;
            }
        },
        {
            // Workaround for setter/getter having to be the same type.
            key: "setLogLevel",
            value: function setLogLevel(val) {
                this._logLevel = typeof val === "string" ? $0e23ad1f7febd798$var$levelStringToEnum[val] : val;
            }
        },
        {
            key: "logHandler",
            get: function get() {
                return this._logHandler;
            },
            set: function set(val) {
                if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
                this._logHandler = val;
            }
        },
        {
            key: "userLogHandler",
            get: function get() {
                return this._userLogHandler;
            },
            set: function set(val) {
                this._userLogHandler = val;
            }
        },
        {
            /**
     * The functions below are all based on the `console` interface
     */ key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $0e23ad1f7febd798$export$243e62d78d3b544d.DEBUG
                ].concat((0, $dHvbf._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $0e23ad1f7febd798$export$243e62d78d3b544d.DEBUG
                ].concat((0, $dHvbf._)(args)));
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $0e23ad1f7febd798$export$243e62d78d3b544d.VERBOSE
                ].concat((0, $dHvbf._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $0e23ad1f7febd798$export$243e62d78d3b544d.VERBOSE
                ].concat((0, $dHvbf._)(args)));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $0e23ad1f7febd798$export$243e62d78d3b544d.INFO
                ].concat((0, $dHvbf._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $0e23ad1f7febd798$export$243e62d78d3b544d.INFO
                ].concat((0, $dHvbf._)(args)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $0e23ad1f7febd798$export$243e62d78d3b544d.WARN
                ].concat((0, $dHvbf._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $0e23ad1f7febd798$export$243e62d78d3b544d.WARN
                ].concat((0, $dHvbf._)(args)));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $0e23ad1f7febd798$export$243e62d78d3b544d.ERROR
                ].concat((0, $dHvbf._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $0e23ad1f7febd798$export$243e62d78d3b544d.ERROR
                ].concat((0, $dHvbf._)(args)));
            }
        }
    ]);
    return Logger;
}();
function $0e23ad1f7febd798$export$c622e99c0ce7b1c9(level) {
    $0e23ad1f7febd798$var$instances.forEach(function(inst) {
        inst.setLogLevel(level);
    });
}
function $0e23ad1f7febd798$export$29577d29c84db5f6(logCallback, options) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var instance = _step.value;
            var customLogLevel = null;
            if (options && options.level) customLogLevel = $0e23ad1f7febd798$var$levelStringToEnum[options.level];
            if (logCallback === null) instance.userLogHandler = null;
            else instance.userLogHandler = function(instance, level) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var message = args.map(function(arg) {
                    if (arg == null) return null;
                    else if (typeof arg === "string") return arg;
                    else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                    else if (arg instanceof Error) return arg.message;
                    else try {
                        return JSON.stringify(arg);
                    } catch (ignored) {
                        return null;
                    }
                }).filter(function(arg) {
                    return arg;
                }).join(" ");
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                    level: $0e23ad1f7febd798$export$243e62d78d3b544d[level].toLowerCase(),
                    message: message,
                    args: args,
                    type: instance.name
                });
            };
        };
        for(var _iterator = $0e23ad1f7febd798$var$instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

});

parcelRequire.register("2XDnt", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $227fa3057980f7a3$export$ca0ed41b1a2af7e; });

var $5Pgs2 = parcelRequire("5Pgs2");

var $6Vnm7 = parcelRequire("6Vnm7");

var $2SZ1L = parcelRequire("2SZ1L");

var $dHvbf = parcelRequire("dHvbf");

var $1XfpH = parcelRequire("1XfpH");

var $aEWhi = parcelRequire("aEWhi");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $227fa3057980f7a3$export$ca0ed41b1a2af7e(name, version) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, blocked = _ref.blocked, upgrade = _ref.upgrade, blocking = _ref.blocking, terminated = _ref.terminated;
    var request = indexedDB.open(name, version);
    var openPromise = (0, $aEWhi.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", function(event) {
        upgrade((0, $aEWhi.w)(request.result), event.oldVersion, event.newVersion, (0, $aEWhi.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", function(event) {
        return blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event);
    });
    openPromise.then(function(db) {
        if (terminated) db.addEventListener("close", function() {
            return terminated();
        });
        if (blocking) db.addEventListener("versionchange", function(event) {
            return blocking(event.oldVersion, event.newVersion, event);
        });
    })["catch"](function() {});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $227fa3057980f7a3$export$9d6df0ac66a98bb2(name) {
    var blocked = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).blocked;
    var request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", function(event) {
        return blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event);
    });
    return (0, $aEWhi.w)(request).then(function() {
        return undefined;
    });
}
var $227fa3057980f7a3$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
var $227fa3057980f7a3$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
var $227fa3057980f7a3$var$cachedMethods = new Map();
function $227fa3057980f7a3$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($227fa3057980f7a3$var$cachedMethods.get(prop)) return $227fa3057980f7a3$var$cachedMethods.get(prop);
    var targetFuncName = prop.replace(/FromIndex$/, "");
    var useIndex = prop !== targetFuncName;
    var isWrite = $227fa3057980f7a3$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $227fa3057980f7a3$var$readMethods.includes(targetFuncName))) return;
    var method = function() {
        var _ref = (0, $5Pgs2._)(function(storeName) {
            var _len, args, _key, _target, tx, _$target;
            var _arguments = arguments;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = _arguments[_key];
                        }
                        tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
                        _$target = tx.store;
                        if (useIndex) _$target = _$target.index(args.shift());
                        return [
                            4,
                            Promise.all([
                                (_target = _$target)[targetFuncName].apply(_target, (0, $dHvbf._)(args)),
                                isWrite && tx.done
                            ])
                        ];
                    case 1:
                        // Must reject if op rejects.
                        // If it's a write operation, must reject if tx.done rejects.
                        // Must reject with op rejection first.
                        // Must resolve with op value.
                        // Must handle both promises (no unhandled rejections)
                        return [
                            2,
                            _state.sent()[0]
                        ];
                }
            });
        });
        return function method(storeName) {
            return _ref.apply(this, arguments);
        };
    }();
    $227fa3057980f7a3$var$cachedMethods.set(prop, method);
    return method;
}
(0, $aEWhi.r)(function(oldTraps) {
    return (0, $2SZ1L._)((0, $6Vnm7._)({}, oldTraps), {
        get: function(target, prop, receiver) {
            return $227fa3057980f7a3$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver);
        },
        has: function(target, prop) {
            return !!$227fa3057980f7a3$var$getMethod(target, prop) || oldTraps.has(target, prop);
        }
    });
});

});
parcelRequire.register("6Vnm7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $50aa2eeb65885e7e$export$581ff339ea0ba762; });

var $2iBlG = parcelRequire("2iBlG");
function $50aa2eeb65885e7e$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $2iBlG._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRequire.register("2SZ1L", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $219ff6b9141574a5$export$4fa2f4023c9cbda5; });
function $219ff6b9141574a5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $219ff6b9141574a5$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $219ff6b9141574a5$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRequire.register("aEWhi", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $7c2ad8970e90fcb9$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $7c2ad8970e90fcb9$export$43caf9889c228507; });

var $dHvbf = parcelRequire("dHvbf");
var $7c2ad8970e90fcb9$export$23f2a1d2818174ef = function(object, constructors) {
    return constructors.some(function(c) {
        return object instanceof c;
    });
};
var $7c2ad8970e90fcb9$var$idbProxyableTypes;
var $7c2ad8970e90fcb9$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $7c2ad8970e90fcb9$var$getIdbProxyableTypes() {
    return $7c2ad8970e90fcb9$var$idbProxyableTypes || ($7c2ad8970e90fcb9$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $7c2ad8970e90fcb9$var$getCursorAdvanceMethods() {
    return $7c2ad8970e90fcb9$var$cursorAdvanceMethods || ($7c2ad8970e90fcb9$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype["continue"],
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
var $7c2ad8970e90fcb9$var$cursorRequestMap = new WeakMap();
var $7c2ad8970e90fcb9$var$transactionDoneMap = new WeakMap();
var $7c2ad8970e90fcb9$var$transactionStoreNamesMap = new WeakMap();
var $7c2ad8970e90fcb9$var$transformCache = new WeakMap();
var $7c2ad8970e90fcb9$export$407448d2b89b1813 = new WeakMap();
function $7c2ad8970e90fcb9$var$promisifyRequest(request) {
    var promise = new Promise(function(resolve, reject) {
        var unlisten = function() {
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        var success = function() {
            resolve($7c2ad8970e90fcb9$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        var error = function() {
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then(function(value) {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $7c2ad8970e90fcb9$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    })["catch"](function() {});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $7c2ad8970e90fcb9$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $7c2ad8970e90fcb9$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($7c2ad8970e90fcb9$var$transactionDoneMap.has(tx)) return;
    var done = new Promise(function(resolve, reject) {
        var unlisten = function() {
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        var complete = function() {
            resolve();
            unlisten();
        };
        var error = function() {
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $7c2ad8970e90fcb9$var$transactionDoneMap.set(tx, done);
}
var $7c2ad8970e90fcb9$var$idbProxyTraps = {
    get: function(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $7c2ad8970e90fcb9$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $7c2ad8970e90fcb9$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $7c2ad8970e90fcb9$export$efccba1c4a2ef57b(target[prop]);
    },
    set: function(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has: function(target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $7c2ad8970e90fcb9$export$43caf9889c228507(callback) {
    $7c2ad8970e90fcb9$var$idbProxyTraps = callback($7c2ad8970e90fcb9$var$idbProxyTraps);
}
function $7c2ad8970e90fcb9$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _func;
        var tx = (_func = func).call.apply(_func, [
            $7c2ad8970e90fcb9$export$3b14a55fb2447963(this),
            storeNames
        ].concat((0, $dHvbf._)(args)));
        $7c2ad8970e90fcb9$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $7c2ad8970e90fcb9$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($7c2ad8970e90fcb9$var$getCursorAdvanceMethods().includes(func)) return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($7c2ad8970e90fcb9$export$3b14a55fb2447963(this), args);
        return $7c2ad8970e90fcb9$export$efccba1c4a2ef57b($7c2ad8970e90fcb9$var$cursorRequestMap.get(this));
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $7c2ad8970e90fcb9$export$efccba1c4a2ef57b(func.apply($7c2ad8970e90fcb9$export$3b14a55fb2447963(this), args));
    };
}
function $7c2ad8970e90fcb9$var$transformCachableValue(value) {
    if (typeof value === "function") return $7c2ad8970e90fcb9$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $7c2ad8970e90fcb9$var$cacheDonePromiseForTransaction(value);
    if ($7c2ad8970e90fcb9$export$23f2a1d2818174ef(value, $7c2ad8970e90fcb9$var$getIdbProxyableTypes())) return new Proxy(value, $7c2ad8970e90fcb9$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $7c2ad8970e90fcb9$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $7c2ad8970e90fcb9$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($7c2ad8970e90fcb9$var$transformCache.has(value)) return $7c2ad8970e90fcb9$var$transformCache.get(value);
    var newValue = $7c2ad8970e90fcb9$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $7c2ad8970e90fcb9$var$transformCache.set(value, newValue);
        $7c2ad8970e90fcb9$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
var $7c2ad8970e90fcb9$export$3b14a55fb2447963 = function(value) {
    return $7c2ad8970e90fcb9$export$407448d2b89b1813.get(value);
};

});






parcelRequire.register("ez2pC", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("02kAW")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("2wq0j")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("49c73")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hFkpD = parcelRequire("hFkpD");

var $komL5 = parcelRequire("komL5");
parcelRequire("e7CGD");
var $hDjAY = parcelRequire("hDjAY");

var $2ueeS = parcelRequire("2ueeS");

var $49c73 = parcelRequire("49c73");

var $kzD7d = parcelRequire("kzD7d");
parcelRequire("c0XUh");
(0, $49c73.initializeUseSelector)((0, $komL5.useSyncExternalStoreWithSelector));
(0, $kzD7d.initializeConnect)((0, $hFkpD.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $2ueeS.setBatch)((0, $hDjAY.unstable_batchedUpdates));

});
parcelRequire.register("hFkpD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("i454y"));

});
parcelRequire.register("i454y", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $d26c890179f4fed1$export$306c0aa65ff9ec16; }, function (v) { return $d26c890179f4fed1$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d26c890179f4fed1$export$306c0aa65ff9ec16;
"use strict";

var $3aC2T = parcelRequire("3aC2T");
function $d26c890179f4fed1$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d26c890179f4fed1$var$k = "function" === typeof Object.is ? Object.is : $d26c890179f4fed1$var$h, $d26c890179f4fed1$var$l = $3aC2T.useState, $d26c890179f4fed1$var$m = $3aC2T.useEffect, $d26c890179f4fed1$var$n = $3aC2T.useLayoutEffect, $d26c890179f4fed1$var$p = $3aC2T.useDebugValue;
function $d26c890179f4fed1$var$q(a, b) {
    var d = b(), f = $d26c890179f4fed1$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $d26c890179f4fed1$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $d26c890179f4fed1$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $d26c890179f4fed1$var$m(function() {
        $d26c890179f4fed1$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $d26c890179f4fed1$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $d26c890179f4fed1$var$p(d);
    return d;
}
function $d26c890179f4fed1$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$d26c890179f4fed1$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $d26c890179f4fed1$var$t(a, b) {
    return b();
}
var $d26c890179f4fed1$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $d26c890179f4fed1$var$t : $d26c890179f4fed1$var$q;
$d26c890179f4fed1$export$306c0aa65ff9ec16 = void 0 !== $3aC2T.useSyncExternalStore ? $3aC2T.useSyncExternalStore : $d26c890179f4fed1$var$u;

});


parcelRequire.register("komL5", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4qFey"));

});
parcelRequire.register("4qFey", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $339993460797d79a$export$bf730a2d8bf68b42; }, function (v) { return $339993460797d79a$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $339993460797d79a$export$bf730a2d8bf68b42;
"use strict";

var $3aC2T = parcelRequire("3aC2T");

var $hFkpD = parcelRequire("hFkpD");
function $339993460797d79a$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $339993460797d79a$var$q = "function" === typeof Object.is ? Object.is : $339993460797d79a$var$p, $339993460797d79a$var$r = $hFkpD.useSyncExternalStore, $339993460797d79a$var$t = $3aC2T.useRef, $339993460797d79a$var$u = $3aC2T.useEffect, $339993460797d79a$var$v = $3aC2T.useMemo, $339993460797d79a$var$w = $3aC2T.useDebugValue;
$339993460797d79a$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $339993460797d79a$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $339993460797d79a$var$v(function() {
        var _$a = function _$a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var _$b = f.value;
                    if (g(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if ($339993460797d79a$var$q(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== g && g(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        };
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return _$a(b());
            },
            null === m ? void 0 : function() {
                return _$a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $339993460797d79a$var$r(a, c[0], c[1]);
    $339993460797d79a$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $339993460797d79a$var$w(d);
    return d;
};

});


parcelRequire.register("e7CGD", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("hDjAY")).unstable_batchedUpdates; });

var $hDjAY = parcelRequire("hDjAY");

});
parcelRequire.register("hDjAY", function(module, exports) {
"use strict";
function $cd654765cc6da6c6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($cd654765cc6da6c6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$cd654765cc6da6c6$var$checkDCE();

module.exports = (parcelRequire("diKvV"));

});


parcelRequire.register("2ueeS", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $1cf96da963d1fa37$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $1cf96da963d1fa37$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $1cf96da963d1fa37$var$defaultNoopBatch(callback) {
    callback();
}
var $1cf96da963d1fa37$var$batch = $1cf96da963d1fa37$var$defaultNoopBatch; // Allow injecting another batching function later
var $1cf96da963d1fa37$export$4b9874722d0da7bc = function(newBatch) {
    return $1cf96da963d1fa37$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $1cf96da963d1fa37$export$fc47d4c0ba3bd2c6 = function() {
    return $1cf96da963d1fa37$var$batch;
};

});

parcelRequire.register("49c73", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $3051660bb0058d96$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $3051660bb0058d96$export$2105062e25df4afe; });

var $2iBlG = parcelRequire("2iBlG");

var $3aC2T = parcelRequire("3aC2T");

var $9IOWJ = parcelRequire("9IOWJ");

var $1oXco = parcelRequire("1oXco");

var $fAbsz = parcelRequire("fAbsz");
var $3051660bb0058d96$var$useSyncExternalStoreWithSelector = (0, $fAbsz.notInitialized);
var $3051660bb0058d96$export$e2e6e3f3f3b782e3 = function(fn) {
    $3051660bb0058d96$var$useSyncExternalStoreWithSelector = fn;
};
var $3051660bb0058d96$var$refEquality = function(a, b) {
    return a === b;
};
function $3051660bb0058d96$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $1oXco.ReactReduxContext);
    var useReduxContext = context === (0, $1oXco.ReactReduxContext) ? (0, $9IOWJ.useReduxContext) : (0, $9IOWJ.createReduxContextHook)(context);
    return function useSelector(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $3051660bb0058d96$var$refEquality : _ref_equalityFn, stabilityCheck = _ref.stabilityCheck, noopCheck = _ref.noopCheck;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, subscription = _useReduxContext.subscription, getServerState = _useReduxContext.getServerState, globalStabilityCheck = _useReduxContext.stabilityCheck, globalNoopCheck = _useReduxContext.noopCheck;
        var firstRun = (0, $3aC2T.useRef)(true);
        var wrappedSelector = (0, $3aC2T.useCallback)((0, $2iBlG._)({}, selector.name, function(state) {
            var selected = selector(state);
            return selected;
        })[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        var selectedState = $3051660bb0058d96$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $3aC2T.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $3051660bb0058d96$export$2105062e25df4afe = /*#__PURE__*/ $3051660bb0058d96$export$2b53f90d2bd1cbfb();

});
parcelRequire.register("9IOWJ", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $713fbdfd53a6c909$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $713fbdfd53a6c909$export$c1275ca9a6fd3ec5; });

var $3aC2T = parcelRequire("3aC2T");

var $1oXco = parcelRequire("1oXco");
function $713fbdfd53a6c909$export$d4d6226d5fc61558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $1oXco.ReactReduxContext);
    return function useReduxContext() {
        var contextValue = (0, $3aC2T.useContext)(context);
        return contextValue;
    };
}
var $713fbdfd53a6c909$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $713fbdfd53a6c909$export$d4d6226d5fc61558();

});
parcelRequire.register("1oXco", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $1055f404276011f7$export$cc80c08dc91f1c00; });

var $3aC2T = parcelRequire("3aC2T");
var $1055f404276011f7$var$ContextKey = Symbol["for"]("react-redux-context");
var $1055f404276011f7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $1055f404276011f7$var$getContext() {
    var _gT$ContextKey;
    if (!$3aC2T.createContext) return {};
    var contextMap = (_gT$ContextKey = $1055f404276011f7$var$gT[$1055f404276011f7$var$ContextKey]) != null ? _gT$ContextKey : $1055f404276011f7$var$gT[$1055f404276011f7$var$ContextKey] = new Map();
    var realContext = contextMap.get($3aC2T.createContext);
    if (!realContext) {
        realContext = $3aC2T.createContext(null);
        contextMap.set($3aC2T.createContext, realContext);
    }
    return realContext;
}
var $1055f404276011f7$export$cc80c08dc91f1c00 = /*#__PURE__*/ $1055f404276011f7$var$getContext();
var $1055f404276011f7$export$2e2bcd8739ae039 = $1055f404276011f7$export$cc80c08dc91f1c00;

});


parcelRequire.register("fAbsz", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $b5831b7dba96b5ca$export$20656a4825650bd0; });
var $b5831b7dba96b5ca$export$20656a4825650bd0 = function() {
    throw new Error("uSES not initialized!");
};

});


parcelRequire.register("kzD7d", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $efa56b088272a604$export$36d45daa6a4925b8; });

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $6Sh9t = parcelRequire("6Sh9t");

var $3aC2T = parcelRequire("3aC2T");

var $4ti5v = parcelRequire("4ti5v");

var $5QFpY = parcelRequire("5QFpY");

var $jZG1d = parcelRequire("jZG1d");

var $2aeNF = parcelRequire("2aeNF");

var $1iaQT = parcelRequire("1iaQT");

var $iqiu0 = parcelRequire("iqiu0");

var $cPKVP = parcelRequire("cPKVP");

var $lzg6Z = parcelRequire("lzg6Z");
parcelRequire("aw0BK");

var $1oXco = parcelRequire("1oXco");

var $fAbsz = parcelRequire("fAbsz");
var $efa56b088272a604$var$_excluded = [
    "reactReduxForwardedRef"
];
var $efa56b088272a604$var$useSyncExternalStore = (0, $fAbsz.notInitialized);
var $efa56b088272a604$export$36d45daa6a4925b8 = function(fn) {
    $efa56b088272a604$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
var $efa56b088272a604$var$EMPTY_ARRAY = [
    null,
    0
];
var $efa56b088272a604$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
var $efa56b088272a604$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $efa56b088272a604$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $cPKVP.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, (0, $dHvbf._)(effectArgs));
    }, dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $efa56b088272a604$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $efa56b088272a604$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return function() {}; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
var $efa56b088272a604$var$initStateUpdates = function() {
    return $efa56b088272a604$var$EMPTY_ARRAY;
};
function $efa56b088272a604$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ var $efa56b088272a604$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $efa56b088272a604$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $efa56b088272a604$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? (0, $lzg6Z.default) : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? (0, $lzg6Z.default) : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? (0, $lzg6Z.default) : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? (0, $1oXco.ReactReduxContext) : _ref_context;
    var Context = context;
    var initMapStateToProps = (0, $2aeNF.mapStateToPropsFactory)(mapStateToProps);
    var initMapDispatchToProps = (0, $jZG1d.mapDispatchToPropsFactory)(mapDispatchToProps);
    var initMergeProps = (0, $1iaQT.mergePropsFactory)(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $aSMts._)($3aC2T.useMemo(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $8vpQL.default)(props, $efa56b088272a604$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $3aC2T.useMemo(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $4ti5v.isContextConsumer)(/*#__PURE__*/ $3aC2T.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = $3aC2T.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $3aC2T.useMemo(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $5QFpY.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $aSMts._)($3aC2T.useMemo(function() {
                if (!shouldHandleStateChanges) return $efa56b088272a604$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $iqiu0.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = $3aC2T.useMemo(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $3hDKy.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = $3aC2T.useRef();
            var lastWrapperProps = $3aC2T.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $3aC2T.useRef();
            var renderIsScheduled = $3aC2T.useRef(false);
            var isProcessingDispatch = $3aC2T.useRef(false);
            var isMounted = $3aC2T.useRef(false);
            var latestSubscriptionCallbackError = $3aC2T.useRef();
            (0, $cPKVP.useIsomorphicLayoutEffect)(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $3aC2T.useMemo(function() {
                var selector = function() {
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            var subscribeForReact = $3aC2T.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $efa56b088272a604$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $efa56b088272a604$var$useIsomorphicLayoutEffectWithArgs($efa56b088272a604$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $efa56b088272a604$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            (0, $cPKVP.useIsomorphicLayoutEffect)(function() {
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = $3aC2T.useMemo(function() {
                return(/*#__PURE__*/ // @ts-ignore
                $3aC2T.createElement(WrappedComponent, (0, $3hDKy.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = $3aC2T.useMemo(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $3aC2T.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $3aC2T.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $3aC2T.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $3aC2T.createElement(Connect, (0, $3hDKy.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6Sh9t)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($6Sh9t)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $efa56b088272a604$export$2e2bcd8739ae039 = $efa56b088272a604$var$connect;

});
parcelRequire.register("4ti5v", function(module, exports) {
"use strict";

module.exports = (parcelRequire("TRLtA"));

});
parcelRequire.register("TRLtA", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $0a7ed7ba24903fb8$export$a7c73072b1a182ae; }, function (v) { return $0a7ed7ba24903fb8$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $0a7ed7ba24903fb8$export$9f27bc3417b4524d; }, function (v) { return $0a7ed7ba24903fb8$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $0a7ed7ba24903fb8$export$db77ccec0bb4ccac; }, function (v) { return $0a7ed7ba24903fb8$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $0a7ed7ba24903fb8$export$8392c0c9d3dcbd35; }, function (v) { return $0a7ed7ba24903fb8$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0a7ed7ba24903fb8$export$ffb0004e005737fa; }, function (v) { return $0a7ed7ba24903fb8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $0a7ed7ba24903fb8$export$b624eff549462981; }, function (v) { return $0a7ed7ba24903fb8$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $0a7ed7ba24903fb8$export$7897aa7841a5380c; }, function (v) { return $0a7ed7ba24903fb8$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $0a7ed7ba24903fb8$export$602eac185826482c; }, function (v) { return $0a7ed7ba24903fb8$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $0a7ed7ba24903fb8$export$e2c29f18771995cb; }, function (v) { return $0a7ed7ba24903fb8$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0a7ed7ba24903fb8$export$5f8d39834fd61797; }, function (v) { return $0a7ed7ba24903fb8$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0a7ed7ba24903fb8$export$74bf444e3cd11ea5; }, function (v) { return $0a7ed7ba24903fb8$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $0a7ed7ba24903fb8$export$998bcd577473dd93; }, function (v) { return $0a7ed7ba24903fb8$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $0a7ed7ba24903fb8$export$92387174baf9b227; }, function (v) { return $0a7ed7ba24903fb8$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $0a7ed7ba24903fb8$export$ec112efeb987d9c6; }, function (v) { return $0a7ed7ba24903fb8$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $0a7ed7ba24903fb8$export$b706b080d889d2c9; }, function (v) { return $0a7ed7ba24903fb8$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $0a7ed7ba24903fb8$export$5be5a87408f70ddc; }, function (v) { return $0a7ed7ba24903fb8$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $0a7ed7ba24903fb8$export$45a5e7f76e0caa8d; }, function (v) { return $0a7ed7ba24903fb8$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $0a7ed7ba24903fb8$export$455c2e768291efa6; }, function (v) { return $0a7ed7ba24903fb8$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $0a7ed7ba24903fb8$export$9522e17588c12572; }, function (v) { return $0a7ed7ba24903fb8$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $0a7ed7ba24903fb8$export$2110ac352bb060b9; }, function (v) { return $0a7ed7ba24903fb8$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $0a7ed7ba24903fb8$export$56885ab8b9c456ab; }, function (v) { return $0a7ed7ba24903fb8$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $0a7ed7ba24903fb8$export$d927fcb6adf8f9de; }, function (v) { return $0a7ed7ba24903fb8$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $0a7ed7ba24903fb8$export$b82d16f27459e05a; }, function (v) { return $0a7ed7ba24903fb8$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $0a7ed7ba24903fb8$export$522c17b4f5e123e8; }, function (v) { return $0a7ed7ba24903fb8$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $0a7ed7ba24903fb8$export$1aabd8a0274ecfd6; }, function (v) { return $0a7ed7ba24903fb8$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $0a7ed7ba24903fb8$export$3d6c20d97e46b957; }, function (v) { return $0a7ed7ba24903fb8$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $0a7ed7ba24903fb8$export$9b621391a187a31a; }, function (v) { return $0a7ed7ba24903fb8$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $0a7ed7ba24903fb8$export$f5bbd400c2f4426f; }, function (v) { return $0a7ed7ba24903fb8$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0a7ed7ba24903fb8$export$a7c73072b1a182ae;
var $0a7ed7ba24903fb8$export$9f27bc3417b4524d;
var $0a7ed7ba24903fb8$export$db77ccec0bb4ccac;
var $0a7ed7ba24903fb8$export$8392c0c9d3dcbd35;
var $0a7ed7ba24903fb8$export$ffb0004e005737fa;
var $0a7ed7ba24903fb8$export$b624eff549462981;
var $0a7ed7ba24903fb8$export$7897aa7841a5380c;
var $0a7ed7ba24903fb8$export$602eac185826482c;
var $0a7ed7ba24903fb8$export$e2c29f18771995cb;
var $0a7ed7ba24903fb8$export$5f8d39834fd61797;
var $0a7ed7ba24903fb8$export$74bf444e3cd11ea5;
var $0a7ed7ba24903fb8$export$998bcd577473dd93;
var $0a7ed7ba24903fb8$export$92387174baf9b227;
var $0a7ed7ba24903fb8$export$ec112efeb987d9c6;
var $0a7ed7ba24903fb8$export$b706b080d889d2c9;
var $0a7ed7ba24903fb8$export$5be5a87408f70ddc;
var $0a7ed7ba24903fb8$export$45a5e7f76e0caa8d;
var $0a7ed7ba24903fb8$export$455c2e768291efa6;
var $0a7ed7ba24903fb8$export$9522e17588c12572;
var $0a7ed7ba24903fb8$export$2110ac352bb060b9;
var $0a7ed7ba24903fb8$export$56885ab8b9c456ab;
var $0a7ed7ba24903fb8$export$d927fcb6adf8f9de;
var $0a7ed7ba24903fb8$export$b82d16f27459e05a;
var $0a7ed7ba24903fb8$export$522c17b4f5e123e8;
var $0a7ed7ba24903fb8$export$1aabd8a0274ecfd6;
var $0a7ed7ba24903fb8$export$3d6c20d97e46b957;
var $0a7ed7ba24903fb8$export$9b621391a187a31a;
var $0a7ed7ba24903fb8$export$f5bbd400c2f4426f;
"use strict";
var $0a7ed7ba24903fb8$var$b = Symbol["for"]("react.element"), $0a7ed7ba24903fb8$var$c = Symbol["for"]("react.portal"), $0a7ed7ba24903fb8$var$d = Symbol["for"]("react.fragment"), $0a7ed7ba24903fb8$var$e = Symbol["for"]("react.strict_mode"), $0a7ed7ba24903fb8$var$f = Symbol["for"]("react.profiler"), $0a7ed7ba24903fb8$var$g = Symbol["for"]("react.provider"), $0a7ed7ba24903fb8$var$h = Symbol["for"]("react.context"), $0a7ed7ba24903fb8$var$k = Symbol["for"]("react.server_context"), $0a7ed7ba24903fb8$var$l = Symbol["for"]("react.forward_ref"), $0a7ed7ba24903fb8$var$m = Symbol["for"]("react.suspense"), $0a7ed7ba24903fb8$var$n = Symbol["for"]("react.suspense_list"), $0a7ed7ba24903fb8$var$p = Symbol["for"]("react.memo"), $0a7ed7ba24903fb8$var$q = Symbol["for"]("react.lazy"), $0a7ed7ba24903fb8$var$t = Symbol["for"]("react.offscreen"), $0a7ed7ba24903fb8$var$u;
$0a7ed7ba24903fb8$var$u = Symbol["for"]("react.module.reference");
function $0a7ed7ba24903fb8$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $0a7ed7ba24903fb8$var$b:
                switch(a = a.type, a){
                    case $0a7ed7ba24903fb8$var$d:
                    case $0a7ed7ba24903fb8$var$f:
                    case $0a7ed7ba24903fb8$var$e:
                    case $0a7ed7ba24903fb8$var$m:
                    case $0a7ed7ba24903fb8$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $0a7ed7ba24903fb8$var$k:
                            case $0a7ed7ba24903fb8$var$h:
                            case $0a7ed7ba24903fb8$var$l:
                            case $0a7ed7ba24903fb8$var$q:
                            case $0a7ed7ba24903fb8$var$p:
                            case $0a7ed7ba24903fb8$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $0a7ed7ba24903fb8$var$c:
                return r;
        }
    }
}
$0a7ed7ba24903fb8$export$a7c73072b1a182ae = $0a7ed7ba24903fb8$var$h;
$0a7ed7ba24903fb8$export$9f27bc3417b4524d = $0a7ed7ba24903fb8$var$g;
$0a7ed7ba24903fb8$export$db77ccec0bb4ccac = $0a7ed7ba24903fb8$var$b;
$0a7ed7ba24903fb8$export$8392c0c9d3dcbd35 = $0a7ed7ba24903fb8$var$l;
$0a7ed7ba24903fb8$export$ffb0004e005737fa = $0a7ed7ba24903fb8$var$d;
$0a7ed7ba24903fb8$export$b624eff549462981 = $0a7ed7ba24903fb8$var$q;
$0a7ed7ba24903fb8$export$7897aa7841a5380c = $0a7ed7ba24903fb8$var$p;
$0a7ed7ba24903fb8$export$602eac185826482c = $0a7ed7ba24903fb8$var$c;
$0a7ed7ba24903fb8$export$e2c29f18771995cb = $0a7ed7ba24903fb8$var$f;
$0a7ed7ba24903fb8$export$5f8d39834fd61797 = $0a7ed7ba24903fb8$var$e;
$0a7ed7ba24903fb8$export$74bf444e3cd11ea5 = $0a7ed7ba24903fb8$var$m;
$0a7ed7ba24903fb8$export$998bcd577473dd93 = $0a7ed7ba24903fb8$var$n;
$0a7ed7ba24903fb8$export$92387174baf9b227 = function() {
    return !1;
};
$0a7ed7ba24903fb8$export$ec112efeb987d9c6 = function() {
    return !1;
};
$0a7ed7ba24903fb8$export$b706b080d889d2c9 = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$h;
};
$0a7ed7ba24903fb8$export$5be5a87408f70ddc = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$g;
};
$0a7ed7ba24903fb8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0a7ed7ba24903fb8$var$b;
};
$0a7ed7ba24903fb8$export$455c2e768291efa6 = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$l;
};
$0a7ed7ba24903fb8$export$9522e17588c12572 = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$d;
};
$0a7ed7ba24903fb8$export$2110ac352bb060b9 = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$q;
};
$0a7ed7ba24903fb8$export$56885ab8b9c456ab = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$p;
};
$0a7ed7ba24903fb8$export$d927fcb6adf8f9de = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$c;
};
$0a7ed7ba24903fb8$export$b82d16f27459e05a = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$f;
};
$0a7ed7ba24903fb8$export$522c17b4f5e123e8 = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$e;
};
$0a7ed7ba24903fb8$export$1aabd8a0274ecfd6 = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$m;
};
$0a7ed7ba24903fb8$export$3d6c20d97e46b957 = function(a) {
    return $0a7ed7ba24903fb8$var$v(a) === $0a7ed7ba24903fb8$var$n;
};
$0a7ed7ba24903fb8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $0a7ed7ba24903fb8$var$d || a === $0a7ed7ba24903fb8$var$f || a === $0a7ed7ba24903fb8$var$e || a === $0a7ed7ba24903fb8$var$m || a === $0a7ed7ba24903fb8$var$n || a === $0a7ed7ba24903fb8$var$t || "object" === typeof a && null !== a && (a.$$typeof === $0a7ed7ba24903fb8$var$q || a.$$typeof === $0a7ed7ba24903fb8$var$p || a.$$typeof === $0a7ed7ba24903fb8$var$g || a.$$typeof === $0a7ed7ba24903fb8$var$h || a.$$typeof === $0a7ed7ba24903fb8$var$l || a.$$typeof === $0a7ed7ba24903fb8$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$0a7ed7ba24903fb8$export$f5bbd400c2f4426f = $0a7ed7ba24903fb8$var$v;

});


parcelRequire.register("5QFpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4421efd6d9cd8b84$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");
parcelRequire("6liOn");
var $4421efd6d9cd8b84$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $4421efd6d9cd8b84$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var handleFirstCall = function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    };
    var handleNewPropsAndNewState = function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    };
    var handleNewProps = function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    };
    var handleNewState = function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    };
    var handleSubsequentCalls = function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    };
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $4421efd6d9cd8b84$export$2e2bcd8739ae039(dispatch, _ref) {
    var initMapStateToProps = _ref.initMapStateToProps, initMapDispatchToProps = _ref.initMapDispatchToProps, initMergeProps = _ref.initMergeProps, options = (0, $8vpQL.default)(_ref, $4421efd6d9cd8b84$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $4421efd6d9cd8b84$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRequire.register("6liOn", function(module, exports) {

var $aw0BK = parcelRequire("aw0BK");
function $49e34bcd31d6ccba$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $aw0BK.default)("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $49e34bcd31d6ccba$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $49e34bcd31d6ccba$var$verify(mapStateToProps, "mapStateToProps");
    $49e34bcd31d6ccba$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $49e34bcd31d6ccba$var$verify(mergeProps, "mergeProps");
}

});
parcelRequire.register("aw0BK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a7d5d3a6c89d4b7$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $7a7d5d3a6c89d4b7$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRequire.register("jZG1d", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $e8e44ed5e5f31bbd$export$b69a785ceac019a6; });

var $3x00c = parcelRequire("3x00c");

var $0ygng = parcelRequire("0ygng");

var $azWiS = parcelRequire("azWiS");
function $e8e44ed5e5f31bbd$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $0ygng.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $3x00c.default)(mapDispatchToProps, dispatch);
    }) : !mapDispatchToProps ? (0, $0ygng.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? (0, $0ygng.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, $azWiS.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

});
parcelRequire.register("3x00c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2924749a1055284b$export$2e2bcd8739ae039; });

var $dHvbf = parcelRequire("dHvbf");
function $2924749a1055284b$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $dHvbf._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRequire.register("0ygng", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $001a9423e997d159$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $001a9423e997d159$export$8d46c7f53c8c602f; });
parcelRequire("cWfEH");
function $001a9423e997d159$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        var constantSelector = function constantSelector() {
            return constant;
        };
        var constant = getConstant(dispatch);
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $001a9423e997d159$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $001a9423e997d159$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $001a9423e997d159$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $001a9423e997d159$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRequire.register("cWfEH", function(module, exports) {

var $2Memr = parcelRequire("2Memr");

var $aw0BK = parcelRequire("aw0BK");
function $96b70ba673b67649$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $2Memr.default)(value)) (0, $aw0BK.default)("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}

});
parcelRequire.register("2Memr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $205b343d414559ae$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $205b343d414559ae$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRequire.register("azWiS", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $7b3a661d02b6bbd2$export$19ef7b929f7e2559; });

var $qb7pP = parcelRequire("qb7pP");
function $7b3a661d02b6bbd2$export$19ef7b929f7e2559(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $qb7pP._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}

});


parcelRequire.register("2aeNF", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $1937feed20e0e787$export$e00e93951827eda7; });

var $0ygng = parcelRequire("0ygng");

var $azWiS = parcelRequire("azWiS");
function $1937feed20e0e787$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $0ygng.wrapMapToPropsConstant)(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? (0, $0ygng.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, $azWiS.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

});

parcelRequire.register("1iaQT", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $0f0fe3e2fccc2d99$export$17457cf6fa742f84; });

var $3hDKy = parcelRequire("3hDKy");
parcelRequire("cWfEH");

var $azWiS = parcelRequire("azWiS");
function $0f0fe3e2fccc2d99$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $3hDKy.default)({}, ownProps, stateProps, dispatchProps);
}
function $0f0fe3e2fccc2d99$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $0f0fe3e2fccc2d99$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? function() {
        return $0f0fe3e2fccc2d99$export$691c327fc30bc857;
    } : typeof mergeProps === "function" ? $0f0fe3e2fccc2d99$export$5b105939c84b5234(mergeProps) : (0, $azWiS.createInvalidArgFactory)(mergeProps, "mergeProps");
}

});

parcelRequire.register("iqiu0", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $d698fe0d95373767$export$d567d2b9af322f8f; });

var $2ueeS = parcelRequire("2ueeS");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $d698fe0d95373767$var$createListenerCollection() {
    var batch = (0, $2ueeS.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $d698fe0d95373767$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $d698fe0d95373767$export$d567d2b9af322f8f(store, parentSub) {
    var addNestedSub = function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    };
    var notifyNestedSubs = function notifyNestedSubs() {
        listeners.notify();
    };
    var handleChangeWrapper = function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    };
    var isSubscribed = function isSubscribed() {
        return Boolean(unsubscribe);
    };
    var trySubscribe = function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $d698fe0d95373767$var$createListenerCollection();
        }
    };
    var tryUnsubscribe = function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $d698fe0d95373767$var$nullListeners;
        }
    };
    var unsubscribe;
    var listeners = $d698fe0d95373767$var$nullListeners;
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}

});

parcelRequire.register("cPKVP", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $957ea71a2b95ba84$export$700979bc83e7db82; });

var $3aC2T = parcelRequire("3aC2T");
var $957ea71a2b95ba84$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $957ea71a2b95ba84$export$700979bc83e7db82 = $957ea71a2b95ba84$export$71594e8a50f746f4 ? $3aC2T.useLayoutEffect : $3aC2T.useEffect;

});

parcelRequire.register("lzg6Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb395d5568ce6c54$export$2e2bcd8739ae039; });
function $fb395d5568ce6c54$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $fb395d5568ce6c54$export$2e2bcd8739ae039(objA, objB) {
    if ($fb395d5568ce6c54$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$fb395d5568ce6c54$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRequire.register("c0XUh", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("02kAW")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("2wq0j")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("49c73")).useSelector; });

var $02kAW = parcelRequire("02kAW");

var $kzD7d = parcelRequire("kzD7d");

var $1oXco = parcelRequire("1oXco");

var $2wq0j = parcelRequire("2wq0j");

var $49c73 = parcelRequire("49c73");

var $lj25l = parcelRequire("lj25l");

var $lzg6Z = parcelRequire("lzg6Z");
parcelRequire("clcan");

});
parcelRequire.register("02kAW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $007029be91ad2fd4$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");

var $1oXco = parcelRequire("1oXco");

var $iqiu0 = parcelRequire("iqiu0");

var $cPKVP = parcelRequire("cPKVP");
function $007029be91ad2fd4$var$Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? "once" : _param_stabilityCheck, _param_noopCheck = param.noopCheck, noopCheck = _param_noopCheck === void 0 ? "once" : _param_noopCheck;
    var contextValue = $3aC2T.useMemo(function() {
        var subscription = (0, $iqiu0.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    var previousState = $3aC2T.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $cPKVP.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $1oXco.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $3aC2T.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $007029be91ad2fd4$export$2e2bcd8739ae039 = $007029be91ad2fd4$var$Provider;

});

parcelRequire.register("2wq0j", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $1d62bdc5e859057c$export$8ad76b76a4c905f8; });

var $1oXco = parcelRequire("1oXco");

var $lj25l = parcelRequire("lj25l");
function $1d62bdc5e859057c$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $1oXco.ReactReduxContext);
    var useStore = context === (0, $1oXco.ReactReduxContext) ? (0, $lj25l.useStore) : (0, $lj25l.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
var $1d62bdc5e859057c$export$8ad76b76a4c905f8 = /*#__PURE__*/ $1d62bdc5e859057c$export$bc9b55530897c558();

});
parcelRequire.register("lj25l", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $f82cfd6141ba6153$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $f82cfd6141ba6153$export$6ccbb43953eebf8; });

var $1oXco = parcelRequire("1oXco");

var $9IOWJ = parcelRequire("9IOWJ");
function $f82cfd6141ba6153$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $1oXco.ReactReduxContext);
    var useReduxContext = context === (0, $1oXco.ReactReduxContext) ? (0, $9IOWJ.useReduxContext) : (0, $9IOWJ.createReduxContextHook)(context);
    return function useStore() {
        var store = useReduxContext().store; // @ts-ignore
        return store;
    };
}
var $f82cfd6141ba6153$export$6ccbb43953eebf8 = /*#__PURE__*/ $f82cfd6141ba6153$export$671dba69185d0304();

});


parcelRequire.register("clcan", function(module, exports) {

});



parcelRequire.register("ar9jW", function(module, exports) {

$parcel$export(module.exports, "firebaseAuth", function () { return $7993a7ddc546efab$export$b4ae2c1c09f3f2c6; });
$parcel$export(module.exports, "provider", function () { return $7993a7ddc546efab$export$ca328f169d304df4; });
// Import the functions you need from the SDKs you need
parcelRequire("i7Zfk");
var $2Ldjj = parcelRequire("2Ldjj");
parcelRequire("l2BLr");
var $qmPZq = parcelRequire("qmPZq");
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var $7993a7ddc546efab$var$firebaseConfig = {
    apiKey: "AIzaSyBIUufdeZnBeSc2YJrQa2LkmuBI3VTe5Ho",
    authDomain: "food-ordering-app-e67d6.firebaseapp.com",
    projectId: "food-ordering-app-e67d6",
    storageBucket: "food-ordering-app-e67d6.appspot.com",
    messagingSenderId: "501970189881",
    appId: "1:501970189881:web:83f1c60ad9666d619817e8",
    measurementId: "G-EL54LY0TPL"
};
// Initialize Firebase
var $7993a7ddc546efab$var$app = (0, $2Ldjj.initializeApp)($7993a7ddc546efab$var$firebaseConfig);
var $7993a7ddc546efab$export$b4ae2c1c09f3f2c6 = (0, $qmPZq.o)($7993a7ddc546efab$var$app);
var $7993a7ddc546efab$export$ca328f169d304df4 = new (0, $qmPZq.W)();

});
parcelRequire.register("i7Zfk", function(module, exports) {
$parcel$export(module.exports, "initializeApp", function () { return (parcelRequire("2Ldjj")).initializeApp; });
$parcel$export(module.exports, "registerVersion", function () { return (parcelRequire("2Ldjj")).registerVersion; });

var $2Ldjj = parcelRequire("2Ldjj");
var $d32863a6a8c29604$var$name = "firebase";
var $d32863a6a8c29604$var$version = "10.4.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $2Ldjj.registerVersion)($d32863a6a8c29604$var$name, $d32863a6a8c29604$var$version, "app");

});


parcelRequire.register("fSXf2", function(module, exports) {
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b909da525ff3b143$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
var $b909da525ff3b143$var$_default = (0, $b909da525ff3b143$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
module.exports["default"] = $b909da525ff3b143$var$_default;

});

parcelRequire.register("1zAyK", function(module, exports) {

$parcel$export(module.exports, "HeaderBox", function () { return $12556b46fcecc3ea$export$a0d9662ebc657c0c; });
$parcel$export(module.exports, "FoodLogoBox", function () { return $12556b46fcecc3ea$export$568aa225dd6161e3; });
$parcel$export(module.exports, "HeadingBox", function () { return $12556b46fcecc3ea$export$b4e5e09251522c2c; });
$parcel$export(module.exports, "NavItems", function () { return $12556b46fcecc3ea$export$698668688a6e8f34; });
$parcel$export(module.exports, "MobileNavItems", function () { return $12556b46fcecc3ea$export$15b8720343e2187; });
$parcel$export(module.exports, "MainBox", function () { return $12556b46fcecc3ea$export$45c0d0d85148c88c; });
$parcel$export(module.exports, "CartBox", function () { return $12556b46fcecc3ea$export$7f1044b3738ac27d; });
$parcel$export(module.exports, "CartItemBox", function () { return $12556b46fcecc3ea$export$a4fc62f641efeb55; });
$parcel$export(module.exports, "Item", function () { return $12556b46fcecc3ea$export$6d08773d2e66f8f2; });
$parcel$export(module.exports, "ButtonBox", function () { return $12556b46fcecc3ea$export$5e37f977ae0514c2; });
$parcel$export(module.exports, "LogOutUserBox", function () { return $12556b46fcecc3ea$export$ff518633db7baeb7; });
$parcel$export(module.exports, "LoggedOutBox", function () { return $12556b46fcecc3ea$export$6a1570a405c3c095; });
// src/components/Navbar/NavbarStyles.js

var $2iBlG = parcelRequire("2iBlG");

var $jjHBq = parcelRequire("jjHBq");

var $kDFB6 = parcelRequire("kDFB6");
var $5ODPG = parcelRequire("5ODPG");
var $gSv8W = parcelRequire("gSv8W");
var $5WdIT = parcelRequire("5WdIT");
function $12556b46fcecc3ea$var$_templateObject() {
    var data = (0, $jjHBq._)([
        "\n  display: flex;\n  align-items: center;\n  gap: 2px;\n\n  :hover {\n    color: rgb(211,47,47);\n  }\n"
    ]);
    $12556b46fcecc3ea$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $12556b46fcecc3ea$var$_templateObject1() {
    var data = (0, $jjHBq._)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n\n  & > svg {\n    margin-bottom: 3px;\n    font-size: 25px;\n  }\n"
    ]);
    $12556b46fcecc3ea$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $12556b46fcecc3ea$var$_templateObject2() {
    var data = (0, $jjHBq._)([
        '\n  color: white;\n  font-family: "Trebuchet MS";\n'
    ]);
    $12556b46fcecc3ea$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $12556b46fcecc3ea$var$_templateObject3() {
    var data = (0, $jjHBq._)([
        "\n  display: flex;\n  align-items: center;\n  color: rgb(211,47,47);\n  gap: 5px;\n  font-weight: bolder;\n"
    ]);
    $12556b46fcecc3ea$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $12556b46fcecc3ea$export$a0d9662ebc657c0c = (0, $gSv8W.default)((0, $5WdIT.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        height: "15vh",
        padding: "10px 0",
        border: "none",
        backgroundColor: "#ffffff",
        backgroundImage: "linear-gradient(to top, rgba(238,194,174,0) 0%, rgba(230,99,103,0.1) 100%)"
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        padding: "0 5px",
        height: "10vh"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        padding: "5px 15px",
        height: "12vh"
    }), _obj;
});
var $12556b46fcecc3ea$export$568aa225dd6161e3 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        marginLeft: "38px",
        "& > img": (0, $2iBlG._)({
            cursor: "pointer",
            background: "none",
            width: "5vw"
        }, theme.breakpoints.down("sm"), {
            width: "10vw"
        })
    }, theme.breakpoints.down("sm"), {
        marginLeft: "5px",
        gap: "15px"
    });
});
var $12556b46fcecc3ea$export$b4e5e09251522c2c = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, (0, $2iBlG._)(_obj, theme.breakpoints.up("md"), {
        display: "flex",
        flexDirection: "column",
        "& > p:nth-child(1), & > p:nth-child(2)": {
            fontFamily: "ubuntu",
            fontSize: "26px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder",
            letterSpacing: ".1rem"
        },
        "& > p:nth-child(2)": {
            fontSize: "12px",
            marginLeft: "2.5rem",
            marginBottom: "3px"
        }
    }), (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        fontFamily: "ubuntu",
        fontSize: "26px",
        color: "rgb(211,47,47)",
        fontWeight: "bolder",
        display: "flex",
        flexDirection: "column",
        "& > p:nth-child(1)": {
            fontFamily: "ubuntu",
            fontSize: "26px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder",
            letterSpacing: ".1rem"
        },
        "& > p:nth-child(2)": {
            fontSize: "12px",
            marginLeft: "3rem",
            marginBottom: "3px"
        }
    }), (0, $2iBlG._)(_obj, theme.breakpoints.down("md"), {
        fontFamily: "ubuntu",
        fontSize: "26px",
        color: "rgb(211,47,47)",
        fontWeight: "bolder",
        display: "flex",
        flexDirection: "column",
        "& > p:nth-child(1)": {
            fontFamily: "ubuntu",
            fontSize: "26px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder"
        },
        "& > p:nth-child(2)": {
            fontSize: "12px",
            marginLeft: "3rem",
            marginBottom: "3px"
        }
    }), _obj;
});
var $12556b46fcecc3ea$export$698668688a6e8f34 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        gap: "2rem",
        "& > ul": {
            display: "flex",
            alignItems: "center",
            gap: "2rem",
            color: "black",
            fontWeight: "bold",
            fontSize: "16px",
            listStyleType: "none",
            "& a": {
                textDecoration: "none",
                color: "black"
            },
            "& > li > a:hover": {
                color: "rgba(211,47,47,0.5)",
                cursor: "pointer"
            }
        }
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        display: "none"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.down("md"), {
        display: "none"
    }), _obj;
});
var $12556b46fcecc3ea$export$15b8720343e2187 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme, visible = param.visible;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        letterSpacing: ".1rem",
        gap: "2rem",
        backgroundColor: "#ffffff",
        padding: "2rem 1.4rem",
        fontSize: "16px",
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        zIndex: 1000,
        boxShadow: "0px 5px 6px rgba(0, 0, 0, 0.3)",
        transition: "opacity 0.5s ease-in-out, transform 0.5s ease-in-out, visibility 0.3s ease-in-out",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(-10px)",
        visibility: visible ? "visible" : "hidden"
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        display: "flex"
    }), (0, $2iBlG._)(_obj, "& > ul", {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        color: "black",
        fontWeight: "bold",
        listStyleType: "none",
        "& a": {
            textDecoration: "none",
            color: "black"
        },
        "& > li > a:hover": {
            color: "rgba(211,47,47,0.5)",
            cursor: "pointer"
        }
    }), _obj;
});
var $12556b46fcecc3ea$export$45c0d0d85148c88c = (0, $gSv8W.default)((0, $kDFB6.default))($12556b46fcecc3ea$var$_templateObject());
var $12556b46fcecc3ea$export$7f1044b3738ac27d = (0, $gSv8W.default)((0, $kDFB6.default))($12556b46fcecc3ea$var$_templateObject1());
var $12556b46fcecc3ea$export$a4fc62f641efeb55 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgb(211,47,47)",
        width: "1.5vw",
        height: "1.5vw",
        borderRadius: "50%",
        top: 0,
        left: "15px"
    }, theme.breakpoints.down("sm"), {
        width: "5vw",
        height: "5vw",
        borderRadius: "50%",
        fontSize: "15px"
    });
});
var $12556b46fcecc3ea$export$6d08773d2e66f8f2 = (0, $gSv8W.default)((0, $kDFB6.default))($12556b46fcecc3ea$var$_templateObject2());
var $12556b46fcecc3ea$export$5e37f977ae0514c2 = (0, $gSv8W.default)((0, $5ODPG.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        padding: "3px 10px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontWeight: "bolder",
        border: "1.5px solid rgb(211,47,47)",
        textTransform: "capitalize",
        "&:hover": {
            background: "rgb(211,47,47)",
            color: "white",
            boxShadow: "3px 3px 6px rgb(211,47,47)"
        }
    }, theme.breakpoints.down("sm"), {
        padding: "8px 50px"
    });
});
var $12556b46fcecc3ea$export$ff518633db7baeb7 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        gap: "25px",
        marginRight: "3rem"
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        display: "none"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.down("md"), {
        display: "none"
    }), _obj;
});
var $12556b46fcecc3ea$export$6a1570a405c3c095 = (0, $gSv8W.default)((0, $kDFB6.default))($12556b46fcecc3ea$var$_templateObject3());

});
parcelRequire.register("5ODPG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43c0853307cd2d79$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $3JnWc = parcelRequire("3JnWc");

var $i7SXW = parcelRequire("i7SXW");

var $6Fcce = parcelRequire("6Fcce");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $db1CZ = parcelRequire("db1CZ");

var $lqmBd = parcelRequire("lqmBd");

var $5IwTm = parcelRequire("5IwTm");

var $jXApy = parcelRequire("jXApy");

var $kTl4X = parcelRequire("kTl4X");

var $esXub = parcelRequire("esXub");
"use client";
var $43c0853307cd2d79$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
var $43c0853307cd2d79$var$useUtilityClasses = function(ownerState) {
    var color = ownerState.color, disableElevation = ownerState.disableElevation, fullWidth = ownerState.fullWidth, size = ownerState.size, variant = ownerState.variant, classes = ownerState.classes;
    var slots = {
        root: [
            "root",
            variant,
            "".concat(variant).concat((0, $lqmBd.default)(color)),
            "size".concat((0, $lqmBd.default)(size)),
            "".concat(variant, "Size").concat((0, $lqmBd.default)(size)),
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            "iconSize".concat((0, $lqmBd.default)(size))
        ],
        endIcon: [
            "endIcon",
            "iconSize".concat((0, $lqmBd.default)(size))
        ]
    };
    var composedClasses = (0, $i7SXW.default)(slots, (0, $5IwTm.getButtonUtilityClass), classes);
    return (0, $3hDKy.default)({}, classes, composedClasses);
};
var $43c0853307cd2d79$var$commonIconStyles = function(ownerState) {
    return (0, $3hDKy.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
};
var $43c0853307cd2d79$var$ButtonRoot = (0, $gSv8W.default)((0, $db1CZ.default), {
    shouldForwardProp: function(prop) {
        return (0, $gSv8W.rootShouldForwardProp)(prop) || prop === "classes";
    },
    name: "MuiButton",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.variant],
            styles["".concat(ownerState.variant).concat((0, $lqmBd.default)(ownerState.color))],
            styles["size".concat((0, $lqmBd.default)(ownerState.size))],
            styles["".concat(ownerState.variant, "Size").concat((0, $lqmBd.default)(ownerState.size))],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var _theme$palette$getCon, _theme$palette;
    var inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    var inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    var _obj;
    return (0, $3hDKy.default)({}, theme.typography.button, (_obj = {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration["short"]
        }),
        "&:hover": (0, $3hDKy.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.text.primaryChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : (0, $6Fcce.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[ownerState.color].mainChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : (0, $6Fcce.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: "1px solid ".concat((theme.vars || theme).palette[ownerState.color].main),
            backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[ownerState.color].mainChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : (0, $6Fcce.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $3hDKy.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        })
    }, (0, $2iBlG._)(_obj, "&.".concat((0, $5IwTm.default).focusVisible), (0, $3hDKy.default)({}, ownerState.variant === "contained" && {
        boxShadow: (theme.vars || theme).shadows[6]
    })), (0, $2iBlG._)(_obj, "&.".concat((0, $5IwTm.default).disabled), (0, $3hDKy.default)({
        color: (theme.vars || theme).palette.action.disabled
    }, ownerState.variant === "outlined" && {
        border: "1px solid ".concat((theme.vars || theme).palette.action.disabledBackground)
    }, ownerState.variant === "contained" && {
        color: (theme.vars || theme).palette.action.disabled,
        boxShadow: (theme.vars || theme).shadows[0],
        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    })), _obj), ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? "1px solid rgba(".concat(theme.vars.palette[ownerState.color].mainChannel, " / 0.5)") : "1px solid ".concat((0, $6Fcce.alpha)(theme.palette[ownerState.color].main, 0.5))
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, function(param) {
    var ownerState = param.ownerState;
    var _obj;
    return ownerState.disableElevation && (_obj = {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        }
    }, (0, $2iBlG._)(_obj, "&.".concat((0, $5IwTm.default).focusVisible), {
        boxShadow: "none"
    }), (0, $2iBlG._)(_obj, "&:active", {
        boxShadow: "none"
    }), (0, $2iBlG._)(_obj, "&.".concat((0, $5IwTm.default).disabled), {
        boxShadow: "none"
    }), _obj);
});
var $43c0853307cd2d79$var$ButtonStartIcon = (0, $gSv8W.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.startIcon,
            styles["iconSize".concat((0, $lqmBd.default)(ownerState.size))]
        ];
    }
})(function(param) {
    var ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $43c0853307cd2d79$var$commonIconStyles(ownerState));
});
var $43c0853307cd2d79$var$ButtonEndIcon = (0, $gSv8W.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.endIcon,
            styles["iconSize".concat((0, $lqmBd.default)(ownerState.size))]
        ];
    }
})(function(param) {
    var ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $43c0853307cd2d79$var$commonIconStyles(ownerState));
});
var $43c0853307cd2d79$var$Button = /*#__PURE__*/ $3aC2T.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    var contextProps = $3aC2T.useContext((0, $jXApy.default));
    var buttonGroupButtonContextPositionClassName = $3aC2T.useContext((0, $kTl4X.default));
    var resolvedProps = (0, $3JnWc.default)(contextProps, inProps);
    var props = (0, $4WGW4.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    var children = props.children, _props_color = props.color, color = _props_color === void 0 ? "primary" : _props_color, _props_component = props.component, component = _props_component === void 0 ? "button" : _props_component, className = props.className, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_disableElevation = props.disableElevation, disableElevation = _props_disableElevation === void 0 ? false : _props_disableElevation, _props_disableFocusRipple = props.disableFocusRipple, disableFocusRipple = _props_disableFocusRipple === void 0 ? false : _props_disableFocusRipple, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, _props_size = props.size, size = _props_size === void 0 ? "medium" : _props_size, startIconProp = props.startIcon, type = props.type, _props_variant = props.variant, variant = _props_variant === void 0 ? "text" : _props_variant, other = (0, $8vpQL.default)(props, $43c0853307cd2d79$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    var classes = $43c0853307cd2d79$var$useUtilityClasses(ownerState);
    var startIcon = startIconProp && /*#__PURE__*/ (0, $esXub.jsx)($43c0853307cd2d79$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    var endIcon = endIconProp && /*#__PURE__*/ (0, $esXub.jsx)($43c0853307cd2d79$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    var positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $esXub.jsxs)($43c0853307cd2d79$var$ButtonRoot, (0, $3hDKy.default)({
        ownerState: ownerState,
        className: (0, $5i80G.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $5i80G.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $43c0853307cd2d79$export$2e2bcd8739ae039 = $43c0853307cd2d79$var$Button;

});
parcelRequire.register("5IwTm", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $429a9379a3072712$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $429a9379a3072712$export$2e2bcd8739ae039; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $429a9379a3072712$export$5a6f9035944c8119(slot) {
    return (0, $iZWB2.default)("MuiButton", slot);
}
var $429a9379a3072712$var$buttonClasses = (0, $1Zd5c.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $429a9379a3072712$export$2e2bcd8739ae039 = $429a9379a3072712$var$buttonClasses;

});

parcelRequire.register("jXApy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e87fc5834da7152e$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
/**
 * @ignore - internal component.
 */ var $e87fc5834da7152e$var$ButtonGroupContext = /*#__PURE__*/ $3aC2T.createContext({});
var $e87fc5834da7152e$export$2e2bcd8739ae039 = $e87fc5834da7152e$var$ButtonGroupContext;

});

parcelRequire.register("kTl4X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3594b918e4a2a70$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
/**
 * @ignore - internal component.
 */ var $f3594b918e4a2a70$var$ButtonGroupButtonContext = /*#__PURE__*/ $3aC2T.createContext(undefined);
var $f3594b918e4a2a70$export$2e2bcd8739ae039 = $f3594b918e4a2a70$var$ButtonGroupButtonContext;

});


parcelRequire.register("5WdIT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $452d03a3d209b9c1$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $4WGW4 = parcelRequire("4WGW4");

var $gSv8W = parcelRequire("gSv8W");

var $5mz1Q = parcelRequire("5mz1Q");

var $esXub = parcelRequire("esXub");
"use client";
var $452d03a3d209b9c1$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
var $452d03a3d209b9c1$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, disableGutters = ownerState.disableGutters, variant = ownerState.variant;
    var slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $5mz1Q.getToolbarUtilityClass), classes);
};
var $452d03a3d209b9c1$var$ToolbarRoot = (0, $gSv8W.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && (0, $2iBlG._)({
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    }, theme.breakpoints.up("sm"), {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    }), ownerState.variant === "dense" && {
        minHeight: 48
    });
}, function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return ownerState.variant === "regular" && theme.mixins.toolbar;
});
var $452d03a3d209b9c1$var$Toolbar = /*#__PURE__*/ $3aC2T.forwardRef(function Toolbar(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    var className = props.className, _props_component = props.component, component = _props_component === void 0 ? "div" : _props_component, _props_disableGutters = props.disableGutters, disableGutters = _props_disableGutters === void 0 ? false : _props_disableGutters, _props_variant = props.variant, variant = _props_variant === void 0 ? "regular" : _props_variant, other = (0, $8vpQL.default)(props, $452d03a3d209b9c1$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    var classes = $452d03a3d209b9c1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsx)($452d03a3d209b9c1$var$ToolbarRoot, (0, $3hDKy.default)({
        as: component,
        className: (0, $5i80G.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $452d03a3d209b9c1$export$2e2bcd8739ae039 = $452d03a3d209b9c1$var$Toolbar;

});
parcelRequire.register("5mz1Q", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", function () { return $3e7a2dd0f13d1b57$export$b12cb262231eef32; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $3e7a2dd0f13d1b57$export$b12cb262231eef32(slot) {
    return (0, $iZWB2.default)("MuiToolbar", slot);
}
var $3e7a2dd0f13d1b57$var$toolbarClasses = (0, $1Zd5c.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $3e7a2dd0f13d1b57$export$2e2bcd8739ae039 = $3e7a2dd0f13d1b57$var$toolbarClasses;

});




parcelRequire.register("iYQo1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd167772e964b41c$export$2e2bcd8739ae039; });
parcelRequire("3aC2T");

var $j7n4p = parcelRequire("j7n4p");

var $fc9Ou = parcelRequire("fc9Ou");

var $gH0Wp = parcelRequire("gH0Wp");
"use client";
function $dd167772e964b41c$export$2e2bcd8739ae039() {
    var theme = (0, $j7n4p.default)((0, $fc9Ou.default));
    return theme[0, $gH0Wp.default] || theme;
}

});

parcelRequire.register("5y9cv", function(module, exports) {
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $40a743ce5ef20f41$var$React = $40a743ce5ef20f41$var$_interopRequireWildcard((parcelRequire("3aC2T")));

var $40a743ce5ef20f41$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
function $40a743ce5ef20f41$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($40a743ce5ef20f41$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $40a743ce5ef20f41$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $40a743ce5ef20f41$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $40a743ce5ef20f41$var$_default = (0, $40a743ce5ef20f41$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
}), "Instagram");
module.exports["default"] = $40a743ce5ef20f41$var$_default;

});

parcelRequire.register("aEJlh", function(module, exports) {
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7c20cfd99d687ff2$var$React = $7c20cfd99d687ff2$var$_interopRequireWildcard((parcelRequire("3aC2T")));

var $7c20cfd99d687ff2$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
function $7c20cfd99d687ff2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7c20cfd99d687ff2$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7c20cfd99d687ff2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $7c20cfd99d687ff2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $7c20cfd99d687ff2$var$_default = (0, $7c20cfd99d687ff2$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
}), "LinkedIn");
module.exports["default"] = $7c20cfd99d687ff2$var$_default;

});

parcelRequire.register("2CEgJ", function(module, exports) {
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1e8e5df703ec6a51$var$React = $1e8e5df703ec6a51$var$_interopRequireWildcard((parcelRequire("3aC2T")));

var $1e8e5df703ec6a51$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
function $1e8e5df703ec6a51$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1e8e5df703ec6a51$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1e8e5df703ec6a51$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $1e8e5df703ec6a51$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $1e8e5df703ec6a51$var$_default = (0, $1e8e5df703ec6a51$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "M12 1.27a11 11 0 00-3.48 21.46c.55.09.73-.28.73-.55v-1.84c-3.03.64-3.67-1.46-3.67-1.46-.55-1.29-1.28-1.65-1.28-1.65-.92-.65.1-.65.1-.65 1.1 0 1.73 1.1 1.73 1.1.92 1.65 2.57 1.2 3.21.92a2 2 0 01.64-1.47c-2.47-.27-5.04-1.19-5.04-5.5 0-1.1.46-2.1 1.2-2.84a3.76 3.76 0 010-2.93s.91-.28 3.11 1.1c1.8-.49 3.7-.49 5.5 0 2.1-1.38 3.02-1.1 3.02-1.1a3.76 3.76 0 010 2.93c.83.74 1.2 1.74 1.2 2.94 0 4.21-2.57 5.13-5.04 5.4.45.37.82.92.82 2.02v3.03c0 .27.1.64.73.55A11 11 0 0012 1.27"
}), "GitHub");
module.exports["default"] = $1e8e5df703ec6a51$var$_default;

});

parcelRequire.register("a2coa", function(module, exports) {
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $74e3b3722937fe28$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
var $74e3b3722937fe28$var$_default = (0, $74e3b3722937fe28$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
}), "MailOutline");
module.exports["default"] = $74e3b3722937fe28$var$_default;

});

parcelRequire.register("gmJlE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bea1e09bbc598f50$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $esXub = parcelRequire("esXub");
parcelRequire("3aC2T");

var $kDFB6 = parcelRequire("kDFB6");
var $apLC3 = parcelRequire("apLC3");
var $3Dkss = parcelRequire("3Dkss");
var $gSv8W = parcelRequire("gSv8W");
var $2wbWF = parcelRequire("2wbWF");
var $iYQo1 = parcelRequire("iYQo1");

var $hTuL5 = parcelRequire("hTuL5");

var $8fJNP = parcelRequire("8fJNP");

var $kjtsG = parcelRequire("kjtsG");
var $bea1e09bbc598f50$var$AppBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgb(240,240,245)",
        width: "100%",
        gap: "4rem",
        height: "18vh",
        padding: "0 5rem",
        marginTop: "5rem",
        "& > div": {
            "& p": (0, $2iBlG._)({
                fontFamily: "Trebuchet MS",
                fontSize: "28px",
                fontWeight: "900"
            }, theme.breakpoints.down("sm"), {
                fontSize: "22px",
                fontWeight: "900",
                textAlign: "center"
            }),
            "& img": (0, $2iBlG._)({
                cursor: "pointer",
                width: "16vw",
                height: "12vh"
            }, theme.breakpoints.down("sm"), {
                width: "25vw",
                height: "5vh"
            })
        }
    }, theme.breakpoints.down("sm"), {
        flexDirection: "column",
        height: "auto",
        gap: "1rem",
        width: "100%",
        padding: "0 1rem"
    });
});
var $bea1e09bbc598f50$var$FooterContainer = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        background: "rgb(2,6,12)",
        color: "#838787",
        width: "100%",
        minHeight: "60vh",
        textAlign: "center",
        padding: "2rem 0"
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        height: "auto",
        width: "100%",
        padding: "1rem"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.down("md"), {
        height: "auto",
        padding: "1rem"
    }), _obj;
});
var $bea1e09bbc598f50$var$GridContainer = (0, $gSv8W.default)((0, $apLC3.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        margin: "2rem 0 0 2rem",
        "& > p": {
            fontWeight: "bold"
        },
        "& ul": {
            listStyle: "none"
        }
    }, theme.breakpoints.down("sm", "md"), {
        flexDirection: "column",
        margin: "0"
    });
});
var $bea1e09bbc598f50$var$Panel = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        gap: "6rem",
        flexWrap: "wrap"
    }, theme.breakpoints.down("md"), {
        flexDirection: "column",
        gap: "2rem"
    });
});
var $bea1e09bbc598f50$var$LeftPanel = (0, $gSv8W.default)($bea1e09bbc598f50$var$Panel)(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        gap: "6rem",
        marginRight: "3rem",
        "& > div": {
            "& p": {
                fontFamily: '"Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial, sans-serif',
                color: "white",
                marginBottom: "8px",
                fontSize: "14px"
            },
            "& a": {
                color: "#838787",
                "&:hover": {
                    color: "white"
                }
            },
            "& li": {
                marginBottom: "8px",
                fontSize: "14px"
            }
        }
    };
});
var $bea1e09bbc598f50$var$RightPanel = (0, $gSv8W.default)($bea1e09bbc598f50$var$Panel)(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        borderLeft: "1px solid grey",
        paddingLeft: "25px",
        marginRight: "3rem",
        "& > div": {
            "& p": {
                fontFamily: '"Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial, sans-serif',
                color: "white",
                marginBottom: "8px",
                fontSize: "14px"
            },
            "ul > li": {
                marginBottom: "8px"
            }
        }
    }, theme.breakpoints.down("md"), {
        borderLeft: "none",
        paddingLeft: "0"
    });
});
var $bea1e09bbc598f50$var$Footer = function() {
    var theme = (0, $iYQo1.default)();
    return /*#__PURE__*/ (0, $esXub.jsxs)((0, $esXub.Fragment), {
        children: [
            /*#__PURE__*/ (0, $esXub.jsxs)($bea1e09bbc598f50$var$AppBox, {
                children: [
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                        sx: {
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                            children: "For better experience, download the app now"
                        })
                    }),
                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                        sx: {
                            display: "flex",
                            gap: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                href: "https://play.google.com/store/apps/details?id=in.swiggy.android&hl=en&gl=US",
                                children: /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8fJNP))),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                href: "https://apps.apple.com/in/app/swiggy-food-grocery-delivery/id989540920",
                                children: /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($hTuL5))),
                                    alt: ""
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $esXub.jsx)($bea1e09bbc598f50$var$FooterContainer, {
                children: /*#__PURE__*/ (0, $esXub.jsxs)($bea1e09bbc598f50$var$GridContainer, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $esXub.jsx)((0, $apLC3.default), {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 7,
                            children: /*#__PURE__*/ (0, $esXub.jsxs)($bea1e09bbc598f50$var$LeftPanel, {
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                children: "COMPANY"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "About Us"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Team"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Careers"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Blog"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Instamart"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Corporate"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Bounty"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                children: "CONTACT US"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Help & Support"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Partner With Us"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Ride With Us"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                children: "HELP"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Payments"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Shipping"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Cancellation & Returns"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "FAQ"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Report"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                children: "SOCIAL"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Facebook"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Twitter"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "Instagram"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $3Dkss.default), {
                                                            href: "#",
                                                            children: "YouTube"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $esXub.jsx)((0, $apLC3.default), {
                            item: true,
                            xs: 12,
                            sm: 12,
                            md: 5,
                            lg: 5,
                            children: /*#__PURE__*/ (0, $esXub.jsxs)($bea1e09bbc598f50$var$RightPanel, {
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                children: "LEGAL"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                                                sx: {
                                                    fontSize: "14px"
                                                },
                                                children: /*#__PURE__*/ (0, $esXub.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Terms & Conditions"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Refund & Cancellation"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Privacy Policy"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Cookie Policy"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Offer Terms"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Phishing & Fraud"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "FV Instamart"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "FV Money Codes"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "FV Discount Voucher"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                children: "WE DELIVER TO:"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                                                sx: {
                                                    fontSize: "14px"
                                                },
                                                children: /*#__PURE__*/ (0, $esXub.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Bangalore"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Gurgaon"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Hyderabad"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Kolkata"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Delhi"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Mumbai"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "Pune"
                                                        }),
                                                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                                            children: "& other 588 Cities in India"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $esXub.jsx)((0, $kjtsG.default), {})
        ]
    });
};
var $bea1e09bbc598f50$export$2e2bcd8739ae039 = $bea1e09bbc598f50$var$Footer;

});
parcelRequire.register("apLC3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79512c17e63b7ebc$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $dHvbf = parcelRequire("dHvbf");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $kf05Q = parcelRequire("kf05Q");
var $2m5wd = parcelRequire("2m5wd");

var $i7SXW = parcelRequire("i7SXW");


var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $iYQo1 = parcelRequire("iYQo1");

var $lqybz = parcelRequire("lqybz");

var $hpTiw = parcelRequire("hpTiw");

var $esXub = parcelRequire("esXub");
"use client";
var $79512c17e63b7ebc$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $79512c17e63b7ebc$var$getOffset(val) {
    var parse = parseFloat(val);
    return "".concat(parse).concat(String(val).replace(String(parse), "") || "px");
}
function $79512c17e63b7ebc$export$ca2a698f6020fda(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var size;
    return theme.breakpoints.keys.reduce(function(globalStyles, breakpoint) {
        // Use side effect over immutability for better performance.
        var styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            var columnsBreakpointValues = (0, $kf05Q.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            var columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            var width = "".concat(Math.round(size / columnValue * 10e7) / 10e5, "%");
            var more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                var themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    var fullWidth = "calc(".concat(width, " + ").concat($79512c17e63b7ebc$var$getOffset(themeSpacing), ")");
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $3hDKy.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $79512c17e63b7ebc$export$71d4225eeb1bc13e(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var directionValues = (0, $kf05Q.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $kf05Q.handleBreakpoints)({
        theme: theme
    }, directionValues, function(propValue) {
        var output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output["& > .".concat((0, $hpTiw.default).item)] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $79512c17e63b7ebc$var$extractZeroValueBreakpointKeys(param) {
    var breakpoints = param.breakpoints, values = param.values;
    var nonZeroKey = "";
    Object.keys(values).forEach(function(key) {
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    var sortedBreakpointKeysByValue = Object.keys(breakpoints).sort(function(a, b) {
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $79512c17e63b7ebc$export$380604d7c79f9e8f(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var container = ownerState.container, rowSpacing = ownerState.rowSpacing;
    var styles = {};
    if (container && rowSpacing !== 0) {
        var rowSpacingValues = (0, $kf05Q.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        var zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $79512c17e63b7ebc$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $kf05Q.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, function(propValue, breakpoint) {
            var _zeroValueBreakpointK;
            var themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return (0, $2iBlG._)({
                marginTop: "-".concat($79512c17e63b7ebc$var$getOffset(themeSpacing))
            }, "& > .".concat((0, $hpTiw.default).item), {
                paddingTop: $79512c17e63b7ebc$var$getOffset(themeSpacing)
            });
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return (0, $2iBlG._)({
                marginTop: 0
            }, "& > .".concat((0, $hpTiw.default).item), {
                paddingTop: 0
            });
        });
    }
    return styles;
}
function $79512c17e63b7ebc$export$4315fba5128fb4a1(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var container = ownerState.container, columnSpacing = ownerState.columnSpacing;
    var styles = {};
    if (container && columnSpacing !== 0) {
        var columnSpacingValues = (0, $kf05Q.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        var zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $79512c17e63b7ebc$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $kf05Q.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, function(propValue, breakpoint) {
            var _zeroValueBreakpointK2;
            var themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return (0, $2iBlG._)({
                width: "calc(100% + ".concat($79512c17e63b7ebc$var$getOffset(themeSpacing), ")"),
                marginLeft: "-".concat($79512c17e63b7ebc$var$getOffset(themeSpacing))
            }, "& > .".concat((0, $hpTiw.default).item), {
                paddingLeft: $79512c17e63b7ebc$var$getOffset(themeSpacing)
            });
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return (0, $2iBlG._)({
                width: "100%",
                marginLeft: 0
            }, "& > .".concat((0, $hpTiw.default).item), {
                paddingLeft: 0
            });
        });
    }
    return styles;
}
function $79512c17e63b7ebc$export$4ffcd0b3420424d2(spacing, breakpoints) {
    var styles = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles["spacing-xs-".concat(String(spacing))]
    ];
    // in case of object `spacing`
    var spacingStyles = [];
    breakpoints.forEach(function(breakpoint) {
        var value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles["spacing-".concat(breakpoint, "-").concat(String(value))]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
var $79512c17e63b7ebc$var$GridRoot = (0, $gSv8W.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        var container = ownerState.container, direction = ownerState.direction, item = ownerState.item, spacing = ownerState.spacing, wrap = ownerState.wrap, zeroMinWidth = ownerState.zeroMinWidth, breakpoints = ownerState.breakpoints;
        var spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $79512c17e63b7ebc$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        var breakpointsStyles = [];
        breakpoints.forEach(function(breakpoint) {
            var value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles["grid-".concat(breakpoint, "-").concat(String(value))]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth
        ].concat((0, $dHvbf._)(spacingStyles), [
            direction !== "row" && styles["direction-xs-".concat(String(direction))],
            wrap !== "wrap" && styles["wrap-xs-".concat(String(wrap))]
        ], (0, $dHvbf._)(breakpointsStyles));
    }
})(function(param) {
    var ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    });
}, $79512c17e63b7ebc$export$71d4225eeb1bc13e, $79512c17e63b7ebc$export$380604d7c79f9e8f, $79512c17e63b7ebc$export$4315fba5128fb4a1, $79512c17e63b7ebc$export$ca2a698f6020fda);
function $79512c17e63b7ebc$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        "spacing-xs-".concat(String(spacing))
    ];
    // in case of object `spacing`
    var classes = [];
    breakpoints.forEach(function(breakpoint) {
        var value = spacing[breakpoint];
        if (Number(value) > 0) {
            var className = "spacing-".concat(breakpoint, "-").concat(String(value));
            classes.push(className);
        }
    });
    return classes;
}
var $79512c17e63b7ebc$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, container = ownerState.container, direction = ownerState.direction, item = ownerState.item, spacing = ownerState.spacing, wrap = ownerState.wrap, zeroMinWidth = ownerState.zeroMinWidth, breakpoints = ownerState.breakpoints;
    var spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $79512c17e63b7ebc$export$2d1097e8e67cf24b(spacing, breakpoints);
    var breakpointsClasses = [];
    breakpoints.forEach(function(breakpoint) {
        var value = ownerState[breakpoint];
        if (value) breakpointsClasses.push("grid-".concat(breakpoint, "-").concat(String(value)));
    });
    var slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth"
        ].concat((0, $dHvbf._)(spacingClasses), [
            direction !== "row" && "direction-xs-".concat(String(direction)),
            wrap !== "wrap" && "wrap-xs-".concat(String(wrap))
        ], (0, $dHvbf._)(breakpointsClasses))
    };
    return (0, $i7SXW.default)(slots, (0, $hpTiw.getGridUtilityClass), classes);
};
var $79512c17e63b7ebc$var$Grid = /*#__PURE__*/ $3aC2T.forwardRef(function Grid(inProps, ref) {
    var themeProps = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiGrid"
    });
    var breakpoints = (0, $iYQo1.default)().breakpoints;
    var props = (0, $2m5wd.default)(themeProps);
    var className = props.className, columnsProp = props.columns, columnSpacingProp = props.columnSpacing, _props_component = props.component, component = _props_component === void 0 ? "div" : _props_component, _props_container = props.container, container = _props_container === void 0 ? false : _props_container, _props_direction = props.direction, direction = _props_direction === void 0 ? "row" : _props_direction, _props_item = props.item, item = _props_item === void 0 ? false : _props_item, rowSpacingProp = props.rowSpacing, _props_spacing = props.spacing, spacing = _props_spacing === void 0 ? 0 : _props_spacing, _props_wrap = props.wrap, wrap = _props_wrap === void 0 ? "wrap" : _props_wrap, _props_zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props_zeroMinWidth === void 0 ? false : _props_zeroMinWidth, other = (0, $8vpQL.default)(props, $79512c17e63b7ebc$var$_excluded);
    var rowSpacing = rowSpacingProp || spacing;
    var columnSpacing = columnSpacingProp || spacing;
    var columnsContext = $3aC2T.useContext((0, $lqybz.default));
    // columns set with default breakpoint unit of 12
    var columns = container ? columnsProp || 12 : columnsContext;
    var breakpointsValues = {};
    var otherFiltered = (0, $3hDKy.default)({}, other);
    breakpoints.keys.forEach(function(breakpoint) {
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    var ownerState = (0, $3hDKy.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    var classes = $79512c17e63b7ebc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $lqybz.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $esXub.jsx)($79512c17e63b7ebc$var$GridRoot, (0, $3hDKy.default)({
            ownerState: ownerState,
            className: (0, $5i80G.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $79512c17e63b7ebc$export$2e2bcd8739ae039 = $79512c17e63b7ebc$var$Grid;

});
parcelRequire.register("lqybz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9968b3e39bf5729$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
"use client";
/**
 * @ignore - internal component.
 */ var $f9968b3e39bf5729$var$GridContext = /*#__PURE__*/ $3aC2T.createContext();
var $f9968b3e39bf5729$export$2e2bcd8739ae039 = $f9968b3e39bf5729$var$GridContext;

});

parcelRequire.register("hpTiw", function(module, exports) {

$parcel$export(module.exports, "getGridUtilityClass", function () { return $cadfaa6e91086da1$export$9973ac5fd0181f33; });
$parcel$export(module.exports, "default", function () { return $cadfaa6e91086da1$export$2e2bcd8739ae039; });

var $dHvbf = parcelRequire("dHvbf");

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $cadfaa6e91086da1$export$9973ac5fd0181f33(slot) {
    return (0, $iZWB2.default)("MuiGrid", slot);
}
var $cadfaa6e91086da1$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $cadfaa6e91086da1$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
var $cadfaa6e91086da1$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
var $cadfaa6e91086da1$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
var $cadfaa6e91086da1$var$gridClasses = (0, $1Zd5c.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth"
].concat(// spacings
(0, $dHvbf._)($cadfaa6e91086da1$var$SPACINGS.map(function(spacing) {
    return "spacing-xs-".concat(spacing);
})), // direction values
(0, $dHvbf._)($cadfaa6e91086da1$var$DIRECTIONS.map(function(direction) {
    return "direction-xs-".concat(direction);
})), // wrap values
(0, $dHvbf._)($cadfaa6e91086da1$var$WRAPS.map(function(wrap) {
    return "wrap-xs-".concat(wrap);
})), // grid sizes for all breakpoints
(0, $dHvbf._)($cadfaa6e91086da1$var$GRID_SIZES.map(function(size) {
    return "grid-xs-".concat(size);
})), (0, $dHvbf._)($cadfaa6e91086da1$var$GRID_SIZES.map(function(size) {
    return "grid-sm-".concat(size);
})), (0, $dHvbf._)($cadfaa6e91086da1$var$GRID_SIZES.map(function(size) {
    return "grid-md-".concat(size);
})), (0, $dHvbf._)($cadfaa6e91086da1$var$GRID_SIZES.map(function(size) {
    return "grid-lg-".concat(size);
})), (0, $dHvbf._)($cadfaa6e91086da1$var$GRID_SIZES.map(function(size) {
    return "grid-xl-".concat(size);
}))));
var $cadfaa6e91086da1$export$2e2bcd8739ae039 = $cadfaa6e91086da1$var$gridClasses;

});


parcelRequire.register("3Dkss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a54e221bd3b1f44$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");


var $i7SXW = parcelRequire("i7SXW");

var $lqmBd = parcelRequire("lqmBd");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $l6Dnm = parcelRequire("l6Dnm");

var $gcZH1 = parcelRequire("gcZH1");

var $2wbWF = parcelRequire("2wbWF");

var $2pHbj = parcelRequire("2pHbj");

var $23i1f = parcelRequire("23i1f");

var $esXub = parcelRequire("esXub");
"use client";
var $2a54e221bd3b1f44$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
var $2a54e221bd3b1f44$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, component = ownerState.component, focusVisible = ownerState.focusVisible, underline = ownerState.underline;
    var slots = {
        root: [
            "root",
            "underline".concat((0, $lqmBd.default)(underline)),
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $2pHbj.getLinkUtilityClass), classes);
};
var $2a54e221bd3b1f44$var$LinkRoot = (0, $gSv8W.default)((0, $2wbWF.default), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles["underline".concat((0, $lqmBd.default)(ownerState.underline))],
            ownerState.component === "button" && styles.button
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0, $3hDKy.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $3hDKy.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $23i1f.default)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && (0, $2iBlG._)({
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        }
    }, "&.".concat((0, $2pHbj.default).focusVisible), {
        outline: "auto"
    }));
});
var $2a54e221bd3b1f44$var$Link = /*#__PURE__*/ $3aC2T.forwardRef(function Link(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiLink"
    });
    var className = props.className, _props_color = props.color, color = _props_color === void 0 ? "primary" : _props_color, _props_component = props.component, component = _props_component === void 0 ? "a" : _props_component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props_underline = props.underline, underline = _props_underline === void 0 ? "always" : _props_underline, _props_variant = props.variant, variant = _props_variant === void 0 ? "inherit" : _props_variant, sx = props.sx, other = (0, $8vpQL.default)(props, $2a54e221bd3b1f44$var$_excluded);
    var _useIsFocusVisible = (0, $l6Dnm.default)(), isFocusVisibleRef = _useIsFocusVisible.isFocusVisibleRef, handleBlurVisible = _useIsFocusVisible.onBlur, handleFocusVisible = _useIsFocusVisible.onFocus, focusVisibleRef = _useIsFocusVisible.ref;
    var _React_useState = (0, $aSMts._)($3aC2T.useState(false), 2), focusVisible = _React_useState[0], setFocusVisible = _React_useState[1];
    var handlerRef = (0, $gcZH1.default)(ref, focusVisibleRef);
    var handleBlur = function(event) {
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    var handleFocus = function(event) {
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    var ownerState = (0, $3hDKy.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    var classes = $2a54e221bd3b1f44$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsx)($2a54e221bd3b1f44$var$LinkRoot, (0, $3hDKy.default)({
        color: color,
        className: (0, $5i80G.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: (0, $dHvbf._)(!Object.keys((0, $23i1f.colorTransformations)).includes(color) ? [
            {
                color: color
            }
        ] : []).concat((0, $dHvbf._)(Array.isArray(sx) ? sx : [
            sx
        ]))
    }, other));
});
var $2a54e221bd3b1f44$export$2e2bcd8739ae039 = $2a54e221bd3b1f44$var$Link;

});
parcelRequire.register("2pHbj", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", function () { return $1c1f697e28b29094$export$d6efab9620b78fec; });
$parcel$export(module.exports, "default", function () { return $1c1f697e28b29094$export$2e2bcd8739ae039; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $1c1f697e28b29094$export$d6efab9620b78fec(slot) {
    return (0, $iZWB2.default)("MuiLink", slot);
}
var $1c1f697e28b29094$var$linkClasses = (0, $1Zd5c.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $1c1f697e28b29094$export$2e2bcd8739ae039 = $1c1f697e28b29094$var$linkClasses;

});

parcelRequire.register("23i1f", function(module, exports) {

$parcel$export(module.exports, "colorTransformations", function () { return $17e9d6cf3a2d26ae$export$c4e140d5d351182b; });
$parcel$export(module.exports, "default", function () { return $17e9d6cf3a2d26ae$export$2e2bcd8739ae039; });

var $6Fcce = parcelRequire("6Fcce");
var $fpsdE = parcelRequire("fpsdE");
var $17e9d6cf3a2d26ae$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
var $17e9d6cf3a2d26ae$var$transformDeprecatedColors = function(color) {
    return $17e9d6cf3a2d26ae$export$c4e140d5d351182b[color] || color;
};
var $17e9d6cf3a2d26ae$var$getTextDecoration = function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var transformedColor = $17e9d6cf3a2d26ae$var$transformDeprecatedColors(ownerState.color);
    var color = (0, $fpsdE.getPath)(theme, "palette.".concat(transformedColor), false) || ownerState.color;
    var channelColor = (0, $fpsdE.getPath)(theme, "palette.".concat(transformedColor, "Channel"));
    if ("vars" in theme && channelColor) return "rgba(".concat(channelColor, " / 0.4)");
    return (0, $6Fcce.alpha)(color, 0.4);
};
var $17e9d6cf3a2d26ae$export$2e2bcd8739ae039 = $17e9d6cf3a2d26ae$var$getTextDecoration;

});


parcelRequire.register("hTuL5", function(module, exports) {


module.exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("5ZdJq");

});

parcelRequire.register("8fJNP", function(module, exports) {


module.exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("aGO0x");

});

parcelRequire.register("kjtsG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec9c6f7697456f83$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $jjHBq = parcelRequire("jjHBq");

var $esXub = parcelRequire("esXub");
parcelRequire("3aC2T");

var $kDFB6 = parcelRequire("kDFB6");
var $gSv8W = parcelRequire("gSv8W");
var $2wbWF = parcelRequire("2wbWF");

var $kDmJt = parcelRequire("kDmJt");

var $5y9cv = parcelRequire("5y9cv");

var $aEJlh = parcelRequire("aEJlh");

var $2CEgJ = parcelRequire("2CEgJ");

var $a2coa = parcelRequire("a2coa");
function $ec9c6f7697456f83$var$_templateObject() {
    var data = (0, $jjHBq._)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    $ec9c6f7697456f83$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ec9c6f7697456f83$var$MainContainer = (0, $gSv8W.default)((0, $kDFB6.default))($ec9c6f7697456f83$var$_templateObject());
var $ec9c6f7697456f83$var$Container = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "rgb(2, 6, 12)",
        width: "100%",
        height: "15vh",
        padding: "1rem 3rem",
        color: "white",
        marginTop: "0.1rem"
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        padding: "1rem 2rem",
        flexDirection: "column",
        alignItems: "center",
        height: "auto",
        gap: "15px"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.down("md"), {
        padding: "1rem 2rem",
        flexDirection: "column",
        alignItems: "center",
        height: "auto",
        gap: "20px"
    }), _obj;
});
var $ec9c6f7697456f83$var$LogoImage = (0, $gSv8W.default)("img")(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        width: "6vw"
    }, theme.breakpoints.down("md"), {
        width: "15vw",
        marginBottom: "1rem"
    });
});
var $ec9c6f7697456f83$var$FooterText = (0, $gSv8W.default)((0, $2wbWF.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        fontFamily: "Trebuchet MS",
        fontSize: "18px",
        fontWeight: 900
    }, theme.breakpoints.down("md"), {
        textAlign: "center"
    });
});
var $ec9c6f7697456f83$var$IconContainer = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        gap: "20px",
        alignItems: "center",
        justifyContent: "center",
        "& > a:hover": {
            transform: "scale(1.2)",
            transition: "0.3s"
        }
    };
});
var $ec9c6f7697456f83$var$SubContainer = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        height: "14vh",
        backgroundImage: "linear-gradient(to bottom, rgba(238,194,174,0) 0%, rgba(230,99,103,0.3) 100%)",
        "& > p > span": {
            fontWeight: "900",
            color: "rgb(211,47,47)"
        }
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        flexDirection: "column",
        alignItems: "center",
        padding: "5px"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.down("md"), {
        flexDirection: "column",
        alignItems: "center",
        padding: "8px"
    }), _obj;
});
var $ec9c6f7697456f83$var$SubFooter = function() {
    return /*#__PURE__*/ (0, $esXub.jsxs)($ec9c6f7697456f83$var$MainContainer, {
        children: [
            /*#__PURE__*/ (0, $esXub.jsxs)($ec9c6f7697456f83$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $esXub.jsx)($ec9c6f7697456f83$var$LogoImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($kDmJt))),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)($ec9c6f7697456f83$var$FooterText, {
                        children: "\xa9 2023 The Foodie Zone"
                    }),
                    /*#__PURE__*/ (0, $esXub.jsxs)($ec9c6f7697456f83$var$IconContainer, {
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                href: "https://www.instagram.com/o_n_k_a_r_0895/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5y9cv))), {
                                    sx: {
                                        cursor: "pointer",
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                href: "https://github.com/onkar895/FOOD-ORDERING-APP",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2CEgJ))), {
                                    sx: {
                                        cursor: "pointer",
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                href: "https://www.linkedin.com/in/omkarkarale541/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aEJlh))), {
                                    sx: {
                                        cursor: "pointer",
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                href: "mailto:onkarkarale4@gmail.com",
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a2coa))), {
                                    sx: {
                                        cursor: "pointer",
                                        color: "white"
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $esXub.jsx)($ec9c6f7697456f83$var$SubContainer, {
                children: /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                    children: [
                        "Made with ❤️ by ",
                        /*#__PURE__*/ (0, $esXub.jsx)("span", {
                            children: " Onkar Karale \uD83D\uDE0A"
                        })
                    ]
                })
            })
        ]
    });
};
var $ec9c6f7697456f83$export$2e2bcd8739ae039 = $ec9c6f7697456f83$var$SubFooter;

});


parcelRequire.register("dORbj", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

(function() {
    var e = {
        181: function(e, t, r) {
            var d = function d(e) {
                var t = typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
                return !!e && ("object" == t || "function" == t);
            };
            var h = function h(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == (typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e)) || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Symbol]" == f.call(e);
                }(e)) return NaN;
                if (d(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = d(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(o, "");
                var _$r = i.test(e);
                return _$r || u.test(e) ? c(e.slice(2), _$r ? 2 : 8) : n.test(e) ? NaN : +e;
            };
            var o = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, u = /^0o[0-7]+$/i, c = parseInt, s = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, l = "object" == typeof self && self && self.Object === Object && self, a = s || l || Function("return this")(), f = Object.prototype.toString, p = Math.max, y = Math.min, b = function b() {
                return a.Date.now();
            };
            e.exports = function(e, t, r) {
                var m = function m(t) {
                    var _$r = o, i = n;
                    return o = n = void 0, l = t, u = e.apply(i, _$r);
                };
                var O = function O(e) {
                    var _$r = e - s;
                    return void 0 === s || _$r >= t || _$r < 0 || f && e - l >= i;
                };
                var g = function g(e) {
                    return c = void 0, v && o ? m(e) : (o = n = void 0, u);
                };
                var P = function P() {
                    var _$e = b(), _$r = O(_$e);
                    if (o = arguments, n = this, s = _$e, _$r) {
                        if (void 0 === c) return function(e) {
                            return l = e, c = setTimeout(w, t), a ? m(e) : u;
                        }(s);
                        if (f) return c = setTimeout(w, t), m(s);
                    }
                    return void 0 === c && (c = setTimeout(w, t)), u;
                };
                var o, n, i, u, c, s, l = 0, a = !1, f = !1, v = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function w() {
                    var _$e = b();
                    if (O(_$e)) return g(_$e);
                    c = setTimeout(w, function(e) {
                        var _$r = t - (e - s);
                        return f ? y(_$r, i - (e - l)) : _$r;
                    }(_$e));
                }
                return t = h(t) || 0, d(r) && (a = !!r.leading, i = (f = "maxWait" in r) ? p(h(r.maxWait) || 0, t) : i, v = "trailing" in r ? !!r.trailing : v), P.cancel = function() {
                    void 0 !== c && clearTimeout(c), l = 0, o = s = n = c = void 0;
                }, P.flush = function() {
                    return void 0 === c ? u : g(b());
                }, P;
            };
        },
        858: function(e, t, r) {
            var m = function m(e) {
                var t = typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
                return !!e && ("object" == t || "function" == t);
            };
            var O = function O(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == (typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e)) || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && b.call(e) == i;
                }(e)) return n;
                if (m(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = m(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(u, "");
                var _$r = s.test(e);
                return _$r || l.test(e) ? a(e.slice(2), _$r ? 2 : 8) : c.test(e) ? n : +e;
            };
            var o = "Expected a function", n = NaN, i = "[object Symbol]", u = /^\s+|\s+$/g, c = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, a = parseInt, f = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, p = "object" == typeof self && self && self.Object === Object && self, y = f || p || Function("return this")(), b = Object.prototype.toString, d = Math.max, h = Math.min, v = function v() {
                return y.Date.now();
            };
            e.exports = function(e, t, r) {
                var n = !0, i = !0;
                if ("function" != typeof e) throw new TypeError(o);
                return m(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), function(e, t, r) {
                    var b = function b(t) {
                        var _$r = n, o = i;
                        return n = i = void 0, a = t, c = e.apply(o, _$r);
                    };
                    var w = function w(e) {
                        var _$r = e - l;
                        return void 0 === l || _$r >= t || _$r < 0 || p && e - a >= u;
                    };
                    var P = function P(e) {
                        return s = void 0, y && n ? b(e) : (n = i = void 0, c);
                    };
                    var j = function j() {
                        var _$e = v(), _$r = w(_$e);
                        if (n = arguments, i = this, l = _$e, _$r) {
                            if (void 0 === s) return function(e) {
                                return a = e, s = setTimeout(g, t), f ? b(e) : c;
                            }(l);
                            if (p) return s = setTimeout(g, t), b(l);
                        }
                        return void 0 === s && (s = setTimeout(g, t)), c;
                    };
                    var n, i, u, c, s, l, a = 0, f = !1, p = !1, y = !0;
                    if ("function" != typeof e) throw new TypeError(o);
                    function g() {
                        var _$e = v();
                        if (w(_$e)) return P(_$e);
                        s = setTimeout(g, function(e) {
                            var _$r = t - (e - l);
                            return p ? h(_$r, u - (e - a)) : _$r;
                        }(_$e));
                    }
                    return t = O(t) || 0, m(r) && (f = !!r.leading, u = (p = "maxWait" in r) ? d(O(r.maxWait) || 0, t) : u, y = "trailing" in r ? !!r.trailing : y), j.cancel = function() {
                        void 0 !== s && clearTimeout(s), a = 0, n = l = i = s = void 0;
                    }, j.flush = function() {
                        return void 0 === s ? c : P(v());
                    }, j;
                }(e, t, {
                    leading: n,
                    maxWait: t,
                    trailing: i
                });
            };
        },
        694: function(e, t, r) {
            "use strict";
            var n = function n() {};
            var i = function i() {};
            var o = r(925);
            i.resetWarningCache = n, e.exports = function() {
                var _$e = function _$e(e, t, r, n, i, u) {
                    if (u !== o) {
                        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw c.name = "Invariant Violation", c;
                    }
                };
                var t = function t() {
                    return _$e;
                };
                _$e.isRequired = _$e;
                var _$r = {
                    array: _$e,
                    bigint: _$e,
                    bool: _$e,
                    func: _$e,
                    number: _$e,
                    object: _$e,
                    string: _$e,
                    symbol: _$e,
                    any: _$e,
                    arrayOf: t,
                    element: _$e,
                    elementType: _$e,
                    instanceOf: t,
                    node: _$e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: i,
                    resetWarningCache: n
                };
                return _$r.PropTypes = _$r, _$r;
            };
        },
        556: function(e, t, r) {
            e.exports = r(694)();
        },
        925: function(e) {
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        }
    }, t = {};
    function r(o) {
        var n = t[o];
        if (void 0 !== n) return n.exports;
        var i = t[o] = {
            exports: {}
        };
        return e[o](i, i.exports, r), i.exports;
    }
    r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e["default"];
        } : function() {
            return e;
        };
        return r.d(t, {
            a: t
        }), t;
    }, r.d = function(e, t) {
        for(var o in t)r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
            enumerable: !0,
            get: t[o]
        });
    }, r.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (e) {
            if ("object" == typeof window) return window;
        }
    }(), r.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, r.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    };
    var o = {};
    (function() {
        "use strict";
        var i = function i() {
            return "undefined" != typeof window && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
        };
        var c = function c(e, t) {
            var _$r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), _$r.push.apply(_$r, o);
            }
            return _$r;
        };
        var s = function s(e, t, r) {
            return (t = a(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        };
        var l = function l(e, t) {
            for(var _$r = 0; _$r < t.length; _$r++){
                var o = t[_$r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, a(o.key), o);
            }
        };
        var a = function a(e) {
            var t = function(e, t) {
                if ("object" != u(e) || !e) return e;
                var _$r = e[Symbol.toPrimitive];
                if (void 0 !== _$r) {
                    var o = _$r.call(e, "string");
                    if ("object" != u(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" == u(t) ? t : t + "";
        };
        var f = function f(e, t, r) {
            return t = y(t), function(e, t) {
                if (t && ("object" == u(t) || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e);
            }(e, p() ? Reflect.construct(t, r || [], y(e).constructor) : t.apply(e, r));
        };
        var _ = function _(e, t) {
            for(var _$r = 0; _$r < t.length; _$r++){
                var o = t[_$r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, I(o.key), o);
            }
        };
        var I = function I(e) {
            var t = function(e, t) {
                if ("object" != S(e) || !e) return e;
                var _$r = e[Symbol.toPrimitive];
                if (void 0 !== _$r) {
                    var o = _$r.call(e, "string");
                    if ("object" != S(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" == S(t) ? t : t + "";
        };
        var x = function x(e, t, r) {
            return t = R(t), k(e, D() ? Reflect.construct(t, r || [], R(e).constructor) : t.apply(e, r));
        };
        var k = function k(e, t) {
            if (t && ("object" == S(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e);
        };
        var W = function W(e, t) {
            for(var _$r = 0; _$r < t.length; _$r++){
                var o = t[_$r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, z(o.key), o);
            }
        };
        var z = function z(e) {
            var t = function(e, t) {
                if ("object" != V(e) || !e) return e;
                var _$r = e[Symbol.toPrimitive];
                if (void 0 !== _$r) {
                    var o = _$r.call(e, "string");
                    if ("object" != V(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" == V(t) ? t : t + "";
        };
        var $ = function $(e, t, r) {
            return t = F(t), function(e, t) {
                if (t && ("object" == V(t) || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e);
            }(e, U() ? Reflect.construct(t, r || [], F(e).constructor) : t.apply(e, r));
        };
        var A = function A(e, t) {
            for(var _$r = 0; _$r < t.length; _$r++){
                var o = t[_$r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, G(o.key), o);
            }
        };
        var G = function G(e) {
            var t = function(e, t) {
                if ("object" != X(e) || !e) return e;
                var _$r = e[Symbol.toPrimitive];
                if (void 0 !== _$r) {
                    var o = _$r.call(e, "string");
                    if ("object" != X(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" == X(t) ? t : t + "";
        };
        var J = function J(e, t, r) {
            return t = Q(t), function(e, t) {
                if (t && ("object" == X(t) || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e);
            }(e, K() ? Reflect.construct(t, r || [], Q(e).constructor) : t.apply(e, r));
        };
        var ne = function ne(e, t) {
            var _$r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), _$r.push.apply(_$r, o);
            }
            return _$r;
        };
        var ie = function ie(e) {
            for(var t = 1; t < arguments.length; t++){
                var _$r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ne(Object(_$r), !0).forEach(function(t) {
                    ue(e, t, _$r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(_$r)) : ne(Object(_$r)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(_$r, t));
                });
            }
            return e;
        };
        var ue = function ue(e, t, r) {
            return (t = le(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        };
        var se = function se(e, t) {
            for(var _$r = 0; _$r < t.length; _$r++){
                var o = t[_$r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, le(o.key), o);
            }
        };
        var le = function le(e) {
            var t = function(e, t) {
                if ("object" != re(e) || !e) return e;
                var _$r = e[Symbol.toPrimitive];
                if (void 0 !== _$r) {
                    var o = _$r.call(e, "string");
                    if ("object" != re(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" == re(t) ? t : t + "";
        };
        var ae = function ae(e, t, r) {
            return t = pe(t), function(e, t) {
                if (t && ("object" == re(t) || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }(e);
            }(e, fe() ? Reflect.construct(t, r || [], pe(e).constructor) : t.apply(e, r));
        };
        r.r(o), r.d(o, {
            LazyLoadComponent: function() {
                return te;
            },
            LazyLoadImage: function() {
                return de;
            },
            trackWindowScroll: function() {
                return N;
            }
        });
        var e = (parcelRequire("3aC2T"));
        var t = r.n(e), n = r(556);
        function u(e) {
            return u = "function" == typeof Symbol && "symbol" == (0, $qb7pP._)(Symbol.iterator) ? function u(e) {
                return typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
            }, u(e);
        }
        function p() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (p = function p() {
                return !!e;
            })();
        }
        function y(e) {
            return y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function y(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, y(e);
        }
        function b(e, t) {
            return b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function b(e, t) {
                return e.__proto__ = t, e;
            }, b(e, t);
        }
        var d = function d(e) {
            e.forEach(function(e) {
                e.isIntersecting && e.target.onVisible();
            });
        }, h = {}, v = function(e) {
            function r(e) {
                var t;
                if (function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, r), (t = f(this, r, [
                    e
                ])).supportsObserver = !e.scrollPosition && e.useIntersectionObserver && i(), t.supportsObserver) {
                    var o = e.threshold;
                    t.observer = function(e) {
                        return h[e] = h[e] || new IntersectionObserver(d, {
                            rootMargin: e + "px"
                        }), h[e];
                    }(o);
                }
                return t;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && b(e, t);
            }(r, e), o = r, n = [
                {
                    key: "componentDidMount",
                    value: function value() {
                        this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function value() {
                        this.observer && this.placeholder && this.observer.unobserve(this.placeholder);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function value() {
                        this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "getPlaceholderBoundingBox",
                    value: function value() {
                        var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition, t = this.placeholder.getBoundingClientRect(), _$r = this.placeholder.style, o = parseInt(_$r.getPropertyValue("margin-left"), 10) || 0, n = parseInt(_$r.getPropertyValue("margin-top"), 10) || 0;
                        return {
                            bottom: _$e.y + t.bottom + n,
                            left: _$e.x + t.left + o,
                            right: _$e.x + t.right + o,
                            top: _$e.y + t.top + n
                        };
                    }
                },
                {
                    key: "isPlaceholderInViewport",
                    value: function value() {
                        if ("undefined" == typeof window || !this.placeholder) return !1;
                        var _$e = this.props, t = _$e.scrollPosition, _$r = _$e.threshold, o = this.getPlaceholderBoundingBox(t), n = t.y + window.innerHeight, i = t.x, u = t.x + window.innerWidth, c = t.y;
                        return Boolean(c - _$r <= o.bottom && n + _$r >= o.top && i - _$r <= o.right && u + _$r >= o.left);
                    }
                },
                {
                    key: "updateVisibility",
                    value: function value() {
                        this.isPlaceholderInViewport() && this.props.onVisible();
                    }
                },
                {
                    key: "render",
                    value: function value() {
                        var _$e = this, _$r = this.props, o = _$r.className, n = _$r.height, i = _$r.placeholder, u = _$r.style, l = _$r.width;
                        if (i && "function" != typeof i.type) return t().cloneElement(i, {
                            ref: function ref(t) {
                                return _$e.placeholder = t;
                            }
                        });
                        var a = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var _$r = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? c(Object(_$r), !0).forEach(function(t) {
                                    s(e, t, _$r[t]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(_$r)) : c(Object(_$r)).forEach(function(t) {
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(_$r, t));
                                });
                            }
                            return e;
                        }({
                            display: "inline-block"
                        }, u);
                        return void 0 !== l && (a.width = l), void 0 !== n && (a.height = n), t().createElement("span", {
                            className: o,
                            ref: function ref(t) {
                                return _$e.placeholder = t;
                            },
                            style: a
                        }, i);
                    }
                }
            ], n && l(o.prototype, n), Object.defineProperty(o, "prototype", {
                writable: !1
            }), o;
        }(t().Component);
        v.propTypes = {
            onVisible: n.PropTypes.func.isRequired,
            className: n.PropTypes.string,
            height: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ]),
            placeholder: n.PropTypes.element,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            scrollPosition: n.PropTypes.shape({
                x: n.PropTypes.number.isRequired,
                y: n.PropTypes.number.isRequired
            }),
            width: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ])
        }, v.defaultProps = {
            className: "",
            placeholder: null,
            threshold: 100,
            useIntersectionObserver: !0
        };
        var m = v;
        var O = r(181), w = r.n(O), g = r(858), P = r.n(g), j = function j(e) {
            var t = getComputedStyle(e, null);
            return t.getPropertyValue("overflow") + t.getPropertyValue("overflow-y") + t.getPropertyValue("overflow-x");
        };
        var T = function T(e) {
            if (!(e instanceof HTMLElement)) return window;
            for(var t = e; t && t instanceof HTMLElement;){
                if (/(scroll|auto)/.test(j(t))) return t;
                t = t.parentNode;
            }
            return window;
        };
        function S(e) {
            return S = "function" == typeof Symbol && "symbol" == (0, $qb7pP._)(Symbol.iterator) ? function S(e) {
                return typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
            }, S(e);
        }
        var E = [
            "delayMethod",
            "delayTime"
        ];
        function L() {
            return L = Object.assign ? Object.assign.bind() : function L(e) {
                for(var t = 1; t < arguments.length; t++){
                    var _$r = arguments[t];
                    for(var o in _$r)({}).hasOwnProperty.call(_$r, o) && (e[o] = _$r[o]);
                }
                return e;
            }, L.apply(null, arguments);
        }
        function D() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (D = function D() {
                return !!e;
            })();
        }
        function R(e) {
            return R = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function R(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, R(e);
        }
        function C(e, t) {
            return C = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function C(e, t) {
                return e.__proto__ = t, e;
            }, C(e, t);
        }
        var B = function B() {
            return "undefined" == typeof window ? 0 : window.scrollX || window.pageXOffset;
        }, M = function M() {
            return "undefined" == typeof window ? 0 : window.scrollY || window.pageYOffset;
        };
        var N = function N(e) {
            var _$r = function(r) {
                function o(e) {
                    var _$r;
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, o), (_$r = x(this, o, [
                        e
                    ])).useIntersectionObserver = e.useIntersectionObserver && i(), _$r.useIntersectionObserver) return k(_$r);
                    var n = _$r.onChangeScroll.bind(_$r);
                    return "debounce" === e.delayMethod ? _$r.delayedScroll = w()(n, e.delayTime) : "throttle" === e.delayMethod && (_$r.delayedScroll = P()(n, e.delayTime)), _$r.state = {
                        scrollPosition: {
                            x: B(),
                            y: M()
                        }
                    }, _$r.baseComponentRef = t().createRef(), _$r;
                }
                var n, u;
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && C(e, t);
                }(o, r), n = o, u = [
                    {
                        key: "componentDidMount",
                        value: function value() {
                            this.addListeners();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function value() {
                            this.removeListeners();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function value() {
                            "undefined" == typeof window || this.useIntersectionObserver || T(this.baseComponentRef.current) !== this.scrollElement && (this.removeListeners(), this.addListeners());
                        }
                    },
                    {
                        key: "addListeners",
                        value: function value() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement = T(this.baseComponentRef.current), this.scrollElement.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }), window.addEventListener("resize", this.delayedScroll, {
                                passive: !0
                            }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }));
                        }
                    },
                    {
                        key: "removeListeners",
                        value: function value() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
                        }
                    },
                    {
                        key: "onChangeScroll",
                        value: function value() {
                            this.useIntersectionObserver || this.setState({
                                scrollPosition: {
                                    x: B(),
                                    y: M()
                                }
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function value() {
                            var _$r = this.props, _$o = (_$r.delayMethod, _$r.delayTime, function(e, t) {
                                if (null == e) return {};
                                var _$r, _$o, n = function(e, t) {
                                    if (null == e) return {};
                                    var _$r = {};
                                    for(var _$o in e)if (({}).hasOwnProperty.call(e, _$o)) {
                                        if (t.indexOf(_$o) >= 0) continue;
                                        _$r[_$o] = e[_$o];
                                    }
                                    return _$r;
                                }(e, t);
                                if (Object.getOwnPropertySymbols) {
                                    var i = Object.getOwnPropertySymbols(e);
                                    for(_$o = 0; _$o < i.length; _$o++)_$r = i[_$o], t.indexOf(_$r) >= 0 || ({}).propertyIsEnumerable.call(e, _$r) && (n[_$r] = e[_$r]);
                                }
                                return n;
                            }(_$r, E)), n = this.useIntersectionObserver ? null : this.state.scrollPosition;
                            return t().createElement(e, L({
                                forwardRef: this.baseComponentRef,
                                scrollPosition: n
                            }, _$o));
                        }
                    }
                ], u && _(n.prototype, u), Object.defineProperty(n, "prototype", {
                    writable: !1
                }), n;
            }(t().Component);
            return _$r.propTypes = {
                delayMethod: n.PropTypes.oneOf([
                    "debounce",
                    "throttle"
                ]),
                delayTime: n.PropTypes.number,
                useIntersectionObserver: n.PropTypes.bool
            }, _$r.defaultProps = {
                delayMethod: "throttle",
                delayTime: 300,
                useIntersectionObserver: !0
            }, _$r;
        };
        function V(e) {
            return V = "function" == typeof Symbol && "symbol" == (0, $qb7pP._)(Symbol.iterator) ? function V(e) {
                return typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
            }, V(e);
        }
        function U() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (U = function U() {
                return !!e;
            })();
        }
        function F(e) {
            return F = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function F(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, F(e);
        }
        function q(e, t) {
            return q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function q(e, t) {
                return e.__proto__ = t, e;
            }, q(e, t);
        }
        var H = function(e) {
            function r(e) {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, r), $(this, r, [
                    e
                ]);
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && q(e, t);
            }(r, e), o = r, n = [
                {
                    key: "render",
                    value: function value() {
                        return t().createElement(m, this.props);
                    }
                }
            ], W(o.prototype, n), Object.defineProperty(o, "prototype", {
                writable: !1
            }), o;
        }(t().Component);
        var Y = N(H);
        function X(e) {
            return X = "function" == typeof Symbol && "symbol" == (0, $qb7pP._)(Symbol.iterator) ? function X(e) {
                return typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
            }, X(e);
        }
        function K() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (K = function K() {
                return !!e;
            })();
        }
        function Q(e) {
            return Q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function Q(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Q(e);
        }
        function Z(e, t) {
            return Z = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function Z(e, t) {
                return e.__proto__ = t, e;
            }, Z(e, t);
        }
        var ee = function(e) {
            function r(e) {
                var t;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, r), t = J(this, r, [
                    e
                ]);
                var o = e.afterLoad, n = e.beforeLoad, i = e.scrollPosition, u = e.visibleByDefault;
                return t.state = {
                    visible: u
                }, u && (n(), o()), t.onVisible = t.onVisible.bind(t), t.isScrollTracked = Boolean(i && Number.isFinite(i.x) && i.x >= 0 && Number.isFinite(i.y) && i.y >= 0), t;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && Z(e, t);
            }(r, e), o = r, n = [
                {
                    key: "componentDidUpdate",
                    value: function value(e, t) {
                        t.visible !== this.state.visible && this.props.afterLoad();
                    }
                },
                {
                    key: "onVisible",
                    value: function value() {
                        this.props.beforeLoad(), this.setState({
                            visible: !0
                        });
                    }
                },
                {
                    key: "render",
                    value: function value() {
                        if (this.state.visible) return this.props.children;
                        var _$e = this.props, _$r = _$e.className, o = _$e.delayMethod, n = _$e.delayTime, u = _$e.height, c = _$e.placeholder, s = _$e.scrollPosition, l = _$e.style, a = _$e.threshold, f = _$e.useIntersectionObserver, p = _$e.width;
                        return this.isScrollTracked || f && i() ? t().createElement(m, {
                            className: _$r,
                            height: u,
                            onVisible: this.onVisible,
                            placeholder: c,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            width: p
                        }) : t().createElement(Y, {
                            className: _$r,
                            delayMethod: o,
                            delayTime: n,
                            height: u,
                            onVisible: this.onVisible,
                            placeholder: c,
                            style: l,
                            threshold: a,
                            width: p
                        });
                    }
                }
            ], A(o.prototype, n), Object.defineProperty(o, "prototype", {
                writable: !1
            }), o;
        }(t().Component);
        ee.propTypes = {
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool
        }, ee.defaultProps = {
            afterLoad: function afterLoad() {
                return {};
            },
            beforeLoad: function beforeLoad() {
                return {};
            },
            useIntersectionObserver: !0,
            visibleByDefault: !1
        };
        var te = ee;
        function re(e) {
            return re = "function" == typeof Symbol && "symbol" == (0, $qb7pP._)(Symbol.iterator) ? function re(e) {
                return typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e);
            }, re(e);
        }
        var oe = [
            "afterLoad",
            "beforeLoad",
            "delayMethod",
            "delayTime",
            "effect",
            "placeholder",
            "placeholderSrc",
            "scrollPosition",
            "threshold",
            "useIntersectionObserver",
            "visibleByDefault",
            "wrapperClassName",
            "wrapperProps"
        ];
        function ce() {
            return ce = Object.assign ? Object.assign.bind() : function ce(e) {
                for(var t = 1; t < arguments.length; t++){
                    var _$r = arguments[t];
                    for(var o in _$r)({}).hasOwnProperty.call(_$r, o) && (e[o] = _$r[o]);
                }
                return e;
            }, ce.apply(null, arguments);
        }
        function fe() {
            try {
                var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (e) {}
            return (fe = function fe() {
                return !!e;
            })();
        }
        function pe(e) {
            return pe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function pe(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, pe(e);
        }
        function ye(e, t) {
            return ye = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function ye(e, t) {
                return e.__proto__ = t, e;
            }, ye(e, t);
        }
        var be = function(e) {
            function r(e) {
                var t;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, r), (t = ae(this, r, [
                    e
                ])).state = {
                    loaded: !1
                }, t;
            }
            var o, n;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && ye(e, t);
            }(r, e), o = r, n = [
                {
                    key: "onImageLoad",
                    value: function value() {
                        var _$e = this;
                        return this.state.loaded ? null : function(t) {
                            _$e.props.onLoad(t), _$e.props.afterLoad(), _$e.setState({
                                loaded: !0
                            });
                        };
                    }
                },
                {
                    key: "getImg",
                    value: function value() {
                        var _$e = this.props, _$r = (_$e.afterLoad, _$e.beforeLoad, _$e.delayMethod, _$e.delayTime, _$e.effect, _$e.placeholder, _$e.placeholderSrc, _$e.scrollPosition, _$e.threshold, _$e.useIntersectionObserver, _$e.visibleByDefault, _$e.wrapperClassName, _$e.wrapperProps, function(e, t) {
                            if (null == e) return {};
                            var _$r, o, n = function(e, t) {
                                if (null == e) return {};
                                var _$r = {};
                                for(var o in e)if (({}).hasOwnProperty.call(e, o)) {
                                    if (t.indexOf(o) >= 0) continue;
                                    _$r[o] = e[o];
                                }
                                return _$r;
                            }(e, t);
                            if (Object.getOwnPropertySymbols) {
                                var i = Object.getOwnPropertySymbols(e);
                                for(o = 0; o < i.length; o++)_$r = i[o], t.indexOf(_$r) >= 0 || ({}).propertyIsEnumerable.call(e, _$r) && (n[_$r] = e[_$r]);
                            }
                            return n;
                        }(_$e, oe));
                        return t().createElement("img", ce({}, _$r, {
                            onLoad: this.onImageLoad()
                        }));
                    }
                },
                {
                    key: "getLazyLoadImage",
                    value: function value() {
                        var _$e = this.props, _$r = _$e.beforeLoad, o = _$e.className, n = _$e.delayMethod, i = _$e.delayTime, u = _$e.height, c = _$e.placeholder, s = _$e.scrollPosition, l = _$e.style, a = _$e.threshold, f = _$e.useIntersectionObserver, p = _$e.visibleByDefault, y = _$e.width;
                        return t().createElement(te, {
                            beforeLoad: _$r,
                            className: o,
                            delayMethod: n,
                            delayTime: i,
                            height: u,
                            placeholder: c,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            visibleByDefault: p,
                            width: y
                        }, this.getImg());
                    }
                },
                {
                    key: "getWrappedLazyLoadImage",
                    value: function value(e) {
                        var _$r = this.props, o = _$r.effect, n = _$r.height, i = _$r.placeholderSrc, u = _$r.width, c = _$r.wrapperClassName, s = _$r.wrapperProps, l = this.state.loaded, a = l ? " lazy-load-image-loaded" : "", f = l || !i ? {} : {
                            backgroundImage: "url(".concat(i, ")"),
                            backgroundSize: "100% 100%"
                        };
                        return t().createElement("span", ce({
                            className: c + " lazy-load-image-background " + o + a,
                            style: ie(ie({}, f), {}, {
                                color: "transparent",
                                display: "inline-block",
                                height: n,
                                width: u
                            })
                        }, s), e);
                    }
                },
                {
                    key: "render",
                    value: function value() {
                        var _$e = this.props, t = _$e.effect, _$r = _$e.placeholderSrc, o = _$e.visibleByDefault, n = _$e.wrapperClassName, i = _$e.wrapperProps, u = this.getLazyLoadImage();
                        return (t || _$r) && !o || n || i ? this.getWrappedLazyLoadImage(u) : u;
                    }
                }
            ], n && se(o.prototype, n), Object.defineProperty(o, "prototype", {
                writable: !1
            }), o;
        }(t().Component);
        be.propTypes = {
            onLoad: n.PropTypes.func,
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            delayMethod: n.PropTypes.string,
            delayTime: n.PropTypes.number,
            effect: n.PropTypes.string,
            placeholderSrc: n.PropTypes.string,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool,
            wrapperClassName: n.PropTypes.string,
            wrapperProps: n.PropTypes.object
        }, be.defaultProps = {
            onLoad: function onLoad() {},
            afterLoad: function afterLoad() {
                return {};
            },
            beforeLoad: function beforeLoad() {
                return {};
            },
            delayMethod: "throttle",
            delayTime: 300,
            effect: "",
            placeholderSrc: null,
            threshold: 100,
            useIntersectionObserver: !0,
            visibleByDefault: !1,
            wrapperClassName: ""
        };
        var de = be;
    })(), module.exports = o;
})();

});

parcelRequire.register("1YKKo", function(module, exports) {
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $170fa81a00fc6aa4$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
var $170fa81a00fc6aa4$var$_default = (0, $170fa81a00fc6aa4$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
module.exports["default"] = $170fa81a00fc6aa4$var$_default;

});

parcelRequire.register("94Cx1", function(module, exports) {

$parcel$export(module.exports, "SWIGGY_CDN_LINK", function () { return $69b26057c6e2d948$export$41dea6a689c665f7; });
$parcel$export(module.exports, "SWIGGY_API_URL", function () { return $69b26057c6e2d948$export$28758bffe9e46c7e; });
$parcel$export(module.exports, "SWIGGY_MENU_API", function () { return $69b26057c6e2d948$export$dfea971c0e349374; });
$parcel$export(module.exports, "SWIGGY_MENU_IMG_API", function () { return $69b26057c6e2d948$export$fc9614a9a7541a63; });
$parcel$export(module.exports, "FAQ", function () { return $69b26057c6e2d948$export$690878eeeaffbdc8; });
// Image CDN URL for Restaurant card
var $69b26057c6e2d948$export$41dea6a689c665f7 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";
var $69b26057c6e2d948$export$28758bffe9e46c7e = "https://food-ordering-app-server.vercel.app/api/proxy/swiggy/dapi/restaurants/list/v5?lat=18.5204303&lng=73.8567437&&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
var $69b26057c6e2d948$export$dfea971c0e349374 = "https://food-ordering-app-server.vercel.app/api/proxy/swiggy/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=18.5204303&lng=73.8567437&restaurantId=";
var $69b26057c6e2d948$export$fc9614a9a7541a63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";
var $69b26057c6e2d948$export$690878eeeaffbdc8 = [
    {
        id: 1,
        title: "What is Swiggy Customer Care Number?",
        description: "We value our customer’s time and hence moved away from a single customer care number to a comprehensive chat-based support system for quick and easy resolution. You no longer have to go through the maze of an IVRS call support. Just search for your issue in the help section on this page and initiate a chat with us. A customer care executive will be assigned to you shortly. You can also email us your issue on support@swiggy.in Note: We value your privacy and your information is safe with us. Please do not reveal any personal information, bank account number, OTP etc. to another person. A Swiggy representative will never ask you for these details. Please do not reveal these details to fraudsters and imposters claiming to be calling on our behalf. Be vigilant and do not entertain phishing calls or emails."
    },
    {
        id: 2,
        title: "I want to explore career opportunities with Swiggy",
        description: "https://www.swiggy.com/careers?hide_header=ios_android"
    },
    {
        id: 3,
        title: "Can I edit my order?",
        description: "Your order can be edited before it reaches the restaurant. You could contact customer support team via chat or call to do so. Once order is placed and restaurant starts preparing your food, you may not edit its contents."
    },
    {
        id: 4,
        title: "I want to cancel my order",
        description: "We will do our best to accommodate your request if the order is not placed to the restaurant (Customer service number: 080-67466729). Please note that we will have a right to charge a cancellation fee up to full order value to compensate our restaurant and delivery partners if your order has been confirmed."
    },
    {
        id: 5,
        title: "Will Swiggy be accountable for quality/quantity?",
        description: "Quantity and quality of the food is the restaurants' responsibility. However in case of issues with the quality or quantity, kindly submit your feedback and we will pass it on to the restaurant."
    },
    {
        id: 6,
        title: "Is there a minimum order value?",
        description: "We have no minimum order value and you can order for any amount."
    },
    {
        id: 7,
        title: "Do you charge for delivery?",
        description: "Delivery fee varies from city to city and is applicable if order value is below a certain amount. Additionally, certain restaurants might have fixed delivery fees. Delivery fee (if any) is specified on the Review Order page."
    },
    {
        id: 8,
        title: "How long do you take to deliver?",
        description: "Standard delivery times vary by the location selected and prevailing conditions. Once you select your location, an estimated delivery time is mentioned for each restaurant."
    },
    {
        id: 9,
        title: "What are your delivery hours?",
        description: "Our delivery hours vary for different locations and depends on availability of supply from restaurant partners."
    },
    {
        id: 10,
        title: "Can I order from any location?",
        description: "We will deliver from any restaurant listed on the search results for your location. We recommend enabling your GPS location finder and letting the app auto-detect your location."
    },
    {
        id: 11,
        title: "Is single order from many restaurants possible?",
        description: "We currently do not support this functionality. However, you can place orders for individual items from different restaurants."
    },
    {
        id: 12,
        title: "Do you support bulk orders?",
        description: "In order to provide all customers with a great selection and to ensure on time delivery of your meal, we reserve the right to limit the quantities depending on supply."
    },
    {
        id: 13,
        title: "Can I order in advance?",
        description: "We currently do not support this functionality. All our orders are placed and executed on-demand."
    },
    {
        id: 14,
        title: "Can I change the address / number?",
        description: "Any major change in delivery address is not possible after you have placed an order with us. However, slight modifications like changing the flat number, street name, landmark etc. are allowed. If you have received delivery executive details, you can directly call him, else you could contact our customer service team."
    },
    {
        id: 15,
        title: "Did not receive referral coupon?",
        description: "Referral coupon is given upon the first successful transaction of the referred person. If you still have not received it, kindly send us your details at support@swiggy.in. We will contact you within 48 hours."
    },
    {
        id: 16,
        title: "Deactivate my account",
        description: "Please write to us at support@swiggy.in in the event that you want to deactivate your account."
    }
];

});

parcelRequire.register("GorQr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07f6e33e667309a6$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $3BGRq = parcelRequire("3BGRq");


var $3aC2T = parcelRequire("3aC2T");

var $hDjAY = parcelRequire("hDjAY");

var $04Imp = parcelRequire("04Imp");


var $5dFAS = parcelRequire("5dFAS");

var $lx9jH = parcelRequire("lx9jH");
var $07f6e33e667309a6$export$bb38bb9a1161268 = "unmounted";
var $07f6e33e667309a6$export$84cbff306f539230 = "exited";
var $07f6e33e667309a6$export$df38205c966be359 = "entering";
var $07f6e33e667309a6$export$78e9e6e3e014d60a = "entered";
var $07f6e33e667309a6$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $07f6e33e667309a6$var$Transition = /*#__PURE__*/ function(_React$Component) {
    var Transition = function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props["in"]) {
            if (appear) {
                initialStatus = $07f6e33e667309a6$export$84cbff306f539230;
                _this.appearStatus = $07f6e33e667309a6$export$df38205c966be359;
            } else initialStatus = $07f6e33e667309a6$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $07f6e33e667309a6$export$bb38bb9a1161268;
        else initialStatus = $07f6e33e667309a6$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    };
    (0, $3BGRq.default)(Transition, _React$Component);
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref["in"];
        if (nextIn && prevState.status === $07f6e33e667309a6$export$bb38bb9a1161268) return {
            status: $07f6e33e667309a6$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props["in"]) {
                if (status !== $07f6e33e667309a6$export$df38205c966be359 && status !== $07f6e33e667309a6$export$78e9e6e3e014d60a) nextStatus = $07f6e33e667309a6$export$df38205c966be359;
            } else if (status === $07f6e33e667309a6$export$df38205c966be359 || status === $07f6e33e667309a6$export$78e9e6e3e014d60a) nextStatus = $07f6e33e667309a6$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $07f6e33e667309a6$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($hDjAY))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $lx9jH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $07f6e33e667309a6$export$84cbff306f539230) this.setState({
            status: $07f6e33e667309a6$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($hDjAY))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $04Imp.default).disabled) {
            this.safeSetState({
                status: $07f6e33e667309a6$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $07f6e33e667309a6$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $07f6e33e667309a6$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($hDjAY))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $04Imp.default).disabled) {
            this.safeSetState({
                status: $07f6e33e667309a6$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $07f6e33e667309a6$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $07f6e33e667309a6$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($hDjAY))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $07f6e33e667309a6$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props["in"], _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $8vpQL.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement((0, $5dFAS.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).Component);
$07f6e33e667309a6$var$Transition.contextType = (0, $5dFAS.default);
$07f6e33e667309a6$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $07f6e33e667309a6$var$noop() {}
$07f6e33e667309a6$var$Transition.defaultProps = {
    "in": false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $07f6e33e667309a6$var$noop,
    onEntering: $07f6e33e667309a6$var$noop,
    onEntered: $07f6e33e667309a6$var$noop,
    onExit: $07f6e33e667309a6$var$noop,
    onExiting: $07f6e33e667309a6$var$noop,
    onExited: $07f6e33e667309a6$var$noop
};
$07f6e33e667309a6$var$Transition.UNMOUNTED = $07f6e33e667309a6$export$bb38bb9a1161268;
$07f6e33e667309a6$var$Transition.EXITED = $07f6e33e667309a6$export$84cbff306f539230;
$07f6e33e667309a6$var$Transition.ENTERING = $07f6e33e667309a6$export$df38205c966be359;
$07f6e33e667309a6$var$Transition.ENTERED = $07f6e33e667309a6$export$78e9e6e3e014d60a;
$07f6e33e667309a6$var$Transition.EXITING = $07f6e33e667309a6$export$4aacc83d4d59139f;
var $07f6e33e667309a6$export$2e2bcd8739ae039 = $07f6e33e667309a6$var$Transition;

});
parcelRequire.register("04Imp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00e2c8e052783e76$export$2e2bcd8739ae039; });
var $00e2c8e052783e76$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRequire.register("lx9jH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $fad3e821b4298e1e$export$7d26bbb1236dafd6; });
var $fad3e821b4298e1e$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRequire.register("hi9je", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $c96b56b631711f2f$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $c96b56b631711f2f$export$8cb1e9b404609ae9; });
var $c96b56b631711f2f$export$b7a864e1eaef9de5 = function(node) {
    return node.scrollTop;
};
function $c96b56b631711f2f$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    var timeout = props.timeout, easing = props.easing, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});

parcelRequire.register("c67v1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cebdcd03e4ae8d3$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $6eT20 = parcelRequire("6eT20");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $l5nR6 = parcelRequire("l5nR6");

var $8vA7h = parcelRequire("8vA7h");

var $bhFAG = parcelRequire("bhFAG");

var $aKdz5 = parcelRequire("aKdz5");

var $5hhZB = parcelRequire("5hhZB");

var $bal7F = parcelRequire("bal7F");

var $cypgR = parcelRequire("cypgR");

var $3enro = parcelRequire("3enro");

var $esXub = parcelRequire("esXub");
"use client";
var $8cebdcd03e4ae8d3$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
var $8cebdcd03e4ae8d3$var$variantComponent = {
    standard: (0, $l5nR6.default),
    filled: (0, $8vA7h.default),
    outlined: (0, $bhFAG.default)
};
var $8cebdcd03e4ae8d3$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            "root"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $3enro.getTextFieldUtilityClass), classes);
};
var $8cebdcd03e4ae8d3$var$TextFieldRoot = (0, $gSv8W.default)((0, $5hhZB.default), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: function(props, styles) {
        return styles.root;
    }
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $8cebdcd03e4ae8d3$var$TextField = /*#__PURE__*/ $3aC2T.forwardRef(function TextField(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiTextField"
    });
    var autoComplete = props.autoComplete, _props_autoFocus = props.autoFocus, autoFocus = _props_autoFocus === void 0 ? false : _props_autoFocus, children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? "primary" : _props_color, defaultValue = props.defaultValue, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_error = props.error, error = _props_error === void 0 ? false : _props_error, FormHelperTextProps = props.FormHelperTextProps, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, helperText = props.helperText, idOverride = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, maxRows = props.maxRows, minRows = props.minRows, _props_multiline = props.multiline, multiline = _props_multiline === void 0 ? false : _props_multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props_required = props.required, required = _props_required === void 0 ? false : _props_required, rows = props.rows, _props_select = props.select, select = _props_select === void 0 ? false : _props_select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props_variant = props.variant, variant = _props_variant === void 0 ? "outlined" : _props_variant, other = (0, $8vpQL.default)(props, $8cebdcd03e4ae8d3$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    var classes = $8cebdcd03e4ae8d3$var$useUtilityClasses(ownerState);
    var InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps["native"]) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    var id = (0, $6eT20.default)(idOverride);
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $8cebdcd03e4ae8d3$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ (0, $esXub.jsx)(InputComponent, (0, $3hDKy.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $esXub.jsxs)($8cebdcd03e4ae8d3$var$TextFieldRoot, (0, $3hDKy.default)({
        className: (0, $5i80G.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $esXub.jsx)((0, $aKdz5.default), (0, $3hDKy.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $esXub.jsx)((0, $cypgR.default), (0, $3hDKy.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $esXub.jsx)((0, $bal7F.default), (0, $3hDKy.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $8cebdcd03e4ae8d3$export$2e2bcd8739ae039 = $8cebdcd03e4ae8d3$var$TextField;

});
parcelRequire.register("6eT20", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48aebcf505b2f99a$export$2e2bcd8739ae039; });

var $aSMts = parcelRequire("aSMts");

var $3aC2T = parcelRequire("3aC2T");
"use client";
var $48aebcf505b2f99a$var$globalId = 0;
function $48aebcf505b2f99a$var$useGlobalId(idOverride) {
    var _React_useState = (0, $aSMts._)($3aC2T.useState(idOverride), 2), defaultId = _React_useState[0], setDefaultId = _React_useState[1];
    var id = idOverride || defaultId;
    $3aC2T.useEffect(function() {
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $48aebcf505b2f99a$var$globalId += 1;
            setDefaultId("mui-".concat($48aebcf505b2f99a$var$globalId));
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
var $48aebcf505b2f99a$var$maybeReactUseId = $3aC2T["useId".toString()];
function $48aebcf505b2f99a$export$2e2bcd8739ae039(idOverride) {
    if ($48aebcf505b2f99a$var$maybeReactUseId !== undefined) {
        var reactId = $48aebcf505b2f99a$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $48aebcf505b2f99a$var$useGlobalId(idOverride);
}

});

parcelRequire.register("l5nR6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f59c91c92c776f8f$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $dHvbf = parcelRequire("dHvbf");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $i7SXW = parcelRequire("i7SXW");

var $luotc = parcelRequire("luotc");

var $180Qj = parcelRequire("180Qj");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $6y3Y8 = parcelRequire("6y3Y8");

var $180Qj = parcelRequire("180Qj");

var $esXub = parcelRequire("esXub");
"use client";
var $f59c91c92c776f8f$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
var $f59c91c92c776f8f$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, disableUnderline = ownerState.disableUnderline;
    var slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    var composedClasses = (0, $i7SXW.default)(slots, (0, $6y3Y8.getInputUtilityClass), classes);
    return (0, $3hDKy.default)({}, classes, composedClasses);
};
var $f59c91c92c776f8f$var$InputRoot = (0, $gSv8W.default)((0, $180Qj.InputBaseRoot), {
    shouldForwardProp: function(prop) {
        return (0, $gSv8W.rootShouldForwardProp)(prop) || prop === "classes";
    },
    name: "MuiInput",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return (0, $dHvbf._)((0, $180Qj.rootOverridesResolver)(props, styles)).concat([
            !ownerState.disableUnderline && styles.underline
        ]);
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var light = theme.palette.mode === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = "rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / ").concat(theme.vars.opacity.inputUnderline, ")");
    var _obj;
    return (0, $3hDKy.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && (_obj = {
        "&:after": {
            borderBottom: "2px solid ".concat((theme.vars || theme).palette[ownerState.color].main),
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        }
    }, (0, $2iBlG._)(_obj, "&.".concat((0, $6y3Y8.default).focused, ":after"), {
        // translateX(0) is a workaround for Safari transform scale bug
        // See https://github.com/mui/material-ui/issues/31766
        transform: "scaleX(1) translateX(0)"
    }), (0, $2iBlG._)(_obj, "&.".concat((0, $6y3Y8.default).error), {
        "&:before, &:after": {
            borderBottomColor: (theme.vars || theme).palette.error.main
        }
    }), (0, $2iBlG._)(_obj, "&:before", {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: "absolute",
        right: 0,
        transition: theme.transitions.create("border-bottom-color", {
            duration: theme.transitions.duration.shorter
        }),
        pointerEvents: "none" // Transparent to the hover style.
    }), (0, $2iBlG._)(_obj, "&:hover:not(.".concat((0, $6y3Y8.default).disabled, ", .").concat((0, $6y3Y8.default).error, "):before"), {
        borderBottom: "2px solid ".concat((theme.vars || theme).palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            borderBottom: "1px solid ".concat(bottomLineColor)
        }
    }), (0, $2iBlG._)(_obj, "&.".concat((0, $6y3Y8.default).disabled, ":before"), {
        borderBottomStyle: "dotted"
    }), _obj));
});
var $f59c91c92c776f8f$var$InputInput = (0, $gSv8W.default)((0, $180Qj.InputBaseComponent), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $180Qj.inputOverridesResolver)
})({});
var $f59c91c92c776f8f$var$Input = /*#__PURE__*/ $3aC2T.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiInput"
    });
    var disableUnderline = props.disableUnderline, _props_components = props.components, components = _props_components === void 0 ? {} : _props_components, componentsPropsProp = props.componentsProps, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, _props_inputComponent = props.inputComponent, inputComponent = _props_inputComponent === void 0 ? "input" : _props_inputComponent, _props_multiline = props.multiline, multiline = _props_multiline === void 0 ? false : _props_multiline, slotProps = props.slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_type = props.type, type = _props_type === void 0 ? "text" : _props_type, other = (0, $8vpQL.default)(props, $f59c91c92c776f8f$var$_excluded);
    var classes = $f59c91c92c776f8f$var$useUtilityClasses(props);
    var ownerState = {
        disableUnderline: disableUnderline
    };
    var inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    var componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $luotc.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    var RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $f59c91c92c776f8f$var$InputRoot;
    var InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $f59c91c92c776f8f$var$InputInput;
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $180Qj.default), (0, $3hDKy.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$f59c91c92c776f8f$var$Input.muiName = "Input";
var $f59c91c92c776f8f$export$2e2bcd8739ae039 = $f59c91c92c776f8f$var$Input;

});
parcelRequire.register("180Qj", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", function () { return $0d2731217412f77b$export$965edad20a84fa75; });
$parcel$export(module.exports, "inputOverridesResolver", function () { return $0d2731217412f77b$export$cf507b112810e72d; });
$parcel$export(module.exports, "InputBaseRoot", function () { return $0d2731217412f77b$export$298a043133d72a38; });
$parcel$export(module.exports, "InputBaseComponent", function () { return $0d2731217412f77b$export$a1ad29c901026019; });
$parcel$export(module.exports, "default", function () { return $0d2731217412f77b$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $cZvD6 = parcelRequire("cZvD6");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $lp3r0 = parcelRequire("lp3r0");
var $kATGS = parcelRequire("kATGS");
var $i7SXW = parcelRequire("i7SXW");

var $gCmsM = parcelRequire("gCmsM");

var $jErS0 = parcelRequire("jErS0");

var $9uoCl = parcelRequire("9uoCl");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $lqmBd = parcelRequire("lqmBd");

var $gcZH1 = parcelRequire("gcZH1");

var $lOvSp = parcelRequire("lOvSp");

var $lb1Pi = parcelRequire("lb1Pi");

var $3FQQU = parcelRequire("3FQQU");

var $drVS4 = parcelRequire("drVS4");

var $esXub = parcelRequire("esXub");
"use client";
var $0d2731217412f77b$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
var $0d2731217412f77b$export$965edad20a84fa75 = function(props, styles) {
    var ownerState = props.ownerState;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles["color".concat((0, $lqmBd.default)(ownerState.color))],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
var $0d2731217412f77b$export$cf507b112810e72d = function(props, styles) {
    var ownerState = props.ownerState;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
var $0d2731217412f77b$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, color = ownerState.color, disabled = ownerState.disabled, error = ownerState.error, endAdornment = ownerState.endAdornment, focused = ownerState.focused, formControl = ownerState.formControl, fullWidth = ownerState.fullWidth, hiddenLabel = ownerState.hiddenLabel, multiline = ownerState.multiline, readOnly = ownerState.readOnly, size = ownerState.size, startAdornment = ownerState.startAdornment, type = ownerState.type;
    var slots = {
        root: [
            "root",
            "color".concat((0, $lqmBd.default)(color)),
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && "size".concat((0, $lqmBd.default)(size)),
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $drVS4.getInputBaseUtilityClass), classes);
};
var $0d2731217412f77b$export$298a043133d72a38 = (0, $gSv8W.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $0d2731217412f77b$export$965edad20a84fa75
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0, $3hDKy.default)({}, theme.typography.body1, (0, $2iBlG._)({
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center"
    }, "&.".concat((0, $drVS4.default).disabled), {
        color: (theme.vars || theme).palette.text.disabled,
        cursor: "default"
    }), ownerState.multiline && (0, $3hDKy.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    });
});
var $0d2731217412f77b$export$a1ad29c901026019 = (0, $gSv8W.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $0d2731217412f77b$export$cf507b112810e72d
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var light = theme.palette.mode === "light";
    var placeholder = (0, $3hDKy.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    var placeholderHidden = {
        opacity: "0 !important"
    };
    var placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    var _obj;
    return (0, $3hDKy.default)((_obj = {
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        }
    }, // Show and hide the placeholder logic
    (0, $2iBlG._)(_obj, "label[data-shrink=false] + .".concat((0, $drVS4.default).formControl, " &"), {
        "&::-webkit-input-placeholder": placeholderHidden,
        "&::-moz-placeholder": placeholderHidden,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholderHidden,
        // IE11
        "&::-ms-input-placeholder": placeholderHidden,
        // Edge
        "&:focus::-webkit-input-placeholder": placeholderVisible,
        "&:focus::-moz-placeholder": placeholderVisible,
        // Firefox 19+
        "&:focus:-ms-input-placeholder": placeholderVisible,
        // IE11
        "&:focus::-ms-input-placeholder": placeholderVisible // Edge
    }), (0, $2iBlG._)(_obj, "&.".concat((0, $drVS4.default).disabled), {
        opacity: 1,
        // Reset iOS opacity
        WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
    }), (0, $2iBlG._)(_obj, "&:-webkit-autofill", {
        animationDuration: "5000s",
        animationName: "mui-auto-fill"
    }), _obj), ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
var $0d2731217412f77b$var$inputGlobalStyles = /*#__PURE__*/ (0, $esXub.jsx)((0, $lb1Pi.default), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $0d2731217412f77b$var$InputBase = /*#__PURE__*/ $3aC2T.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    var ariaDescribedby = props["aria-describedby"], autoComplete = props.autoComplete, autoFocus = props.autoFocus, className = props.className, _props_components = props.components, components = _props_components === void 0 ? {} : _props_components, _props_componentsProps = props.componentsProps, componentsProps = _props_componentsProps === void 0 ? {} : _props_componentsProps, defaultValue = props.defaultValue, disabled = props.disabled, disableInjectingGlobalStyles = props.disableInjectingGlobalStyles, endAdornment = props.endAdornment, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, id = props.id, _props_inputComponent = props.inputComponent, inputComponent = _props_inputComponent === void 0 ? "input" : _props_inputComponent, tmp = props.inputProps, inputPropsProp = tmp === void 0 ? {} : tmp, inputRefProp = props.inputRef, maxRows = props.maxRows, minRows = props.minRows, _props_multiline = props.multiline, multiline = _props_multiline === void 0 ? false : _props_multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, startAdornment = props.startAdornment, _props_type = props.type, type = _props_type === void 0 ? "text" : _props_type, valueProp = props.value, other = (0, $8vpQL.default)(props, $0d2731217412f77b$var$_excluded);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React_useRef = $3aC2T.useRef(value != null), isControlled = _React_useRef.current;
    var inputRef = $3aC2T.useRef();
    var handleInputRefWarning = $3aC2T.useCallback(function(instance) {}, []);
    var handleInputRef = (0, $gcZH1.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    var _React_useState = (0, $aSMts._)($3aC2T.useState(false), 2), focused = _React_useState[0], setFocused = _React_useState[1];
    var muiFormControl = (0, $9uoCl.default)();
    var fcs = (0, $gCmsM.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $3aC2T.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $3aC2T.useCallback(function(obj) {
        if ((0, $3FQQU.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $lOvSp.default)(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function(event) {
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _inputPropsProp;
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $cZvD6.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) (_inputPropsProp = inputPropsProp).onChange.apply(_inputPropsProp, [
            event
        ].concat((0, $dHvbf._)(args)));
        // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat((0, $dHvbf._)(args)));
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $3aC2T.useEffect(function() {
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleClick = function(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $3hDKy.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $3hDKy.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $kATGS.TextareaAutosize);
    }
    var handleAutoFill = function(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $3aC2T.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    var ownerState = (0, $3hDKy.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    var classes = $0d2731217412f77b$var$useUtilityClasses(ownerState);
    var Root = slots.root || components.Root || $0d2731217412f77b$export$298a043133d72a38;
    var rootProps = slotProps.root || componentsProps.root || {};
    var Input = slots.input || components.Input || $0d2731217412f77b$export$a1ad29c901026019;
    inputProps = (0, $3hDKy.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $esXub.jsxs)($3aC2T.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $0d2731217412f77b$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $esXub.jsxs)(Root, (0, $3hDKy.default)({}, rootProps, !(0, $lp3r0.isHostComponent)(Root) && {
                ownerState: (0, $3hDKy.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $5i80G.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $jErS0.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $esXub.jsx)(Input, (0, $3hDKy.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $lp3r0.isHostComponent)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $3hDKy.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $5i80G.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $3hDKy.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $0d2731217412f77b$export$2e2bcd8739ae039 = $0d2731217412f77b$var$InputBase;

});
parcelRequire.register("lp3r0", function(module, exports) {

$parcel$export(module.exports, "isHostComponent", function () { return $f94e98cb1a0a81c0$export$e28348cc2430497; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $f94e98cb1a0a81c0$export$e28348cc2430497(element) {
    return typeof element === "string";
}

});

parcelRequire.register("kATGS", function(module, exports) {

$parcel$export(module.exports, "TextareaAutosize", function () { return $efe25e69651d36a8$export$d1710922ecaf577a; });

var $aSMts = parcelRequire("aSMts");

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");


var $hDjAY = parcelRequire("hDjAY");

var $j1xdx = parcelRequire("j1xdx");
var $fAR5q = parcelRequire("fAR5q");
var $7GrSn = parcelRequire("7GrSn");
var $6mnDc = parcelRequire("6mnDc");

var $esXub = parcelRequire("esXub");
"use client";
var $efe25e69651d36a8$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $efe25e69651d36a8$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
var $efe25e69651d36a8$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $efe25e69651d36a8$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ var $efe25e69651d36a8$export$d1710922ecaf577a = /*#__PURE__*/ $3aC2T.forwardRef(function TextareaAutosize(props, forwardedRef) {
    var onChange = props.onChange, maxRows = props.maxRows, _props_minRows = props.minRows, minRows = _props_minRows === void 0 ? 1 : _props_minRows, style = props.style, value = props.value, other = (0, $8vpQL.default)(props, $efe25e69651d36a8$var$_excluded);
    var _React_useRef = $3aC2T.useRef(value != null), isControlled = _React_useRef.current;
    var inputRef = $3aC2T.useRef(null);
    var handleRef = (0, $6mnDc.default)(forwardedRef, inputRef);
    var shadowRef = $3aC2T.useRef(null);
    var renders = $3aC2T.useRef(0);
    var _React_useState = (0, $aSMts._)($3aC2T.useState({
        outerHeightStyle: 0
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    var getUpdatedState = $3aC2T.useCallback(function() {
        var input = inputRef.current;
        var containerWindow = (0, $fAR5q.default)(input);
        var computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        var boxSizing = computedStyle.boxSizing;
        var padding = $efe25e69651d36a8$var$getStyleValue(computedStyle.paddingBottom) + $efe25e69651d36a8$var$getStyleValue(computedStyle.paddingTop);
        var border = $efe25e69651d36a8$var$getStyleValue(computedStyle.borderBottomWidth) + $efe25e69651d36a8$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        var innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        var singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    var updateState = function(prevState, newState) {
        var outerHeightStyle = newState.outerHeightStyle, overflow = newState.overflow;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    var syncHeight = $3aC2T.useCallback(function() {
        var newState = getUpdatedState();
        if ($efe25e69651d36a8$var$isEmpty(newState)) return;
        setState(function(prevState) {
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    var syncHeightWithFlushSync = function() {
        var newState = getUpdatedState();
        if ($efe25e69651d36a8$var$isEmpty(newState)) return;
        // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $hDjAY.flushSync(function() {
            setState(function(prevState) {
                return updateState(prevState, newState);
            });
        });
    };
    $3aC2T.useEffect(function() {
        var handleResize = function() {
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        };
        var handleResizeWindow = (0, $j1xdx.default)(function() {
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        });
        var resizeObserver;
        var input = inputRef.current;
        var containerWindow = (0, $fAR5q.default)(input);
        containerWindow.addEventListener("resize", handleResizeWindow);
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return function() {
            handleResizeWindow.clear();
            containerWindow.removeEventListener("resize", handleResizeWindow);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $7GrSn.default)(function() {
        syncHeight();
    });
    $3aC2T.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $esXub.jsxs)($3aC2T.Fragment, {
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("textarea", (0, $3hDKy.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $3hDKy.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $esXub.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $3hDKy.default)({}, $efe25e69651d36a8$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});

});
parcelRequire.register("j1xdx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd97e09b16727478$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $dd97e09b16727478$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 166;
    var debounced = function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _this = this;
        var later = function() {
            // @ts-ignore
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
    var timeout;
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRequire.register("fAR5q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5a365a8c93c7f33$export$2e2bcd8739ae039; });

var $gM8lu = parcelRequire("gM8lu");
function $b5a365a8c93c7f33$export$2e2bcd8739ae039(node) {
    var doc = (0, $gM8lu.default)(node);
    return doc.defaultView || window;
}

});
parcelRequire.register("gM8lu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3679a479db72c0a$export$2e2bcd8739ae039; });
function $c3679a479db72c0a$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});



parcelRequire.register("gCmsM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1919ea7177d3858$export$2e2bcd8739ae039; });
function $c1919ea7177d3858$export$2e2bcd8739ae039(param) {
    var props = param.props, states = param.states, muiFormControl = param.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRequire.register("jErS0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4e75f28e1626f1a$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
/**
 * @ignore - internal component.
 */ var $e4e75f28e1626f1a$var$FormControlContext = /*#__PURE__*/ $3aC2T.createContext(undefined);
var $e4e75f28e1626f1a$export$2e2bcd8739ae039 = $e4e75f28e1626f1a$var$FormControlContext;

});

parcelRequire.register("9uoCl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e8a02e80c0bb439$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");

var $jErS0 = parcelRequire("jErS0");
"use client";
function $6e8a02e80c0bb439$export$2e2bcd8739ae039() {
    return $3aC2T.useContext((0, $jErS0.default));
}

});

parcelRequire.register("lOvSp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe16fe7d9237ed67$export$2e2bcd8739ae039; });

var $7GrSn = parcelRequire("7GrSn");
"use client";
var $fe16fe7d9237ed67$export$2e2bcd8739ae039 = (0, $7GrSn.default);

});

parcelRequire.register("lb1Pi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6ac0ab6eb41d049$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");
parcelRequire("3aC2T");


var $3ITCG = parcelRequire("3ITCG");

var $fc9Ou = parcelRequire("fc9Ou");

var $gH0Wp = parcelRequire("gH0Wp");

var $esXub = parcelRequire("esXub");
"use client";
function $f6ac0ab6eb41d049$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $3ITCG.default), (0, $3hDKy.default)({}, props, {
        defaultTheme: (0, $fc9Ou.default),
        themeId: (0, $gH0Wp.default)
    }));
}
var $f6ac0ab6eb41d049$export$2e2bcd8739ae039 = $f6ac0ab6eb41d049$var$GlobalStyles;

});
parcelRequire.register("3ITCG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b60a0b10632100c$export$2e2bcd8739ae039; });
parcelRequire("3aC2T");


var $7xThp = parcelRequire("7xThp");

var $j7n4p = parcelRequire("j7n4p");

var $esXub = parcelRequire("esXub");
"use client";
function $2b60a0b10632100c$var$GlobalStyles(param) {
    var styles = param.styles, themeId = param.themeId, _param_defaultTheme = param.defaultTheme, defaultTheme = _param_defaultTheme === void 0 ? {} : _param_defaultTheme;
    var upperTheme = (0, $j7n4p.default)(defaultTheme);
    var globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $7xThp.default), {
        styles: globalStyles
    });
}
var $2b60a0b10632100c$export$2e2bcd8739ae039 = $2b60a0b10632100c$var$GlobalStyles;

});


parcelRequire.register("3FQQU", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $2ace32d08eab588d$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $2ace32d08eab588d$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $2ace32d08eab588d$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $2ace32d08eab588d$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return obj && ($2ace32d08eab588d$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $2ace32d08eab588d$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $2ace32d08eab588d$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRequire.register("drVS4", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", function () { return $9caaaffc4ff94e85$export$ef57d5c8ca2278f6; });
$parcel$export(module.exports, "default", function () { return $9caaaffc4ff94e85$export$2e2bcd8739ae039; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $9caaaffc4ff94e85$export$ef57d5c8ca2278f6(slot) {
    return (0, $iZWB2.default)("MuiInputBase", slot);
}
var $9caaaffc4ff94e85$var$inputBaseClasses = (0, $1Zd5c.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $9caaaffc4ff94e85$export$2e2bcd8739ae039 = $9caaaffc4ff94e85$var$inputBaseClasses;

});


parcelRequire.register("6y3Y8", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", function () { return $4c48ff32b40e1099$export$cdb270390122322b; });
$parcel$export(module.exports, "default", function () { return $4c48ff32b40e1099$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");

var $drVS4 = parcelRequire("drVS4");
function $4c48ff32b40e1099$export$cdb270390122322b(slot) {
    return (0, $iZWB2.default)("MuiInput", slot);
}
var $4c48ff32b40e1099$var$inputClasses = (0, $3hDKy.default)({}, (0, $drVS4.default), (0, $1Zd5c.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $4c48ff32b40e1099$export$2e2bcd8739ae039 = $4c48ff32b40e1099$var$inputClasses;

});


parcelRequire.register("8vA7h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $631d3bf2d0d3ff25$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $dHvbf = parcelRequire("dHvbf");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");

var $luotc = parcelRequire("luotc");


var $i7SXW = parcelRequire("i7SXW");

var $180Qj = parcelRequire("180Qj");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $3vaAI = parcelRequire("3vaAI");

var $180Qj = parcelRequire("180Qj");

var $esXub = parcelRequire("esXub");
"use client";
var $631d3bf2d0d3ff25$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
var $631d3bf2d0d3ff25$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, disableUnderline = ownerState.disableUnderline;
    var slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    var composedClasses = (0, $i7SXW.default)(slots, (0, $3vaAI.getFilledInputUtilityClass), classes);
    return (0, $3hDKy.default)({}, classes, composedClasses);
};
var $631d3bf2d0d3ff25$var$FilledInputRoot = (0, $gSv8W.default)((0, $180Qj.InputBaseRoot), {
    shouldForwardProp: function(prop) {
        return (0, $gSv8W.rootShouldForwardProp)(prop) || prop === "classes";
    },
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return (0, $dHvbf._)((0, $180Qj.rootOverridesResolver)(props, styles)).concat([
            !ownerState.disableUnderline && styles.underline
        ]);
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var _palette;
    var light = theme.palette.mode === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    var backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    var hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    var disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    var _obj, _obj1;
    return (0, $3hDKy.default)((_obj = {
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        }
    }, (0, $2iBlG._)(_obj, "&.".concat((0, $3vaAI.default).focused), {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
    }), (0, $2iBlG._)(_obj, "&.".concat((0, $3vaAI.default).disabled), {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
    }), _obj), !ownerState.disableUnderline && (_obj1 = {
        "&:after": {
            borderBottom: "2px solid ".concat((_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main),
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        }
    }, (0, $2iBlG._)(_obj1, "&.".concat((0, $3vaAI.default).focused, ":after"), {
        // translateX(0) is a workaround for Safari transform scale bug
        // See https://github.com/mui/material-ui/issues/31766
        transform: "scaleX(1) translateX(0)"
    }), (0, $2iBlG._)(_obj1, "&.".concat((0, $3vaAI.default).error), {
        "&:before, &:after": {
            borderBottomColor: (theme.vars || theme).palette.error.main
        }
    }), (0, $2iBlG._)(_obj1, "&:before", {
        borderBottom: "1px solid ".concat(theme.vars ? "rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / ").concat(theme.vars.opacity.inputUnderline, ")") : bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: "absolute",
        right: 0,
        transition: theme.transitions.create("border-bottom-color", {
            duration: theme.transitions.duration.shorter
        }),
        pointerEvents: "none" // Transparent to the hover style.
    }), (0, $2iBlG._)(_obj1, "&:hover:not(.".concat((0, $3vaAI.default).disabled, ", .").concat((0, $3vaAI.default).error, "):before"), {
        borderBottom: "1px solid ".concat((theme.vars || theme).palette.text.primary)
    }), (0, $2iBlG._)(_obj1, "&.".concat((0, $3vaAI.default).disabled, ":before"), {
        borderBottomStyle: "dotted"
    }), _obj1), ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $3hDKy.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
var $631d3bf2d0d3ff25$var$FilledInputInput = (0, $gSv8W.default)((0, $180Qj.InputBaseComponent), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $180Qj.inputOverridesResolver)
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && (0, $2iBlG._)({
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.getColorSchemeSelector("dark"), {
        "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 100px #266798 inset",
            WebkitTextFillColor: "#fff",
            caretColor: "#fff"
        }
    }), ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    });
});
var $631d3bf2d0d3ff25$var$FilledInput = /*#__PURE__*/ $3aC2T.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    var _props_components = props.components, components = _props_components === void 0 ? {} : _props_components, componentsPropsProp = props.componentsProps, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, _props_inputComponent = props.// declare here to prevent spreading to DOM
    inputComponent, inputComponent = _props_inputComponent === void 0 ? "input" : _props_inputComponent, _props_multiline = props.multiline, multiline = _props_multiline === void 0 ? false : _props_multiline, slotProps = props.slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_type = props.type, type = _props_type === void 0 ? "text" : _props_type, other = (0, $8vpQL.default)(props, $631d3bf2d0d3ff25$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    var classes = $631d3bf2d0d3ff25$var$useUtilityClasses(props);
    var filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    var componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $luotc.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    var RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $631d3bf2d0d3ff25$var$FilledInputRoot;
    var InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $631d3bf2d0d3ff25$var$FilledInputInput;
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $180Qj.default), (0, $3hDKy.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$631d3bf2d0d3ff25$var$FilledInput.muiName = "Input";
var $631d3bf2d0d3ff25$export$2e2bcd8739ae039 = $631d3bf2d0d3ff25$var$FilledInput;

});
parcelRequire.register("3vaAI", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", function () { return $28cc7b85aacfd8b7$export$3331e419f1a48437; });
$parcel$export(module.exports, "default", function () { return $28cc7b85aacfd8b7$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");

var $drVS4 = parcelRequire("drVS4");
function $28cc7b85aacfd8b7$export$3331e419f1a48437(slot) {
    return (0, $iZWB2.default)("MuiFilledInput", slot);
}
var $28cc7b85aacfd8b7$var$filledInputClasses = (0, $3hDKy.default)({}, (0, $drVS4.default), (0, $1Zd5c.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $28cc7b85aacfd8b7$export$2e2bcd8739ae039 = $28cc7b85aacfd8b7$var$filledInputClasses;

});


parcelRequire.register("bhFAG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83718b4d50b2f353$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");



var $i7SXW = parcelRequire("i7SXW");

var $e9iLW = parcelRequire("e9iLW");

var $9uoCl = parcelRequire("9uoCl");

var $gCmsM = parcelRequire("gCmsM");

var $gSv8W = parcelRequire("gSv8W");

var $gj5HA = parcelRequire("gj5HA");

var $180Qj = parcelRequire("180Qj");

var $4WGW4 = parcelRequire("4WGW4");

var $esXub = parcelRequire("esXub");
"use client";
var $83718b4d50b2f353$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
var $83718b4d50b2f353$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    var composedClasses = (0, $i7SXW.default)(slots, (0, $gj5HA.getOutlinedInputUtilityClass), classes);
    return (0, $3hDKy.default)({}, classes, composedClasses);
};
var $83718b4d50b2f353$var$OutlinedInputRoot = (0, $gSv8W.default)((0, $180Qj.InputBaseRoot), {
    shouldForwardProp: function(prop) {
        return (0, $gSv8W.rootShouldForwardProp)(prop) || prop === "classes";
    },
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $180Qj.rootOverridesResolver)
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    var _obj;
    return (0, $3hDKy.default)((_obj = {
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, (0, $2iBlG._)(_obj, "&:hover .".concat((0, $gj5HA.default).notchedOutline), {
        borderColor: (theme.vars || theme).palette.text.primary
    }), // Reset on touch devices, it doesn't add specificity
    (0, $2iBlG._)(_obj, "@media (hover: none)", (0, $2iBlG._)({}, "&:hover .".concat((0, $gj5HA.default).notchedOutline), {
        borderColor: theme.vars ? "rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / 0.23)") : borderColor
    })), (0, $2iBlG._)(_obj, "&.".concat((0, $gj5HA.default).focused, " .").concat((0, $gj5HA.default).notchedOutline), {
        borderColor: (theme.vars || theme).palette[ownerState.color].main,
        borderWidth: 2
    }), (0, $2iBlG._)(_obj, "&.".concat((0, $gj5HA.default).error, " .").concat((0, $gj5HA.default).notchedOutline), {
        borderColor: (theme.vars || theme).palette.error.main
    }), (0, $2iBlG._)(_obj, "&.".concat((0, $gj5HA.default).disabled, " .").concat((0, $gj5HA.default).notchedOutline), {
        borderColor: (theme.vars || theme).palette.action.disabled
    }), _obj), ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $3hDKy.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
var $83718b4d50b2f353$var$NotchedOutlineRoot = (0, $gSv8W.default)((0, $e9iLW.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: function(props, styles) {
        return styles.notchedOutline;
    }
})(function(param) {
    var theme = param.theme;
    var borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? "rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / 0.23)") : borderColor
    };
});
var $83718b4d50b2f353$var$OutlinedInputInput = (0, $gSv8W.default)((0, $180Qj.InputBaseComponent), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $180Qj.inputOverridesResolver)
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && (0, $2iBlG._)({
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        }
    }, theme.getColorSchemeSelector("dark"), {
        "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 100px #266798 inset",
            WebkitTextFillColor: "#fff",
            caretColor: "#fff"
        }
    }), ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    });
});
var $83718b4d50b2f353$var$OutlinedInput = /*#__PURE__*/ $3aC2T.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    var _props_components = props.components, components = _props_components === void 0 ? {} : _props_components, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, _props_inputComponent = props.inputComponent, inputComponent = _props_inputComponent === void 0 ? "input" : _props_inputComponent, label = props.label, _props_multiline = props.multiline, multiline = _props_multiline === void 0 ? false : _props_multiline, notched = props.notched, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_type = props.type, type = _props_type === void 0 ? "text" : _props_type, other = (0, $8vpQL.default)(props, $83718b4d50b2f353$var$_excluded);
    var classes = $83718b4d50b2f353$var$useUtilityClasses(props);
    var muiFormControl = (0, $9uoCl.default)();
    var fcs = (0, $gCmsM.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    var ownerState = (0, $3hDKy.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    var RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $83718b4d50b2f353$var$OutlinedInputRoot;
    var InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $83718b4d50b2f353$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $180Qj.default), (0, $3hDKy.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: function(state) {
            return /*#__PURE__*/ (0, $esXub.jsx)($83718b4d50b2f353$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $esXub.jsxs)($3aC2T.Fragment, {
                    children: [
                        label,
                        " ",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $3hDKy.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$83718b4d50b2f353$var$OutlinedInput.muiName = "Input";
var $83718b4d50b2f353$export$2e2bcd8739ae039 = $83718b4d50b2f353$var$OutlinedInput;

});
parcelRequire.register("e9iLW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d077ba858db73c$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");
parcelRequire("3aC2T");


var $gSv8W = parcelRequire("gSv8W");

var $esXub = parcelRequire("esXub");
"use client";
var $a4d077ba858db73c$var$_span;
var $a4d077ba858db73c$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
var $a4d077ba858db73c$var$NotchedOutlineRoot = (0, $gSv8W.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
var $a4d077ba858db73c$var$NotchedOutlineLegend = (0, $gSv8W.default)("legend")(function(param) {
    var ownerState = param.ownerState, theme = param.theme;
    return (0, $3hDKy.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $3hDKy.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    }));
});
function $a4d077ba858db73c$export$2e2bcd8739ae039(props) {
    var className = props.className, label = props.label, notched = props.notched, other = (0, $8vpQL.default)(props, $a4d077ba858db73c$var$_excluded);
    var withLabel = label != null && label !== "";
    var ownerState = (0, $3hDKy.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $esXub.jsx)($a4d077ba858db73c$var$NotchedOutlineRoot, (0, $3hDKy.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $esXub.jsx)($a4d077ba858db73c$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $esXub.jsx)("span", {
                children: label
            }) : $a4d077ba858db73c$var$_span || ($a4d077ba858db73c$var$_span = /*#__PURE__*/ (0, $esXub.jsx)("span", {
                className: "notranslate",
                children: "​"
            }))
        })
    }));
}

});

parcelRequire.register("gj5HA", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", function () { return $bdf2d7ff573fd4da$export$89922944c7227687; });
$parcel$export(module.exports, "default", function () { return $bdf2d7ff573fd4da$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");

var $drVS4 = parcelRequire("drVS4");
function $bdf2d7ff573fd4da$export$89922944c7227687(slot) {
    return (0, $iZWB2.default)("MuiOutlinedInput", slot);
}
var $bdf2d7ff573fd4da$var$outlinedInputClasses = (0, $3hDKy.default)({}, (0, $drVS4.default), (0, $1Zd5c.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $bdf2d7ff573fd4da$export$2e2bcd8739ae039 = $bdf2d7ff573fd4da$var$outlinedInputClasses;

});


parcelRequire.register("aKdz5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d28b8fe5b2d9f08$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $i7SXW = parcelRequire("i7SXW");

var $5i80G = parcelRequire("5i80G");

var $gCmsM = parcelRequire("gCmsM");

var $9uoCl = parcelRequire("9uoCl");

var $uYZ83 = parcelRequire("uYZ83");
var $2OnUt = parcelRequire("2OnUt");

var $4WGW4 = parcelRequire("4WGW4");

var $lqmBd = parcelRequire("lqmBd");

var $gSv8W = parcelRequire("gSv8W");

var $lq8Wi = parcelRequire("lq8Wi");

var $esXub = parcelRequire("esXub");
"use client";
var $7d28b8fe5b2d9f08$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
var $7d28b8fe5b2d9f08$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, formControl = ownerState.formControl, size = ownerState.size, shrink = ownerState.shrink, disableAnimation = ownerState.disableAnimation, variant = ownerState.variant, required = ownerState.required;
    var slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && "size".concat((0, $lqmBd.default)(size)),
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    var composedClasses = (0, $i7SXW.default)(slots, (0, $lq8Wi.getInputLabelUtilityClasses), classes);
    return (0, $3hDKy.default)({}, classes, composedClasses);
};
var $7d28b8fe5b2d9f08$var$InputLabelRoot = (0, $gSv8W.default)((0, $uYZ83.default), {
    shouldForwardProp: function(prop) {
        return (0, $gSv8W.rootShouldForwardProp)(prop) || prop === "classes";
    },
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            (0, $2iBlG._)({}, "& .".concat((0, $2OnUt.default).asterisk), styles.asterisk),
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $3hDKy.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $3hDKy.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $3hDKy.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    }));
});
var $7d28b8fe5b2d9f08$var$InputLabel = /*#__PURE__*/ $3aC2T.forwardRef(function InputLabel(inProps, ref) {
    var props = (0, $4WGW4.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    var _props_disableAnimation = props.disableAnimation, disableAnimation = _props_disableAnimation === void 0 ? false : _props_disableAnimation, shrinkProp = props.shrink, className = props.className, other = (0, $8vpQL.default)(props, $7d28b8fe5b2d9f08$var$_excluded);
    var muiFormControl = (0, $9uoCl.default)();
    var shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $gCmsM.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required"
        ]
    });
    var ownerState = (0, $3hDKy.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    var classes = $7d28b8fe5b2d9f08$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsx)($7d28b8fe5b2d9f08$var$InputLabelRoot, (0, $3hDKy.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $5i80G.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $7d28b8fe5b2d9f08$export$2e2bcd8739ae039 = $7d28b8fe5b2d9f08$var$InputLabel;

});
parcelRequire.register("uYZ83", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05d21bcc23e5a8a7$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $gCmsM = parcelRequire("gCmsM");

var $9uoCl = parcelRequire("9uoCl");

var $lqmBd = parcelRequire("lqmBd");

var $4WGW4 = parcelRequire("4WGW4");

var $gSv8W = parcelRequire("gSv8W");

var $2OnUt = parcelRequire("2OnUt");

var $esXub = parcelRequire("esXub");
"use client";
var $05d21bcc23e5a8a7$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
var $05d21bcc23e5a8a7$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, color = ownerState.color, focused = ownerState.focused, disabled = ownerState.disabled, error = ownerState.error, filled = ownerState.filled, required = ownerState.required;
    var slots = {
        root: [
            "root",
            "color".concat((0, $lqmBd.default)(color)),
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $2OnUt.getFormLabelUtilityClasses), classes);
};
var $05d21bcc23e5a8a7$export$aa5bc7f8a4705b27 = (0, $gSv8W.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return (0, $3hDKy.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var _obj;
    return (0, $3hDKy.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, (_obj = {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative"
    }, (0, $2iBlG._)(_obj, "&.".concat((0, $2OnUt.default).focused), {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), (0, $2iBlG._)(_obj, "&.".concat((0, $2OnUt.default).disabled), {
        color: (theme.vars || theme).palette.text.disabled
    }), (0, $2iBlG._)(_obj, "&.".concat((0, $2OnUt.default).error), {
        color: (theme.vars || theme).palette.error.main
    }), _obj));
});
var $05d21bcc23e5a8a7$var$AsteriskComponent = (0, $gSv8W.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: function(props, styles) {
        return styles.asterisk;
    }
})(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({}, "&.".concat((0, $2OnUt.default).error), {
        color: (theme.vars || theme).palette.error.main
    });
});
var $05d21bcc23e5a8a7$var$FormLabel = /*#__PURE__*/ $3aC2T.forwardRef(function FormLabel(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    var children = props.children, className = props.className, _props_component = props.component, component = _props_component === void 0 ? "label" : _props_component, other = (0, $8vpQL.default)(props, $05d21bcc23e5a8a7$var$_excluded);
    var muiFormControl = (0, $9uoCl.default)();
    var fcs = (0, $gCmsM.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    var ownerState = (0, $3hDKy.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    var classes = $05d21bcc23e5a8a7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsxs)($05d21bcc23e5a8a7$export$aa5bc7f8a4705b27, (0, $3hDKy.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $5i80G.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $esXub.jsxs)($05d21bcc23e5a8a7$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    " ",
                    "*"
                ]
            })
        ]
    }));
});
var $05d21bcc23e5a8a7$export$2e2bcd8739ae039 = $05d21bcc23e5a8a7$var$FormLabel;

});
parcelRequire.register("2OnUt", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", function () { return $20c2cc46be435816$export$f7d501e40371cd17; });
$parcel$export(module.exports, "default", function () { return $20c2cc46be435816$export$2e2bcd8739ae039; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $20c2cc46be435816$export$f7d501e40371cd17(slot) {
    return (0, $iZWB2.default)("MuiFormLabel", slot);
}
var $20c2cc46be435816$var$formLabelClasses = (0, $1Zd5c.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $20c2cc46be435816$export$2e2bcd8739ae039 = $20c2cc46be435816$var$formLabelClasses;

});


parcelRequire.register("lq8Wi", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", function () { return $f982f5d737df11a3$export$c1c4b4545ad2ea5f; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $f982f5d737df11a3$export$c1c4b4545ad2ea5f(slot) {
    return (0, $iZWB2.default)("MuiInputLabel", slot);
}
var $f982f5d737df11a3$var$inputLabelClasses = (0, $1Zd5c.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $f982f5d737df11a3$export$2e2bcd8739ae039 = $f982f5d737df11a3$var$inputLabelClasses;

});


parcelRequire.register("5hhZB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d7c7f384cbfdda2$export$2e2bcd8739ae039; });

var $aSMts = parcelRequire("aSMts");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $4WGW4 = parcelRequire("4WGW4");

var $gSv8W = parcelRequire("gSv8W");

var $3FQQU = parcelRequire("3FQQU");

var $lqmBd = parcelRequire("lqmBd");

var $wPmxV = parcelRequire("wPmxV");

var $jErS0 = parcelRequire("jErS0");

var $8SItZ = parcelRequire("8SItZ");

var $esXub = parcelRequire("esXub");
"use client";
var $3d7c7f384cbfdda2$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
var $3d7c7f384cbfdda2$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, margin = ownerState.margin, fullWidth = ownerState.fullWidth;
    var slots = {
        root: [
            "root",
            margin !== "none" && "margin".concat((0, $lqmBd.default)(margin)),
            fullWidth && "fullWidth"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $8SItZ.getFormControlUtilityClasses), classes);
};
var $3d7c7f384cbfdda2$var$FormControlRoot = (0, $gSv8W.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return (0, $3hDKy.default)({}, styles.root, styles["margin".concat((0, $lqmBd.default)(ownerState.margin))], ownerState.fullWidth && styles.fullWidth);
    }
})(function(param) {
    var ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    });
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ var $3d7c7f384cbfdda2$var$FormControl = /*#__PURE__*/ $3aC2T.forwardRef(function FormControl(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    var children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? "primary" : _props_color, _props_component = props.component, component = _props_component === void 0 ? "div" : _props_component, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_error = props.error, error = _props_error === void 0 ? false : _props_error, visuallyFocused = props.focused, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, _props_hiddenLabel = props.hiddenLabel, hiddenLabel = _props_hiddenLabel === void 0 ? false : _props_hiddenLabel, _props_margin = props.margin, margin = _props_margin === void 0 ? "none" : _props_margin, _props_required = props.required, required = _props_required === void 0 ? false : _props_required, _props_size = props.size, size = _props_size === void 0 ? "medium" : _props_size, _props_variant = props.variant, variant = _props_variant === void 0 ? "outlined" : _props_variant, other = (0, $8vpQL.default)(props, $3d7c7f384cbfdda2$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    var classes = $3d7c7f384cbfdda2$var$useUtilityClasses(ownerState);
    var _React_useState = (0, $aSMts._)($3aC2T.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $3aC2T.Children.forEach(children, function(child) {
            if (!(0, $wPmxV.default)(child, [
                "Input",
                "Select"
            ])) return;
            var input = (0, $wPmxV.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $3FQQU.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), 2), adornedStart = _React_useState[0], setAdornedStart = _React_useState[1];
    var _React_useState1 = (0, $aSMts._)($3aC2T.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $3aC2T.Children.forEach(children, function(child) {
            if (!(0, $wPmxV.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $3FQQU.isFilled)(child.props, true) || (0, $3FQQU.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    }), 2), filled = _React_useState1[0], setFilled = _React_useState1[1];
    var _React_useState2 = (0, $aSMts._)($3aC2T.useState(false), 2), focusedState = _React_useState2[0], setFocused = _React_useState2[1];
    if (disabled && focusedState) setFocused(false);
    var focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    var registerEffect;
    var childContext = $3aC2T.useMemo(function() {
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: function() {
                setFocused(false);
            },
            onEmpty: function() {
                setFilled(false);
            },
            onFilled: function() {
                setFilled(true);
            },
            onFocus: function() {
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $jErS0.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $esXub.jsx)($3d7c7f384cbfdda2$var$FormControlRoot, (0, $3hDKy.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $5i80G.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $3d7c7f384cbfdda2$export$2e2bcd8739ae039 = $3d7c7f384cbfdda2$var$FormControl;

});
parcelRequire.register("wPmxV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $062ad4d371b31b93$export$2e2bcd8739ae039; });

var $1YYLI = parcelRequire("1YYLI");
var $062ad4d371b31b93$export$2e2bcd8739ae039 = (0, $1YYLI.default);

});
parcelRequire.register("1YYLI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $171a886b0bddbdb5$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
function $171a886b0bddbdb5$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $3aC2T.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

});


parcelRequire.register("8SItZ", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", function () { return $6775df348e308491$export$149c8b8bab2289d1; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $6775df348e308491$export$149c8b8bab2289d1(slot) {
    return (0, $iZWB2.default)("MuiFormControl", slot);
}
var $6775df348e308491$var$formControlClasses = (0, $1Zd5c.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $6775df348e308491$export$2e2bcd8739ae039 = $6775df348e308491$var$formControlClasses;

});


parcelRequire.register("bal7F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82110361d8466c65$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $gCmsM = parcelRequire("gCmsM");

var $9uoCl = parcelRequire("9uoCl");

var $gSv8W = parcelRequire("gSv8W");

var $lqmBd = parcelRequire("lqmBd");

var $iNmUD = parcelRequire("iNmUD");

var $4WGW4 = parcelRequire("4WGW4");

var $esXub = parcelRequire("esXub");
"use client";
var $82110361d8466c65$var$_span;
var $82110361d8466c65$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
var $82110361d8466c65$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, contained = ownerState.contained, size = ownerState.size, disabled = ownerState.disabled, error = ownerState.error, filled = ownerState.filled, focused = ownerState.focused, required = ownerState.required;
    var slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && "size".concat((0, $lqmBd.default)(size)),
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $iNmUD.getFormHelperTextUtilityClasses), classes);
};
var $82110361d8466c65$var$FormHelperTextRoot = (0, $gSv8W.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.size && styles["size".concat((0, $lqmBd.default)(ownerState.size))],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var _obj;
    return (0, $3hDKy.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, (_obj = {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
    }, (0, $2iBlG._)(_obj, "&.".concat((0, $iNmUD.default).disabled), {
        color: (theme.vars || theme).palette.text.disabled
    }), (0, $2iBlG._)(_obj, "&.".concat((0, $iNmUD.default).error), {
        color: (theme.vars || theme).palette.error.main
    }), _obj), ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    });
});
var $82110361d8466c65$var$FormHelperText = /*#__PURE__*/ $3aC2T.forwardRef(function FormHelperText(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    var children = props.children, className = props.className, _props_component = props.component, component = _props_component === void 0 ? "p" : _props_component, other = (0, $8vpQL.default)(props, $82110361d8466c65$var$_excluded);
    var muiFormControl = (0, $9uoCl.default)();
    var fcs = (0, $gCmsM.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    var ownerState = (0, $3hDKy.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    var classes = $82110361d8466c65$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsx)($82110361d8466c65$var$FormHelperTextRoot, (0, $3hDKy.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $5i80G.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $82110361d8466c65$var$_span || ($82110361d8466c65$var$_span = /*#__PURE__*/ (0, $esXub.jsx)("span", {
            className: "notranslate",
            children: "​"
        })) : children
    }));
});
var $82110361d8466c65$export$2e2bcd8739ae039 = $82110361d8466c65$var$FormHelperText;

});
parcelRequire.register("iNmUD", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", function () { return $daee938977b61bc4$export$a394fa61b1d583a9; });
$parcel$export(module.exports, "default", function () { return $daee938977b61bc4$export$2e2bcd8739ae039; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $daee938977b61bc4$export$a394fa61b1d583a9(slot) {
    return (0, $iZWB2.default)("MuiFormHelperText", slot);
}
var $daee938977b61bc4$var$formHelperTextClasses = (0, $1Zd5c.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $daee938977b61bc4$export$2e2bcd8739ae039 = $daee938977b61bc4$var$formHelperTextClasses;

});


parcelRequire.register("cypgR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $923c435094081495$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $luotc = parcelRequire("luotc");

var $8fEsS = parcelRequire("8fEsS");

var $gCmsM = parcelRequire("gCmsM");

var $9uoCl = parcelRequire("9uoCl");

var $56Bx3 = parcelRequire("56Bx3");

var $l5nR6 = parcelRequire("l5nR6");

var $fhwcH = parcelRequire("fhwcH");

var $8vA7h = parcelRequire("8vA7h");

var $bhFAG = parcelRequire("bhFAG");

var $4WGW4 = parcelRequire("4WGW4");

var $gcZH1 = parcelRequire("gcZH1");

var $gSv8W = parcelRequire("gSv8W");

var $esXub = parcelRequire("esXub");
"use client";
var $923c435094081495$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $923c435094081495$var$_excluded2 = [
    "root"
];
var $923c435094081495$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    return classes;
};
var $923c435094081495$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: function(props, styles) {
        return styles.root;
    },
    shouldForwardProp: function(prop) {
        return (0, $gSv8W.rootShouldForwardProp)(prop) && prop !== "variant";
    },
    slot: "Root"
};
var $923c435094081495$var$StyledInput = (0, $gSv8W.default)((0, $l5nR6.default), $923c435094081495$var$styledRootConfig)("");
var $923c435094081495$var$StyledOutlinedInput = (0, $gSv8W.default)((0, $bhFAG.default), $923c435094081495$var$styledRootConfig)("");
var $923c435094081495$var$StyledFilledInput = (0, $gSv8W.default)((0, $8vA7h.default), $923c435094081495$var$styledRootConfig)("");
var $923c435094081495$var$Select = /*#__PURE__*/ $3aC2T.forwardRef(function Select(inProps, ref) {
    var props = (0, $4WGW4.default)({
        name: "MuiSelect",
        props: inProps
    });
    var _props_autoWidth = props.autoWidth, autoWidth = _props_autoWidth === void 0 ? false : _props_autoWidth, children = props.children, tmp = props.classes, classesProp = tmp === void 0 ? {} : tmp, className = props.className, _props_defaultOpen = props.defaultOpen, defaultOpen = _props_defaultOpen === void 0 ? false : _props_defaultOpen, _props_displayEmpty = props.displayEmpty, displayEmpty = _props_displayEmpty === void 0 ? false : _props_displayEmpty, _props_IconComponent = props.IconComponent, IconComponent = _props_IconComponent === void 0 ? (0, $56Bx3.default) : _props_IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, MenuProps = props.MenuProps, _props_multiple = props.multiple, multiple = _props_multiple === void 0 ? false : _props_multiple, _props_native = props["native"], _native = _props_native === void 0 ? false : _props_native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, tmp1 = props.variant, variantProp = tmp1 === void 0 ? "outlined" : tmp1, other = (0, $8vpQL.default)(props, $923c435094081495$var$_excluded);
    var inputComponent = _native ? (0, $fhwcH.default) : (0, $8fEsS.default);
    var muiFormControl = (0, $9uoCl.default)();
    var fcs = (0, $gCmsM.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    var variant = fcs.variant || variantProp;
    var ownerState = (0, $3hDKy.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    var classes = $923c435094081495$var$useUtilityClasses(ownerState);
    var restOfClasses = (0, $8vpQL.default)(classes, $923c435094081495$var$_excluded2);
    var InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $esXub.jsx)($923c435094081495$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $esXub.jsx)($923c435094081495$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $esXub.jsx)($923c435094081495$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    var inputComponentRef = (0, $gcZH1.default)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $esXub.jsx)($3aC2T.Fragment, {
        children: /*#__PURE__*/ $3aC2T.cloneElement(InputComponent, (0, $3hDKy.default)({
            // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent: inputComponent,
            inputProps: (0, $3hDKy.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                // We render a select. We can ignore the type provided by the `Input`.
                multiple: multiple
            }, _native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $3hDKy.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $luotc.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, multiple && _native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $5i80G.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$923c435094081495$var$Select.muiName = "Select";
var $923c435094081495$export$2e2bcd8739ae039 = $923c435094081495$var$Select;

});
parcelRequire.register("8fEsS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $601f1cec0fd39354$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $aSMts = parcelRequire("aSMts");

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $cZvD6 = parcelRequire("cZvD6");

var $3aC2T = parcelRequire("3aC2T");
parcelRequire("4ti5v");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $dl4cE = parcelRequire("dl4cE");

var $lqmBd = parcelRequire("lqmBd");

var $2LfbM = parcelRequire("2LfbM");

var $fhwcH = parcelRequire("fhwcH");

var $3FQQU = parcelRequire("3FQQU");

var $gSv8W = parcelRequire("gSv8W");

var $gcZH1 = parcelRequire("gcZH1");

var $a1r53 = parcelRequire("a1r53");

var $bCbKk = parcelRequire("bCbKk");

var $esXub = parcelRequire("esXub");
"use client";
var $601f1cec0fd39354$var$_span;
var $601f1cec0fd39354$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
var $601f1cec0fd39354$var$SelectSelect = (0, $gSv8W.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            (0, $2iBlG._)({}, "&.".concat((0, $bCbKk.default).select), styles.select),
            (0, $2iBlG._)({}, "&.".concat((0, $bCbKk.default).select), styles[ownerState.variant]),
            (0, $2iBlG._)({}, "&.".concat((0, $bCbKk.default).error), styles.error),
            (0, $2iBlG._)({}, "&.".concat((0, $bCbKk.default).multiple), styles.multiple)
        ];
    }
})((0, $fhwcH.nativeSelectSelectStyles), // Win specificity over the input base
(0, $2iBlG._)({}, "&.".concat((0, $bCbKk.default).select), {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
}));
var $601f1cec0fd39354$var$SelectIcon = (0, $gSv8W.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.icon,
            ownerState.variant && styles["icon".concat((0, $lqmBd.default)(ownerState.variant))],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $fhwcH.nativeSelectIconStyles));
var $601f1cec0fd39354$var$SelectNativeInput = (0, $gSv8W.default)("input", {
    shouldForwardProp: function(prop) {
        return (0, $gSv8W.slotShouldForwardProp)(prop) && prop !== "classes";
    },
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: function(props, styles) {
        return styles.nativeInput;
    }
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $601f1cec0fd39354$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $601f1cec0fd39354$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
var $601f1cec0fd39354$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, variant = ownerState.variant, disabled = ownerState.disabled, multiple = ownerState.multiple, open = ownerState.open, error = ownerState.error;
    var slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            "icon".concat((0, $lqmBd.default)(variant)),
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $bCbKk.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ var $601f1cec0fd39354$var$SelectInput = /*#__PURE__*/ $3aC2T.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    var ariaDescribedby = props["aria-describedby"], ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, className = props.className, defaultOpen = props.defaultOpen, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, _props_error = props.error, error = _props_error === void 0 ? false : _props_error, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props_MenuProps = props.MenuProps, MenuProps = _props_MenuProps === void 0 ? {} : _props_MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props_SelectDisplayProps = props.SelectDisplayProps, SelectDisplayProps = _props_SelectDisplayProps === void 0 ? {} : _props_SelectDisplayProps, tabIndexProp = props.tabIndex, valueProp = props.value, _props_variant = props.variant, variant = _props_variant === void 0 ? "standard" : _props_variant, other = (0, $8vpQL.default)(props, $601f1cec0fd39354$var$_excluded);
    var _useControlled = (0, $aSMts._)((0, $a1r53.default)({
        controlled: valueProp,
        "default": defaultValue,
        name: "Select"
    }), 2), value = _useControlled[0], setValueState = _useControlled[1];
    var _useControlled1 = (0, $aSMts._)((0, $a1r53.default)({
        controlled: openProp,
        "default": defaultOpen,
        name: "Select"
    }), 2), openState = _useControlled1[0], setOpenState = _useControlled1[1];
    var inputRef = $3aC2T.useRef(null);
    var displayRef = $3aC2T.useRef(null);
    var _React_useState = (0, $aSMts._)($3aC2T.useState(null), 2), displayNode = _React_useState[0], setDisplayNode = _React_useState[1];
    var _React_useRef = $3aC2T.useRef(openProp != null), isOpenControlled = _React_useRef.current;
    var _React_useState1 = (0, $aSMts._)($3aC2T.useState(), 2), menuMinWidthState = _React_useState1[0], setMenuMinWidthState = _React_useState1[1];
    var handleRef = (0, $gcZH1.default)(ref, inputRefProp);
    var handleDisplayRef = $3aC2T.useCallback(function(node) {
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    var anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $3aC2T.useImperativeHandle(handleRef, function() {
        return {
            focus: function() {
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $3aC2T.useEffect(function() {
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $3aC2T.useEffect(function() {
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $3aC2T.useEffect(function() {
        if (!labelId) return undefined;
        var label = (0, $dl4cE.default)(displayRef.current).getElementById(labelId);
        if (label) {
            var handler = function() {
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return function() {
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    var update = function(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    var handleClose = function(event) {
        update(false, event);
    };
    var childrenArray = $3aC2T.Children.toArray(children);
    // Support autofill.
    var handleChange = function(event) {
        var child = childrenArray.find(function(childItem) {
            return childItem.props.value === event.target.value;
        });
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function(child) {
        return function(event) {
            var newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    var nativeEvent = event.nativeEvent || event;
                    var clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    };
    var handleKeyDown = function(event) {
        if (!readOnly) {
            var validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && openState;
    var handleBlur = function(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $3FQQU.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $3aC2T.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $cZvD6.default)(2));
            selected = value.some(function(v) {
                return $601f1cec0fd39354$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $601f1cec0fd39354$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $3aC2T.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: function(event) {
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce(function(output, child, index) {
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    var ownerState = (0, $3hDKy.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    var classes = $601f1cec0fd39354$var$useUtilityClasses(ownerState);
    var paperProps = (0, $3hDKy.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    return /*#__PURE__*/ (0, $esXub.jsxs)($3aC2T.Fragment, {
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)($601f1cec0fd39354$var$SelectSelect, (0, $3hDKy.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $5i80G.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $601f1cec0fd39354$var$isEmpty(display) ? $601f1cec0fd39354$var$_span || ($601f1cec0fd39354$var$_span = /*#__PURE__*/ (0, $esXub.jsx)("span", {
                    className: "notranslate",
                    children: "​"
                })) : display
            })),
            /*#__PURE__*/ (0, $esXub.jsx)($601f1cec0fd39354$var$SelectNativeInput, (0, $3hDKy.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $esXub.jsx)($601f1cec0fd39354$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $esXub.jsx)((0, $2LfbM.default), (0, $3hDKy.default)({
                id: "menu-".concat(name || ""),
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $3hDKy.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                slotProps: {
                    paper: (0, $3hDKy.default)({}, paperProps, {
                        style: (0, $3hDKy.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                },
                children: items
            }))
        ]
    });
});
var $601f1cec0fd39354$export$2e2bcd8739ae039 = $601f1cec0fd39354$var$SelectInput;

});
parcelRequire.register("dl4cE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b607f2895eaa376$export$2e2bcd8739ae039; });

var $gM8lu = parcelRequire("gM8lu");
var $9b607f2895eaa376$export$2e2bcd8739ae039 = (0, $gM8lu.default);

});

parcelRequire.register("2LfbM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $202bc0c95f590091$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");
parcelRequire("4ti5v");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $9BQAY = parcelRequire("9BQAY");


var $bLg9u = parcelRequire("bLg9u");

var $fKBCx = parcelRequire("fKBCx");

var $gSv8W = parcelRequire("gSv8W");

var $iYQo1 = parcelRequire("iYQo1");

var $4WGW4 = parcelRequire("4WGW4");

var $fPfRG = parcelRequire("fPfRG");

var $esXub = parcelRequire("esXub");
"use client";
var $202bc0c95f590091$var$_excluded = [
    "onEntering"
], $202bc0c95f590091$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
var $202bc0c95f590091$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
var $202bc0c95f590091$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
var $202bc0c95f590091$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $fPfRG.getMenuUtilityClass), classes);
};
var $202bc0c95f590091$var$MenuRoot = (0, $gSv8W.default)((0, $fKBCx.default), {
    shouldForwardProp: function(prop) {
        return (0, $gSv8W.rootShouldForwardProp)(prop) || prop === "classes";
    },
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: function(props, styles) {
        return styles.root;
    }
})({});
var $202bc0c95f590091$export$4f7c51a5920c9f33 = (0, $gSv8W.default)((0, $fKBCx.PopoverPaper), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: function(props, styles) {
        return styles.paper;
    }
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
var $202bc0c95f590091$var$MenuMenuList = (0, $gSv8W.default)((0, $bLg9u.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: function(props, styles) {
        return styles.list;
    }
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
var $202bc0c95f590091$var$Menu = /*#__PURE__*/ $3aC2T.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiMenu"
    });
    var _props_autoFocus = props.autoFocus, autoFocus = _props_autoFocus === void 0 ? true : _props_autoFocus, children = props.children, className = props.className, _props_disableAutoFocusItem = props.disableAutoFocusItem, disableAutoFocusItem = _props_disableAutoFocusItem === void 0 ? false : _props_disableAutoFocusItem, _props_MenuListProps = props.MenuListProps, MenuListProps = _props_MenuListProps === void 0 ? {} : _props_MenuListProps, onClose = props.onClose, open = props.open, _props_PaperProps = props.PaperProps, PaperProps = _props_PaperProps === void 0 ? {} : _props_PaperProps, PopoverClasses = props.PopoverClasses, _props_transitionDuration = props.transitionDuration, transitionDuration = _props_transitionDuration === void 0 ? "auto" : _props_transitionDuration, tmp = props.TransitionProps, onEntering = (tmp === void 0 ? {} : tmp).onEntering, _props_variant = props.variant, variant = _props_variant === void 0 ? "selectedMenu" : _props_variant, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, TransitionProps = (0, $8vpQL.default)(props.TransitionProps, $202bc0c95f590091$var$_excluded), other = (0, $8vpQL.default)(props, $202bc0c95f590091$var$_excluded2);
    var theme = (0, $iYQo1.default)();
    var isRtl = theme.direction === "rtl";
    var ownerState = (0, $3hDKy.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    var classes = $202bc0c95f590091$var$useUtilityClasses(ownerState);
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $3aC2T.useRef(null);
    var handleEntering = function(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $3aC2T.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $3aC2T.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $202bc0c95f590091$export$4f7c51a5920c9f33;
    var paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    var rootSlotProps = (0, $9BQAY.useSlotProps)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    var paperSlotProps = (0, $9BQAY.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $esXub.jsx)($202bc0c95f590091$var$MenuRoot, (0, $3hDKy.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $202bc0c95f590091$var$RTL_ORIGIN : $202bc0c95f590091$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $3hDKy.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $esXub.jsx)($202bc0c95f590091$var$MenuMenuList, (0, $3hDKy.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $5i80G.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $202bc0c95f590091$export$2e2bcd8739ae039 = $202bc0c95f590091$var$Menu;

});
parcelRequire.register("9BQAY", function(module, exports) {

$parcel$export(module.exports, "useSlotProps", function () { return $6ff05e1a485f5db0$export$1e5c9e6e4e15efe3; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $6mnDc = parcelRequire("6mnDc");

var $gKP8R = parcelRequire("gKP8R");

var $9ql1A = parcelRequire("9ql1A");

var $jjxGk = parcelRequire("jjxGk");
"use client";
var $6ff05e1a485f5db0$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $6ff05e1a485f5db0$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    var elementType = parameters.elementType, externalSlotProps = parameters.externalSlotProps, ownerState = parameters.ownerState, _parameters_skipResolvingSlotProps = parameters.skipResolvingSlotProps, skipResolvingSlotProps = _parameters_skipResolvingSlotProps === void 0 ? false : _parameters_skipResolvingSlotProps, rest = (0, $8vpQL.default)(parameters, $6ff05e1a485f5db0$var$_excluded);
    var resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $jjxGk.resolveComponentProps)(externalSlotProps, ownerState);
    var _mergeSlotProps = (0, $9ql1A.mergeSlotProps)((0, $3hDKy.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    })), mergedProps = _mergeSlotProps.props, internalRef = _mergeSlotProps.internalRef;
    var ref = (0, $6mnDc.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    var props = (0, $gKP8R.appendOwnerState)(elementType, (0, $3hDKy.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}

});
parcelRequire.register("gKP8R", function(module, exports) {

$parcel$export(module.exports, "appendOwnerState", function () { return $c3289cf5d0b094aa$export$b089efb01a7bdf50; });

var $3hDKy = parcelRequire("3hDKy");

var $lp3r0 = parcelRequire("lp3r0");
function $c3289cf5d0b094aa$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $lp3r0.isHostComponent)(elementType)) return otherProps;
    return (0, $3hDKy.default)({}, otherProps, {
        ownerState: (0, $3hDKy.default)({}, otherProps.ownerState, ownerState)
    });
}

});

parcelRequire.register("9ql1A", function(module, exports) {

$parcel$export(module.exports, "mergeSlotProps", function () { return $6dc6d9cd54a4ac7c$export$b01d1e419b049226; });

var $3hDKy = parcelRequire("3hDKy");

var $5i80G = parcelRequire("5i80G");

var $l9nMF = parcelRequire("l9nMF");

var $9e8D2 = parcelRequire("9e8D2");
function $6dc6d9cd54a4ac7c$export$b01d1e419b049226(parameters) {
    var getSlotProps = parameters.getSlotProps, additionalProps = parameters.additionalProps, externalSlotProps = parameters.externalSlotProps, externalForwardedProps = parameters.externalForwardedProps, className = parameters.className;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        var joinedClasses = (0, $5i80G.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        var mergedStyle = (0, $3hDKy.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        var props = (0, $3hDKy.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    var eventHandlers = (0, $l9nMF.extractEventHandlers)((0, $3hDKy.default)({}, externalForwardedProps, externalSlotProps));
    var componentsPropsWithoutEventHandlers = (0, $9e8D2.omitEventHandlers)(externalSlotProps);
    var otherPropsWithoutEventHandlers = (0, $9e8D2.omitEventHandlers)(externalForwardedProps);
    var internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    var joinedClasses1 = (0, $5i80G.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    var mergedStyle1 = (0, $3hDKy.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    var props1 = (0, $3hDKy.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses1.length > 0) props1.className = joinedClasses1;
    if (Object.keys(mergedStyle1).length > 0) props1.style = mergedStyle1;
    return {
        props: props1,
        internalRef: internalSlotProps.ref
    };
}

});
parcelRequire.register("l9nMF", function(module, exports) {

$parcel$export(module.exports, "extractEventHandlers", function () { return $f65ce335ceebc577$export$24d5698b57eff81c; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $f65ce335ceebc577$export$24d5698b57eff81c(object) {
    var excludeKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (object === undefined) return {};
    var result = {};
    Object.keys(object).filter(function(prop) {
        return prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop);
    }).forEach(function(prop) {
        result[prop] = object[prop];
    });
    return result;
}

});

parcelRequire.register("9e8D2", function(module, exports) {

$parcel$export(module.exports, "omitEventHandlers", function () { return $6b7c1d4eb8e2a6b7$export$2ac0fa4d3a39be45; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $6b7c1d4eb8e2a6b7$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    var result = {};
    Object.keys(object).filter(function(prop) {
        return !(prop.match(/^on[A-Z]/) && typeof object[prop] === "function");
    }).forEach(function(prop) {
        result[prop] = object[prop];
    });
    return result;
}

});


parcelRequire.register("jjxGk", function(module, exports) {

$parcel$export(module.exports, "resolveComponentProps", function () { return $e0f9eb2d8224516b$export$308c24034cde71de; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $e0f9eb2d8224516b$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}

});


parcelRequire.register("bLg9u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89009cfacf6b27af$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");
parcelRequire("4ti5v");


var $dl4cE = parcelRequire("dl4cE");

var $4e3d6 = parcelRequire("4e3d6");

var $3mxHJ = parcelRequire("3mxHJ");

var $gcZH1 = parcelRequire("gcZH1");

var $lOvSp = parcelRequire("lOvSp");

var $esXub = parcelRequire("esXub");
"use client";
var $89009cfacf6b27af$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $89009cfacf6b27af$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $89009cfacf6b27af$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $89009cfacf6b27af$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $89009cfacf6b27af$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$89009cfacf6b27af$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $89009cfacf6b27af$var$MenuList = /*#__PURE__*/ $3aC2T.forwardRef(function MenuList(props, ref) {
    var // private
    // eslint-disable-next-line react/prop-types
    actions = props.actions, _props_autoFocus = props.autoFocus, autoFocus = _props_autoFocus === void 0 ? false : _props_autoFocus, _props_autoFocusItem = props.autoFocusItem, autoFocusItem = _props_autoFocusItem === void 0 ? false : _props_autoFocusItem, children = props.children, className = props.className, _props_disabledItemsFocusable = props.disabledItemsFocusable, disabledItemsFocusable = _props_disabledItemsFocusable === void 0 ? false : _props_disabledItemsFocusable, _props_disableListWrap = props.disableListWrap, disableListWrap = _props_disableListWrap === void 0 ? false : _props_disableListWrap, onKeyDown = props.onKeyDown, _props_variant = props.variant, variant = _props_variant === void 0 ? "selectedMenu" : _props_variant, other = (0, $8vpQL.default)(props, $89009cfacf6b27af$var$_excluded);
    var listRef = $3aC2T.useRef(null);
    var textCriteriaRef = $3aC2T.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $lOvSp.default)(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $3aC2T.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $3mxHJ.default)((0, $dl4cE.default)(containerElement)), "px");
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $dl4cE.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $89009cfacf6b27af$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $89009cfacf6b27af$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $89009cfacf6b27af$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $89009cfacf6b27af$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $89009cfacf6b27af$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $89009cfacf6b27af$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $89009cfacf6b27af$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $89009cfacf6b27af$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $89009cfacf6b27af$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $89009cfacf6b27af$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $89009cfacf6b27af$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleRef = (0, $gcZH1.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $3aC2T.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $3aC2T.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    var items = $3aC2T.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $3aC2T.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $4e3d6.default), (0, $3hDKy.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $89009cfacf6b27af$export$2e2bcd8739ae039 = $89009cfacf6b27af$var$MenuList;

});
parcelRequire.register("4e3d6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $313af5be829c6632$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $l4bDc = parcelRequire("l4bDc");

var $bJvE4 = parcelRequire("bJvE4");

var $esXub = parcelRequire("esXub");
"use client";
var $313af5be829c6632$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
var $313af5be829c6632$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, disablePadding = ownerState.disablePadding, dense = ownerState.dense, subheader = ownerState.subheader;
    var slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $bJvE4.getListUtilityClass), classes);
};
var $313af5be829c6632$var$ListRoot = (0, $gSv8W.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(function(param) {
    var ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    });
});
var $313af5be829c6632$var$List = /*#__PURE__*/ $3aC2T.forwardRef(function List(inProps, ref) {
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiList"
    });
    var children = props.children, className = props.className, _props_component = props.component, component = _props_component === void 0 ? "ul" : _props_component, _props_dense = props.dense, dense = _props_dense === void 0 ? false : _props_dense, _props_disablePadding = props.disablePadding, disablePadding = _props_disablePadding === void 0 ? false : _props_disablePadding, subheader = props.subheader, other = (0, $8vpQL.default)(props, $313af5be829c6632$var$_excluded);
    var context = $3aC2T.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    var ownerState = (0, $3hDKy.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    var classes = $313af5be829c6632$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $l4bDc.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $esXub.jsxs)($313af5be829c6632$var$ListRoot, (0, $3hDKy.default)({
            as: component,
            className: (0, $5i80G.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $313af5be829c6632$export$2e2bcd8739ae039 = $313af5be829c6632$var$List;

});
parcelRequire.register("l4bDc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f562fe68969a6939$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
"use client";
/**
 * @ignore - internal component.
 */ var $f562fe68969a6939$var$ListContext = /*#__PURE__*/ $3aC2T.createContext({});
var $f562fe68969a6939$export$2e2bcd8739ae039 = $f562fe68969a6939$var$ListContext;

});

parcelRequire.register("bJvE4", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $88ac71c6be722808$export$c6bd6795ed6e3203; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $88ac71c6be722808$export$c6bd6795ed6e3203(slot) {
    return (0, $iZWB2.default)("MuiList", slot);
}
var $88ac71c6be722808$var$listClasses = (0, $1Zd5c.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $88ac71c6be722808$export$2e2bcd8739ae039 = $88ac71c6be722808$var$listClasses;

});


parcelRequire.register("3mxHJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $272d92262657ddd8$export$2e2bcd8739ae039; });

var $ejVIU = parcelRequire("ejVIU");
var $272d92262657ddd8$export$2e2bcd8739ae039 = (0, $ejVIU.default);

});
parcelRequire.register("ejVIU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6cf9dab968bc339$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $a6cf9dab968bc339$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    var documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});



parcelRequire.register("fKBCx", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", function () { return $b77855935033ad68$export$821346c38a2d9390; });
$parcel$export(module.exports, "default", function () { return $b77855935033ad68$export$2e2bcd8739ae039; });

var $aSMts = parcelRequire("aSMts");

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $lp3r0 = parcelRequire("lp3r0");
var $i7SXW = parcelRequire("i7SXW");
var $9BQAY = parcelRequire("9BQAY");


var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $8ja3k = parcelRequire("8ja3k");

var $dl4cE = parcelRequire("dl4cE");

var $6H54Z = parcelRequire("6H54Z");

var $gcZH1 = parcelRequire("gcZH1");

var $i7pw4 = parcelRequire("i7pw4");

var $bTE2V = parcelRequire("bTE2V");

var $1LxH8 = parcelRequire("1LxH8");

var $eIvSj = parcelRequire("eIvSj");

var $esXub = parcelRequire("esXub");
"use client";
var $b77855935033ad68$var$_excluded = [
    "onEntering"
], $b77855935033ad68$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $b77855935033ad68$var$_excluded3 = [
    "slotProps"
];
function $b77855935033ad68$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $b77855935033ad68$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $b77855935033ad68$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === "number" ? "".concat(n, "px") : n;
    }).join(" ");
}
function $b77855935033ad68$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
var $b77855935033ad68$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $eIvSj.getPopoverUtilityClass), classes);
};
var $b77855935033ad68$export$bcce13685275fc99 = (0, $gSv8W.default)((0, $bTE2V.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: function(props, styles) {
        return styles.root;
    }
})({});
var $b77855935033ad68$export$821346c38a2d9390 = (0, $gSv8W.default)((0, $1LxH8.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: function(props, styles) {
        return styles.paper;
    }
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
var $b77855935033ad68$var$Popover = /*#__PURE__*/ $3aC2T.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiPopover"
    });
    var action = props.action, anchorEl = props.anchorEl, _props_anchorOrigin = props.anchorOrigin, anchorOrigin = _props_anchorOrigin === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props_anchorOrigin, anchorPosition = props.anchorPosition, _props_anchorReference = props.anchorReference, anchorReference = _props_anchorReference === void 0 ? "anchorEl" : _props_anchorReference, children = props.children, className = props.className, containerProp = props.container, _props_elevation = props.elevation, elevation = _props_elevation === void 0 ? 8 : _props_elevation, _props_marginThreshold = props.marginThreshold, marginThreshold = _props_marginThreshold === void 0 ? 16 : _props_marginThreshold, open = props.open, tmp = props.PaperProps, PaperPropsProp = tmp === void 0 ? {} : tmp, slots = props.slots, slotProps = props.slotProps, _props_transformOrigin = props.transformOrigin, transformOrigin = _props_transformOrigin === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props_transformOrigin, _props_TransitionComponent = props.TransitionComponent, TransitionComponent = _props_TransitionComponent === void 0 ? (0, $i7pw4.default) : _props_TransitionComponent, tmp1 = props.transitionDuration, transitionDurationProp = tmp1 === void 0 ? "auto" : tmp1, tmp2 = props.TransitionProps, onEntering = (tmp2 === void 0 ? {} : tmp2).onEntering, _props_disableScrollLock = props.disableScrollLock, disableScrollLock = _props_disableScrollLock === void 0 ? false : _props_disableScrollLock, TransitionProps = (0, $8vpQL.default)(props.TransitionProps, $b77855935033ad68$var$_excluded), other = (0, $8vpQL.default)(props, $b77855935033ad68$var$_excluded2);
    var externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    var paperRef = $3aC2T.useRef();
    var handlePaperRef = (0, $gcZH1.default)(paperRef, externalPaperSlotProps.ref);
    var ownerState = (0, $3hDKy.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    var classes = $b77855935033ad68$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $3aC2T.useCallback(function() {
        if (anchorReference === "anchorPosition") return anchorPosition;
        var resolvedAnchorEl = $b77855935033ad68$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $dl4cE.default)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $b77855935033ad68$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $b77855935033ad68$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    var getTransformOrigin = $3aC2T.useCallback(function(elemRect) {
        return {
            vertical: $b77855935033ad68$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $b77855935033ad68$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $3aC2T.useCallback(function(element) {
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $b77855935033ad68$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        var anchorOffset = getAnchorOffset();
        // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $6H54Z.default)($b77855935033ad68$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            var diff1 = bottom - heightThreshold;
            top -= diff1;
            elemTransformOrigin.vertical += diff1;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            var diff2 = left - marginThreshold;
            left -= diff2;
            elemTransformOrigin.horizontal += diff2;
        } else if (right > widthThreshold) {
            var diff3 = right - widthThreshold;
            left -= diff3;
            elemTransformOrigin.horizontal += diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $b77855935033ad68$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var _React_useState = (0, $aSMts._)($3aC2T.useState(open), 2), isPositioned = _React_useState[0], setIsPositioned = _React_useState[1];
    var setPositioningStyles = $3aC2T.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $3aC2T.useEffect(function() {
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return function() {
            return window.removeEventListener("scroll", setPositioningStyles);
        };
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    var handleEntering = function(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handleExited = function() {
        setIsPositioned(false);
    };
    $3aC2T.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $3aC2T.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $3aC2T.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $8ja3k.default)(function() {
            setPositioningStyles();
        });
        var containerWindow = (0, $6H54Z.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $dl4cE.default)($b77855935033ad68$var$resolveAnchorEl(anchorEl)).body : undefined);
    var RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $b77855935033ad68$export$bcce13685275fc99;
    var PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $b77855935033ad68$export$821346c38a2d9390;
    var paperProps = (0, $9BQAY.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: (0, $3hDKy.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $3hDKy.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $5i80G.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    var _useSlotProps = (0, $9BQAY.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $5i80G.default)(classes.root, className)
    }), rootSlotPropsProp = _useSlotProps.slotProps, rootProps = (0, $8vpQL.default)(_useSlotProps, $b77855935033ad68$var$_excluded3);
    return /*#__PURE__*/ (0, $esXub.jsx)(RootSlot, (0, $3hDKy.default)({}, rootProps, !(0, $lp3r0.isHostComponent)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $esXub.jsx)(TransitionComponent, (0, $3hDKy.default)({
            appear: true,
            "in": open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $esXub.jsx)(PaperSlot, (0, $3hDKy.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $b77855935033ad68$export$2e2bcd8739ae039 = $b77855935033ad68$var$Popover;

});
parcelRequire.register("8ja3k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60c7e5584e6d51b3$export$2e2bcd8739ae039; });

var $j1xdx = parcelRequire("j1xdx");
var $60c7e5584e6d51b3$export$2e2bcd8739ae039 = (0, $j1xdx.default);

});

parcelRequire.register("6H54Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dfab2eddf834e69$export$2e2bcd8739ae039; });

var $fAR5q = parcelRequire("fAR5q");
var $4dfab2eddf834e69$export$2e2bcd8739ae039 = (0, $fAR5q.default);

});

parcelRequire.register("i7pw4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d30cac6b1c249069$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");



var $GorQr = parcelRequire("GorQr");

var $iYQo1 = parcelRequire("iYQo1");

var $hi9je = parcelRequire("hi9je");

var $gcZH1 = parcelRequire("gcZH1");

var $esXub = parcelRequire("esXub");
"use client";
var $d30cac6b1c249069$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d30cac6b1c249069$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $d30cac6b1c249069$var$styles = {
    entering: {
        opacity: 1,
        transform: $d30cac6b1c249069$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ var $d30cac6b1c249069$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $d30cac6b1c249069$var$Grow = /*#__PURE__*/ $3aC2T.forwardRef(function Grow(props, ref) {
    var addEndListener = props.addEndListener, _props_appear = props.appear, appear = _props_appear === void 0 ? true : _props_appear, children = props.children, easing = props.easing, inProp = props["in"], onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props_timeout = props.timeout, timeout = _props_timeout === void 0 ? "auto" : _props_timeout, _props_TransitionComponent = props.// eslint-disable-next-line react/prop-types
    TransitionComponent, TransitionComponent = _props_TransitionComponent === void 0 ? (0, $GorQr.default) : _props_TransitionComponent, other = (0, $8vpQL.default)(props, $d30cac6b1c249069$var$_excluded);
    var timer = $3aC2T.useRef();
    var autoTimeout = $3aC2T.useRef();
    var theme = (0, $iYQo1.default)();
    var nodeRef = $3aC2T.useRef(null);
    var handleRef = (0, $gcZH1.default)(nodeRef, children.ref, ref);
    var normalizedTransitionCallback = function(callback) {
        return function(maybeIsAppearing) {
            if (callback) {
                var node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $hi9je.reflow)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $hi9je.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay, transitionTimingFunction = _getTransitionProps.easing;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $d30cac6b1c249069$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps = (0, $hi9je.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay, transitionTimingFunction = _getTransitionProps.easing;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $d30cac6b1c249069$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d30cac6b1c249069$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $d30cac6b1c249069$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleAddEndListener = function(next) {
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $3aC2T.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $esXub.jsx)(TransitionComponent, (0, $3hDKy.default)({
        appear: appear,
        "in": inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: function(state, childProps) {
            return /*#__PURE__*/ $3aC2T.cloneElement(children, (0, $3hDKy.default)({
                style: (0, $3hDKy.default)({
                    opacity: 0,
                    transform: $d30cac6b1c249069$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $d30cac6b1c249069$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$d30cac6b1c249069$var$Grow.muiSupportAuto = true;
var $d30cac6b1c249069$export$2e2bcd8739ae039 = $d30cac6b1c249069$var$Grow;

});

parcelRequire.register("bTE2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a93e51ab52ef03a$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");


var $9BQAY = parcelRequire("9BQAY");

var $jo4Ok = parcelRequire("jo4Ok");

var $i7SXW = parcelRequire("i7SXW");

var $bxUnh = parcelRequire("bxUnh");

var $2xq0P = parcelRequire("2xq0P");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $5ME3L = parcelRequire("5ME3L");

var $jMtk4 = parcelRequire("jMtk4");

var $esXub = parcelRequire("esXub");
"use client";
var $8a93e51ab52ef03a$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
var $8a93e51ab52ef03a$var$useUtilityClasses = function(ownerState) {
    var open = ownerState.open, exited = ownerState.exited, classes = ownerState.classes;
    var slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $jMtk4.getModalUtilityClass), classes);
};
var $8a93e51ab52ef03a$var$ModalRoot = (0, $gSv8W.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    });
});
var $8a93e51ab52ef03a$var$ModalBackdrop = (0, $gSv8W.default)((0, $5ME3L.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: function(props, styles) {
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $8a93e51ab52ef03a$var$Modal = /*#__PURE__*/ $3aC2T.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    var props = (0, $4WGW4.default)({
        name: "MuiModal",
        props: inProps
    });
    var _props_BackdropComponent = props.BackdropComponent, BackdropComponent = _props_BackdropComponent === void 0 ? $8a93e51ab52ef03a$var$ModalBackdrop : _props_BackdropComponent, BackdropProps = props.BackdropProps, className = props.className, _props_closeAfterTransition = props.closeAfterTransition, closeAfterTransition = _props_closeAfterTransition === void 0 ? false : _props_closeAfterTransition, children = props.children, container = props.container, component = props.component, _props_components = props.components, components = _props_components === void 0 ? {} : _props_components, _props_componentsProps = props.componentsProps, componentsProps = _props_componentsProps === void 0 ? {} : _props_componentsProps, _props_disableAutoFocus = props.disableAutoFocus, disableAutoFocus = _props_disableAutoFocus === void 0 ? false : _props_disableAutoFocus, _props_disableEnforceFocus = props.disableEnforceFocus, disableEnforceFocus = _props_disableEnforceFocus === void 0 ? false : _props_disableEnforceFocus, _props_disableEscapeKeyDown = props.disableEscapeKeyDown, disableEscapeKeyDown = _props_disableEscapeKeyDown === void 0 ? false : _props_disableEscapeKeyDown, _props_disablePortal = props.disablePortal, disablePortal = _props_disablePortal === void 0 ? false : _props_disablePortal, _props_disableRestoreFocus = props.disableRestoreFocus, disableRestoreFocus = _props_disableRestoreFocus === void 0 ? false : _props_disableRestoreFocus, _props_disableScrollLock = props.disableScrollLock, disableScrollLock = _props_disableScrollLock === void 0 ? false : _props_disableScrollLock, _props_hideBackdrop = props.hideBackdrop, hideBackdrop = _props_hideBackdrop === void 0 ? false : _props_hideBackdrop, _props_keepMounted = props.keepMounted, keepMounted = _props_keepMounted === void 0 ? false : _props_keepMounted, onBackdropClick = props.onBackdropClick, open = props.open, slotProps = props.slotProps, slots = props.slots, other = (0, $8vpQL.default)(props, $8a93e51ab52ef03a$var$_excluded);
    var propsWithDefaults = (0, $3hDKy.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    var _useModal = (0, $jo4Ok.useModal)((0, $3hDKy.default)({}, propsWithDefaults, {
        rootRef: ref
    })), getRootProps = _useModal.getRootProps, getBackdropProps = _useModal.getBackdropProps, getTransitionProps = _useModal.getTransitionProps, portalRef = _useModal.portalRef, isTopModal = _useModal.isTopModal, exited = _useModal.exited, hasTransition = _useModal.hasTransition;
    var ownerState = (0, $3hDKy.default)({}, propsWithDefaults, {
        exited: exited
    });
    var classes = $8a93e51ab52ef03a$var$useUtilityClasses(ownerState);
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        var _getTransitionProps = getTransitionProps(), onEnter = _getTransitionProps.onEnter, onExited = _getTransitionProps.onExited;
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    var RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $8a93e51ab52ef03a$var$ModalRoot;
    var BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    var rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    var backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    var rootProps = (0, $9BQAY.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $5i80G.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    var backdropProps = (0, $9BQAY.useSlotProps)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: function(otherHandlers) {
            return getBackdropProps((0, $3hDKy.default)({}, otherHandlers, {
                onClick: function(e) {
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $5i80G.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $2xq0P.Portal), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $esXub.jsxs)(RootSlot, (0, $3hDKy.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $esXub.jsx)(BackdropSlot, (0, $3hDKy.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $esXub.jsx)((0, $bxUnh.FocusTrap), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $3aC2T.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $8a93e51ab52ef03a$export$2e2bcd8739ae039 = $8a93e51ab52ef03a$var$Modal;

});
parcelRequire.register("jo4Ok", function(module, exports) {

$parcel$export(module.exports, "useModal", function () { return $e1d3fd87a804cdbe$export$33ffd74ebf07f060; });

var $aSMts = parcelRequire("aSMts");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");

var $9w66k = parcelRequire("9w66k");
var $gM8lu = parcelRequire("gM8lu");
var $9EdjO = parcelRequire("9EdjO");
var $6mnDc = parcelRequire("6mnDc");

var $l9nMF = parcelRequire("l9nMF");

var $fLJ6l = parcelRequire("fLJ6l");
"use client";
function $e1d3fd87a804cdbe$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $e1d3fd87a804cdbe$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $e1d3fd87a804cdbe$var$defaultManager = new (0, $fLJ6l.ModalManager)();
function $e1d3fd87a804cdbe$export$33ffd74ebf07f060(parameters) {
    var container = parameters.container, _parameters_disableEscapeKeyDown = parameters.disableEscapeKeyDown, disableEscapeKeyDown = _parameters_disableEscapeKeyDown === void 0 ? false : _parameters_disableEscapeKeyDown, _parameters_disableScrollLock = parameters.disableScrollLock, disableScrollLock = _parameters_disableScrollLock === void 0 ? false : _parameters_disableScrollLock, _parameters_manager = parameters.// @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager, manager = _parameters_manager === void 0 ? $e1d3fd87a804cdbe$var$defaultManager : _parameters_manager, _parameters_closeAfterTransition = parameters.closeAfterTransition, closeAfterTransition = _parameters_closeAfterTransition === void 0 ? false : _parameters_closeAfterTransition, onTransitionEnter = parameters.onTransitionEnter, onTransitionExited = parameters.onTransitionExited, children = parameters.children, onClose = parameters.onClose, open = parameters.open, rootRef = parameters.rootRef;
    // @ts-ignore internal logic
    var modal = $3aC2T.useRef({});
    var mountNodeRef = $3aC2T.useRef(null);
    var modalRef = $3aC2T.useRef(null);
    var handleRef = (0, $6mnDc.default)(modalRef, rootRef);
    var _React_useState = (0, $aSMts._)($3aC2T.useState(!open), 2), exited = _React_useState[0], setExited = _React_useState[1];
    var hasTransition = $e1d3fd87a804cdbe$var$getHasTransition(children);
    var ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    var getDoc = function() {
        return (0, $gM8lu.default)(mountNodeRef.current);
    };
    var getModal = function() {
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $9EdjO.default)(function() {
        var resolvedContainer = $e1d3fd87a804cdbe$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $3aC2T.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $9EdjO.default)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $fLJ6l.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    var handleClose = $3aC2T.useCallback(function() {
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $3aC2T.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $3aC2T.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    var createHandleKeyDown = function(otherHandlers) {
        return function(event) {
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    };
    var createHandleBackdropClick = function(otherHandlers) {
        return function(event) {
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    };
    var getRootProps = function() {
        var otherHandlers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var propsEventHandlers = (0, $l9nMF.extractEventHandlers)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        var externalEventHandlers = (0, $3hDKy.default)({}, propsEventHandlers, otherHandlers);
        return (0, $3hDKy.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    var getBackdropProps = function() {
        var otherHandlers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var externalEventHandlers = otherHandlers;
        return (0, $3hDKy.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    var getTransitionProps = function() {
        var handleEnter = function() {
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        var handleExited = function() {
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $9w66k.default)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $9w66k.default)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}

});
parcelRequire.register("9w66k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6edbd5bf481456a9$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $6edbd5bf481456a9$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}

});

parcelRequire.register("fLJ6l", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $b7ae3b00db51d16c$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "ModalManager", function () { return $b7ae3b00db51d16c$export$ce11c4ecd08cea67; });

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $dHvbf = parcelRequire("dHvbf");

var $ejVIU = parcelRequire("ejVIU");
var $gM8lu = parcelRequire("gM8lu");
var $fAR5q = parcelRequire("fAR5q");
// Is a vertical scrollbar displayed?
function $b7ae3b00db51d16c$var$isOverflowing(container) {
    var doc = (0, $gM8lu.default)(container);
    if (doc.body === container) return (0, $fAR5q.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $b7ae3b00db51d16c$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $b7ae3b00db51d16c$var$getPaddingRight(element) {
    return parseInt((0, $fAR5q.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $b7ae3b00db51d16c$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    var forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    var isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    var isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $b7ae3b00db51d16c$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    var blacklist = [
        mountElement,
        currentElement
    ].concat((0, $dHvbf._)(elementsToExclude));
    [].forEach.call(container.children, function(element) {
        var isNotExcludedElement = blacklist.indexOf(element) === -1;
        var isNotForbiddenElement = !$b7ae3b00db51d16c$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $b7ae3b00db51d16c$export$e1bd0c6150f13d96(element, show);
    });
}
function $b7ae3b00db51d16c$var$findIndexOf(items, callback) {
    var idx = -1;
    items.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $b7ae3b00db51d16c$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($b7ae3b00db51d16c$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $ejVIU.default)((0, $gM8lu.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = "".concat($b7ae3b00db51d16c$var$getPaddingRight(container) + scrollbarSize, "px");
            // .mui-fixed is a global helper.
            var fixedElements = (0, $gM8lu.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, function(element) {
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = "".concat($b7ae3b00db51d16c$var$getPaddingRight(element) + scrollbarSize, "px");
            });
        }
        var scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $gM8lu.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            var parent = container.parentElement;
            var containerWindow = (0, $fAR5q.default)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    var restore = function() {
        restoreStyle.forEach(function(param) {
            var value = param.value, el = param.el, property = param.property;
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $b7ae3b00db51d16c$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(element) {
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
var $b7ae3b00db51d16c$export$ce11c4ecd08cea67 = /*#__PURE__*/ function() {
    "use strict";
    function ModalManager() {
        (0, $50OuQ._)(this, ModalManager);
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    (0, $fGdZr._)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal);
                // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $b7ae3b00db51d16c$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblings = $b7ae3b00db51d16c$var$getHiddenSiblings(container);
                $b7ae3b00db51d16c$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
                var containerIndex = $b7ae3b00db51d16c$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblings: hiddenSiblings
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $b7ae3b00db51d16c$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $b7ae3b00db51d16c$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var ariaHiddenState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $b7ae3b00db51d16c$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1);
                // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $b7ae3b00db51d16c$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
                    $b7ae3b00db51d16c$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1];
                    // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $b7ae3b00db51d16c$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();

});


parcelRequire.register("bxUnh", function(module, exports) {

$parcel$export(module.exports, "FocusTrap", function () { return $867e81930a6f8ad4$export$34eba2437817a67b; });

var $3aC2T = parcelRequire("3aC2T");


var $gM8lu = parcelRequire("gM8lu");
var $6mnDc = parcelRequire("6mnDc");

var $esXub = parcelRequire("esXub");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
var $867e81930a6f8ad4$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $867e81930a6f8ad4$var$getTabIndex(node) {
    var tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $867e81930a6f8ad4$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    var getRadio = function(selector) {
        return node.ownerDocument.querySelector('input[type="radio"]'.concat(selector));
    };
    var roving = getRadio('[name="'.concat(node.name, '"]:checked'));
    if (!roving) roving = getRadio('[name="'.concat(node.name, '"]'));
    return roving !== node;
}
function $867e81930a6f8ad4$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $867e81930a6f8ad4$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $867e81930a6f8ad4$var$defaultGetTabbable(root) {
    var regularTabNodes = [];
    var orderedTabNodes = [];
    Array.from(root.querySelectorAll($867e81930a6f8ad4$var$candidatesSelector)).forEach(function(node, i) {
        var nodeTabIndex = $867e81930a6f8ad4$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$867e81930a6f8ad4$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    }).concat(regularTabNodes);
}
function $867e81930a6f8ad4$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $867e81930a6f8ad4$export$34eba2437817a67b(props) {
    var children = props.children, _props_disableAutoFocus = props.disableAutoFocus, disableAutoFocus = _props_disableAutoFocus === void 0 ? false : _props_disableAutoFocus, _props_disableEnforceFocus = props.disableEnforceFocus, disableEnforceFocus = _props_disableEnforceFocus === void 0 ? false : _props_disableEnforceFocus, _props_disableRestoreFocus = props.disableRestoreFocus, disableRestoreFocus = _props_disableRestoreFocus === void 0 ? false : _props_disableRestoreFocus, _props_getTabbable = props.getTabbable, getTabbable = _props_getTabbable === void 0 ? $867e81930a6f8ad4$var$defaultGetTabbable : _props_getTabbable, _props_isEnabled = props.isEnabled, isEnabled = _props_isEnabled === void 0 ? $867e81930a6f8ad4$var$defaultIsEnabled : _props_isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $3aC2T.useRef(false);
    var sentinelStart = $3aC2T.useRef(null);
    var sentinelEnd = $3aC2T.useRef(null);
    var nodeToRestore = $3aC2T.useRef(null);
    var reactFocusEventTarget = $3aC2T.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    var activated = $3aC2T.useRef(false);
    var rootRef = $3aC2T.useRef(null);
    // @ts-expect-error TODO upstream fix
    var handleRef = (0, $6mnDc.default)(children.ref, rootRef);
    var lastKeydown = $3aC2T.useRef(null);
    $3aC2T.useEffect(function() {
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $3aC2T.useEffect(function() {
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        var doc = (0, $gM8lu.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return function() {
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $3aC2T.useEffect(function() {
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        var doc = (0, $gM8lu.default)(rootRef.current);
        var loopFocus = function(nativeEvent) {
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        var contain = function() {
            var rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            var tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                var isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                var focusNext = tabbable[0];
                var focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    var onFocus = function(event) {
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        var childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    var handleFocusSentinel = function(event) {
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $esXub.jsxs)($3aC2T.Fragment, {
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $3aC2T.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}

});

parcelRequire.register("2xq0P", function(module, exports) {

$parcel$export(module.exports, "Portal", function () { return $1d92d75c82f0e42a$export$602eac185826482c; });

var $aSMts = parcelRequire("aSMts");

var $3aC2T = parcelRequire("3aC2T");

var $hDjAY = parcelRequire("hDjAY");


var $rUaL0 = parcelRequire("rUaL0");
var $7GrSn = parcelRequire("7GrSn");
var $6mnDc = parcelRequire("6mnDc");

var $esXub = parcelRequire("esXub");
"use client";
function $1d92d75c82f0e42a$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ var $1d92d75c82f0e42a$export$602eac185826482c = /*#__PURE__*/ $3aC2T.forwardRef(function Portal(props, forwardedRef) {
    var children = props.children, container = props.container, _props_disablePortal = props.disablePortal, disablePortal = _props_disablePortal === void 0 ? false : _props_disablePortal;
    var _React_useState = (0, $aSMts._)($3aC2T.useState(null), 2), mountNode = _React_useState[0], setMountNode = _React_useState[1];
    // @ts-expect-error TODO upstream fix
    var handleRef = (0, $6mnDc.default)(/*#__PURE__*/ $3aC2T.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $7GrSn.default)(function() {
        if (!disablePortal) setMountNode($1d92d75c82f0e42a$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $7GrSn.default)(function() {
        if (mountNode && !disablePortal) {
            (0, $rUaL0.default)(forwardedRef, mountNode);
            return function() {
                (0, $rUaL0.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $3aC2T.isValidElement(children)) {
            var newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $3aC2T.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $esXub.jsx)($3aC2T.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $esXub.jsx)($3aC2T.Fragment, {
        children: mountNode ? /*#__PURE__*/ $hDjAY.createPortal(children, mountNode) : mountNode
    });
});

});

parcelRequire.register("5ME3L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4360827a83628e5a$export$2e2bcd8739ae039; });

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");

var $i7SXW = parcelRequire("i7SXW");

var $gSv8W = parcelRequire("gSv8W");

var $4WGW4 = parcelRequire("4WGW4");

var $f0PwI = parcelRequire("f0PwI");

var $dE9Ud = parcelRequire("dE9Ud");

var $esXub = parcelRequire("esXub");
"use client";
var $4360827a83628e5a$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
var $4360827a83628e5a$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, invisible = ownerState.invisible;
    var slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $dE9Ud.getBackdropUtilityClass), classes);
};
var $4360827a83628e5a$var$BackdropRoot = (0, $gSv8W.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(function(param) {
    var ownerState = param.ownerState;
    return (0, $3hDKy.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    });
});
var $4360827a83628e5a$var$Backdrop = /*#__PURE__*/ $3aC2T.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    var props = (0, $4WGW4.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    var children = props.children, className = props.className, _props_component = props.component, component = _props_component === void 0 ? "div" : _props_component, _props_components = props.components, components = _props_components === void 0 ? {} : _props_components, _props_componentsProps = props.componentsProps, componentsProps = _props_componentsProps === void 0 ? {} : _props_componentsProps, _props_invisible = props.invisible, invisible = _props_invisible === void 0 ? false : _props_invisible, open = props.open, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_TransitionComponent = props.TransitionComponent, TransitionComponent = _props_TransitionComponent === void 0 ? (0, $f0PwI.default) : _props_TransitionComponent, transitionDuration = props.transitionDuration, other = (0, $8vpQL.default)(props, $4360827a83628e5a$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        component: component,
        invisible: invisible
    });
    var classes = $4360827a83628e5a$var$useUtilityClasses(ownerState);
    var rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $esXub.jsx)(TransitionComponent, (0, $3hDKy.default)({
        "in": open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $esXub.jsx)($4360827a83628e5a$var$BackdropRoot, (0, $3hDKy.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $5i80G.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $3hDKy.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $4360827a83628e5a$export$2e2bcd8739ae039 = $4360827a83628e5a$var$Backdrop;

});
parcelRequire.register("f0PwI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeded33e6886a27e$export$2e2bcd8739ae039; });

var $3hDKy = parcelRequire("3hDKy");

var $8vpQL = parcelRequire("8vpQL");

var $3aC2T = parcelRequire("3aC2T");


var $GorQr = parcelRequire("GorQr");


var $iYQo1 = parcelRequire("iYQo1");

var $hi9je = parcelRequire("hi9je");

var $gcZH1 = parcelRequire("gcZH1");

var $esXub = parcelRequire("esXub");
"use client";
var $aeded33e6886a27e$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
var $aeded33e6886a27e$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $aeded33e6886a27e$var$Fade = /*#__PURE__*/ $3aC2T.forwardRef(function Fade(props, ref) {
    var theme = (0, $iYQo1.default)();
    var defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    var addEndListener = props.addEndListener, _props_appear = props.appear, appear = _props_appear === void 0 ? true : _props_appear, children = props.children, easing = props.easing, inProp = props["in"], onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props_timeout = props.timeout, timeout = _props_timeout === void 0 ? defaultTimeout : _props_timeout, _props_TransitionComponent = props.// eslint-disable-next-line react/prop-types
    TransitionComponent, TransitionComponent = _props_TransitionComponent === void 0 ? (0, $GorQr.default) : _props_TransitionComponent, other = (0, $8vpQL.default)(props, $aeded33e6886a27e$var$_excluded);
    var enableStrictModeCompat = true;
    var nodeRef = $3aC2T.useRef(null);
    var handleRef = (0, $gcZH1.default)(nodeRef, children.ref, ref);
    var normalizedTransitionCallback = function(callback) {
        return function(maybeIsAppearing) {
            if (callback) {
                var node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $hi9je.reflow)(node); // So the animation always start from the start.
        var transitionProps = (0, $hi9je.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $hi9je.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleAddEndListener = function(next) {
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $esXub.jsx)(TransitionComponent, (0, $3hDKy.default)({
        appear: appear,
        "in": inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: function(state, childProps) {
            return /*#__PURE__*/ $3aC2T.cloneElement(children, (0, $3hDKy.default)({
                style: (0, $3hDKy.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $aeded33e6886a27e$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $aeded33e6886a27e$export$2e2bcd8739ae039 = $aeded33e6886a27e$var$Fade;

});

parcelRequire.register("dE9Ud", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $9ef6b1ded3ef9bbb$export$9927a91fd93152bd; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $9ef6b1ded3ef9bbb$export$9927a91fd93152bd(slot) {
    return (0, $iZWB2.default)("MuiBackdrop", slot);
}
var $9ef6b1ded3ef9bbb$var$backdropClasses = (0, $1Zd5c.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $9ef6b1ded3ef9bbb$export$2e2bcd8739ae039 = $9ef6b1ded3ef9bbb$var$backdropClasses;

});


parcelRequire.register("jMtk4", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $e6693ee96c92aa9e$export$67960e22b12a638d; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $e6693ee96c92aa9e$export$67960e22b12a638d(slot) {
    return (0, $iZWB2.default)("MuiModal", slot);
}
var $e6693ee96c92aa9e$var$modalClasses = (0, $1Zd5c.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $e6693ee96c92aa9e$export$2e2bcd8739ae039 = $e6693ee96c92aa9e$var$modalClasses;

});


parcelRequire.register("eIvSj", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", function () { return $ab6de679f94f369b$export$88f455dd56c95edb; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $ab6de679f94f369b$export$88f455dd56c95edb(slot) {
    return (0, $iZWB2.default)("MuiPopover", slot);
}
var $ab6de679f94f369b$var$popoverClasses = (0, $1Zd5c.default)("MuiPopover", [
    "root",
    "paper"
]);
var $ab6de679f94f369b$export$2e2bcd8739ae039 = $ab6de679f94f369b$var$popoverClasses;

});


parcelRequire.register("fPfRG", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", function () { return $b857ecdda74dd724$export$2cf86a63a84fe23d; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $b857ecdda74dd724$export$2cf86a63a84fe23d(slot) {
    return (0, $iZWB2.default)("MuiMenu", slot);
}
var $b857ecdda74dd724$var$menuClasses = (0, $1Zd5c.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $b857ecdda74dd724$export$2e2bcd8739ae039 = $b857ecdda74dd724$var$menuClasses;

});


parcelRequire.register("fhwcH", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", function () { return $b2016c8fa273b1cc$export$c1eccd1617458c87; });
$parcel$export(module.exports, "nativeSelectIconStyles", function () { return $b2016c8fa273b1cc$export$e7a817afd12a40d0; });
$parcel$export(module.exports, "default", function () { return $b2016c8fa273b1cc$export$2e2bcd8739ae039; });

var $2iBlG = parcelRequire("2iBlG");

var $8vpQL = parcelRequire("8vpQL");

var $3hDKy = parcelRequire("3hDKy");

var $3aC2T = parcelRequire("3aC2T");


var $5i80G = parcelRequire("5i80G");


var $i7SXW = parcelRequire("i7SXW");

var $lqmBd = parcelRequire("lqmBd");

var $65Wwe = parcelRequire("65Wwe");

var $gSv8W = parcelRequire("gSv8W");

var $esXub = parcelRequire("esXub");
"use client";
var $b2016c8fa273b1cc$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
var $b2016c8fa273b1cc$var$useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, variant = ownerState.variant, disabled = ownerState.disabled, multiple = ownerState.multiple, open = ownerState.open, error = ownerState.error;
    var slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            "icon".concat((0, $lqmBd.default)(variant)),
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $i7SXW.default)(slots, (0, $65Wwe.getNativeSelectUtilityClasses), classes);
};
var $b2016c8fa273b1cc$export$c1eccd1617458c87 = function(param) {
    var ownerState = param.ownerState, theme = param.theme;
    var _obj;
    return (0, $3hDKy.default)((_obj = {
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $3hDKy.default)({}, theme.vars ? {
            backgroundColor: "rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / 0.05)")
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        }
    }, (0, $2iBlG._)(_obj, "&.".concat((0, $65Wwe.default).disabled), {
        cursor: "default"
    }), (0, $2iBlG._)(_obj, "&[multiple]", {
        height: "auto"
    }), (0, $2iBlG._)(_obj, "&:not([multiple]) option, &:not([multiple]) optgroup", {
        backgroundColor: (theme.vars || theme).palette.background.paper
    }), // Bump specificity to allow extending custom inputs
    (0, $2iBlG._)(_obj, "&&&", {
        paddingRight: 24,
        minWidth: 16 // So it doesn't collapse.
    }), _obj), ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
};
var $b2016c8fa273b1cc$var$NativeSelectSelect = (0, $gSv8W.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $gSv8W.rootShouldForwardProp),
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            (0, $2iBlG._)({}, "&.".concat((0, $65Wwe.default).multiple), styles.multiple)
        ];
    }
})($b2016c8fa273b1cc$export$c1eccd1617458c87);
var $b2016c8fa273b1cc$export$e7a817afd12a40d0 = function(param) {
    var ownerState = param.ownerState, theme = param.theme;
    return (0, $3hDKy.default)((0, $2iBlG._)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active
    }, "&.".concat((0, $65Wwe.default).disabled), {
        color: (theme.vars || theme).palette.action.disabled
    }), ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
};
var $b2016c8fa273b1cc$var$NativeSelectIcon = (0, $gSv8W.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.icon,
            ownerState.variant && styles["icon".concat((0, $lqmBd.default)(ownerState.variant))],
            ownerState.open && styles.iconOpen
        ];
    }
})($b2016c8fa273b1cc$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ var $b2016c8fa273b1cc$var$NativeSelectInput = /*#__PURE__*/ $3aC2T.forwardRef(function NativeSelectInput(props, ref) {
    var className = props.className, disabled = props.disabled, error = props.error, IconComponent = props.IconComponent, inputRef = props.inputRef, _props_variant = props.variant, variant = _props_variant === void 0 ? "standard" : _props_variant, other = (0, $8vpQL.default)(props, $b2016c8fa273b1cc$var$_excluded);
    var ownerState = (0, $3hDKy.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    var classes = $b2016c8fa273b1cc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $esXub.jsxs)($3aC2T.Fragment, {
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)($b2016c8fa273b1cc$var$NativeSelectSelect, (0, $3hDKy.default)({
                ownerState: ownerState,
                className: (0, $5i80G.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $esXub.jsx)($b2016c8fa273b1cc$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $b2016c8fa273b1cc$export$2e2bcd8739ae039 = $b2016c8fa273b1cc$var$NativeSelectInput;

});
parcelRequire.register("65Wwe", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", function () { return $47009a51045426b3$export$1ee13051fd9e2ab5; });
$parcel$export(module.exports, "default", function () { return $47009a51045426b3$export$2e2bcd8739ae039; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $47009a51045426b3$export$1ee13051fd9e2ab5(slot) {
    return (0, $iZWB2.default)("MuiNativeSelect", slot);
}
var $47009a51045426b3$var$nativeSelectClasses = (0, $1Zd5c.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $47009a51045426b3$export$2e2bcd8739ae039 = $47009a51045426b3$var$nativeSelectClasses;

});


parcelRequire.register("a1r53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74bf010397017f55$export$2e2bcd8739ae039; });

var $klU1x = parcelRequire("klU1x");
"use client";
var $74bf010397017f55$export$2e2bcd8739ae039 = (0, $klU1x.default);

});
parcelRequire.register("klU1x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed1139fe5b7c0f85$export$2e2bcd8739ae039; });

var $aSMts = parcelRequire("aSMts");

var $3aC2T = parcelRequire("3aC2T");
"use client";
function $ed1139fe5b7c0f85$export$2e2bcd8739ae039(param) {
    var controlled = param.controlled, defaultProp = param["default"], name = param.name, _param_state = param.state, state = _param_state === void 0 ? "value" : _param_state;
    // isControlled is ignored in the hook dependency lists as it should never change.
    var _React_useRef = $3aC2T.useRef(controlled !== undefined), isControlled = _React_useRef.current;
    var _React_useState = (0, $aSMts._)($3aC2T.useState(defaultProp), 2), valueState = _React_useState[0], setValue = _React_useState[1];
    var value = isControlled ? controlled : valueState;
    var setValueIfUncontrolled = $3aC2T.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRequire.register("bCbKk", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", function () { return $874c5ae1952e9534$export$2c0c1ee5a3392e; });
$parcel$export(module.exports, "default", function () { return $874c5ae1952e9534$export$2e2bcd8739ae039; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $874c5ae1952e9534$export$2c0c1ee5a3392e(slot) {
    return (0, $iZWB2.default)("MuiSelect", slot);
}
var $874c5ae1952e9534$var$selectClasses = (0, $1Zd5c.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $874c5ae1952e9534$export$2e2bcd8739ae039 = $874c5ae1952e9534$var$selectClasses;

});


parcelRequire.register("56Bx3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b7aa05f2877f4cc$export$2e2bcd8739ae039; });
parcelRequire("3aC2T");

var $3rjC7 = parcelRequire("3rjC7");

var $esXub = parcelRequire("esXub");
"use client";
var $3b7aa05f2877f4cc$export$2e2bcd8739ae039 = (0, $3rjC7.default)(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});


parcelRequire.register("3enro", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", function () { return $25a4dcc83275ee77$export$c1bdcbaf0596aeda; });

var $1Zd5c = parcelRequire("1Zd5c");

var $iZWB2 = parcelRequire("iZWB2");
function $25a4dcc83275ee77$export$c1bdcbaf0596aeda(slot) {
    return (0, $iZWB2.default)("MuiTextField", slot);
}
var $25a4dcc83275ee77$var$textFieldClasses = (0, $1Zd5c.default)("MuiTextField", [
    "root"
]);
var $25a4dcc83275ee77$export$2e2bcd8739ae039 = $25a4dcc83275ee77$var$textFieldClasses;

});


parcelRequire.register("9yM65", function(module, exports) {

$parcel$export(module.exports, "ToastContainer", function () { return $dafb1e8c442d1d38$export$f2815235e76a62b9; });
$parcel$export(module.exports, "toast", function () { return $dafb1e8c442d1d38$export$b410431fab84fa58; });

var $2iBlG = parcelRequire("2iBlG");

var $6Vnm7 = parcelRequire("6Vnm7");

var $2SZ1L = parcelRequire("2SZ1L");

var $J1E1c = parcelRequire("J1E1c");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $3aC2T = parcelRequire("3aC2T");

var $g5D7Y = parcelRequire("g5D7Y");
"use client";
var $dafb1e8c442d1d38$var$u = function(t) {
    return "number" == typeof t && !isNaN(t);
}, $dafb1e8c442d1d38$var$d = function(t) {
    return "string" == typeof t;
}, $dafb1e8c442d1d38$var$p = function(t) {
    return "function" == typeof t;
}, $dafb1e8c442d1d38$var$m = function(t) {
    return $dafb1e8c442d1d38$var$d(t) || $dafb1e8c442d1d38$var$p(t) ? t : null;
}, $dafb1e8c442d1d38$var$f = function(t) {
    return (0, $3aC2T.isValidElement)(t) || $dafb1e8c442d1d38$var$d(t) || $dafb1e8c442d1d38$var$p(t) || $dafb1e8c442d1d38$var$u(t);
};
function $dafb1e8c442d1d38$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    var o = t.scrollHeight, s = t.style;
    requestAnimationFrame(function() {
        s.minHeight = "initial", s.height = o + "px", s.transition = "all ".concat(n, "ms"), requestAnimationFrame(function() {
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $dafb1e8c442d1d38$export$3ff7dc44d332d222(e) {
    var a = e.enter, r = e.exit, tmp = e.appendPosition, i = tmp === void 0 ? !1 : tmp, tmp1 = e.collapse, _$l = tmp1 === void 0 ? !0 : tmp1, tmp2 = e.collapseDuration, c = tmp2 === void 0 ? 300 : tmp2;
    return function(e) {
        var u = e.children, d = e.position, p = e.preventExitTransition, m = e.done, f = e.nodeRef, _$h = e.isIn;
        var y = i ? "".concat(a, "--").concat(d) : a, v = i ? "".concat(r, "--").concat(d) : r, T = (0, $3aC2T.useRef)(0);
        return (0, $3aC2T.useLayoutEffect)(function() {
            var _t_classList;
            var _$t = f.current, _$e = y.split(" "), _$n = function(o) {
                var _t_classList;
                o.target === f.current && (_$t.dispatchEvent(new Event("d")), _$t.removeEventListener("animationend", _$n), _$t.removeEventListener("animationcancel", _$n), 0 === T.current && "animationcancel" !== o.type && (_t_classList = _$t.classList).remove.apply(_t_classList, (0, $dHvbf._)(_$e)));
            };
            (_t_classList = _$t.classList).add.apply(_t_classList, (0, $dHvbf._)(_$e)), _$t.addEventListener("animationend", _$n), _$t.addEventListener("animationcancel", _$n);
        }, []), (0, $3aC2T.useEffect)(function() {
            var _$t = f.current, _$e = function() {
                _$t.removeEventListener("animationend", _$e), _$l ? $dafb1e8c442d1d38$export$184cca501f1aed7f(_$t, m, c) : m();
            };
            _$h || (p ? _$e() : (T.current = 1, _$t.className += " ".concat(v), _$t.addEventListener("animationend", _$e)));
        }, [
            _$h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).Fragment, null, u);
    };
}
function $dafb1e8c442d1d38$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
var $dafb1e8c442d1d38$var$v = {
    list: new Map,
    emitQueue: new Map,
    on: function(t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off: function(t, e) {
        if (e) {
            var n = this.list.get(t).filter(function(t) {
                return t !== e;
            });
            return this.list.set(t, n), this;
        }
        return this.list["delete"](t), this;
    },
    cancelEmit: function(t) {
        var e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue["delete"](t)), this;
    },
    emit: function(t) {
        var _this = this;
        this.list.has(t) && this.list.get(t).forEach(function(e) {
            var n = setTimeout(function() {
                e.apply(void 0, (0, $dHvbf._)([].slice.call(arguments, 1)));
            }, 0);
            _this.emitQueue.has(t) || _this.emitQueue.set(t, []), _this.emitQueue.get(t).push(n);
        });
    }
}, $dafb1e8c442d1d38$var$T = function(e) {
    var n = e.theme, o = e.type, s = (0, $J1E1c._)(e, [
        "theme",
        "type"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("svg", (0, $6Vnm7._)({
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : "var(--toastify-icon-color-".concat(o, ")")
    }, s));
}, $dafb1e8c442d1d38$export$4f13f83fd8bb1dac = {
    info: function info(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement($dafb1e8c442d1d38$var$T, (0, $6Vnm7._)({}, e), (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function warning(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement($dafb1e8c442d1d38$var$T, (0, $6Vnm7._)({}, e), (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function success(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement($dafb1e8c442d1d38$var$T, (0, $6Vnm7._)({}, e), (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function error(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement($dafb1e8c442d1d38$var$T, (0, $6Vnm7._)({}, e), (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function spinner() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $dafb1e8c442d1d38$export$b262e13ca2dd2381(t) {
    var b = function b(t) {
        var e = t.containerId;
        var _C_props = C.props, _$n = _C_props.limit;
        !_$n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    };
    var I = function I(t) {
        c(function(e) {
            return null == t ? [] : e.filter(function(e) {
                return e !== t;
            });
        });
    };
    var _ = function _() {
        var _C_queue_shift = C.queue.shift(), _$t = _C_queue_shift.toastContent, e = _C_queue_shift.toastProps, _$n = _C_queue_shift.staleId;
        O(_$t, e, _$n);
    };
    var _$L = function _$L(t, n) {
        var _$s = n.delay, _$r = n.staleId, _$i = (0, $J1E1c._)(n, [
            "delay",
            "staleId"
        ]);
        if (!$dafb1e8c442d1d38$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || _$h.has(t.toastId) && null == t.updateId;
        }(_$i)) return;
        var _$l = _$i.toastId, c = _$i.updateId, T = _$i.data, b = C.props, _$L = function() {
            return I(_$l);
        }, N = null == c;
        N && C.count++;
        var M = (0, $2SZ1L._)((0, $6Vnm7._)((0, $2SZ1L._)((0, $6Vnm7._)({}, b), {
            style: b.toastStyle,
            key: C.toastKey++
        }), Object.fromEntries(Object.entries(_$i).filter(function(t) {
            var _t = (0, $aSMts._)(t, 2), _$e = _t[0], _$n = _t[1];
            return null != _$n;
        }))), {
            toastId: _$l,
            updateId: c,
            data: T,
            closeToast: _$L,
            isIn: !1,
            className: $dafb1e8c442d1d38$var$m(_$i.className || b.toastClassName),
            bodyClassName: $dafb1e8c442d1d38$var$m(_$i.bodyClassName || b.bodyClassName),
            progressClassName: $dafb1e8c442d1d38$var$m(_$i.progressClassName || b.progressClassName),
            autoClose: !_$i.isLoading && (R = _$i.autoClose, w = b.autoClose, !1 === R || $dafb1e8c442d1d38$var$u(R) && R > 0 ? R : w),
            deleteToast: function() {
                var _$t = $dafb1e8c442d1d38$var$y(_$h.get(_$l), "removed");
                _$h["delete"](_$l), $dafb1e8c442d1d38$var$v.emit(4, _$t);
                var _$e = C.queue.length;
                if (C.count = null == _$l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), _$e > 0) {
                    var _$t1 = null == _$l ? C.props.limit : 1;
                    if (1 === _$e || 1 === _$t1) C.displayedToast++, _();
                    else {
                        var _$n = _$t1 > _$e ? _$e : _$t1;
                        C.displayedToast = _$n;
                        for(var _$t2 = 0; _$t2 < _$n; _$t2++)_();
                    }
                } else o();
            }
        });
        var R, w;
        M.iconOut = function(t) {
            var _$n = t.theme, o = t.type, _$s = t.isLoading, _$r = t.icon, _$i = null;
            var _$l = {
                theme: _$n,
                type: o
            };
            return !1 === _$r || ($dafb1e8c442d1d38$var$p(_$r) ? _$i = _$r(_$l) : (0, $3aC2T.isValidElement)(_$r) ? _$i = (0, $3aC2T.cloneElement)(_$r, _$l) : $dafb1e8c442d1d38$var$d(_$r) || $dafb1e8c442d1d38$var$u(_$r) ? _$i = _$r : _$s ? _$i = $dafb1e8c442d1d38$export$4f13f83fd8bb1dac.spinner() : function(t) {
                return t in $dafb1e8c442d1d38$export$4f13f83fd8bb1dac;
            }(o) && (_$i = $dafb1e8c442d1d38$export$4f13f83fd8bb1dac[o](_$l))), _$i;
        }(M), $dafb1e8c442d1d38$var$p(_$i.onOpen) && (M.onOpen = _$i.onOpen), $dafb1e8c442d1d38$var$p(_$i.onClose) && (M.onClose = _$i.onClose), M.closeButton = b.closeButton, !1 === _$i.closeButton || $dafb1e8c442d1d38$var$f(_$i.closeButton) ? M.closeButton = _$i.closeButton : !0 === _$i.closeButton && (M.closeButton = !$dafb1e8c442d1d38$var$f(b.closeButton) || b.closeButton);
        var x = t;
        (0, $3aC2T.isValidElement)(t) && !$dafb1e8c442d1d38$var$d(t.type) ? x = (0, $3aC2T.cloneElement)(t, {
            closeToast: _$L,
            toastProps: M,
            data: T
        }) : $dafb1e8c442d1d38$var$p(t) && (x = t({
            closeToast: _$L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: _$r
        }) : $dafb1e8c442d1d38$var$u(_$s) ? setTimeout(function() {
            O(x, M, _$r);
        }, _$s) : O(x, M, _$r);
    };
    var O = function O(t, e, n) {
        var o = e.toastId;
        n && _$h["delete"](n);
        var _$s = {
            content: t,
            props: e
        };
        _$h.set(o, _$s), c(function(t) {
            return (0, $dHvbf._)(t).concat([
                o
            ]).filter(function(t) {
                return t !== n;
            });
        }), $dafb1e8c442d1d38$var$v.emit(4, $dafb1e8c442d1d38$var$y(_$s, null == _$s.props.updateId ? "added" : "updated"));
    };
    var _r = (0, $aSMts._)((0, $3aC2T.useReducer)(function(t) {
        return t + 1;
    }, 0), 2), o = _r[1], _i = (0, $aSMts._)((0, $3aC2T.useState)([]), 2), _$l = _i[0], c = _i[1], g = (0, $3aC2T.useRef)(null), _$h = (0, $3aC2T.useRef)(new Map).current, T = function(t) {
        return -1 !== _$l.indexOf(t);
    }, C = (0, $3aC2T.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: function(t) {
            return _$h.get(t);
        }
    }).current;
    return (0, $3aC2T.useEffect)(function() {
        return C.containerId = t.containerId, $dafb1e8c442d1d38$var$v.cancelEmit(3).on(0, _$L).on(1, function(t) {
            return g.current && I(t);
        }).on(5, b).emit(2, C), function() {
            _$h.clear(), $dafb1e8c442d1d38$var$v.emit(3, C);
        };
    }, []), (0, $3aC2T.useEffect)(function() {
        C.props = t, C.isToastActive = T, C.displayedToast = _$l.length;
    }), {
        getToastToRender: function getToastToRender(e) {
            var _$n = new Map, o = Array.from(_$h.values());
            return t.newestOnTop && o.reverse(), o.forEach(function(t) {
                var _t_props = t.props, e = _t_props.position;
                _$n.has(e) || _$n.set(e, []), _$n.get(e).push(t);
            }), Array.from(_$n, function(t) {
                return e(t[0], t[1]);
            });
        },
        containerRef: g,
        isToastActive: T
    };
}
function $dafb1e8c442d1d38$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $dafb1e8c442d1d38$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $dafb1e8c442d1d38$export$a407b657d3044108(t) {
    var v = function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            var _$n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = _$n.getBoundingClientRect(), _$n.style.transition = "", u.x = $dafb1e8c442d1d38$var$b(e.nativeEvent), u.y = $dafb1e8c442d1d38$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = _$n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = _$n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    };
    var T = function T(e) {
        if (u.boundingRect) {
            var _u_boundingRect = u.boundingRect, _$n = _u_boundingRect.top, o = _u_boundingRect.bottom, _$s = _u_boundingRect.left, a = _u_boundingRect.right;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= _$s && u.x <= a && u.y >= _$n && u.y <= o ? C() : E();
        }
    };
    var E = function E() {
        a(!0);
    };
    var C = function C() {
        a(!1);
    };
    var _ = function _(e) {
        var _$n = c.current;
        u.canDrag && _$n && (u.didMove = !0, o && C(), u.x = $dafb1e8c442d1d38$var$b(e), u.y = $dafb1e8c442d1d38$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), _$n.style.transform = "translate".concat(t.draggableDirection, "(").concat(u.delta, "px)"), _$n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    };
    var _i = (0, $aSMts._)((0, $3aC2T.useState)(!1), 2), o = _i[0], a = _i[1], _i1 = (0, $aSMts._)((0, $3aC2T.useState)(!1), 2), r = _i1[0], _$l = _i1[1], c = (0, $3aC2T.useRef)(null), u = (0, $3aC2T.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $3aC2T.useRef)(t), m = t.autoClose, f = t.pauseOnHover, g = t.closeToast, _$h = t.onClick, y = t.closeOnClick;
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        var e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return _$l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = "translate".concat(t.draggableDirection, "(0)"), e.style.opacity = "1";
        }
    }
    (0, $3aC2T.useEffect)(function() {
        d.current = t;
    }), (0, $3aC2T.useEffect)(function() {
        return c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $dafb1e8c442d1d38$var$p(t.onOpen) && t.onOpen((0, $3aC2T.isValidElement)(t.children) && t.children.props), function() {
            var _$t = d.current;
            $dafb1e8c442d1d38$var$p(_$t.onClose) && _$t.onClose((0, $3aC2T.isValidElement)(_$t.children) && _$t.children.props);
        };
    }, []), (0, $3aC2T.useEffect)(function() {
        return t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), function() {
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    var O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = function(t) {
        _$h && _$h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $dafb1e8c442d1d38$var$L(e) {
    var n = e.closeToast, o = e.theme, tmp = e.ariaLabel, s = tmp === void 0 ? "close" : tmp;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("button", {
        className: "Toastify__close-button Toastify__close-button--".concat(o),
        type: "button",
        onClick: function(t) {
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $dafb1e8c442d1d38$var$O(e) {
    var n = e.delay, o = e.isRunning, s = e.closeToast, tmp = e.type, a = tmp === void 0 ? "default" : tmp, r = e.hide, i = e.className, _$l = e.style, u = e.controlledProgress, d = e.progress, m = e.rtl, f = e.isIn, g = e.theme;
    var _$h = r || u && 0 === d, y = (0, $2SZ1L._)((0, $6Vnm7._)({}, _$l), {
        animationDuration: "".concat(n, "ms"),
        animationPlayState: o ? "running" : "paused",
        opacity: _$h ? 0 : 1
    });
    u && (y.transform = "scaleX(".concat(d, ")"));
    var v = (0, $g5D7Y.default)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--".concat(g), "Toastify__progress-bar--".concat(a), {
        "Toastify__progress-bar--rtl": m
    }), T = $dafb1e8c442d1d38$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $g5D7Y.default)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("div", (0, $2iBlG._)({
        role: "progressbar",
        "aria-hidden": _$h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y
    }, u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd", u && d < 1 ? null : function() {
        f && s();
    }));
}
var $dafb1e8c442d1d38$var$N = function(n) {
    var _$_ = $dafb1e8c442d1d38$export$a407b657d3044108(n), o = _$_.isRunning, s = _$_.preventExitTransition, r = _$_.toastRef, i = _$_.eventHandlers, _$l = n.closeButton, u = n.children, d = n.autoClose, m = n.onClick, f = n.type, g = n.hideProgressBar, _$h = n.closeToast, y = n.transition, v = n.position, T = n.className, E = n.style, C = n.bodyClassName, b = n.bodyStyle, I = n.progressClassName, N = n.progressStyle, M = n.updateId, R = n.role, w = n.progress, x = n.rtl, $ = n.toastId, k = n.deleteToast, P = n.isIn, B = n.isLoading, D = n.iconOut, A = n.closeOnClick, z = n.theme, F = (0, $g5D7Y.default)("Toastify__toast", "Toastify__toast-theme--".concat(z), "Toastify__toast--".concat(f), {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $dafb1e8c442d1d38$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $g5D7Y.default)(F, T), S = !!w || !d, _$q = {
        closeToast: _$h,
        type: f,
        theme: z
    };
    var _$Q = null;
    return !1 === _$l || (_$Q = $dafb1e8c442d1d38$var$p(_$l) ? _$l(_$q) : (0, $3aC2T.isValidElement)(_$l) ? (0, $3aC2T.cloneElement)(_$l, _$q) : $dafb1e8c442d1d38$var$L(_$q)), (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("div", (0, $2SZ1L._)((0, $6Vnm7._)({
        id: $,
        onClick: m,
        className: H
    }, i), {
        style: E,
        ref: r
    }), (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("div", (0, $2SZ1L._)((0, $6Vnm7._)({}, P && {
        role: R
    }), {
        className: $dafb1e8c442d1d38$var$p(C) ? C({
            type: f
        }) : (0, $g5D7Y.default)("Toastify__toast-body", C),
        style: b
    }), null != D && (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("div", {
        className: (0, $g5D7Y.default)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("div", null, u)), _$Q, (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement($dafb1e8c442d1d38$var$O, (0, $2SZ1L._)((0, $6Vnm7._)({}, M && !S ? {
        key: "pb-".concat(M)
    } : {}), {
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: _$h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    }))));
}, $dafb1e8c442d1d38$var$M = function M(t, e) {
    return void 0 === e && (e = !1), {
        enter: "Toastify--animate Toastify__".concat(t, "-enter"),
        exit: "Toastify--animate Toastify__".concat(t, "-exit"),
        appendPosition: e
    };
}, $dafb1e8c442d1d38$export$d20e79fdc3899e95 = $dafb1e8c442d1d38$export$3ff7dc44d332d222($dafb1e8c442d1d38$var$M("bounce", !0)), $dafb1e8c442d1d38$export$d8dc01b5c85a37b9 = $dafb1e8c442d1d38$export$3ff7dc44d332d222($dafb1e8c442d1d38$var$M("slide", !0)), $dafb1e8c442d1d38$export$65cfd44a2050f99 = $dafb1e8c442d1d38$export$3ff7dc44d332d222($dafb1e8c442d1d38$var$M("zoom")), $dafb1e8c442d1d38$export$4d2fae537bd90431 = $dafb1e8c442d1d38$export$3ff7dc44d332d222($dafb1e8c442d1d38$var$M("flip")), $dafb1e8c442d1d38$export$f2815235e76a62b9 = (0, $3aC2T.forwardRef)(function(e, n) {
    var f = function f(t) {
        var _$e = (0, $g5D7Y.default)("Toastify__toast-container", "Toastify__toast-container--".concat(t), {
            "Toastify__toast-container--rtl": u
        });
        return $dafb1e8c442d1d38$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: _$e
        }) : (0, $g5D7Y.default)(_$e, $dafb1e8c442d1d38$var$m(i));
    };
    var _C = $dafb1e8c442d1d38$export$b262e13ca2dd2381(e), o = _C.getToastToRender, a = _C.containerRef, r = _C.isToastActive, i = e.className, _$l = e.style, u = e.rtl, d = e.containerId;
    return (0, $3aC2T.useEffect)(function() {
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o(function(e, n) {
        var o = n.length ? (0, $6Vnm7._)({}, _$l) : (0, $2SZ1L._)((0, $6Vnm7._)({}, _$l), {
            pointerEvents: "none"
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement("div", {
            className: f(e),
            style: o,
            key: "container-".concat(e)
        }, n.map(function(e, o) {
            var _$s = e.content, a = e.props;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement($dafb1e8c442d1d38$var$N, (0, $2SZ1L._)((0, $6Vnm7._)({}, a), {
                isIn: r(a.toastId),
                style: (0, $2SZ1L._)((0, $6Vnm7._)({}, a.style), {
                    "--nth": o + 1,
                    "--len": n.length
                }),
                key: "toast-".concat(a.key)
            }), _$s);
        }));
    }));
});
$dafb1e8c442d1d38$export$f2815235e76a62b9.displayName = "ToastContainer", $dafb1e8c442d1d38$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $dafb1e8c442d1d38$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $dafb1e8c442d1d38$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
var $dafb1e8c442d1d38$var$P, $dafb1e8c442d1d38$var$B = new Map, $dafb1e8c442d1d38$var$D = [], $dafb1e8c442d1d38$var$A = 1;
function $dafb1e8c442d1d38$var$z() {
    return "" + $dafb1e8c442d1d38$var$A++;
}
function $dafb1e8c442d1d38$var$F(t) {
    return t && ($dafb1e8c442d1d38$var$d(t.toastId) || $dafb1e8c442d1d38$var$u(t.toastId)) ? t.toastId : $dafb1e8c442d1d38$var$z();
}
function $dafb1e8c442d1d38$var$H(t, e) {
    return $dafb1e8c442d1d38$var$B.size > 0 ? $dafb1e8c442d1d38$var$v.emit(0, t, e) : $dafb1e8c442d1d38$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $dafb1e8c442d1d38$var$S(t, e) {
    return (0, $2SZ1L._)((0, $6Vnm7._)({}, e), {
        type: e && e.type || t,
        toastId: $dafb1e8c442d1d38$var$F(e)
    });
}
function $dafb1e8c442d1d38$var$q(t) {
    return function(e, n) {
        return $dafb1e8c442d1d38$var$H(e, $dafb1e8c442d1d38$var$S(t, n));
    };
}
function $dafb1e8c442d1d38$export$b410431fab84fa58(t, e) {
    return $dafb1e8c442d1d38$var$H(t, $dafb1e8c442d1d38$var$S("default", e));
}
$dafb1e8c442d1d38$export$b410431fab84fa58.loading = function(t, e) {
    return $dafb1e8c442d1d38$var$H(t, $dafb1e8c442d1d38$var$S("default", (0, $6Vnm7._)({
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1
    }, e)));
}, $dafb1e8c442d1d38$export$b410431fab84fa58.promise = function(t, e, n) {
    var o, s = e.pending, a = e.error, r = e.success;
    s && (o = $dafb1e8c442d1d38$var$d(s) ? $dafb1e8c442d1d38$export$b410431fab84fa58.loading(s, n) : $dafb1e8c442d1d38$export$b410431fab84fa58.loading(s.render, (0, $6Vnm7._)({}, n, s)));
    var i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, _$l = function(t, e, s) {
        if (null == e) return void $dafb1e8c442d1d38$export$b410431fab84fa58.dismiss(o);
        var a = (0, $2SZ1L._)((0, $6Vnm7._)({
            type: t
        }, i, n), {
            data: s
        }), r = $dafb1e8c442d1d38$var$d(e) ? {
            render: e
        } : e;
        return o ? $dafb1e8c442d1d38$export$b410431fab84fa58.update(o, (0, $6Vnm7._)({}, a, r)) : $dafb1e8c442d1d38$export$b410431fab84fa58(r.render, (0, $6Vnm7._)({}, a, r)), s;
    }, c = $dafb1e8c442d1d38$var$p(t) ? t() : t;
    return c.then(function(t) {
        return _$l("success", r, t);
    })["catch"](function(t) {
        return _$l("error", a, t);
    }), c;
}, $dafb1e8c442d1d38$export$b410431fab84fa58.success = $dafb1e8c442d1d38$var$q("success"), $dafb1e8c442d1d38$export$b410431fab84fa58.info = $dafb1e8c442d1d38$var$q("info"), $dafb1e8c442d1d38$export$b410431fab84fa58.error = $dafb1e8c442d1d38$var$q("error"), $dafb1e8c442d1d38$export$b410431fab84fa58.warning = $dafb1e8c442d1d38$var$q("warning"), $dafb1e8c442d1d38$export$b410431fab84fa58.warn = $dafb1e8c442d1d38$export$b410431fab84fa58.warning, $dafb1e8c442d1d38$export$b410431fab84fa58.dark = function(t, e) {
    return $dafb1e8c442d1d38$var$H(t, $dafb1e8c442d1d38$var$S("default", (0, $6Vnm7._)({
        theme: "dark"
    }, e)));
}, $dafb1e8c442d1d38$export$b410431fab84fa58.dismiss = function(t) {
    $dafb1e8c442d1d38$var$B.size > 0 ? $dafb1e8c442d1d38$var$v.emit(1, t) : $dafb1e8c442d1d38$var$D = $dafb1e8c442d1d38$var$D.filter(function(e) {
        return null != t && e.options.toastId !== t;
    });
}, $dafb1e8c442d1d38$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $dafb1e8c442d1d38$var$v.emit(5, t);
}, $dafb1e8c442d1d38$export$b410431fab84fa58.isActive = function(t) {
    var e = !1;
    return $dafb1e8c442d1d38$var$B.forEach(function(n) {
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $dafb1e8c442d1d38$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(function() {
        var n = function(t, e) {
            var n = e.containerId;
            var o = $dafb1e8c442d1d38$var$B.get(n || $dafb1e8c442d1d38$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            var o = n.props, s = n.content, a = (0, $2SZ1L._)((0, $6Vnm7._)({
                delay: 100
            }, o, e), {
                toastId: e.toastId || t,
                updateId: $dafb1e8c442d1d38$var$z()
            });
            a.toastId !== t && (a.staleId = t);
            var r = a.render || s;
            delete a.render, $dafb1e8c442d1d38$var$H(r, a);
        }
    }, 0);
}, $dafb1e8c442d1d38$export$b410431fab84fa58.done = function(t) {
    $dafb1e8c442d1d38$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $dafb1e8c442d1d38$export$b410431fab84fa58.onChange = function(t) {
    return $dafb1e8c442d1d38$var$v.on(4, t), function() {
        $dafb1e8c442d1d38$var$v.off(4, t);
    };
}, $dafb1e8c442d1d38$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $dafb1e8c442d1d38$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $dafb1e8c442d1d38$var$v.on(2, function(t) {
    $dafb1e8c442d1d38$var$P = t.containerId || t, $dafb1e8c442d1d38$var$B.set($dafb1e8c442d1d38$var$P, t), $dafb1e8c442d1d38$var$D.forEach(function(t) {
        $dafb1e8c442d1d38$var$v.emit(0, t.content, t.options);
    }), $dafb1e8c442d1d38$var$D = [];
}).on(3, function(t) {
    $dafb1e8c442d1d38$var$B["delete"](t.containerId || t), 0 === $dafb1e8c442d1d38$var$B.size && $dafb1e8c442d1d38$var$v.off(0).off(1).off(5);
});

});
parcelRequire.register("J1E1c", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $08757aa37edf87c6$export$69fdd232f62cde60; });

var $ah6zB = parcelRequire("ah6zB");
function $08757aa37edf87c6$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $ah6zB._object_without_properties_loose)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRequire.register("ah6zB", function(module, exports) {

$parcel$export(module.exports, "_object_without_properties_loose", function () { return $77b09736095ba578$export$7a4a7e38737aceb4; });
function $77b09736095ba578$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRequire.register("g5D7Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb6b76e573fb2ec2$export$2e2bcd8739ae039; });
function $bb6b76e573fb2ec2$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $bb6b76e573fb2ec2$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $bb6b76e573fb2ec2$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $bb6b76e573fb2ec2$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $bb6b76e573fb2ec2$export$2e2bcd8739ae039 = $bb6b76e573fb2ec2$export$4f5d2d50c9deca37;

});


parcelRequire.register("gWZ9M", function(module, exports) {

$parcel$export(module.exports, "addToCart", function () { return $c5718093fa7de7e6$export$576b6dd9d68b37bc; });
$parcel$export(module.exports, "removeItem", function () { return $c5718093fa7de7e6$export$fe2d9b4e03920b4c; });
$parcel$export(module.exports, "clearCart", function () { return $c5718093fa7de7e6$export$810121176e3e3671; });
$parcel$export(module.exports, "cartReducer", function () { return $c5718093fa7de7e6$export$458f39dd68da7b3f; });

var $9AK5f = parcelRequire("9AK5f");
var $c5718093fa7de7e6$var$cartSlice = (0, $9AK5f.createSlice)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addToCart: function(state, action) {
            state.items.push(action.payload);
        },
        removeItem: function(state, action) {
            var indexToRemove = state.items.findIndex(function(item) {
                return item.id === action.payload.id;
            });
            if (indexToRemove !== -1) state.items.splice(indexToRemove, 1);
        },
        clearCart: function(state) {
            state.items = [];
        }
    }
});
var $c5718093fa7de7e6$var$_cartSlice_actions = $c5718093fa7de7e6$var$cartSlice.actions;
var $c5718093fa7de7e6$export$576b6dd9d68b37bc = $c5718093fa7de7e6$var$_cartSlice_actions.addToCart, $c5718093fa7de7e6$export$fe2d9b4e03920b4c = $c5718093fa7de7e6$var$_cartSlice_actions.removeItem, $c5718093fa7de7e6$export$810121176e3e3671 = $c5718093fa7de7e6$var$_cartSlice_actions.clearCart;
var $c5718093fa7de7e6$export$458f39dd68da7b3f = $c5718093fa7de7e6$var$cartSlice.reducer;

});
parcelRequire.register("9AK5f", function(module, exports) {
$parcel$export(module.exports, "applyMiddleware", function () { return (parcelRequire("7w0GC")).applyMiddleware; }, function (v) { return (parcelRequire("7w0GC")).applyMiddleware = v; });
$parcel$export(module.exports, "combineReducers", function () { return (parcelRequire("7w0GC")).combineReducers; }, function (v) { return (parcelRequire("7w0GC")).combineReducers = v; });
$parcel$export(module.exports, "compose", function () { return (parcelRequire("7w0GC")).compose; }, function (v) { return (parcelRequire("7w0GC")).compose = v; });
$parcel$export(module.exports, "createStore", function () { return (parcelRequire("7w0GC")).createStore; }, function (v) { return (parcelRequire("7w0GC")).createStore = v; });

$parcel$export(module.exports, "configureStore", function () { return $6fbb391f9a1c765f$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createSlice", function () { return $6fbb391f9a1c765f$export$4d8d9bd83c24ae8b; });

var $qb7pP = parcelRequire("qb7pP");

var $1Be8m = parcelRequire("1Be8m");

var $7w0GC = parcelRequire("7w0GC");

var $3k8cf = parcelRequire("3k8cf");

var $ma7gB = parcelRequire("ma7gB");

var $ffICS = parcelRequire("ffICS");
var $6fbb391f9a1c765f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        var __ = function __() {
            this.constructor = d;
        };
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6fbb391f9a1c765f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
};
var $6fbb391f9a1c765f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $6fbb391f9a1c765f$var$__defProp = Object.defineProperty;
var $6fbb391f9a1c765f$var$__defProps = Object.defineProperties;
var $6fbb391f9a1c765f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6fbb391f9a1c765f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6fbb391f9a1c765f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6fbb391f9a1c765f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6fbb391f9a1c765f$var$__defNormalProp = function __defNormalProp(obj, key, value) {
    return key in obj ? $6fbb391f9a1c765f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $6fbb391f9a1c765f$var$__spreadValues = function __spreadValues(a, b) {
    for(var prop in b || (b = {}))if ($6fbb391f9a1c765f$var$__hasOwnProp.call(b, prop)) $6fbb391f9a1c765f$var$__defNormalProp(a, prop, b[prop]);
    if ($6fbb391f9a1c765f$var$__getOwnPropSymbols) for(var _i = 0, _c = $6fbb391f9a1c765f$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($6fbb391f9a1c765f$var$__propIsEnum.call(b, prop)) $6fbb391f9a1c765f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6fbb391f9a1c765f$var$__spreadProps = function __spreadProps(a, b) {
    return $6fbb391f9a1c765f$var$__defProps(a, $6fbb391f9a1c765f$var$__getOwnPropDescs(b));
};
var $6fbb391f9a1c765f$var$__async = function __async(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $6fbb391f9a1c765f$export$a5d3c27355e35910 = function createDraftSafeSelector() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $3k8cf.createSelector).apply(void 0, args);
    var wrappedSelector = function wrappedSelector(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $6fbb391f9a1c765f$var$__spreadArray([
            (0, $1Be8m.isDraft)(value) ? (0, $1Be8m.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $6fbb391f9a1c765f$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $7w0GC.compose;
    return (0, $7w0GC.compose).apply(null, arguments);
};
var $6fbb391f9a1c765f$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $6fbb391f9a1c765f$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $6fbb391f9a1c765f$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function measureTime(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function warnIfExceeded() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $6fbb391f9a1c765f$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $6fbb391f9a1c765f$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function get() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $6fbb391f9a1c765f$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $6fbb391f9a1c765f$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $6fbb391f9a1c765f$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $6fbb391f9a1c765f$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function get() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $6fbb391f9a1c765f$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $6fbb391f9a1c765f$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $6fbb391f9a1c765f$var$freezeDraftable(val) {
    return (0, $1Be8m.isDraftable)(val) ? (0, $1Be8m.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $6fbb391f9a1c765f$var$isProduction = true;
var $6fbb391f9a1c765f$var$prefix = "Invariant failed";
function $6fbb391f9a1c765f$var$invariant(condition, message) {
    if (condition) return;
    if ($6fbb391f9a1c765f$var$isProduction) throw new Error($6fbb391f9a1c765f$var$prefix);
    throw new Error($6fbb391f9a1c765f$var$prefix + ": " + (message || ""));
}
function $6fbb391f9a1c765f$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $6fbb391f9a1c765f$var$getSerialize(serializer, decycler), indent);
}
function $6fbb391f9a1c765f$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function decycler(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $6fbb391f9a1c765f$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $6fbb391f9a1c765f$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $6fbb391f9a1c765f$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function detectMutations1() {
            return $6fbb391f9a1c765f$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $6fbb391f9a1c765f$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $6fbb391f9a1c765f$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $6fbb391f9a1c765f$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function _loop_1(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $6fbb391f9a1c765f$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $6fbb391f9a1c765f$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $6fbb391f9a1c765f$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $qb7pP._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $6fbb391f9a1c765f$export$53b83ca8eaab0383(val);
}
function $6fbb391f9a1c765f$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $6fbb391f9a1c765f$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function _loop_2(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $6fbb391f9a1c765f$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $6fbb391f9a1c765f$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $6fbb391f9a1c765f$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$6fbb391f9a1c765f$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $6fbb391f9a1c765f$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $6fbb391f9a1c765f$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $6fbb391f9a1c765f$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $6fbb391f9a1c765f$export$36c1185aeee5b0a6(options);
    };
}
function $6fbb391f9a1c765f$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $6fbb391f9a1c765f$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($6fbb391f9a1c765f$var$isBoolean(thunk)) middlewareArray.push((0, $ma7gB.default));
        else middlewareArray.push((0, $ma7gB.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $6fbb391f9a1c765f$var$IS_PRODUCTION = true;
function $6fbb391f9a1c765f$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $6fbb391f9a1c765f$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($6fbb391f9a1c765f$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $7w0GC.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$6fbb391f9a1c765f$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$6fbb391f9a1c765f$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $7w0GC.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $7w0GC.compose);
    if (devTools) finalCompose = $6fbb391f9a1c765f$var$composeWithDevTools($6fbb391f9a1c765f$var$__spreadValues({
        trace: !$6fbb391f9a1c765f$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $6fbb391f9a1c765f$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $6fbb391f9a1c765f$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $7w0GC.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $6fbb391f9a1c765f$export$309c7a02b0b0bc62(type, prepareAction) {
    var actionCreator = function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $6fbb391f9a1c765f$var$__spreadValues($6fbb391f9a1c765f$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    };
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $6fbb391f9a1c765f$export$b956e38827fca970(action) {
    return $6fbb391f9a1c765f$export$53b83ca8eaab0383(action) && "type" in action;
}
function $6fbb391f9a1c765f$export$ebd532f9034651f3(action) {
    return $6fbb391f9a1c765f$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($6fbb391f9a1c765f$var$isValidKey);
}
function $6fbb391f9a1c765f$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $6fbb391f9a1c765f$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $6fbb391f9a1c765f$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function addCase(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function addMatcher(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function addDefaultCase(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $6fbb391f9a1c765f$var$isStateFunction(x) {
    return typeof x === "function";
}
var $6fbb391f9a1c765f$var$hasWarnedAboutObjectNotation = false;
function $6fbb391f9a1c765f$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    var reducer = function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $6fbb391f9a1c765f$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $1Be8m.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $1Be8m.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $1Be8m.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    };
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $6fbb391f9a1c765f$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($6fbb391f9a1c765f$var$isStateFunction(initialState)) getInitialState = function getInitialState() {
        return $6fbb391f9a1c765f$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $6fbb391f9a1c765f$var$freezeDraftable(initialState);
        getInitialState = function getInitialState() {
            return frozenInitialState_1;
        };
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $6fbb391f9a1c765f$var$hasWarnedAboutObjectNotation2 = false;
function $6fbb391f9a1c765f$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $6fbb391f9a1c765f$export$4d8d9bd83c24ae8b(options) {
    var buildReducer = function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $6fbb391f9a1c765f$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $6fbb391f9a1c765f$var$__spreadValues($6fbb391f9a1c765f$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $6fbb391f9a1c765f$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    };
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $ffICS === "undefined" ? "undefined" : (0, $qb7pP._)($ffICS);
    var initialState = typeof options.initialState == "function" ? options.initialState : $6fbb391f9a1c765f$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $6fbb391f9a1c765f$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $6fbb391f9a1c765f$export$309c7a02b0b0bc62(type, prepareCallback) : $6fbb391f9a1c765f$export$309c7a02b0b0bc62(type);
    });
    var _reducer;
    return {
        name: name,
        reducer: function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $6fbb391f9a1c765f$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $6fbb391f9a1c765f$var$createInitialStateFactory() {
    var getInitialState = function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($6fbb391f9a1c765f$var$getInitialEntityState(), additionalState);
    };
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $6fbb391f9a1c765f$var$createSelectorsFactory() {
    var getSelectors = function getSelectors(selectState) {
        var selectIds = function selectIds(state) {
            return state.ids;
        };
        var selectEntities = function selectEntities(state) {
            return state.entities;
        };
        var selectAll = $6fbb391f9a1c765f$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function selectId(_, id) {
            return id;
        };
        var selectById = function selectById(entities, id) {
            return entities[id];
        };
        var selectTotal = $6fbb391f9a1c765f$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $6fbb391f9a1c765f$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $6fbb391f9a1c765f$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $6fbb391f9a1c765f$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $6fbb391f9a1c765f$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $6fbb391f9a1c765f$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $6fbb391f9a1c765f$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    };
    return {
        getSelectors: getSelectors
    };
}
function $6fbb391f9a1c765f$var$createSingleArgumentStateOperator(mutator) {
    var operator = $6fbb391f9a1c765f$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $6fbb391f9a1c765f$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        var isPayloadActionArgument = function isPayloadActionArgument(arg2) {
            return $6fbb391f9a1c765f$export$ebd532f9034651f3(arg2);
        };
        var runMutator = function runMutator(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $1Be8m.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $1Be8m.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $6fbb391f9a1c765f$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $6fbb391f9a1c765f$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $6fbb391f9a1c765f$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $6fbb391f9a1c765f$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $6fbb391f9a1c765f$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $6fbb391f9a1c765f$var$createUnsortedStateAdapter(selectId) {
    var addOneMutably = function addOneMutably(entity, state) {
        var key = $6fbb391f9a1c765f$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    };
    var addManyMutably = function addManyMutably(newEntities, state) {
        newEntities = $6fbb391f9a1c765f$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    };
    var setOneMutably = function setOneMutably(entity, state) {
        var key = $6fbb391f9a1c765f$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    };
    var setManyMutably = function setManyMutably(newEntities, state) {
        newEntities = $6fbb391f9a1c765f$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    };
    var setAllMutably = function setAllMutably(newEntities, state) {
        newEntities = $6fbb391f9a1c765f$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    };
    var removeOneMutably = function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    };
    var removeManyMutably = function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    };
    var removeAllMutably = function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    };
    var takeNewKey = function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $6fbb391f9a1c765f$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    };
    var updateOneMutably = function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    };
    var updateManyMutably = function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $6fbb391f9a1c765f$var$__spreadValues($6fbb391f9a1c765f$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    };
    var upsertOneMutably = function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    };
    var upsertManyMutably = function upsertManyMutably(newEntities, state) {
        var _c = $6fbb391f9a1c765f$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    };
    return {
        removeAll: $6fbb391f9a1c765f$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $6fbb391f9a1c765f$var$createStateOperator(addOneMutably),
        addMany: $6fbb391f9a1c765f$var$createStateOperator(addManyMutably),
        setOne: $6fbb391f9a1c765f$var$createStateOperator(setOneMutably),
        setMany: $6fbb391f9a1c765f$var$createStateOperator(setManyMutably),
        setAll: $6fbb391f9a1c765f$var$createStateOperator(setAllMutably),
        updateOne: $6fbb391f9a1c765f$var$createStateOperator(updateOneMutably),
        updateMany: $6fbb391f9a1c765f$var$createStateOperator(updateManyMutably),
        upsertOne: $6fbb391f9a1c765f$var$createStateOperator(upsertOneMutably),
        upsertMany: $6fbb391f9a1c765f$var$createStateOperator(upsertManyMutably),
        removeOne: $6fbb391f9a1c765f$var$createStateOperator(removeOneMutably),
        removeMany: $6fbb391f9a1c765f$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $6fbb391f9a1c765f$var$createSortedStateAdapter(selectId, sort) {
    var addOneMutably = function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    };
    var addManyMutably = function addManyMutably(newEntities, state) {
        newEntities = $6fbb391f9a1c765f$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($6fbb391f9a1c765f$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    };
    var setOneMutably = function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    };
    var setManyMutably = function setManyMutably(newEntities, state) {
        newEntities = $6fbb391f9a1c765f$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    };
    var setAllMutably = function setAllMutably(newEntities, state) {
        newEntities = $6fbb391f9a1c765f$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    };
    var updateOneMutably = function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    };
    var updateManyMutably = function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    };
    var upsertOneMutably = function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    };
    var upsertManyMutably = function upsertManyMutably(newEntities, state) {
        var _c = $6fbb391f9a1c765f$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    };
    var areArraysEqual = function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    };
    var merge = function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    };
    var resortEntities = function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    };
    var _c = $6fbb391f9a1c765f$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $6fbb391f9a1c765f$var$createStateOperator(addOneMutably),
        updateOne: $6fbb391f9a1c765f$var$createStateOperator(updateOneMutably),
        upsertOne: $6fbb391f9a1c765f$var$createStateOperator(upsertOneMutably),
        setOne: $6fbb391f9a1c765f$var$createStateOperator(setOneMutably),
        setMany: $6fbb391f9a1c765f$var$createStateOperator(setManyMutably),
        setAll: $6fbb391f9a1c765f$var$createStateOperator(setAllMutably),
        addMany: $6fbb391f9a1c765f$var$createStateOperator(addManyMutably),
        updateMany: $6fbb391f9a1c765f$var$createStateOperator(updateManyMutably),
        upsertMany: $6fbb391f9a1c765f$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $6fbb391f9a1c765f$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $6fbb391f9a1c765f$var$__spreadValues({
        sortComparer: false,
        selectId: function selectId(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $6fbb391f9a1c765f$var$createInitialStateFactory();
    var selectorsFactory = $6fbb391f9a1c765f$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $6fbb391f9a1c765f$var$createSortedStateAdapter(selectId, sortComparer) : $6fbb391f9a1c765f$var$createUnsortedStateAdapter(selectId);
    return $6fbb391f9a1c765f$var$__spreadValues($6fbb391f9a1c765f$var$__spreadValues($6fbb391f9a1c765f$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $6fbb391f9a1c765f$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $6fbb391f9a1c765f$export$ac4959f4f1338dfc = function nanoid(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $6fbb391f9a1c765f$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $6fbb391f9a1c765f$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $6fbb391f9a1c765f$var$RejectWithValue = /** @class */ function() {
    var RejectWithValue = function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    };
    return RejectWithValue;
}();
var $6fbb391f9a1c765f$var$FulfillWithMeta = /** @class */ function() {
    var FulfillWithMeta = function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    };
    return FulfillWithMeta;
}();
var $6fbb391f9a1c765f$export$c97c53d0b2d5d81e = function miniSerializeError(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $6fbb391f9a1c765f$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $6fbb391f9a1c765f$export$6abd22dc03e5063f = function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $6fbb391f9a1c765f$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $6fbb391f9a1c765f$var$__spreadProps($6fbb391f9a1c765f$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $6fbb391f9a1c765f$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $6fbb391f9a1c765f$var$__spreadProps($6fbb391f9a1c765f$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $6fbb391f9a1c765f$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $6fbb391f9a1c765f$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $6fbb391f9a1c765f$var$__spreadProps($6fbb391f9a1c765f$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function addEventListener() {},
                    dispatchEvent: function dispatchEvent() {
                        return false;
                    },
                    onabort: function onabort() {},
                    removeEventListener: function removeEventListener() {},
                    reason: void 0,
                    throwIfAborted: function throwIfAborted() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $6fbb391f9a1c765f$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $6fbb391f9a1c765f$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $6fbb391f9a1c765f$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$6fbb391f9a1c765f$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function rejectWithValue(value, meta) {
                                                    return new $6fbb391f9a1c765f$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function fulfillWithValue(value, meta) {
                                                    return new $6fbb391f9a1c765f$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $6fbb391f9a1c765f$var$RejectWithValue) throw result;
                                                if (result instanceof $6fbb391f9a1c765f$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $6fbb391f9a1c765f$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function unwrap() {
                        return promise2.then($6fbb391f9a1c765f$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $6fbb391f9a1c765f$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $6fbb391f9a1c765f$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $6fbb391f9a1c765f$var$hasMatchFunction = function hasMatchFunction(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $6fbb391f9a1c765f$var$matches = function matches(matcher, action) {
    if ($6fbb391f9a1c765f$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $6fbb391f9a1c765f$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $6fbb391f9a1c765f$var$matches(matcher, action);
        });
    };
}
function $6fbb391f9a1c765f$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $6fbb391f9a1c765f$var$matches(matcher, action);
        });
    };
}
function $6fbb391f9a1c765f$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $6fbb391f9a1c765f$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $6fbb391f9a1c765f$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $6fbb391f9a1c765f$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$6fbb391f9a1c765f$var$isAsyncThunkArray(asyncThunks)) return $6fbb391f9a1c765f$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $6fbb391f9a1c765f$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $6fbb391f9a1c765f$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $6fbb391f9a1c765f$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$6fbb391f9a1c765f$var$isAsyncThunkArray(asyncThunks)) return $6fbb391f9a1c765f$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $6fbb391f9a1c765f$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $6fbb391f9a1c765f$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function hasFlag(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $6fbb391f9a1c765f$export$9dd1fb32974da385($6fbb391f9a1c765f$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$6fbb391f9a1c765f$var$isAsyncThunkArray(asyncThunks)) return $6fbb391f9a1c765f$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $6fbb391f9a1c765f$export$9dd1fb32974da385($6fbb391f9a1c765f$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $6fbb391f9a1c765f$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $6fbb391f9a1c765f$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$6fbb391f9a1c765f$var$isAsyncThunkArray(asyncThunks)) return $6fbb391f9a1c765f$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $6fbb391f9a1c765f$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $6fbb391f9a1c765f$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $6fbb391f9a1c765f$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$6fbb391f9a1c765f$var$isAsyncThunkArray(asyncThunks)) return $6fbb391f9a1c765f$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $6fbb391f9a1c765f$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $6fbb391f9a1c765f$var$assertFunction = function assertFunction(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $6fbb391f9a1c765f$var$noop = function noop() {};
var $6fbb391f9a1c765f$var$catchRejection = function catchRejection(promise2, onError) {
    if (onError === void 0) onError = $6fbb391f9a1c765f$var$noop;
    promise2["catch"](onError);
    return promise2;
};
var $6fbb391f9a1c765f$var$addAbortSignalListener = function addAbortSignalListener(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $6fbb391f9a1c765f$var$abortControllerWithReason = function abortControllerWithReason(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $6fbb391f9a1c765f$var$task = "task";
var $6fbb391f9a1c765f$var$listener = "listener";
var $6fbb391f9a1c765f$var$completed = "completed";
var $6fbb391f9a1c765f$var$cancelled = "cancelled";
var $6fbb391f9a1c765f$var$taskCancelled = "task-" + $6fbb391f9a1c765f$var$cancelled;
var $6fbb391f9a1c765f$var$taskCompleted = "task-" + $6fbb391f9a1c765f$var$completed;
var $6fbb391f9a1c765f$var$listenerCancelled = $6fbb391f9a1c765f$var$listener + "-" + $6fbb391f9a1c765f$var$cancelled;
var $6fbb391f9a1c765f$var$listenerCompleted = $6fbb391f9a1c765f$var$listener + "-" + $6fbb391f9a1c765f$var$completed;
var $6fbb391f9a1c765f$export$cb1bdac908fed7f = /** @class */ function() {
    var TaskAbortError = function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $6fbb391f9a1c765f$var$task + " " + $6fbb391f9a1c765f$var$cancelled + " (reason: " + code + ")";
    };
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $6fbb391f9a1c765f$var$validateActive = function validateActive(signal) {
    if (signal.aborted) throw new $6fbb391f9a1c765f$export$cb1bdac908fed7f(signal.reason);
};
function $6fbb391f9a1c765f$var$raceWithSignal(signal, promise2) {
    var cleanup = $6fbb391f9a1c765f$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function notifyRejection() {
            return reject(new $6fbb391f9a1c765f$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $6fbb391f9a1c765f$var$addAbortSignalListener(signal, notifyRejection);
        promise2["finally"](function() {
            return cleanup();
        }).then(resolve, reject);
    })["finally"](function() {
        cleanup = $6fbb391f9a1c765f$var$noop;
    });
}
var $6fbb391f9a1c765f$var$runTask = function runTask(task2, cleanUp) {
    return $6fbb391f9a1c765f$var$__async(void 0, null, function() {
        var value, error_1;
        return $6fbb391f9a1c765f$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $6fbb391f9a1c765f$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $6fbb391f9a1c765f$var$createPause = function createPause(signal) {
    return function(promise2) {
        return $6fbb391f9a1c765f$var$catchRejection($6fbb391f9a1c765f$var$raceWithSignal(signal, promise2).then(function(output) {
            $6fbb391f9a1c765f$var$validateActive(signal);
            return output;
        }));
    };
};
var $6fbb391f9a1c765f$var$createDelay = function createDelay(signal) {
    var pause = $6fbb391f9a1c765f$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $6fbb391f9a1c765f$var$assign = Object.assign;
var $6fbb391f9a1c765f$var$INTERNAL_NIL_TOKEN = {};
var $6fbb391f9a1c765f$var$alm = "listenerMiddleware";
var $6fbb391f9a1c765f$var$createFork = function createFork(parentAbortSignal) {
    var linkControllers = function linkControllers(controller) {
        return $6fbb391f9a1c765f$var$addAbortSignalListener(parentAbortSignal, function() {
            return $6fbb391f9a1c765f$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $6fbb391f9a1c765f$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $6fbb391f9a1c765f$var$runTask(function() {
            return $6fbb391f9a1c765f$var$__async(void 0, null, function() {
                var result2;
                return $6fbb391f9a1c765f$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $6fbb391f9a1c765f$var$validateActive(parentAbortSignal);
                            $6fbb391f9a1c765f$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $6fbb391f9a1c765f$var$createPause(childAbortController.signal),
                                    delay: $6fbb391f9a1c765f$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $6fbb391f9a1c765f$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $6fbb391f9a1c765f$var$abortControllerWithReason(childAbortController, $6fbb391f9a1c765f$var$taskCompleted);
        });
        return {
            result: $6fbb391f9a1c765f$var$createPause(parentAbortSignal)(result),
            cancel: function cancel() {
                $6fbb391f9a1c765f$var$abortControllerWithReason(childAbortController, $6fbb391f9a1c765f$var$taskCancelled);
            }
        };
    };
};
var $6fbb391f9a1c765f$var$createTakePattern = function createTakePattern(startListening, signal) {
    var take = function take(predicate, timeout) {
        return $6fbb391f9a1c765f$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $6fbb391f9a1c765f$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $6fbb391f9a1c765f$var$validateActive(signal);
                        unsubscribe = function unsubscribe() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function effect(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function unsubscribe() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $6fbb391f9a1c765f$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $6fbb391f9a1c765f$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $6fbb391f9a1c765f$var$catchRejection(take(predicate, timeout));
    };
};
var $6fbb391f9a1c765f$var$getListenerEntryPropsFrom = function getListenerEntryPropsFrom(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $6fbb391f9a1c765f$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $6fbb391f9a1c765f$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $6fbb391f9a1c765f$var$createListenerEntry = function createListenerEntry(options) {
    var _c = $6fbb391f9a1c765f$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $6fbb391f9a1c765f$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function unsubscribe() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $6fbb391f9a1c765f$var$cancelActiveListeners = function cancelActiveListeners(entry) {
    entry.pending.forEach(function(controller) {
        $6fbb391f9a1c765f$var$abortControllerWithReason(controller, $6fbb391f9a1c765f$var$listenerCancelled);
    });
};
var $6fbb391f9a1c765f$var$createClearListenerMiddleware = function createClearListenerMiddleware(listenerMap) {
    return function() {
        listenerMap.forEach($6fbb391f9a1c765f$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $6fbb391f9a1c765f$var$safelyNotifyError = function safelyNotifyError(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $6fbb391f9a1c765f$export$f03a6b845d3fb58b = $6fbb391f9a1c765f$export$309c7a02b0b0bc62($6fbb391f9a1c765f$var$alm + "/add");
var $6fbb391f9a1c765f$export$b1b8022855fb2b71 = $6fbb391f9a1c765f$export$309c7a02b0b0bc62($6fbb391f9a1c765f$var$alm + "/removeAll");
var $6fbb391f9a1c765f$export$b03e9483f936dccb = $6fbb391f9a1c765f$export$309c7a02b0b0bc62($6fbb391f9a1c765f$var$alm + "/remove");
var $6fbb391f9a1c765f$var$defaultErrorHandler = function defaultErrorHandler() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $6fbb391f9a1c765f$var$__spreadArray([
        $6fbb391f9a1c765f$var$alm + "/error"
    ], args));
};
function $6fbb391f9a1c765f$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $6fbb391f9a1c765f$var$defaultErrorHandler : _c;
    $6fbb391f9a1c765f$var$assertFunction(onError, "onError");
    var insertEntry = function insertEntry(entry) {
        entry.unsubscribe = function() {
            return listenerMap["delete"](entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $6fbb391f9a1c765f$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function findListenerEntry(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function startListening(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $6fbb391f9a1c765f$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function stopListening(options) {
        var _c = $6fbb391f9a1c765f$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $6fbb391f9a1c765f$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function notifyListener(entry, action, api, getOriginalState) {
        return $6fbb391f9a1c765f$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $6fbb391f9a1c765f$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $6fbb391f9a1c765f$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $6fbb391f9a1c765f$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function condition(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $6fbb391f9a1c765f$var$createDelay(internalTaskController.signal),
                                pause: $6fbb391f9a1c765f$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $6fbb391f9a1c765f$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function subscribe() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function cancelActiveListeners() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $6fbb391f9a1c765f$var$abortControllerWithReason(controller, $6fbb391f9a1c765f$var$listenerCancelled);
                                            set["delete"](controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $6fbb391f9a1c765f$export$cb1bdac908fed7f)) $6fbb391f9a1c765f$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $6fbb391f9a1c765f$var$abortControllerWithReason(internalTaskController, $6fbb391f9a1c765f$var$listenerCompleted);
                        entry.pending["delete"](internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $6fbb391f9a1c765f$var$createClearListenerMiddleware(listenerMap);
    var middleware = function middleware(api) {
        return function(next) {
            return function(action) {
                if (!$6fbb391f9a1c765f$export$b956e38827fca970(action)) return next(action);
                if ($6fbb391f9a1c765f$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($6fbb391f9a1c765f$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($6fbb391f9a1c765f$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function getOriginalState() {
                    if (originalState === $6fbb391f9a1c765f$var$INTERNAL_NIL_TOKEN) throw new Error($6fbb391f9a1c765f$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $6fbb391f9a1c765f$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $6fbb391f9a1c765f$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $6fbb391f9a1c765f$export$8fb31c0f05df007b = "RTK_autoBatch";
var $6fbb391f9a1c765f$export$39fcd5145ec5e4e2 = function prepareAutoBatched() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$6fbb391f9a1c765f$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $6fbb391f9a1c765f$var$promise;
var $6fbb391f9a1c765f$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function queueMicrotaskShim(cb) {
    return ($6fbb391f9a1c765f$var$promise || ($6fbb391f9a1c765f$var$promise = Promise.resolve())).then(cb)["catch"](function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $6fbb391f9a1c765f$var$createQueueWithTimer = function createQueueWithTimer(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $6fbb391f9a1c765f$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $6fbb391f9a1c765f$var$createQueueWithTimer(10);
var $6fbb391f9a1c765f$export$676277d7dca0f396 = function autoBatchEnhancer(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $6fbb391f9a1c765f$var$queueMicrotaskShim : options.type === "raf" ? $6fbb391f9a1c765f$var$rAF : options.type === "callback" ? options.queueNotification : $6fbb391f9a1c765f$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function notifyListeners() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function subscribe(listener2) {
                    var wrappedListener = function wrappedListener() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners["delete"](listener2);
                    };
                },
                dispatch: function dispatch(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$6fbb391f9a1c765f$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $1Be8m.enableES5)();

});
parcelRequire.register("1Be8m", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return $12a435cf125d2c60$export$541ac630993a4c84; });
$parcel$export(module.exports, "isDraftable", function () { return $12a435cf125d2c60$export$16e3aed3edb85946; });
$parcel$export(module.exports, "current", function () { return $12a435cf125d2c60$export$97aac956da55dae9; });
$parcel$export(module.exports, "enableES5", function () { return $12a435cf125d2c60$export$56771cf63ee491f5; });
$parcel$export(module.exports, "default", function () { return $12a435cf125d2c60$export$2e2bcd8739ae039; });

var $qb7pP = parcelRequire("qb7pP");
function $12a435cf125d2c60$var$n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var _$i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function $12a435cf125d2c60$export$541ac630993a4c84(n) {
    return !!n && !!n[$12a435cf125d2c60$var$Q];
}
function $12a435cf125d2c60$export$16e3aed3edb85946(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === $12a435cf125d2c60$var$Z;
    }(n) || Array.isArray(n) || !!n[$12a435cf125d2c60$export$6ee2082928bcb0ee] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[$12a435cf125d2c60$export$6ee2082928bcb0ee]) || $12a435cf125d2c60$var$s(n) || $12a435cf125d2c60$var$v(n));
}
function $12a435cf125d2c60$export$22e8af3f75a010e3(t) {
    return $12a435cf125d2c60$export$541ac630993a4c84(t) || $12a435cf125d2c60$var$n(23, t), t[$12a435cf125d2c60$var$Q].t;
}
function $12a435cf125d2c60$var$i(n, r, t) {
    void 0 === t && (t = !1), 0 === $12a435cf125d2c60$var$o(n) ? (t ? Object.keys : $12a435cf125d2c60$var$nn)(n).forEach(function(e) {
        t && "symbol" == (typeof e === "undefined" ? "undefined" : (0, $qb7pP._)(e)) || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function $12a435cf125d2c60$var$o(n) {
    var r = n[$12a435cf125d2c60$var$Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : $12a435cf125d2c60$var$s(n) ? 2 : $12a435cf125d2c60$var$v(n) ? 3 : 0;
}
function $12a435cf125d2c60$var$u(n, r) {
    return 2 === $12a435cf125d2c60$var$o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function $12a435cf125d2c60$var$a(n, r) {
    return 2 === $12a435cf125d2c60$var$o(n) ? n.get(r) : n[r];
}
function $12a435cf125d2c60$var$f(n, r, t) {
    var e = $12a435cf125d2c60$var$o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function $12a435cf125d2c60$var$c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function $12a435cf125d2c60$var$s(n) {
    return $12a435cf125d2c60$var$X && n instanceof Map;
}
function $12a435cf125d2c60$var$v(n) {
    return $12a435cf125d2c60$var$q && n instanceof Set;
}
function $12a435cf125d2c60$var$p(n) {
    return n.o || n.t;
}
function $12a435cf125d2c60$var$l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = $12a435cf125d2c60$var$rn(n);
    delete r[$12a435cf125d2c60$var$Q];
    for(var t = $12a435cf125d2c60$var$nn(r), e = 0; e < t.length; e++){
        var _$i = t[e], o = r[_$i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[_$i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[_$i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function $12a435cf125d2c60$export$792f3d81ea979f55(n, e) {
    return void 0 === e && (e = !1), $12a435cf125d2c60$var$y(n) || $12a435cf125d2c60$export$541ac630993a4c84(n) || !$12a435cf125d2c60$export$16e3aed3edb85946(n) || ($12a435cf125d2c60$var$o(n) > 1 && (n.set = n.add = n.clear = n["delete"] = $12a435cf125d2c60$var$h), Object.freeze(n), e && $12a435cf125d2c60$var$i(n, function(n, r) {
        return $12a435cf125d2c60$export$792f3d81ea979f55(r, !0);
    }, !0)), n;
}
function $12a435cf125d2c60$var$h() {
    $12a435cf125d2c60$var$n(2);
}
function $12a435cf125d2c60$var$y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function $12a435cf125d2c60$var$b(r) {
    var t = $12a435cf125d2c60$var$tn[r];
    return t || $12a435cf125d2c60$var$n(18, r), t;
}
function $12a435cf125d2c60$var$m(n, r) {
    $12a435cf125d2c60$var$tn[n] || ($12a435cf125d2c60$var$tn[n] = r);
}
function $12a435cf125d2c60$var$_() {
    return $12a435cf125d2c60$var$U;
}
function $12a435cf125d2c60$var$j(n, r) {
    r && ($12a435cf125d2c60$var$b("Patches"), n.u = [], n.s = [], n.v = r);
}
function $12a435cf125d2c60$var$g(n) {
    $12a435cf125d2c60$var$O(n), n.p.forEach($12a435cf125d2c60$var$S), n.p = null;
}
function $12a435cf125d2c60$var$O(n) {
    n === $12a435cf125d2c60$var$U && ($12a435cf125d2c60$var$U = n.l);
}
function $12a435cf125d2c60$var$w(n) {
    return $12a435cf125d2c60$var$U = {
        p: [],
        l: $12a435cf125d2c60$var$U,
        h: n,
        m: !0,
        _: 0
    };
}
function $12a435cf125d2c60$var$S(n) {
    var r = n[$12a435cf125d2c60$var$Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function $12a435cf125d2c60$var$P(r, e) {
    e._ = e.p.length;
    var _$i = e.p[0], o = void 0 !== r && r !== _$i;
    return e.h.O || $12a435cf125d2c60$var$b("ES5").S(e, r, o), o ? (_$i[$12a435cf125d2c60$var$Q].P && ($12a435cf125d2c60$var$g(e), $12a435cf125d2c60$var$n(4)), $12a435cf125d2c60$export$16e3aed3edb85946(r) && (r = $12a435cf125d2c60$var$M(e, r), e.l || $12a435cf125d2c60$var$x(e, r)), e.u && $12a435cf125d2c60$var$b("Patches").M(_$i[$12a435cf125d2c60$var$Q].t, r, e.u, e.s)) : r = $12a435cf125d2c60$var$M(e, _$i, []), $12a435cf125d2c60$var$g(e), e.u && e.v(e.u, e.s), r !== $12a435cf125d2c60$export$45b790e32b2810ee ? r : void 0;
}
function $12a435cf125d2c60$var$M(n, r, t) {
    if ($12a435cf125d2c60$var$y(r)) return r;
    var e = r[$12a435cf125d2c60$var$Q];
    if (!e) return $12a435cf125d2c60$var$i(r, function(i, o) {
        return $12a435cf125d2c60$var$A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return $12a435cf125d2c60$var$x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = $12a435cf125d2c60$var$l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), $12a435cf125d2c60$var$i(u, function(r, i) {
            return $12a435cf125d2c60$var$A(n, e, o, r, i, t, a);
        }), $12a435cf125d2c60$var$x(n, o, !1), t && n.u && $12a435cf125d2c60$var$b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function $12a435cf125d2c60$var$A(e, i, o, a, c, s, v) {
    if ($12a435cf125d2c60$export$541ac630993a4c84(c)) {
        var p = $12a435cf125d2c60$var$M(e, c, s && i && 3 !== i.i && !$12a435cf125d2c60$var$u(i.R, a) ? s.concat(a) : void 0);
        if ($12a435cf125d2c60$var$f(o, a, p), !$12a435cf125d2c60$export$541ac630993a4c84(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if ($12a435cf125d2c60$export$16e3aed3edb85946(c) && !$12a435cf125d2c60$var$y(c)) {
        if (!e.h.D && e._ < 1) return;
        $12a435cf125d2c60$var$M(e, c), i && i.A.l || $12a435cf125d2c60$var$x(e, c);
    }
}
function $12a435cf125d2c60$var$x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && $12a435cf125d2c60$export$792f3d81ea979f55(r, t);
}
function $12a435cf125d2c60$var$z(n, r) {
    var t = n[$12a435cf125d2c60$var$Q];
    return (t ? $12a435cf125d2c60$var$p(t) : n)[r];
}
function $12a435cf125d2c60$var$I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function $12a435cf125d2c60$var$k(n) {
    n.P || (n.P = !0, n.l && $12a435cf125d2c60$var$k(n.l));
}
function $12a435cf125d2c60$var$E(n) {
    n.o || (n.o = $12a435cf125d2c60$var$l(n.t));
}
function $12a435cf125d2c60$var$N(n, r, t) {
    var e = $12a435cf125d2c60$var$s(r) ? $12a435cf125d2c60$var$b("MapSet").F(r, t) : $12a435cf125d2c60$var$v(r) ? $12a435cf125d2c60$var$b("MapSet").T(r, t) : n.O ? function(n, r) {
        var _$t = Array.isArray(n), e = {
            i: _$t ? 1 : 0,
            A: r ? r.A : $12a435cf125d2c60$var$_(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, _$i = e, o = $12a435cf125d2c60$var$en;
        _$t && (_$i = [
            e
        ], o = $12a435cf125d2c60$var$on);
        var u = Proxy.revocable(_$i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : $12a435cf125d2c60$var$b("ES5").J(r, t);
    return (t ? t.A : $12a435cf125d2c60$var$_()).p.push(e), e;
}
function $12a435cf125d2c60$export$97aac956da55dae9(e) {
    return $12a435cf125d2c60$export$541ac630993a4c84(e) || $12a435cf125d2c60$var$n(22, e), function n(r) {
        if (!$12a435cf125d2c60$export$16e3aed3edb85946(r)) return r;
        var _$e, u = r[$12a435cf125d2c60$var$Q], c = $12a435cf125d2c60$var$o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !$12a435cf125d2c60$var$b("ES5").K(u))) return u.t;
            u.I = !0, _$e = $12a435cf125d2c60$var$D(r, c), u.I = !1;
        } else _$e = $12a435cf125d2c60$var$D(r, c);
        return $12a435cf125d2c60$var$i(_$e, function(r, t) {
            u && $12a435cf125d2c60$var$a(u.t, r) === t || $12a435cf125d2c60$var$f(_$e, r, n(t));
        }), 3 === c ? new Set(_$e) : _$e;
    }(e);
}
function $12a435cf125d2c60$var$D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return $12a435cf125d2c60$var$l(n);
}
function $12a435cf125d2c60$export$56771cf63ee491f5() {
    var t = function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function get() {
                var _$r = this[$12a435cf125d2c60$var$Q];
                return $12a435cf125d2c60$var$en.get(_$r, n);
            },
            set: function set(r) {
                var t = this[$12a435cf125d2c60$var$Q];
                $12a435cf125d2c60$var$en.set(t, n, r);
            }
        }, t;
    };
    var e = function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][$12a435cf125d2c60$var$Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && $12a435cf125d2c60$var$k(t);
                    break;
                case 4:
                    o(t) && $12a435cf125d2c60$var$k(t);
            }
        }
    };
    var o = function o(n) {
        for(var r = n.t, t = n.k, e = $12a435cf125d2c60$var$nn(t), _$i = e.length - 1; _$i >= 0; _$i--){
            var o = e[_$i];
            if (o !== $12a435cf125d2c60$var$Q) {
                var a = r[o];
                if (void 0 === a && !$12a435cf125d2c60$var$u(r, o)) return !0;
                var f = t[o], s = f && f[$12a435cf125d2c60$var$Q];
                if (s ? s.t !== a : !$12a435cf125d2c60$var$c(f, a)) return !0;
            }
        }
        var v = !!r[$12a435cf125d2c60$var$Q];
        return e.length !== $12a435cf125d2c60$var$nn(r).length + (v ? 0 : 1);
    };
    var a = function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    };
    var f = function f(r) {
        r.g && $12a435cf125d2c60$var$n(3, JSON.stringify($12a435cf125d2c60$var$p(r)));
    };
    var s = {};
    $12a435cf125d2c60$var$m("ES5", {
        J: function J(n, r) {
            var e = Array.isArray(n), _$i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), _$i = 0; _$i < r.length; _$i++)Object.defineProperty(e, "" + _$i, t(_$i, !0));
                    return e;
                }
                var o = $12a435cf125d2c60$var$rn(r);
                delete o[$12a435cf125d2c60$var$Q];
                for(var u = $12a435cf125d2c60$var$nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : $12a435cf125d2c60$var$_(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: _$i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(_$i, $12a435cf125d2c60$var$Q, {
                value: o,
                writable: !0
            }), _$i;
        },
        S: function S(n, t, o) {
            o ? $12a435cf125d2c60$export$541ac630993a4c84(t) && t[$12a435cf125d2c60$var$Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var _$t = r[$12a435cf125d2c60$var$Q];
                    if (_$t) {
                        var e = _$t.t, _$o = _$t.k, f = _$t.R, c = _$t.i;
                        if (4 === c) $12a435cf125d2c60$var$i(_$o, function(r) {
                            r !== $12a435cf125d2c60$var$Q && (void 0 !== e[r] || $12a435cf125d2c60$var$u(e, r) ? f[r] || n(_$o[r]) : (f[r] = !0, $12a435cf125d2c60$var$k(_$t)));
                        }), $12a435cf125d2c60$var$i(e, function(n) {
                            void 0 !== _$o[n] || $12a435cf125d2c60$var$u(_$o, n) || (f[n] = !1, $12a435cf125d2c60$var$k(_$t));
                        });
                        else if (5 === c) {
                            if (a(_$t) && ($12a435cf125d2c60$var$k(_$t), f.length = !0), _$o.length < e.length) for(var s = _$o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < _$o.length; v++)f[v] = !0;
                            for(var p = Math.min(_$o.length, e.length), l = 0; l < p; l++)_$o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(_$o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function K(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function $12a435cf125d2c60$export$d3a6659991a0696c() {
    var f = function f(n) {
        return $12a435cf125d2c60$export$541ac630993a4c84(n) ? e(n) : n;
    };
    function e(n) {
        if (!$12a435cf125d2c60$export$16e3aed3edb85946(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if ($12a435cf125d2c60$var$s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if ($12a435cf125d2c60$var$v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var _$i in n)r[_$i] = e(n[_$i]);
        return $12a435cf125d2c60$var$u(n, $12a435cf125d2c60$export$6ee2082928bcb0ee) && (r[$12a435cf125d2c60$export$6ee2082928bcb0ee] = n[$12a435cf125d2c60$export$6ee2082928bcb0ee]), r;
    }
    var c = "add";
    $12a435cf125d2c60$var$m("Patches", {
        $: function $(r, t) {
            return t.forEach(function(t) {
                for(var _$i = t.path, u = t.op, f = r, s = 0; s < _$i.length - 1; s++){
                    var v = $12a435cf125d2c60$var$o(f), p = _$i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || $12a435cf125d2c60$var$n(24), "function" == typeof f && "prototype" === p && $12a435cf125d2c60$var$n(24), "object" != typeof (f = $12a435cf125d2c60$var$a(f, p)) && $12a435cf125d2c60$var$n(15, _$i.join("/"));
                }
                var l = $12a435cf125d2c60$var$o(f), d = e(t.value), h = _$i[_$i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                $12a435cf125d2c60$var$n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f["delete"](h);
                            case 3:
                                return f["delete"](t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        $12a435cf125d2c60$var$n(17, u);
                }
            }), r;
        },
        N: function N(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        $12a435cf125d2c60$var$i(n.R, function(n, i) {
                            var v = $12a435cf125d2c60$var$a(o, n), p = $12a435cf125d2c60$var$a(s, n), l = i ? $12a435cf125d2c60$var$u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var _$i = n.t, o = n.R, u = n.o;
                        if (u.length < _$i.length) {
                            var a = [
                                u,
                                _$i
                            ];
                            _$i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < _$i.length; v++)if (o[v] && u[v] !== _$i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(_$i[v])
                            });
                        }
                        for(var l = _$i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        _$i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: _$i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var _$i = n.t, o = n.o, u = 0;
                        _$i.forEach(function(n) {
                            if (!o.has(n)) {
                                var _$i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: _$i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: _$i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!_$i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function M(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === $12a435cf125d2c60$export$45b790e32b2810ee ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function $12a435cf125d2c60$export$7d9f65390203b435() {
    var r = function r(n, _r) {
        function t() {
            this.constructor = n;
        }
        a(n, _r), n.prototype = (t.prototype = _r.prototype, new t);
    };
    var e = function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    };
    var o = function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if ($12a435cf125d2c60$export$16e3aed3edb85946(r)) {
                var e = $12a435cf125d2c60$var$N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    };
    var u = function u(r) {
        r.g && $12a435cf125d2c60$var$n(3, JSON.stringify($12a435cf125d2c60$var$p(r)));
    };
    var a = function a1(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        var n = function n(n, r) {
            return this[$12a435cf125d2c60$var$Q] = {
                i: 2,
                l: r,
                A: r ? r.A : $12a435cf125d2c60$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        };
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function get() {
                return $12a435cf125d2c60$var$p(this[$12a435cf125d2c60$var$Q]).size;
            }
        }), o.has = function(n) {
            return $12a435cf125d2c60$var$p(this[$12a435cf125d2c60$var$Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[$12a435cf125d2c60$var$Q];
            return u(t), $12a435cf125d2c60$var$p(t).has(n) && $12a435cf125d2c60$var$p(t).get(n) === r || (e(t), $12a435cf125d2c60$var$k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o["delete"] = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$12a435cf125d2c60$var$Q];
            return u(r), e(r), $12a435cf125d2c60$var$k(r), r.t.has(n) ? r.R.set(n, !1) : r.R["delete"](n), r.o["delete"](n), !0;
        }, o.clear = function() {
            var n = this[$12a435cf125d2c60$var$Q];
            u(n), $12a435cf125d2c60$var$p(n).size && (e(n), $12a435cf125d2c60$var$k(n), n.R = new Map, $12a435cf125d2c60$var$i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            $12a435cf125d2c60$var$p(this[$12a435cf125d2c60$var$Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[$12a435cf125d2c60$var$Q];
            u(r);
            var _$i = $12a435cf125d2c60$var$p(r).get(n);
            if (r.I || !$12a435cf125d2c60$export$16e3aed3edb85946(_$i)) return _$i;
            if (_$i !== r.t.get(n)) return _$i;
            var o = $12a435cf125d2c60$var$N(r.A.h, _$i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return $12a435cf125d2c60$var$p(this[$12a435cf125d2c60$var$Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$12a435cf125d2c60$var$V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$12a435cf125d2c60$var$V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[$12a435cf125d2c60$var$V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        var n = function n(n, r) {
            return this[$12a435cf125d2c60$var$Q] = {
                i: 3,
                l: r,
                A: r ? r.A : $12a435cf125d2c60$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        };
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function get() {
                return $12a435cf125d2c60$var$p(this[$12a435cf125d2c60$var$Q]).size;
            }
        }), t.has = function(n) {
            var r = this[$12a435cf125d2c60$var$Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[$12a435cf125d2c60$var$Q];
            return u(r), this.has(n) || (o(r), $12a435cf125d2c60$var$k(r), r.o.add(n)), this;
        }, t["delete"] = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$12a435cf125d2c60$var$Q];
            return u(r), o(r), $12a435cf125d2c60$var$k(r), r.o["delete"](n) || !!r.p.has(n) && r.o["delete"](r.p.get(n));
        }, t.clear = function() {
            var n = this[$12a435cf125d2c60$var$Q];
            u(n), $12a435cf125d2c60$var$p(n).size && (o(n), $12a435cf125d2c60$var$k(n), n.o.clear());
        }, t.values = function() {
            var n = this[$12a435cf125d2c60$var$Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[$12a435cf125d2c60$var$Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[$12a435cf125d2c60$var$V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    $12a435cf125d2c60$var$m("MapSet", {
        F: function F(n, r) {
            return new f(n, r);
        },
        T: function T(n, r) {
            return new c(n, r);
        }
    });
}
function $12a435cf125d2c60$export$cae049b67c7d1bc9() {
    $12a435cf125d2c60$export$56771cf63ee491f5(), $12a435cf125d2c60$export$7d9f65390203b435(), $12a435cf125d2c60$export$d3a6659991a0696c();
}
function $12a435cf125d2c60$export$c05b21e3257751e5(n) {
    return n;
}
function $12a435cf125d2c60$export$20f911b3f8cf0b74(n) {
    return n;
}
var $12a435cf125d2c60$var$G, $12a435cf125d2c60$var$U, $12a435cf125d2c60$var$W = "undefined" != typeof Symbol && "symbol" == (0, $qb7pP._)(Symbol("x")), $12a435cf125d2c60$var$X = "undefined" != typeof Map, $12a435cf125d2c60$var$q = "undefined" != typeof Set, $12a435cf125d2c60$var$B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, $12a435cf125d2c60$export$45b790e32b2810ee = $12a435cf125d2c60$var$W ? Symbol["for"]("immer-nothing") : (($12a435cf125d2c60$var$G = {})["immer-nothing"] = !0, $12a435cf125d2c60$var$G), $12a435cf125d2c60$export$6ee2082928bcb0ee = $12a435cf125d2c60$var$W ? Symbol["for"]("immer-draftable") : "__$immer_draftable", $12a435cf125d2c60$var$Q = $12a435cf125d2c60$var$W ? Symbol["for"]("immer-state") : "__$immer_state", $12a435cf125d2c60$var$V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", $12a435cf125d2c60$var$Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, $12a435cf125d2c60$var$Z = "" + Object.prototype.constructor, $12a435cf125d2c60$var$nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function nn(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, $12a435cf125d2c60$var$rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return $12a435cf125d2c60$var$nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, $12a435cf125d2c60$var$tn = {}, $12a435cf125d2c60$var$en = {
    get: function get(n, r) {
        if (r === $12a435cf125d2c60$var$Q) return n;
        var e = $12a435cf125d2c60$var$p(n);
        if (!$12a435cf125d2c60$var$u(e, r)) return function(n, r, t) {
            var e, _$i = $12a435cf125d2c60$var$I(r, t);
            return _$i ? "value" in _$i ? _$i.value : null === (e = _$i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var _$i = e[r];
        return n.I || !$12a435cf125d2c60$export$16e3aed3edb85946(_$i) ? _$i : _$i === $12a435cf125d2c60$var$z(n.t, r) ? ($12a435cf125d2c60$var$E(n), n.o[r] = $12a435cf125d2c60$var$N(n.A.h, _$i, n)) : _$i;
    },
    has: function has(n, r) {
        return r in $12a435cf125d2c60$var$p(n);
    },
    ownKeys: function ownKeys(n) {
        return Reflect.ownKeys($12a435cf125d2c60$var$p(n));
    },
    set: function set(n, r, t) {
        var e = $12a435cf125d2c60$var$I($12a435cf125d2c60$var$p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var _$i = $12a435cf125d2c60$var$z($12a435cf125d2c60$var$p(n), r), o = null == _$i ? void 0 : _$i[$12a435cf125d2c60$var$Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if ($12a435cf125d2c60$var$c(t, _$i) && (void 0 !== t || $12a435cf125d2c60$var$u(n.t, r))) return !0;
            $12a435cf125d2c60$var$E(n), $12a435cf125d2c60$var$k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function deleteProperty(n, r) {
        return void 0 !== $12a435cf125d2c60$var$z(n.t, r) || r in n.t ? (n.R[r] = !1, $12a435cf125d2c60$var$E(n), $12a435cf125d2c60$var$k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(n, r) {
        var t = $12a435cf125d2c60$var$p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function defineProperty() {
        $12a435cf125d2c60$var$n(11);
    },
    getPrototypeOf: function getPrototypeOf(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function setPrototypeOf() {
        $12a435cf125d2c60$var$n(12);
    }
}, $12a435cf125d2c60$var$on = {};
$12a435cf125d2c60$var$i($12a435cf125d2c60$var$en, function(n, r) {
    $12a435cf125d2c60$var$on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), $12a435cf125d2c60$var$on.deleteProperty = function(r, t) {
    return $12a435cf125d2c60$var$on.set.call(this, r, t, void 0);
}, $12a435cf125d2c60$var$on.set = function(r, t, e) {
    return $12a435cf125d2c60$var$en.set.call(this, r[0], t, e, r[0]);
};
var $12a435cf125d2c60$export$aaadc6ff0f822719 = function() {
    var e = function e(r) {
        var e = this;
        this.O = $12a435cf125d2c60$var$B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var _$r = this;
                    void 0 === n && (n = u);
                    for(var _$t = arguments.length, e = Array(_$t > 1 ? _$t - 1 : 0), _$o = 1; _$o < _$t; _$o++)e[_$o - 1] = arguments[_$o];
                    return a.produce(n, function(n) {
                        var _$t;
                        return (_$t = i).call.apply(_$t, [
                            _$r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && $12a435cf125d2c60$var$n(6), void 0 !== o && "function" != typeof o && $12a435cf125d2c60$var$n(7), $12a435cf125d2c60$export$16e3aed3edb85946(r)) {
                var c = $12a435cf125d2c60$var$w(e), s = $12a435cf125d2c60$var$N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? $12a435cf125d2c60$var$g(c) : $12a435cf125d2c60$var$O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return $12a435cf125d2c60$var$j(c, o), $12a435cf125d2c60$var$P(n, c);
                }, function(n) {
                    throw $12a435cf125d2c60$var$g(c), n;
                }) : ($12a435cf125d2c60$var$j(c, o), $12a435cf125d2c60$var$P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === $12a435cf125d2c60$export$45b790e32b2810ee && (f = void 0), e.D && $12a435cf125d2c60$export$792f3d81ea979f55(f, !0), o) {
                    var p = [], l = [];
                    $12a435cf125d2c60$var$b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            $12a435cf125d2c60$var$n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, _$i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)_$i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(_$i));
                });
            };
            var t, _$i, o = e.produce(n, r, function(n, r) {
                t = n, _$i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    _$i
                ];
            }) : [
                o,
                t,
                _$i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    };
    var _$i = e.prototype;
    return _$i.createDraft = function(e) {
        $12a435cf125d2c60$export$16e3aed3edb85946(e) || $12a435cf125d2c60$var$n(8), $12a435cf125d2c60$export$541ac630993a4c84(e) && (e = $12a435cf125d2c60$export$97aac956da55dae9(e));
        var _$i = $12a435cf125d2c60$var$w(this), o = $12a435cf125d2c60$var$N(this, e, void 0);
        return o[$12a435cf125d2c60$var$Q].C = !0, $12a435cf125d2c60$var$O(_$i), o;
    }, _$i.finishDraft = function(r, t) {
        var e = r && r[$12a435cf125d2c60$var$Q];
        var _$i = e.A;
        return $12a435cf125d2c60$var$j(_$i, t), $12a435cf125d2c60$var$P(void 0, _$i);
    }, _$i.setAutoFreeze = function(n) {
        this.D = n;
    }, _$i.setUseProxies = function(r) {
        r && !$12a435cf125d2c60$var$B && $12a435cf125d2c60$var$n(20), this.O = r;
    }, _$i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var _$i = t[e];
            if (0 === _$i.path.length && "replace" === _$i.op) {
                n = _$i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = $12a435cf125d2c60$var$b("Patches").$;
        return $12a435cf125d2c60$export$541ac630993a4c84(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), $12a435cf125d2c60$var$an = new $12a435cf125d2c60$export$aaadc6ff0f822719, $12a435cf125d2c60$export$b46cabe22e78bc00 = $12a435cf125d2c60$var$an.produce, $12a435cf125d2c60$export$4da66d41c9492c78 = $12a435cf125d2c60$var$an.produceWithPatches.bind($12a435cf125d2c60$var$an), $12a435cf125d2c60$export$573f26f60825c493 = $12a435cf125d2c60$var$an.setAutoFreeze.bind($12a435cf125d2c60$var$an), $12a435cf125d2c60$export$36ccd207ae29b74e = $12a435cf125d2c60$var$an.setUseProxies.bind($12a435cf125d2c60$var$an), $12a435cf125d2c60$export$a8b8e03e6bbe5473 = $12a435cf125d2c60$var$an.applyPatches.bind($12a435cf125d2c60$var$an), $12a435cf125d2c60$export$3c3214997190395f = $12a435cf125d2c60$var$an.createDraft.bind($12a435cf125d2c60$var$an), $12a435cf125d2c60$export$c60f5e69c521b528 = $12a435cf125d2c60$var$an.finishDraft.bind($12a435cf125d2c60$var$an);
var $12a435cf125d2c60$export$2e2bcd8739ae039 = $12a435cf125d2c60$export$b46cabe22e78bc00;

});

parcelRequire.register("7w0GC", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $578c0dddf04e573a$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $578c0dddf04e573a$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $578c0dddf04e573a$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $578c0dddf04e573a$export$9ff26e0402cc7b7; });

var $qb7pP = parcelRequire("qb7pP");

var $hEGhs = parcelRequire("hEGhs");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $578c0dddf04e573a$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $578c0dddf04e573a$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $578c0dddf04e573a$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $578c0dddf04e573a$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $578c0dddf04e573a$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $578c0dddf04e573a$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $578c0dddf04e573a$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $578c0dddf04e573a$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $578c0dddf04e573a$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $qb7pP._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($578c0dddf04e573a$var$isDate(val)) return "date";
    if ($578c0dddf04e573a$var$isError(val)) return "error";
    var constructorName = $578c0dddf04e573a$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $578c0dddf04e573a$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $578c0dddf04e573a$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $578c0dddf04e573a$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $578c0dddf04e573a$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $qb7pP._)(val);
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $578c0dddf04e573a$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var ensureCanMutateNextListeners = /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    };
    var getState = /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(3));
        return currentState;
    };
    var subscribe = /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    };
    var dispatch = /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$578c0dddf04e573a$var$isPlainObject(action)) throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    };
    var replaceReducer = /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $578c0dddf04e573a$export$4219e499db7ca678.REPLACE
        });
    };
    var observable = /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$578c0dddf04e573a$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    ;
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(1));
        return enhancer($578c0dddf04e573a$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $578c0dddf04e573a$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$578c0dddf04e573a$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $578c0dddf04e573a$export$8928921ea2d3b126 = $578c0dddf04e573a$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $578c0dddf04e573a$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $578c0dddf04e573a$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $578c0dddf04e573a$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$578c0dddf04e573a$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $578c0dddf04e573a$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $578c0dddf04e573a$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $578c0dddf04e573a$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $578c0dddf04e573a$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $578c0dddf04e573a$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $578c0dddf04e573a$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $578c0dddf04e573a$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $578c0dddf04e573a$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $578c0dddf04e573a$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $578c0dddf04e573a$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $578c0dddf04e573a$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $578c0dddf04e573a$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $578c0dddf04e573a$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($578c0dddf04e573a$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $578c0dddf04e573a$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $hEGhs.default)((0, $hEGhs.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRequire.register("hEGhs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cda6f826554f3dc1$export$2e2bcd8739ae039; });

var $ctl4t = parcelRequire("ctl4t");
function $cda6f826554f3dc1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cda6f826554f3dc1$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cda6f826554f3dc1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ctl4t.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cda6f826554f3dc1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRequire.register("ctl4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $914889bfb65fa1ae$export$2e2bcd8739ae039; });

var $3VQxE = parcelRequire("3VQxE");
function $914889bfb65fa1ae$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3VQxE.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRequire.register("3VQxE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dcf73ab0a75b309$export$2e2bcd8739ae039; });

var $2CMGn = parcelRequire("2CMGn");

var $8OGGw = parcelRequire("8OGGw");
function $2dcf73ab0a75b309$export$2e2bcd8739ae039(arg) {
    var key = (0, $8OGGw.default)(arg, "string");
    return (0, $2CMGn.default)(key) === "symbol" ? key : String(key);
}

});
parcelRequire.register("2CMGn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e94e4b9e578fb02$export$2e2bcd8739ae039; });
function $1e94e4b9e578fb02$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $1e94e4b9e578fb02$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1e94e4b9e578fb02$export$2e2bcd8739ae039(o);
}

});

parcelRequire.register("8OGGw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66b41a9446060280$export$2e2bcd8739ae039; });

var $2CMGn = parcelRequire("2CMGn");
function $66b41a9446060280$export$2e2bcd8739ae039(input, hint) {
    if ((0, $2CMGn.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $2CMGn.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});





parcelRequire.register("3k8cf", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $26b9990797577fc3$export$595d22ed68ca2841; });

var $qb7pP = parcelRequire("qb7pP");

var $j5IhJ = parcelRequire("j5IhJ");
function $26b9990797577fc3$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep === "undefined" ? "undefined" : (0, $qb7pP._)(dep);
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $26b9990797577fc3$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + (typeof resultFunc === "undefined" ? "undefined" : (0, $qb7pP._)(resultFunc)) + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $26b9990797577fc3$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $26b9990797577fc3$export$595d22ed68ca2841 = /* #__PURE__ */ $26b9990797577fc3$export$5943f4447f6ef248((0, $j5IhJ.defaultMemoize));
var $26b9990797577fc3$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $26b9990797577fc3$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + (typeof selectors === "undefined" ? "undefined" : (0, $qb7pP._)(selectors))));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRequire.register("j5IhJ", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $de60d602c303cbeb$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $de60d602c303cbeb$var$NOT_FOUND = "NOT_FOUND";
function $de60d602c303cbeb$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $de60d602c303cbeb$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $de60d602c303cbeb$var$createLruCache(maxSize, equals) {
    var get = function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $de60d602c303cbeb$var$NOT_FOUND;
    };
    var put = function put(key, value) {
        if (get(key) === $de60d602c303cbeb$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    };
    var getEntries = function getEntries() {
        return entries;
    };
    var clear = function clear() {
        entries = [];
    };
    var entries = [];
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $de60d602c303cbeb$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $de60d602c303cbeb$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $de60d602c303cbeb$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var memoized = function memoized() {
        var value = cache.get(arguments);
        if (value === $de60d602c303cbeb$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    };
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $de60d602c303cbeb$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $de60d602c303cbeb$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $de60d602c303cbeb$var$createSingletonCache(comparator) : $de60d602c303cbeb$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRequire.register("ma7gB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0429e70e90dc6a29$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $0429e70e90dc6a29$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $0429e70e90dc6a29$var$thunk = $0429e70e90dc6a29$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$0429e70e90dc6a29$var$thunk.withExtraArgument = $0429e70e90dc6a29$var$createThunkMiddleware;
var $0429e70e90dc6a29$export$2e2bcd8739ae039 = $0429e70e90dc6a29$var$thunk;

});



parcelRequire.register("eOzfo", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1Vk0O"))((parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("jf007")),
    (parcelRequire("iwOd7"))((parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("1idCF"))
]).then(function() {
    return parcelRequire("dLbEZ");
});

});
parcelRequire.register("1Vk0O", function(module, exports) {
"use strict";

var $axrlS = parcelRequire("axrlS");
module.exports = $axrlS(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRequire.register("axrlS", function(module, exports) {
"use strict";
var $7ac233fabe109637$var$cachedBundles = {};
var $7ac233fabe109637$var$cachedPreloads = {};
var $7ac233fabe109637$var$cachedPrefetches = {};
function $7ac233fabe109637$var$getCache(type) {
    switch(type){
        case "preload":
            return $7ac233fabe109637$var$cachedPreloads;
        case "prefetch":
            return $7ac233fabe109637$var$cachedPrefetches;
        default:
            return $7ac233fabe109637$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $7ac233fabe109637$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("iwOd7", function(module, exports) {
"use strict";

var $axrlS = parcelRequire("axrlS");
module.exports = $axrlS(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});


parcelRequire.register("g0ZcG", function(module, exports) {



module.exports = (parcelRequire("iwOd7"))((parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("ir1ST")).then(function() {
    return parcelRequire("8x0Xs");
});

});

parcelRequire.register("bUgBz", function(module, exports) {



module.exports = (parcelRequire("iwOd7"))((parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("9TcZR")).then(function() {
    return parcelRequire("e72CS");
});

});


var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");
var $931d92b7390d92a2$exports = {};

$parcel$export($931d92b7390d92a2$exports, "createRoot", function () { return $931d92b7390d92a2$export$882461b6382ed46c; }, function (v) { return $931d92b7390d92a2$export$882461b6382ed46c = v; });
$parcel$export($931d92b7390d92a2$exports, "hydrateRoot", function () { return $931d92b7390d92a2$export$757ceba2d55c277e; }, function (v) { return $931d92b7390d92a2$export$757ceba2d55c277e = v; });
var $931d92b7390d92a2$export$882461b6382ed46c;
var $931d92b7390d92a2$export$757ceba2d55c277e;
"use strict";

var $hDjAY = parcelRequire("hDjAY");
var $931d92b7390d92a2$var$i;
$931d92b7390d92a2$export$882461b6382ed46c = $hDjAY.createRoot;
$931d92b7390d92a2$export$757ceba2d55c277e = $hDjAY.hydrateRoot;


parcelRequire("aFlA4");

var $esXub = parcelRequire("esXub");
parcelRequire("3aC2T");

var $awSZB = parcelRequire("awSZB");
var $cd5775156596c920$var$Style = {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    color: "red",
    textAlign: "center",
    backgroundImage: "linear-gradient(toBottom, rgba(238, 194, 174, 0) 0%, rgba(230, 99, 103, 0.1) 100%)"
};
var $cd5775156596c920$var$Error = function() {
    var err = (0, $awSZB.useRouteError)();
    console.log(err);
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        style: $cd5775156596c920$var$Style,
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("h1", {
                children: "OOPS..!!!"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("h2", {
                children: "Sorry, an unexpected error has occurred."
            }),
            /*#__PURE__*/ (0, $esXub.jsxs)("h3", {
                children: [
                    err === null || err === void 0 ? void 0 : err.status,
                    " : ",
                    (err === null || err === void 0 ? void 0 : err.statusText) || (err === null || err === void 0 ? void 0 : err.message)
                ]
            })
        ]
    });
};
var $cd5775156596c920$export$2e2bcd8739ae039 = $cd5775156596c920$var$Error;



var $2iBlG = parcelRequire("2iBlG");

var $esXub = parcelRequire("esXub");
parcelRequire("3aC2T");

var $kDFB6 = parcelRequire("kDFB6");
var $gSv8W = parcelRequire("gSv8W");
var $2wbWF = parcelRequire("2wbWF");

var $5y9cv = parcelRequire("5y9cv");

var $aEJlh = parcelRequire("aEJlh");

var $2CEgJ = parcelRequire("2CEgJ");
var $caebcc753253ca1a$exports = {};
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty($caebcc753253ca1a$exports, "__esModule", {
    value: true
});
$caebcc753253ca1a$exports["default"] = void 0;

var $caebcc753253ca1a$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
var $caebcc753253ca1a$var$_default = (0, $caebcc753253ca1a$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "m23 12-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z"
}), "Verified");
$caebcc753253ca1a$exports["default"] = $caebcc753253ca1a$var$_default;



var $a2coa = parcelRequire("a2coa");

var $aFlA4 = parcelRequire("aFlA4");
var $d96da18c7591b85f$exports = {};


$d96da18c7591b85f$exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("bd3o2");



var $gmJlE = parcelRequire("gmJlE");

var $dORbj = parcelRequire("dORbj");

var $e8017021171de205$var$MainContainer = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
    };
});
var $e8017021171de205$var$WelcomeBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "6rem",
        background: "linear-gradient(to right, #f32170, #ff6b08, #f32170, #cf23cf,#ff6b08, #f32170, #ff6b08)",
        WebkitTextFillColor: "transparent",
        WebkitBackgroundClip: "text"
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        marginTop: "6rem",
        textAlign: "center"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        marginTop: "10rem",
        textAlign: "center"
    }), _obj;
});
var $e8017021171de205$var$HeaderBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        justifyContent: "center",
        alignItems: "center",
        margin: "1rem 4rem",
        padding: "20px 0",
        boxShadow: "1px 1px 5px grey",
        borderRadius: "15px",
        "& > h2": {
            borderRadius: "5px",
            padding: "5px 20px",
            color: "rgb(211,47,47)",
            fontFamily: "Trebuchet MS"
        },
        "& p": {
            fontSize: "20px",
            fontFamily: "Trebuchet MS"
        }
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        margin: "1rem 0.5rem",
        padding: "10px 5px",
        "& p": {
            fontSize: "16px",
            textAlign: "center"
        }
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        margin: "1rem 3rem",
        padding: "10px 20px",
        "& p": {
            fontSize: "16px",
            textAlign: "center"
        }
    }), _obj;
});
var $e8017021171de205$var$Container = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
        marginTop: "15px"
    };
});
var $e8017021171de205$var$ImageBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
        "& img": (0, $2iBlG._)({
            borderRadius: "10px",
            width: "75vw",
            height: "80vh",
            marginBottom: "10px"
        }, theme.breakpoints.down("sm"), {
            width: "90vw",
            height: "50vh"
        })
    };
});
var $e8017021171de205$var$StoryBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
        "& p": {
            fontSize: "18px"
        }
    };
});
var $e8017021171de205$var$SubContainer = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        "& > div": {
            display: "flex",
            alignItems: "center",
            gap: "10px"
        },
        "& svg": {
            color: "#228B22"
        },
        "& p": {
            fontFamily: "Trebuchet MS",
            fontSize: "18px"
        }
    };
});
var $e8017021171de205$var$IconContainer = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        gap: "20px",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "2rem",
        "& > a:hover": {
            transform: "scale(1.2)",
            transition: "0.3s"
        }
    }, theme.breakpoints.down("sm"), {
        gap: "10px"
    });
});
var $e8017021171de205$var$About = function() {
    return /*#__PURE__*/ (0, $esXub.jsxs)((0, $esXub.Fragment), {
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)((0, $aFlA4.default), {}),
            /*#__PURE__*/ (0, $esXub.jsxs)($e8017021171de205$var$MainContainer, {
                children: [
                    /*#__PURE__*/ (0, $esXub.jsx)($e8017021171de205$var$WelcomeBox, {
                        children: /*#__PURE__*/ (0, $esXub.jsx)("h1", {
                            children: "WELCOME TO FOODIE ZONE!!!"
                        })
                    }),
                    /*#__PURE__*/ (0, $esXub.jsxs)($e8017021171de205$var$HeaderBox, {
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)($e8017021171de205$var$ImageBox, {
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, $dORbj.LazyLoadImage), {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d96da18c7591b85f$exports))),
                                    alt: "AboutImage",
                                    effect: "blur"
                                })
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("h2", {
                                children: "OUR STORY"
                            }),
                            /*#__PURE__*/ (0, $esXub.jsxs)($e8017021171de205$var$StoryBox, {
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                        children: "Everything we do is a celebration of fresh food - from how we source our restaurants and quality food"
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                        sx: {
                                            textAlign: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $esXub.jsx)("strong", {
                                            children: "to serving up new ways for you to enjoy it. Since, 2018 we've been  committed to"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                        children: "bringing you the best restaurants and food experience on our website you won't find anywhere else."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $esXub.jsxs)($e8017021171de205$var$Container, {
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsxs)($e8017021171de205$var$SubContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($caebcc753253ca1a$exports))), {}),
                                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                        children: [
                                                            "The Foodie Zone offers delivery of ",
                                                            /*#__PURE__*/ (0, $esXub.jsx)("strong", {
                                                                children: "delicious and healthy food."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($caebcc753253ca1a$exports))), {}),
                                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                        children: [
                                                            "Our focus is on satisfying hunger with tasty meals and quick, ",
                                                            /*#__PURE__*/ (0, $esXub.jsx)("strong", {
                                                                children: "free delivery."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($caebcc753253ca1a$exports))), {}),
                                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                        children: [
                                                            "Customers can order online and receive a ",
                                                            /*#__PURE__*/ (0, $esXub.jsx)("strong", {
                                                                children: " 40% discount "
                                                            }),
                                                            " on their orders."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($caebcc753253ca1a$exports))), {}),
                                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                        children: [
                                                            "The service combines ",
                                                            /*#__PURE__*/ (0, $esXub.jsx)("strong", {
                                                                children: "taste and health"
                                                            }),
                                                            " in its food offerings."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($caebcc753253ca1a$exports))), {}),
                                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                        children: [
                                                            "The emphasis is on ",
                                                            /*#__PURE__*/ (0, $esXub.jsx)("strong", {
                                                                children: "convenience, taste, and affordability"
                                                            }),
                                                            " for customers."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)($e8017021171de205$var$IconContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                                href: "https://www.instagram.com/o_n_k_a_r_0895/",
                                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5y9cv))), {
                                                    sx: {
                                                        cursor: "pointer",
                                                        color: "rgb(211,47,47)"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                                href: "https://github.com/onkar895/FOOD-ORDERING-APP",
                                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2CEgJ))), {
                                                    sx: {
                                                        cursor: "pointer",
                                                        color: "black"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                                href: "https://www.linkedin.com/in/omkarkarale541/",
                                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aEJlh))), {
                                                    sx: {
                                                        cursor: "pointer",
                                                        color: "#0A66C2"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                                href: "mailto:onkarkarale4@gmail.com",
                                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a2coa))), {
                                                    sx: {
                                                        cursor: "pointer",
                                                        color: "red"
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $esXub.jsx)((0, $gmJlE.default), {})
        ]
    });
};
var $e8017021171de205$export$2e2bcd8739ae039 = $e8017021171de205$var$About;



var $2iBlG = parcelRequire("2iBlG");

var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");

var $kDFB6 = parcelRequire("kDFB6");
var $5ODPG = parcelRequire("5ODPG");
var $1LxH8 = parcelRequire("1LxH8");
var $gSv8W = parcelRequire("gSv8W");
var $2wbWF = parcelRequire("2wbWF");

var $1YKKo = parcelRequire("1YKKo");
var $836f5e4fbad15525$exports = {};
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty($836f5e4fbad15525$exports, "__esModule", {
    value: true
});
$836f5e4fbad15525$exports["default"] = void 0;

var $836f5e4fbad15525$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
var $836f5e4fbad15525$var$_default = (0, $836f5e4fbad15525$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess");
$836f5e4fbad15525$exports["default"] = $836f5e4fbad15525$var$_default;



var $aFlA4 = parcelRequire("aFlA4");

var $jjHBq = parcelRequire("jjHBq");

var $esXub = parcelRequire("esXub");
parcelRequire("3aC2T");

var $kDFB6 = parcelRequire("kDFB6");
var $gSv8W = parcelRequire("gSv8W");
function $0219f1199a10954a$var$_templateObject() {
    var data = (0, $jjHBq._)([
        "\nwidth : 55.6%;\nheight : 50px;\nmargin: 7rem 0 0 18rem;\nbackground-color: #E5E4E2;\nborder-radius : 10px;\n"
    ]);
    $0219f1199a10954a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0219f1199a10954a$var$_templateObject1() {
    var data = (0, $jjHBq._)([
        "\ndisplay : flex;\ngap : 12px;\nflex-direction : column;\nmargin: 1.8rem 0 0 18rem;\n\n& > div {\nwidth : 72%;\nheight : 80px;\nbackground-color: #E5E4E2;\nborder-radius : 10px;\n}\n"
    ]);
    $0219f1199a10954a$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $0219f1199a10954a$var$HeaderBox = (0, $gSv8W.default)((0, $kDFB6.default))($0219f1199a10954a$var$_templateObject());
var $0219f1199a10954a$var$ShimmerBox = (0, $gSv8W.default)((0, $kDFB6.default))($0219f1199a10954a$var$_templateObject1());
var $0219f1199a10954a$var$MenuShimmer = function() {
    return /*#__PURE__*/ (0, $esXub.jsxs)((0, $esXub.Fragment), {
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)($0219f1199a10954a$var$HeaderBox, {}),
            /*#__PURE__*/ (0, $esXub.jsx)($0219f1199a10954a$var$ShimmerBox, {
                children: // creating a new Array instance using Array() constructor and map through every element of array 
                Array(10).fill("").map(function(_, index) {
                    return /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {}, index);
                })
            })
        ]
    });
};
var $0219f1199a10954a$export$2e2bcd8739ae039 = $0219f1199a10954a$var$MenuShimmer;


var $2cc2d768f59ae211$exports = {};
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty($2cc2d768f59ae211$exports, "__esModule", {
    value: true
});
$2cc2d768f59ae211$exports["default"] = void 0;

var $2cc2d768f59ae211$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
var $2cc2d768f59ae211$var$_default = (0, $2cc2d768f59ae211$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");
$2cc2d768f59ae211$exports["default"] = $2cc2d768f59ae211$var$_default;



var $gmJlE = parcelRequire("gmJlE");

var $94Cx1 = parcelRequire("94Cx1");
var $c387bc3d5bf0a3b2$var$MainContainer = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
        paddingBottom: theme.spacing(0)
    };
});
var $c387bc3d5bf0a3b2$var$MainBox = (0, $gSv8W.default)((0, $1LxH8.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        width: "80%",
        margin: "8rem auto",
        padding: theme.spacing(4),
        boxShadow: "0 0 4px 0 grey",
        borderRadius: "10px",
        backgroundImage: "linear-gradient(to left, rgba(238, 194, 174, 0) 0%, rgba(230, 99, 103, 0.1) 100%)"
    }, theme.breakpoints.down("sm"), {
        width: "95%",
        margin: "6rem auto",
        padding: theme.spacing(0.5)
    });
});
var $c387bc3d5bf0a3b2$var$ContentBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        flexDirection: "column",
        gap: "2rem"
    }, theme.breakpoints.down("sm"), {
        padding: theme.spacing(2)
    });
});
var $c387bc3d5bf0a3b2$var$HeadingBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "2rem",
        "& > p": {
            fontWeight: "bold",
            fontSize: "2rem"
        }
    }, theme.breakpoints.down("sm"), {
        justifyContent: "start",
        "& > p": {
            fontWeight: "bold",
            fontSize: "1.2rem"
        }
    });
});
var $c387bc3d5bf0a3b2$var$TitleBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        "& > p": {
            fontSize: "16px",
            fontWeight: "bold"
        }
    }, theme.breakpoints.down("sm"), {
        "& > p": {
            fontSize: "14px",
            fontWeight: "bold"
        }
    });
});
var $c387bc3d5bf0a3b2$var$InfoBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        border: "1.3px solid rgb(208,208,208)",
        borderRadius: "6.5px",
        padding: theme.spacing(3)
    }, theme.breakpoints.down("sm"), {
        padding: theme.spacing(2)
    });
});
var $c387bc3d5bf0a3b2$var$DropDownContent = (0, $gSv8W.default)((0, $kDFB6.default))({
    "& > p": {
        fontFamily: "Trebuchet MS",
        color: "grey",
        textAlign: "justify",
        fontSize: "14px"
    }
});
var $c387bc3d5bf0a3b2$var$Help = function() {
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(null), 2), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var handleClick = function(index) {
        setActiveIndex(activeIndex === index ? null : index);
    };
    if (!(0, $94Cx1.FAQ)) return /*#__PURE__*/ (0, $esXub.jsx)((0, $0219f1199a10954a$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $esXub.jsxs)((0, $esXub.Fragment), {
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)((0, $aFlA4.default), {}),
            /*#__PURE__*/ (0, $esXub.jsx)($c387bc3d5bf0a3b2$var$MainContainer, {
                children: (0, $94Cx1.FAQ) && /*#__PURE__*/ (0, $esXub.jsx)($c387bc3d5bf0a3b2$var$MainBox, {
                    children: /*#__PURE__*/ (0, $esXub.jsxs)($c387bc3d5bf0a3b2$var$ContentBox, {
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsxs)($c387bc3d5bf0a3b2$var$HeadingBox, {
                                sx: {
                                    display: "flex",
                                    gap: "6px",
                                    alignItems: "center",
                                    textAlign: "start",
                                    color: "rgb(211,47,47)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                        children: "WE ARE ALWAYS READY TO HELP"
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2cc2d768f59ae211$exports))), {
                                        sx: {
                                            fontSize: "36px"
                                        }
                                    })
                                ]
                            }),
                            (0, $94Cx1.FAQ).map(function(item, index) {
                                return (item.description || item.hyperLink) && /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                                    children: /*#__PURE__*/ (0, $esXub.jsxs)($c387bc3d5bf0a3b2$var$InfoBox, {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsxs)($c387bc3d5bf0a3b2$var$TitleBox, {
                                                onClick: function() {
                                                    return handleClick(index);
                                                },
                                                sx: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                        children: item.title
                                                    }),
                                                    activeIndex !== index && /*#__PURE__*/ (0, $esXub.jsx)((0, $5ODPG.default), {
                                                        color: "error",
                                                        children: activeIndex ? /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($836f5e4fbad15525$exports))), {}) : /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1YKKo))), {})
                                                    })
                                                ]
                                            }),
                                            activeIndex === index && /*#__PURE__*/ (0, $esXub.jsxs)($c387bc3d5bf0a3b2$var$DropDownContent, {
                                                children: [
                                                    item.description && /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                        children: item.description
                                                    }),
                                                    item.hyperLink && /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                                            href: "#",
                                                            style: {
                                                                color: "rgb(211,47,47)"
                                                            },
                                                            children: item.hyperLink
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, item.title);
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $esXub.jsx)((0, $gmJlE.default), {})
        ]
    });
};
var $c387bc3d5bf0a3b2$export$2e2bcd8739ae039 = $c387bc3d5bf0a3b2$var$Help;



var $5Pgs2 = parcelRequire("5Pgs2");

var $aSMts = parcelRequire("aSMts");

var $1XfpH = parcelRequire("1XfpH");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");

var $52eXO = parcelRequire("52eXO");
var $kDFB6 = parcelRequire("kDFB6");
var $5ODPG = parcelRequire("5ODPG");
var $bTE2V = parcelRequire("bTE2V");
var $c67v1 = parcelRequire("c67v1");
var $2wbWF = parcelRequire("2wbWF");

var $4ghiA = parcelRequire("4ghiA");
var $3e6f407db5c0f137$export$c42cff54156f85d7 = function(email, password) {
    var isEmailValid = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/.test(email);
    var isPasswordValid = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);
    if (!isEmailValid) return "Please enter a valid email address.";
    if (!isPasswordValid) return "Password must contain at least 8 characters, including at least one uppercase letter, one lowercase letter, one number and special character";
    return null;
};



var $kDmJt = parcelRequire("kDmJt");

var $ar9jW = parcelRequire("ar9jW");
parcelRequire("l2BLr");
var $qmPZq = parcelRequire("qmPZq");

var $9yM65 = parcelRequire("9yM65");

parcelRequire("5WuyH");
var $awSZB = parcelRequire("awSZB");
var $665799726d32642b$exports = {};


$665799726d32642b$exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("5VhnP");


var $70dae381c49ae809$exports = {};


$70dae381c49ae809$exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("1XKxr");


var $a203d1322fa69753$exports = {};


$a203d1322fa69753$exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("3Rzl0");



var $3a02b22c69e152bc$exports = {};
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty($3a02b22c69e152bc$exports, "__esModule", {
    value: true
});
$3a02b22c69e152bc$exports["default"] = void 0;

var $3a02b22c69e152bc$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
var $3a02b22c69e152bc$var$_default = (0, $3a02b22c69e152bc$var$_createSvgIcon["default"])([
    /*#__PURE__*/ (0, $esXub.jsx)("circle", {
        cx: "15.5",
        cy: "9.5",
        r: "1.5"
    }, "0"),
    /*#__PURE__*/ (0, $esXub.jsx)("circle", {
        cx: "8.5",
        cy: "9.5",
        r: "1.5"
    }, "1"),
    /*#__PURE__*/ (0, $esXub.jsx)("circle", {
        cx: "15.5",
        cy: "9.5",
        r: "1.5"
    }, "2"),
    /*#__PURE__*/ (0, $esXub.jsx)("circle", {
        cx: "8.5",
        cy: "9.5",
        r: "1.5"
    }, "3"),
    /*#__PURE__*/ (0, $esXub.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-2.5c2.33 0 4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2s-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5z"
    }, "4")
], "SentimentSatisfiedAlt");
$3a02b22c69e152bc$exports["default"] = $3a02b22c69e152bc$var$_default;




var $3c2b0b24dcc89550$exports = {};
"use strict";
"use client";

var $iJeGA = parcelRequire("iJeGA");
Object.defineProperty($3c2b0b24dcc89550$exports, "__esModule", {
    value: true
});
$3c2b0b24dcc89550$exports["default"] = void 0;

var $3c2b0b24dcc89550$var$_createSvgIcon = $iJeGA((parcelRequire("66GhS")));

var $esXub = parcelRequire("esXub");
var $3c2b0b24dcc89550$var$_default = (0, $3c2b0b24dcc89550$var$_createSvgIcon["default"])(/*#__PURE__*/ (0, $esXub.jsx)("path", {
    d: "M17 1H7c-1.1 0-1.99.85-1.99 1.95v18C5.01 22.05 5.9 23 7 23h10c1.1 0 2-.95 2-2.05v-18C19 1.85 18.1 1 17 1zm0 18H7V5h10v14zm-4.2-5.76v1.75L16 12l-3.2-2.98v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
}), "MobileScreenShareOutlined");
$3c2b0b24dcc89550$exports["default"] = $3c2b0b24dcc89550$var$_default;



var $2iBlG = parcelRequire("2iBlG");

var $kDFB6 = parcelRequire("kDFB6");
var $5ODPG = parcelRequire("5ODPG");
var $3Dkss = parcelRequire("3Dkss");
var $1LxH8 = parcelRequire("1LxH8");
var $gSv8W = parcelRequire("gSv8W");
var $5WdIT = parcelRequire("5WdIT");
var $f37ca684952ddbda$export$a0d9662ebc657c0c = (0, $gSv8W.default)((0, $5WdIT.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "14vh",
        backgroundColor: "#ffffff",
        backgroundImage: "linear-gradient(to bottom, rgba(238,194,174,0) 0%, rgba(230,99,103,0.1) 100%)"
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        height: "10vh",
        backgroundImage: "linear-gradient(to bottom, rgba(238,194,174,0) 0%, rgba(230,99,103,0.1) 100%)"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        height: "12vh"
    }), _obj;
});
var $f37ca684952ddbda$export$9dbabbc541f56009 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        backgroundColor: "#ffffff",
        backgroundImage: "linear-gradient(to top, rgba(238,194,174,0) 0%, rgba(230,99,103,0.1) 100%)",
        position: "fixed",
        width: "100vw",
        height: "100vh"
    }, theme.breakpoints.between("sm", "md"), {
        position: "static"
    });
});
var $f37ca684952ddbda$export$568aa225dd6161e3 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return (0, $2iBlG._)({
        display: "flex",
        alignItems: "center",
        gap: "20px",
        marginLeft: "38px",
        "& > img": (_obj = {
            cursor: "pointer",
            background: "none",
            width: "5vw"
        }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
            width: "12vw"
        }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
            width: "8vw"
        }), _obj)
    }, theme.breakpoints.down("sm"), {
        margin: "10px auto"
    });
});
var $f37ca684952ddbda$export$b4e5e09251522c2c = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj, _obj1, _obj2;
    return _obj2 = {
        display: "flex",
        flexDirection: "column",
        "& > p": (_obj = {
            fontFamily: "Trebuchet MS",
            fontSize: "26px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder"
        }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
            fontFamily: "Trebuchet MS",
            fontSize: "18px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder"
        }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
            fontFamily: "Trebuchet MS",
            fontSize: "32px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder"
        }), _obj),
        "& > p:nth-child(2)": (_obj1 = {
            fontFamily: "Trebuchet MS",
            fontSize: "12px",
            marginLeft: "3rem",
            marginBottom: "6px",
            color: "rgb(211,47,47)",
            fontWeight: "bolder"
        }, (0, $2iBlG._)(_obj1, theme.breakpoints.down("sm"), {
            marginLeft: "1rem"
        }), (0, $2iBlG._)(_obj1, theme.breakpoints.between("sm", "md"), {
            marginLeft: "4rem"
        }), _obj1)
    }, (0, $2iBlG._)(_obj2, theme.breakpoints.down("sm"), {
        width: "40vw"
    }), (0, $2iBlG._)(_obj2, theme.breakpoints.between("sm", "md"), {
        width: "60vw"
    }), _obj2;
});
var $f37ca684952ddbda$export$698668688a6e8f34 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        gap: "2rem",
        marginRight: "2.4rem",
        "& > ul": {
            display: "flex",
            alignItems: "center",
            gap: "2rem",
            color: "black",
            fontWeight: "bold",
            fontSize: "16px",
            listStyleType: "none"
        }
    }, theme.breakpoints.down("sm"), {
        margin: "10px auto"
    });
});
var $f37ca684952ddbda$export$5e37f977ae0514c2 = (0, $gSv8W.default)((0, $5ODPG.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        padding: "3px 15px",
        alignItems: "center",
        cursor: "pointer",
        border: "1.5px solid rgb(211,47,47)",
        textTransform: "capitalize",
        fontWeight: "bold",
        "&:hover": {
            background: "rgb(211,47,47)",
            color: "white",
            boxShadow: "3px 3px 6px rgb(211,47,47)"
        }
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        padding: "3px 12px",
        margin: "3rem"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        padding: "6px 20px",
        marginLeft: "3rem"
    }), _obj;
});
var $f37ca684952ddbda$export$17cf5552e668a4ed = (0, $gSv8W.default)((0, $5ODPG.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontFamily: "Trebuchet MS",
        background: "white",
        color: "black",
        padding: "8px",
        textTransform: "capitalize",
        "& p": {
            fontSize: "15px",
            fontWeight: "bolder"
        },
        "&:hover": {
            background: "white",
            color: "black"
        },
        "& > img": {
            width: "2vw"
        }
    }, theme.breakpoints.down("sm"), {
        padding: "12px",
        "& p": {
            fontSize: "12px"
        },
        "& > img": {
            width: "5vw"
        }
    });
});
var $f37ca684952ddbda$export$6a1570a405c3c095 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        color: "rgb(211,47,47)",
        gap: "2px",
        fontWeight: "bolder",
        "& > svg": {
            fontSize: "25px",
            color: "rgb(211,47,47)",
            cursor: "pointer"
        }
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        display: "none"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        display: "none"
    }), _obj;
});
var $f37ca684952ddbda$export$d63af35ad2e48287 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        gap: "2px",
        "& > a": {
            textDecoration: "none",
            color: "rgb(211,47,47)"
        },
        "& > svg": {
            fontSize: "25px",
            color: "rgb(211,47,47)",
            cursor: "pointer"
        }
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        display: "none"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        display: "none"
    }), _obj;
});
var $f37ca684952ddbda$export$7f1044b3738ac27d = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        "& > svg": {
            marginBottom: "3px",
            fontSize: "28px",
            color: "rgb(211,47,47)",
            cursor: "pointer"
        }
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        display: "none"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        display: "none"
    }), _obj;
});
var $f37ca684952ddbda$export$d653589df987fd93 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "3.5%"
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        marginTop: "30%"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        marginTop: "30%"
    }), _obj;
});
var $f37ca684952ddbda$export$68a3906f6694d512 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "100vh",
        "& > img": {
            width: "45%",
            height: "auto"
        }
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        flexDirection: "column-reverse",
        minHeight: "100vh",
        gap: "3rem",
        "& img": {
            width: "100%",
            height: "auto"
        }
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        flexDirection: "column-reverse",
        "& img": {
            width: "100%",
            height: "auto",
            marginTop: "4.5rem"
        }
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("md", "lg"), {
        width: "90%",
        minHeight: "80vh"
    }), _obj;
});
var $f37ca684952ddbda$export$16223cbffe6527a6 = (0, $gSv8W.default)((0, $1LxH8.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "3rem",
        justifyContent: "center",
        width: "28%",
        backgroundColor: "rgba(0,0,0,0.4)",
        height: "85vh",
        filter: "drop-shadow(2px 2px 6px black)",
        borderRadius: "10px"
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        width: "90%",
        height: "auto",
        padding: "2rem"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        width: "50%",
        height: "auto",
        padding: "2rem"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("md", "lg"), {
        width: "50%",
        height: "50vh",
        margin: "10rem auto",
        padding: "2rem"
    }), _obj;
});
var $f37ca684952ddbda$export$8b251419efc915eb = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        fontFamily: "Trebuchet MS",
        marginRight: "35px",
        "& > p": {
            color: "darkgray",
            fontFamily: "Trebuchet MS",
            fontSize: "12px"
        }
    }, theme.breakpoints.down("sm"), {
        margin: "10px auto"
    });
});
var $f37ca684952ddbda$export$5ac7b85d728a3568 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",
        gap: "1rem",
        width: "80%",
        "& input": {
            fontSize: "12.5px",
            color: "white",
            border: "1px solid white",
            borderRadius: "5px",
            "&:hover": {
                borderBottom: "2px solid white"
            }
        },
        "& > h3": {
            color: "white"
        },
        "& label": {
            color: "darkgray",
            fontSize: "14px",
            fontFamily: "Trebuchet MS"
        },
        "& p": {
            fontFamily: "Trebuchet MS",
            fontSize: "12px",
            cursor: "pointer"
        }
    }, theme.breakpoints.down("sm"), {
        width: "100%"
    });
});
var $f37ca684952ddbda$export$9baf404e9c6f7a66 = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        gap: "10px"
    };
});
var $f37ca684952ddbda$export$45a71fef754c4939 = (0, $gSv8W.default)((0, $3Dkss.default))(function(param) {
    var theme = param.theme;
    return {
        fontFamily: "Trebuchet MS",
        cursor: "pointer",
        fontWeight: "bolder",
        fontSize: "12px",
        color: "darkgray",
        textDecoration: "none",
        marginTop: "0.5rem",
        "&:hover": {
            color: "white"
        }
    };
});



var $dORbj = parcelRequire("dORbj");

var $f9c69a81ca4441d0$var$Login = function() {
    var _useContext = (0, $3aC2T.useContext)((0, $4ghiA.default)), setUserName = _useContext.setUserName, loggedInUser = _useContext.loggedInUser, userName = _useContext.userName;
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(true), 2), isSignIn = _useState[0], setIsSignIn = _useState[1];
    var _useState1 = (0, $aSMts._)((0, $3aC2T.useState)(""), 2), errMessage = _useState1[0], setErrMessage = _useState1[1];
    var _useState2 = (0, $aSMts._)((0, $3aC2T.useState)(false), 2), open = _useState2[0], setOpen = _useState2[1];
    var navigate = (0, $awSZB.useNavigate)();
    var email = (0, $3aC2T.useRef)(null);
    var password = (0, $3aC2T.useRef)(null);
    var handleUserNameChange = function(e) {
        setUserName(e.target.value);
    };
    var handleOpen = function() {
        return setOpen(true);
    };
    var handleClose = function() {
        return setOpen(false);
    };
    var handleClick = function() {
        var _ref = (0, $5Pgs2._)(function(e) {
            var message, err, err1;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        message = (0, $3e6f407db5c0f137$export$c42cff54156f85d7)(email.current.value, password.current.value);
                        setErrMessage(message);
                        if (message) return [
                            2
                        ];
                        if (!!isSignIn) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $qmPZq.a9)((0, $ar9jW.firebaseAuth), email.current.value, password.current.value)
                        ];
                    case 2:
                        _state.sent();
                        navigate("/");
                        (0, $9yM65.toast).success(/*#__PURE__*/ (0, $esXub.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $esXub.jsx)("div", {
                                    style: {
                                        fontSize: "14px",
                                        textAlign: "center",
                                        color: "black"
                                    },
                                    children: /*#__PURE__*/ (0, $esXub.jsx)("strong", {
                                        children: "Congratulations! Your account has been successfully created."
                                    })
                                }),
                                /*#__PURE__*/ (0, $esXub.jsx)("div", {
                                    style: {
                                        fontSize: "12px",
                                        textAlign: "center",
                                        color: "rgb(211,47,47)",
                                        fontWeight: "bold",
                                        marginTop: "10px"
                                    },
                                    children: /*#__PURE__*/ (0, $esXub.jsx)("strong", {
                                        children: 'Click on the "Sign In Now" below to Sign In.'
                                    })
                                })
                            ]
                        }), {
                            position: "top-center",
                            newestOnTop: true,
                            autoClose: 2000,
                            closeButton: true,
                            closeOnClick: true,
                            pauseOnHover: true
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setErrMessage(err.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            8
                        ];
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            (0, $qmPZq.aa)((0, $ar9jW.firebaseAuth), email.current.value, password.current.value)
                        ];
                    case 6:
                        _state.sent();
                        navigate("/home");
                        return [
                            3,
                            8
                        ];
                    case 7:
                        err1 = _state.sent();
                        setErrMessage(err1.message);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleGoogleSignIn = function() {
        var _ref = (0, $5Pgs2._)(function(e) {
            var error;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $qmPZq.c)((0, $ar9jW.firebaseAuth), (0, $ar9jW.provider))
                        ];
                    case 2:
                        _state.sent();
                        navigate("/home");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleGoogleSignIn(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleSignInForm = function() {
        setIsSignIn(!isSignIn);
    };
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $esXub.Fragment), {
        children: /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$9dbabbc541f56009), {
            children: [
                /*#__PURE__*/ (0, $esXub.jsx)((0, $52eXO.default), {
                    sx: {
                        boxShadow: "none"
                    },
                    children: /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$a0d9662ebc657c0c), {
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$568aa225dd6161e3), {
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($kDmJt))),
                                        alt: "FoodLogo",
                                        onClick: function() {
                                            return navigate("/");
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$b4e5e09251522c2c), {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                children: "Zra Foods"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                children: "Taste of Everything"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)((0, $f37ca684952ddbda$export$698668688a6e8f34), {
                                children: /*#__PURE__*/ (0, $esXub.jsx)("ul", {
                                    children: /*#__PURE__*/ (0, $esXub.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$d63af35ad2e48287), {
                                            children: [
                                                /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3c2b0b24dcc89550$exports))), {}),
                                                /*#__PURE__*/ (0, $esXub.jsx)("a", {
                                                    href: "https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader",
                                                    children: "Get The App"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$68a3906f6694d512), {
                    children: [
                        /*#__PURE__*/ (0, $esXub.jsx)((0, $dORbj.LazyLoadImage), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($665799726d32642b$exports))),
                            alt: "FoodImage",
                            effect: "blur"
                        }),
                        /*#__PURE__*/ (0, $esXub.jsx)((0, $dORbj.LazyLoadImage), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a203d1322fa69753$exports))),
                            alt: "Image",
                            effect: "blur"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $esXub.jsx)((0, $bTE2V.default), {
                    open: open,
                    onClose: handleClose,
                    "aria-labelledby": "modal-modal-title",
                    "aria-describedby": "modal-modal-description",
                    children: /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$d653589df987fd93), {
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$16223cbffe6527a6), {
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$8b251419efc915eb), {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    color: "white"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)("h2", {
                                                        children: "Welcome Back"
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a02b22c69e152bc$exports))), {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                children: isSignIn ? "Sign In with your email address and password" : "Sign Up with your email address and password"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$5ac7b85d728a3568), {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)("h3", {
                                                children: isSignIn ? "Sign In" : "Sign Up"
                                            }),
                                            !isSignIn && /*#__PURE__*/ (0, $esXub.jsx)((0, $c67v1.default), {
                                                type: "text",
                                                variant: "filled",
                                                color: "warning",
                                                label: "UserName",
                                                required: true,
                                                fullWidth: true,
                                                value: userName,
                                                onChange: handleUserNameChange
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $c67v1.default), {
                                                inputRef: email,
                                                type: "email",
                                                variant: "filled",
                                                color: "warning",
                                                label: "Email",
                                                required: true,
                                                fullWidth: true
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $c67v1.default), {
                                                inputRef: password,
                                                type: "password",
                                                color: "warning",
                                                variant: "filled",
                                                label: "Password",
                                                required: true,
                                                fullWidth: true
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                sx: {
                                                    color: "red",
                                                    fontSize: "14px",
                                                    fontFamily: "Trebuchet MS",
                                                    fontWeight: "bold"
                                                },
                                                children: errMessage
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $5ODPG.default), {
                                                sx: {
                                                    fontFamily: "Trebuchet MS",
                                                    padding: "8px 0"
                                                },
                                                variant: "contained",
                                                size: "medium",
                                                color: "error",
                                                required: true,
                                                fullWidth: true,
                                                onClick: handleClick,
                                                children: isSignIn ? "Sign In" : "Sign Up"
                                            }),
                                            isSignIn && /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                                                sx: {
                                                    color: "white"
                                                },
                                                children: /*#__PURE__*/ (0, $esXub.jsx)("h5", {
                                                    children: "OR Sign In Using"
                                                })
                                            }),
                                            isSignIn && /*#__PURE__*/ (0, $esXub.jsxs)((0, $f37ca684952ddbda$export$17cf5552e668a4ed), {
                                                onClick: handleGoogleSignIn,
                                                fullWidth: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($70dae381c49ae809$exports))),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                        children: "Sign In With Google"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $f37ca684952ddbda$export$9baf404e9c6f7a66), {
                                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, $f37ca684952ddbda$export$45a71fef754c4939), {
                                                    onClick: toggleSignInForm,
                                                    children: isSignIn ? "New User? Sign Up Now" : "Already Registered? Sign In Now"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)((0, $9yM65.ToastContainer), {})
                        ]
                    })
                })
            ]
        })
    });
};
var $f9c69a81ca4441d0$export$2e2bcd8739ae039 = $f9c69a81ca4441d0$var$Login;



var $2iBlG = parcelRequire("2iBlG");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");

var $kDFB6 = parcelRequire("kDFB6");
var $5ODPG = parcelRequire("5ODPG");
var $gSv8W = parcelRequire("gSv8W");
var $2wbWF = parcelRequire("2wbWF");

var $2iBlG = parcelRequire("2iBlG");

var $esXub = parcelRequire("esXub");
parcelRequire("3aC2T");

var $kDFB6 = parcelRequire("kDFB6");
var $5ODPG = parcelRequire("5ODPG");
var $gSv8W = parcelRequire("gSv8W");
var $2wbWF = parcelRequire("2wbWF");
parcelRequire("ez2pC");
var $2wq0j = parcelRequire("2wq0j");
parcelRequire("5WuyH");
var $awSZB = parcelRequire("awSZB");

var $gWZ9M = parcelRequire("gWZ9M");

var $9yM65 = parcelRequire("9yM65");


var $94Cx1 = parcelRequire("94Cx1");
var $0d438dbd68fee6ca$exports = {};


$0d438dbd68fee6ca$exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("gsu29");


var $ed0ee006661997e8$var$HeaderBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        alignItems: "start",
        gap: theme.spacing(6),
        marginLeft: theme.spacing(6)
    }, theme.breakpoints.down("sm"), {
        flexDirection: "column",
        gap: theme.spacing(4),
        marginLeft: 0,
        alignItems: "center"
    });
});
var $ed0ee006661997e8$var$MainContainer = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(3),
        width: "45vw",
        padding: theme.spacing(3),
        boxShadow: "0 0 4px 0 rgba(208,208,208,0.8)"
    }, theme.breakpoints.down("sm"), {
        flexDirection: "column",
        width: "96vw",
        gap: "30px",
        padding: "15px 5px"
    });
});
var $ed0ee006661997e8$var$CardContent = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        flexDirection: "column",
        gap: "10px"
    }, theme.breakpoints.down("sm"), {
        gap: "5px"
    });
});
var $ed0ee006661997e8$var$PriceBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        gap: "10px",
        alignItems: "center",
        "& h6": {
            fontWeight: "bold",
            color: "red",
            backgroundColor: "rgba(211,47,47,0.1)",
            padding: "2px 5px",
            "& > span": {
                fontSize: "10px"
            }
        }
    }, theme.breakpoints.down("sm"), {
        flexDirection: "column",
        alignItems: "start",
        "& h6": {
            fontSize: "10px",
            "& > span": {
                fontSize: "10px"
            }
        }
    });
});
var $ed0ee006661997e8$var$MenuImageBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        "& > img": (0, $2iBlG._)({
            objectFit: "cover",
            borderRadius: "5px",
            width: "10vw",
            height: "15vh"
        }, theme.breakpoints.down("sm"), {
            width: "40vw",
            height: "12vh"
        })
    };
});
var $ed0ee006661997e8$var$_obj;
var $ed0ee006661997e8$var$RemoveItemBox = (0, $gSv8W.default)((0, $kDFB6.default))(($ed0ee006661997e8$var$_obj = {
    cursor: "pointer",
    marginLeft: "1.5rem",
    color: "grey"
}, (0, $2iBlG._)($ed0ee006661997e8$var$_obj, "color", "rgb(211,47,47)"), (0, $2iBlG._)($ed0ee006661997e8$var$_obj, "fontWeight", 500), $ed0ee006661997e8$var$_obj));
var $ed0ee006661997e8$var$ButtonBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        gap: "10px",
        fontWeight: "bold",
        margin: "0 auto",
        "& button:nth-child(1)": {
            fontFamily: "Trebuchet MS",
            textTransform: "capitalize",
            backgroundColor: "rgba(55,118,210,0.1)",
            "&:hover": {
                color: "white",
                backgroundColor: "rgb(55,118,210)",
                fontWeight: "bold"
            }
        },
        "& button:nth-child(2)": {
            fontFamily: "Trebuchet MS",
            textTransform: "capitalize",
            backgroundColor: "rgba(211,47,47,0.1)",
            padding: "5px 38px",
            "&:hover": {
                color: "white",
                fontWeight: "bold",
                backgroundColor: "rgb(211,47,47)"
            }
        }
    }, theme.breakpoints.down("sm"), {
        gap: "20px",
        margin: "0 auto",
        "& button:nth-child(2)": {
            padding: "6px 30px"
        }
    });
});
var $ed0ee006661997e8$var$ImgBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({}, theme.breakpoints.down("sm"), {});
});
var $ed0ee006661997e8$var$InfoBox = (0, $gSv8W.default)((0, $kDFB6.default))({
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    margin: "10px 0",
    borderTop: "1px solid lightgray",
    borderBottom: "1px solid lightgray",
    padding: "10px 0 15px 0",
    "& > div": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        color: "#71797E",
        "& p": {
            fontFamily: "Trebuchet MS",
            fontSize: "14px",
            color: "black"
        },
        "& h4": {
            fontFamily: "Trebuchet MS",
            color: "black"
        },
        "& span": {
            fontSize: "13px",
            color: "rgb(211,47,47)"
        }
    }
});
var $ed0ee006661997e8$var$TotalBox = (0, $gSv8W.default)((0, $kDFB6.default))({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 0 15px 0",
    borderBottom: "1px solid lightgray",
    "& h3": {
        fontFamily: "Trebuchet MS"
    }
});
var $ed0ee006661997e8$var$SummaryContainer = (0, $gSv8W.default)((0, $kDFB6.default))({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "20px"
});
var $ed0ee006661997e8$var$Container = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        padding: theme.spacing(3),
        width: "28vw",
        boxShadow: "0 0 6px 0 rgba(208,208,208,0.8)",
        height: "60vh"
    }, theme.breakpoints.down("sm"), {
        width: "98vw"
    });
});
var $ed0ee006661997e8$var$CartItemList = function(param) {
    var items = param.items;
    var dispatch = (0, $2wq0j.useDispatch)();
    var navigate = (0, $awSZB.useNavigate)();
    var handleRemove = function(item) {
        dispatch((0, $gWZ9M.removeItem)({
            item: item
        })) ? (0, $9yM65.toast).success("Removed from Cart", {
            position: "top-center",
            newestOnTop: true,
            autoClose: 1000
        }) : (0, $9yM65.toast).error("Not Removed", {
            position: "top-center",
            newestOnTop: true,
            autoClose: 1000
        });
    };
    var handleClearCart = function() {
        dispatch((0, $gWZ9M.clearCart)()) ? (0, $9yM65.toast).success("All Items Removed", {
            position: "top-center",
            newestOnTop: true,
            autoClose: 1000
        }) : (0, $9yM65.toast).error("Items Not Removed", {
            position: "top-center",
            newestOnTop: true,
            autoClose: 1000
        });
    };
    var handleClick = function() {
        (0, $9yM65.toast).success("Order Placed Successfully", {
            position: "top-center",
            newestOnTop: true,
            autoClose: 5000
        });
    };
    var TotalAmount = items.length > 0 ? items.map(function(x) {
        return x.card.info.price > 0 ? x.card.info.price / 100 : x.card.info.defaultPrice / 100;
    }).reduce(function(sum, a) {
        return sum + a;
    }, 0) : 0;
    var DeliveryCharges = TotalAmount * 0.5 / 10;
    var Discount = TotalAmount * 10 / 100;
    var FinalAmount = TotalAmount + DeliveryCharges - Discount;
    return /*#__PURE__*/ (0, $esXub.jsxs)((0, $esXub.Fragment), {
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                variant: "h4",
                style: {
                    textAlign: "center",
                    marginBottom: "1rem",
                    color: "rgb(211,47,47)"
                },
                children: "Cart"
            }),
            /*#__PURE__*/ (0, $esXub.jsxs)($ed0ee006661997e8$var$HeaderBox, {
                children: [
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                        children: items && items.map(function(item) {
                            return /*#__PURE__*/ (0, $esXub.jsxs)($ed0ee006661997e8$var$MainContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsxs)($ed0ee006661997e8$var$ImgBox, {
                                        sx: {
                                            display: "flex",
                                            gap: "20px",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)($ed0ee006661997e8$var$MenuImageBox, {
                                                children: /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                                    src: item.card.info.imageId ? (0, $94Cx1.SWIGGY_MENU_IMG_API) + item.card.info.imageId : (0, (/*@__PURE__*/$parcel$interopDefault($0d438dbd68fee6ca$exports))),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)($ed0ee006661997e8$var$CardContent, {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                            sx: {
                                                                fontFamily: "Trebuchet MS"
                                                            },
                                                            children: item.card.info.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsxs)($ed0ee006661997e8$var$PriceBox, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                                sx: {
                                                                    fontFamily: "Trebuchet MS"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $esXub.jsx)("strong", {
                                                                        children: "Price :"
                                                                    }),
                                                                    " ₹ ",
                                                                    (item.card.info.price / 100 || item.card.info.defaultPrice / 100).toFixed(2)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                                variant: "subtitle2",
                                                                children: [
                                                                    "50% OFF | ",
                                                                    /*#__PURE__*/ (0, $esXub.jsx)("span", {
                                                                        children: "USE FOODIEIT"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, item.card.info.id)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsx)($ed0ee006661997e8$var$RemoveItemBox, {
                                        onClick: function() {
                                            return handleRemove(item);
                                        },
                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                            variant: "body2",
                                            children: /*#__PURE__*/ (0, $esXub.jsx)("strong", {
                                                children: "Remove"
                                            })
                                        })
                                    })
                                ]
                            }, item.card.info.id);
                        })
                    }),
                    /*#__PURE__*/ (0, $esXub.jsxs)($ed0ee006661997e8$var$SummaryContainer, {
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsxs)($ed0ee006661997e8$var$Container, {
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                                        sx: {
                                            textAlign: "center",
                                            fontWeight: "bolder"
                                        },
                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                            variant: "h5",
                                            children: "Order Summary"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)($ed0ee006661997e8$var$InfoBox, {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                        variant: "body1",
                                                        children: [
                                                            "Price: (",
                                                            items.length,
                                                            " Items)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                        variant: "h6",
                                                        children: "₹ ".concat(parseFloat(TotalAmount).toFixed(2))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                        variant: "body1",
                                                        children: "Discount (10%):"
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                        variant: "h6",
                                                        children: [
                                                            "- ₹ ",
                                                            parseFloat(Discount).toFixed(2)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $kDFB6.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                        variant: "body1",
                                                        children: "Delivery Charges (5%):"
                                                    }),
                                                    /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                        variant: "h6",
                                                        children: [
                                                            "+ ₹ ",
                                                            parseFloat(DeliveryCharges).toFixed(2)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                                                children: /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                    children: [
                                                        "You have saved ",
                                                        /*#__PURE__*/ (0, $esXub.jsxs)("strong", {
                                                            children: [
                                                                "₹ ",
                                                                parseFloat(Discount).toFixed(2)
                                                            ]
                                                        }),
                                                        " on this order \uD83D\uDE0A"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)($ed0ee006661997e8$var$TotalBox, {
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                variant: "h6",
                                                sx: {
                                                    fontFamily: "Trebuchet MS"
                                                },
                                                children: "Total Amount :"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)((0, $2wbWF.default), {
                                                variant: "h6",
                                                sx: {
                                                    fontFamily: "Trebuchet MS"
                                                },
                                                children: [
                                                    "₹ ",
                                                    parseFloat(FinalAmount).toFixed(2)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                                        sx: {
                                            marginTop: "5px"
                                        },
                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $5ODPG.default), {
                                            onClick: handleClick,
                                            variant: "contained",
                                            color: "error",
                                            size: "large",
                                            fullWidth: true,
                                            children: /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                                sx: {
                                                    fontWeight: "bold"
                                                },
                                                children: "Place Order"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $esXub.jsxs)($ed0ee006661997e8$var$ButtonBox, {
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $5ODPG.default), {
                                        variant: "outlined",
                                        size: "small",
                                        onClick: function() {
                                            return navigate(-1);
                                        },
                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                            variant: "h6",
                                            children: "Continue Ordering"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsx)((0, $5ODPG.default), {
                                        variant: "outlined",
                                        size: "small",
                                        color: "error",
                                        onClick: handleClearCart,
                                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                            variant: "h6",
                                            children: "Clear Cart"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $9yM65.ToastContainer), {})
                ]
            })
        ]
    });
};
var $ed0ee006661997e8$export$2e2bcd8739ae039 = $ed0ee006661997e8$var$CartItemList;


parcelRequire("ez2pC");
var $49c73 = parcelRequire("49c73");
var $23d4c55c55cabf27$exports = {};


$23d4c55c55cabf27$exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + (parcelRequire("7meeL")).resolve("aYokX");


parcelRequire("5WuyH");
var $awSZB = parcelRequire("awSZB");

var $aFlA4 = parcelRequire("aFlA4");

var $gmJlE = parcelRequire("gmJlE");

var $dORbj = parcelRequire("dORbj");

var $de3c4f0c84d4929f$var$MainContainer = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
        paddingBottom: theme.spacing(0)
    };
});
var $de3c4f0c84d4929f$var$MainCartBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
        alignItems: "center",
        justifyContent: "center"
    }, (0, $2iBlG._)(_obj, theme.breakpoints.down("sm"), {
        gap: theme.spacing(2),
        marginTop: "8rem"
    }), (0, $2iBlG._)(_obj, theme.breakpoints.between("sm", "md"), {
        gap: theme.spacing(2),
        marginTop: "8rem"
    }), _obj;
});
var $de3c4f0c84d4929f$var$CartBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
        alignItems: "center",
        justifyContent: "center",
        marginTop: theme.spacing(6)
    }, theme.breakpoints.down("sm"), {
        marginTop: theme.spacing(4)
    });
});
var $de3c4f0c84d4929f$var$ItemsBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return {
        width: "100%"
    };
});
var $de3c4f0c84d4929f$var$EmptyBox = (0, $gSv8W.default)((0, $kDFB6.default))(function(param) {
    var theme = param.theme;
    return (0, $2iBlG._)({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(3),
        "& img": {
            width: "40vw",
            marginTop: "3rem"
        },
        "& p": {
            fontFamily: "Trebuchet MS",
            color: "rgb(211,47,47)",
            fontWeight: "900",
            fontSize: "2rem",
            textAlign: "center"
        },
        "& button": {
            fontFamily: "Trebuchet MS",
            textTransform: "capitalize"
        }
    }, theme.breakpoints.down("sm"), {
        "& img": {
            width: "80vw"
        }
    });
});
var $de3c4f0c84d4929f$var$Cart = function() {
    var cartItems = (0, $49c73.useSelector)(function(store) {
        return store.items;
    });
    var navigate = (0, $awSZB.useNavigate)();
    var location = (0, $awSZB.useLocation)();
    (0, $3aC2T.useEffect)(function() {
        window.scrollTo(0, 0);
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $esXub.jsxs)((0, $esXub.Fragment), {
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)((0, $aFlA4.default), {}),
            /*#__PURE__*/ (0, $esXub.jsx)($de3c4f0c84d4929f$var$MainContainer, {
                children: /*#__PURE__*/ (0, $esXub.jsx)($de3c4f0c84d4929f$var$MainCartBox, {
                    children: cartItems.length === 0 ? /*#__PURE__*/ (0, $esXub.jsxs)($de3c4f0c84d4929f$var$EmptyBox, {
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)((0, $dORbj.LazyLoadImage), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($23d4c55c55cabf27$exports))),
                                alt: "EmptyCart",
                                effect: "blur"
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)((0, $2wbWF.default), {
                                children: "Your Cart is Empty."
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)((0, $5ODPG.default), {
                                onClick: function() {
                                    return navigate("/restaurants");
                                },
                                variant: "contained",
                                size: "large",
                                color: "error",
                                children: "Explore the Restaurants"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $esXub.jsx)($de3c4f0c84d4929f$var$CartBox, {
                        children: /*#__PURE__*/ (0, $esXub.jsx)($de3c4f0c84d4929f$var$ItemsBox, {
                            children: /*#__PURE__*/ (0, $esXub.jsx)((0, $ed0ee006661997e8$export$2e2bcd8739ae039), {
                                items: cartItems
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $esXub.jsx)((0, $gmJlE.default), {})
        ]
    });
};
var $de3c4f0c84d4929f$export$2e2bcd8739ae039 = $de3c4f0c84d4929f$var$Cart;



var $kDFB6 = parcelRequire("kDFB6");

var $4ghiA = parcelRequire("4ghiA");

var $5WuyH = parcelRequire("5WuyH");
var $awSZB = parcelRequire("awSZB");
parcelRequire("l2BLr");
var $qmPZq = parcelRequire("qmPZq");

var $ar9jW = parcelRequire("ar9jW");
parcelRequire("ez2pC");
var $02kAW = parcelRequire("02kAW");

var $9AK5f = parcelRequire("9AK5f");

var $gWZ9M = parcelRequire("gWZ9M");
var $c8ffc255fc97de67$var$appStore = (0, $9AK5f.configureStore)({
    reducer: (0, $gWZ9M.cartReducer)
});
var $c8ffc255fc97de67$export$2e2bcd8739ae039 = $c8ffc255fc97de67$var$appStore;





// * Modularity is also known as:
// * Chunking
// * Code Splitting
// * Dynamic Bundling
// * Lazy Loading
// * On-Demand Loading
// * Dynamic Import
// const Grocery = lazy(() => import('./Components/Grocery/Grocery'));
var $6c74cc72a0a2f69a$var$HomePage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).memo(/*#__PURE__*/ (0, $3aC2T.lazy)(function() {
    return (parcelRequire("eOzfo"));
}));

var $6c74cc72a0a2f69a$var$Menu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).memo(/*#__PURE__*/ (0, $3aC2T.lazy)(function() {
    return (parcelRequire("g0ZcG"));
}));

var $6c74cc72a0a2f69a$var$RestaurantMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).memo(/*#__PURE__*/ (0, $3aC2T.lazy)(function() {
    return (parcelRequire("bUgBz"));
}));
var $6c74cc72a0a2f69a$var$MainComponent = function() {
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(), 2), userName = _useState[0], setUserName = _useState[1];
    var _useState1 = (0, $aSMts._)((0, $3aC2T.useState)({}), 2), user = _useState1[0], setUser = _useState1[1];
    var Area = "Pune";
    (0, $3aC2T.useEffect)(function() {
        var unSubscribe = (0, $qmPZq.y)((0, $ar9jW.firebaseAuth), function(currentUser) {
            setUser(currentUser);
            console.log("user", currentUser);
        });
        return function() {
            unSubscribe();
        };
    }, []);
    (0, $3aC2T.useEffect)(function() {
        var data = {
            name: "User"
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $esXub.Fragment), {
        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $02kAW.default), {
            store: (0, $c8ffc255fc97de67$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $esXub.jsx)((0, $4ghiA.default).Provider, {
                value: {
                    loggedInUser: userName,
                    setUserName: setUserName,
                    user: user,
                    Area: Area
                },
                children: /*#__PURE__*/ (0, $esXub.jsx)((0, $kDFB6.default), {
                    style: {
                        marginTop: "3rem"
                    },
                    children: /*#__PURE__*/ (0, $esXub.jsx)((0, $awSZB.Outlet), {})
                })
            })
        })
    });
};
var $6c74cc72a0a2f69a$var$appRouter = (0, $5WuyH.createBrowserRouter)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $esXub.jsx)($6c74cc72a0a2f69a$var$MainComponent, {}),
        children: [
            {
                path: "/home",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $3aC2T.Suspense), {
                    fallback: /*#__PURE__*/ (0, $esXub.jsx)("h1", {
                        children: "Loading HomePage..."
                    }),
                    children: /*#__PURE__*/ (0, $esXub.jsx)($6c74cc72a0a2f69a$var$HomePage, {})
                })
            },
            {
                path: "/restaurants",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $3aC2T.Suspense), {
                    fallback: /*#__PURE__*/ (0, $esXub.jsx)("h1", {
                        children: "Loading Restaurants..."
                    }),
                    children: /*#__PURE__*/ (0, $esXub.jsx)($6c74cc72a0a2f69a$var$Menu, {})
                })
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $e8017021171de205$export$2e2bcd8739ae039), {})
            },
            {
                path: "/help",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $c387bc3d5bf0a3b2$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $de3c4f0c84d4929f$export$2e2bcd8739ae039), {})
            },
            // {
            //   path: '/grocery',
            //   element: (
            //     <Suspense fallback={<h1>Loading...</h1>}>
            //       <Grocery />
            //     </Suspense>
            //   )
            // },
            {
                path: "/restaurantmenu/:resId",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $3aC2T.Suspense), {
                    fallback: /*#__PURE__*/ (0, $esXub.jsx)("h1", {
                        children: "Loading Restaurant Menu..."
                    }),
                    children: /*#__PURE__*/ (0, $esXub.jsx)($6c74cc72a0a2f69a$var$RestaurantMenu, {})
                })
            },
            {
                path: "/",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $f9c69a81ca4441d0$export$2e2bcd8739ae039), {})
            },
            {
                path: "/error",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $cd5775156596c920$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
var $6c74cc72a0a2f69a$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($931d92b7390d92a2$exports))).createRoot(document.getElementById("root"));
$6c74cc72a0a2f69a$var$root.render(/*#__PURE__*/ (0, $esXub.jsx)((0, $awSZB.RouterProvider), {
    router: $6c74cc72a0a2f69a$var$appRouter
}));

})();
//# sourceMappingURL=index.df2420a9.js.map
